(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefdb2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefdb2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("82g8Y", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $5d9b086fb32f5a5e$export$ffb0004e005737fa; }, function (v) { return $5d9b086fb32f5a5e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $5d9b086fb32f5a5e$export$34b9dba7ce09269b; }, function (v) { return $5d9b086fb32f5a5e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $5d9b086fb32f5a5e$export$25062201e9e25d76; }, function (v) { return $5d9b086fb32f5a5e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d9b086fb32f5a5e$export$ffb0004e005737fa;
var $5d9b086fb32f5a5e$export$34b9dba7ce09269b;
var $5d9b086fb32f5a5e$export$25062201e9e25d76;
"use strict";
var $5d9b086fb32f5a5e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5d9b086fb32f5a5e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $5d9b086fb32f5a5e$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $5d9b086fb32f5a5e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$5d9b086fb32f5a5e$export$ffb0004e005737fa = $5d9b086fb32f5a5e$var$REACT_FRAGMENT_TYPE;
$5d9b086fb32f5a5e$export$34b9dba7ce09269b = $5d9b086fb32f5a5e$var$jsxProd;
$5d9b086fb32f5a5e$export$25062201e9e25d76 = $5d9b086fb32f5a5e$var$jsxProd;

});

parcelRegister("4TMho", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3911bfce698fbe4a$export$71511d61b312f219; });
function $3911bfce698fbe4a$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("l0Yig", function(module, exports) {




module.exports = {
    "anchor": {
        "anchor": function() {
            return (parcelRequire("jjZ2x"));
        }
    },
    "search": {
        "search-autocomplete": function() {
            return Promise.resolve((parcelRequire("53pa5")));
        }
    },
    "slider": {
        "slider-plugins": function() {
            return (parcelRequire("c4Ied"));
        },
        "slider": function() {
            return (parcelRequire("5O7RQ"));
        }
    }
};

});
parcelRegister("jjZ2x", function(module, exports) {

module.exports = (parcelRequire("1K40G"))($parcel$resolve("jlwCP")).then(function() {
    return parcelRequire('wAkeP');
});

});
parcelRegister("1K40G", function(module, exports) {
"use strict";

var $5h5TK = parcelRequire("5h5TK");
module.exports = $5h5TK(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("5h5TK", function(module, exports) {
"use strict";
var $3d731d862d3263f1$var$cachedBundles = {};
var $3d731d862d3263f1$var$cachedPreloads = {};
var $3d731d862d3263f1$var$cachedPrefetches = {};
function $3d731d862d3263f1$var$getCache(type) {
    switch(type){
        case 'preload':
            return $3d731d862d3263f1$var$cachedPreloads;
        case 'prefetch':
            return $3d731d862d3263f1$var$cachedPrefetches;
        default:
            return $3d731d862d3263f1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3d731d862d3263f1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("53pa5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3ae0c0286979d898$export$2e2bcd8739ae039; });

var $iMhBj = parcelRequire("iMhBj");

var $iom5D = parcelRequire("iom5D");

var $lhZta = parcelRequire("lhZta");
var $4sXVO = parcelRequire("4sXVO");

function $3ae0c0286979d898$var$_templateObject() {
    var data = (0, $iMhBj._)([
        ' <p class="px-20 pt-20">\n                  Start your search by typing a keyword in the search box above\n                </p>'
    ]);
    $3ae0c0286979d898$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3ae0c0286979d898$var$_templateObject1() {
    var data = (0, $iMhBj._)([
        '\n                <p class="px-20 pt-20">\n                  No results found for <strong>',
        "</strong>\n                </p>\n              "
    ]);
    $3ae0c0286979d898$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3ae0c0286979d898$var$_templateObject2() {
    var data = (0, $iMhBj._)([
        '\n                <article>\n                  <a href="',
        '">\n                    <p class="aa-Label p--sm">',
        "</p>\n                    <h5>",
        "</h5>\n                  </a>\n                </article>\n              "
    ]);
    $3ae0c0286979d898$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $3ae0c0286979d898$var$goToSearchPage = function(value) {
    window.location.replace(window.location.origin + '?s=' + value);
};
var $3ae0c0286979d898$var$searchTest = function() {
    var searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($iom5D)))(window.ALGOLIA_APPLICATION_ID, window.ALGOLIA_SEARCH_API_KEY);
    (0, $lhZta.autocomplete)({
        container: '#autocomplete',
        detachedMediaQuery: '',
        debug: false,
        onSubmit: function(query) {
            var _query_state;
            var keyword = query === null || query === void 0 ? void 0 : (_query_state = query.state) === null || _query_state === void 0 ? void 0 : _query_state.query;
            if (keyword) $3ae0c0286979d898$var$goToSearchPage(keyword);
        },
        getSources: function() {
            return [
                {
                    sourceId: 'search',
                    getItems: function(param) {
                        var query = param.query;
                        return (0, $4sXVO.getAlgoliaResults)({
                            searchClient: searchClient,
                            queries: [
                                {
                                    indexName: 'wp_searchable_posts',
                                    query: query
                                }
                            ]
                        });
                    },
                    templates: {
                        noResults: function(param) {
                            var state = param.state, html = param.html;
                            if (!(state === null || state === void 0 ? void 0 : state.query)) return html($3ae0c0286979d898$var$_templateObject());
                            return html($3ae0c0286979d898$var$_templateObject1(), state.query);
                        },
                        item: function(param) {
                            var item = param.item, html = param.html;
                            return html($3ae0c0286979d898$var$_templateObject2(), item.permalink, item.post_type, item.post_title);
                        }
                    }
                }
            ];
        }
    });
};
var $3ae0c0286979d898$export$2e2bcd8739ae039 = $3ae0c0286979d898$var$searchTest;

});
parcelRegister("iMhBj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $daba5cdc9025976d$export$71511d61b312f219; });
function $daba5cdc9025976d$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("iom5D", function(module, exports) {
/*! algoliasearch-lite.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    function e(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function r(r) {
        for(var n = 1; n < arguments.length; n++){
            var o = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t(Object(o), !0).forEach(function(t) {
                e(r, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function(e) {
                Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
        }
        return r;
    }
    function n(e, t) {
        if (null == e) return {};
        var r, n, o = function(e, t) {
            if (null == e) return {};
            var r, n, o = {}, a = Object.keys(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
            return o;
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
        return o;
    }
    function o(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e;
        }(e) || function(e, t) {
            if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
            var r = [], n = !0, o = !1, a = void 0;
            try {
                for(var u, i = e[Symbol.iterator](); !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
            } catch (e) {
                o = !0, a = e;
            } finally{
                try {
                    n || null == i.return || i.return();
                } finally{
                    if (o) throw a;
                }
            }
            return r;
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
    }
    function a(e) {
        return function(e) {
            if (Array.isArray(e)) {
                for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                return r;
            }
        }(e) || function(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
    }
    function u(e) {
        var t, r = "algoliasearch-client-js-".concat(e.key), n = function n() {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
        }, a = function a() {
            return JSON.parse(n().getItem(r) || "{}");
        }, u = function u(e) {
            n().setItem(r, JSON.stringify(e));
        }, i = function i() {
            var t = e.timeToLive ? 1e3 * e.timeToLive : null, r = a(), n = Object.fromEntries(Object.entries(r).filter(function(e) {
                return void 0 !== o(e, 2)[1].timestamp;
            }));
            if (u(n), t) {
                var i = Object.fromEntries(Object.entries(n).filter(function(e) {
                    var r = o(e, 2)[1], n = (new Date).getTime();
                    return !(r.timestamp + t < n);
                }));
                u(i);
            }
        };
        return {
            get: function get(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                };
                return Promise.resolve().then(function() {
                    i();
                    var t = JSON.stringify(e);
                    return a()[t];
                }).then(function(e) {
                    return Promise.all([
                        e ? e.value : t(),
                        void 0 !== e
                    ]);
                }).then(function(e) {
                    var t = o(e, 2), n = t[0], a = t[1];
                    return Promise.all([
                        n,
                        a || r.miss(n)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function set(e, t) {
                return Promise.resolve().then(function() {
                    var o = a();
                    return o[JSON.stringify(e)] = {
                        timestamp: (new Date).getTime(),
                        value: t
                    }, n().setItem(r, JSON.stringify(o)), t;
                });
            },
            delete: function _delete(e) {
                return Promise.resolve().then(function() {
                    var t = a();
                    delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t));
                });
            },
            clear: function clear() {
                return Promise.resolve().then(function() {
                    n().removeItem(r);
                });
            }
        };
    }
    function i(e) {
        var t = a(e.caches), r = t.shift();
        return void 0 === r ? {
            get: function get(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                }, n = t();
                return n.then(function(e) {
                    return Promise.all([
                        e,
                        r.miss(e)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function set(e, t) {
                return Promise.resolve(t);
            },
            delete: function _delete(e) {
                return Promise.resolve();
            },
            clear: function clear() {
                return Promise.resolve();
            }
        } : {
            get: function get(e, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                };
                return r.get(e, n, o).catch(function() {
                    return i({
                        caches: t
                    }).get(e, n, o);
                });
            },
            set: function set(e, n) {
                return r.set(e, n).catch(function() {
                    return i({
                        caches: t
                    }).set(e, n);
                });
            },
            delete: function _delete(e) {
                return r.delete(e).catch(function() {
                    return i({
                        caches: t
                    }).delete(e);
                });
            },
            clear: function clear() {
                return r.clear().catch(function() {
                    return i({
                        caches: t
                    }).clear();
                });
            }
        };
    }
    function s() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
        }, t = {};
        return {
            get: function get(r, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                }, a = JSON.stringify(r);
                if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
                var u = n(), i = o && o.miss || function() {
                    return Promise.resolve();
                };
                return u.then(function(e) {
                    return i(e);
                }).then(function() {
                    return u;
                });
            },
            set: function set(r, n) {
                return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
            },
            delete: function _delete(e) {
                return delete t[JSON.stringify(e)], Promise.resolve();
            },
            clear: function clear() {
                return t = {}, Promise.resolve();
            }
        };
    }
    function c(e) {
        for(var t = e.length - 1; t > 0; t--){
            var r = Math.floor(Math.random() * (t + 1)), n = e[t];
            e[t] = e[r], e[r] = n;
        }
        return e;
    }
    function l(e, t) {
        return t ? (Object.keys(t).forEach(function(r) {
            e[r] = t[r](e);
        }), e) : e;
    }
    function f(e) {
        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
        var o = 0;
        return e.replace(/%s/g, function() {
            return encodeURIComponent(r[o++]);
        });
    }
    var h = {
        WithinQueryParameters: 0,
        WithinHeaders: 1
    };
    function m(e, t) {
        var r = e || {}, n = r.data || {};
        return Object.keys(r).forEach(function(e) {
            -1 === [
                "timeout",
                "headers",
                "queryParameters",
                "data",
                "cacheable"
            ].indexOf(e) && (n[e] = r[e]);
        }), {
            data: Object.entries(n).length > 0 ? n : void 0,
            timeout: r.timeout || t,
            headers: r.headers || {},
            queryParameters: r.queryParameters || {},
            cacheable: r.cacheable
        };
    }
    var d = {
        Read: 1,
        Write: 2,
        Any: 3
    }, p = 1, v = 2, g = 3;
    function y(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
        return r(r({}, e), {}, {
            status: t,
            lastUpdate: Date.now()
        });
    }
    function b(e) {
        return "string" == typeof e ? {
            protocol: "https",
            url: e,
            accept: d.Any
        } : {
            protocol: e.protocol || "https",
            url: e.url,
            accept: e.accept || d.Any
        };
    }
    var O = "GET", P = "POST";
    function q(e, t) {
        return Promise.all(t.map(function(t) {
            return e.get(t, function() {
                return Promise.resolve(y(t));
            });
        })).then(function(e) {
            var r = e.filter(function(e) {
                return function(e) {
                    return e.status === p || Date.now() - e.lastUpdate > 12e4;
                }(e);
            }), n = e.filter(function(e) {
                return function(e) {
                    return e.status === g && Date.now() - e.lastUpdate <= 12e4;
                }(e);
            }), o = [].concat(a(r), a(n));
            return {
                getTimeout: function getTimeout(e, t) {
                    return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
                },
                statelessHosts: o.length > 0 ? o.map(function(e) {
                    return b(e);
                }) : t
            };
        });
    }
    function j(e, t, n, o) {
        var u = [], i = function(e, t) {
            if (e.method === O || void 0 === e.data && void 0 === t.data) return;
            var _$n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
            return JSON.stringify(_$n);
        }(n, o), s = function(e, t) {
            var _$n = r(r({}, e.headers), t.headers), _$o = {};
            return Object.keys(_$n).forEach(function(e) {
                var _$t = _$n[e];
                _$o[e.toLowerCase()] = _$t;
            }), _$o;
        }(e, o), c = n.method, l = n.method !== O ? {} : r(r({}, n.data), o.data), f = r(r(r({
            "x-algolia-agent": e.userAgent.value
        }, e.queryParameters), l), o.queryParameters), h = 0, m = function t(r, a) {
            var l = r.pop();
            if (void 0 === l) throw {
                name: "RetryError",
                message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .",
                transporterStackTrace: A(u)
            };
            var m = {
                data: i,
                headers: s,
                method: c,
                url: S(l, n.path, f),
                connectTimeout: a(h, e.timeouts.connect),
                responseTimeout: a(h, o.timeout)
            }, d = function d(e) {
                var _$t = {
                    request: m,
                    response: e,
                    host: l,
                    triesLeft: r.length
                };
                return u.push(_$t), _$t;
            }, p = {
                onSuccess: function onSuccess(e) {
                    return function(e) {
                        try {
                            return JSON.parse(e.content);
                        } catch (t) {
                            throw function(e, t) {
                                return {
                                    name: "DeserializationError",
                                    message: e,
                                    response: t
                                };
                            }(t.message, e);
                        }
                    }(e);
                },
                onRetry: function onRetry(n) {
                    var _$o = d(n);
                    return n.isTimedOut && h++, Promise.all([
                        e.logger.info("Retryable failure", x(_$o)),
                        e.hostsCache.set(l, y(l, n.isTimedOut ? g : v))
                    ]).then(function() {
                        return t(r, a);
                    });
                },
                onFail: function onFail(e) {
                    throw d(e), function(e, t) {
                        var _$r = e.content, _$n = e.status, _$o = _$r;
                        try {
                            _$o = JSON.parse(_$r).message;
                        } catch (e) {}
                        return function(e, t, r) {
                            return {
                                name: "ApiError",
                                message: e,
                                status: t,
                                transporterStackTrace: r
                            };
                        }(_$o, _$n, t);
                    }(e, A(u));
                }
            };
            return e.requester.send(m).then(function(e) {
                return function(e, t) {
                    return function(e) {
                        var _$t = e.status;
                        return e.isTimedOut || function(e) {
                            var _$t = e.isTimedOut, _$r = e.status;
                            return !_$t && 0 == ~~_$r;
                        }(e) || 2 != ~~(_$t / 100) && 4 != ~~(_$t / 100);
                    }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
                }(e, p);
            });
        };
        return q(e.hostsCache, t).then(function(e) {
            return m(a(e.statelessHosts).reverse(), e.getTimeout);
        });
    }
    function w(e) {
        var t = {
            value: "Algolia for JavaScript (".concat(e, ")"),
            add: function add(e) {
                var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
            }
        };
        return t;
    }
    function S(e, t, r) {
        var n = T(r), o = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
        return n.length && (o += "?".concat(n)), o;
    }
    function T(e) {
        return Object.keys(e).map(function(t) {
            var r;
            return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
        }).join("&");
    }
    function A(e) {
        return e.map(function(e) {
            return x(e);
        });
    }
    function x(e) {
        var t = e.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return r(r({}, e), {}, {
            request: r(r({}, e.request), {}, {
                headers: r(r({}, e.request.headers), t)
            })
        });
    }
    var N = function N(e) {
        var t = e.appId, n = function(e, t, r) {
            var n = {
                "x-algolia-api-key": r,
                "x-algolia-application-id": t
            };
            return {
                headers: function headers() {
                    return e === h.WithinHeaders ? n : {};
                },
                queryParameters: function queryParameters() {
                    return e === h.WithinQueryParameters ? n : {};
                }
            };
        }(void 0 !== e.authMode ? e.authMode : h.WithinHeaders, t, e.apiKey), a = function(e) {
            var t = e.hostsCache, _$r = e.logger, n = e.requester, a = e.requestsCache, u = e.responsesCache, i = e.timeouts, s = e.userAgent, _$c = e.hosts, _$l = e.queryParameters, f = {
                hostsCache: t,
                logger: _$r,
                requester: n,
                requestsCache: a,
                responsesCache: u,
                timeouts: i,
                userAgent: s,
                headers: e.headers,
                queryParameters: _$l,
                hosts: _$c.map(function(e) {
                    return b(e);
                }),
                read: function read(e, t) {
                    var _$r = m(t, f.timeouts.read), n = function n() {
                        return j(f, f.hosts.filter(function(e) {
                            return 0 != (e.accept & d.Read);
                        }), e, _$r);
                    };
                    if (!0 !== (void 0 !== _$r.cacheable ? _$r.cacheable : e.cacheable)) return n();
                    var a = {
                        request: e,
                        mappedRequestOptions: _$r,
                        transporter: {
                            queryParameters: f.queryParameters,
                            headers: f.headers
                        }
                    };
                    return f.responsesCache.get(a, function() {
                        return f.requestsCache.get(a, function() {
                            return f.requestsCache.set(a, n()).then(function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    e
                                ]);
                            }, function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    Promise.reject(e)
                                ]);
                            }).then(function(e) {
                                var _$t = o(e, 2);
                                _$t[0];
                                return _$t[1];
                            });
                        });
                    }, {
                        miss: function miss(e) {
                            return f.responsesCache.set(a, e);
                        }
                    });
                },
                write: function write(e, t) {
                    return j(f, f.hosts.filter(function(e) {
                        return 0 != (e.accept & d.Write);
                    }), e, m(t, f.timeouts.write));
                }
            };
            return f;
        }(r(r({
            hosts: [
                {
                    url: "".concat(t, "-dsn.algolia.net"),
                    accept: d.Read
                },
                {
                    url: "".concat(t, ".algolia.net"),
                    accept: d.Write
                }
            ].concat(c([
                {
                    url: "".concat(t, "-1.algolianet.com")
                },
                {
                    url: "".concat(t, "-2.algolianet.com")
                },
                {
                    url: "".concat(t, "-3.algolianet.com")
                }
            ]))
        }, e), {}, {
            headers: r(r(r({}, n.headers()), {
                "content-type": "application/x-www-form-urlencoded"
            }), e.headers),
            queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
        }));
        return l({
            transporter: a,
            appId: t,
            addAlgoliaAgent: function addAlgoliaAgent(e, t) {
                a.userAgent.add({
                    segment: e,
                    version: t
                });
            },
            clearCache: function clearCache() {
                return Promise.all([
                    a.requestsCache.clear(),
                    a.responsesCache.clear()
                ]).then(function() {});
            }
        }, e.methods);
    }, C = function C(e) {
        return function(t, r) {
            return t.method === O ? e.transporter.read(t, r) : e.transporter.write(t, r);
        };
    }, E = function E(e) {
        return function(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
                transporter: e.transporter,
                appId: e.appId,
                indexName: t
            };
            return l(n, r.methods);
        };
    }, J = function J(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    params: T(e.params || {})
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/queries",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    }, k = function k(e) {
        return function(t, o) {
            return Promise.all(t.map(function(t) {
                var a = t.params, u = a.facetName, i = a.facetQuery, s = n(a, [
                    "facetName",
                    "facetQuery"
                ]);
                return E(e)(t.indexName, {
                    methods: {
                        searchForFacetValues: F
                    }
                }).searchForFacetValues(u, i, r(r({}, o), s));
            }));
        };
    }, I = function I(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/answers/%s/prediction", e.indexName),
                data: {
                    query: t,
                    queryLanguages: r
                },
                cacheable: !0
            }, n);
        };
    }, R = function R(e) {
        return function(t, r) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/query", e.indexName),
                data: {
                    query: t
                },
                cacheable: !0
            }, r);
        };
    }, F = function F(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                data: {
                    facetQuery: r
                },
                cacheable: !0
            }, n);
        };
    }, D = 1, W = 2, H = 3;
    var Q = function Q(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    threshold: e.threshold || 0
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    };
    function L(e, t, n) {
        var o, a = {
            appId: e,
            apiKey: t,
            timeouts: {
                connect: 1,
                read: 2,
                write: 30
            },
            requester: {
                send: function send(e) {
                    return new Promise(function(t) {
                        var _$r = new XMLHttpRequest;
                        _$r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function(t) {
                            return _$r.setRequestHeader(t, e.headers[t]);
                        });
                        var _$n, o = function o(e, n) {
                            return setTimeout(function() {
                                _$r.abort(), t({
                                    status: 0,
                                    content: n,
                                    isTimedOut: !0
                                });
                            }, 1e3 * e);
                        }, a = o(e.connectTimeout, "Connection timeout");
                        _$r.onreadystatechange = function() {
                            _$r.readyState > _$r.OPENED && void 0 === _$n && (clearTimeout(a), _$n = o(e.responseTimeout, "Socket timeout"));
                        }, _$r.onerror = function() {
                            0 === _$r.status && (clearTimeout(a), clearTimeout(_$n), t({
                                content: _$r.responseText || "Network request failed",
                                status: _$r.status,
                                isTimedOut: !1
                            }));
                        }, _$r.onload = function() {
                            clearTimeout(a), clearTimeout(_$n), t({
                                content: _$r.responseText,
                                status: _$r.status,
                                isTimedOut: !1
                            });
                        }, _$r.send(e.data);
                    });
                }
            },
            logger: (o = H, {
                debug: function debug(e, t) {
                    return D >= o && console.debug(e, t), Promise.resolve();
                },
                info: function info(e, t) {
                    return W >= o && console.info(e, t), Promise.resolve();
                },
                error: function error(e, t) {
                    return console.error(e, t), Promise.resolve();
                }
            }),
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: i({
                caches: [
                    u({
                        key: "".concat("4.24.0", "-").concat(e)
                    }),
                    s()
                ]
            }),
            userAgent: w("4.24.0").add({
                segment: "Browser",
                version: "lite"
            }),
            authMode: h.WithinQueryParameters
        };
        return N(r(r(r({}, a), n), {}, {
            methods: {
                search: J,
                searchForFacetValues: k,
                multipleQueries: J,
                multipleSearchForFacetValues: k,
                customRequest: C,
                initIndex: function initIndex(e) {
                    return function(t) {
                        return E(e)(t, {
                            methods: {
                                search: R,
                                searchForFacetValues: F,
                                findAnswers: I
                            }
                        });
                    };
                },
                getRecommendations: Q
            }
        }));
    }
    return L.version = "4.24.0", L;
});

});

parcelRegister("lhZta", function(module, exports) {

$parcel$export(module.exports, "autocomplete", function () { return $f7fade1013664afd$export$485ded5f26ebe08d; });

var $byLo2 = parcelRequire("byLo2");

var $lbQrQ = parcelRequire("lbQrQ");
var $hQHsw = parcelRequire("hQHsw");
var $6GH72 = parcelRequire("6GH72");

var $i0Pbx = parcelRequire("i0Pbx");

var $79XkZ = parcelRequire("79XkZ");

var $gfvkJ = parcelRequire("gfvkJ");

var $2kCTV = parcelRequire("2kCTV");

var $8lshO = parcelRequire("8lshO");

var $j8iLB = parcelRequire("j8iLB");

var $6y63H = parcelRequire("6y63H");

var $2r0Rp = parcelRequire("2r0Rp");

var $2nBEc = parcelRequire("2nBEc");
var $lbvZh = parcelRequire("lbvZh");
var $616FB = parcelRequire("616FB");
var $f7fade1013664afd$var$_excluded = [
    "components"
];
function $f7fade1013664afd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f7fade1013664afd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f7fade1013664afd$var$_typeof(obj);
}
function $f7fade1013664afd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f7fade1013664afd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f7fade1013664afd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f7fade1013664afd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f7fade1013664afd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f7fade1013664afd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f7fade1013664afd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f7fade1013664afd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f7fade1013664afd$var$_defineProperty(obj, key, value) {
    key = $f7fade1013664afd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f7fade1013664afd$var$_toPropertyKey(arg) {
    var key = $f7fade1013664afd$var$_toPrimitive(arg, "string");
    return $f7fade1013664afd$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f7fade1013664afd$var$_toPrimitive(input, hint) {
    if ($f7fade1013664afd$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f7fade1013664afd$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f7fade1013664afd$var$instancesCount = 0;
function $f7fade1013664afd$export$485ded5f26ebe08d(options) {
    var _createEffectWrapper = (0, $gfvkJ.createEffectWrapper)(), runEffect = _createEffectWrapper.runEffect, cleanupEffects = _createEffectWrapper.cleanupEffects, runEffects = _createEffectWrapper.runEffects;
    var _createReactiveWrappe = (0, $2kCTV.createReactiveWrapper)(), reactive = _createReactiveWrappe.reactive, runReactives = _createReactiveWrappe.runReactives;
    var hasNoResultsSourceTemplateRef = (0, $lbQrQ.createRef)(false);
    var optionsRef = (0, $lbQrQ.createRef)(options);
    var onStateChangeRef = (0, $lbQrQ.createRef)(undefined);
    var props = reactive(function() {
        return (0, $8lshO.getDefaultOptions)(optionsRef.current);
    });
    var isDetached = reactive(function() {
        return props.value.core.environment.matchMedia(props.value.renderer.detachedMediaQuery).matches;
    });
    var autocomplete = reactive(function() {
        return (0, $byLo2.createAutocomplete)($f7fade1013664afd$var$_objectSpread($f7fade1013664afd$var$_objectSpread({}, props.value.core), {}, {
            onStateChange: function onStateChange(params) {
                var _onStateChangeRef$cur, _props$value$core$onS, _props$value$core;
                hasNoResultsSourceTemplateRef.current = params.state.collections.some(function(collection) {
                    return collection.source.templates.noResults;
                });
                (_onStateChangeRef$cur = onStateChangeRef.current) === null || _onStateChangeRef$cur === void 0 || _onStateChangeRef$cur.call(onStateChangeRef, params);
                (_props$value$core$onS = (_props$value$core = props.value.core).onStateChange) === null || _props$value$core$onS === void 0 || _props$value$core$onS.call(_props$value$core, params);
            },
            shouldPanelOpen: optionsRef.current.shouldPanelOpen || function(_ref) {
                var state = _ref.state;
                if (isDetached.value) return true;
                var hasItems = (0, $6GH72.getItemsCount)(state) > 0;
                if (!props.value.core.openOnFocus && !state.query) return hasItems;
                var hasNoResultsTemplate = Boolean(hasNoResultsSourceTemplateRef.current || props.value.renderer.renderNoResults);
                return !hasItems && hasNoResultsTemplate || hasItems;
            },
            __autocomplete_metadata: {
                userAgents: (0, $2r0Rp.userAgents),
                options: options
            }
        }));
    });
    var lastStateRef = (0, $lbQrQ.createRef)($f7fade1013664afd$var$_objectSpread({
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: '',
        activeItemId: null,
        status: 'idle'
    }, props.value.core.initialState));
    var propGetters = {
        getEnvironmentProps: props.value.renderer.getEnvironmentProps,
        getFormProps: props.value.renderer.getFormProps,
        getInputProps: props.value.renderer.getInputProps,
        getItemProps: props.value.renderer.getItemProps,
        getLabelProps: props.value.renderer.getLabelProps,
        getListProps: props.value.renderer.getListProps,
        getPanelProps: props.value.renderer.getPanelProps,
        getRootProps: props.value.renderer.getRootProps
    };
    var autocompleteScopeApi = {
        setActiveItemId: autocomplete.value.setActiveItemId,
        setQuery: autocomplete.value.setQuery,
        setCollections: autocomplete.value.setCollections,
        setIsOpen: autocomplete.value.setIsOpen,
        setStatus: autocomplete.value.setStatus,
        setContext: autocomplete.value.setContext,
        refresh: autocomplete.value.refresh,
        navigator: autocomplete.value.navigator
    };
    var html = reactive(function() {
        return (0, $i0Pbx.default).bind(props.value.renderer.renderer.createElement);
    });
    var dom = reactive(function() {
        return (0, $79XkZ.createAutocompleteDom)({
            autocomplete: autocomplete.value,
            autocompleteScopeApi: autocompleteScopeApi,
            classNames: props.value.renderer.classNames,
            environment: props.value.core.environment,
            isDetached: isDetached.value,
            placeholder: props.value.core.placeholder,
            propGetters: propGetters,
            setIsModalOpen: setIsModalOpen,
            state: lastStateRef.current,
            translations: props.value.renderer.translations
        });
    });
    function setPanelPosition() {
        (0, $616FB.setProperties)(dom.value.panel, {
            style: isDetached.value ? {} : (0, $j8iLB.getPanelPlacementStyle)({
                panelPlacement: props.value.renderer.panelPlacement,
                container: dom.value.root,
                form: dom.value.form,
                environment: props.value.core.environment
            })
        });
    }
    function scheduleRender(state) {
        lastStateRef.current = state;
        var renderProps = {
            autocomplete: autocomplete.value,
            autocompleteScopeApi: autocompleteScopeApi,
            classNames: props.value.renderer.classNames,
            components: props.value.renderer.components,
            container: props.value.renderer.container,
            html: html.value,
            dom: dom.value,
            panelContainer: isDetached.value ? dom.value.detachedContainer : props.value.renderer.panelContainer,
            propGetters: propGetters,
            state: lastStateRef.current,
            renderer: props.value.renderer.renderer
        };
        var render = !(0, $6GH72.getItemsCount)(state) && !hasNoResultsSourceTemplateRef.current && props.value.renderer.renderNoResults || props.value.renderer.render;
        (0, $6y63H.renderSearchBox)(renderProps);
        (0, $6y63H.renderPanel)(render, renderProps);
    }
    runEffect(function() {
        var environmentProps = autocomplete.value.getEnvironmentProps({
            formElement: dom.value.form,
            panelElement: dom.value.panel,
            inputElement: dom.value.input
        });
        (0, $616FB.setProperties)(props.value.core.environment, environmentProps);
        return function() {
            (0, $616FB.setProperties)(props.value.core.environment, Object.keys(environmentProps).reduce(function(acc, key) {
                return $f7fade1013664afd$var$_objectSpread($f7fade1013664afd$var$_objectSpread({}, acc), {}, $f7fade1013664afd$var$_defineProperty({}, key, undefined));
            }, {}));
        };
    });
    runEffect(function() {
        var panelContainerElement = isDetached.value ? props.value.core.environment.document.body : props.value.renderer.panelContainer;
        var panelElement = isDetached.value ? dom.value.detachedOverlay : dom.value.panel;
        if (isDetached.value && lastStateRef.current.isOpen) setIsModalOpen(true);
        scheduleRender(lastStateRef.current);
        return function() {
            if (panelContainerElement.contains(panelElement)) {
                panelContainerElement.removeChild(panelElement);
                panelContainerElement.classList.remove('aa-Detached');
            }
        };
    });
    runEffect(function() {
        var containerElement = props.value.renderer.container;
        containerElement.appendChild(dom.value.root);
        return function() {
            containerElement.removeChild(dom.value.root);
        };
    });
    runEffect(function() {
        var debouncedRender = (0, $hQHsw.debounce)(function(_ref2) {
            var state = _ref2.state;
            scheduleRender(state);
        }, 0);
        onStateChangeRef.current = function(_ref3) {
            var state = _ref3.state, prevState = _ref3.prevState;
            if (isDetached.value && prevState.isOpen !== state.isOpen) setIsModalOpen(state.isOpen);
            // The outer DOM might have changed since the last time the panel was
            // positioned. The layout might have shifted vertically for instance.
            // It's therefore safer to re-calculate the panel position before opening
            // it again.
            if (!isDetached.value && state.isOpen && !prevState.isOpen) setPanelPosition();
            // We scroll to the top of the panel whenever the query changes (i.e. new
            // results come in) so that users don't have to.
            if (state.query !== prevState.query) {
                var scrollablePanels = props.value.core.environment.document.querySelectorAll('.aa-Panel--scrollable');
                scrollablePanels.forEach(function(scrollablePanel) {
                    if (scrollablePanel.scrollTop !== 0) scrollablePanel.scrollTop = 0;
                });
            }
            debouncedRender({
                state: state
            });
        };
        return function() {
            onStateChangeRef.current = undefined;
        };
    });
    runEffect(function() {
        var onResize = (0, $hQHsw.debounce)(function() {
            var previousIsDetached = isDetached.value;
            isDetached.value = props.value.core.environment.matchMedia(props.value.renderer.detachedMediaQuery).matches;
            if (previousIsDetached !== isDetached.value) update({});
            else requestAnimationFrame(setPanelPosition);
        }, 20);
        props.value.core.environment.addEventListener('resize', onResize);
        return function() {
            props.value.core.environment.removeEventListener('resize', onResize);
        };
    });
    runEffect(function() {
        if (!isDetached.value) return function() {};
        function toggleModalClassname(isActive) {
            dom.value.detachedContainer.classList.toggle('aa-DetachedContainer--modal', isActive);
        }
        function onChange(event) {
            toggleModalClassname(event.matches);
        }
        var isModalDetachedMql = props.value.core.environment.matchMedia(getComputedStyle(props.value.core.environment.document.documentElement).getPropertyValue('--aa-detached-modal-media-query'));
        toggleModalClassname(isModalDetachedMql.matches);
        // Prior to Safari 14, `MediaQueryList` isn't based on `EventTarget`,
        // so we must use `addListener` and `removeListener` to observe media query lists.
        // See https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
        var hasModernEventListener = Boolean(isModalDetachedMql.addEventListener);
        hasModernEventListener ? isModalDetachedMql.addEventListener('change', onChange) : isModalDetachedMql.addListener(onChange);
        return function() {
            hasModernEventListener ? isModalDetachedMql.removeEventListener('change', onChange) : isModalDetachedMql.removeListener(onChange);
        };
    });
    runEffect(function() {
        requestAnimationFrame(setPanelPosition);
        return function() {};
    });
    function destroy() {
        $f7fade1013664afd$var$instancesCount--;
        cleanupEffects();
    }
    function update() {
        var updatedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        cleanupEffects();
        var _props$value$renderer = props.value.renderer, components = _props$value$renderer.components, rendererProps = $f7fade1013664afd$var$_objectWithoutProperties(_props$value$renderer, $f7fade1013664afd$var$_excluded);
        optionsRef.current = (0, $2nBEc.mergeDeep)(rendererProps, props.value.core, {
            // We need to filter out default components so they can be replaced with
            // a new `renderer`, without getting rid of user components.
            // @MAJOR Deal with registering components with the same name as the
            // default ones. If we disallow overriding default components, we'd just
            // need to pass all `components` here.
            components: (0, $lbvZh.pickBy)(components, function(_ref4) {
                var value = _ref4.value;
                return !value.hasOwnProperty('__autocomplete_componentName');
            }),
            initialState: lastStateRef.current
        }, updatedOptions);
        runReactives();
        runEffects();
        autocomplete.value.refresh().then(function() {
            scheduleRender(lastStateRef.current);
        });
    }
    function setIsModalOpen(value) {
        var prevValue = props.value.core.environment.document.body.contains(dom.value.detachedOverlay);
        if (value === prevValue) return;
        if (value) {
            props.value.core.environment.document.body.appendChild(dom.value.detachedOverlay);
            props.value.core.environment.document.body.classList.add('aa-Detached');
            dom.value.input.focus();
        } else {
            props.value.core.environment.document.body.removeChild(dom.value.detachedOverlay);
            props.value.core.environment.document.body.classList.remove('aa-Detached');
        }
    }
    $f7fade1013664afd$var$instancesCount++;
    return $f7fade1013664afd$var$_objectSpread($f7fade1013664afd$var$_objectSpread({}, autocompleteScopeApi), {}, {
        update: update,
        destroy: destroy
    });
}

});
parcelRegister("byLo2", function(module, exports) {

$parcel$export(module.exports, "createAutocomplete", function () { return $86a7a0ad8732d6c0$export$b00b86c416695282; });

var $hXRsX = parcelRequire("hXRsX");

var $fJIBM = parcelRequire("fJIBM");

var $kjPHd = parcelRequire("kjPHd");

var $693jx = parcelRequire("693jx");

var $gjRUq = parcelRequire("gjRUq");

var $9e25Y = parcelRequire("9e25Y");

var $d43QV = parcelRequire("d43QV");

var $ZNOPo = parcelRequire("ZNOPo");

var $35zz4 = parcelRequire("35zz4");
function $86a7a0ad8732d6c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $86a7a0ad8732d6c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $86a7a0ad8732d6c0$var$_typeof(obj);
}
function $86a7a0ad8732d6c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86a7a0ad8732d6c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86a7a0ad8732d6c0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $86a7a0ad8732d6c0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86a7a0ad8732d6c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86a7a0ad8732d6c0$var$_defineProperty(obj, key, value) {
    key = $86a7a0ad8732d6c0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $86a7a0ad8732d6c0$var$_toPropertyKey(arg) {
    var key = $86a7a0ad8732d6c0$var$_toPrimitive(arg, "string");
    return $86a7a0ad8732d6c0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $86a7a0ad8732d6c0$var$_toPrimitive(input, hint) {
    if ($86a7a0ad8732d6c0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($86a7a0ad8732d6c0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $86a7a0ad8732d6c0$export$b00b86c416695282(options) {
    (0, $fJIBM.checkOptions)(options);
    var subscribers = [];
    var props = (0, $gjRUq.getDefaultProps)(options, subscribers);
    var store = (0, $kjPHd.createStore)((0, $35zz4.stateReducer), props, onStoreStateChange);
    var setters = (0, $693jx.getAutocompleteSetters)({
        store: store
    });
    var propGetters = (0, $9e25Y.getPropGetters)($86a7a0ad8732d6c0$var$_objectSpread({
        props: props,
        refresh: refresh,
        store: store,
        navigator: props.navigator
    }, setters));
    function onStoreStateChange(_ref) {
        var _state$context, _state$context$algoli;
        var prevState = _ref.prevState, state = _ref.state;
        props.onStateChange($86a7a0ad8732d6c0$var$_objectSpread({
            prevState: prevState,
            state: state,
            refresh: refresh,
            navigator: props.navigator
        }, setters));
        if (!isAlgoliaInsightsPluginEnabled() && (_state$context = state.context) !== null && _state$context !== void 0 && (_state$context$algoli = _state$context.algoliaInsightsPlugin) !== null && _state$context$algoli !== void 0 && _state$context$algoli.__automaticInsights && props.insights !== false) {
            var plugin = (0, $hXRsX.createAlgoliaInsightsPlugin)({
                __autocomplete_clickAnalytics: false
            });
            props.plugins.push(plugin);
            subscribePlugins([
                plugin
            ]);
        }
    }
    function refresh() {
        return (0, $ZNOPo.onInput)($86a7a0ad8732d6c0$var$_objectSpread({
            event: new Event('input'),
            nextState: {
                isOpen: store.getState().isOpen
            },
            props: props,
            navigator: props.navigator,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters));
    }
    function subscribePlugins(plugins) {
        plugins.forEach(function(plugin) {
            var _plugin$subscribe;
            return (_plugin$subscribe = plugin.subscribe) === null || _plugin$subscribe === void 0 ? void 0 : _plugin$subscribe.call(plugin, $86a7a0ad8732d6c0$var$_objectSpread($86a7a0ad8732d6c0$var$_objectSpread({}, setters), {}, {
                navigator: props.navigator,
                refresh: refresh,
                onSelect: function onSelect(fn) {
                    subscribers.push({
                        onSelect: fn
                    });
                },
                onActive: function onActive(fn) {
                    subscribers.push({
                        onActive: fn
                    });
                },
                onResolve: function onResolve(fn) {
                    subscribers.push({
                        onResolve: fn
                    });
                }
            }));
        });
    }
    function isAlgoliaInsightsPluginEnabled() {
        return props.plugins.some(function(plugin) {
            return plugin.name === 'aa.algoliaInsightsPlugin';
        });
    }
    if (props.insights && !isAlgoliaInsightsPluginEnabled()) {
        var insightsParams = typeof props.insights === 'boolean' ? {} : props.insights;
        props.plugins.push((0, $hXRsX.createAlgoliaInsightsPlugin)(insightsParams));
    }
    subscribePlugins(props.plugins);
    (0, $d43QV.injectMetadata)({
        metadata: (0, $d43QV.getMetadata)({
            plugins: props.plugins,
            options: options
        }),
        environment: props.environment
    });
    return $86a7a0ad8732d6c0$var$_objectSpread($86a7a0ad8732d6c0$var$_objectSpread({
        refresh: refresh,
        navigator: props.navigator
    }, propGetters), setters);
}

});
parcelRegister("hXRsX", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaInsightsPlugin", function () { return $d1416b9a8b073216$export$89ab4208990a3782; });

var $lbQrQ = parcelRequire("lbQrQ");
var $hQHsw = parcelRequire("hQHsw");
var $34UP4 = parcelRequire("34UP4");
var $4akAZ = parcelRequire("4akAZ");
var $86lmL = parcelRequire("86lmL");

var $edB9N = parcelRequire("edB9N");

var $fFFuP = parcelRequire("fFFuP");

var $2TNpO = parcelRequire("2TNpO");

var $kSj1w = parcelRequire("kSj1w");
function $d1416b9a8b073216$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d1416b9a8b073216$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d1416b9a8b073216$var$_typeof(obj);
}
function $d1416b9a8b073216$var$_toConsumableArray(arr) {
    return $d1416b9a8b073216$var$_arrayWithoutHoles(arr) || $d1416b9a8b073216$var$_iterableToArray(arr) || $d1416b9a8b073216$var$_unsupportedIterableToArray(arr) || $d1416b9a8b073216$var$_nonIterableSpread();
}
function $d1416b9a8b073216$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d1416b9a8b073216$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d1416b9a8b073216$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d1416b9a8b073216$var$_arrayLikeToArray(o, minLen);
}
function $d1416b9a8b073216$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d1416b9a8b073216$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d1416b9a8b073216$var$_arrayLikeToArray(arr);
}
function $d1416b9a8b073216$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d1416b9a8b073216$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d1416b9a8b073216$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d1416b9a8b073216$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d1416b9a8b073216$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d1416b9a8b073216$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d1416b9a8b073216$var$_defineProperty(obj, key, value) {
    key = $d1416b9a8b073216$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d1416b9a8b073216$var$_toPropertyKey(arg) {
    var key = $d1416b9a8b073216$var$_toPrimitive(arg, "string");
    return $d1416b9a8b073216$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d1416b9a8b073216$var$_toPrimitive(input, hint) {
    if ($d1416b9a8b073216$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d1416b9a8b073216$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d1416b9a8b073216$var$VIEW_EVENT_DELAY = 400;
var $d1416b9a8b073216$var$ALGOLIA_INSIGHTS_VERSION = '2.15.0';
var $d1416b9a8b073216$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($d1416b9a8b073216$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
var $d1416b9a8b073216$var$sendViewedObjectIDs = (0, $hQHsw.debounce)(function(_ref) {
    var onItemsChange = _ref.onItemsChange, items = _ref.items, insights = _ref.insights, state = _ref.state;
    onItemsChange({
        insights: insights,
        insightsEvents: (0, $2TNpO.createViewedEvents)({
            items: items
        }).map(function(event) {
            return $d1416b9a8b073216$var$_objectSpread({
                eventName: 'Items Viewed'
            }, event);
        }),
        state: state
    });
}, $d1416b9a8b073216$var$VIEW_EVENT_DELAY);
function $d1416b9a8b073216$export$89ab4208990a3782(options) {
    var _getOptions = $d1416b9a8b073216$var$getOptions(options), providedInsightsClient = _getOptions.insightsClient, insightsInitParams = _getOptions.insightsInitParams, onItemsChange = _getOptions.onItemsChange, onSelectEvent = _getOptions.onSelect, onActiveEvent = _getOptions.onActive, __autocomplete_clickAnalytics = _getOptions.__autocomplete_clickAnalytics;
    var insightsClient = providedInsightsClient;
    if (!providedInsightsClient) (0, $86lmL.safelyRunOnBrowser)(function(_ref2) {
        var window = _ref2.window;
        var pointer = window.AlgoliaAnalyticsObject || 'aa';
        if (typeof pointer === 'string') insightsClient = window[pointer];
        if (!insightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) window[pointer] = function() {
                if (!window[pointer].queue) window[pointer].queue = [];
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                window[pointer].queue.push(args);
            };
            window[pointer].version = $d1416b9a8b073216$var$ALGOLIA_INSIGHTS_VERSION;
            insightsClient = window[pointer];
            $d1416b9a8b073216$var$loadInsights(window);
        }
    });
    // We return an empty plugin if `insightsClient` is still undefined at
    // this stage, which can happen in server environments.
    if (!insightsClient) return {};
    if (insightsInitParams) insightsClient('init', $d1416b9a8b073216$var$_objectSpread({
        partial: true
    }, insightsInitParams));
    var insights = (0, $fFFuP.createSearchInsightsApi)(insightsClient);
    var previousItems = (0, $lbQrQ.createRef)([]);
    var debouncedOnStateChange = (0, $hQHsw.debounce)(function(_ref3) {
        var state = _ref3.state;
        if (!state.isOpen) return;
        var items = state.collections.reduce(function(acc, current) {
            return [].concat($d1416b9a8b073216$var$_toConsumableArray(acc), $d1416b9a8b073216$var$_toConsumableArray(current.items));
        }, []).filter((0, $kSj1w.isAlgoliaInsightsHit));
        if (!(0, $34UP4.isEqual)(previousItems.current.map(function(x) {
            return x.objectID;
        }), items.map(function(x) {
            return x.objectID;
        }))) {
            previousItems.current = items;
            if (items.length > 0) $d1416b9a8b073216$var$sendViewedObjectIDs({
                onItemsChange: onItemsChange,
                items: items,
                insights: insights,
                state: state
            });
        }
    }, 0);
    return {
        name: 'aa.algoliaInsightsPlugin',
        subscribe: function subscribe(_ref4) {
            var setContext = _ref4.setContext, onSelect = _ref4.onSelect, onActive = _ref4.onActive;
            function setInsightsContext(userToken) {
                setContext({
                    algoliaInsightsPlugin: {
                        __algoliaSearchParameters: $d1416b9a8b073216$var$_objectSpread($d1416b9a8b073216$var$_objectSpread({}, __autocomplete_clickAnalytics ? {
                            clickAnalytics: true
                        } : {}), userToken ? {
                            userToken: $d1416b9a8b073216$var$normalizeUserToken(userToken)
                        } : {}),
                        insights: insights
                    }
                });
            }
            insightsClient('addAlgoliaAgent', 'insights-plugin');
            setInsightsContext();
            // Handles user token changes
            insightsClient('onUserTokenChange', function(userToken) {
                setInsightsContext(userToken);
            });
            insightsClient('getUserToken', null, function(_error, userToken) {
                setInsightsContext(userToken);
            });
            onSelect(function(_ref5) {
                var item = _ref5.item, state = _ref5.state, event = _ref5.event, source = _ref5.source;
                if (!(0, $kSj1w.isAlgoliaInsightsHit)(item)) return;
                onSelectEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $d1416b9a8b073216$var$_objectSpread({
                            eventName: 'Item Selected'
                        }, (0, $edB9N.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $kSj1w.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
            onActive(function(_ref6) {
                var item = _ref6.item, source = _ref6.source, state = _ref6.state, event = _ref6.event;
                if (!(0, $kSj1w.isAlgoliaInsightsHit)(item)) return;
                onActiveEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $d1416b9a8b073216$var$_objectSpread({
                            eventName: 'Item Active'
                        }, (0, $edB9N.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $kSj1w.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
        },
        onStateChange: function onStateChange(_ref7) {
            var state = _ref7.state;
            debouncedOnStateChange({
                state: state
            });
        },
        __autocomplete_pluginOptions: options
    };
}
function $d1416b9a8b073216$var$getAlgoliaSources() {
    var _context$algoliaInsig;
    var algoliaSourceBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var context = arguments.length > 1 ? arguments[1] : undefined;
    return [].concat($d1416b9a8b073216$var$_toConsumableArray(algoliaSourceBase), [
        'autocomplete-internal'
    ], $d1416b9a8b073216$var$_toConsumableArray((_context$algoliaInsig = context.algoliaInsightsPlugin) !== null && _context$algoliaInsig !== void 0 && _context$algoliaInsig.__automaticInsights ? [
        'autocomplete-automatic'
    ] : []));
}
function $d1416b9a8b073216$var$getOptions(options) {
    return $d1416b9a8b073216$var$_objectSpread({
        onItemsChange: function onItemsChange(_ref8) {
            var insights = _ref8.insights, insightsEvents = _ref8.insightsEvents, state = _ref8.state;
            insights.viewedObjectIDs.apply(insights, $d1416b9a8b073216$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $d1416b9a8b073216$var$_objectSpread($d1416b9a8b073216$var$_objectSpread({}, event), {}, {
                    algoliaSource: $d1416b9a8b073216$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onSelect: function onSelect(_ref9) {
            var insights = _ref9.insights, insightsEvents = _ref9.insightsEvents, state = _ref9.state;
            insights.clickedObjectIDsAfterSearch.apply(insights, $d1416b9a8b073216$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $d1416b9a8b073216$var$_objectSpread($d1416b9a8b073216$var$_objectSpread({}, event), {}, {
                    algoliaSource: $d1416b9a8b073216$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onActive: (0, $4akAZ.noop),
        __autocomplete_clickAnalytics: true
    }, options);
}
function $d1416b9a8b073216$var$loadInsights(environment) {
    var errorMessage = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
    try {
        var script = environment.document.createElement('script');
        script.async = true;
        script.src = $d1416b9a8b073216$var$ALGOLIA_INSIGHTS_SRC;
        script.onerror = function() {
            // eslint-disable-next-line no-console
            console.error(errorMessage);
        };
        document.body.appendChild(script);
    } catch (cause) {
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $d1416b9a8b073216$var$normalizeUserToken(userToken) {
    return typeof userToken === 'number' ? userToken.toString() : userToken;
}

});
parcelRegister("lbQrQ", function(module, exports) {

$parcel$export(module.exports, "createRef", function () { return $f6d34f2c5000b21f$export$7d1e3a5e95ceca43; });
function $f6d34f2c5000b21f$export$7d1e3a5e95ceca43(initialValue) {
    return {
        current: initialValue
    };
}

});

parcelRegister("hQHsw", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $cfe901103d8aadbb$export$61fc7d43ac8f84b0; });
function $cfe901103d8aadbb$export$61fc7d43ac8f84b0(fn, time) {
    var timerId = undefined;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(function() {
            return fn.apply(void 0, args);
        }, time);
    };
}

});

parcelRegister("34UP4", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $23ddd2a3b0081a68$export$248d38f6296296c5; });
function $23ddd2a3b0081a68$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $23ddd2a3b0081a68$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($23ddd2a3b0081a68$var$isPrimitive(first) || $23ddd2a3b0081a68$var$isPrimitive(second) || typeof first === 'function' || typeof second === 'function') return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$23ddd2a3b0081a68$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

});

parcelRegister("4akAZ", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $30881278bbc2c17f$export$8793edee2d425525; });
var $30881278bbc2c17f$export$8793edee2d425525 = function noop() {};

});

parcelRegister("86lmL", function(module, exports) {

$parcel$export(module.exports, "safelyRunOnBrowser", function () { return $5e5f75204178d4db$export$39f19eed34acd2f1; });
/**
 * Safely runs code meant for browser environments only.
 */ function $5e5f75204178d4db$export$39f19eed34acd2f1(callback) {
    if (typeof window !== 'undefined') return callback({
        window: window
    });
    return undefined;
}

});

parcelRegister("edB9N", function(module, exports) {

$parcel$export(module.exports, "createClickedEvent", function () { return $a59f1a2e2e74b708$export$285269928260a84d; });
function $a59f1a2e2e74b708$export$285269928260a84d(_ref) {
    var item = _ref.item, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items;
    return {
        index: item.__autocomplete_indexName,
        items: [
            item
        ],
        positions: [
            1 + items.findIndex(function(x) {
                return x.objectID === item.objectID;
            })
        ],
        queryID: item.__autocomplete_queryID,
        algoliaSource: [
            'autocomplete'
        ]
    };
}

});

parcelRegister("fFFuP", function(module, exports) {

$parcel$export(module.exports, "createSearchInsightsApi", function () { return $b68adfa5841d2350$export$96bc93a891c6f784; });

var $3lrLf = parcelRequire("3lrLf");
var $b68adfa5841d2350$var$_excluded = [
    "items"
], $b68adfa5841d2350$var$_excluded2 = [
    "items"
];
function $b68adfa5841d2350$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b68adfa5841d2350$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b68adfa5841d2350$var$_typeof(obj);
}
function $b68adfa5841d2350$var$_toConsumableArray(arr) {
    return $b68adfa5841d2350$var$_arrayWithoutHoles(arr) || $b68adfa5841d2350$var$_iterableToArray(arr) || $b68adfa5841d2350$var$_unsupportedIterableToArray(arr) || $b68adfa5841d2350$var$_nonIterableSpread();
}
function $b68adfa5841d2350$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b68adfa5841d2350$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b68adfa5841d2350$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b68adfa5841d2350$var$_arrayLikeToArray(o, minLen);
}
function $b68adfa5841d2350$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b68adfa5841d2350$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b68adfa5841d2350$var$_arrayLikeToArray(arr);
}
function $b68adfa5841d2350$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b68adfa5841d2350$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b68adfa5841d2350$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b68adfa5841d2350$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b68adfa5841d2350$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b68adfa5841d2350$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b68adfa5841d2350$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b68adfa5841d2350$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b68adfa5841d2350$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b68adfa5841d2350$var$_defineProperty(obj, key, value) {
    key = $b68adfa5841d2350$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b68adfa5841d2350$var$_toPropertyKey(arg) {
    var key = $b68adfa5841d2350$var$_toPrimitive(arg, "string");
    return $b68adfa5841d2350$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b68adfa5841d2350$var$_toPrimitive(input, hint) {
    if ($b68adfa5841d2350$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b68adfa5841d2350$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b68adfa5841d2350$var$chunk(item) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < item.objectIDs.length; i += chunkSize)chunks.push($b68adfa5841d2350$var$_objectSpread($b68adfa5841d2350$var$_objectSpread({}, item), {}, {
        objectIDs: item.objectIDs.slice(i, i + chunkSize)
    }));
    return chunks;
}
function $b68adfa5841d2350$var$mapToInsightsParamsApi(params) {
    return params.map(function(_ref) {
        var items = _ref.items, param = $b68adfa5841d2350$var$_objectWithoutProperties(_ref, $b68adfa5841d2350$var$_excluded);
        return $b68adfa5841d2350$var$_objectSpread($b68adfa5841d2350$var$_objectSpread({}, param), {}, {
            objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref2) {
                var objectID = _ref2.objectID;
                return objectID;
            })) || param.objectIDs
        });
    });
}
function $b68adfa5841d2350$export$96bc93a891c6f784(searchInsights) {
    var canSendHeaders = (0, $3lrLf.isModernInsightsClient)(searchInsights);
    function sendToInsights(method, payloads, items) {
        if (canSendHeaders && typeof items !== 'undefined') {
            var _items$0$__autocomple = items[0].__autocomplete_algoliaCredentials, appId = _items$0$__autocomple.appId, apiKey = _items$0$__autocomple.apiKey;
            var headers = {
                'X-Algolia-Application-Id': appId,
                'X-Algolia-API-Key': apiKey
            };
            searchInsights.apply(void 0, [
                method
            ].concat($b68adfa5841d2350$var$_toConsumableArray(payloads), [
                {
                    headers: headers
                }
            ]));
        } else searchInsights.apply(void 0, [
            method
        ].concat($b68adfa5841d2350$var$_toConsumableArray(payloads)));
    }
    return {
        /**
     * Initializes Insights with Algolia credentials.
     */ init: function init(appId, apiKey) {
            searchInsights('init', {
                appId: appId,
                apiKey: apiKey
            });
        },
        /**
     * Sets the authenticated user token to attach to events.
     * Unsets the authenticated token by passing `undefined`.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/set-authenticated-user-token/
     */ setAuthenticatedUserToken: function setAuthenticatedUserToken(authenticatedUserToken) {
            searchInsights('setAuthenticatedUserToken', authenticatedUserToken);
        },
        /**
     * Sets the user token to attach to events.
     */ setUserToken: function setUserToken(userToken) {
            searchInsights('setUserToken', userToken);
        },
        /**
     * Sends click events to capture a query and its clicked items and positions.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids-after-search/
     */ clickedObjectIDsAfterSearch: function clickedObjectIDsAfterSearch() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
            if (params.length > 0) sendToInsights('clickedObjectIDsAfterSearch', $b68adfa5841d2350$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids/
     */ clickedObjectIDs: function clickedObjectIDs() {
            for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
            if (params.length > 0) sendToInsights('clickedObjectIDs', $b68adfa5841d2350$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture the filters a user clicks on.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-filters/
     */ clickedFilters: function clickedFilters() {
            for(var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)params[_key3] = arguments[_key3];
            if (params.length > 0) searchInsights.apply(void 0, [
                'clickedFilters'
            ].concat(params));
        },
        /**
     * Sends conversion events to capture a query and its clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids-after-search/
     */ convertedObjectIDsAfterSearch: function convertedObjectIDsAfterSearch() {
            for(var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)params[_key4] = arguments[_key4];
            if (params.length > 0) sendToInsights('convertedObjectIDsAfterSearch', $b68adfa5841d2350$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids/
     */ convertedObjectIDs: function convertedObjectIDs() {
            for(var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)params[_key5] = arguments[_key5];
            if (params.length > 0) sendToInsights('convertedObjectIDs', $b68adfa5841d2350$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture the filters a user uses when converting.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-filters/
     */ convertedFilters: function convertedFilters() {
            for(var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)params[_key6] = arguments[_key6];
            if (params.length > 0) searchInsights.apply(void 0, [
                'convertedFilters'
            ].concat(params));
        },
        /**
     * Sends view events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-object-ids/
     */ viewedObjectIDs: function viewedObjectIDs() {
            for(var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)params[_key7] = arguments[_key7];
            if (params.length > 0) params.reduce(function(acc, _ref3) {
                var items = _ref3.items, param = $b68adfa5841d2350$var$_objectWithoutProperties(_ref3, $b68adfa5841d2350$var$_excluded2);
                return [].concat($b68adfa5841d2350$var$_toConsumableArray(acc), $b68adfa5841d2350$var$_toConsumableArray($b68adfa5841d2350$var$chunk($b68adfa5841d2350$var$_objectSpread($b68adfa5841d2350$var$_objectSpread({}, param), {}, {
                    objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref4) {
                        var objectID = _ref4.objectID;
                        return objectID;
                    })) || param.objectIDs
                })).map(function(payload) {
                    return {
                        items: items,
                        payload: payload
                    };
                })));
            }, []).forEach(function(_ref5) {
                var items = _ref5.items, payload = _ref5.payload;
                return sendToInsights('viewedObjectIDs', [
                    payload
                ], items);
            });
        },
        /**
     * Sends view events to capture the filters a user uses when viewing.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-filters/
     */ viewedFilters: function viewedFilters() {
            for(var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)params[_key8] = arguments[_key8];
            if (params.length > 0) searchInsights.apply(void 0, [
                'viewedFilters'
            ].concat(params));
        }
    };
}

});
parcelRegister("3lrLf", function(module, exports) {

$parcel$export(module.exports, "isModernInsightsClient", function () { return $26f8de06a6176e3f$export$5c9cfc0c9d3b5e01; });
function $26f8de06a6176e3f$var$_slicedToArray(arr, i) {
    return $26f8de06a6176e3f$var$_arrayWithHoles(arr) || $26f8de06a6176e3f$var$_iterableToArrayLimit(arr, i) || $26f8de06a6176e3f$var$_unsupportedIterableToArray(arr, i) || $26f8de06a6176e3f$var$_nonIterableRest();
}
function $26f8de06a6176e3f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $26f8de06a6176e3f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $26f8de06a6176e3f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $26f8de06a6176e3f$var$_arrayLikeToArray(o, minLen);
}
function $26f8de06a6176e3f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $26f8de06a6176e3f$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $26f8de06a6176e3f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $26f8de06a6176e3f$export$5c9cfc0c9d3b5e01(client) {
    var _split$map = (client.version || '').split('.').map(Number), _split$map2 = $26f8de06a6176e3f$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/camelcase */ var v3 = major >= 3;
    var v2_4 = major === 2 && minor >= 4;
    var v1_10 = major === 1 && minor >= 10;
    return v3 || v2_4 || v1_10;
/* eslint-enable @typescript-eslint/camelcase */ }

});


parcelRegister("2TNpO", function(module, exports) {

$parcel$export(module.exports, "createViewedEvents", function () { return $21c70cadd22338c9$export$8bae0094a47f6972; });
function $21c70cadd22338c9$export$8bae0094a47f6972(_ref) {
    var items = _ref.items;
    var itemsByIndexName = items.reduce(function(acc, current) {
        var _acc$current$__autoco;
        acc[current.__autocomplete_indexName] = ((_acc$current$__autoco = acc[current.__autocomplete_indexName]) !== null && _acc$current$__autoco !== void 0 ? _acc$current$__autoco : []).concat(current);
        return acc;
    }, {});
    return Object.keys(itemsByIndexName).map(function(indexName) {
        var items = itemsByIndexName[indexName];
        return {
            index: indexName,
            items: items,
            algoliaSource: [
                'autocomplete'
            ]
        };
    });
}

});

parcelRegister("kSj1w", function(module, exports) {

$parcel$export(module.exports, "isAlgoliaInsightsHit", function () { return $f3279b7c92ae427a$export$977f4849b4f88a72; });
function $f3279b7c92ae427a$export$977f4849b4f88a72(hit) {
    return hit.objectID && hit.__autocomplete_indexName && hit.__autocomplete_queryID;
}

});


parcelRegister("fJIBM", function(module, exports) {

$parcel$export(module.exports, "checkOptions", function () { return $b74da94c1a622f6f$export$6fe837ce0e0e0cdf; });

function $b74da94c1a622f6f$export$6fe837ce0e0e0cdf(options) {}

});

parcelRegister("kjPHd", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $ecadaec18ab8e3c3$export$f51a9068ac82ea43; });

var $gz5lC = parcelRequire("gz5lC");
function $ecadaec18ab8e3c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ecadaec18ab8e3c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ecadaec18ab8e3c3$var$_typeof(obj);
}
function $ecadaec18ab8e3c3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ecadaec18ab8e3c3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ecadaec18ab8e3c3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ecadaec18ab8e3c3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ecadaec18ab8e3c3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ecadaec18ab8e3c3$var$_defineProperty(obj, key, value) {
    key = $ecadaec18ab8e3c3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ecadaec18ab8e3c3$var$_toPropertyKey(arg) {
    var key = $ecadaec18ab8e3c3$var$_toPrimitive(arg, "string");
    return $ecadaec18ab8e3c3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ecadaec18ab8e3c3$var$_toPrimitive(input, hint) {
    if ($ecadaec18ab8e3c3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ecadaec18ab8e3c3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ecadaec18ab8e3c3$export$f51a9068ac82ea43(reducer, props, onStoreStateChange) {
    var state = props.initialState;
    return {
        getState: function getState() {
            return state;
        },
        dispatch: function dispatch(action, payload) {
            var prevState = $ecadaec18ab8e3c3$var$_objectSpread({}, state);
            state = reducer(state, {
                type: action,
                props: props,
                payload: payload
            });
            onStoreStateChange({
                state: state,
                prevState: prevState
            });
        },
        pendingRequests: (0, $gz5lC.createCancelablePromiseList)()
    };
}

});
parcelRegister("gz5lC", function(module, exports) {

$parcel$export(module.exports, "createCancelablePromiseList", function () { return $c0f410260728cac6$export$9661f890aacb4415; });
// Ensures multiple callers sync to the same promise.
var $c0f410260728cac6$var$_hasWaitPromiseResolved = true;
var $c0f410260728cac6$var$_waitPromise;
function $c0f410260728cac6$export$9661f890aacb4415() {
    var list = [];
    return {
        add: function add(cancelablePromise) {
            list.push(cancelablePromise);
            return cancelablePromise.finally(function() {
                list = list.filter(function(item) {
                    return item !== cancelablePromise;
                });
            });
        },
        cancelAll: function cancelAll() {
            list.forEach(function(promise) {
                return promise.cancel();
            });
        },
        isEmpty: function isEmpty() {
            return list.length === 0;
        },
        wait: function wait(timeout) {
            // Reuse promise if already exists. Keeps multiple callers subscribed to the same promise.
            if (!$c0f410260728cac6$var$_hasWaitPromiseResolved) return $c0f410260728cac6$var$_waitPromise;
            // Creates a promise which either resolves after all pending requests complete
            // or the timeout is reached (if provided). Whichever comes first.
            $c0f410260728cac6$var$_hasWaitPromiseResolved = false;
            $c0f410260728cac6$var$_waitPromise = !timeout ? Promise.all(list) : Promise.race([
                Promise.all(list),
                new Promise(function(resolve) {
                    return setTimeout(resolve, timeout);
                })
            ]);
            return $c0f410260728cac6$var$_waitPromise.then(function() {
                $c0f410260728cac6$var$_hasWaitPromiseResolved = true;
            });
        }
    };
}

});


parcelRegister("693jx", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteSetters", function () { return $479627752d170995$export$5085b122b817cee; });

var $ckSmA = parcelRequire("ckSmA");
function $479627752d170995$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $479627752d170995$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $479627752d170995$var$_typeof(obj);
}
function $479627752d170995$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $479627752d170995$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $479627752d170995$var$ownKeys(Object(source), !0).forEach(function(key) {
            $479627752d170995$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $479627752d170995$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $479627752d170995$var$_defineProperty(obj, key, value) {
    key = $479627752d170995$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $479627752d170995$var$_toPropertyKey(arg) {
    var key = $479627752d170995$var$_toPrimitive(arg, "string");
    return $479627752d170995$var$_typeof(key) === "symbol" ? key : String(key);
}
function $479627752d170995$var$_toPrimitive(input, hint) {
    if ($479627752d170995$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($479627752d170995$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $479627752d170995$export$5085b122b817cee(_ref) {
    var store = _ref.store;
    var setActiveItemId = function setActiveItemId(value) {
        store.dispatch('setActiveItemId', value);
    };
    var setQuery = function setQuery(value) {
        store.dispatch('setQuery', value);
    };
    var setCollections = function setCollections(rawValue) {
        var baseItemId = 0;
        var value = rawValue.map(function(collection) {
            return $479627752d170995$var$_objectSpread($479627752d170995$var$_objectSpread({}, collection), {}, {
                // We flatten the stored items to support calling `getAlgoliaResults`
                // from the source itself.
                items: (0, $ckSmA.flatten)(collection.items).map(function(item) {
                    return $479627752d170995$var$_objectSpread($479627752d170995$var$_objectSpread({}, item), {}, {
                        __autocomplete_id: baseItemId++
                    });
                })
            });
        });
        store.dispatch('setCollections', value);
    };
    var setIsOpen = function setIsOpen(value) {
        store.dispatch('setIsOpen', value);
    };
    var setStatus = function setStatus(value) {
        store.dispatch('setStatus', value);
    };
    var setContext = function setContext(value) {
        store.dispatch('setContext', value);
    };
    return {
        setActiveItemId: setActiveItemId,
        setQuery: setQuery,
        setCollections: setCollections,
        setIsOpen: setIsOpen,
        setStatus: setStatus,
        setContext: setContext
    };
}

});
parcelRegister("ckSmA", function(module, exports) {

$parcel$export(module.exports, "flatten", function () { return $8fb185b297a2a388$export$bffa455ba8c619a6; });
function $8fb185b297a2a388$export$bffa455ba8c619a6(values) {
    return values.reduce(function(a, b) {
        return a.concat(b);
    }, []);
}

});


parcelRegister("gjRUq", function(module, exports) {

$parcel$export(module.exports, "getDefaultProps", function () { return $be183ce5d6d3679c$export$61b94149aeb1f59; });

var $ckSmA = parcelRequire("ckSmA");
var $2o9EK = parcelRequire("2o9EK");
var $6GH72 = parcelRequire("6GH72");

var $112MQ = parcelRequire("112MQ");
function $be183ce5d6d3679c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $be183ce5d6d3679c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $be183ce5d6d3679c$var$_typeof(obj);
}
function $be183ce5d6d3679c$var$_toConsumableArray(arr) {
    return $be183ce5d6d3679c$var$_arrayWithoutHoles(arr) || $be183ce5d6d3679c$var$_iterableToArray(arr) || $be183ce5d6d3679c$var$_unsupportedIterableToArray(arr) || $be183ce5d6d3679c$var$_nonIterableSpread();
}
function $be183ce5d6d3679c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $be183ce5d6d3679c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $be183ce5d6d3679c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $be183ce5d6d3679c$var$_arrayLikeToArray(o, minLen);
}
function $be183ce5d6d3679c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $be183ce5d6d3679c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $be183ce5d6d3679c$var$_arrayLikeToArray(arr);
}
function $be183ce5d6d3679c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $be183ce5d6d3679c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $be183ce5d6d3679c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $be183ce5d6d3679c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $be183ce5d6d3679c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $be183ce5d6d3679c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $be183ce5d6d3679c$var$_defineProperty(obj, key, value) {
    key = $be183ce5d6d3679c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be183ce5d6d3679c$var$_toPropertyKey(arg) {
    var key = $be183ce5d6d3679c$var$_toPrimitive(arg, "string");
    return $be183ce5d6d3679c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $be183ce5d6d3679c$var$_toPrimitive(input, hint) {
    if ($be183ce5d6d3679c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($be183ce5d6d3679c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $be183ce5d6d3679c$export$61b94149aeb1f59(props, pluginSubscribers) {
    var _props$id;
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== 'undefined' ? window : {};
    /* eslint-enable no-restricted-globals */ var plugins = props.plugins || [];
    return $be183ce5d6d3679c$var$_objectSpread($be183ce5d6d3679c$var$_objectSpread({
        debug: false,
        openOnFocus: false,
        enterKeyHint: undefined,
        ignoreCompositionEvents: false,
        placeholder: '',
        autoFocus: false,
        defaultActiveItemId: null,
        stallThreshold: 300,
        insights: undefined,
        environment: environment,
        shouldPanelOpen: function shouldPanelOpen(_ref) {
            var state = _ref.state;
            return (0, $6GH72.getItemsCount)(state) > 0;
        },
        reshape: function reshape(_ref2) {
            var sources = _ref2.sources;
            return sources;
        }
    }, props), {}, {
        // Since `generateAutocompleteId` triggers a side effect (it increments
        // an internal counter), we don't want to execute it if unnecessary.
        id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : (0, $2o9EK.generateAutocompleteId)(),
        plugins: plugins,
        // The following props need to be deeply defaulted.
        initialState: $be183ce5d6d3679c$var$_objectSpread({
            activeItemId: null,
            query: '',
            completion: null,
            collections: [],
            isOpen: false,
            status: 'idle',
            context: {}
        }, props.initialState),
        onStateChange: function onStateChange(params) {
            var _props$onStateChange;
            (_props$onStateChange = props.onStateChange) === null || _props$onStateChange === void 0 || _props$onStateChange.call(props, params);
            plugins.forEach(function(x) {
                var _x$onStateChange;
                return (_x$onStateChange = x.onStateChange) === null || _x$onStateChange === void 0 ? void 0 : _x$onStateChange.call(x, params);
            });
        },
        onSubmit: function onSubmit(params) {
            var _props$onSubmit;
            (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 || _props$onSubmit.call(props, params);
            plugins.forEach(function(x) {
                var _x$onSubmit;
                return (_x$onSubmit = x.onSubmit) === null || _x$onSubmit === void 0 ? void 0 : _x$onSubmit.call(x, params);
            });
        },
        onReset: function onReset(params) {
            var _props$onReset;
            (_props$onReset = props.onReset) === null || _props$onReset === void 0 || _props$onReset.call(props, params);
            plugins.forEach(function(x) {
                var _x$onReset;
                return (_x$onReset = x.onReset) === null || _x$onReset === void 0 ? void 0 : _x$onReset.call(x, params);
            });
        },
        getSources: function getSources(params) {
            return Promise.all([].concat($be183ce5d6d3679c$var$_toConsumableArray(plugins.map(function(plugin) {
                return plugin.getSources;
            })), [
                props.getSources
            ]).filter(Boolean).map(function(getSources) {
                return (0, $112MQ.getNormalizedSources)(getSources, params);
            })).then(function(nested) {
                return (0, $ckSmA.flatten)(nested);
            }).then(function(sources) {
                return sources.map(function(source) {
                    return $be183ce5d6d3679c$var$_objectSpread($be183ce5d6d3679c$var$_objectSpread({}, source), {}, {
                        onSelect: function onSelect(params) {
                            source.onSelect(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onSelect;
                                return (_x$onSelect = x.onSelect) === null || _x$onSelect === void 0 ? void 0 : _x$onSelect.call(x, params);
                            });
                        },
                        onActive: function onActive(params) {
                            source.onActive(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onActive;
                                return (_x$onActive = x.onActive) === null || _x$onActive === void 0 ? void 0 : _x$onActive.call(x, params);
                            });
                        },
                        onResolve: function onResolve(params) {
                            source.onResolve(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onResolve;
                                return (_x$onResolve = x.onResolve) === null || _x$onResolve === void 0 ? void 0 : _x$onResolve.call(x, params);
                            });
                        }
                    });
                });
            });
        },
        navigator: $be183ce5d6d3679c$var$_objectSpread({
            navigate: function navigate(_ref3) {
                var itemUrl = _ref3.itemUrl;
                environment.location.assign(itemUrl);
            },
            navigateNewTab: function navigateNewTab(_ref4) {
                var itemUrl = _ref4.itemUrl;
                var windowReference = environment.open(itemUrl, '_blank', 'noopener');
                windowReference === null || windowReference === void 0 || windowReference.focus();
            },
            navigateNewWindow: function navigateNewWindow(_ref5) {
                var itemUrl = _ref5.itemUrl;
                environment.open(itemUrl, '_blank', 'noopener');
            }
        }, props.navigator)
    });
}

});
parcelRegister("2o9EK", function(module, exports) {

$parcel$export(module.exports, "generateAutocompleteId", function () { return $1bd5502cf23934de$export$46ae397d8484b6c2; });
var $1bd5502cf23934de$var$autocompleteId = 0;
function $1bd5502cf23934de$export$46ae397d8484b6c2() {
    return "autocomplete-".concat($1bd5502cf23934de$var$autocompleteId++);
}

});

parcelRegister("6GH72", function(module, exports) {

$parcel$export(module.exports, "getItemsCount", function () { return $4de81b93b3f21c7a$export$dd01a43948d7de86; });
function $4de81b93b3f21c7a$export$dd01a43948d7de86(state) {
    if (state.collections.length === 0) return 0;
    return state.collections.reduce(function(sum, collection) {
        return sum + collection.items.length;
    }, 0);
}

});

parcelRegister("112MQ", function(module, exports) {

$parcel$export(module.exports, "getNormalizedSources", function () { return $0bd80bd8ec32a085$export$c7afda361f77b571; });

var $bC31o = parcelRequire("bC31o");
var $hAVux = parcelRequire("hAVux");
var $4akAZ = parcelRequire("4akAZ");
function $0bd80bd8ec32a085$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0bd80bd8ec32a085$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0bd80bd8ec32a085$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0bd80bd8ec32a085$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0bd80bd8ec32a085$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0bd80bd8ec32a085$var$_defineProperty(obj, key, value) {
    key = $0bd80bd8ec32a085$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0bd80bd8ec32a085$var$_toPropertyKey(arg) {
    var key = $0bd80bd8ec32a085$var$_toPrimitive(arg, "string");
    return $0bd80bd8ec32a085$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0bd80bd8ec32a085$var$_toPrimitive(input, hint) {
    if ($0bd80bd8ec32a085$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0bd80bd8ec32a085$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0bd80bd8ec32a085$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0bd80bd8ec32a085$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0bd80bd8ec32a085$var$_typeof(obj);
}
function $0bd80bd8ec32a085$export$c7afda361f77b571(getSources, params) {
    var seenSourceIds = [];
    return Promise.resolve(getSources(params)).then(function(sources) {
        (0, $hAVux.invariant)(Array.isArray(sources), function() {
            return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify($0bd80bd8ec32a085$var$_typeof(sources)), ":\n\n").concat(JSON.stringify((0, $bC31o.decycle)(sources), null, 2));
        });
        return Promise.all(sources// We allow `undefined` and `false` sources to allow users to use
        // `Boolean(query) && source` (=> `false`).
        // We need to remove these values at this point.
        .filter(function(maybeSource) {
            return Boolean(maybeSource);
        }).map(function(source) {
            (0, $hAVux.invariant)(typeof source.sourceId === 'string', 'A source must provide a `sourceId` string.');
            if (seenSourceIds.includes(source.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(source.sourceId), " is not unique."));
            seenSourceIds.push(source.sourceId);
            var defaultSource = {
                getItemInputValue: function getItemInputValue(_ref) {
                    var state = _ref.state;
                    return state.query;
                },
                getItemUrl: function getItemUrl() {
                    return undefined;
                },
                onSelect: function onSelect(_ref2) {
                    var setIsOpen = _ref2.setIsOpen;
                    setIsOpen(false);
                },
                onActive: (0, $4akAZ.noop),
                onResolve: (0, $4akAZ.noop)
            };
            Object.keys(defaultSource).forEach(function(key) {
                defaultSource[key].__default = true;
            });
            var normalizedSource = $0bd80bd8ec32a085$var$_objectSpread($0bd80bd8ec32a085$var$_objectSpread({}, defaultSource), source);
            return Promise.resolve(normalizedSource);
        }));
    });
}

});
parcelRegister("bC31o", function(module, exports) {

$parcel$export(module.exports, "decycle", function () { return $8745964bb29c248d$export$ed3e2bdb532b061f; });
function $8745964bb29c248d$var$_slicedToArray(arr, i) {
    return $8745964bb29c248d$var$_arrayWithHoles(arr) || $8745964bb29c248d$var$_iterableToArrayLimit(arr, i) || $8745964bb29c248d$var$_unsupportedIterableToArray(arr, i) || $8745964bb29c248d$var$_nonIterableRest();
}
function $8745964bb29c248d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8745964bb29c248d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8745964bb29c248d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8745964bb29c248d$var$_arrayLikeToArray(o, minLen);
}
function $8745964bb29c248d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8745964bb29c248d$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8745964bb29c248d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8745964bb29c248d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8745964bb29c248d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8745964bb29c248d$var$_typeof(obj);
}
function $8745964bb29c248d$export$ed3e2bdb532b061f(obj) {
    var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var newSeen;
    return obj;
}

});

parcelRegister("hAVux", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $ccf265157abd3bd9$export$f5708dca728d7177; });
/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $ccf265157abd3bd9$export$f5708dca728d7177(condition, message) {
    return;
}

});



parcelRegister("9e25Y", function(module, exports) {

$parcel$export(module.exports, "getPropGetters", function () { return $6b770bf13ebbff5b$export$a4b47c9a40a3a795; });

var $4akAZ = parcelRequire("4akAZ");

var $ZNOPo = parcelRequire("ZNOPo");

var $j6e3I = parcelRequire("j6e3I");

var $j4Nus = parcelRequire("j4Nus");
var $76Wn8 = parcelRequire("76Wn8");
var $1fV6i = parcelRequire("1fV6i");
var $azk7z = parcelRequire("azk7z");
var $fHZk0 = parcelRequire("fHZk0");
var $d3XCN = parcelRequire("d3XCN");
function $6b770bf13ebbff5b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6b770bf13ebbff5b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6b770bf13ebbff5b$var$_typeof(obj);
}
var $6b770bf13ebbff5b$var$_excluded = [
    "props",
    "refresh",
    "store"
], $6b770bf13ebbff5b$var$_excluded2 = [
    "inputElement",
    "formElement",
    "panelElement"
], $6b770bf13ebbff5b$var$_excluded3 = [
    "inputElement"
], $6b770bf13ebbff5b$var$_excluded4 = [
    "inputElement",
    "maxLength"
], $6b770bf13ebbff5b$var$_excluded5 = [
    "source"
], $6b770bf13ebbff5b$var$_excluded6 = [
    "item",
    "source"
];
function $6b770bf13ebbff5b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6b770bf13ebbff5b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6b770bf13ebbff5b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6b770bf13ebbff5b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6b770bf13ebbff5b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6b770bf13ebbff5b$var$_defineProperty(obj, key, value) {
    key = $6b770bf13ebbff5b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6b770bf13ebbff5b$var$_toPropertyKey(arg) {
    var key = $6b770bf13ebbff5b$var$_toPrimitive(arg, "string");
    return $6b770bf13ebbff5b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6b770bf13ebbff5b$var$_toPrimitive(input, hint) {
    if ($6b770bf13ebbff5b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6b770bf13ebbff5b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6b770bf13ebbff5b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6b770bf13ebbff5b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6b770bf13ebbff5b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6b770bf13ebbff5b$export$a4b47c9a40a3a795(_ref) {
    var props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $6b770bf13ebbff5b$var$_objectWithoutProperties(_ref, $6b770bf13ebbff5b$var$_excluded);
    var getEnvironmentProps = function getEnvironmentProps(providedProps) {
        var inputElement = providedProps.inputElement, formElement = providedProps.formElement, panelElement = providedProps.panelElement, rest = $6b770bf13ebbff5b$var$_objectWithoutProperties(providedProps, $6b770bf13ebbff5b$var$_excluded2);
        function onMouseDownOrTouchStart(event) {
            // The `onTouchStart`/`onMouseDown` events shouldn't trigger the `blur`
            // handler when it's not an interaction with Autocomplete.
            // We detect it with the following heuristics:
            // - the panel is closed AND there are no pending requests
            //   (no interaction with the autocomplete, no future state updates)
            // - OR the touched target is the input element (should open the panel)
            var isAutocompleteInteraction = store.getState().isOpen || !store.pendingRequests.isEmpty();
            if (!isAutocompleteInteraction || event.target === inputElement) return;
            // @TODO: support cases where there are multiple Autocomplete instances.
            // Right now, a second instance makes this computation return false.
            var isTargetWithinAutocomplete = [
                formElement,
                panelElement
            ].some(function(contextNode) {
                return (0, $fHZk0.isOrContainsNode)(contextNode, event.target);
            });
            if (isTargetWithinAutocomplete === false) {
                store.dispatch('blur', null);
                // If requests are still pending when the user closes the panel, they
                // could reopen the panel once they resolve.
                // We want to prevent any subsequent query from reopening the panel
                // because it would result in an unsolicited UI behavior.
                if (!props.debug) store.pendingRequests.cancelAll();
            }
        }
        return $6b770bf13ebbff5b$var$_objectSpread({
            // We do not rely on the native `blur` event of the input to close the
            // panel, but rather on a custom `touchstart`/`mousedown` event outside
            // of the autocomplete elements.
            // This ensures we don't mistakenly interpret interactions within the
            // autocomplete (but outside of the input) as a signal to close the panel.
            // For example, clicking reset button causes an input blur, but if
            // `openOnFocus=true`, it shouldn't close the panel.
            // On touch devices, scrolling results (`touchmove`) causes an input blur
            // but shouldn't close the panel.
            onTouchStart: onMouseDownOrTouchStart,
            onMouseDown: onMouseDownOrTouchStart,
            // When scrolling on touch devices (mobiles, tablets, etc.), we want to
            // mimic the native platform behavior where the input is blurred to
            // hide the virtual keyboard. This gives more vertical space to
            // discover all the suggestions showing up in the panel.
            onTouchMove: function onTouchMove(event) {
                if (store.getState().isOpen === false || inputElement !== props.environment.document.activeElement || event.target === inputElement) return;
                inputElement.blur();
            }
        }, rest);
    };
    var getRootProps = function getRootProps(rest) {
        return $6b770bf13ebbff5b$var$_objectSpread({
            role: 'combobox',
            'aria-expanded': store.getState().isOpen,
            'aria-haspopup': 'listbox',
            'aria-controls': store.getState().isOpen ? store.getState().collections.map(function(_ref2) {
                var source = _ref2.source;
                return (0, $76Wn8.getAutocompleteElementId)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $76Wn8.getAutocompleteElementId)(props.id, 'label')
        }, rest);
    };
    var getFormProps = function getFormProps(providedProps) {
        var inputElement = providedProps.inputElement, rest = $6b770bf13ebbff5b$var$_objectWithoutProperties(providedProps, $6b770bf13ebbff5b$var$_excluded3);
        var handleSubmit = function handleSubmit(event) {
            var _providedProps$inputE;
            props.onSubmit($6b770bf13ebbff5b$var$_objectSpread({
                event: event,
                refresh: refresh,
                state: store.getState()
            }, setters));
            store.dispatch('submit', null);
            (_providedProps$inputE = providedProps.inputElement) === null || _providedProps$inputE === void 0 || _providedProps$inputE.blur();
        };
        return $6b770bf13ebbff5b$var$_objectSpread({
            action: '',
            noValidate: true,
            role: 'search',
            onSubmit: function onSubmit(event) {
                event.preventDefault();
                var waitForSubmit = (0, $azk7z.getPluginSubmitPromise)(props.plugins, store.pendingRequests);
                if (waitForSubmit !== undefined) waitForSubmit.then(function() {
                    return handleSubmit(event);
                });
                else handleSubmit(event);
            },
            onReset: function onReset(event) {
                var _providedProps$inputE2;
                event.preventDefault();
                props.onReset($6b770bf13ebbff5b$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('reset', null);
                (_providedProps$inputE2 = providedProps.inputElement) === null || _providedProps$inputE2 === void 0 || _providedProps$inputE2.focus();
            }
        }, rest);
    };
    var getInputProps = function getInputProps(providedProps) {
        var _props$environment$na;
        function onFocus(event) {
            // We want to trigger a query when `openOnFocus` is true
            // because the panel should open with the current query.
            if (props.openOnFocus || Boolean(store.getState().query)) (0, $ZNOPo.onInput)($6b770bf13ebbff5b$var$_objectSpread({
                event: event,
                props: props,
                query: store.getState().completion || store.getState().query,
                refresh: refresh,
                store: store
            }, setters));
            store.dispatch('focus', null);
        }
        var _ref3 = providedProps || {}, inputElement = _ref3.inputElement, _ref3$maxLength = _ref3.maxLength, maxLength = _ref3$maxLength === void 0 ? 512 : _ref3$maxLength, rest = $6b770bf13ebbff5b$var$_objectWithoutProperties(_ref3, $6b770bf13ebbff5b$var$_excluded4);
        var activeItem = (0, $j4Nus.getActiveItem)(store.getState());
        var userAgent = ((_props$environment$na = props.environment.navigator) === null || _props$environment$na === void 0 ? void 0 : _props$environment$na.userAgent) || '';
        var shouldFallbackKeyHint = (0, $d3XCN.isSamsung)(userAgent);
        var enterKeyHint = props.enterKeyHint || (activeItem !== null && activeItem !== void 0 && activeItem.itemUrl && !shouldFallbackKeyHint ? 'go' : 'search');
        return $6b770bf13ebbff5b$var$_objectSpread({
            'aria-autocomplete': 'both',
            'aria-activedescendant': store.getState().isOpen && store.getState().activeItemId !== null ? (0, $76Wn8.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), activeItem === null || activeItem === void 0 ? void 0 : activeItem.source) : undefined,
            'aria-controls': store.getState().isOpen ? store.getState().collections.filter(function(collection) {
                return collection.items.length > 0;
            }).map(function(_ref4) {
                var source = _ref4.source;
                return (0, $76Wn8.getAutocompleteElementId)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $76Wn8.getAutocompleteElementId)(props.id, 'label'),
            value: store.getState().completion || store.getState().query,
            id: (0, $76Wn8.getAutocompleteElementId)(props.id, 'input'),
            autoComplete: 'off',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            enterKeyHint: enterKeyHint,
            spellCheck: 'false',
            autoFocus: props.autoFocus,
            placeholder: props.placeholder,
            maxLength: maxLength,
            type: 'search',
            onChange: function onChange(event) {
                var value = event.currentTarget.value;
                if (props.ignoreCompositionEvents && (0, $1fV6i.getNativeEvent)(event).isComposing) {
                    setters.setQuery(value);
                    return;
                }
                (0, $ZNOPo.onInput)($6b770bf13ebbff5b$var$_objectSpread({
                    event: event,
                    props: props,
                    query: value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onCompositionEnd: function onCompositionEnd(event) {
                (0, $ZNOPo.onInput)($6b770bf13ebbff5b$var$_objectSpread({
                    event: event,
                    props: props,
                    query: event.currentTarget.value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onKeyDown: function onKeyDown(event) {
                if ((0, $1fV6i.getNativeEvent)(event).isComposing) return;
                (0, $j6e3I.onKeyDown)($6b770bf13ebbff5b$var$_objectSpread({
                    event: event,
                    props: props,
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onFocus: onFocus,
            // We don't rely on the `blur` event.
            // See explanation in `onTouchStart`/`onMouseDown`.
            // @MAJOR See if we need to keep this handler.
            onBlur: (0, $4akAZ.noop),
            onClick: function onClick(event) {
                // When the panel is closed and you click on the input while
                // the input is focused, the `onFocus` event is not triggered
                // (default browser behavior).
                // In an autocomplete context, it makes sense to open the panel in this
                // case.
                // We mimic this event by catching the `onClick` event which
                // triggers the `onFocus` for the panel to open.
                if (providedProps.inputElement === props.environment.document.activeElement && !store.getState().isOpen) onFocus(event);
            }
        }, rest);
    };
    var getLabelProps = function getLabelProps(rest) {
        return $6b770bf13ebbff5b$var$_objectSpread({
            htmlFor: (0, $76Wn8.getAutocompleteElementId)(props.id, 'input'),
            id: (0, $76Wn8.getAutocompleteElementId)(props.id, 'label')
        }, rest);
    };
    var getListProps = function getListProps(providedProps) {
        var _ref5 = providedProps || {}, source = _ref5.source, rest = $6b770bf13ebbff5b$var$_objectWithoutProperties(_ref5, $6b770bf13ebbff5b$var$_excluded5);
        return $6b770bf13ebbff5b$var$_objectSpread({
            role: 'listbox',
            'aria-labelledby': (0, $76Wn8.getAutocompleteElementId)(props.id, 'label'),
            id: (0, $76Wn8.getAutocompleteElementId)(props.id, 'list', source)
        }, rest);
    };
    var getPanelProps = function getPanelProps(rest) {
        return $6b770bf13ebbff5b$var$_objectSpread({
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the panel so
                // that the blur event is not triggered, otherwise it closes the
                // panel.
                event.preventDefault();
            },
            onMouseLeave: function onMouseLeave() {
                store.dispatch('mouseleave', null);
            }
        }, rest);
    };
    var getItemProps = function getItemProps(providedProps) {
        var item = providedProps.item, source = providedProps.source, rest = $6b770bf13ebbff5b$var$_objectWithoutProperties(providedProps, $6b770bf13ebbff5b$var$_excluded6);
        return $6b770bf13ebbff5b$var$_objectSpread({
            id: (0, $76Wn8.getAutocompleteElementId)(props.id, "item-".concat(item.__autocomplete_id), source),
            role: 'option',
            'aria-selected': store.getState().activeItemId === item.__autocomplete_id,
            onMouseMove: function onMouseMove(event) {
                if (item.__autocomplete_id === store.getState().activeItemId) return;
                store.dispatch('mousemove', item.__autocomplete_id);
                var activeItem = (0, $j4Nus.getActiveItem)(store.getState());
                if (store.getState().activeItemId !== null && activeItem) {
                    var _item = activeItem.item, itemInputValue = activeItem.itemInputValue, itemUrl = activeItem.itemUrl, _source = activeItem.source;
                    _source.onActive($6b770bf13ebbff5b$var$_objectSpread({
                        event: event,
                        item: _item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: _source,
                        state: store.getState()
                    }, setters));
                }
            },
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the item so it
                // can remain with the current `activeElement`.
                event.preventDefault();
            },
            onClick: function onClick(event) {
                var itemInputValue = source.getItemInputValue({
                    item: item,
                    state: store.getState()
                });
                var itemUrl = source.getItemUrl({
                    item: item,
                    state: store.getState()
                });
                // If `getItemUrl` is provided, it means that the suggestion
                // is a link, not plain text that aims at updating the query.
                // We can therefore skip the state change because it will update
                // the `activeItemId`, resulting in a UI flash, especially
                // noticeable on mobile.
                var runPreCommand = itemUrl ? Promise.resolve() : (0, $ZNOPo.onInput)($6b770bf13ebbff5b$var$_objectSpread({
                    event: event,
                    nextState: {
                        isOpen: false
                    },
                    props: props,
                    query: itemInputValue,
                    refresh: refresh,
                    store: store
                }, setters));
                runPreCommand.then(function() {
                    source.onSelect($6b770bf13ebbff5b$var$_objectSpread({
                        event: event,
                        item: item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: source,
                        state: store.getState()
                    }, setters));
                });
            }
        }, rest);
    };
    return {
        getEnvironmentProps: getEnvironmentProps,
        getRootProps: getRootProps,
        getFormProps: getFormProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getPanelProps: getPanelProps,
        getListProps: getListProps,
        getItemProps: getItemProps
    };
}

});
parcelRegister("ZNOPo", function(module, exports) {

$parcel$export(module.exports, "onInput", function () { return $0b9c5798d58b4419$export$7fbc06d7c1beb512; });

var $2E5MP = parcelRequire("2E5MP");

var $4YpBM = parcelRequire("4YpBM");

var $3iThl = parcelRequire("3iThl");
var $lqs5m = parcelRequire("lqs5m");
var $j4Nus = parcelRequire("j4Nus");
function $0b9c5798d58b4419$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0b9c5798d58b4419$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0b9c5798d58b4419$var$_typeof(obj);
}
var $0b9c5798d58b4419$var$_excluded = [
    "event",
    "nextState",
    "props",
    "query",
    "refresh",
    "store"
];
function $0b9c5798d58b4419$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0b9c5798d58b4419$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0b9c5798d58b4419$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0b9c5798d58b4419$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0b9c5798d58b4419$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0b9c5798d58b4419$var$_defineProperty(obj, key, value) {
    key = $0b9c5798d58b4419$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0b9c5798d58b4419$var$_toPropertyKey(arg) {
    var key = $0b9c5798d58b4419$var$_toPrimitive(arg, "string");
    return $0b9c5798d58b4419$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0b9c5798d58b4419$var$_toPrimitive(input, hint) {
    if ($0b9c5798d58b4419$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0b9c5798d58b4419$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0b9c5798d58b4419$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0b9c5798d58b4419$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0b9c5798d58b4419$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0b9c5798d58b4419$var$lastStalledId = null;
var $0b9c5798d58b4419$var$runConcurrentSafePromise = (0, $lqs5m.createConcurrentSafePromise)();
function $0b9c5798d58b4419$export$7fbc06d7c1beb512(_ref) {
    var event = _ref.event, _ref$nextState = _ref.nextState, nextState = _ref$nextState === void 0 ? {} : _ref$nextState, props = _ref.props, query = _ref.query, refresh = _ref.refresh, store = _ref.store, setters = $0b9c5798d58b4419$var$_objectWithoutProperties(_ref, $0b9c5798d58b4419$var$_excluded);
    if ($0b9c5798d58b4419$var$lastStalledId) props.environment.clearTimeout($0b9c5798d58b4419$var$lastStalledId);
    var setCollections = setters.setCollections, setIsOpen = setters.setIsOpen, setQuery = setters.setQuery, setActiveItemId = setters.setActiveItemId, setStatus = setters.setStatus, setContext = setters.setContext;
    setQuery(query);
    setActiveItemId(props.defaultActiveItemId);
    if (!query && props.openOnFocus === false) {
        var _nextState$isOpen;
        var collections = store.getState().collections.map(function(collection) {
            return $0b9c5798d58b4419$var$_objectSpread($0b9c5798d58b4419$var$_objectSpread({}, collection), {}, {
                items: []
            });
        });
        setStatus('idle');
        setCollections(collections);
        setIsOpen((_nextState$isOpen = nextState.isOpen) !== null && _nextState$isOpen !== void 0 ? _nextState$isOpen : props.shouldPanelOpen({
            state: store.getState()
        }));
        // We make sure to update the latest resolved value of the tracked
        // promises to keep late resolving promises from "cancelling" the state
        // updates performed in this code path.
        // We chain with a void promise to respect `onInput`'s expected return type.
        var _request = (0, $3iThl.cancelable)($0b9c5798d58b4419$var$runConcurrentSafePromise(collections).then(function() {
            return Promise.resolve();
        }));
        return store.pendingRequests.add(_request);
    }
    setStatus('loading');
    $0b9c5798d58b4419$var$lastStalledId = props.environment.setTimeout(function() {
        setStatus('stalled');
    }, props.stallThreshold);
    // We track the entire promise chain triggered by `onInput` before mutating
    // the Autocomplete state to make sure that any state manipulation is based on
    // fresh data regardless of when promises individually resolve.
    // We don't track nested promises and only rely on the full chain resolution,
    // meaning we should only ever manipulate the state once this concurrent-safe
    // promise is resolved.
    var request = (0, $3iThl.cancelable)($0b9c5798d58b4419$var$runConcurrentSafePromise(props.getSources($0b9c5798d58b4419$var$_objectSpread({
        query: query,
        refresh: refresh,
        state: store.getState()
    }, setters)).then(function(sources) {
        return Promise.all(sources.map(function(source) {
            return Promise.resolve(source.getItems($0b9c5798d58b4419$var$_objectSpread({
                query: query,
                refresh: refresh,
                state: store.getState()
            }, setters))).then(function(itemsOrDescription) {
                return (0, $4YpBM.preResolve)(itemsOrDescription, source.sourceId, store.getState());
            });
        })).then((0, $4YpBM.resolve)).then(function(responses) {
            var __automaticInsights = responses.some(function(_ref2) {
                var items = _ref2.items;
                return $0b9c5798d58b4419$var$isSearchResponseWithAutomaticInsightsFlag(items);
            });
            // No need to pollute the context if `__automaticInsights=false`
            if (__automaticInsights) {
                var _store$getState$conte;
                setContext({
                    algoliaInsightsPlugin: $0b9c5798d58b4419$var$_objectSpread($0b9c5798d58b4419$var$_objectSpread({}, ((_store$getState$conte = store.getState().context) === null || _store$getState$conte === void 0 ? void 0 : _store$getState$conte.algoliaInsightsPlugin) || {}), {}, {
                        __automaticInsights: __automaticInsights
                    })
                });
            }
            return (0, $4YpBM.postResolve)(responses, sources, store);
        }).then(function(collections) {
            return (0, $2E5MP.reshape)({
                collections: collections,
                props: props,
                state: store.getState()
            });
        });
    }))).then(function(collections) {
        var _nextState$isOpen2;
        // Parameters passed to `onInput` could be stale when the following code
        // executes, because `onInput` calls may not resolve in order.
        // If it becomes a problem we'll need to save the last passed parameters.
        // See: https://codesandbox.io/s/agitated-cookies-y290z
        setStatus('idle');
        setCollections(collections);
        var isPanelOpen = props.shouldPanelOpen({
            state: store.getState()
        });
        setIsOpen((_nextState$isOpen2 = nextState.isOpen) !== null && _nextState$isOpen2 !== void 0 ? _nextState$isOpen2 : props.openOnFocus && !query && isPanelOpen || isPanelOpen);
        var highlightedItem = (0, $j4Nus.getActiveItem)(store.getState());
        if (store.getState().activeItemId !== null && highlightedItem) {
            var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
            source.onActive($0b9c5798d58b4419$var$_objectSpread({
                event: event,
                item: item,
                itemInputValue: itemInputValue,
                itemUrl: itemUrl,
                refresh: refresh,
                source: source,
                state: store.getState()
            }, setters));
        }
    }).finally(function() {
        setStatus('idle');
        if ($0b9c5798d58b4419$var$lastStalledId) props.environment.clearTimeout($0b9c5798d58b4419$var$lastStalledId);
    });
    return store.pendingRequests.add(request);
}
function $0b9c5798d58b4419$var$isSearchResponseWithAutomaticInsightsFlag(items) {
    return !Array.isArray(items) && Boolean(items === null || items === void 0 ? void 0 : items._automaticInsights);
}

});
parcelRegister("2E5MP", function(module, exports) {

$parcel$export(module.exports, "reshape", function () { return $1ed3ce4b8b05e411$export$9eaad88cf88cee2b; });

var $ckSmA = parcelRequire("ckSmA");
function $1ed3ce4b8b05e411$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1ed3ce4b8b05e411$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1ed3ce4b8b05e411$var$_typeof(obj);
}
function $1ed3ce4b8b05e411$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1ed3ce4b8b05e411$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1ed3ce4b8b05e411$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1ed3ce4b8b05e411$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1ed3ce4b8b05e411$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1ed3ce4b8b05e411$var$_defineProperty(obj, key, value) {
    key = $1ed3ce4b8b05e411$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ed3ce4b8b05e411$var$_toPropertyKey(arg) {
    var key = $1ed3ce4b8b05e411$var$_toPrimitive(arg, "string");
    return $1ed3ce4b8b05e411$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1ed3ce4b8b05e411$var$_toPrimitive(input, hint) {
    if ($1ed3ce4b8b05e411$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1ed3ce4b8b05e411$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1ed3ce4b8b05e411$export$9eaad88cf88cee2b(_ref) {
    var collections = _ref.collections, props = _ref.props, state = _ref.state;
    // Sources are grouped by `sourceId` to conveniently pick them via destructuring.
    // Example: `const { recentSearchesPlugin } = sourcesBySourceId`
    var originalSourcesBySourceId = collections.reduce(function(acc, collection) {
        return $1ed3ce4b8b05e411$var$_objectSpread($1ed3ce4b8b05e411$var$_objectSpread({}, acc), {}, $1ed3ce4b8b05e411$var$_defineProperty({}, collection.source.sourceId, $1ed3ce4b8b05e411$var$_objectSpread($1ed3ce4b8b05e411$var$_objectSpread({}, collection.source), {}, {
            getItems: function getItems() {
                // We provide the resolved items from the collection to the `reshape` prop.
                return (0, $ckSmA.flatten)(collection.items);
            }
        })));
    }, {});
    var _props$plugins$reduce = props.plugins.reduce(function(acc, plugin) {
        if (plugin.reshape) return plugin.reshape(acc);
        return acc;
    }, {
        sourcesBySourceId: originalSourcesBySourceId,
        state: state
    }), sourcesBySourceId = _props$plugins$reduce.sourcesBySourceId;
    var reshapeSources = props.reshape({
        sourcesBySourceId: sourcesBySourceId,
        sources: Object.values(sourcesBySourceId),
        state: state
    });
    // We reconstruct the collections with the items modified by the `reshape` prop.
    return (0, $ckSmA.flatten)(reshapeSources).filter(Boolean).map(function(source) {
        return {
            source: source,
            items: source.getItems()
        };
    });
}

});

parcelRegister("4YpBM", function(module, exports) {

$parcel$export(module.exports, "preResolve", function () { return $39f0a14870cf991a$export$ae3cd3529c74e69e; });
$parcel$export(module.exports, "resolve", function () { return $39f0a14870cf991a$export$f7ad0328861e2f03; });
$parcel$export(module.exports, "postResolve", function () { return $39f0a14870cf991a$export$c1b3edf5a28f586; });

var $bC31o = parcelRequire("bC31o");
var $ckSmA = parcelRequire("ckSmA");
var $hAVux = parcelRequire("hAVux");

var $5Q6l8 = parcelRequire("5Q6l8");
function $39f0a14870cf991a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $39f0a14870cf991a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $39f0a14870cf991a$var$_typeof(obj);
}
function $39f0a14870cf991a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39f0a14870cf991a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $39f0a14870cf991a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $39f0a14870cf991a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $39f0a14870cf991a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $39f0a14870cf991a$var$_defineProperty(obj, key, value) {
    key = $39f0a14870cf991a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39f0a14870cf991a$var$_toPropertyKey(arg) {
    var key = $39f0a14870cf991a$var$_toPrimitive(arg, "string");
    return $39f0a14870cf991a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $39f0a14870cf991a$var$_toPrimitive(input, hint) {
    if ($39f0a14870cf991a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($39f0a14870cf991a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $39f0a14870cf991a$var$_toConsumableArray(arr) {
    return $39f0a14870cf991a$var$_arrayWithoutHoles(arr) || $39f0a14870cf991a$var$_iterableToArray(arr) || $39f0a14870cf991a$var$_unsupportedIterableToArray(arr) || $39f0a14870cf991a$var$_nonIterableSpread();
}
function $39f0a14870cf991a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39f0a14870cf991a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $39f0a14870cf991a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $39f0a14870cf991a$var$_arrayLikeToArray(o, minLen);
}
function $39f0a14870cf991a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $39f0a14870cf991a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $39f0a14870cf991a$var$_arrayLikeToArray(arr);
}
function $39f0a14870cf991a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $39f0a14870cf991a$var$isDescription(item) {
    return Boolean(item.execute);
}
function $39f0a14870cf991a$var$isRequesterDescription(description) {
    return Boolean(description === null || description === void 0 ? void 0 : description.execute);
}
function $39f0a14870cf991a$export$ae3cd3529c74e69e(itemsOrDescription, sourceId, state) {
    if ($39f0a14870cf991a$var$isRequesterDescription(itemsOrDescription)) {
        var contextParameters = itemsOrDescription.requesterId === 'algolia' ? Object.assign.apply(Object, [
            {}
        ].concat($39f0a14870cf991a$var$_toConsumableArray(Object.keys(state.context).map(function(key) {
            var _state$context$key;
            return (_state$context$key = state.context[key]) === null || _state$context$key === void 0 ? void 0 : _state$context$key.__algoliaSearchParameters;
        })))) : {};
        return $39f0a14870cf991a$var$_objectSpread($39f0a14870cf991a$var$_objectSpread({}, itemsOrDescription), {}, {
            requests: itemsOrDescription.queries.map(function(query) {
                return {
                    query: itemsOrDescription.requesterId === 'algolia' ? $39f0a14870cf991a$var$_objectSpread($39f0a14870cf991a$var$_objectSpread({}, query), {}, {
                        params: $39f0a14870cf991a$var$_objectSpread($39f0a14870cf991a$var$_objectSpread({}, contextParameters), query.params)
                    }) : query,
                    sourceId: sourceId,
                    transformResponse: itemsOrDescription.transformResponse
                };
            })
        });
    }
    return {
        items: itemsOrDescription,
        sourceId: sourceId
    };
}
function $39f0a14870cf991a$export$f7ad0328861e2f03(items) {
    var packed = items.reduce(function(acc, current) {
        if (!$39f0a14870cf991a$var$isDescription(current)) {
            acc.push(current);
            return acc;
        }
        var searchClient = current.searchClient, execute = current.execute, requesterId = current.requesterId, requests = current.requests;
        var container = acc.find(function(item) {
            return $39f0a14870cf991a$var$isDescription(current) && $39f0a14870cf991a$var$isDescription(item) && item.searchClient === searchClient && Boolean(requesterId) && item.requesterId === requesterId;
        });
        if (container) {
            var _container$items;
            (_container$items = container.items).push.apply(_container$items, $39f0a14870cf991a$var$_toConsumableArray(requests));
        } else {
            var request = {
                execute: execute,
                requesterId: requesterId,
                items: requests,
                searchClient: searchClient
            };
            acc.push(request);
        }
        return acc;
    }, []);
    var values = packed.map(function(maybeDescription) {
        if (!$39f0a14870cf991a$var$isDescription(maybeDescription)) return Promise.resolve(maybeDescription);
        var _ref = maybeDescription, execute = _ref.execute, _$items = _ref.items, searchClient = _ref.searchClient;
        return execute({
            searchClient: searchClient,
            requests: _$items
        });
    });
    return Promise.all(values).then(function(responses) {
        return (0, $ckSmA.flatten)(responses);
    });
}
function $39f0a14870cf991a$export$c1b3edf5a28f586(responses, sources, store) {
    return sources.map(function(source) {
        var matches = responses.filter(function(response) {
            return response.sourceId === source.sourceId;
        });
        var results = matches.map(function(_ref2) {
            var items = _ref2.items;
            return items;
        });
        var transform = matches[0].transformResponse;
        var items = transform ? transform((0, $5Q6l8.mapToAlgoliaResponse)(results)) : results;
        source.onResolve({
            source: source,
            results: results,
            items: items,
            state: store.getState()
        });
        (0, $hAVux.invariant)(Array.isArray(items), function() {
            return "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned type ").concat(JSON.stringify($39f0a14870cf991a$var$_typeof(items)), ":\n\n").concat(JSON.stringify((0, $bC31o.decycle)(items), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems");
        });
        (0, $hAVux.invariant)(items.every(Boolean), "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned ").concat(JSON.stringify(undefined), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"));
        return {
            source: source,
            items: items
        };
    });
}

});
parcelRegister("5Q6l8", function(module, exports) {

$parcel$export(module.exports, "mapToAlgoliaResponse", function () { return $4406ba05fef65a62$export$23042d7bd0b8d14b; });
function $4406ba05fef65a62$export$23042d7bd0b8d14b(rawResults) {
    return {
        results: rawResults,
        hits: rawResults.map(function(result) {
            return result.hits;
        }).filter(Boolean),
        facetHits: rawResults.map(function(result) {
            var _facetHits;
            return (_facetHits = result.facetHits) === null || _facetHits === void 0 ? void 0 : _facetHits.map(function(facetHit) {
                // Bring support for the highlighting components.
                return {
                    label: facetHit.value,
                    count: facetHit.count,
                    _highlightResult: {
                        label: {
                            value: facetHit.highlighted
                        }
                    }
                };
            });
        }).filter(Boolean)
    };
}

});


parcelRegister("3iThl", function(module, exports) {

$parcel$export(module.exports, "cancelable", function () { return $267deeba8f76be84$export$95ff25b64c2b7c9d; });
function $267deeba8f76be84$var$createInternalCancelablePromise(promise, initialState) {
    var state = initialState;
    return {
        then: function then(onfulfilled, onrejected) {
            return $267deeba8f76be84$var$createInternalCancelablePromise(promise.then($267deeba8f76be84$var$createCallback(onfulfilled, state, promise), $267deeba8f76be84$var$createCallback(onrejected, state, promise)), state);
        },
        catch: function _catch(onrejected) {
            return $267deeba8f76be84$var$createInternalCancelablePromise(promise.catch($267deeba8f76be84$var$createCallback(onrejected, state, promise)), state);
        },
        finally: function _finally(onfinally) {
            if (onfinally) state.onCancelList.push(onfinally);
            return $267deeba8f76be84$var$createInternalCancelablePromise(promise.finally($267deeba8f76be84$var$createCallback(onfinally && function() {
                state.onCancelList = [];
                return onfinally();
            }, state, promise)), state);
        },
        cancel: function cancel() {
            state.isCanceled = true;
            var callbacks = state.onCancelList;
            state.onCancelList = [];
            callbacks.forEach(function(callback) {
                callback();
            });
        },
        isCanceled: function isCanceled() {
            return state.isCanceled === true;
        }
    };
}
function $267deeba8f76be84$export$72af18a8b033265c(executor) {
    return $267deeba8f76be84$var$createInternalCancelablePromise(new Promise(function(resolve, reject) {
        return executor(resolve, reject);
    }), {
        isCanceled: false,
        onCancelList: []
    });
}
$267deeba8f76be84$export$72af18a8b033265c.resolve = function(value) {
    return $267deeba8f76be84$export$95ff25b64c2b7c9d(Promise.resolve(value));
};
$267deeba8f76be84$export$72af18a8b033265c.reject = function(reason) {
    return $267deeba8f76be84$export$95ff25b64c2b7c9d(Promise.reject(reason));
};
function $267deeba8f76be84$export$95ff25b64c2b7c9d(promise) {
    return $267deeba8f76be84$var$createInternalCancelablePromise(promise, {
        isCanceled: false,
        onCancelList: []
    });
}
function $267deeba8f76be84$var$createCallback(onResult, state, fallback) {
    if (!onResult) return fallback;
    return function callback(arg) {
        if (state.isCanceled) return arg;
        return onResult(arg);
    };
}

});

parcelRegister("lqs5m", function(module, exports) {

$parcel$export(module.exports, "createConcurrentSafePromise", function () { return $f991cfe1756292e8$export$8829b68d73f73d13; });
/**
 * Creates a runner that executes promises in a concurrent-safe way.
 *
 * This is useful to prevent older promises to resolve after a newer promise,
 * otherwise resulting in stale resolved values.
 */ function $f991cfe1756292e8$export$8829b68d73f73d13() {
    var basePromiseId = -1;
    var latestResolvedId = -1;
    var latestResolvedValue = undefined;
    return function runConcurrentSafePromise(promise) {
        basePromiseId++;
        var currentPromiseId = basePromiseId;
        return Promise.resolve(promise).then(function(x) {
            // The promise might take too long to resolve and get outdated. This would
            // result in resolving stale values.
            // When this happens, we ignore the promise value and return the one
            // coming from the latest resolved value.
            //
            // +----------------------------------+
            // |        100ms                     |
            // | run(1) +--->  R1                 |
            // |        300ms                     |
            // | run(2) +-------------> R2 (SKIP) |
            // |        200ms                     |
            // | run(3) +--------> R3             |
            // +----------------------------------+
            if (latestResolvedValue && currentPromiseId < latestResolvedId) return latestResolvedValue;
            latestResolvedId = currentPromiseId;
            latestResolvedValue = x;
            return x;
        });
    };
}

});

parcelRegister("j4Nus", function(module, exports) {

$parcel$export(module.exports, "getActiveItem", function () { return $de34c7cb2bc3b16e$export$f0f14253205ef68f; });
// We don't have access to the autocomplete source when we call `onKeyDown`
// or `onClick` because those are native browser events.
// However, we can get the source from the suggestion index.
function $de34c7cb2bc3b16e$var$getCollectionFromActiveItemId(state) {
    // Given 3 sources with respectively 1, 2 and 3 suggestions: [1, 2, 3]
    // We want to get the accumulated counts:
    // [1, 1 + 2, 1 + 2 + 3] = [1, 3, 3 + 3] = [1, 3, 6]
    var accumulatedCollectionsCount = state.collections.map(function(collections) {
        return collections.items.length;
    }).reduce(function(acc, collectionsCount, index) {
        var previousValue = acc[index - 1] || 0;
        var nextValue = previousValue + collectionsCount;
        acc.push(nextValue);
        return acc;
    }, []);
    // Based on the accumulated counts, we can infer the index of the suggestion.
    var collectionIndex = accumulatedCollectionsCount.reduce(function(acc, current) {
        if (current <= state.activeItemId) return acc + 1;
        return acc;
    }, 0);
    return state.collections[collectionIndex];
}
/**
 * Gets the highlighted index relative to a suggestion object (not the absolute
 * highlighted index).
 *
 * Example:
 *  [['a', 'b'], ['c', 'd', 'e'], ['f']]
 *                      ↑
 *         (absolute: 3, relative: 1)
 */ function $de34c7cb2bc3b16e$var$getRelativeActiveItemId(_ref) {
    var state = _ref.state, collection = _ref.collection;
    var isOffsetFound = false;
    var counter = 0;
    var previousItemsOffset = 0;
    while(isOffsetFound === false){
        var currentCollection = state.collections[counter];
        if (currentCollection === collection) {
            isOffsetFound = true;
            break;
        }
        previousItemsOffset += currentCollection.items.length;
        counter++;
    }
    return state.activeItemId - previousItemsOffset;
}
function $de34c7cb2bc3b16e$export$f0f14253205ef68f(state) {
    var collection = $de34c7cb2bc3b16e$var$getCollectionFromActiveItemId(state);
    if (!collection) return null;
    var item = collection.items[$de34c7cb2bc3b16e$var$getRelativeActiveItemId({
        state: state,
        collection: collection
    })];
    var source = collection.source;
    var itemInputValue = source.getItemInputValue({
        item: item,
        state: state
    });
    var itemUrl = source.getItemUrl({
        item: item,
        state: state
    });
    return {
        item: item,
        itemInputValue: itemInputValue,
        itemUrl: itemUrl,
        source: source
    };
}

});


parcelRegister("j6e3I", function(module, exports) {

$parcel$export(module.exports, "onKeyDown", function () { return $de797ba7e188fa18$export$de8e1b1372cdb41b; });

var $ZNOPo = parcelRequire("ZNOPo");

var $j4Nus = parcelRequire("j4Nus");
var $76Wn8 = parcelRequire("76Wn8");
var $azk7z = parcelRequire("azk7z");
function $de797ba7e188fa18$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $de797ba7e188fa18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $de797ba7e188fa18$var$_typeof(obj);
}
var $de797ba7e188fa18$var$_excluded = [
    "event",
    "props",
    "refresh",
    "store"
];
function $de797ba7e188fa18$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de797ba7e188fa18$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de797ba7e188fa18$var$ownKeys(Object(source), !0).forEach(function(key) {
            $de797ba7e188fa18$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de797ba7e188fa18$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de797ba7e188fa18$var$_defineProperty(obj, key, value) {
    key = $de797ba7e188fa18$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de797ba7e188fa18$var$_toPropertyKey(arg) {
    var key = $de797ba7e188fa18$var$_toPrimitive(arg, "string");
    return $de797ba7e188fa18$var$_typeof(key) === "symbol" ? key : String(key);
}
function $de797ba7e188fa18$var$_toPrimitive(input, hint) {
    if ($de797ba7e188fa18$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($de797ba7e188fa18$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $de797ba7e188fa18$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $de797ba7e188fa18$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $de797ba7e188fa18$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $de797ba7e188fa18$export$de8e1b1372cdb41b(_ref) {
    var event = _ref.event, props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $de797ba7e188fa18$var$_objectWithoutProperties(_ref, $de797ba7e188fa18$var$_excluded);
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        // eslint-disable-next-line no-inner-declarations
        var triggerScrollIntoView = function triggerScrollIntoView() {
            var highlightedItem = (0, $j4Nus.getActiveItem)(store.getState());
            var nodeItem = props.environment.document.getElementById((0, $76Wn8.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.source));
            if (nodeItem) {
                if (nodeItem.scrollIntoViewIfNeeded) nodeItem.scrollIntoViewIfNeeded(false);
                else nodeItem.scrollIntoView(false);
            }
        }; // eslint-disable-next-line no-inner-declarations
        var triggerOnActive = function triggerOnActive() {
            var highlightedItem = (0, $j4Nus.getActiveItem)(store.getState());
            if (store.getState().activeItemId !== null && highlightedItem) {
                var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
                source.onActive($de797ba7e188fa18$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            }
        }; // Default browser behavior changes the caret placement on ArrowUp and
        // ArrowDown.
        event.preventDefault();
        // When re-opening the panel, we need to split the logic to keep the actions
        // synchronized as `onInput` returns a promise.
        if (store.getState().isOpen === false && (props.openOnFocus || Boolean(store.getState().query))) (0, $ZNOPo.onInput)($de797ba7e188fa18$var$_objectSpread({
            event: event,
            props: props,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters)).then(function() {
            store.dispatch(event.key, {
                nextActiveItemId: props.defaultActiveItemId
            });
            triggerOnActive();
            // Since we rely on the DOM, we need to wait for all the micro tasks to
            // finish (which include re-opening the panel) to make sure all the
            // elements are available.
            setTimeout(triggerScrollIntoView, 0);
        });
        else {
            store.dispatch(event.key, {});
            triggerOnActive();
            triggerScrollIntoView();
        }
    } else if (event.key === 'Escape') {
        // This prevents the default browser behavior on `input[type="search"]`
        // from removing the query right away because we first want to close the
        // panel.
        event.preventDefault();
        store.dispatch(event.key, null);
        // Hitting the `Escape` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Tab') {
        store.dispatch('blur', null);
        // Hitting the `Tab` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Enter') {
        // No active item, so we let the browser handle the native `onSubmit` form
        // event.
        if (store.getState().activeItemId === null || store.getState().collections.every(function(collection) {
            return collection.items.length === 0;
        })) {
            var waitForSubmit = (0, $azk7z.getPluginSubmitPromise)(props.plugins, store.pendingRequests);
            if (waitForSubmit !== undefined) waitForSubmit.then(store.pendingRequests.cancelAll); // Cancel the rest if timeout number is provided
            else if (!props.debug) // If requests are still pending when the panel closes, they could reopen
            // the panel once they resolve.
            // We want to prevent any subsequent query from reopening the panel
            // because it would result in an unsolicited UI behavior.
            store.pendingRequests.cancelAll();
            return;
        }
        // This prevents the `onSubmit` event to be sent because an item is
        // highlighted.
        event.preventDefault();
        var _ref2 = (0, $j4Nus.getActiveItem)(store.getState()), item = _ref2.item, itemInputValue = _ref2.itemInputValue, itemUrl = _ref2.itemUrl, source = _ref2.source;
        if (event.metaKey || event.ctrlKey) {
            if (itemUrl !== undefined) {
                source.onSelect($de797ba7e188fa18$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewTab({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.shiftKey) {
            if (itemUrl !== undefined) {
                source.onSelect($de797ba7e188fa18$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewWindow({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.altKey) ;
        else {
            if (itemUrl !== undefined) {
                source.onSelect($de797ba7e188fa18$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigate({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
                return;
            }
            (0, $ZNOPo.onInput)($de797ba7e188fa18$var$_objectSpread({
                event: event,
                nextState: {
                    isOpen: false
                },
                props: props,
                query: itemInputValue,
                refresh: refresh,
                store: store
            }, setters)).then(function() {
                source.onSelect($de797ba7e188fa18$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            });
        }
    }
}

});
parcelRegister("76Wn8", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteElementId", function () { return $52d65f6c9dd13774$export$17f5bb35a44b3f03; });
/**
 * Returns a full element id for an autocomplete element.
 *
 * @param autocompleteInstanceId The id of the autocomplete instance
 * @param elementId The specific element id
 * @param source The source of the element, when it needs to be scoped
 */ function $52d65f6c9dd13774$export$17f5bb35a44b3f03(autocompleteInstanceId, elementId, source) {
    return [
        autocompleteInstanceId,
        source === null || source === void 0 ? void 0 : source.sourceId,
        elementId
    ].filter(Boolean).join('-').replace(/\s/g, '');
}

});

parcelRegister("azk7z", function(module, exports) {

$parcel$export(module.exports, "getPluginSubmitPromise", function () { return $7b1cc7e0ac42f347$export$cbf3bb7319a8fa85; });
function $7b1cc7e0ac42f347$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7b1cc7e0ac42f347$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7b1cc7e0ac42f347$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b1cc7e0ac42f347$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b1cc7e0ac42f347$var$_arrayLikeToArray(o, minLen);
}
function $7b1cc7e0ac42f347$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7b1cc7e0ac42f347$export$cbf3bb7319a8fa85 = function getPluginSubmitPromise(plugins, pendingRequests) {
    var waitUntilComplete = false;
    var timeouts = [];
    var _iterator = $7b1cc7e0ac42f347$var$_createForOfIteratorHelper(plugins), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _plugin$__autocomplet, _plugin$__autocomplet2, _plugin$__autocomplet3;
            var plugin = _step.value;
            var value = (_plugin$__autocomplet = plugin.__autocomplete_pluginOptions) === null || _plugin$__autocomplet === void 0 ? void 0 : (_plugin$__autocomplet2 = (_plugin$__autocomplet3 = _plugin$__autocomplet).awaitSubmit) === null || _plugin$__autocomplet2 === void 0 ? void 0 : _plugin$__autocomplet2.call(_plugin$__autocomplet3);
            if (typeof value === 'number') timeouts.push(value);
            else if (value === true) {
                waitUntilComplete = true;
                break; // break loop as bool overrides num array below
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (waitUntilComplete) return pendingRequests.wait();
    else if (timeouts.length > 0) return pendingRequests.wait(Math.max.apply(Math, timeouts));
    return undefined;
};

});


parcelRegister("1fV6i", function(module, exports) {

$parcel$export(module.exports, "getNativeEvent", function () { return $0ea37c2759988741$export$4abe0e945399ac1d; });
function $0ea37c2759988741$export$4abe0e945399ac1d(event) {
    return event.nativeEvent || event;
}

});

parcelRegister("fHZk0", function(module, exports) {

$parcel$export(module.exports, "isOrContainsNode", function () { return $b6fa70626c33885e$export$428954767edfafa7; });
function $b6fa70626c33885e$export$428954767edfafa7(parent, child) {
    return parent === child || parent.contains(child);
}

});

parcelRegister("d3XCN", function(module, exports) {

$parcel$export(module.exports, "isSamsung", function () { return $02744985d939efcf$export$838732a363f40fc6; });
var $02744985d939efcf$var$regex = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
function $02744985d939efcf$export$838732a363f40fc6(userAgent) {
    return Boolean(userAgent && userAgent.match($02744985d939efcf$var$regex));
}

});


parcelRegister("d43QV", function(module, exports) {

$parcel$export(module.exports, "getMetadata", function () { return $982ea3203003d7cc$export$8548546c0aa631e6; });
$parcel$export(module.exports, "injectMetadata", function () { return $982ea3203003d7cc$export$404feeb97c870f44; });

var $gKX7m = parcelRequire("gKX7m");
function $982ea3203003d7cc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $982ea3203003d7cc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $982ea3203003d7cc$var$_typeof(obj);
}
function $982ea3203003d7cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $982ea3203003d7cc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $982ea3203003d7cc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $982ea3203003d7cc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $982ea3203003d7cc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $982ea3203003d7cc$var$_defineProperty(obj, key, value) {
    key = $982ea3203003d7cc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $982ea3203003d7cc$var$_toPropertyKey(arg) {
    var key = $982ea3203003d7cc$var$_toPrimitive(arg, "string");
    return $982ea3203003d7cc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $982ea3203003d7cc$var$_toPrimitive(input, hint) {
    if ($982ea3203003d7cc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($982ea3203003d7cc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $982ea3203003d7cc$export$8548546c0aa631e6(_ref) {
    var _, _options$__autocomple, _options$__autocomple2, _options$__autocomple3;
    var plugins = _ref.plugins, options = _ref.options;
    var optionsKey = (_ = (((_options$__autocomple = options.__autocomplete_metadata) === null || _options$__autocomple === void 0 ? void 0 : _options$__autocomple.userAgents) || [])[0]) === null || _ === void 0 ? void 0 : _.segment;
    var extraOptions = optionsKey ? $982ea3203003d7cc$var$_defineProperty({}, optionsKey, Object.keys(((_options$__autocomple2 = options.__autocomplete_metadata) === null || _options$__autocomple2 === void 0 ? void 0 : _options$__autocomple2.options) || {})) : {};
    return {
        plugins: plugins.map(function(plugin) {
            return {
                name: plugin.name,
                options: Object.keys(plugin.__autocomplete_pluginOptions || [])
            };
        }),
        options: $982ea3203003d7cc$var$_objectSpread({
            'autocomplete-core': Object.keys(options)
        }, extraOptions),
        ua: (0, $gKX7m.userAgents).concat(((_options$__autocomple3 = options.__autocomplete_metadata) === null || _options$__autocomple3 === void 0 ? void 0 : _options$__autocomple3.userAgents) || [])
    };
}
function $982ea3203003d7cc$export$404feeb97c870f44(_ref3) {
    var _environment$navigato, _environment$navigato2;
    var metadata = _ref3.metadata, environment = _ref3.environment;
    var isMetadataEnabled = (_environment$navigato = environment.navigator) === null || _environment$navigato === void 0 ? void 0 : (_environment$navigato2 = _environment$navigato.userAgent) === null || _environment$navigato2 === void 0 ? void 0 : _environment$navigato2.includes('Algolia Crawler');
    if (isMetadataEnabled) {
        var metadataContainer = environment.document.createElement('meta');
        var headRef = environment.document.querySelector('head');
        metadataContainer.name = 'algolia:metadata';
        setTimeout(function() {
            metadataContainer.content = JSON.stringify(metadata);
            headRef.appendChild(metadataContainer);
        }, 0);
    }
}

});
parcelRegister("gKX7m", function(module, exports) {

$parcel$export(module.exports, "userAgents", function () { return $c32eccca0806c7e6$export$9536ea83a4cbd560; });

var $igGyg = parcelRequire("igGyg");
var $c32eccca0806c7e6$export$9536ea83a4cbd560 = [
    {
        segment: 'autocomplete-core',
        version: (0, $igGyg.version)
    }
];

});
parcelRegister("igGyg", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $036e9fe94b4283fc$export$83d89fbfd8236492; });
var $036e9fe94b4283fc$export$83d89fbfd8236492 = '1.19.2';

});



parcelRegister("35zz4", function(module, exports) {

$parcel$export(module.exports, "stateReducer", function () { return $23fd6d1deb627ba2$export$ca8ebd435faad836; });

var $6GH72 = parcelRequire("6GH72");
var $hAVux = parcelRequire("hAVux");

var $9I9Am = parcelRequire("9I9Am");

var $iQCUj = parcelRequire("iQCUj");
function $23fd6d1deb627ba2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $23fd6d1deb627ba2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $23fd6d1deb627ba2$var$_typeof(obj);
}
function $23fd6d1deb627ba2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $23fd6d1deb627ba2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $23fd6d1deb627ba2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $23fd6d1deb627ba2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $23fd6d1deb627ba2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $23fd6d1deb627ba2$var$_defineProperty(obj, key, value) {
    key = $23fd6d1deb627ba2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $23fd6d1deb627ba2$var$_toPropertyKey(arg) {
    var key = $23fd6d1deb627ba2$var$_toPrimitive(arg, "string");
    return $23fd6d1deb627ba2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $23fd6d1deb627ba2$var$_toPrimitive(input, hint) {
    if ($23fd6d1deb627ba2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($23fd6d1deb627ba2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $23fd6d1deb627ba2$export$ca8ebd435faad836 = function stateReducer(state, action) {
    switch(action.type){
        case 'setActiveItemId':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'setQuery':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                query: action.payload,
                completion: null
            });
        case 'setCollections':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                collections: action.payload
            });
        case 'setIsOpen':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                isOpen: action.payload
            });
        case 'setStatus':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                status: action.payload
            });
        case 'setContext':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                context: $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state.context), action.payload)
            });
        case 'ArrowDown':
            var nextState = $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload.hasOwnProperty('nextActiveItemId') ? action.payload.nextActiveItemId : (0, $iQCUj.getNextActiveItemId)(1, state.activeItemId, (0, $6GH72.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, nextState), {}, {
                completion: (0, $9I9Am.getCompletion)({
                    state: nextState
                })
            });
        case 'ArrowUp':
            var _nextState = $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: (0, $iQCUj.getNextActiveItemId)(-1, state.activeItemId, (0, $6GH72.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, _nextState), {}, {
                completion: (0, $9I9Am.getCompletion)({
                    state: _nextState
                })
            });
        case 'Escape':
            if (state.isOpen) return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                completion: null
            });
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                query: '',
                status: 'idle',
                collections: []
            });
        case 'submit':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                status: 'idle'
            });
        case 'reset':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: // Since we open the panel on reset when openOnFocus=true
                // we need to restore the highlighted index to the defaultActiveItemId. (DocSearch use-case)
                // Since we close the panel when openOnFocus=false
                // we lose track of the highlighted index. (Query-suggestions use-case)
                action.props.openOnFocus === true ? action.props.defaultActiveItemId : null,
                status: 'idle',
                completion: null,
                query: ''
            });
        case 'focus':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId,
                isOpen: (action.props.openOnFocus || Boolean(state.query)) && action.props.shouldPanelOpen({
                    state: state
                })
            });
        case 'blur':
            if (action.props.debug) return state;
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                isOpen: false,
                activeItemId: null
            });
        case 'mousemove':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'mouseleave':
            return $23fd6d1deb627ba2$var$_objectSpread($23fd6d1deb627ba2$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId
            });
        default:
            (0, $hAVux.invariant)(false, "The reducer action ".concat(JSON.stringify(action.type), " is not supported."));
            return state;
    }
};

});
parcelRegister("9I9Am", function(module, exports) {

$parcel$export(module.exports, "getCompletion", function () { return $711fa8974065b7ca$export$6c69e642446172b6; });

var $j4Nus = parcelRequire("j4Nus");
function $711fa8974065b7ca$export$6c69e642446172b6(_ref) {
    var _getActiveItem;
    var state = _ref.state;
    if (state.isOpen === false || state.activeItemId === null) return null;
    return ((_getActiveItem = (0, $j4Nus.getActiveItem)(state)) === null || _getActiveItem === void 0 ? void 0 : _getActiveItem.itemInputValue) || null;
}

});

parcelRegister("iQCUj", function(module, exports) {

$parcel$export(module.exports, "getNextActiveItemId", function () { return $db8b437ebe1e46f5$export$9e353209669d8620; });
/**
 * Returns the next active item ID from the current state.
 *
 * We allow circular keyboard navigation from the base index.
 * The base index can either be `null` (nothing is highlighted) or `0`
 * (the first item is highlighted).
 * The base index is allowed to get assigned `null` only if
 * `props.defaultActiveItemId` is `null`. This pattern allows to "stop"
 * by the actual query before navigating to other suggestions as seen on
 * Google or Amazon.
 *
 * @param moveAmount The offset to increment (or decrement) the last index
 * @param baseIndex The current index to compute the next index from
 * @param itemCount The number of items
 * @param defaultActiveItemId The default active index to fallback to
 */ function $db8b437ebe1e46f5$export$9e353209669d8620(moveAmount, baseIndex, itemCount, defaultActiveItemId) {
    if (!itemCount) return null;
    if (moveAmount < 0 && (baseIndex === null || defaultActiveItemId !== null && baseIndex === 0)) return itemCount + moveAmount;
    var numericIndex = (baseIndex === null ? -1 : baseIndex) + moveAmount;
    if (numericIndex <= -1 || numericIndex >= itemCount) return defaultActiveItemId === null ? null : 0;
    return numericIndex;
}

});



parcelRegister("i0Pbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1cfee5e85fc4e3b$export$2e2bcd8739ae039; });
var $d1cfee5e85fc4e3b$var$n = function n1(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $d1cfee5e85fc4e3b$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $d1cfee5e85fc4e3b$var$t = new Map;
function $d1cfee5e85fc4e3b$export$2e2bcd8739ae039(s) {
    var r = $d1cfee5e85fc4e3b$var$t.get(this);
    return r || (r = new Map, $d1cfee5e85fc4e3b$var$t.set(this, r)), (r = $d1cfee5e85fc4e3b$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, _$s, r = 1, e = "", u = "", h = [
            0
        ], p = function p(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, _$s), r = 6), n && (h.push(r, n, 0, _$s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, _$s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}

});

parcelRegister("79XkZ", function(module, exports) {

$parcel$export(module.exports, "createAutocompleteDom", function () { return $536766dbf7f2748e$export$55e5ca2210a4e3c2; });

var $7wPkn = parcelRequire("7wPkn");
var $donsR = parcelRequire("donsR");
var $1fzoV = parcelRequire("1fzoV");
var $hjsg2 = parcelRequire("hjsg2");

var $ltYgQ = parcelRequire("ltYgQ");

function $536766dbf7f2748e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $536766dbf7f2748e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $536766dbf7f2748e$var$_typeof(obj);
}
function $536766dbf7f2748e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $536766dbf7f2748e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $536766dbf7f2748e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $536766dbf7f2748e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $536766dbf7f2748e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $536766dbf7f2748e$var$_defineProperty(obj, key, value) {
    key = $536766dbf7f2748e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $536766dbf7f2748e$var$_toPropertyKey(arg) {
    var key = $536766dbf7f2748e$var$_toPrimitive(arg, "string");
    return $536766dbf7f2748e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $536766dbf7f2748e$var$_toPrimitive(input, hint) {
    if ($536766dbf7f2748e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($536766dbf7f2748e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $536766dbf7f2748e$export$55e5ca2210a4e3c2(_ref) {
    var autocomplete = _ref.autocomplete, autocompleteScopeApi = _ref.autocompleteScopeApi, classNames = _ref.classNames, environment = _ref.environment, isDetached = _ref.isDetached, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder, propGetters = _ref.propGetters, setIsModalOpen = _ref.setIsModalOpen, state = _ref.state, translations = _ref.translations;
    var createDomElement = (0, $ltYgQ.getCreateDomElement)(environment);
    var rootProps = propGetters.getRootProps($536766dbf7f2748e$var$_objectSpread({
        state: state,
        props: autocomplete.getRootProps({})
    }, autocompleteScopeApi));
    var root = createDomElement('div', $536766dbf7f2748e$var$_objectSpread({
        class: classNames.root
    }, rootProps));
    var detachedContainer = createDomElement('div', {
        class: classNames.detachedContainer,
        onMouseDown: function onMouseDown(event) {
            event.stopPropagation();
        }
    });
    var detachedOverlay = createDomElement('div', {
        class: classNames.detachedOverlay,
        children: [
            detachedContainer
        ],
        onMouseDown: function onMouseDown() {
            setIsModalOpen(false);
            autocomplete.setIsOpen(false);
        }
    });
    var labelProps = propGetters.getLabelProps($536766dbf7f2748e$var$_objectSpread({
        state: state,
        props: autocomplete.getLabelProps({})
    }, autocompleteScopeApi));
    var submitButton = createDomElement('button', {
        class: classNames.submitButton,
        type: 'submit',
        title: translations.submitButtonTitle,
        children: [
            (0, $hjsg2.SearchIcon)({
                environment: environment
            })
        ]
    });
    // @MAJOR Remove the label wrapper for the submit button.
    // The submit button is sufficient for accessibility purposes, and
    // wrapping it with the label actually makes it less accessible (see CR-6077).
    var label = createDomElement('label', $536766dbf7f2748e$var$_objectSpread({
        class: classNames.label,
        children: [
            submitButton
        ],
        ariaLabel: translations.submitButtonTitle
    }, labelProps));
    var clearButton = createDomElement('button', {
        class: classNames.clearButton,
        type: 'reset',
        title: translations.clearButtonTitle,
        children: [
            (0, $7wPkn.ClearIcon)({
                environment: environment
            })
        ]
    });
    var loadingIndicator = createDomElement('div', {
        class: classNames.loadingIndicator,
        children: [
            (0, $1fzoV.LoadingIcon)({
                environment: environment
            })
        ]
    });
    var input = (0, $donsR.Input)({
        class: classNames.input,
        environment: environment,
        state: state,
        getInputProps: propGetters.getInputProps,
        getInputPropsCore: autocomplete.getInputProps,
        autocompleteScopeApi: autocompleteScopeApi,
        isDetached: isDetached
    });
    var inputWrapperPrefix = createDomElement('div', {
        class: classNames.inputWrapperPrefix,
        children: [
            label,
            loadingIndicator
        ]
    });
    var inputWrapperSuffix = createDomElement('div', {
        class: classNames.inputWrapperSuffix,
        children: [
            clearButton
        ]
    });
    var inputWrapper = createDomElement('div', {
        class: classNames.inputWrapper,
        children: [
            input
        ]
    });
    var formProps = propGetters.getFormProps($536766dbf7f2748e$var$_objectSpread({
        state: state,
        props: autocomplete.getFormProps({
            inputElement: input
        })
    }, autocompleteScopeApi));
    var form = createDomElement('form', $536766dbf7f2748e$var$_objectSpread({
        class: classNames.form,
        children: [
            inputWrapperPrefix,
            inputWrapper,
            inputWrapperSuffix
        ]
    }, formProps));
    var panelProps = propGetters.getPanelProps($536766dbf7f2748e$var$_objectSpread({
        state: state,
        props: autocomplete.getPanelProps({})
    }, autocompleteScopeApi));
    var panel = createDomElement('div', $536766dbf7f2748e$var$_objectSpread({
        class: classNames.panel
    }, panelProps));
    var detachedSearchButtonQuery = createDomElement('div', {
        class: classNames.detachedSearchButtonQuery,
        textContent: state.query
    });
    var detachedSearchButtonPlaceholder = createDomElement('div', {
        class: classNames.detachedSearchButtonPlaceholder,
        hidden: Boolean(state.query),
        textContent: placeholder
    });
    if (isDetached) {
        var detachedSearchButtonIcon = createDomElement('div', {
            class: classNames.detachedSearchButtonIcon,
            ariaLabel: translations.detachedSearchButtonTitle,
            children: [
                (0, $hjsg2.SearchIcon)({
                    environment: environment
                })
            ]
        });
        var detachedSearchButton = createDomElement('button', {
            type: 'button',
            class: classNames.detachedSearchButton,
            title: translations.detachedSearchButtonTitle,
            id: labelProps.id,
            onClick: function onClick() {
                setIsModalOpen(true);
            },
            children: [
                detachedSearchButtonIcon,
                detachedSearchButtonPlaceholder,
                detachedSearchButtonQuery
            ]
        });
        var detachedCancelButton = createDomElement('button', {
            type: 'button',
            class: classNames.detachedCancelButton,
            textContent: translations.detachedCancelButtonText,
            // Prevent `onTouchStart` from closing the panel
            // since it should be initiated by `onClick` only
            onTouchStart: function onTouchStart(event) {
                event.stopPropagation();
            },
            onClick: function onClick() {
                autocomplete.setIsOpen(false);
                setIsModalOpen(false);
            }
        });
        var detachedFormContainer = createDomElement('div', {
            class: classNames.detachedFormContainer,
            children: [
                form,
                detachedCancelButton
            ]
        });
        detachedContainer.appendChild(detachedFormContainer);
        root.appendChild(detachedSearchButton);
    } else root.appendChild(form);
    return {
        detachedContainer: detachedContainer,
        detachedOverlay: detachedOverlay,
        detachedSearchButtonQuery: detachedSearchButtonQuery,
        detachedSearchButtonPlaceholder: detachedSearchButtonPlaceholder,
        inputWrapper: inputWrapper,
        input: input,
        root: root,
        form: form,
        label: label,
        submitButton: submitButton,
        clearButton: clearButton,
        loadingIndicator: loadingIndicator,
        panel: panel
    };
}

});
parcelRegister("7wPkn", function(module, exports) {

$parcel$export(module.exports, "ClearIcon", function () { return $57b3562ec091521a$export$cefbac224a47f32; });
var $57b3562ec091521a$export$cefbac224a47f32 = function ClearIcon(_ref) {
    var environment = _ref.environment;
    var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    element.setAttribute('class', 'aa-ClearIcon');
    element.setAttribute('viewBox', '0 0 24 24');
    element.setAttribute('width', '18');
    element.setAttribute('height', '18');
    element.setAttribute('fill', 'currentColor');
    var path = environment.document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z');
    element.appendChild(path);
    return element;
};

});

parcelRegister("donsR", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $9bffb7d58c2065dc$export$f5b8910cec6cf069; });

var $ltYgQ = parcelRequire("ltYgQ");

var $616FB = parcelRequire("616FB");
function $9bffb7d58c2065dc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9bffb7d58c2065dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9bffb7d58c2065dc$var$_typeof(obj);
}
var $9bffb7d58c2065dc$var$_excluded = [
    "autocompleteScopeApi",
    "environment",
    "classNames",
    "getInputProps",
    "getInputPropsCore",
    "isDetached",
    "state"
];
function $9bffb7d58c2065dc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9bffb7d58c2065dc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9bffb7d58c2065dc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9bffb7d58c2065dc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9bffb7d58c2065dc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9bffb7d58c2065dc$var$_defineProperty(obj, key, value) {
    key = $9bffb7d58c2065dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9bffb7d58c2065dc$var$_toPropertyKey(arg) {
    var key = $9bffb7d58c2065dc$var$_toPrimitive(arg, "string");
    return $9bffb7d58c2065dc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9bffb7d58c2065dc$var$_toPrimitive(input, hint) {
    if ($9bffb7d58c2065dc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9bffb7d58c2065dc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9bffb7d58c2065dc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9bffb7d58c2065dc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9bffb7d58c2065dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9bffb7d58c2065dc$export$f5b8910cec6cf069 = function Input(_ref) {
    var autocompleteScopeApi = _ref.autocompleteScopeApi, environment = _ref.environment, classNames = _ref.classNames, getInputProps = _ref.getInputProps, getInputPropsCore = _ref.getInputPropsCore, isDetached = _ref.isDetached, state = _ref.state, props = $9bffb7d58c2065dc$var$_objectWithoutProperties(_ref, $9bffb7d58c2065dc$var$_excluded);
    var createDomElement = (0, $ltYgQ.getCreateDomElement)(environment);
    var element = createDomElement('input', props);
    var inputProps = getInputProps($9bffb7d58c2065dc$var$_objectSpread({
        state: state,
        props: getInputPropsCore({
            inputElement: element
        }),
        inputElement: element
    }, autocompleteScopeApi));
    (0, $616FB.setProperties)(element, $9bffb7d58c2065dc$var$_objectSpread($9bffb7d58c2065dc$var$_objectSpread({}, inputProps), {}, {
        onKeyDown: function onKeyDown(event) {
            // In detached mode we don't want to close the panel when hitting `Tab`.
            if (isDetached && event.key === 'Tab') return;
            inputProps.onKeyDown(event);
        }
    }));
    return element;
};

});
parcelRegister("ltYgQ", function(module, exports) {

$parcel$export(module.exports, "getCreateDomElement", function () { return $fa3b0ee9bbc3403e$export$c7f8c472ad836e1a; });

var $616FB = parcelRequire("616FB");
var $fa3b0ee9bbc3403e$var$_excluded = [
    "children"
];
function $fa3b0ee9bbc3403e$var$_toConsumableArray(arr) {
    return $fa3b0ee9bbc3403e$var$_arrayWithoutHoles(arr) || $fa3b0ee9bbc3403e$var$_iterableToArray(arr) || $fa3b0ee9bbc3403e$var$_unsupportedIterableToArray(arr) || $fa3b0ee9bbc3403e$var$_nonIterableSpread();
}
function $fa3b0ee9bbc3403e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fa3b0ee9bbc3403e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fa3b0ee9bbc3403e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fa3b0ee9bbc3403e$var$_arrayLikeToArray(o, minLen);
}
function $fa3b0ee9bbc3403e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fa3b0ee9bbc3403e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fa3b0ee9bbc3403e$var$_arrayLikeToArray(arr);
}
function $fa3b0ee9bbc3403e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fa3b0ee9bbc3403e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fa3b0ee9bbc3403e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fa3b0ee9bbc3403e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fa3b0ee9bbc3403e$export$c7f8c472ad836e1a(environment) {
    return function createDomElement(tagName, _ref) {
        var _ref$children = _ref.children, children = _ref$children === void 0 ? [] : _ref$children, props = $fa3b0ee9bbc3403e$var$_objectWithoutProperties(_ref, $fa3b0ee9bbc3403e$var$_excluded);
        var element = environment.document.createElement(tagName);
        (0, $616FB.setProperties)(element, props);
        element.append.apply(element, $fa3b0ee9bbc3403e$var$_toConsumableArray(children));
        return element;
    };
}

});
parcelRegister("616FB", function(module, exports) {

$parcel$export(module.exports, "setProperties", function () { return $461802994d69c52e$export$80f053e5e39de51d; });
$parcel$export(module.exports, "setPropertiesWithoutEvents", function () { return $461802994d69c52e$export$514d50f66c38c2be; });
/* eslint-disable */ /**
 * Touch-specific event aliases
 *
 * See https://w3c.github.io/touch-events/#extensions-to-the-globaleventhandlers-mixin
 */ var $461802994d69c52e$var$TOUCH_EVENTS_ALIASES = [
    'ontouchstart',
    'ontouchend',
    'ontouchmove',
    'ontouchcancel'
];
/*
 * Taken from Preact
 *
 * See https://github.com/preactjs/preact/blob/6ab49d9020740127577bf4af66bf63f4af7f9fee/src/diff/props.js#L58-L151
 */ function $461802994d69c52e$var$setStyle(style, key, value) {
    if (value === null) style[key] = '';
    else if (typeof value !== 'number') style[key] = value;
    else style[key] = value + 'px';
}
/**
 * Proxy an event to hooked event handlers
 */ function $461802994d69c52e$var$eventProxy(event) {
    this._listeners[event.type](event);
}
function $461802994d69c52e$export$a41c68a4eb5ff164(dom, name, value) {
    var useCapture;
    var nameLower;
    var oldValue = dom[name];
    if (name === 'style') {
        if (typeof value == 'string') dom.style = value;
        else if (value === null) dom.style = '';
        else {
            for(name in value)if (!oldValue || value[name] !== oldValue[name]) $461802994d69c52e$var$setStyle(dom.style, name, value[name]);
        }
    } else if (name[0] === 'o' && name[1] === 'n') {
        useCapture = name !== (name = name.replace(/Capture$/, ''));
        nameLower = name.toLowerCase();
        if (nameLower in dom || $461802994d69c52e$var$TOUCH_EVENTS_ALIASES.includes(nameLower)) name = nameLower;
        name = name.slice(2);
        if (!dom._listeners) dom._listeners = {};
        dom._listeners[name] = value;
        if (value) {
            if (!oldValue) dom.addEventListener(name, $461802994d69c52e$var$eventProxy, useCapture);
        } else dom.removeEventListener(name, $461802994d69c52e$var$eventProxy, useCapture);
    } else if (name !== 'list' && name !== 'tagName' && // HTMLButtonElement.form and HTMLInputElement.form are read-only but can be set using
    // setAttribute
    name !== 'form' && name !== 'type' && name !== 'size' && name !== 'download' && name !== 'href' && name in dom) dom[name] = value == null ? '' : value;
    else if (typeof value != 'function' && name !== 'dangerouslySetInnerHTML') {
        if (value == null || value === false && // ARIA-attributes have a different notion of boolean values.
        // The value `false` is different from the attribute not
        // existing on the DOM, so we can't remove it. For non-boolean
        // ARIA-attributes we could treat false as a removal, but the
        // amount of exceptions would cost us too many bytes. On top of
        // that other VDOM frameworks also always stringify `false`.
        !/^ar/.test(name)) dom.removeAttribute(name);
        else dom.setAttribute(name, value);
    }
}
function $461802994d69c52e$var$getNormalizedName(name) {
    switch(name){
        case 'onChange':
            return 'onInput';
        // see: https://github.com/preactjs/preact/issues/1978
        case 'onCompositionEnd':
            return 'oncompositionend';
        default:
            return name;
    }
}
function $461802994d69c52e$export$80f053e5e39de51d(dom, props) {
    for(var name in props)$461802994d69c52e$export$a41c68a4eb5ff164(dom, $461802994d69c52e$var$getNormalizedName(name), props[name]);
}
function $461802994d69c52e$export$514d50f66c38c2be(dom, props) {
    for(var name in props)if (!(name[0] === 'o' && name[1] === 'n')) $461802994d69c52e$export$a41c68a4eb5ff164(dom, $461802994d69c52e$var$getNormalizedName(name), props[name]);
}

});



parcelRegister("1fzoV", function(module, exports) {

$parcel$export(module.exports, "LoadingIcon", function () { return $0e92a70cb9bd94f4$export$b936c55164dcf1db; });
var $0e92a70cb9bd94f4$export$b936c55164dcf1db = function LoadingIcon(_ref) {
    var environment = _ref.environment;
    var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    element.setAttribute('class', 'aa-LoadingIcon');
    element.setAttribute('viewBox', '0 0 100 100');
    element.setAttribute('width', '20');
    element.setAttribute('height', '20');
    element.innerHTML = "<circle\n  cx=\"50\"\n  cy=\"50\"\n  fill=\"none\"\n  r=\"35\"\n  stroke=\"currentColor\"\n  stroke-dasharray=\"164.93361431346415 56.97787143782138\"\n  stroke-width=\"6\"\n>\n  <animateTransform\n    attributeName=\"transform\"\n    type=\"rotate\"\n    repeatCount=\"indefinite\"\n    dur=\"1s\"\n    values=\"0 50 50;90 50 50;180 50 50;360 50 50\"\n    keyTimes=\"0;0.40;0.65;1\"\n  />\n</circle>";
    return element;
};

});

parcelRegister("hjsg2", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", function () { return $c9aa21654e5a45e0$export$82eafebb825fc23f; });
var $c9aa21654e5a45e0$export$82eafebb825fc23f = function SearchIcon(_ref) {
    var environment = _ref.environment;
    var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    element.setAttribute('class', 'aa-SubmitIcon');
    element.setAttribute('viewBox', '0 0 24 24');
    element.setAttribute('width', '20');
    element.setAttribute('height', '20');
    element.setAttribute('fill', 'currentColor');
    var path = environment.document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z');
    element.appendChild(path);
    return element;
};

});


parcelRegister("gfvkJ", function(module, exports) {

$parcel$export(module.exports, "createEffectWrapper", function () { return $bd465a36c7f12c0f$export$10c722448c02c6b9; });
function $bd465a36c7f12c0f$export$10c722448c02c6b9() {
    var effects = [];
    var cleanups = [];
    function runEffect(fn) {
        effects.push(fn);
        var effectCleanup = fn();
        cleanups.push(effectCleanup);
    }
    return {
        runEffect: runEffect,
        cleanupEffects: function cleanupEffects() {
            var currentCleanups = cleanups;
            cleanups = [];
            currentCleanups.forEach(function(cleanup) {
                cleanup();
            });
        },
        runEffects: function runEffects() {
            var currentEffects = effects;
            effects = [];
            currentEffects.forEach(function(effect) {
                runEffect(effect);
            });
        }
    };
}

});

parcelRegister("2kCTV", function(module, exports) {

$parcel$export(module.exports, "createReactiveWrapper", function () { return $1b2b9ffc6a251b06$export$d1aaf184999dfd1f; });
function $1b2b9ffc6a251b06$export$d1aaf184999dfd1f() {
    var reactives = [];
    return {
        reactive: function reactive(value1) {
            var current = value1();
            var reactive = {
                _fn: value1,
                _ref: {
                    current: current
                },
                get value () {
                    return this._ref.current;
                },
                set value (value){
                    this._ref.current = value;
                }
            };
            reactives.push(reactive);
            return reactive;
        },
        runReactives: function runReactives() {
            reactives.forEach(function(value1) {
                value1._ref.current = value1._fn();
            });
        }
    };
}

});

parcelRegister("8lshO", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $613639fc2a1315ca$export$430a3269e24b912e; });

var $2o9EK = parcelRequire("2o9EK");
var $hAVux = parcelRequire("hAVux");

var $1Hje6 = parcelRequire("1Hje6");

var $6Fe4W = parcelRequire("6Fe4W");
var $j6fJc = parcelRequire("j6fJc");
var $e7w1t = parcelRequire("e7w1t");
var $79JzL = parcelRequire("79JzL");

var $5GomW = parcelRequire("5GomW");
var $69LUF = parcelRequire("69LUF");
function $613639fc2a1315ca$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $613639fc2a1315ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $613639fc2a1315ca$var$_typeof(obj);
}
var $613639fc2a1315ca$var$_excluded = [
    "classNames",
    "container",
    "getEnvironmentProps",
    "getFormProps",
    "getInputProps",
    "getItemProps",
    "getLabelProps",
    "getListProps",
    "getPanelProps",
    "getRootProps",
    "panelContainer",
    "panelPlacement",
    "render",
    "renderNoResults",
    "renderer",
    "detachedMediaQuery",
    "components",
    "translations"
];
function $613639fc2a1315ca$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $613639fc2a1315ca$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $613639fc2a1315ca$var$ownKeys(Object(source), !0).forEach(function(key) {
            $613639fc2a1315ca$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $613639fc2a1315ca$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $613639fc2a1315ca$var$_defineProperty(obj, key, value) {
    key = $613639fc2a1315ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $613639fc2a1315ca$var$_toPropertyKey(arg) {
    var key = $613639fc2a1315ca$var$_toPrimitive(arg, "string");
    return $613639fc2a1315ca$var$_typeof(key) === "symbol" ? key : String(key);
}
function $613639fc2a1315ca$var$_toPrimitive(input, hint) {
    if ($613639fc2a1315ca$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($613639fc2a1315ca$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $613639fc2a1315ca$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $613639fc2a1315ca$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $613639fc2a1315ca$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $613639fc2a1315ca$var$defaultClassNames = {
    clearButton: 'aa-ClearButton',
    detachedCancelButton: 'aa-DetachedCancelButton',
    detachedContainer: 'aa-DetachedContainer',
    detachedFormContainer: 'aa-DetachedFormContainer',
    detachedOverlay: 'aa-DetachedOverlay',
    detachedSearchButton: 'aa-DetachedSearchButton',
    detachedSearchButtonIcon: 'aa-DetachedSearchButtonIcon',
    detachedSearchButtonPlaceholder: 'aa-DetachedSearchButtonPlaceholder',
    detachedSearchButtonQuery: 'aa-DetachedSearchButtonQuery',
    form: 'aa-Form',
    input: 'aa-Input',
    inputWrapper: 'aa-InputWrapper',
    inputWrapperPrefix: 'aa-InputWrapperPrefix',
    inputWrapperSuffix: 'aa-InputWrapperSuffix',
    item: 'aa-Item',
    label: 'aa-Label',
    list: 'aa-List',
    loadingIndicator: 'aa-LoadingIndicator',
    panel: 'aa-Panel',
    panelLayout: 'aa-PanelLayout aa-Panel--scrollable',
    root: 'aa-Autocomplete',
    source: 'aa-Source',
    sourceFooter: 'aa-SourceFooter',
    sourceHeader: 'aa-SourceHeader',
    sourceNoResults: 'aa-SourceNoResults',
    submitButton: 'aa-SubmitButton'
};
var $613639fc2a1315ca$var$defaultRender = function defaultRender(_ref, root) {
    var children = _ref.children, _$render = _ref.render;
    _$render(children, root);
};
var $613639fc2a1315ca$var$defaultRenderer = {
    createElement: (0, $1Hje6.createElement),
    Fragment: (0, $1Hje6.Fragment),
    render: (0, $1Hje6.render)
};
function $613639fc2a1315ca$export$430a3269e24b912e(options) {
    var _core$id;
    var classNames = options.classNames, container = options.container, getEnvironmentProps = options.getEnvironmentProps, getFormProps = options.getFormProps, getInputProps = options.getInputProps, getItemProps = options.getItemProps, getLabelProps = options.getLabelProps, getListProps = options.getListProps, getPanelProps = options.getPanelProps, getRootProps = options.getRootProps, panelContainer = options.panelContainer, panelPlacement = options.panelPlacement, _$render = options.render, renderNoResults = options.renderNoResults, renderer = options.renderer, detachedMediaQuery = options.detachedMediaQuery, components = options.components, translations = options.translations, core = $613639fc2a1315ca$var$_objectWithoutProperties(options, $613639fc2a1315ca$var$_excluded);
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== 'undefined' ? window : {};
    /* eslint-enable no-restricted-globals */ var containerElement = (0, $5GomW.getHTMLElement)(environment, container);
    (0, $hAVux.invariant)(containerElement.tagName !== 'INPUT', 'The `container` option does not support `input` elements. You need to change the container to a `div`.');
    var defaultedRenderer = $613639fc2a1315ca$var$_objectSpread($613639fc2a1315ca$var$_objectSpread({}, $613639fc2a1315ca$var$defaultRenderer), renderer);
    var defaultComponents = {
        Highlight: (0, $6Fe4W.createHighlightComponent)(defaultedRenderer),
        ReverseHighlight: (0, $j6fJc.createReverseHighlightComponent)(defaultedRenderer),
        ReverseSnippet: (0, $e7w1t.createReverseSnippetComponent)(defaultedRenderer),
        Snippet: (0, $79JzL.createSnippetComponent)(defaultedRenderer)
    };
    var defaultTranslations = {
        clearButtonTitle: 'Clear',
        detachedCancelButtonText: 'Cancel',
        detachedSearchButtonTitle: 'Search',
        submitButtonTitle: 'Submit'
    };
    return {
        renderer: {
            classNames: (0, $69LUF.mergeClassNames)($613639fc2a1315ca$var$defaultClassNames, classNames !== null && classNames !== void 0 ? classNames : {}),
            container: containerElement,
            getEnvironmentProps: getEnvironmentProps !== null && getEnvironmentProps !== void 0 ? getEnvironmentProps : function(_ref2) {
                var props = _ref2.props;
                return props;
            },
            getFormProps: getFormProps !== null && getFormProps !== void 0 ? getFormProps : function(_ref3) {
                var props = _ref3.props;
                return props;
            },
            getInputProps: getInputProps !== null && getInputProps !== void 0 ? getInputProps : function(_ref4) {
                var props = _ref4.props;
                return props;
            },
            getItemProps: getItemProps !== null && getItemProps !== void 0 ? getItemProps : function(_ref5) {
                var props = _ref5.props;
                return props;
            },
            getLabelProps: getLabelProps !== null && getLabelProps !== void 0 ? getLabelProps : function(_ref6) {
                var props = _ref6.props;
                return props;
            },
            getListProps: getListProps !== null && getListProps !== void 0 ? getListProps : function(_ref7) {
                var props = _ref7.props;
                return props;
            },
            getPanelProps: getPanelProps !== null && getPanelProps !== void 0 ? getPanelProps : function(_ref8) {
                var props = _ref8.props;
                return props;
            },
            getRootProps: getRootProps !== null && getRootProps !== void 0 ? getRootProps : function(_ref9) {
                var props = _ref9.props;
                return props;
            },
            panelContainer: panelContainer ? (0, $5GomW.getHTMLElement)(environment, panelContainer) : environment.document.body,
            panelPlacement: panelPlacement !== null && panelPlacement !== void 0 ? panelPlacement : 'input-wrapper-width',
            render: _$render !== null && _$render !== void 0 ? _$render : $613639fc2a1315ca$var$defaultRender,
            renderNoResults: renderNoResults,
            renderer: defaultedRenderer,
            detachedMediaQuery: detachedMediaQuery !== null && detachedMediaQuery !== void 0 ? detachedMediaQuery : getComputedStyle(environment.document.documentElement).getPropertyValue('--aa-detached-media-query'),
            components: $613639fc2a1315ca$var$_objectSpread($613639fc2a1315ca$var$_objectSpread({}, defaultComponents), components),
            translations: $613639fc2a1315ca$var$_objectSpread($613639fc2a1315ca$var$_objectSpread({}, defaultTranslations), translations)
        },
        core: $613639fc2a1315ca$var$_objectSpread($613639fc2a1315ca$var$_objectSpread({}, core), {}, {
            id: (_core$id = core.id) !== null && _core$id !== void 0 ? _core$id : (0, $2o9EK.generateAutocompleteId)(),
            environment: environment
        })
    };
}

});
parcelRegister("1Hje6", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $13c8b89034f966ca$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Fragment", function () { return $13c8b89034f966ca$export$ffb0004e005737fa; });
$parcel$export(module.exports, "render", function () { return $13c8b89034f966ca$export$b3890eb0ae9dca99; });

var $4TMho = parcelRequire("4TMho");
var $13c8b89034f966ca$var$n, $13c8b89034f966ca$export$41c562ebe57d11e2, $13c8b89034f966ca$var$u, $13c8b89034f966ca$export$a8257692ac88316c, $13c8b89034f966ca$var$i, $13c8b89034f966ca$var$r, $13c8b89034f966ca$var$o, $13c8b89034f966ca$var$e, $13c8b89034f966ca$var$f, $13c8b89034f966ca$var$c, $13c8b89034f966ca$var$s, $13c8b89034f966ca$var$a, $13c8b89034f966ca$var$h, $13c8b89034f966ca$var$p = {}, $13c8b89034f966ca$var$v = [], $13c8b89034f966ca$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c8b89034f966ca$var$w = Array.isArray;
function $13c8b89034f966ca$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c8b89034f966ca$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c8b89034f966ca$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c8b89034f966ca$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $13c8b89034f966ca$var$m(l, e, i, r, null);
}
function $13c8b89034f966ca$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$13c8b89034f966ca$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $13c8b89034f966ca$export$41c562ebe57d11e2.vnode && $13c8b89034f966ca$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c8b89034f966ca$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c8b89034f966ca$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c8b89034f966ca$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c8b89034f966ca$var$S(n, l) {
    if (null == l) return n.__ ? $13c8b89034f966ca$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c8b89034f966ca$var$S(n) : null;
}
function $13c8b89034f966ca$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c8b89034f966ca$var$C(n);
    }
}
function $13c8b89034f966ca$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c8b89034f966ca$var$i.push(n) && !$13c8b89034f966ca$var$$.__r++ || $13c8b89034f966ca$var$r != $13c8b89034f966ca$export$41c562ebe57d11e2.debounceRendering) && (($13c8b89034f966ca$var$r = $13c8b89034f966ca$export$41c562ebe57d11e2.debounceRendering) || $13c8b89034f966ca$var$o)($13c8b89034f966ca$var$$);
}
function $13c8b89034f966ca$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $13c8b89034f966ca$var$i.length;)$13c8b89034f966ca$var$i.length > s && $13c8b89034f966ca$var$i.sort($13c8b89034f966ca$var$e), n = $13c8b89034f966ca$var$i.shift(), s = $13c8b89034f966ca$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $13c8b89034f966ca$var$d({}, r)).__v = r.__v + 1, $13c8b89034f966ca$export$41c562ebe57d11e2.vnode && $13c8b89034f966ca$export$41c562ebe57d11e2.vnode(t), $13c8b89034f966ca$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $13c8b89034f966ca$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $13c8b89034f966ca$var$z(f, t, c), t.__e != o && $13c8b89034f966ca$var$C(t)));
    $13c8b89034f966ca$var$$.__r = 0;
}
function $13c8b89034f966ca$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _ = t && t.__k || $13c8b89034f966ca$var$v, m = l.length;
    for(f = $13c8b89034f966ca$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $13c8b89034f966ca$var$p : _[y.__i] || $13c8b89034f966ca$var$p, y.__i = a, g = $13c8b89034f966ca$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $13c8b89034f966ca$var$q(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), 4 & y.__u || h.__k === y.__k ? f = $13c8b89034f966ca$var$A(y, f, n) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $13c8b89034f966ca$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == (typeof o === "undefined" ? "undefined" : (0, $4TMho._)(o)) || o.constructor == String ? $13c8b89034f966ca$var$m(null, o, null, null, null) : $13c8b89034f966ca$var$w(o) ? $13c8b89034f966ca$var$m($13c8b89034f966ca$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $13c8b89034f966ca$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $13c8b89034f966ca$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c8b89034f966ca$var$S(e)), $13c8b89034f966ca$var$B(e, e));
    return t;
}
function $13c8b89034f966ca$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c8b89034f966ca$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $13c8b89034f966ca$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c8b89034f966ca$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c8b89034f966ca$var$w(n) ? n.some(function(n) {
        $13c8b89034f966ca$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c8b89034f966ca$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f && null == n.key || f && o == f.key && e == f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return r;
            r++;
        }
    }
    return -1;
}
function $13c8b89034f966ca$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c8b89034f966ca$var$y.test(l) ? u : u + "px";
}
function $13c8b89034f966ca$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c8b89034f966ca$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c8b89034f966ca$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($13c8b89034f966ca$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $13c8b89034f966ca$var$c, n.addEventListener(l, r ? $13c8b89034f966ca$var$a : $13c8b89034f966ca$var$s, r)) : n.removeEventListener(l, r ? $13c8b89034f966ca$var$a : $13c8b89034f966ca$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c8b89034f966ca$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c8b89034f966ca$var$c++;
            else if (u.t < t.u) return;
            return t($13c8b89034f966ca$export$41c562ebe57d11e2.event ? $13c8b89034f966ca$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c8b89034f966ca$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, _$$, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $13c8b89034f966ca$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $13c8b89034f966ca$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $13c8b89034f966ca$var$D), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c8b89034f966ca$var$d({}, h.__s)), $13c8b89034f966ca$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), _$$ = 0; _$$ < h._sb.length; _$$++)h.__h.push(h._sb[_$$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $13c8b89034f966ca$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c8b89034f966ca$var$d($13c8b89034f966ca$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $13c8b89034f966ca$export$ffb0004e005737fa && null == a.key && (L = $13c8b89034f966ca$var$N(a.props.children)), f = $13c8b89034f966ca$var$I(n, $13c8b89034f966ca$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(T = o.length; T--;)$13c8b89034f966ca$var$g(o[T]);
        } else u.__e = t.__e, u.__k = t.__k;
        $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c8b89034f966ca$var$V(t.__e, u, t, i, r, o, e, c, s);
    return (a = $13c8b89034f966ca$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $13c8b89034f966ca$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c8b89034f966ca$var$q(t[i], t[++i], t[++i]);
    $13c8b89034f966ca$export$41c562ebe57d11e2.__c && $13c8b89034f966ca$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c8b89034f966ca$var$N(n) {
    return "object" != (typeof n === "undefined" ? "undefined" : (0, $4TMho._)(n)) || null == n || n.__b && n.__b > 0 ? n : $13c8b89034f966ca$var$w(n) ? n.map($13c8b89034f966ca$var$N) : $13c8b89034f966ca$var$d({}, n);
}
function $13c8b89034f966ca$var$V(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, _$k = t.props, _$x = t.type;
    if ("svg" == _$x ? o = "http://www.w3.org/2000/svg" : "math" == _$x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!_$x && (_$x ? d.localName == _$x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == _$x) return document.createTextNode(_$k);
        u = document.createElementNS(o, _$x, _$k.is && _$k), c && ($13c8b89034f966ca$export$41c562ebe57d11e2.__m && $13c8b89034f966ca$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == _$x) b === _$k || c && u.data == _$k || (u.data = _$k);
    else {
        if (e = e && $13c8b89034f966ca$var$n.call(u.childNodes), b = i.props || $13c8b89034f966ca$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in _$k)) {
            if ("value" == a && "defaultValue" in _$k || "checked" == a && "defaultChecked" in _$k) continue;
            $13c8b89034f966ca$var$j(u, a, null, d, o);
        }
        for(a in _$k)d = _$k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $13c8b89034f966ca$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $13c8b89034f966ca$var$I("template" == t.type ? u.content : u, $13c8b89034f966ca$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == _$x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $13c8b89034f966ca$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$13c8b89034f966ca$var$g(e[a]);
        c || (a = "value", "progress" == _$x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == _$x && !_ || "option" == _$x && _ != b[a]) && $13c8b89034f966ca$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $13c8b89034f966ca$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $13c8b89034f966ca$var$q(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c8b89034f966ca$var$B(n, u, t) {
    var i, r;
    if ($13c8b89034f966ca$export$41c562ebe57d11e2.unmount && $13c8b89034f966ca$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c8b89034f966ca$var$q(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $13c8b89034f966ca$var$B(i[r], u, t || "function" != typeof n.type);
    t || $13c8b89034f966ca$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c8b89034f966ca$var$D(n, l, u) {
    return this.constructor(n, u);
}
function $13c8b89034f966ca$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $13c8b89034f966ca$export$41c562ebe57d11e2.__ && $13c8b89034f966ca$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c8b89034f966ca$var$O(t, u = (!r && i || t).__k = $13c8b89034f966ca$export$c8a8987d4410bf2d($13c8b89034f966ca$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c8b89034f966ca$var$p, $13c8b89034f966ca$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $13c8b89034f966ca$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $13c8b89034f966ca$var$z(e, u, f);
}
function $13c8b89034f966ca$export$fa8d919ba61d84db(n, l) {
    $13c8b89034f966ca$export$b3890eb0ae9dca99(n, l, $13c8b89034f966ca$export$fa8d919ba61d84db);
}
function $13c8b89034f966ca$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $13c8b89034f966ca$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c8b89034f966ca$var$n.call(arguments, 2) : t), $13c8b89034f966ca$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $13c8b89034f966ca$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c8b89034f966ca$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var _$l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), _$l && _$l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c8b89034f966ca$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c8b89034f966ca$var$n = $13c8b89034f966ca$var$v.slice, $13c8b89034f966ca$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c8b89034f966ca$var$u = 0, $13c8b89034f966ca$export$a8257692ac88316c = function t(n) {
    return null != n && null == n.constructor;
}, $13c8b89034f966ca$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c8b89034f966ca$var$d({}, this.state), "function" == typeof n && (n = n($13c8b89034f966ca$var$d({}, u), this.props)), n && $13c8b89034f966ca$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $13c8b89034f966ca$var$M(this));
}, $13c8b89034f966ca$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c8b89034f966ca$var$M(this));
}, $13c8b89034f966ca$export$16fa2f45be04daa8.prototype.render = $13c8b89034f966ca$export$ffb0004e005737fa, $13c8b89034f966ca$var$i = [], $13c8b89034f966ca$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c8b89034f966ca$var$e = function e(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c8b89034f966ca$var$$.__r = 0, $13c8b89034f966ca$var$f = /(PointerCapture)$|Capture$/i, $13c8b89034f966ca$var$c = 0, $13c8b89034f966ca$var$s = $13c8b89034f966ca$var$F(!1), $13c8b89034f966ca$var$a = $13c8b89034f966ca$var$F(!0), $13c8b89034f966ca$var$h = 0;

});

parcelRegister("6Fe4W", function(module, exports) {

$parcel$export(module.exports, "createHighlightComponent", function () { return $4da17e24c4e77c26$export$c8682df1c852a966; });

var $6chV5 = parcelRequire("6chV5");
function $4da17e24c4e77c26$export$c8682df1c852a966(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function Highlight(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $6chV5.parseAlgoliaHitHighlight)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    Highlight.__autocomplete_componentName = 'Highlight';
    return Highlight;
}

});
parcelRegister("6chV5", function(module, exports) {

$parcel$export(module.exports, "parseAlgoliaHitHighlight", function () { return $4831c39477d8824d$export$8d253e1eb996c525; });

var $bodV8 = parcelRequire("bodV8");

var $8KIsb = parcelRequire("8KIsb");
function $4831c39477d8824d$var$_toConsumableArray(arr) {
    return $4831c39477d8824d$var$_arrayWithoutHoles(arr) || $4831c39477d8824d$var$_iterableToArray(arr) || $4831c39477d8824d$var$_unsupportedIterableToArray(arr) || $4831c39477d8824d$var$_nonIterableSpread();
}
function $4831c39477d8824d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4831c39477d8824d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4831c39477d8824d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4831c39477d8824d$var$_arrayLikeToArray(o, minLen);
}
function $4831c39477d8824d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4831c39477d8824d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4831c39477d8824d$var$_arrayLikeToArray(arr);
}
function $4831c39477d8824d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4831c39477d8824d$export$8d253e1eb996c525(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $bodV8.getAttributeValueByPath)(hit, [
        '_highlightResult'
    ].concat($4831c39477d8824d$var$_toConsumableArray(path), [
        'value'
    ]));
    if (typeof highlightedValue !== 'string') highlightedValue = (0, $bodV8.getAttributeValueByPath)(hit, path) || '';
    return (0, $8KIsb.parseAttribute)({
        highlightedValue: highlightedValue
    });
}

});
parcelRegister("bodV8", function(module, exports) {

$parcel$export(module.exports, "getAttributeValueByPath", function () { return $84acbbeb4640b4e6$export$3219add52b18c0d7; });
function $84acbbeb4640b4e6$export$3219add52b18c0d7(record, path) {
    return path.reduce(function(current, key) {
        return current && current[key];
    }, record);
}

});

parcelRegister("8KIsb", function(module, exports) {

$parcel$export(module.exports, "parseAttribute", function () { return $65f51a2f58a8712e$export$dd369bc78e81a241; });

var $iZBKx = parcelRequire("iZBKx");
/**
 * Creates a data structure that allows to concatenate similar highlighting
 * parts in a single value.
 */ function $65f51a2f58a8712e$var$createAttributeSet() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = initialValue;
    return {
        get: function get() {
            return value;
        },
        add: function add(part) {
            var lastPart = value[value.length - 1];
            if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.isHighlighted) === part.isHighlighted) value[value.length - 1] = {
                value: lastPart.value + part.value,
                isHighlighted: lastPart.isHighlighted
            };
            else value.push(part);
        }
    };
}
function $65f51a2f58a8712e$export$dd369bc78e81a241(_ref) {
    var highlightedValue = _ref.highlightedValue;
    var preTagParts = highlightedValue.split((0, $iZBKx.HIGHLIGHT_PRE_TAG));
    var firstValue = preTagParts.shift();
    var parts = $65f51a2f58a8712e$var$createAttributeSet(firstValue ? [
        {
            value: firstValue,
            isHighlighted: false
        }
    ] : []);
    preTagParts.forEach(function(part) {
        var postTagParts = part.split((0, $iZBKx.HIGHLIGHT_POST_TAG));
        parts.add({
            value: postTagParts[0],
            isHighlighted: true
        });
        if (postTagParts[1] !== '') parts.add({
            value: postTagParts[1],
            isHighlighted: false
        });
    });
    return parts.get();
}

});
parcelRegister("iZBKx", function(module, exports) {

$parcel$export(module.exports, "HIGHLIGHT_PRE_TAG", function () { return $dd3b34c4394fe7d9$export$2df5424f792538bd; });
$parcel$export(module.exports, "HIGHLIGHT_POST_TAG", function () { return $dd3b34c4394fe7d9$export$2681d4c6a4ae86; });
var $dd3b34c4394fe7d9$export$2df5424f792538bd = '__aa-highlight__';
var $dd3b34c4394fe7d9$export$2681d4c6a4ae86 = '__/aa-highlight__';

});




parcelRegister("j6fJc", function(module, exports) {

$parcel$export(module.exports, "createReverseHighlightComponent", function () { return $de7ac7203b4d8339$export$6497355a57b2273f; });

var $cJaTR = parcelRequire("cJaTR");
function $de7ac7203b4d8339$export$6497355a57b2273f(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function ReverseHighlight(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $cJaTR.parseAlgoliaHitReverseHighlight)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    ReverseHighlight.__autocomplete_componentName = 'ReverseHighlight';
    return ReverseHighlight;
}

});
parcelRegister("cJaTR", function(module, exports) {

$parcel$export(module.exports, "parseAlgoliaHitReverseHighlight", function () { return $94422482788fcdc9$export$4923484c50253a9b; });

var $6chV5 = parcelRequire("6chV5");

var $lsY3i = parcelRequire("lsY3i");
function $94422482788fcdc9$export$4923484c50253a9b(props) {
    return (0, $lsY3i.reverseHighlightedParts)((0, $6chV5.parseAlgoliaHitHighlight)(props));
}

});
parcelRegister("lsY3i", function(module, exports) {

$parcel$export(module.exports, "reverseHighlightedParts", function () { return $fa0acba0e5f1df6b$export$8d1202a2cf66e93; });

var $bUk0c = parcelRequire("bUk0c");
function $fa0acba0e5f1df6b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fa0acba0e5f1df6b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fa0acba0e5f1df6b$var$_typeof(obj);
}
function $fa0acba0e5f1df6b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fa0acba0e5f1df6b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fa0acba0e5f1df6b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fa0acba0e5f1df6b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fa0acba0e5f1df6b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fa0acba0e5f1df6b$var$_defineProperty(obj, key, value) {
    key = $fa0acba0e5f1df6b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fa0acba0e5f1df6b$var$_toPropertyKey(arg) {
    var key = $fa0acba0e5f1df6b$var$_toPrimitive(arg, "string");
    return $fa0acba0e5f1df6b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fa0acba0e5f1df6b$var$_toPrimitive(input, hint) {
    if ($fa0acba0e5f1df6b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fa0acba0e5f1df6b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fa0acba0e5f1df6b$export$8d1202a2cf66e93(parts) {
    // We don't want to highlight the whole word when no parts match.
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $fa0acba0e5f1df6b$var$_objectSpread($fa0acba0e5f1df6b$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $fa0acba0e5f1df6b$var$_objectSpread($fa0acba0e5f1df6b$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $bUk0c.isPartHighlighted)(parts, i)
        });
    });
}

});
parcelRegister("bUk0c", function(module, exports) {

$parcel$export(module.exports, "isPartHighlighted", function () { return $8ab470b807a92305$export$72c2046b3b0a911c; });
var $8ab470b807a92305$var$htmlEscapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
var $8ab470b807a92305$var$hasAlphanumeric = new RegExp(/\w/i);
var $8ab470b807a92305$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $8ab470b807a92305$var$regexHasEscapedHtml = RegExp($8ab470b807a92305$var$regexEscapedHtml.source);
function $8ab470b807a92305$var$unescape(value) {
    return value && $8ab470b807a92305$var$regexHasEscapedHtml.test(value) ? value.replace($8ab470b807a92305$var$regexEscapedHtml, function(character) {
        return $8ab470b807a92305$var$htmlEscapes[character];
    }) : value;
}
function $8ab470b807a92305$export$72c2046b3b0a911c(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$8ab470b807a92305$var$hasAlphanumeric.test($8ab470b807a92305$var$unescape(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}

});




parcelRegister("e7w1t", function(module, exports) {

$parcel$export(module.exports, "createReverseSnippetComponent", function () { return $a47a8f3639f68f18$export$8af413b0fd5d7b30; });

var $eKP0i = parcelRequire("eKP0i");
function $a47a8f3639f68f18$export$8af413b0fd5d7b30(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function ReverseSnippet(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $eKP0i.parseAlgoliaHitReverseSnippet)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    ReverseSnippet.__autocomplete_componentName = 'ReverseSnippet';
    return ReverseSnippet;
}

});
parcelRegister("eKP0i", function(module, exports) {

$parcel$export(module.exports, "parseAlgoliaHitReverseSnippet", function () { return $abdcecd9a826133a$export$28f36526e7a141af; });

var $drewp = parcelRequire("drewp");

var $lsY3i = parcelRequire("lsY3i");
function $abdcecd9a826133a$export$28f36526e7a141af(props) {
    return (0, $lsY3i.reverseHighlightedParts)((0, $drewp.parseAlgoliaHitSnippet)(props));
}

});
parcelRegister("drewp", function(module, exports) {

$parcel$export(module.exports, "parseAlgoliaHitSnippet", function () { return $9c890fb05b34b24f$export$8d43cf2bcfea1837; });

var $bodV8 = parcelRequire("bodV8");

var $8KIsb = parcelRequire("8KIsb");
function $9c890fb05b34b24f$var$_toConsumableArray(arr) {
    return $9c890fb05b34b24f$var$_arrayWithoutHoles(arr) || $9c890fb05b34b24f$var$_iterableToArray(arr) || $9c890fb05b34b24f$var$_unsupportedIterableToArray(arr) || $9c890fb05b34b24f$var$_nonIterableSpread();
}
function $9c890fb05b34b24f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9c890fb05b34b24f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9c890fb05b34b24f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9c890fb05b34b24f$var$_arrayLikeToArray(o, minLen);
}
function $9c890fb05b34b24f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9c890fb05b34b24f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9c890fb05b34b24f$var$_arrayLikeToArray(arr);
}
function $9c890fb05b34b24f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9c890fb05b34b24f$export$8d43cf2bcfea1837(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $bodV8.getAttributeValueByPath)(hit, [
        '_snippetResult'
    ].concat($9c890fb05b34b24f$var$_toConsumableArray(path), [
        'value'
    ]));
    if (typeof highlightedValue !== 'string') highlightedValue = (0, $bodV8.getAttributeValueByPath)(hit, path) || '';
    return (0, $8KIsb.parseAttribute)({
        highlightedValue: highlightedValue
    });
}

});



parcelRegister("79JzL", function(module, exports) {

$parcel$export(module.exports, "createSnippetComponent", function () { return $535cba1883198529$export$563bb1b0fb5a610d; });

var $drewp = parcelRequire("drewp");
function $535cba1883198529$export$563bb1b0fb5a610d(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function Snippet(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $drewp.parseAlgoliaHitSnippet)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    Snippet.__autocomplete_componentName = 'Snippet';
    return Snippet;
}

});

parcelRegister("5GomW", function(module, exports) {

$parcel$export(module.exports, "getHTMLElement", function () { return $4233c72ddeeb082b$export$bad8ef72755038c6; });

var $hAVux = parcelRequire("hAVux");
function $4233c72ddeeb082b$export$bad8ef72755038c6(environment, value) {
    if (typeof value === 'string') {
        var element = environment.document.querySelector(value);
        (0, $hAVux.invariant)(element !== null, "The element ".concat(JSON.stringify(value), " is not in the document."));
        return element;
    }
    return value;
}

});

parcelRegister("69LUF", function(module, exports) {

$parcel$export(module.exports, "mergeClassNames", function () { return $47b8bfd7ba920bf4$export$8bf64cd1c29a1310; });
function $47b8bfd7ba920bf4$export$8bf64cd1c29a1310() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return values.reduce(function(acc, current) {
        Object.keys(current).forEach(function(key) {
            var accValue = acc[key];
            var currentValue = current[key];
            if (accValue !== currentValue) acc[key] = [
                accValue,
                currentValue
            ].filter(Boolean).join(' ');
        });
        return acc;
    }, {});
}

});


parcelRegister("j8iLB", function(module, exports) {

$parcel$export(module.exports, "getPanelPlacementStyle", function () { return $dedd525975e9c069$export$1d22b12817313d05; });
function $dedd525975e9c069$export$1d22b12817313d05(_ref) {
    var panelPlacement = _ref.panelPlacement, container = _ref.container, form = _ref.form, environment = _ref.environment;
    var containerRect = container.getBoundingClientRect();
    // Some browsers have specificities to retrieve the document scroll position.
    // See https://stackoverflow.com/a/28633515/9940315
    var scrollTop = environment.pageYOffset || environment.document.documentElement.scrollTop || environment.document.body.scrollTop || 0;
    var top = scrollTop + containerRect.top + containerRect.height;
    switch(panelPlacement){
        case 'start':
            return {
                top: top,
                left: containerRect.left
            };
        case 'end':
            return {
                top: top,
                right: environment.document.documentElement.clientWidth - (containerRect.left + containerRect.width)
            };
        case 'full-width':
            return {
                top: top,
                left: 0,
                right: 0,
                width: 'unset',
                maxWidth: 'unset'
            };
        case 'input-wrapper-width':
            var formRect = form.getBoundingClientRect();
            return {
                top: top,
                left: formRect.left,
                right: environment.document.documentElement.clientWidth - (formRect.left + formRect.width),
                width: 'unset',
                maxWidth: 'unset'
            };
        default:
            throw new Error("[Autocomplete] The `panelPlacement` value ".concat(JSON.stringify(panelPlacement), " is not valid."));
    }
}

});

parcelRegister("6y63H", function(module, exports) {

$parcel$export(module.exports, "renderSearchBox", function () { return $4c4a9e2ddc86798d$export$348e1e27f1e916dd; });
$parcel$export(module.exports, "renderPanel", function () { return $4c4a9e2ddc86798d$export$67d17c7da9b4cdd6; });

var $616FB = parcelRequire("616FB");
function $4c4a9e2ddc86798d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4c4a9e2ddc86798d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4c4a9e2ddc86798d$var$_typeof(obj);
}
function $4c4a9e2ddc86798d$var$_extends() {
    $4c4a9e2ddc86798d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c4a9e2ddc86798d$var$_extends.apply(this, arguments);
}
function $4c4a9e2ddc86798d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4c4a9e2ddc86798d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4c4a9e2ddc86798d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4c4a9e2ddc86798d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4c4a9e2ddc86798d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4c4a9e2ddc86798d$var$_defineProperty(obj, key, value) {
    key = $4c4a9e2ddc86798d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4c4a9e2ddc86798d$var$_toPropertyKey(arg) {
    var key = $4c4a9e2ddc86798d$var$_toPrimitive(arg, "string");
    return $4c4a9e2ddc86798d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4c4a9e2ddc86798d$var$_toPrimitive(input, hint) {
    if ($4c4a9e2ddc86798d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4c4a9e2ddc86798d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4c4a9e2ddc86798d$export$348e1e27f1e916dd(_ref) {
    var autocomplete = _ref.autocomplete, autocompleteScopeApi = _ref.autocompleteScopeApi, dom = _ref.dom, propGetters = _ref.propGetters, state = _ref.state;
    (0, $616FB.setPropertiesWithoutEvents)(dom.root, propGetters.getRootProps($4c4a9e2ddc86798d$var$_objectSpread({
        state: state,
        props: autocomplete.getRootProps({})
    }, autocompleteScopeApi)));
    (0, $616FB.setPropertiesWithoutEvents)(dom.input, propGetters.getInputProps($4c4a9e2ddc86798d$var$_objectSpread({
        state: state,
        props: autocomplete.getInputProps({
            inputElement: dom.input
        }),
        inputElement: dom.input
    }, autocompleteScopeApi)));
    (0, $616FB.setProperties)(dom.label, {
        hidden: state.status === 'stalled'
    });
    (0, $616FB.setProperties)(dom.loadingIndicator, {
        hidden: state.status !== 'stalled'
    });
    (0, $616FB.setProperties)(dom.clearButton, {
        hidden: !state.query
    });
    (0, $616FB.setProperties)(dom.detachedSearchButtonQuery, {
        textContent: state.query
    });
    (0, $616FB.setProperties)(dom.detachedSearchButtonPlaceholder, {
        hidden: Boolean(state.query)
    });
}
function $4c4a9e2ddc86798d$export$67d17c7da9b4cdd6(render, _ref2) {
    var autocomplete = _ref2.autocomplete, autocompleteScopeApi = _ref2.autocompleteScopeApi, classNames = _ref2.classNames, html = _ref2.html, dom = _ref2.dom, panelContainer = _ref2.panelContainer, propGetters = _ref2.propGetters, state = _ref2.state, components = _ref2.components, renderer = _ref2.renderer;
    if (!state.isOpen) {
        if (panelContainer.contains(dom.panel)) panelContainer.removeChild(dom.panel);
        return;
    }
    // We add the panel element to the DOM when it's not yet appended and that the
    // items are fetched.
    if (!panelContainer.contains(dom.panel) && state.status !== 'loading') panelContainer.appendChild(dom.panel);
    dom.panel.classList.toggle('aa-Panel--stalled', state.status === 'stalled');
    var sections = state.collections.filter(function(_ref3) {
        var source = _ref3.source, items = _ref3.items;
        return source.templates.noResults || items.length > 0;
    }).map(function(_ref4, sourceIndex) {
        var source = _ref4.source, items = _ref4.items;
        return renderer.createElement("section", {
            key: sourceIndex,
            className: classNames.source,
            "data-autocomplete-source-id": source.sourceId
        }, source.templates.header && renderer.createElement("div", {
            className: classNames.sourceHeader
        }, source.templates.header({
            components: components,
            createElement: renderer.createElement,
            Fragment: renderer.Fragment,
            items: items,
            source: source,
            state: state,
            html: html
        })), source.templates.noResults && items.length === 0 ? renderer.createElement("div", {
            className: classNames.sourceNoResults
        }, source.templates.noResults({
            components: components,
            createElement: renderer.createElement,
            Fragment: renderer.Fragment,
            source: source,
            state: state,
            html: html
        })) : renderer.createElement("ul", $4c4a9e2ddc86798d$var$_extends({
            className: classNames.list
        }, propGetters.getListProps($4c4a9e2ddc86798d$var$_objectSpread({
            state: state,
            props: autocomplete.getListProps({
                source: source
            })
        }, autocompleteScopeApi))), items.map(function(item) {
            var itemProps = autocomplete.getItemProps({
                item: item,
                source: source
            });
            return renderer.createElement("li", $4c4a9e2ddc86798d$var$_extends({
                key: itemProps.id,
                className: classNames.item
            }, propGetters.getItemProps($4c4a9e2ddc86798d$var$_objectSpread({
                state: state,
                props: itemProps
            }, autocompleteScopeApi))), source.templates.item({
                components: components,
                createElement: renderer.createElement,
                Fragment: renderer.Fragment,
                item: item,
                state: state,
                html: html
            }));
        })), source.templates.footer && renderer.createElement("div", {
            className: classNames.sourceFooter
        }, source.templates.footer({
            components: components,
            createElement: renderer.createElement,
            Fragment: renderer.Fragment,
            items: items,
            source: source,
            state: state,
            html: html
        })));
    });
    var children = renderer.createElement(renderer.Fragment, null, renderer.createElement("div", {
        className: classNames.panelLayout
    }, sections), renderer.createElement("div", {
        className: "aa-GradientBottom"
    }));
    var elements = sections.reduce(function(acc, current) {
        acc[current.props['data-autocomplete-source-id']] = current;
        return acc;
    }, {});
    render($4c4a9e2ddc86798d$var$_objectSpread($4c4a9e2ddc86798d$var$_objectSpread({
        children: children,
        state: state,
        sections: sections,
        elements: elements
    }, renderer), {}, {
        components: components,
        html: html
    }, autocompleteScopeApi), dom.panel);
}

});

parcelRegister("2r0Rp", function(module, exports) {

$parcel$export(module.exports, "userAgents", function () { return $1c5ec53e42816366$export$9536ea83a4cbd560; });

var $igGyg = parcelRequire("igGyg");
var $1c5ec53e42816366$export$9536ea83a4cbd560 = [
    {
        segment: 'autocomplete-js',
        version: (0, $igGyg.version)
    }
];

});

parcelRegister("2nBEc", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", function () { return $1bbaeebd1f1e3b91$export$dd702b3c8240390c; });
function $1bbaeebd1f1e3b91$var$_toConsumableArray(arr) {
    return $1bbaeebd1f1e3b91$var$_arrayWithoutHoles(arr) || $1bbaeebd1f1e3b91$var$_iterableToArray(arr) || $1bbaeebd1f1e3b91$var$_unsupportedIterableToArray(arr) || $1bbaeebd1f1e3b91$var$_nonIterableSpread();
}
function $1bbaeebd1f1e3b91$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1bbaeebd1f1e3b91$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1bbaeebd1f1e3b91$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1bbaeebd1f1e3b91$var$_arrayLikeToArray(o, minLen);
}
function $1bbaeebd1f1e3b91$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1bbaeebd1f1e3b91$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1bbaeebd1f1e3b91$var$_arrayLikeToArray(arr);
}
function $1bbaeebd1f1e3b91$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1bbaeebd1f1e3b91$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1bbaeebd1f1e3b91$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1bbaeebd1f1e3b91$var$_typeof(obj);
}
var $1bbaeebd1f1e3b91$var$isPlainObject = function isPlainObject(value) {
    return value && $1bbaeebd1f1e3b91$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Object]';
};
function $1bbaeebd1f1e3b91$export$dd702b3c8240390c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return values.reduce(function(acc, current) {
        Object.keys(current).forEach(function(key) {
            var accValue = acc[key];
            var currentValue = current[key];
            if (Array.isArray(accValue) && Array.isArray(currentValue)) acc[key] = accValue.concat.apply(accValue, $1bbaeebd1f1e3b91$var$_toConsumableArray(currentValue));
            else if ($1bbaeebd1f1e3b91$var$isPlainObject(accValue) && $1bbaeebd1f1e3b91$var$isPlainObject(currentValue)) acc[key] = $1bbaeebd1f1e3b91$export$dd702b3c8240390c(accValue, currentValue);
            else acc[key] = currentValue;
        });
        return acc;
    }, {});
}

});

parcelRegister("lbvZh", function(module, exports) {

$parcel$export(module.exports, "pickBy", function () { return $03fae4e77f2a9eb7$export$b460b275d6c6aa0; });
function $03fae4e77f2a9eb7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $03fae4e77f2a9eb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $03fae4e77f2a9eb7$var$_typeof(obj);
}
function $03fae4e77f2a9eb7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $03fae4e77f2a9eb7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $03fae4e77f2a9eb7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $03fae4e77f2a9eb7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $03fae4e77f2a9eb7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $03fae4e77f2a9eb7$var$_defineProperty(obj, key, value) {
    key = $03fae4e77f2a9eb7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $03fae4e77f2a9eb7$var$_toPropertyKey(arg) {
    var key = $03fae4e77f2a9eb7$var$_toPrimitive(arg, "string");
    return $03fae4e77f2a9eb7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $03fae4e77f2a9eb7$var$_toPrimitive(input, hint) {
    if ($03fae4e77f2a9eb7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($03fae4e77f2a9eb7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $03fae4e77f2a9eb7$var$_slicedToArray(arr, i) {
    return $03fae4e77f2a9eb7$var$_arrayWithHoles(arr) || $03fae4e77f2a9eb7$var$_iterableToArrayLimit(arr, i) || $03fae4e77f2a9eb7$var$_unsupportedIterableToArray(arr, i) || $03fae4e77f2a9eb7$var$_nonIterableRest();
}
function $03fae4e77f2a9eb7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $03fae4e77f2a9eb7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $03fae4e77f2a9eb7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $03fae4e77f2a9eb7$var$_arrayLikeToArray(o, minLen);
}
function $03fae4e77f2a9eb7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $03fae4e77f2a9eb7$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $03fae4e77f2a9eb7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $03fae4e77f2a9eb7$export$b460b275d6c6aa0(obj, predicate) {
    return Object.entries(obj).reduce(function(acc, _ref) {
        var _ref2 = $03fae4e77f2a9eb7$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (predicate({
            key: key,
            value: value
        })) return $03fae4e77f2a9eb7$var$_objectSpread($03fae4e77f2a9eb7$var$_objectSpread({}, acc), {}, $03fae4e77f2a9eb7$var$_defineProperty({}, key, value));
        return acc;
    }, {});
}

});


parcelRegister("4sXVO", function(module, exports) {

$parcel$export(module.exports, "getAlgoliaResults", function () { return $3408441c6d6a327b$export$d82b34328f310205; });

var $9wwAN = parcelRequire("9wwAN");
var $3408441c6d6a327b$export$d82b34328f310205 = (0, $9wwAN.createAlgoliaRequester)({
    transformResponse: function transformResponse(response) {
        return response.hits;
    }
});

});
parcelRegister("9wwAN", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaRequester", function () { return $6ef06268d414ae53$export$9f082baead25d83b; });

var $fOO5E = parcelRequire("fOO5E");
var $fitoe = parcelRequire("fitoe");

var $2r0Rp = parcelRequire("2r0Rp");
function $6ef06268d414ae53$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6ef06268d414ae53$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6ef06268d414ae53$var$_typeof(obj);
}
function $6ef06268d414ae53$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ef06268d414ae53$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ef06268d414ae53$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ef06268d414ae53$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ef06268d414ae53$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ef06268d414ae53$var$_defineProperty(obj, key, value) {
    key = $6ef06268d414ae53$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ef06268d414ae53$var$_toPropertyKey(arg) {
    var key = $6ef06268d414ae53$var$_toPrimitive(arg, "string");
    return $6ef06268d414ae53$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6ef06268d414ae53$var$_toPrimitive(input, hint) {
    if ($6ef06268d414ae53$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6ef06268d414ae53$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6ef06268d414ae53$export$9f082baead25d83b = (0, $fOO5E.createRequester)(function(params) {
    return (0, $fitoe.fetchAlgoliaResults)($6ef06268d414ae53$var$_objectSpread($6ef06268d414ae53$var$_objectSpread({}, params), {}, {
        userAgents: (0, $2r0Rp.userAgents)
    }));
}, 'algolia');

});
parcelRegister("fOO5E", function(module, exports) {

$parcel$export(module.exports, "createRequester", function () { return $b84261649e66e51c$export$8d54726fdbf08e0a; });
function $b84261649e66e51c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b84261649e66e51c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b84261649e66e51c$var$_typeof(obj);
}
function $b84261649e66e51c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b84261649e66e51c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b84261649e66e51c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b84261649e66e51c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b84261649e66e51c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b84261649e66e51c$var$_defineProperty(obj, key, value) {
    key = $b84261649e66e51c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b84261649e66e51c$var$_toPropertyKey(arg) {
    var key = $b84261649e66e51c$var$_toPrimitive(arg, "string");
    return $b84261649e66e51c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b84261649e66e51c$var$_toPrimitive(input, hint) {
    if ($b84261649e66e51c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b84261649e66e51c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b84261649e66e51c$export$8d54726fdbf08e0a(fetcher, requesterId) {
    function execute(fetcherParams) {
        return fetcher({
            searchClient: fetcherParams.searchClient,
            queries: fetcherParams.requests.map(function(x) {
                return x.query;
            })
        }).then(function(responses) {
            return responses.map(function(response, index) {
                var _fetcherParams$reques = fetcherParams.requests[index], sourceId = _fetcherParams$reques.sourceId, transformResponse = _fetcherParams$reques.transformResponse;
                return {
                    items: response,
                    sourceId: sourceId,
                    transformResponse: transformResponse
                };
            });
        });
    }
    return function createSpecifiedRequester(requesterParams) {
        return function requester(requestParams) {
            return $b84261649e66e51c$var$_objectSpread($b84261649e66e51c$var$_objectSpread({
                requesterId: requesterId,
                execute: execute
            }, requesterParams), requestParams);
        };
    };
}

});

parcelRegister("fitoe", function(module, exports) {

$parcel$export(module.exports, "fetchAlgoliaResults", function () { return $b22f55a9c077279f$export$9e16a9ccc61ab625; });

var $hAVux = parcelRequire("hAVux");
var $gKX7m = parcelRequire("gKX7m");

var $iZBKx = parcelRequire("iZBKx");

var $1Uo4l = parcelRequire("1Uo4l");
function $b22f55a9c077279f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b22f55a9c077279f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b22f55a9c077279f$var$_typeof(obj);
}
var $b22f55a9c077279f$var$_excluded = [
    "params"
];
function $b22f55a9c077279f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b22f55a9c077279f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b22f55a9c077279f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b22f55a9c077279f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b22f55a9c077279f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b22f55a9c077279f$var$_defineProperty(obj, key, value) {
    key = $b22f55a9c077279f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b22f55a9c077279f$var$_toPropertyKey(arg) {
    var key = $b22f55a9c077279f$var$_toPrimitive(arg, "string");
    return $b22f55a9c077279f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b22f55a9c077279f$var$_toPrimitive(input, hint) {
    if ($b22f55a9c077279f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b22f55a9c077279f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b22f55a9c077279f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b22f55a9c077279f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b22f55a9c077279f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b22f55a9c077279f$var$_toConsumableArray(arr) {
    return $b22f55a9c077279f$var$_arrayWithoutHoles(arr) || $b22f55a9c077279f$var$_iterableToArray(arr) || $b22f55a9c077279f$var$_unsupportedIterableToArray(arr) || $b22f55a9c077279f$var$_nonIterableSpread();
}
function $b22f55a9c077279f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b22f55a9c077279f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b22f55a9c077279f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b22f55a9c077279f$var$_arrayLikeToArray(o, minLen);
}
function $b22f55a9c077279f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b22f55a9c077279f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b22f55a9c077279f$var$_arrayLikeToArray(arr);
}
function $b22f55a9c077279f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b22f55a9c077279f$export$9e16a9ccc61ab625(_ref) {
    var searchClient = _ref.searchClient, queries = _ref.queries, _ref$userAgents = _ref.userAgents, userAgents = _ref$userAgents === void 0 ? [] : _ref$userAgents;
    if (typeof searchClient.addAlgoliaAgent === 'function') {
        var algoliaAgents = [].concat($b22f55a9c077279f$var$_toConsumableArray((0, $gKX7m.userAgents)), $b22f55a9c077279f$var$_toConsumableArray(userAgents));
        algoliaAgents.forEach(function(_ref2) {
            var segment = _ref2.segment, version = _ref2.version;
            searchClient.addAlgoliaAgent(segment, version);
        });
    }
    var _getAppIdAndApiKey = (0, $1Uo4l.getAppIdAndApiKey)(searchClient), appId = _getAppIdAndApiKey.appId, apiKey = _getAppIdAndApiKey.apiKey;
    (0, $hAVux.invariant)(Boolean(appId), 'The Algolia `appId` was not accessible from the searchClient passed.');
    (0, $hAVux.invariant)(Boolean(apiKey), 'The Algolia `apiKey` was not accessible from the searchClient passed.');
    return searchClient.search(queries.map(function(searchParameters) {
        var params = searchParameters.params, headers = $b22f55a9c077279f$var$_objectWithoutProperties(searchParameters, $b22f55a9c077279f$var$_excluded);
        return $b22f55a9c077279f$var$_objectSpread($b22f55a9c077279f$var$_objectSpread({}, headers), {}, {
            params: $b22f55a9c077279f$var$_objectSpread({
                hitsPerPage: 5,
                highlightPreTag: (0, $iZBKx.HIGHLIGHT_PRE_TAG),
                highlightPostTag: (0, $iZBKx.HIGHLIGHT_POST_TAG)
            }, params)
        });
    })).then(function(response) {
        return response.results.map(function(result, resultIndex) {
            var _result$hits;
            return $b22f55a9c077279f$var$_objectSpread($b22f55a9c077279f$var$_objectSpread({}, result), {}, {
                hits: (_result$hits = result.hits) === null || _result$hits === void 0 ? void 0 : _result$hits.map(function(hit) {
                    return $b22f55a9c077279f$var$_objectSpread($b22f55a9c077279f$var$_objectSpread({}, hit), {}, {
                        // Bring support for the Insights plugin.
                        __autocomplete_indexName: result.index || queries[resultIndex].indexName,
                        __autocomplete_queryID: result.queryID,
                        __autocomplete_algoliaCredentials: {
                            appId: appId,
                            apiKey: apiKey
                        }
                    });
                })
            });
        });
    });
}

});
parcelRegister("1Uo4l", function(module, exports) {

$parcel$export(module.exports, "getAppIdAndApiKey", function () { return $163db100c8e265b4$export$58f35ab8a1251bc0; });
// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $163db100c8e265b4$export$58f35ab8a1251bc0(searchClient) {
    var transporter = searchClient.transporter || {};
    var headers = transporter.headers || transporter.baseHeaders || {};
    var queryParameters = transporter.queryParameters || transporter.baseQueryParameters || {};
    var APP_ID = 'x-algolia-application-id';
    var API_KEY = 'x-algolia-api-key';
    var appId = headers[APP_ID] || queryParameters[APP_ID];
    var apiKey = headers[API_KEY] || queryParameters[API_KEY];
    return {
        appId: appId,
        apiKey: apiKey
    };
}

});





parcelRegister("c4Ied", function(module, exports) {

module.exports = (parcelRequire("1K40G"))($parcel$resolve("67bzn")).then(function() {
    return parcelRequire('2JCzs');
});

});

parcelRegister("5O7RQ", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("1K40G"))($parcel$resolve("67bzn")),
    (parcelRequire("1K40G"))($parcel$resolve("2pzvU"))
]).then(function() {
    return parcelRequire('8d8IL');
});

});


parcelRegister("gJOMw", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $c2f83d7c13f283fd$export$882461b6382ed46c; }, function (v) { return $c2f83d7c13f283fd$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c2f83d7c13f283fd$export$757ceba2d55c277e; }, function (v) { return $c2f83d7c13f283fd$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $c2f83d7c13f283fd$export$83d89fbfd8236492; }, function (v) { return $c2f83d7c13f283fd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $4TMho = parcelRequire("4TMho");
var $c2f83d7c13f283fd$export$882461b6382ed46c;
var $c2f83d7c13f283fd$export$757ceba2d55c277e;
var $c2f83d7c13f283fd$export$83d89fbfd8236492;
"use strict";

var $kCnPN = parcelRequire("kCnPN");

var $ggE0n = parcelRequire("ggE0n");

var $3og2D = parcelRequire("3og2D");
function $c2f83d7c13f283fd$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c2f83d7c13f283fd$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $c2f83d7c13f283fd$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c2f83d7c13f283fd$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c2f83d7c13f283fd$var$assertIsMounted(fiber) {
    if ($c2f83d7c13f283fd$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(188));
}
function $c2f83d7c13f283fd$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c2f83d7c13f283fd$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c2f83d7c13f283fd$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c2f83d7c13f283fd$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c2f83d7c13f283fd$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c2f83d7c13f283fd$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c2f83d7c13f283fd$var$assign = Object.assign, $c2f83d7c13f283fd$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c2f83d7c13f283fd$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c2f83d7c13f283fd$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c2f83d7c13f283fd$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c2f83d7c13f283fd$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c2f83d7c13f283fd$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $c2f83d7c13f283fd$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c2f83d7c13f283fd$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c2f83d7c13f283fd$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c2f83d7c13f283fd$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c2f83d7c13f283fd$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c2f83d7c13f283fd$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $c2f83d7c13f283fd$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c2f83d7c13f283fd$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $c2f83d7c13f283fd$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c2f83d7c13f283fd$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $4TMho._)(maybeIterable))) return null;
    maybeIterable = $c2f83d7c13f283fd$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c2f83d7c13f283fd$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c2f83d7c13f283fd$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c2f83d7c13f283fd$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c2f83d7c13f283fd$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c2f83d7c13f283fd$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c2f83d7c13f283fd$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c2f83d7c13f283fd$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c2f83d7c13f283fd$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c2f83d7c13f283fd$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $4TMho._)(type))) switch(type.$$typeof){
        case $c2f83d7c13f283fd$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $c2f83d7c13f283fd$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c2f83d7c13f283fd$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c2f83d7c13f283fd$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c2f83d7c13f283fd$var$getComponentNameFromType(type.type) || "Memo";
        case $c2f83d7c13f283fd$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c2f83d7c13f283fd$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c2f83d7c13f283fd$var$isArrayImpl = Array.isArray, $c2f83d7c13f283fd$var$ReactSharedInternals = $ggE0n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c2f83d7c13f283fd$var$ReactDOMSharedInternals = $3og2D.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c2f83d7c13f283fd$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c2f83d7c13f283fd$var$valueStack = [], $c2f83d7c13f283fd$var$index = -1;
function $c2f83d7c13f283fd$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c2f83d7c13f283fd$var$pop(cursor) {
    0 > $c2f83d7c13f283fd$var$index || (cursor.current = $c2f83d7c13f283fd$var$valueStack[$c2f83d7c13f283fd$var$index], $c2f83d7c13f283fd$var$valueStack[$c2f83d7c13f283fd$var$index] = null, $c2f83d7c13f283fd$var$index--);
}
function $c2f83d7c13f283fd$var$push(cursor, value) {
    $c2f83d7c13f283fd$var$index++;
    $c2f83d7c13f283fd$var$valueStack[$c2f83d7c13f283fd$var$index] = cursor.current;
    cursor.current = value;
}
var $c2f83d7c13f283fd$var$contextStackCursor = $c2f83d7c13f283fd$var$createCursor(null), $c2f83d7c13f283fd$var$contextFiberStackCursor = $c2f83d7c13f283fd$var$createCursor(null), $c2f83d7c13f283fd$var$rootInstanceStackCursor = $c2f83d7c13f283fd$var$createCursor(null), $c2f83d7c13f283fd$var$hostTransitionProviderCursor = $c2f83d7c13f283fd$var$createCursor(null);
function $c2f83d7c13f283fd$var$pushHostContainer(fiber, nextRootInstance) {
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$rootInstanceStackCursor, nextRootInstance);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$contextFiberStackCursor, fiber);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $c2f83d7c13f283fd$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $c2f83d7c13f283fd$var$getOwnHostContext(nextRootInstance), fiber = $c2f83d7c13f283fd$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$contextStackCursor);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$contextStackCursor, fiber);
}
function $c2f83d7c13f283fd$var$popHostContainer() {
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$contextStackCursor);
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$contextFiberStackCursor);
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$rootInstanceStackCursor);
}
function $c2f83d7c13f283fd$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$hostTransitionProviderCursor, fiber);
    var context = $c2f83d7c13f283fd$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c2f83d7c13f283fd$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$contextFiberStackCursor, fiber), $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$contextStackCursor, JSCompiler_inline_result));
}
function $c2f83d7c13f283fd$var$popHostContext(fiber) {
    $c2f83d7c13f283fd$var$contextFiberStackCursor.current === fiber && ($c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$contextStackCursor), $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$contextFiberStackCursor));
    $c2f83d7c13f283fd$var$hostTransitionProviderCursor.current === fiber && ($c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$hostTransitionProviderCursor), $c2f83d7c13f283fd$var$HostTransitionContext._currentValue = $c2f83d7c13f283fd$var$sharedNotPendingObject);
}
var $c2f83d7c13f283fd$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c2f83d7c13f283fd$var$scheduleCallback$3 = $kCnPN.unstable_scheduleCallback, $c2f83d7c13f283fd$var$cancelCallback$1 = $kCnPN.unstable_cancelCallback, $c2f83d7c13f283fd$var$shouldYield = $kCnPN.unstable_shouldYield, $c2f83d7c13f283fd$var$requestPaint = $kCnPN.unstable_requestPaint, $c2f83d7c13f283fd$var$now = $kCnPN.unstable_now, $c2f83d7c13f283fd$var$getCurrentPriorityLevel = $kCnPN.unstable_getCurrentPriorityLevel, $c2f83d7c13f283fd$var$ImmediatePriority = $kCnPN.unstable_ImmediatePriority, $c2f83d7c13f283fd$var$UserBlockingPriority = $kCnPN.unstable_UserBlockingPriority, $c2f83d7c13f283fd$var$NormalPriority$1 = $kCnPN.unstable_NormalPriority, $c2f83d7c13f283fd$var$LowPriority = $kCnPN.unstable_LowPriority, $c2f83d7c13f283fd$var$IdlePriority = $kCnPN.unstable_IdlePriority, $c2f83d7c13f283fd$var$log$1 = $kCnPN.log, $c2f83d7c13f283fd$var$unstable_setDisableYieldValue = $kCnPN.unstable_setDisableYieldValue, $c2f83d7c13f283fd$var$rendererID = null, $c2f83d7c13f283fd$var$injectedHook = null;
function $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c2f83d7c13f283fd$var$log$1 && $c2f83d7c13f283fd$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c2f83d7c13f283fd$var$injectedHook && "function" === typeof $c2f83d7c13f283fd$var$injectedHook.setStrictMode) try {
        $c2f83d7c13f283fd$var$injectedHook.setStrictMode($c2f83d7c13f283fd$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c2f83d7c13f283fd$var$clz32 = Math.clz32 ? Math.clz32 : $c2f83d7c13f283fd$var$clz32Fallback, $c2f83d7c13f283fd$var$log = Math.log, $c2f83d7c13f283fd$var$LN2 = Math.LN2;
function $c2f83d7c13f283fd$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c2f83d7c13f283fd$var$log(x) / $c2f83d7c13f283fd$var$LN2 | 0) | 0;
}
var $c2f83d7c13f283fd$var$nextTransitionLane = 256, $c2f83d7c13f283fd$var$nextRetryLane = 4194304;
function $c2f83d7c13f283fd$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c2f83d7c13f283fd$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $c2f83d7c13f283fd$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c2f83d7c13f283fd$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c2f83d7c13f283fd$var$claimNextTransitionLane() {
    var lane = $c2f83d7c13f283fd$var$nextTransitionLane;
    $c2f83d7c13f283fd$var$nextTransitionLane <<= 1;
    0 === ($c2f83d7c13f283fd$var$nextTransitionLane & 4194048) && ($c2f83d7c13f283fd$var$nextTransitionLane = 256);
    return lane;
}
function $c2f83d7c13f283fd$var$claimNextRetryLane() {
    var lane = $c2f83d7c13f283fd$var$nextRetryLane;
    $c2f83d7c13f283fd$var$nextRetryLane <<= 1;
    0 === ($c2f83d7c13f283fd$var$nextRetryLane & 62914560) && ($c2f83d7c13f283fd$var$nextRetryLane = 4194304);
    return lane;
}
function $c2f83d7c13f283fd$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c2f83d7c13f283fd$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c2f83d7c13f283fd$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $c2f83d7c13f283fd$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c2f83d7c13f283fd$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c2f83d7c13f283fd$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c2f83d7c13f283fd$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $c2f83d7c13f283fd$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $c2f83d7c13f283fd$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c2f83d7c13f283fd$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $c2f83d7c13f283fd$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c2f83d7c13f283fd$var$resolveUpdatePriority() {
    var updatePriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c2f83d7c13f283fd$var$getEventPriority(updatePriority.type);
}
function $c2f83d7c13f283fd$var$runWithPriority(priority, fn) {
    var previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
    try {
        return $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c2f83d7c13f283fd$var$randomKey = Math.random().toString(36).slice(2), $c2f83d7c13f283fd$var$internalInstanceKey = "__reactFiber$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalPropsKey = "__reactProps$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalContainerInstanceKey = "__reactContainer$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalEventHandlersKey = "__reactEvents$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalEventHandlerListenersKey = "__reactListeners$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalEventHandlesSetKey = "__reactHandles$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalRootNodeResourcesKey = "__reactResources$" + $c2f83d7c13f283fd$var$randomKey, $c2f83d7c13f283fd$var$internalHoistableMarker = "__reactMarker$" + $c2f83d7c13f283fd$var$randomKey;
function $c2f83d7c13f283fd$var$detachDeletedInstance(node) {
    delete node[$c2f83d7c13f283fd$var$internalInstanceKey];
    delete node[$c2f83d7c13f283fd$var$internalPropsKey];
    delete node[$c2f83d7c13f283fd$var$internalEventHandlersKey];
    delete node[$c2f83d7c13f283fd$var$internalEventHandlerListenersKey];
    delete node[$c2f83d7c13f283fd$var$internalEventHandlesSetKey];
}
function $c2f83d7c13f283fd$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c2f83d7c13f283fd$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c2f83d7c13f283fd$var$internalContainerInstanceKey] || parentNode[$c2f83d7c13f283fd$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c2f83d7c13f283fd$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c2f83d7c13f283fd$var$internalInstanceKey]) return parentNode;
                targetNode = $c2f83d7c13f283fd$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c2f83d7c13f283fd$var$getInstanceFromNode(node) {
    if (node = node[$c2f83d7c13f283fd$var$internalInstanceKey] || node[$c2f83d7c13f283fd$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c2f83d7c13f283fd$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(33));
}
function $c2f83d7c13f283fd$var$getResourcesFromRoot(root) {
    var resources = root[$c2f83d7c13f283fd$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c2f83d7c13f283fd$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c2f83d7c13f283fd$var$markNodeAsHoistable(node) {
    node[$c2f83d7c13f283fd$var$internalHoistableMarker] = !0;
}
var $c2f83d7c13f283fd$var$allNativeEvents = new Set(), $c2f83d7c13f283fd$var$registrationNameDependencies = {};
function $c2f83d7c13f283fd$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c2f83d7c13f283fd$var$registerDirectEvent(registrationName, dependencies);
    $c2f83d7c13f283fd$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c2f83d7c13f283fd$var$registerDirectEvent(registrationName, dependencies) {
    $c2f83d7c13f283fd$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c2f83d7c13f283fd$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c2f83d7c13f283fd$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c2f83d7c13f283fd$var$illegalAttributeNameCache = {}, $c2f83d7c13f283fd$var$validatedAttributeNameCache = {};
function $c2f83d7c13f283fd$var$isAttributeNameSafe(attributeName) {
    if ($c2f83d7c13f283fd$var$hasOwnProperty.call($c2f83d7c13f283fd$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c2f83d7c13f283fd$var$hasOwnProperty.call($c2f83d7c13f283fd$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c2f83d7c13f283fd$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c2f83d7c13f283fd$var$validatedAttributeNameCache[attributeName] = !0;
    $c2f83d7c13f283fd$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c2f83d7c13f283fd$var$setValueForAttribute(node, name, value) {
    if ($c2f83d7c13f283fd$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c2f83d7c13f283fd$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $c2f83d7c13f283fd$var$prefix, $c2f83d7c13f283fd$var$suffix;
function $c2f83d7c13f283fd$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c2f83d7c13f283fd$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c2f83d7c13f283fd$var$prefix = match && match[1] || "";
        $c2f83d7c13f283fd$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c2f83d7c13f283fd$var$prefix + name + $c2f83d7c13f283fd$var$suffix;
}
var $c2f83d7c13f283fd$var$reentry = !1;
function $c2f83d7c13f283fd$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c2f83d7c13f283fd$var$reentry) return "";
    $c2f83d7c13f283fd$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $4TMho._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c2f83d7c13f283fd$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c2f83d7c13f283fd$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c2f83d7c13f283fd$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c2f83d7c13f283fd$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c2f83d7c13f283fd$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $c2f83d7c13f283fd$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c2f83d7c13f283fd$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $c2f83d7c13f283fd$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $c2f83d7c13f283fd$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $c2f83d7c13f283fd$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $c2f83d7c13f283fd$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $c2f83d7c13f283fd$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $c2f83d7c13f283fd$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $c2f83d7c13f283fd$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c2f83d7c13f283fd$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c2f83d7c13f283fd$var$trackValueOnNode(node) {
    var valueField = $c2f83d7c13f283fd$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c2f83d7c13f283fd$var$track(node) {
    node._valueTracker || (node._valueTracker = $c2f83d7c13f283fd$var$trackValueOnNode(node));
}
function $c2f83d7c13f283fd$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c2f83d7c13f283fd$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c2f83d7c13f283fd$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c2f83d7c13f283fd$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $4TMho._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c2f83d7c13f283fd$var$getToStringValue(value);
        } else element.value !== "" + $c2f83d7c13f283fd$var$getToStringValue(value) && (element.value = "" + $c2f83d7c13f283fd$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c2f83d7c13f283fd$var$setDefaultValue(element, type, $c2f83d7c13f283fd$var$getToStringValue(value)) : null != defaultValue ? $c2f83d7c13f283fd$var$setDefaultValue(element, type, $c2f83d7c13f283fd$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $4TMho._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $4TMho._)(name)) && "boolean" !== typeof name ? element.name = "" + $c2f83d7c13f283fd$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c2f83d7c13f283fd$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $4TMho._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $c2f83d7c13f283fd$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c2f83d7c13f283fd$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $4TMho._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $4TMho._)(name)) && "boolean" !== typeof name && (element.name = name);
}
function $c2f83d7c13f283fd$var$setDefaultValue(node, type, value) {
    "number" === type && $c2f83d7c13f283fd$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c2f83d7c13f283fd$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c2f83d7c13f283fd$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c2f83d7c13f283fd$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c2f83d7c13f283fd$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c2f83d7c13f283fd$var$getToStringValue(defaultValue) : "";
}
function $c2f83d7c13f283fd$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(92));
            if ($c2f83d7c13f283fd$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c2f83d7c13f283fd$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $c2f83d7c13f283fd$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c2f83d7c13f283fd$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c2f83d7c13f283fd$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c2f83d7c13f283fd$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c2f83d7c13f283fd$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $4TMho._)(styles))) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c2f83d7c13f283fd$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c2f83d7c13f283fd$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c2f83d7c13f283fd$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c2f83d7c13f283fd$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c2f83d7c13f283fd$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c2f83d7c13f283fd$var$sanitizeURL(url) {
    return $c2f83d7c13f283fd$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $c2f83d7c13f283fd$var$currentReplayingEvent = null;
function $c2f83d7c13f283fd$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c2f83d7c13f283fd$var$restoreTarget = null, $c2f83d7c13f283fd$var$restoreQueue = null;
function $c2f83d7c13f283fd$var$restoreStateOfTarget(target) {
    var internalInstance = $c2f83d7c13f283fd$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c2f83d7c13f283fd$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c2f83d7c13f283fd$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c2f83d7c13f283fd$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(90));
                            $c2f83d7c13f283fd$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c2f83d7c13f283fd$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c2f83d7c13f283fd$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c2f83d7c13f283fd$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c2f83d7c13f283fd$var$isInsideEventHandler = !1;
function $c2f83d7c13f283fd$var$batchedUpdates$1(fn, a, b) {
    if ($c2f83d7c13f283fd$var$isInsideEventHandler) return fn(a, b);
    $c2f83d7c13f283fd$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c2f83d7c13f283fd$var$isInsideEventHandler = !1, null !== $c2f83d7c13f283fd$var$restoreTarget || null !== $c2f83d7c13f283fd$var$restoreQueue) {
            if ($c2f83d7c13f283fd$var$flushSyncWork$1(), $c2f83d7c13f283fd$var$restoreTarget && (a = $c2f83d7c13f283fd$var$restoreTarget, fn = $c2f83d7c13f283fd$var$restoreQueue, $c2f83d7c13f283fd$var$restoreQueue = $c2f83d7c13f283fd$var$restoreTarget = null, $c2f83d7c13f283fd$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c2f83d7c13f283fd$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c2f83d7c13f283fd$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c2f83d7c13f283fd$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $4TMho._)(stateNode)));
    return stateNode;
}
var $c2f83d7c13f283fd$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c2f83d7c13f283fd$var$passiveBrowserEventsSupported = !1;
if ($c2f83d7c13f283fd$var$canUseDOM) try {
    var $c2f83d7c13f283fd$var$options = {};
    Object.defineProperty($c2f83d7c13f283fd$var$options, "passive", {
        get: function get() {
            $c2f83d7c13f283fd$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c2f83d7c13f283fd$var$options, $c2f83d7c13f283fd$var$options);
    window.removeEventListener("test", $c2f83d7c13f283fd$var$options, $c2f83d7c13f283fd$var$options);
} catch (e) {
    $c2f83d7c13f283fd$var$passiveBrowserEventsSupported = !1;
}
var $c2f83d7c13f283fd$var$root = null, $c2f83d7c13f283fd$var$startText = null, $c2f83d7c13f283fd$var$fallbackText = null;
function $c2f83d7c13f283fd$var$getData() {
    if ($c2f83d7c13f283fd$var$fallbackText) return $c2f83d7c13f283fd$var$fallbackText;
    var start, startValue = $c2f83d7c13f283fd$var$startText, startLength = startValue.length, end, endValue = "value" in $c2f83d7c13f283fd$var$root ? $c2f83d7c13f283fd$var$root.value : $c2f83d7c13f283fd$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c2f83d7c13f283fd$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c2f83d7c13f283fd$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c2f83d7c13f283fd$var$functionThatReturnsTrue() {
    return !0;
}
function $c2f83d7c13f283fd$var$functionThatReturnsFalse() {
    return !1;
}
function $c2f83d7c13f283fd$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c2f83d7c13f283fd$var$functionThatReturnsTrue : $c2f83d7c13f283fd$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c2f83d7c13f283fd$var$functionThatReturnsFalse;
        return this;
    }
    $c2f83d7c13f283fd$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $4TMho._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $c2f83d7c13f283fd$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $4TMho._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $c2f83d7c13f283fd$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $c2f83d7c13f283fd$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c2f83d7c13f283fd$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c2f83d7c13f283fd$var$SyntheticEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$EventInterface), $c2f83d7c13f283fd$var$UIEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$EventInterface, {
    view: 0,
    detail: 0
}), $c2f83d7c13f283fd$var$SyntheticUIEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$UIEventInterface), $c2f83d7c13f283fd$var$lastMovementX, $c2f83d7c13f283fd$var$lastMovementY, $c2f83d7c13f283fd$var$lastMouseEvent, $c2f83d7c13f283fd$var$MouseEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c2f83d7c13f283fd$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c2f83d7c13f283fd$var$lastMouseEvent && ($c2f83d7c13f283fd$var$lastMouseEvent && "mousemove" === event.type ? ($c2f83d7c13f283fd$var$lastMovementX = event.screenX - $c2f83d7c13f283fd$var$lastMouseEvent.screenX, $c2f83d7c13f283fd$var$lastMovementY = event.screenY - $c2f83d7c13f283fd$var$lastMouseEvent.screenY) : $c2f83d7c13f283fd$var$lastMovementY = $c2f83d7c13f283fd$var$lastMovementX = 0, $c2f83d7c13f283fd$var$lastMouseEvent = event);
        return $c2f83d7c13f283fd$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $c2f83d7c13f283fd$var$lastMovementY;
    }
}), $c2f83d7c13f283fd$var$SyntheticMouseEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$MouseEventInterface), $c2f83d7c13f283fd$var$DragEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$MouseEventInterface, {
    dataTransfer: 0
}), $c2f83d7c13f283fd$var$SyntheticDragEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$DragEventInterface), $c2f83d7c13f283fd$var$FocusEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$UIEventInterface, {
    relatedTarget: 0
}), $c2f83d7c13f283fd$var$SyntheticFocusEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$FocusEventInterface), $c2f83d7c13f283fd$var$AnimationEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2f83d7c13f283fd$var$SyntheticAnimationEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$AnimationEventInterface), $c2f83d7c13f283fd$var$ClipboardEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c2f83d7c13f283fd$var$SyntheticClipboardEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$ClipboardEventInterface), $c2f83d7c13f283fd$var$CompositionEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$EventInterface, {
    data: 0
}), $c2f83d7c13f283fd$var$SyntheticCompositionEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$CompositionEventInterface), $c2f83d7c13f283fd$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c2f83d7c13f283fd$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c2f83d7c13f283fd$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c2f83d7c13f283fd$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c2f83d7c13f283fd$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c2f83d7c13f283fd$var$getEventModifierState() {
    return $c2f83d7c13f283fd$var$modifierStateGetter;
}
var $c2f83d7c13f283fd$var$KeyboardEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c2f83d7c13f283fd$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c2f83d7c13f283fd$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c2f83d7c13f283fd$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c2f83d7c13f283fd$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $c2f83d7c13f283fd$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $c2f83d7c13f283fd$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c2f83d7c13f283fd$var$SyntheticKeyboardEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$KeyboardEventInterface), $c2f83d7c13f283fd$var$PointerEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c2f83d7c13f283fd$var$SyntheticPointerEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$PointerEventInterface), $c2f83d7c13f283fd$var$TouchEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c2f83d7c13f283fd$var$getEventModifierState
}), $c2f83d7c13f283fd$var$SyntheticTouchEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$TouchEventInterface), $c2f83d7c13f283fd$var$TransitionEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2f83d7c13f283fd$var$SyntheticTransitionEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$TransitionEventInterface), $c2f83d7c13f283fd$var$WheelEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c2f83d7c13f283fd$var$SyntheticWheelEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$WheelEventInterface), $c2f83d7c13f283fd$var$ToggleEventInterface = $c2f83d7c13f283fd$var$assign({}, $c2f83d7c13f283fd$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c2f83d7c13f283fd$var$SyntheticToggleEvent = $c2f83d7c13f283fd$var$createSyntheticEvent($c2f83d7c13f283fd$var$ToggleEventInterface), $c2f83d7c13f283fd$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c2f83d7c13f283fd$var$canUseCompositionEvent = $c2f83d7c13f283fd$var$canUseDOM && "CompositionEvent" in window, $c2f83d7c13f283fd$var$documentMode = null;
$c2f83d7c13f283fd$var$canUseDOM && "documentMode" in document && ($c2f83d7c13f283fd$var$documentMode = document.documentMode);
var $c2f83d7c13f283fd$var$canUseTextInputEvent = $c2f83d7c13f283fd$var$canUseDOM && "TextEvent" in window && !$c2f83d7c13f283fd$var$documentMode, $c2f83d7c13f283fd$var$useFallbackCompositionData = $c2f83d7c13f283fd$var$canUseDOM && (!$c2f83d7c13f283fd$var$canUseCompositionEvent || $c2f83d7c13f283fd$var$documentMode && 8 < $c2f83d7c13f283fd$var$documentMode && 11 >= $c2f83d7c13f283fd$var$documentMode), $c2f83d7c13f283fd$var$SPACEBAR_CHAR = String.fromCharCode(32), $c2f83d7c13f283fd$var$hasSpaceKeypress = !1;
function $c2f83d7c13f283fd$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c2f83d7c13f283fd$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c2f83d7c13f283fd$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $4TMho._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c2f83d7c13f283fd$var$isComposing = !1;
function $c2f83d7c13f283fd$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c2f83d7c13f283fd$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c2f83d7c13f283fd$var$hasSpaceKeypress = !0;
            return $c2f83d7c13f283fd$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c2f83d7c13f283fd$var$SPACEBAR_CHAR && $c2f83d7c13f283fd$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c2f83d7c13f283fd$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c2f83d7c13f283fd$var$isComposing) return "compositionend" === domEventName || !$c2f83d7c13f283fd$var$canUseCompositionEvent && $c2f83d7c13f283fd$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c2f83d7c13f283fd$var$getData(), $c2f83d7c13f283fd$var$fallbackText = $c2f83d7c13f283fd$var$startText = $c2f83d7c13f283fd$var$root = null, $c2f83d7c13f283fd$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c2f83d7c13f283fd$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c2f83d7c13f283fd$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c2f83d7c13f283fd$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c2f83d7c13f283fd$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c2f83d7c13f283fd$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c2f83d7c13f283fd$var$restoreTarget ? $c2f83d7c13f283fd$var$restoreQueue ? $c2f83d7c13f283fd$var$restoreQueue.push(target) : $c2f83d7c13f283fd$var$restoreQueue = [
        target
    ] : $c2f83d7c13f283fd$var$restoreTarget = target;
    inst = $c2f83d7c13f283fd$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c2f83d7c13f283fd$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c2f83d7c13f283fd$var$activeElement$1 = null, $c2f83d7c13f283fd$var$activeElementInst$1 = null;
function $c2f83d7c13f283fd$var$runEventInBatch(dispatchQueue) {
    $c2f83d7c13f283fd$var$processDispatchQueue(dispatchQueue, 0);
}
function $c2f83d7c13f283fd$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c2f83d7c13f283fd$var$getNodeFromInstance(targetInst);
    if ($c2f83d7c13f283fd$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c2f83d7c13f283fd$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c2f83d7c13f283fd$var$isInputEventSupported = !1;
if ($c2f83d7c13f283fd$var$canUseDOM) {
    var $c2f83d7c13f283fd$var$JSCompiler_inline_result$jscomp$282;
    if ($c2f83d7c13f283fd$var$canUseDOM) {
        var $c2f83d7c13f283fd$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$c2f83d7c13f283fd$var$isSupported$jscomp$inline_417) {
            var $c2f83d7c13f283fd$var$element$jscomp$inline_418 = document.createElement("div");
            $c2f83d7c13f283fd$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $c2f83d7c13f283fd$var$isSupported$jscomp$inline_417 = "function" === typeof $c2f83d7c13f283fd$var$element$jscomp$inline_418.oninput;
        }
        $c2f83d7c13f283fd$var$JSCompiler_inline_result$jscomp$282 = $c2f83d7c13f283fd$var$isSupported$jscomp$inline_417;
    } else $c2f83d7c13f283fd$var$JSCompiler_inline_result$jscomp$282 = !1;
    $c2f83d7c13f283fd$var$isInputEventSupported = $c2f83d7c13f283fd$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $c2f83d7c13f283fd$var$stopWatchingForValueChange() {
    $c2f83d7c13f283fd$var$activeElement$1 && ($c2f83d7c13f283fd$var$activeElement$1.detachEvent("onpropertychange", $c2f83d7c13f283fd$var$handlePropertyChange), $c2f83d7c13f283fd$var$activeElementInst$1 = $c2f83d7c13f283fd$var$activeElement$1 = null);
}
function $c2f83d7c13f283fd$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c2f83d7c13f283fd$var$getInstIfValueChanged($c2f83d7c13f283fd$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c2f83d7c13f283fd$var$createAndAccumulateChangeEvent(dispatchQueue, $c2f83d7c13f283fd$var$activeElementInst$1, nativeEvent, $c2f83d7c13f283fd$var$getEventTarget(nativeEvent));
        $c2f83d7c13f283fd$var$batchedUpdates$1($c2f83d7c13f283fd$var$runEventInBatch, dispatchQueue);
    }
}
function $c2f83d7c13f283fd$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c2f83d7c13f283fd$var$stopWatchingForValueChange(), $c2f83d7c13f283fd$var$activeElement$1 = target, $c2f83d7c13f283fd$var$activeElementInst$1 = targetInst, $c2f83d7c13f283fd$var$activeElement$1.attachEvent("onpropertychange", $c2f83d7c13f283fd$var$handlePropertyChange)) : "focusout" === domEventName && $c2f83d7c13f283fd$var$stopWatchingForValueChange();
}
function $c2f83d7c13f283fd$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c2f83d7c13f283fd$var$getInstIfValueChanged($c2f83d7c13f283fd$var$activeElementInst$1);
}
function $c2f83d7c13f283fd$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c2f83d7c13f283fd$var$getInstIfValueChanged(targetInst);
}
function $c2f83d7c13f283fd$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c2f83d7c13f283fd$var$getInstIfValueChanged(targetInst);
}
function $c2f83d7c13f283fd$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c2f83d7c13f283fd$var$objectIs = "function" === typeof Object.is ? Object.is : $c2f83d7c13f283fd$var$is;
function $c2f83d7c13f283fd$var$shallowEqual(objA, objB) {
    if ($c2f83d7c13f283fd$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $4TMho._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $4TMho._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c2f83d7c13f283fd$var$hasOwnProperty.call(objB, currentKey) || !$c2f83d7c13f283fd$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c2f83d7c13f283fd$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c2f83d7c13f283fd$var$getNodeForCharacterOffset(root, offset) {
    var node = $c2f83d7c13f283fd$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c2f83d7c13f283fd$var$getLeafNode(node);
    }
}
function $c2f83d7c13f283fd$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c2f83d7c13f283fd$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c2f83d7c13f283fd$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c2f83d7c13f283fd$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c2f83d7c13f283fd$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c2f83d7c13f283fd$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $c2f83d7c13f283fd$var$skipSelectionChangeEvent = $c2f83d7c13f283fd$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c2f83d7c13f283fd$var$activeElement = null, $c2f83d7c13f283fd$var$activeElementInst = null, $c2f83d7c13f283fd$var$lastSelection = null, $c2f83d7c13f283fd$var$mouseDown = !1;
function $c2f83d7c13f283fd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c2f83d7c13f283fd$var$mouseDown || null == $c2f83d7c13f283fd$var$activeElement || $c2f83d7c13f283fd$var$activeElement !== $c2f83d7c13f283fd$var$getActiveElement(doc) || (doc = $c2f83d7c13f283fd$var$activeElement, "selectionStart" in doc && $c2f83d7c13f283fd$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c2f83d7c13f283fd$var$lastSelection && $c2f83d7c13f283fd$var$shallowEqual($c2f83d7c13f283fd$var$lastSelection, doc) || ($c2f83d7c13f283fd$var$lastSelection = doc, doc = $c2f83d7c13f283fd$var$accumulateTwoPhaseListeners($c2f83d7c13f283fd$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c2f83d7c13f283fd$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c2f83d7c13f283fd$var$activeElement)));
}
function $c2f83d7c13f283fd$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c2f83d7c13f283fd$var$vendorPrefixes = {
    animationend: $c2f83d7c13f283fd$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c2f83d7c13f283fd$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c2f83d7c13f283fd$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c2f83d7c13f283fd$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c2f83d7c13f283fd$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c2f83d7c13f283fd$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c2f83d7c13f283fd$var$makePrefixMap("Transition", "TransitionEnd")
}, $c2f83d7c13f283fd$var$prefixedEventNames = {}, $c2f83d7c13f283fd$var$style = {};
$c2f83d7c13f283fd$var$canUseDOM && ($c2f83d7c13f283fd$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c2f83d7c13f283fd$var$vendorPrefixes.animationend.animation, delete $c2f83d7c13f283fd$var$vendorPrefixes.animationiteration.animation, delete $c2f83d7c13f283fd$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c2f83d7c13f283fd$var$vendorPrefixes.transitionend.transition);
function $c2f83d7c13f283fd$var$getVendorPrefixedEventName(eventName) {
    if ($c2f83d7c13f283fd$var$prefixedEventNames[eventName]) return $c2f83d7c13f283fd$var$prefixedEventNames[eventName];
    if (!$c2f83d7c13f283fd$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c2f83d7c13f283fd$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c2f83d7c13f283fd$var$style) return $c2f83d7c13f283fd$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c2f83d7c13f283fd$var$ANIMATION_END = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("animationend"), $c2f83d7c13f283fd$var$ANIMATION_ITERATION = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("animationiteration"), $c2f83d7c13f283fd$var$ANIMATION_START = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("animationstart"), $c2f83d7c13f283fd$var$TRANSITION_RUN = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("transitionrun"), $c2f83d7c13f283fd$var$TRANSITION_START = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("transitionstart"), $c2f83d7c13f283fd$var$TRANSITION_CANCEL = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("transitioncancel"), $c2f83d7c13f283fd$var$TRANSITION_END = $c2f83d7c13f283fd$var$getVendorPrefixedEventName("transitionend"), $c2f83d7c13f283fd$var$topLevelEventsToReactNames = new Map(), $c2f83d7c13f283fd$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$c2f83d7c13f283fd$var$simpleEventPluginEvents.push("scrollEnd");
function $c2f83d7c13f283fd$var$registerSimpleEvent(domEventName, reactName) {
    $c2f83d7c13f283fd$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c2f83d7c13f283fd$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c2f83d7c13f283fd$var$CapturedStacks = new WeakMap();
function $c2f83d7c13f283fd$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) && null !== value) {
        var existing = $c2f83d7c13f283fd$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c2f83d7c13f283fd$var$getStackByFiberInDevAndProd(source)
        };
        $c2f83d7c13f283fd$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c2f83d7c13f283fd$var$getStackByFiberInDevAndProd(source)
    };
}
var $c2f83d7c13f283fd$var$concurrentQueues = [], $c2f83d7c13f283fd$var$concurrentQueuesIndex = 0, $c2f83d7c13f283fd$var$concurrentlyUpdatedLanes = 0;
function $c2f83d7c13f283fd$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c2f83d7c13f283fd$var$concurrentQueuesIndex, i = $c2f83d7c13f283fd$var$concurrentlyUpdatedLanes = $c2f83d7c13f283fd$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c2f83d7c13f283fd$var$concurrentQueues[i];
        $c2f83d7c13f283fd$var$concurrentQueues[i++] = null;
        var queue = $c2f83d7c13f283fd$var$concurrentQueues[i];
        $c2f83d7c13f283fd$var$concurrentQueues[i++] = null;
        var update = $c2f83d7c13f283fd$var$concurrentQueues[i];
        $c2f83d7c13f283fd$var$concurrentQueues[i++] = null;
        var lane = $c2f83d7c13f283fd$var$concurrentQueues[i];
        $c2f83d7c13f283fd$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c2f83d7c13f283fd$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c2f83d7c13f283fd$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c2f83d7c13f283fd$var$concurrentQueues[$c2f83d7c13f283fd$var$concurrentQueuesIndex++] = fiber;
    $c2f83d7c13f283fd$var$concurrentQueues[$c2f83d7c13f283fd$var$concurrentQueuesIndex++] = queue;
    $c2f83d7c13f283fd$var$concurrentQueues[$c2f83d7c13f283fd$var$concurrentQueuesIndex++] = update;
    $c2f83d7c13f283fd$var$concurrentQueues[$c2f83d7c13f283fd$var$concurrentQueuesIndex++] = lane;
    $c2f83d7c13f283fd$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c2f83d7c13f283fd$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c2f83d7c13f283fd$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c2f83d7c13f283fd$var$getRootForUpdatedFiber(fiber);
}
function $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c2f83d7c13f283fd$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c2f83d7c13f283fd$var$getRootForUpdatedFiber(fiber);
}
function $c2f83d7c13f283fd$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $c2f83d7c13f283fd$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $c2f83d7c13f283fd$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c2f83d7c13f283fd$var$nestedUpdateCount) throw $c2f83d7c13f283fd$var$nestedUpdateCount = 0, $c2f83d7c13f283fd$var$rootWithNestedUpdates = null, Error($c2f83d7c13f283fd$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c2f83d7c13f283fd$var$emptyContextObject = {};
function $c2f83d7c13f283fd$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c2f83d7c13f283fd$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c2f83d7c13f283fd$var$FiberNode(tag, pendingProps, key, mode);
}
function $c2f83d7c13f283fd$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c2f83d7c13f283fd$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c2f83d7c13f283fd$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c2f83d7c13f283fd$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c2f83d7c13f283fd$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c2f83d7c13f283fd$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c2f83d7c13f283fd$var$isHostHoistableType(type, pendingProps, $c2f83d7c13f283fd$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c2f83d7c13f283fd$var$REACT_ACTIVITY_TYPE:
            return type = $c2f83d7c13f283fd$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $c2f83d7c13f283fd$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE:
            return $c2f83d7c13f283fd$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c2f83d7c13f283fd$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c2f83d7c13f283fd$var$REACT_PROFILER_TYPE:
            return type = $c2f83d7c13f283fd$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c2f83d7c13f283fd$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c2f83d7c13f283fd$var$REACT_SUSPENSE_TYPE:
            return type = $c2f83d7c13f283fd$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c2f83d7c13f283fd$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c2f83d7c13f283fd$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c2f83d7c13f283fd$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c2f83d7c13f283fd$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $4TMho._)(type)) && null !== type) switch(type.$$typeof){
                case $c2f83d7c13f283fd$var$REACT_PROVIDER_TYPE:
                case $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c2f83d7c13f283fd$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c2f83d7c13f283fd$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c2f83d7c13f283fd$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c2f83d7c13f283fd$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $4TMho._)(type), ""));
            owner = null;
    }
    key = $c2f83d7c13f283fd$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c2f83d7c13f283fd$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c2f83d7c13f283fd$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c2f83d7c13f283fd$var$createFiberFromText(content, mode, lanes) {
    content = $c2f83d7c13f283fd$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c2f83d7c13f283fd$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c2f83d7c13f283fd$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $c2f83d7c13f283fd$var$forkStack = [], $c2f83d7c13f283fd$var$forkStackIndex = 0, $c2f83d7c13f283fd$var$treeForkProvider = null, $c2f83d7c13f283fd$var$treeForkCount = 0, $c2f83d7c13f283fd$var$idStack = [], $c2f83d7c13f283fd$var$idStackIndex = 0, $c2f83d7c13f283fd$var$treeContextProvider = null, $c2f83d7c13f283fd$var$treeContextId = 1, $c2f83d7c13f283fd$var$treeContextOverflow = "";
function $c2f83d7c13f283fd$var$pushTreeFork(workInProgress, totalChildren) {
    $c2f83d7c13f283fd$var$forkStack[$c2f83d7c13f283fd$var$forkStackIndex++] = $c2f83d7c13f283fd$var$treeForkCount;
    $c2f83d7c13f283fd$var$forkStack[$c2f83d7c13f283fd$var$forkStackIndex++] = $c2f83d7c13f283fd$var$treeForkProvider;
    $c2f83d7c13f283fd$var$treeForkProvider = workInProgress;
    $c2f83d7c13f283fd$var$treeForkCount = totalChildren;
}
function $c2f83d7c13f283fd$var$pushTreeId(workInProgress, totalChildren, index) {
    $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex++] = $c2f83d7c13f283fd$var$treeContextId;
    $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex++] = $c2f83d7c13f283fd$var$treeContextOverflow;
    $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex++] = $c2f83d7c13f283fd$var$treeContextProvider;
    $c2f83d7c13f283fd$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c2f83d7c13f283fd$var$treeContextId;
    workInProgress = $c2f83d7c13f283fd$var$treeContextOverflow;
    var baseLength = 32 - $c2f83d7c13f283fd$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c2f83d7c13f283fd$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c2f83d7c13f283fd$var$treeContextId = 1 << 32 - $c2f83d7c13f283fd$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c2f83d7c13f283fd$var$treeContextOverflow = length + workInProgress;
    } else $c2f83d7c13f283fd$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c2f83d7c13f283fd$var$treeContextOverflow = workInProgress;
}
function $c2f83d7c13f283fd$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c2f83d7c13f283fd$var$pushTreeFork(workInProgress, 1), $c2f83d7c13f283fd$var$pushTreeId(workInProgress, 1, 0));
}
function $c2f83d7c13f283fd$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c2f83d7c13f283fd$var$treeForkProvider;)$c2f83d7c13f283fd$var$treeForkProvider = $c2f83d7c13f283fd$var$forkStack[--$c2f83d7c13f283fd$var$forkStackIndex], $c2f83d7c13f283fd$var$forkStack[$c2f83d7c13f283fd$var$forkStackIndex] = null, $c2f83d7c13f283fd$var$treeForkCount = $c2f83d7c13f283fd$var$forkStack[--$c2f83d7c13f283fd$var$forkStackIndex], $c2f83d7c13f283fd$var$forkStack[$c2f83d7c13f283fd$var$forkStackIndex] = null;
    for(; workInProgress === $c2f83d7c13f283fd$var$treeContextProvider;)$c2f83d7c13f283fd$var$treeContextProvider = $c2f83d7c13f283fd$var$idStack[--$c2f83d7c13f283fd$var$idStackIndex], $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex] = null, $c2f83d7c13f283fd$var$treeContextOverflow = $c2f83d7c13f283fd$var$idStack[--$c2f83d7c13f283fd$var$idStackIndex], $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex] = null, $c2f83d7c13f283fd$var$treeContextId = $c2f83d7c13f283fd$var$idStack[--$c2f83d7c13f283fd$var$idStackIndex], $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex] = null;
}
var $c2f83d7c13f283fd$var$hydrationParentFiber = null, $c2f83d7c13f283fd$var$nextHydratableInstance = null, $c2f83d7c13f283fd$var$isHydrating = !1, $c2f83d7c13f283fd$var$hydrationErrors = null, $c2f83d7c13f283fd$var$rootOrSingletonContext = !1, $c2f83d7c13f283fd$var$HydrationMismatchException = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(519));
function $c2f83d7c13f283fd$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(418, ""));
    $c2f83d7c13f283fd$var$queueHydrationError($c2f83d7c13f283fd$var$createCapturedValueAtFiber(error, fiber));
    throw $c2f83d7c13f283fd$var$HydrationMismatchException;
}
function $c2f83d7c13f283fd$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c2f83d7c13f283fd$var$internalInstanceKey] = fiber;
    instance[$c2f83d7c13f283fd$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("cancel", instance);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c2f83d7c13f283fd$var$mediaEventTypes.length; type++)$c2f83d7c13f283fd$var$listenToNonDelegatedEvent($c2f83d7c13f283fd$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("error", instance);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("invalid", instance);
            $c2f83d7c13f283fd$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $c2f83d7c13f283fd$var$track(instance);
            break;
        case "select":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("invalid", instance), $c2f83d7c13f283fd$var$initTextarea(instance, props.value, props.defaultValue, props.children), $c2f83d7c13f283fd$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $4TMho._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c2f83d7c13f283fd$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c2f83d7c13f283fd$var$listenToNonDelegatedEvent("beforetoggle", instance), $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c2f83d7c13f283fd$var$noop$1), instance = !0) : instance = !1;
    instance || $c2f83d7c13f283fd$var$throwOnHydrationMismatch(fiber);
}
function $c2f83d7c13f283fd$var$popToNextHostParent(fiber) {
    for($c2f83d7c13f283fd$var$hydrationParentFiber = fiber.return; $c2f83d7c13f283fd$var$hydrationParentFiber;)switch($c2f83d7c13f283fd$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $c2f83d7c13f283fd$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $c2f83d7c13f283fd$var$rootOrSingletonContext = !0;
            return;
        default:
            $c2f83d7c13f283fd$var$hydrationParentFiber = $c2f83d7c13f283fd$var$hydrationParentFiber.return;
    }
}
function $c2f83d7c13f283fd$var$popHydrationState(fiber) {
    if (fiber !== $c2f83d7c13f283fd$var$hydrationParentFiber) return !1;
    if (!$c2f83d7c13f283fd$var$isHydrating) return $c2f83d7c13f283fd$var$popToNextHostParent(fiber), $c2f83d7c13f283fd$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c2f83d7c13f283fd$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $c2f83d7c13f283fd$var$nextHydratableInstance && $c2f83d7c13f283fd$var$throwOnHydrationMismatch(fiber);
    $c2f83d7c13f283fd$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $c2f83d7c13f283fd$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $c2f83d7c13f283fd$var$nextHydratableInstance, $c2f83d7c13f283fd$var$isSingletonScope(fiber.type) ? (fiber = $c2f83d7c13f283fd$var$previousHydratableOnEnteringScopedSingleton, $c2f83d7c13f283fd$var$previousHydratableOnEnteringScopedSingleton = null, $c2f83d7c13f283fd$var$nextHydratableInstance = fiber) : $c2f83d7c13f283fd$var$nextHydratableInstance = tag) : $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$hydrationParentFiber ? $c2f83d7c13f283fd$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c2f83d7c13f283fd$var$resetHydrationState() {
    $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$hydrationParentFiber = null;
    $c2f83d7c13f283fd$var$isHydrating = !1;
}
function $c2f83d7c13f283fd$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $c2f83d7c13f283fd$var$hydrationErrors;
    null !== queuedErrors && (null === $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors ? $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors = queuedErrors : $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors.push.apply($c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors, queuedErrors), $c2f83d7c13f283fd$var$hydrationErrors = null);
    return queuedErrors;
}
function $c2f83d7c13f283fd$var$queueHydrationError(error) {
    null === $c2f83d7c13f283fd$var$hydrationErrors ? $c2f83d7c13f283fd$var$hydrationErrors = [
        error
    ] : $c2f83d7c13f283fd$var$hydrationErrors.push(error);
}
var $c2f83d7c13f283fd$var$valueCursor = $c2f83d7c13f283fd$var$createCursor(null), $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 = null, $c2f83d7c13f283fd$var$lastContextDependency = null;
function $c2f83d7c13f283fd$var$pushProvider(providerFiber, context, nextValue) {
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c2f83d7c13f283fd$var$popProvider(context) {
    context._currentValue = $c2f83d7c13f283fd$var$valueCursor.current;
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$valueCursor);
}
function $c2f83d7c13f283fd$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c2f83d7c13f283fd$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c2f83d7c13f283fd$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c2f83d7c13f283fd$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c2f83d7c13f283fd$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c2f83d7c13f283fd$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c2f83d7c13f283fd$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c2f83d7c13f283fd$var$HostTransitionContext) : current = [
                $c2f83d7c13f283fd$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c2f83d7c13f283fd$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c2f83d7c13f283fd$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c2f83d7c13f283fd$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress) {
    $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 = workInProgress;
    $c2f83d7c13f283fd$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c2f83d7c13f283fd$var$readContext(context) {
    return $c2f83d7c13f283fd$var$readContextForConsumer($c2f83d7c13f283fd$var$currentlyRenderingFiber$1, context);
}
function $c2f83d7c13f283fd$var$readContextDuringReconciliation(consumer, context) {
    null === $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 && $c2f83d7c13f283fd$var$prepareToReadContext(consumer);
    return $c2f83d7c13f283fd$var$readContextForConsumer(consumer, context);
}
function $c2f83d7c13f283fd$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c2f83d7c13f283fd$var$lastContextDependency) {
        if (null === consumer) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(308));
        $c2f83d7c13f283fd$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c2f83d7c13f283fd$var$lastContextDependency = $c2f83d7c13f283fd$var$lastContextDependency.next = context;
    return value;
}
var $c2f83d7c13f283fd$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c2f83d7c13f283fd$var$scheduleCallback$2 = $kCnPN.unstable_scheduleCallback, $c2f83d7c13f283fd$var$NormalPriority = $kCnPN.unstable_NormalPriority, $c2f83d7c13f283fd$var$CacheContext = {
    $$typeof: $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c2f83d7c13f283fd$var$createCache() {
    return {
        controller: new $c2f83d7c13f283fd$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c2f83d7c13f283fd$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c2f83d7c13f283fd$var$scheduleCallback$2($c2f83d7c13f283fd$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c2f83d7c13f283fd$var$currentEntangledListeners = null, $c2f83d7c13f283fd$var$currentEntangledPendingCount = 0, $c2f83d7c13f283fd$var$currentEntangledLane = 0, $c2f83d7c13f283fd$var$currentEntangledActionThenable = null;
function $c2f83d7c13f283fd$var$entangleAsyncAction(transition, thenable) {
    if (null === $c2f83d7c13f283fd$var$currentEntangledListeners) {
        var entangledListeners = $c2f83d7c13f283fd$var$currentEntangledListeners = [];
        $c2f83d7c13f283fd$var$currentEntangledPendingCount = 0;
        $c2f83d7c13f283fd$var$currentEntangledLane = $c2f83d7c13f283fd$var$requestTransitionLane();
        $c2f83d7c13f283fd$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c2f83d7c13f283fd$var$currentEntangledPendingCount++;
    thenable.then($c2f83d7c13f283fd$var$pingEngtangledActionScope, $c2f83d7c13f283fd$var$pingEngtangledActionScope);
    return thenable;
}
function $c2f83d7c13f283fd$var$pingEngtangledActionScope() {
    if (0 === --$c2f83d7c13f283fd$var$currentEntangledPendingCount && null !== $c2f83d7c13f283fd$var$currentEntangledListeners) {
        null !== $c2f83d7c13f283fd$var$currentEntangledActionThenable && ($c2f83d7c13f283fd$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c2f83d7c13f283fd$var$currentEntangledListeners;
        $c2f83d7c13f283fd$var$currentEntangledListeners = null;
        $c2f83d7c13f283fd$var$currentEntangledLane = 0;
        $c2f83d7c13f283fd$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c2f83d7c13f283fd$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c2f83d7c13f283fd$var$prevOnStartTransitionFinish = $c2f83d7c13f283fd$var$ReactSharedInternals.S;
$c2f83d7c13f283fd$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $4TMho._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $c2f83d7c13f283fd$var$entangleAsyncAction(transition, returnValue);
    null !== $c2f83d7c13f283fd$var$prevOnStartTransitionFinish && $c2f83d7c13f283fd$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c2f83d7c13f283fd$var$resumedCache = $c2f83d7c13f283fd$var$createCursor(null);
function $c2f83d7c13f283fd$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c2f83d7c13f283fd$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c2f83d7c13f283fd$var$workInProgressRoot.pooledCache;
}
function $c2f83d7c13f283fd$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$resumedCache, $c2f83d7c13f283fd$var$resumedCache.current) : $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$resumedCache, prevCachePool.pool);
}
function $c2f83d7c13f283fd$var$getSuspendedCache() {
    var cacheFromPool = $c2f83d7c13f283fd$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c2f83d7c13f283fd$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c2f83d7c13f283fd$var$SuspenseException = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(460)), $c2f83d7c13f283fd$var$SuspenseyCommitException = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(474)), $c2f83d7c13f283fd$var$SuspenseActionException = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(542)), $c2f83d7c13f283fd$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $c2f83d7c13f283fd$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c2f83d7c13f283fd$var$noop$3() {}
function $c2f83d7c13f283fd$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c2f83d7c13f283fd$var$noop$3, $c2f83d7c13f283fd$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $c2f83d7c13f283fd$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c2f83d7c13f283fd$var$noop$3, $c2f83d7c13f283fd$var$noop$3);
            else {
                thenableState = $c2f83d7c13f283fd$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $c2f83d7c13f283fd$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $c2f83d7c13f283fd$var$suspendedThenable = thenable;
            throw $c2f83d7c13f283fd$var$SuspenseException;
    }
}
var $c2f83d7c13f283fd$var$suspendedThenable = null;
function $c2f83d7c13f283fd$var$getSuspendedThenable() {
    if (null === $c2f83d7c13f283fd$var$suspendedThenable) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(459));
    var thenable = $c2f83d7c13f283fd$var$suspendedThenable;
    $c2f83d7c13f283fd$var$suspendedThenable = null;
    return thenable;
}
function $c2f83d7c13f283fd$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $c2f83d7c13f283fd$var$SuspenseException || rejectedReason === $c2f83d7c13f283fd$var$SuspenseActionException) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(483));
}
var $c2f83d7c13f283fd$var$hasForceUpdate = !1;
function $c2f83d7c13f283fd$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c2f83d7c13f283fd$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c2f83d7c13f283fd$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c2f83d7c13f283fd$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c2f83d7c13f283fd$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c2f83d7c13f283fd$var$getRootForUpdatedFiber(fiber);
        $c2f83d7c13f283fd$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c2f83d7c13f283fd$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c2f83d7c13f283fd$var$getRootForUpdatedFiber(fiber);
}
function $c2f83d7c13f283fd$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c2f83d7c13f283fd$var$markRootEntangled(root, lane);
    }
}
function $c2f83d7c13f283fd$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c2f83d7c13f283fd$var$didReadFromEntangledAsyncAction = !1;
function $c2f83d7c13f283fd$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c2f83d7c13f283fd$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c2f83d7c13f283fd$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c2f83d7c13f283fd$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c2f83d7c13f283fd$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c2f83d7c13f283fd$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c2f83d7c13f283fd$var$currentEntangledLane && ($c2f83d7c13f283fd$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c2f83d7c13f283fd$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c2f83d7c13f283fd$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c2f83d7c13f283fd$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c2f83d7c13f283fd$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c2f83d7c13f283fd$var$callCallback(callbacks[updateQueue], context);
}
var $c2f83d7c13f283fd$var$currentTreeHiddenStackCursor = $c2f83d7c13f283fd$var$createCursor(null), $c2f83d7c13f283fd$var$prevEntangledRenderLanesCursor = $c2f83d7c13f283fd$var$createCursor(0);
function $c2f83d7c13f283fd$var$pushHiddenContext(fiber, context) {
    fiber = $c2f83d7c13f283fd$var$entangledRenderLanes;
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$prevEntangledRenderLanesCursor, fiber);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$currentTreeHiddenStackCursor, context);
    $c2f83d7c13f283fd$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c2f83d7c13f283fd$var$reuseHiddenContextOnStack() {
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$prevEntangledRenderLanesCursor, $c2f83d7c13f283fd$var$entangledRenderLanes);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$currentTreeHiddenStackCursor, $c2f83d7c13f283fd$var$currentTreeHiddenStackCursor.current);
}
function $c2f83d7c13f283fd$var$popHiddenContext() {
    $c2f83d7c13f283fd$var$entangledRenderLanes = $c2f83d7c13f283fd$var$prevEntangledRenderLanesCursor.current;
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$currentTreeHiddenStackCursor);
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$prevEntangledRenderLanesCursor);
}
var $c2f83d7c13f283fd$var$renderLanes = 0, $c2f83d7c13f283fd$var$currentlyRenderingFiber = null, $c2f83d7c13f283fd$var$currentHook = null, $c2f83d7c13f283fd$var$workInProgressHook = null, $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdate = !1, $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c2f83d7c13f283fd$var$localIdCounter = 0, $c2f83d7c13f283fd$var$thenableIndexCounter$1 = 0, $c2f83d7c13f283fd$var$thenableState$1 = null, $c2f83d7c13f283fd$var$globalClientIdCounter = 0;
function $c2f83d7c13f283fd$var$throwInvalidHookError() {
    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(321));
}
function $c2f83d7c13f283fd$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c2f83d7c13f283fd$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c2f83d7c13f283fd$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c2f83d7c13f283fd$var$renderLanes = nextRenderLanes;
    $c2f83d7c13f283fd$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c2f83d7c13f283fd$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c2f83d7c13f283fd$var$HooksDispatcherOnMount : $c2f83d7c13f283fd$var$HooksDispatcherOnUpdate;
    $c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c2f83d7c13f283fd$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c2f83d7c13f283fd$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c2f83d7c13f283fd$var$finishRenderingHooks(current) {
    $c2f83d7c13f283fd$var$ReactSharedInternals.H = $c2f83d7c13f283fd$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c2f83d7c13f283fd$var$currentHook && null !== $c2f83d7c13f283fd$var$currentHook.next;
    $c2f83d7c13f283fd$var$renderLanes = 0;
    $c2f83d7c13f283fd$var$workInProgressHook = $c2f83d7c13f283fd$var$currentHook = $c2f83d7c13f283fd$var$currentlyRenderingFiber = null;
    $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdate = !1;
    $c2f83d7c13f283fd$var$thenableIndexCounter$1 = 0;
    $c2f83d7c13f283fd$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(300));
    null === current || $c2f83d7c13f283fd$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c2f83d7c13f283fd$var$checkIfContextChanged(current) && ($c2f83d7c13f283fd$var$didReceiveUpdate = !0));
}
function $c2f83d7c13f283fd$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c2f83d7c13f283fd$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c2f83d7c13f283fd$var$thenableState$1 = null);
        $c2f83d7c13f283fd$var$thenableIndexCounter$1 = 0;
        $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c2f83d7c13f283fd$var$workInProgressHook = $c2f83d7c13f283fd$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c2f83d7c13f283fd$var$ReactSharedInternals.H = $c2f83d7c13f283fd$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c2f83d7c13f283fd$var$TransitionAwareHostComponent() {
    var dispatcher = $c2f83d7c13f283fd$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c2f83d7c13f283fd$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c2f83d7c13f283fd$var$currentHook ? $c2f83d7c13f283fd$var$currentHook.memoizedState : null) !== dispatcher && ($c2f83d7c13f283fd$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $c2f83d7c13f283fd$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c2f83d7c13f283fd$var$localIdCounter;
    $c2f83d7c13f283fd$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c2f83d7c13f283fd$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c2f83d7c13f283fd$var$resetHooksOnUnwind(workInProgress) {
    if ($c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c2f83d7c13f283fd$var$renderLanes = 0;
    $c2f83d7c13f283fd$var$workInProgressHook = $c2f83d7c13f283fd$var$currentHook = $c2f83d7c13f283fd$var$currentlyRenderingFiber = null;
    $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c2f83d7c13f283fd$var$thenableIndexCounter$1 = $c2f83d7c13f283fd$var$localIdCounter = 0;
    $c2f83d7c13f283fd$var$thenableState$1 = null;
}
function $c2f83d7c13f283fd$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c2f83d7c13f283fd$var$workInProgressHook ? $c2f83d7c13f283fd$var$currentlyRenderingFiber.memoizedState = $c2f83d7c13f283fd$var$workInProgressHook = hook : $c2f83d7c13f283fd$var$workInProgressHook = $c2f83d7c13f283fd$var$workInProgressHook.next = hook;
    return $c2f83d7c13f283fd$var$workInProgressHook;
}
function $c2f83d7c13f283fd$var$updateWorkInProgressHook() {
    if (null === $c2f83d7c13f283fd$var$currentHook) {
        var nextCurrentHook = $c2f83d7c13f283fd$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c2f83d7c13f283fd$var$currentHook.next;
    var nextWorkInProgressHook = null === $c2f83d7c13f283fd$var$workInProgressHook ? $c2f83d7c13f283fd$var$currentlyRenderingFiber.memoizedState : $c2f83d7c13f283fd$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c2f83d7c13f283fd$var$workInProgressHook = nextWorkInProgressHook, $c2f83d7c13f283fd$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c2f83d7c13f283fd$var$currentlyRenderingFiber.alternate) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(467));
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(310));
        }
        $c2f83d7c13f283fd$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c2f83d7c13f283fd$var$currentHook.memoizedState,
            baseState: $c2f83d7c13f283fd$var$currentHook.baseState,
            baseQueue: $c2f83d7c13f283fd$var$currentHook.baseQueue,
            queue: $c2f83d7c13f283fd$var$currentHook.queue,
            next: null
        };
        null === $c2f83d7c13f283fd$var$workInProgressHook ? $c2f83d7c13f283fd$var$currentlyRenderingFiber.memoizedState = $c2f83d7c13f283fd$var$workInProgressHook = nextCurrentHook : $c2f83d7c13f283fd$var$workInProgressHook = $c2f83d7c13f283fd$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c2f83d7c13f283fd$var$workInProgressHook;
}
function $c2f83d7c13f283fd$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $c2f83d7c13f283fd$var$useThenable(thenable) {
    var index = $c2f83d7c13f283fd$var$thenableIndexCounter$1;
    $c2f83d7c13f283fd$var$thenableIndexCounter$1 += 1;
    null === $c2f83d7c13f283fd$var$thenableState$1 && ($c2f83d7c13f283fd$var$thenableState$1 = []);
    thenable = $c2f83d7c13f283fd$var$trackUsedThenable($c2f83d7c13f283fd$var$thenableState$1, thenable, index);
    index = $c2f83d7c13f283fd$var$currentlyRenderingFiber;
    null === (null === $c2f83d7c13f283fd$var$workInProgressHook ? index.memoizedState : $c2f83d7c13f283fd$var$workInProgressHook.next) && (index = index.alternate, $c2f83d7c13f283fd$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c2f83d7c13f283fd$var$HooksDispatcherOnMount : $c2f83d7c13f283fd$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c2f83d7c13f283fd$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $4TMho._)(usable))) {
        if ("function" === typeof usable.then) return $c2f83d7c13f283fd$var$useThenable(usable);
        if (usable.$$typeof === $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE) return $c2f83d7c13f283fd$var$readContext(usable);
    }
    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(438, String(usable)));
}
function $c2f83d7c13f283fd$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c2f83d7c13f283fd$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c2f83d7c13f283fd$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c2f83d7c13f283fd$var$createFunctionComponentUpdateQueue(), $c2f83d7c13f283fd$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c2f83d7c13f283fd$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c2f83d7c13f283fd$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c2f83d7c13f283fd$var$updateReducer(reducer) {
    var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    return $c2f83d7c13f283fd$var$updateReducerImpl(hook, $c2f83d7c13f283fd$var$currentHook, reducer);
}
function $c2f83d7c13f283fd$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c2f83d7c13f283fd$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c2f83d7c13f283fd$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($c2f83d7c13f283fd$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c2f83d7c13f283fd$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c2f83d7c13f283fd$var$currentlyRenderingFiber.lanes |= revertLane, $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c2f83d7c13f283fd$var$currentlyRenderingFiber.lanes |= updateLane, $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c2f83d7c13f283fd$var$objectIs(pendingQueue, hook.memoizedState) && ($c2f83d7c13f283fd$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $c2f83d7c13f283fd$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c2f83d7c13f283fd$var$rerenderReducer(reducer) {
    var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c2f83d7c13f283fd$var$objectIs(newState, hook.memoizedState) || ($c2f83d7c13f283fd$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c2f83d7c13f283fd$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c2f83d7c13f283fd$var$currentlyRenderingFiber, hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c2f83d7c13f283fd$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c2f83d7c13f283fd$var$objectIs(($c2f83d7c13f283fd$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c2f83d7c13f283fd$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $c2f83d7c13f283fd$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $c2f83d7c13f283fd$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c2f83d7c13f283fd$var$workInProgressHook && $c2f83d7c13f283fd$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c2f83d7c13f283fd$var$pushSimpleEffect(9, $c2f83d7c13f283fd$var$createEffectInstance(), $c2f83d7c13f283fd$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $c2f83d7c13f283fd$var$workInProgressRoot) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c2f83d7c13f283fd$var$renderLanes & 124) || $c2f83d7c13f283fd$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c2f83d7c13f283fd$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c2f83d7c13f283fd$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $c2f83d7c13f283fd$var$createFunctionComponentUpdateQueue(), $c2f83d7c13f283fd$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c2f83d7c13f283fd$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c2f83d7c13f283fd$var$checkIfSnapshotChanged(inst) && $c2f83d7c13f283fd$var$forceStoreRerender(fiber);
}
function $c2f83d7c13f283fd$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c2f83d7c13f283fd$var$checkIfSnapshotChanged(inst) && $c2f83d7c13f283fd$var$forceStoreRerender(fiber);
    });
}
function $c2f83d7c13f283fd$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c2f83d7c13f283fd$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c2f83d7c13f283fd$var$forceStoreRerender(fiber) {
    var root = $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c2f83d7c13f283fd$var$mountStateImpl(initialState) {
    var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2f83d7c13f283fd$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c2f83d7c13f283fd$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c2f83d7c13f283fd$var$updateReducerImpl(hook, $c2f83d7c13f283fd$var$currentHook, "function" === typeof reducer ? reducer : $c2f83d7c13f283fd$var$basicStateReducer);
}
function $c2f83d7c13f283fd$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c2f83d7c13f283fd$var$isRenderPhaseUpdate(fiber)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c2f83d7c13f283fd$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c2f83d7c13f283fd$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c2f83d7c13f283fd$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c2f83d7c13f283fd$var$ReactSharedInternals.T, currentTransition = {};
        $c2f83d7c13f283fd$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c2f83d7c13f283fd$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c2f83d7c13f283fd$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c2f83d7c13f283fd$var$onActionError(actionQueue, node, error);
        } finally{
            $c2f83d7c13f283fd$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c2f83d7c13f283fd$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $c2f83d7c13f283fd$var$onActionError(actionQueue, node, error$38);
    }
}
function $c2f83d7c13f283fd$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $4TMho._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c2f83d7c13f283fd$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c2f83d7c13f283fd$var$onActionError(actionQueue, node, error);
    }) : $c2f83d7c13f283fd$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c2f83d7c13f283fd$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c2f83d7c13f283fd$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c2f83d7c13f283fd$var$runActionStateAction(actionQueue, nextState)));
}
function $c2f83d7c13f283fd$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c2f83d7c13f283fd$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c2f83d7c13f283fd$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c2f83d7c13f283fd$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c2f83d7c13f283fd$var$mountActionState(action, initialStateProp) {
    if ($c2f83d7c13f283fd$var$isHydrating) {
        var ssrFormState = $c2f83d7c13f283fd$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c2f83d7c13f283fd$var$currentlyRenderingFiber;
                if ($c2f83d7c13f283fd$var$isHydrating) {
                    if ($c2f83d7c13f283fd$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c2f83d7c13f283fd$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c2f83d7c13f283fd$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c2f83d7c13f283fd$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c2f83d7c13f283fd$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2f83d7c13f283fd$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c2f83d7c13f283fd$var$dispatchSetState.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c2f83d7c13f283fd$var$mountStateImpl(!1);
    inRootOrSingleton = $c2f83d7c13f283fd$var$dispatchOptimisticSetState.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c2f83d7c13f283fd$var$dispatchActionState.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c2f83d7c13f283fd$var$updateActionState(action) {
    var stateHook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    return $c2f83d7c13f283fd$var$updateActionStateImpl(stateHook, $c2f83d7c13f283fd$var$currentHook, action);
}
function $c2f83d7c13f283fd$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c2f83d7c13f283fd$var$updateReducerImpl(stateHook, currentStateHook, $c2f83d7c13f283fd$var$actionStateReducer)[0];
    stateHook = $c2f83d7c13f283fd$var$updateReducer($c2f83d7c13f283fd$var$basicStateReducer)[0];
    if ("object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $4TMho._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $c2f83d7c13f283fd$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $c2f83d7c13f283fd$var$SuspenseException) throw $c2f83d7c13f283fd$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($c2f83d7c13f283fd$var$currentlyRenderingFiber.flags |= 2048, $c2f83d7c13f283fd$var$pushSimpleEffect(9, $c2f83d7c13f283fd$var$createEffectInstance(), $c2f83d7c13f283fd$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $c2f83d7c13f283fd$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c2f83d7c13f283fd$var$rerenderActionState(action) {
    var stateHook = $c2f83d7c13f283fd$var$updateWorkInProgressHook(), currentStateHook = $c2f83d7c13f283fd$var$currentHook;
    if (null !== currentStateHook) return $c2f83d7c13f283fd$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c2f83d7c13f283fd$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $c2f83d7c13f283fd$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $c2f83d7c13f283fd$var$createFunctionComponentUpdateQueue(), $c2f83d7c13f283fd$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $c2f83d7c13f283fd$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $c2f83d7c13f283fd$var$updateRef() {
    return $c2f83d7c13f283fd$var$updateWorkInProgressHook().memoizedState;
}
function $c2f83d7c13f283fd$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $c2f83d7c13f283fd$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $c2f83d7c13f283fd$var$pushSimpleEffect(1 | hookFlags, $c2f83d7c13f283fd$var$createEffectInstance(), create, createDeps);
}
function $c2f83d7c13f283fd$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c2f83d7c13f283fd$var$currentHook && null !== deps && $c2f83d7c13f283fd$var$areHookInputsEqual(deps, $c2f83d7c13f283fd$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c2f83d7c13f283fd$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($c2f83d7c13f283fd$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $c2f83d7c13f283fd$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $c2f83d7c13f283fd$var$mountEffect(create, createDeps) {
    $c2f83d7c13f283fd$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $c2f83d7c13f283fd$var$updateEffect(create, createDeps) {
    $c2f83d7c13f283fd$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $c2f83d7c13f283fd$var$updateInsertionEffect(create, deps) {
    return $c2f83d7c13f283fd$var$updateEffectImpl(4, 2, create, deps);
}
function $c2f83d7c13f283fd$var$updateLayoutEffect(create, deps) {
    return $c2f83d7c13f283fd$var$updateEffectImpl(4, 4, create, deps);
}
function $c2f83d7c13f283fd$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c2f83d7c13f283fd$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c2f83d7c13f283fd$var$updateEffectImpl(4, 4, $c2f83d7c13f283fd$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c2f83d7c13f283fd$var$mountDebugValue() {}
function $c2f83d7c13f283fd$var$updateCallback(callback, deps) {
    var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c2f83d7c13f283fd$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c2f83d7c13f283fd$var$updateMemo(nextCreate, deps) {
    var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c2f83d7c13f283fd$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c2f83d7c13f283fd$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c2f83d7c13f283fd$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c2f83d7c13f283fd$var$requestDeferredLane();
    $c2f83d7c13f283fd$var$currentlyRenderingFiber.lanes |= hook;
    $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c2f83d7c13f283fd$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c2f83d7c13f283fd$var$objectIs(value, prevValue)) return value;
    if (null !== $c2f83d7c13f283fd$var$currentTreeHiddenStackCursor.current) return hook = $c2f83d7c13f283fd$var$mountDeferredValueImpl(hook, value, initialValue), $c2f83d7c13f283fd$var$objectIs(hook, prevValue) || ($c2f83d7c13f283fd$var$didReceiveUpdate = !0), hook;
    if (0 === ($c2f83d7c13f283fd$var$renderLanes & 42)) return $c2f83d7c13f283fd$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c2f83d7c13f283fd$var$requestDeferredLane();
    $c2f83d7c13f283fd$var$currentlyRenderingFiber.lanes |= hook;
    $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c2f83d7c13f283fd$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
    $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c2f83d7c13f283fd$var$ReactSharedInternals.T, currentTransition = {};
    $c2f83d7c13f283fd$var$ReactSharedInternals.T = currentTransition;
    $c2f83d7c13f283fd$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c2f83d7c13f283fd$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $4TMho._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c2f83d7c13f283fd$var$chainThenableValue(returnValue, finishedState);
            $c2f83d7c13f283fd$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c2f83d7c13f283fd$var$requestUpdateLane(fiber));
        } else $c2f83d7c13f283fd$var$dispatchSetStateInternal(fiber, queue, finishedState, $c2f83d7c13f283fd$var$requestUpdateLane(fiber));
    } catch (error) {
        $c2f83d7c13f283fd$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $c2f83d7c13f283fd$var$requestUpdateLane());
    } finally{
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority, $c2f83d7c13f283fd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2f83d7c13f283fd$var$noop$2() {}
function $c2f83d7c13f283fd$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(476));
    var queue = $c2f83d7c13f283fd$var$ensureFormComponentIsStateful(formFiber).queue;
    $c2f83d7c13f283fd$var$startTransition(formFiber, queue, pendingState, $c2f83d7c13f283fd$var$sharedNotPendingObject, null === action ? $c2f83d7c13f283fd$var$noop$2 : function() {
        $c2f83d7c13f283fd$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c2f83d7c13f283fd$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c2f83d7c13f283fd$var$sharedNotPendingObject,
        baseState: $c2f83d7c13f283fd$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c2f83d7c13f283fd$var$basicStateReducer,
            lastRenderedState: $c2f83d7c13f283fd$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c2f83d7c13f283fd$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c2f83d7c13f283fd$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $c2f83d7c13f283fd$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $c2f83d7c13f283fd$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $c2f83d7c13f283fd$var$requestUpdateLane());
}
function $c2f83d7c13f283fd$var$useHostTransitionStatus() {
    return $c2f83d7c13f283fd$var$readContext($c2f83d7c13f283fd$var$HostTransitionContext);
}
function $c2f83d7c13f283fd$var$updateId() {
    return $c2f83d7c13f283fd$var$updateWorkInProgressHook().memoizedState;
}
function $c2f83d7c13f283fd$var$updateRefresh() {
    return $c2f83d7c13f283fd$var$updateWorkInProgressHook().memoizedState;
}
function $c2f83d7c13f283fd$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c2f83d7c13f283fd$var$requestUpdateLane();
                fiber = $c2f83d7c13f283fd$var$createUpdate(lane);
                var root$41 = $c2f83d7c13f283fd$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($c2f83d7c13f283fd$var$scheduleUpdateOnFiber(root$41, provider, lane), $c2f83d7c13f283fd$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $c2f83d7c13f283fd$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c2f83d7c13f283fd$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c2f83d7c13f283fd$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c2f83d7c13f283fd$var$isRenderPhaseUpdate(fiber) ? $c2f83d7c13f283fd$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c2f83d7c13f283fd$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c2f83d7c13f283fd$var$scheduleUpdateOnFiber(action, fiber, lane), $c2f83d7c13f283fd$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c2f83d7c13f283fd$var$dispatchSetState(fiber, queue, action) {
    var lane = $c2f83d7c13f283fd$var$requestUpdateLane();
    $c2f83d7c13f283fd$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c2f83d7c13f283fd$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2f83d7c13f283fd$var$isRenderPhaseUpdate(fiber)) $c2f83d7c13f283fd$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c2f83d7c13f283fd$var$objectIs(eagerState, currentState)) return $c2f83d7c13f283fd$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c2f83d7c13f283fd$var$workInProgressRoot && $c2f83d7c13f283fd$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c2f83d7c13f283fd$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(action, fiber, lane), $c2f83d7c13f283fd$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c2f83d7c13f283fd$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c2f83d7c13f283fd$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2f83d7c13f283fd$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c2f83d7c13f283fd$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c2f83d7c13f283fd$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c2f83d7c13f283fd$var$currentlyRenderingFiber || null !== alternate && alternate === $c2f83d7c13f283fd$var$currentlyRenderingFiber;
}
function $c2f83d7c13f283fd$var$enqueueRenderPhaseUpdate(queue, update) {
    $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdateDuringThisPass = $c2f83d7c13f283fd$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c2f83d7c13f283fd$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c2f83d7c13f283fd$var$markRootEntangled(root, lane);
    }
}
var $c2f83d7c13f283fd$var$ContextOnlyDispatcher = {
    readContext: $c2f83d7c13f283fd$var$readContext,
    use: $c2f83d7c13f283fd$var$use,
    useCallback: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useContext: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useEffect: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useImperativeHandle: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useLayoutEffect: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useInsertionEffect: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useMemo: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useReducer: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useRef: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useState: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useDebugValue: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useDeferredValue: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useTransition: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useSyncExternalStore: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useId: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useHostTransitionStatus: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useFormState: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useActionState: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useOptimistic: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useMemoCache: $c2f83d7c13f283fd$var$throwInvalidHookError,
    useCacheRefresh: $c2f83d7c13f283fd$var$throwInvalidHookError
}, $c2f83d7c13f283fd$var$HooksDispatcherOnMount = {
    readContext: $c2f83d7c13f283fd$var$readContext,
    use: $c2f83d7c13f283fd$var$use,
    useCallback: function useCallback(callback, deps) {
        $c2f83d7c13f283fd$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c2f83d7c13f283fd$var$readContext,
    useEffect: $c2f83d7c13f283fd$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c2f83d7c13f283fd$var$mountEffectImpl(4194308, 4, $c2f83d7c13f283fd$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $c2f83d7c13f283fd$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $c2f83d7c13f283fd$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c2f83d7c13f283fd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c2f83d7c13f283fd$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c2f83d7c13f283fd$var$dispatchReducerAction.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $c2f83d7c13f283fd$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c2f83d7c13f283fd$var$dispatchSetState.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c2f83d7c13f283fd$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
        return $c2f83d7c13f283fd$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $c2f83d7c13f283fd$var$mountStateImpl(!1);
        stateHook = $c2f83d7c13f283fd$var$startTransition.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $c2f83d7c13f283fd$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c2f83d7c13f283fd$var$currentlyRenderingFiber, hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
        if ($c2f83d7c13f283fd$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c2f83d7c13f283fd$var$workInProgressRoot) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(349));
            0 !== ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 124) || $c2f83d7c13f283fd$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c2f83d7c13f283fd$var$mountEffect($c2f83d7c13f283fd$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c2f83d7c13f283fd$var$pushSimpleEffect(9, $c2f83d7c13f283fd$var$createEffectInstance(), $c2f83d7c13f283fd$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook(), identifierPrefix = $c2f83d7c13f283fd$var$workInProgressRoot.identifierPrefix;
        if ($c2f83d7c13f283fd$var$isHydrating) {
            var JSCompiler_inline_result = $c2f83d7c13f283fd$var$treeContextOverflow;
            var idWithLeadingBit = $c2f83d7c13f283fd$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c2f83d7c13f283fd$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c2f83d7c13f283fd$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $c2f83d7c13f283fd$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $c2f83d7c13f283fd$var$useHostTransitionStatus,
    useFormState: $c2f83d7c13f283fd$var$mountActionState,
    useActionState: $c2f83d7c13f283fd$var$mountActionState,
    useOptimistic: function useOptimistic(passthrough) {
        var hook = $c2f83d7c13f283fd$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $c2f83d7c13f283fd$var$dispatchOptimisticSetState.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $c2f83d7c13f283fd$var$useMemoCache,
    useCacheRefresh: function useCacheRefresh() {
        return $c2f83d7c13f283fd$var$mountWorkInProgressHook().memoizedState = $c2f83d7c13f283fd$var$refreshCache.bind(null, $c2f83d7c13f283fd$var$currentlyRenderingFiber);
    }
}, $c2f83d7c13f283fd$var$HooksDispatcherOnUpdate = {
    readContext: $c2f83d7c13f283fd$var$readContext,
    use: $c2f83d7c13f283fd$var$use,
    useCallback: $c2f83d7c13f283fd$var$updateCallback,
    useContext: $c2f83d7c13f283fd$var$readContext,
    useEffect: $c2f83d7c13f283fd$var$updateEffect,
    useImperativeHandle: $c2f83d7c13f283fd$var$updateImperativeHandle,
    useInsertionEffect: $c2f83d7c13f283fd$var$updateInsertionEffect,
    useLayoutEffect: $c2f83d7c13f283fd$var$updateLayoutEffect,
    useMemo: $c2f83d7c13f283fd$var$updateMemo,
    useReducer: $c2f83d7c13f283fd$var$updateReducer,
    useRef: $c2f83d7c13f283fd$var$updateRef,
    useState: function useState() {
        return $c2f83d7c13f283fd$var$updateReducer($c2f83d7c13f283fd$var$basicStateReducer);
    },
    useDebugValue: $c2f83d7c13f283fd$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
        return $c2f83d7c13f283fd$var$updateDeferredValueImpl(hook, $c2f83d7c13f283fd$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $c2f83d7c13f283fd$var$updateReducer($c2f83d7c13f283fd$var$basicStateReducer)[0], start = $c2f83d7c13f283fd$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c2f83d7c13f283fd$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c2f83d7c13f283fd$var$updateSyncExternalStore,
    useId: $c2f83d7c13f283fd$var$updateId,
    useHostTransitionStatus: $c2f83d7c13f283fd$var$useHostTransitionStatus,
    useFormState: $c2f83d7c13f283fd$var$updateActionState,
    useActionState: $c2f83d7c13f283fd$var$updateActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
        return $c2f83d7c13f283fd$var$updateOptimisticImpl(hook, $c2f83d7c13f283fd$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $c2f83d7c13f283fd$var$useMemoCache,
    useCacheRefresh: $c2f83d7c13f283fd$var$updateRefresh
}, $c2f83d7c13f283fd$var$HooksDispatcherOnRerender = {
    readContext: $c2f83d7c13f283fd$var$readContext,
    use: $c2f83d7c13f283fd$var$use,
    useCallback: $c2f83d7c13f283fd$var$updateCallback,
    useContext: $c2f83d7c13f283fd$var$readContext,
    useEffect: $c2f83d7c13f283fd$var$updateEffect,
    useImperativeHandle: $c2f83d7c13f283fd$var$updateImperativeHandle,
    useInsertionEffect: $c2f83d7c13f283fd$var$updateInsertionEffect,
    useLayoutEffect: $c2f83d7c13f283fd$var$updateLayoutEffect,
    useMemo: $c2f83d7c13f283fd$var$updateMemo,
    useReducer: $c2f83d7c13f283fd$var$rerenderReducer,
    useRef: $c2f83d7c13f283fd$var$updateRef,
    useState: function useState() {
        return $c2f83d7c13f283fd$var$rerenderReducer($c2f83d7c13f283fd$var$basicStateReducer);
    },
    useDebugValue: $c2f83d7c13f283fd$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
        return null === $c2f83d7c13f283fd$var$currentHook ? $c2f83d7c13f283fd$var$mountDeferredValueImpl(hook, value, initialValue) : $c2f83d7c13f283fd$var$updateDeferredValueImpl(hook, $c2f83d7c13f283fd$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $c2f83d7c13f283fd$var$rerenderReducer($c2f83d7c13f283fd$var$basicStateReducer)[0], start = $c2f83d7c13f283fd$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c2f83d7c13f283fd$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c2f83d7c13f283fd$var$updateSyncExternalStore,
    useId: $c2f83d7c13f283fd$var$updateId,
    useHostTransitionStatus: $c2f83d7c13f283fd$var$useHostTransitionStatus,
    useFormState: $c2f83d7c13f283fd$var$rerenderActionState,
    useActionState: $c2f83d7c13f283fd$var$rerenderActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $c2f83d7c13f283fd$var$updateWorkInProgressHook();
        if (null !== $c2f83d7c13f283fd$var$currentHook) return $c2f83d7c13f283fd$var$updateOptimisticImpl(hook, $c2f83d7c13f283fd$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $c2f83d7c13f283fd$var$useMemoCache,
    useCacheRefresh: $c2f83d7c13f283fd$var$updateRefresh
}, $c2f83d7c13f283fd$var$thenableState = null, $c2f83d7c13f283fd$var$thenableIndexCounter = 0;
function $c2f83d7c13f283fd$var$unwrapThenable(thenable) {
    var index = $c2f83d7c13f283fd$var$thenableIndexCounter;
    $c2f83d7c13f283fd$var$thenableIndexCounter += 1;
    null === $c2f83d7c13f283fd$var$thenableState && ($c2f83d7c13f283fd$var$thenableState = []);
    return $c2f83d7c13f283fd$var$trackUsedThenable($c2f83d7c13f283fd$var$thenableState, thenable, index);
}
function $c2f83d7c13f283fd$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c2f83d7c13f283fd$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $c2f83d7c13f283fd$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c2f83d7c13f283fd$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $c2f83d7c13f283fd$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c2f83d7c13f283fd$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c2f83d7c13f283fd$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $4TMho._)(elementType)) && null !== elementType && elementType.$$typeof === $c2f83d7c13f283fd$var$REACT_LAZY_TYPE && $c2f83d7c13f283fd$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c2f83d7c13f283fd$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c2f83d7c13f283fd$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c2f83d7c13f283fd$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c2f83d7c13f283fd$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c2f83d7c13f283fd$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild))) return newChild = $c2f83d7c13f283fd$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2f83d7c13f283fd$var$REACT_ELEMENT_TYPE:
                    return lanes = $c2f83d7c13f283fd$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c2f83d7c13f283fd$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c2f83d7c13f283fd$var$REACT_PORTAL_TYPE:
                    return newChild = $c2f83d7c13f283fd$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c2f83d7c13f283fd$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($c2f83d7c13f283fd$var$isArrayImpl(newChild) || $c2f83d7c13f283fd$var$getIteratorFn(newChild)) return newChild = $c2f83d7c13f283fd$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c2f83d7c13f283fd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c2f83d7c13f283fd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2f83d7c13f283fd$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2f83d7c13f283fd$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c2f83d7c13f283fd$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c2f83d7c13f283fd$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c2f83d7c13f283fd$var$isArrayImpl(newChild) || $c2f83d7c13f283fd$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c2f83d7c13f283fd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c2f83d7c13f283fd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2f83d7c13f283fd$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2f83d7c13f283fd$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c2f83d7c13f283fd$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c2f83d7c13f283fd$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c2f83d7c13f283fd$var$isArrayImpl(newChild) || $c2f83d7c13f283fd$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c2f83d7c13f283fd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c2f83d7c13f283fd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2f83d7c13f283fd$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c2f83d7c13f283fd$var$isHydrating && $c2f83d7c13f283fd$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c2f83d7c13f283fd$var$isHydrating && $c2f83d7c13f283fd$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c2f83d7c13f283fd$var$isHydrating && $c2f83d7c13f283fd$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c2f83d7c13f283fd$var$isHydrating && $c2f83d7c13f283fd$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c2f83d7c13f283fd$var$isHydrating && $c2f83d7c13f283fd$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c2f83d7c13f283fd$var$isHydrating && $c2f83d7c13f283fd$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild)) && null !== newChild && newChild.type === $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2f83d7c13f283fd$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $4TMho._)(key)) && null !== key && key.$$typeof === $c2f83d7c13f283fd$var$REACT_LAZY_TYPE && $c2f83d7c13f283fd$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c2f83d7c13f283fd$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c2f83d7c13f283fd$var$REACT_FRAGMENT_TYPE ? (lanes = $c2f83d7c13f283fd$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c2f83d7c13f283fd$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c2f83d7c13f283fd$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c2f83d7c13f283fd$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c2f83d7c13f283fd$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c2f83d7c13f283fd$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c2f83d7c13f283fd$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c2f83d7c13f283fd$var$getIteratorFn(newChild)) {
                key = $c2f83d7c13f283fd$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c2f83d7c13f283fd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c2f83d7c13f283fd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2f83d7c13f283fd$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $4TMho._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c2f83d7c13f283fd$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c2f83d7c13f283fd$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c2f83d7c13f283fd$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c2f83d7c13f283fd$var$SuspenseException || x === $c2f83d7c13f283fd$var$SuspenseActionException) throw x;
            var fiber = $c2f83d7c13f283fd$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c2f83d7c13f283fd$var$reconcileChildFibers = $c2f83d7c13f283fd$var$createChildReconciler(!0), $c2f83d7c13f283fd$var$mountChildFibers = $c2f83d7c13f283fd$var$createChildReconciler(!1), $c2f83d7c13f283fd$var$suspenseHandlerStackCursor = $c2f83d7c13f283fd$var$createCursor(null), $c2f83d7c13f283fd$var$shellBoundary = null;
function $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, $c2f83d7c13f283fd$var$suspenseStackCursor.current & 1);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseHandlerStackCursor, handler);
    null === $c2f83d7c13f283fd$var$shellBoundary && (null === current || null !== $c2f83d7c13f283fd$var$currentTreeHiddenStackCursor.current ? $c2f83d7c13f283fd$var$shellBoundary = handler : null !== current.memoizedState && ($c2f83d7c13f283fd$var$shellBoundary = handler));
}
function $c2f83d7c13f283fd$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, $c2f83d7c13f283fd$var$suspenseStackCursor.current), $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseHandlerStackCursor, fiber), null === $c2f83d7c13f283fd$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($c2f83d7c13f283fd$var$shellBoundary = fiber);
        }
    } else $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack() {
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, $c2f83d7c13f283fd$var$suspenseStackCursor.current);
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseHandlerStackCursor, $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current);
}
function $c2f83d7c13f283fd$var$popSuspenseHandler(fiber) {
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$suspenseHandlerStackCursor);
    $c2f83d7c13f283fd$var$shellBoundary === fiber && ($c2f83d7c13f283fd$var$shellBoundary = null);
    $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$suspenseStackCursor);
}
var $c2f83d7c13f283fd$var$suspenseStackCursor = $c2f83d7c13f283fd$var$createCursor(0);
function $c2f83d7c13f283fd$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $c2f83d7c13f283fd$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $c2f83d7c13f283fd$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c2f83d7c13f283fd$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c2f83d7c13f283fd$var$classComponentUpdater = {
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c2f83d7c13f283fd$var$requestUpdateLane(), update = $c2f83d7c13f283fd$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c2f83d7c13f283fd$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c2f83d7c13f283fd$var$scheduleUpdateOnFiber(payload, inst, lane), $c2f83d7c13f283fd$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c2f83d7c13f283fd$var$requestUpdateLane(), update = $c2f83d7c13f283fd$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c2f83d7c13f283fd$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c2f83d7c13f283fd$var$scheduleUpdateOnFiber(payload, inst, lane), $c2f83d7c13f283fd$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c2f83d7c13f283fd$var$requestUpdateLane(), update = $c2f83d7c13f283fd$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c2f83d7c13f283fd$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c2f83d7c13f283fd$var$scheduleUpdateOnFiber(callback, inst, lane), $c2f83d7c13f283fd$var$entangleTransitions(callback, inst, lane));
    }
};
function $c2f83d7c13f283fd$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c2f83d7c13f283fd$var$shallowEqual(oldProps, newProps) || !$c2f83d7c13f283fd$var$shallowEqual(oldState, newState) : !0;
}
function $c2f83d7c13f283fd$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c2f83d7c13f283fd$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c2f83d7c13f283fd$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c2f83d7c13f283fd$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $c2f83d7c13f283fd$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $4TMho._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $4TMho._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $c2f83d7c13f283fd$var$defaultOnUncaughtError(error) {
    $c2f83d7c13f283fd$var$reportGlobalError(error);
}
function $c2f83d7c13f283fd$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c2f83d7c13f283fd$var$defaultOnRecoverableError(error) {
    $c2f83d7c13f283fd$var$reportGlobalError(error);
}
function $c2f83d7c13f283fd$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $c2f83d7c13f283fd$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $c2f83d7c13f283fd$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c2f83d7c13f283fd$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c2f83d7c13f283fd$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c2f83d7c13f283fd$var$createClassErrorUpdate(lane) {
    lane = $c2f83d7c13f283fd$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c2f83d7c13f283fd$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c2f83d7c13f283fd$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c2f83d7c13f283fd$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed ? $c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c2f83d7c13f283fd$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c2f83d7c13f283fd$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $c2f83d7c13f283fd$var$shellBoundary ? $c2f83d7c13f283fd$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c2f83d7c13f283fd$var$workInProgressRootExitStatus && ($c2f83d7c13f283fd$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c2f83d7c13f283fd$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c2f83d7c13f283fd$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c2f83d7c13f283fd$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c2f83d7c13f283fd$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c2f83d7c13f283fd$var$attachPingListener(root, value, rootRenderLanes);
        $c2f83d7c13f283fd$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c2f83d7c13f283fd$var$isHydrating) return returnFiber = $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c2f83d7c13f283fd$var$HydrationMismatchException && (root = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(422), {
        cause: value
    }), $c2f83d7c13f283fd$var$queueHydrationError($c2f83d7c13f283fd$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c2f83d7c13f283fd$var$HydrationMismatchException && (returnFiber = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(423), {
        cause: value
    }), $c2f83d7c13f283fd$var$queueHydrationError($c2f83d7c13f283fd$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c2f83d7c13f283fd$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c2f83d7c13f283fd$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c2f83d7c13f283fd$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c2f83d7c13f283fd$var$workInProgressRootExitStatus && ($c2f83d7c13f283fd$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c2f83d7c13f283fd$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c2f83d7c13f283fd$var$workInProgressRootConcurrentErrors ? $c2f83d7c13f283fd$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c2f83d7c13f283fd$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c2f83d7c13f283fd$var$workInProgressRootExitStatus && ($c2f83d7c13f283fd$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c2f83d7c13f283fd$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c2f83d7c13f283fd$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c2f83d7c13f283fd$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed || !$c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c2f83d7c13f283fd$var$createClassErrorUpdate(rootRenderLanes), $c2f83d7c13f283fd$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c2f83d7c13f283fd$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c2f83d7c13f283fd$var$SelectiveHydrationException = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(461)), $c2f83d7c13f283fd$var$didReceiveUpdate = !1;
function $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c2f83d7c13f283fd$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c2f83d7c13f283fd$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c2f83d7c13f283fd$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress);
    nextProps = $c2f83d7c13f283fd$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c2f83d7c13f283fd$var$checkDidRenderIdHook();
    if (null !== current && !$c2f83d7c13f283fd$var$didReceiveUpdate) return $c2f83d7c13f283fd$var$bailoutHooks(current, workInProgress, renderLanes), $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2f83d7c13f283fd$var$isHydrating && key && $c2f83d7c13f283fd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c2f83d7c13f283fd$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c2f83d7c13f283fd$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c2f83d7c13f283fd$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c2f83d7c13f283fd$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c2f83d7c13f283fd$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c2f83d7c13f283fd$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c2f83d7c13f283fd$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c2f83d7c13f283fd$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c2f83d7c13f283fd$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c2f83d7c13f283fd$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c2f83d7c13f283fd$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c2f83d7c13f283fd$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c2f83d7c13f283fd$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c2f83d7c13f283fd$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $c2f83d7c13f283fd$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c2f83d7c13f283fd$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c2f83d7c13f283fd$var$pushHiddenContext(workInProgress, prevState) : $c2f83d7c13f283fd$var$reuseHiddenContextOnStack(), $c2f83d7c13f283fd$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $c2f83d7c13f283fd$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($c2f83d7c13f283fd$var$pushTransition(workInProgress, prevState.cachePool), $c2f83d7c13f283fd$var$pushHiddenContext(workInProgress, prevState), $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c2f83d7c13f283fd$var$pushTransition(workInProgress, null), $c2f83d7c13f283fd$var$reuseHiddenContextOnStack(), $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c2f83d7c13f283fd$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $c2f83d7c13f283fd$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c2f83d7c13f283fd$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c2f83d7c13f283fd$var$pushTransition(workInProgress, null);
    $c2f83d7c13f283fd$var$reuseHiddenContextOnStack();
    $c2f83d7c13f283fd$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c2f83d7c13f283fd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $c2f83d7c13f283fd$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $4TMho._)(ref))) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $c2f83d7c13f283fd$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress);
    Component = $c2f83d7c13f283fd$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c2f83d7c13f283fd$var$checkDidRenderIdHook();
    if (null !== current && !$c2f83d7c13f283fd$var$didReceiveUpdate) return $c2f83d7c13f283fd$var$bailoutHooks(current, workInProgress, renderLanes), $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2f83d7c13f283fd$var$isHydrating && nextProps && $c2f83d7c13f283fd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c2f83d7c13f283fd$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c2f83d7c13f283fd$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c2f83d7c13f283fd$var$finishRenderingHooks(current);
    Component = $c2f83d7c13f283fd$var$checkDidRenderIdHook();
    if (null !== current && !$c2f83d7c13f283fd$var$didReceiveUpdate) return $c2f83d7c13f283fd$var$bailoutHooks(current, workInProgress, renderLanes), $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2f83d7c13f283fd$var$isHydrating && Component && $c2f83d7c13f283fd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c2f83d7c13f283fd$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c2f83d7c13f283fd$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $4TMho._)(contextType)) && null !== contextType && (context = $c2f83d7c13f283fd$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c2f83d7c13f283fd$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c2f83d7c13f283fd$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $4TMho._)(contextType)) && null !== contextType ? $c2f83d7c13f283fd$var$readContext(contextType) : $c2f83d7c13f283fd$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c2f83d7c13f283fd$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c2f83d7c13f283fd$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c2f83d7c13f283fd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c2f83d7c13f283fd$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c2f83d7c13f283fd$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c2f83d7c13f283fd$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $4TMho._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $c2f83d7c13f283fd$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c2f83d7c13f283fd$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c2f83d7c13f283fd$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c2f83d7c13f283fd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c2f83d7c13f283fd$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c2f83d7c13f283fd$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c2f83d7c13f283fd$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c2f83d7c13f283fd$var$hasForceUpdate || $c2f83d7c13f283fd$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c2f83d7c13f283fd$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c2f83d7c13f283fd$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c2f83d7c13f283fd$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $4TMho._)(oldContext)) && null !== oldContext && (oldProps = $c2f83d7c13f283fd$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c2f83d7c13f283fd$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c2f83d7c13f283fd$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c2f83d7c13f283fd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c2f83d7c13f283fd$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c2f83d7c13f283fd$var$hasForceUpdate || null !== current && null !== current.dependencies && $c2f83d7c13f283fd$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c2f83d7c13f283fd$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c2f83d7c13f283fd$var$hasForceUpdate || $c2f83d7c13f283fd$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c2f83d7c13f283fd$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c2f83d7c13f283fd$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c2f83d7c13f283fd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c2f83d7c13f283fd$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c2f83d7c13f283fd$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c2f83d7c13f283fd$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c2f83d7c13f283fd$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $c2f83d7c13f283fd$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c2f83d7c13f283fd$var$getSuspendedCache()
    };
}
function $c2f83d7c13f283fd$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c2f83d7c13f283fd$var$workInProgressDeferredLane);
    return current;
}
function $c2f83d7c13f283fd$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c2f83d7c13f283fd$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c2f83d7c13f283fd$var$isHydrating) {
            showFallback ? $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($c2f83d7c13f283fd$var$isHydrating) {
                var nextInstance = $c2f83d7c13f283fd$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $c2f83d7c13f283fd$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $c2f83d7c13f283fd$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $c2f83d7c13f283fd$var$treeContextProvider ? {
                            id: $c2f83d7c13f283fd$var$treeContextId,
                            overflow: $c2f83d7c13f283fd$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $c2f83d7c13f283fd$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $c2f83d7c13f283fd$var$hydrationParentFiber = workInProgress, $c2f83d7c13f283fd$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $c2f83d7c13f283fd$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $c2f83d7c13f283fd$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $c2f83d7c13f283fd$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $c2f83d7c13f283fd$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $c2f83d7c13f283fd$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $c2f83d7c13f283fd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2f83d7c13f283fd$var$SUSPENDED_MARKER, nextProps;
        $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c2f83d7c13f283fd$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c2f83d7c13f283fd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $c2f83d7c13f283fd$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $c2f83d7c13f283fd$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $c2f83d7c13f283fd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c2f83d7c13f283fd$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c2f83d7c13f283fd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2f83d7c13f283fd$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress), $c2f83d7c13f283fd$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c2f83d7c13f283fd$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c2f83d7c13f283fd$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c2f83d7c13f283fd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c2f83d7c13f283fd$var$didReceiveUpdate || $c2f83d7c13f283fd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c2f83d7c13f283fd$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c2f83d7c13f283fd$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $c2f83d7c13f283fd$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(current, nextProps), $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c2f83d7c13f283fd$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $c2f83d7c13f283fd$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c2f83d7c13f283fd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$getNextHydratable(nextInstance.nextSibling), $c2f83d7c13f283fd$var$hydrationParentFiber = workInProgress, $c2f83d7c13f283fd$var$isHydrating = !0, $c2f83d7c13f283fd$var$hydrationErrors = null, $c2f83d7c13f283fd$var$rootOrSingletonContext = !1, null !== current && ($c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex++] = $c2f83d7c13f283fd$var$treeContextId, $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex++] = $c2f83d7c13f283fd$var$treeContextOverflow, $c2f83d7c13f283fd$var$idStack[$c2f83d7c13f283fd$var$idStackIndex++] = $c2f83d7c13f283fd$var$treeContextProvider, $c2f83d7c13f283fd$var$treeContextId = current.id, $c2f83d7c13f283fd$var$treeContextOverflow = current.overflow, $c2f83d7c13f283fd$var$treeContextProvider = workInProgress), workInProgress = $c2f83d7c13f283fd$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c2f83d7c13f283fd$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $c2f83d7c13f283fd$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $c2f83d7c13f283fd$var$createWorkInProgress(digest, showFallback) : (showFallback = $c2f83d7c13f283fd$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $c2f83d7c13f283fd$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $c2f83d7c13f283fd$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $c2f83d7c13f283fd$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $c2f83d7c13f283fd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2f83d7c13f283fd$var$SUSPENDED_MARKER, nextProps;
    $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c2f83d7c13f283fd$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c2f83d7c13f283fd$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c2f83d7c13f283fd$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c2f83d7c13f283fd$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $c2f83d7c13f283fd$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $c2f83d7c13f283fd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c2f83d7c13f283fd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c2f83d7c13f283fd$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c2f83d7c13f283fd$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c2f83d7c13f283fd$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c2f83d7c13f283fd$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $c2f83d7c13f283fd$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $c2f83d7c13f283fd$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $c2f83d7c13f283fd$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $c2f83d7c13f283fd$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c2f83d7c13f283fd$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c2f83d7c13f283fd$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c2f83d7c13f283fd$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c2f83d7c13f283fd$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $c2f83d7c13f283fd$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c2f83d7c13f283fd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c2f83d7c13f283fd$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c2f83d7c13f283fd$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c2f83d7c13f283fd$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c2f83d7c13f283fd$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c2f83d7c13f283fd$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c2f83d7c13f283fd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c2f83d7c13f283fd$var$pushProvider(workInProgress, $c2f83d7c13f283fd$var$CacheContext, current.memoizedState.cache);
            $c2f83d7c13f283fd$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c2f83d7c13f283fd$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c2f83d7c13f283fd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c2f83d7c13f283fd$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c2f83d7c13f283fd$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c2f83d7c13f283fd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($c2f83d7c13f283fd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $c2f83d7c13f283fd$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, $c2f83d7c13f283fd$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $c2f83d7c13f283fd$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $c2f83d7c13f283fd$var$pushProvider(workInProgress, $c2f83d7c13f283fd$var$CacheContext, current.memoizedState.cache);
    }
    return $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c2f83d7c13f283fd$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c2f83d7c13f283fd$var$didReceiveUpdate = !0;
        else {
            if (!$c2f83d7c13f283fd$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c2f83d7c13f283fd$var$didReceiveUpdate = !1, $c2f83d7c13f283fd$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c2f83d7c13f283fd$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c2f83d7c13f283fd$var$didReceiveUpdate = !1, $c2f83d7c13f283fd$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c2f83d7c13f283fd$var$pushTreeId(workInProgress, $c2f83d7c13f283fd$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $c2f83d7c13f283fd$var$shouldConstruct(lazyComponent) ? (current = $c2f83d7c13f283fd$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $c2f83d7c13f283fd$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c2f83d7c13f283fd$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $c2f83d7c13f283fd$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c2f83d7c13f283fd$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $c2f83d7c13f283fd$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c2f83d7c13f283fd$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c2f83d7c13f283fd$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c2f83d7c13f283fd$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $c2f83d7c13f283fd$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $c2f83d7c13f283fd$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $c2f83d7c13f283fd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $c2f83d7c13f283fd$var$cloneUpdateQueue(current, workInProgress);
                $c2f83d7c13f283fd$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $c2f83d7c13f283fd$var$pushProvider(workInProgress, $c2f83d7c13f283fd$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $c2f83d7c13f283fd$var$propagateContextChanges(workInProgress, [
                    $c2f83d7c13f283fd$var$CacheContext
                ], renderLanes, !0);
                $c2f83d7c13f283fd$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $c2f83d7c13f283fd$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $c2f83d7c13f283fd$var$createCapturedValueAtFiber(Error($c2f83d7c13f283fd$var$formatProdErrorMessage(424)), workInProgress);
                        $c2f83d7c13f283fd$var$queueHydrationError(init);
                        workInProgress = $c2f83d7c13f283fd$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$getNextHydratable(current.firstChild);
                        $c2f83d7c13f283fd$var$hydrationParentFiber = workInProgress;
                        $c2f83d7c13f283fd$var$isHydrating = !0;
                        $c2f83d7c13f283fd$var$hydrationErrors = null;
                        $c2f83d7c13f283fd$var$rootOrSingletonContext = !0;
                        renderLanes = $c2f83d7c13f283fd$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $c2f83d7c13f283fd$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $c2f83d7c13f283fd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c2f83d7c13f283fd$var$markRef(current, workInProgress), null === current ? (renderLanes = $c2f83d7c13f283fd$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c2f83d7c13f283fd$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $c2f83d7c13f283fd$var$getOwnerDocumentFromRootContainer($c2f83d7c13f283fd$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$c2f83d7c13f283fd$var$internalInstanceKey] = workInProgress, lazyComponent[$c2f83d7c13f283fd$var$internalPropsKey] = current, $c2f83d7c13f283fd$var$setInitialProperties(lazyComponent, renderLanes, current), $c2f83d7c13f283fd$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $c2f83d7c13f283fd$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c2f83d7c13f283fd$var$pushHostContext(workInProgress), null === current && $c2f83d7c13f283fd$var$isHydrating && (lazyComponent = workInProgress.stateNode = $c2f83d7c13f283fd$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c2f83d7c13f283fd$var$rootInstanceStackCursor.current), $c2f83d7c13f283fd$var$hydrationParentFiber = workInProgress, $c2f83d7c13f283fd$var$rootOrSingletonContext = !0, init = $c2f83d7c13f283fd$var$nextHydratableInstance, $c2f83d7c13f283fd$var$isSingletonScope(workInProgress.type) ? ($c2f83d7c13f283fd$var$previousHydratableOnEnteringScopedSingleton = init, $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$getNextHydratable(lazyComponent.firstChild)) : $c2f83d7c13f283fd$var$nextHydratableInstance = init), $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $c2f83d7c13f283fd$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $c2f83d7c13f283fd$var$isHydrating) {
                if (init = lazyComponent = $c2f83d7c13f283fd$var$nextHydratableInstance) lazyComponent = $c2f83d7c13f283fd$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $c2f83d7c13f283fd$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $c2f83d7c13f283fd$var$hydrationParentFiber = workInProgress, $c2f83d7c13f283fd$var$nextHydratableInstance = $c2f83d7c13f283fd$var$getNextHydratable(lazyComponent.firstChild), $c2f83d7c13f283fd$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $c2f83d7c13f283fd$var$throwOnHydrationMismatch(workInProgress);
            }
            $c2f83d7c13f283fd$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $c2f83d7c13f283fd$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $c2f83d7c13f283fd$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $c2f83d7c13f283fd$var$renderWithHooks(current, workInProgress, $c2f83d7c13f283fd$var$TransitionAwareHostComponent, null, null, renderLanes), $c2f83d7c13f283fd$var$HostTransitionContext._currentValue = init);
            $c2f83d7c13f283fd$var$markRef(current, workInProgress);
            $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c2f83d7c13f283fd$var$isHydrating) {
                if (current = renderLanes = $c2f83d7c13f283fd$var$nextHydratableInstance) renderLanes = $c2f83d7c13f283fd$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c2f83d7c13f283fd$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c2f83d7c13f283fd$var$hydrationParentFiber = workInProgress, $c2f83d7c13f283fd$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c2f83d7c13f283fd$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c2f83d7c13f283fd$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c2f83d7c13f283fd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $c2f83d7c13f283fd$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $c2f83d7c13f283fd$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $c2f83d7c13f283fd$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress), init = $c2f83d7c13f283fd$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $c2f83d7c13f283fd$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c2f83d7c13f283fd$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c2f83d7c13f283fd$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $c2f83d7c13f283fd$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $c2f83d7c13f283fd$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $c2f83d7c13f283fd$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $c2f83d7c13f283fd$var$prepareToReadContext(workInProgress), lazyComponent = $c2f83d7c13f283fd$var$readContext($c2f83d7c13f283fd$var$CacheContext), null === current ? (init = $c2f83d7c13f283fd$var$peekCacheFromPool(), null === init && (init = $c2f83d7c13f283fd$var$workInProgressRoot, prevState = $c2f83d7c13f283fd$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $c2f83d7c13f283fd$var$initializeUpdateQueue(workInProgress), $c2f83d7c13f283fd$var$pushProvider(workInProgress, $c2f83d7c13f283fd$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($c2f83d7c13f283fd$var$cloneUpdateQueue(current, workInProgress), $c2f83d7c13f283fd$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c2f83d7c13f283fd$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $c2f83d7c13f283fd$var$pushProvider(workInProgress, $c2f83d7c13f283fd$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $c2f83d7c13f283fd$var$pushProvider(workInProgress, $c2f83d7c13f283fd$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $c2f83d7c13f283fd$var$propagateContextChanges(workInProgress, [
                $c2f83d7c13f283fd$var$CacheContext
            ], renderLanes, !0))), $c2f83d7c13f283fd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c2f83d7c13f283fd$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c2f83d7c13f283fd$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c2f83d7c13f283fd$var$preloadResource(resource)) {
        resource = $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 4194048) === $c2f83d7c13f283fd$var$workInProgressRootRenderLanes ? null !== $c2f83d7c13f283fd$var$shellBoundary : ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 62914560) !== $c2f83d7c13f283fd$var$workInProgressRootRenderLanes && 0 === ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 536870912) || resource !== $c2f83d7c13f283fd$var$shellBoundary)) throw $c2f83d7c13f283fd$var$suspendedThenable = $c2f83d7c13f283fd$var$noopSuspenseyCommitThenable, $c2f83d7c13f283fd$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $c2f83d7c13f283fd$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c2f83d7c13f283fd$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c2f83d7c13f283fd$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c2f83d7c13f283fd$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $c2f83d7c13f283fd$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c2f83d7c13f283fd$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c2f83d7c13f283fd$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c2f83d7c13f283fd$var$popProvider($c2f83d7c13f283fd$var$CacheContext);
            $c2f83d7c13f283fd$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c2f83d7c13f283fd$var$popHydrationState(workInProgress) ? $c2f83d7c13f283fd$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $c2f83d7c13f283fd$var$upgradeHydrationErrorsToRecoverable());
            $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($c2f83d7c13f283fd$var$markUpdate(workInProgress), null !== renderLanes ? ($c2f83d7c13f283fd$var$bubbleProperties(workInProgress), $c2f83d7c13f283fd$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c2f83d7c13f283fd$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($c2f83d7c13f283fd$var$markUpdate(workInProgress), $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), $c2f83d7c13f283fd$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c2f83d7c13f283fd$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $c2f83d7c13f283fd$var$markUpdate(workInProgress), $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $c2f83d7c13f283fd$var$popHostContext(workInProgress);
            renderLanes = $c2f83d7c13f283fd$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2f83d7c13f283fd$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(166));
                    $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c2f83d7c13f283fd$var$contextStackCursor.current;
                $c2f83d7c13f283fd$var$popHydrationState(workInProgress) ? $c2f83d7c13f283fd$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c2f83d7c13f283fd$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c2f83d7c13f283fd$var$markUpdate(workInProgress));
            }
            $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c2f83d7c13f283fd$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2f83d7c13f283fd$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(166));
                    $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c2f83d7c13f283fd$var$contextStackCursor.current;
                if ($c2f83d7c13f283fd$var$popHydrationState(workInProgress)) $c2f83d7c13f283fd$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $c2f83d7c13f283fd$var$getOwnerDocumentFromRootContainer($c2f83d7c13f283fd$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$c2f83d7c13f283fd$var$internalInstanceKey] = workInProgress;
                    current[$c2f83d7c13f283fd$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($c2f83d7c13f283fd$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $c2f83d7c13f283fd$var$markUpdate(workInProgress);
                }
            }
            $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2f83d7c13f283fd$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(166));
                current = $c2f83d7c13f283fd$var$rootInstanceStackCursor.current;
                if ($c2f83d7c13f283fd$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c2f83d7c13f283fd$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c2f83d7c13f283fd$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c2f83d7c13f283fd$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c2f83d7c13f283fd$var$throwOnHydrationMismatch(workInProgress);
                } else current = $c2f83d7c13f283fd$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c2f83d7c13f283fd$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c2f83d7c13f283fd$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(317));
                        type[$c2f83d7c13f283fd$var$internalInstanceKey] = workInProgress;
                    } else $c2f83d7c13f283fd$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $c2f83d7c13f283fd$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c2f83d7c13f283fd$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c2f83d7c13f283fd$var$popHostContainer(), null === current && $c2f83d7c13f283fd$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c2f83d7c13f283fd$var$popProvider(workInProgress.type), $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
        case 19:
            $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $c2f83d7c13f283fd$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $c2f83d7c13f283fd$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $c2f83d7c13f283fd$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $c2f83d7c13f283fd$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $c2f83d7c13f283fd$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c2f83d7c13f283fd$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, $c2f83d7c13f283fd$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $c2f83d7c13f283fd$var$now() > $c2f83d7c13f283fd$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $c2f83d7c13f283fd$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $c2f83d7c13f283fd$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c2f83d7c13f283fd$var$scheduleRetryEffect(workInProgress, current), $c2f83d7c13f283fd$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$c2f83d7c13f283fd$var$isHydrating) return $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c2f83d7c13f283fd$var$now() - type.renderingStartTime > $c2f83d7c13f283fd$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $c2f83d7c13f283fd$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $c2f83d7c13f283fd$var$now(), workInProgress.sibling = null, current = $c2f83d7c13f283fd$var$suspenseStackCursor.current, $c2f83d7c13f283fd$var$push($c2f83d7c13f283fd$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $c2f83d7c13f283fd$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress), $c2f83d7c13f283fd$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c2f83d7c13f283fd$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c2f83d7c13f283fd$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c2f83d7c13f283fd$var$popProvider($c2f83d7c13f283fd$var$CacheContext), $c2f83d7c13f283fd$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c2f83d7c13f283fd$var$unwindWork(current, workInProgress) {
    $c2f83d7c13f283fd$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c2f83d7c13f283fd$var$popProvider($c2f83d7c13f283fd$var$CacheContext), $c2f83d7c13f283fd$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c2f83d7c13f283fd$var$popHostContext(workInProgress), null;
        case 13:
            $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(340));
                $c2f83d7c13f283fd$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$suspenseStackCursor), null;
        case 4:
            return $c2f83d7c13f283fd$var$popHostContainer(), null;
        case 10:
            return $c2f83d7c13f283fd$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c2f83d7c13f283fd$var$popSuspenseHandler(workInProgress), $c2f83d7c13f283fd$var$popHiddenContext(), null !== current && $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c2f83d7c13f283fd$var$popProvider($c2f83d7c13f283fd$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c2f83d7c13f283fd$var$unwindInterruptedWork(current, interruptedWork) {
    $c2f83d7c13f283fd$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c2f83d7c13f283fd$var$popProvider($c2f83d7c13f283fd$var$CacheContext);
            $c2f83d7c13f283fd$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c2f83d7c13f283fd$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c2f83d7c13f283fd$var$popHostContainer();
            break;
        case 13:
            $c2f83d7c13f283fd$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$suspenseStackCursor);
            break;
        case 10:
            $c2f83d7c13f283fd$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c2f83d7c13f283fd$var$popSuspenseHandler(interruptedWork);
            $c2f83d7c13f283fd$var$popHiddenContext();
            null !== current && $c2f83d7c13f283fd$var$pop($c2f83d7c13f283fd$var$resumedCache);
            break;
        case 24:
            $c2f83d7c13f283fd$var$popProvider($c2f83d7c13f283fd$var$CacheContext);
    }
}
function $c2f83d7c13f283fd$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2f83d7c13f283fd$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $c2f83d7c13f283fd$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2f83d7c13f283fd$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c2f83d7c13f283fd$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c2f83d7c13f283fd$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c2f83d7c13f283fd$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c2f83d7c13f283fd$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c2f83d7c13f283fd$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c2f83d7c13f283fd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $c2f83d7c13f283fd$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $c2f83d7c13f283fd$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2f83d7c13f283fd$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c2f83d7c13f283fd$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c2f83d7c13f283fd$var$internalPropsKey] = newProps;
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2f83d7c13f283fd$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $c2f83d7c13f283fd$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $c2f83d7c13f283fd$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c2f83d7c13f283fd$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $c2f83d7c13f283fd$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c2f83d7c13f283fd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c2f83d7c13f283fd$var$noop$1));
    else if (4 !== tag && (27 === tag && $c2f83d7c13f283fd$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($c2f83d7c13f283fd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c2f83d7c13f283fd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c2f83d7c13f283fd$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $c2f83d7c13f283fd$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($c2f83d7c13f283fd$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c2f83d7c13f283fd$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $c2f83d7c13f283fd$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $c2f83d7c13f283fd$var$setInitialProperties(singleton, type, props);
        singleton[$c2f83d7c13f283fd$var$internalInstanceKey] = finishedWork;
        singleton[$c2f83d7c13f283fd$var$internalPropsKey] = props;
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden = !1, $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = !1, $c2f83d7c13f283fd$var$needsFormReset = !1, $c2f83d7c13f283fd$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c2f83d7c13f283fd$var$nextEffect = null;
function $c2f83d7c13f283fd$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c2f83d7c13f283fd$var$eventsEnabled = $c2f83d7c13f283fd$var$_enabled;
    root = $c2f83d7c13f283fd$var$getActiveElementDeep(root);
    if ($c2f83d7c13f283fd$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c2f83d7c13f283fd$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c2f83d7c13f283fd$var$_enabled = !1;
    for($c2f83d7c13f283fd$var$nextEffect = firstChild; null !== $c2f83d7c13f283fd$var$nextEffect;)if (firstChild = $c2f83d7c13f283fd$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $c2f83d7c13f283fd$var$nextEffect = root;
    else for(; null !== $c2f83d7c13f283fd$var$nextEffect;){
        firstChild = $c2f83d7c13f283fd$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c2f83d7c13f283fd$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c2f83d7c13f283fd$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c2f83d7c13f283fd$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c2f83d7c13f283fd$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c2f83d7c13f283fd$var$nextEffect = root;
            break;
        }
        $c2f83d7c13f283fd$var$nextEffect = firstChild.return;
    }
}
function $c2f83d7c13f283fd$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2f83d7c13f283fd$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c2f83d7c13f283fd$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $c2f83d7c13f283fd$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c2f83d7c13f283fd$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $c2f83d7c13f283fd$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $c2f83d7c13f283fd$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c2f83d7c13f283fd$var$commitHostMount(finishedWork);
            flags & 512 && $c2f83d7c13f283fd$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2f83d7c13f283fd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $c2f83d7c13f283fd$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $c2f83d7c13f283fd$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden;
                prevProps = $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden;
                $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden = flags;
                ($c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden = prevProps;
                $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c2f83d7c13f283fd$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c2f83d7c13f283fd$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c2f83d7c13f283fd$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c2f83d7c13f283fd$var$hostParent = null, $c2f83d7c13f283fd$var$hostParentIsContainer = !1;
function $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c2f83d7c13f283fd$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c2f83d7c13f283fd$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c2f83d7c13f283fd$var$injectedHook && "function" === typeof $c2f83d7c13f283fd$var$injectedHook.onCommitFiberUnmount) try {
        $c2f83d7c13f283fd$var$injectedHook.onCommitFiberUnmount($c2f83d7c13f283fd$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || $c2f83d7c13f283fd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || $c2f83d7c13f283fd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c2f83d7c13f283fd$var$hostParent, prevHostParentIsContainer = $c2f83d7c13f283fd$var$hostParentIsContainer;
            $c2f83d7c13f283fd$var$isSingletonScope(deletedFiber.type) && ($c2f83d7c13f283fd$var$hostParent = deletedFiber.stateNode, $c2f83d7c13f283fd$var$hostParentIsContainer = !1);
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2f83d7c13f283fd$var$releaseSingletonInstance(deletedFiber.stateNode);
            $c2f83d7c13f283fd$var$hostParent = prevHostParent;
            $c2f83d7c13f283fd$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || $c2f83d7c13f283fd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $c2f83d7c13f283fd$var$hostParent;
            prevHostParentIsContainer = $c2f83d7c13f283fd$var$hostParentIsContainer;
            $c2f83d7c13f283fd$var$hostParent = null;
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2f83d7c13f283fd$var$hostParent = prevHostParent;
            $c2f83d7c13f283fd$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $c2f83d7c13f283fd$var$hostParent) {
                if ($c2f83d7c13f283fd$var$hostParentIsContainer) try {
                    (9 === $c2f83d7c13f283fd$var$hostParent.nodeType ? $c2f83d7c13f283fd$var$hostParent.body : "HTML" === $c2f83d7c13f283fd$var$hostParent.nodeName ? $c2f83d7c13f283fd$var$hostParent.ownerDocument.body : $c2f83d7c13f283fd$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c2f83d7c13f283fd$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c2f83d7c13f283fd$var$hostParent && ($c2f83d7c13f283fd$var$hostParentIsContainer ? (finishedRoot = $c2f83d7c13f283fd$var$hostParent, $c2f83d7c13f283fd$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $c2f83d7c13f283fd$var$retryIfBlockedOn(finishedRoot)) : $c2f83d7c13f283fd$var$clearSuspenseBoundary($c2f83d7c13f283fd$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c2f83d7c13f283fd$var$hostParent;
            prevHostParentIsContainer = $c2f83d7c13f283fd$var$hostParentIsContainer;
            $c2f83d7c13f283fd$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c2f83d7c13f283fd$var$hostParentIsContainer = !0;
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2f83d7c13f283fd$var$hostParent = prevHostParent;
            $c2f83d7c13f283fd$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || $c2f83d7c13f283fd$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || $c2f83d7c13f283fd$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || ($c2f83d7c13f283fd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c2f83d7c13f283fd$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = (prevHostParent = $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c2f83d7c13f283fd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c2f83d7c13f283fd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c2f83d7c13f283fd$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2f83d7c13f283fd$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c2f83d7c13f283fd$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c2f83d7c13f283fd$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c2f83d7c13f283fd$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c2f83d7c13f283fd$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $c2f83d7c13f283fd$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($c2f83d7c13f283fd$var$isSingletonScope(parent.type)) {
                        $c2f83d7c13f283fd$var$hostParent = parent.stateNode;
                        $c2f83d7c13f283fd$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $c2f83d7c13f283fd$var$hostParent = parent.stateNode;
                    $c2f83d7c13f283fd$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $c2f83d7c13f283fd$var$hostParent = parent.stateNode.containerInfo;
                    $c2f83d7c13f283fd$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c2f83d7c13f283fd$var$hostParent) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(160));
        $c2f83d7c13f283fd$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c2f83d7c13f283fd$var$hostParent = null;
        $c2f83d7c13f283fd$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2f83d7c13f283fd$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c2f83d7c13f283fd$var$currentHoistableRoot = null;
function $c2f83d7c13f283fd$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c2f83d7c13f283fd$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c2f83d7c13f283fd$var$commitHookEffectListMount(3, finishedWork), $c2f83d7c13f283fd$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || null === current || $c2f83d7c13f283fd$var$safelyDetachRef(current, current.return));
            flags & 64 && $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c2f83d7c13f283fd$var$currentHoistableRoot;
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || null === current || $c2f83d7c13f283fd$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c2f83d7c13f283fd$var$internalHoistableMarker] || currentResource[$c2f83d7c13f283fd$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c2f83d7c13f283fd$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c2f83d7c13f283fd$var$internalInstanceKey] = finishedWork;
                                        $c2f83d7c13f283fd$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c2f83d7c13f283fd$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c2f83d7c13f283fd$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c2f83d7c13f283fd$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c2f83d7c13f283fd$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c2f83d7c13f283fd$var$internalInstanceKey] = finishedWork;
                                $c2f83d7c13f283fd$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c2f83d7c13f283fd$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c2f83d7c13f283fd$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c2f83d7c13f283fd$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c2f83d7c13f283fd$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c2f83d7c13f283fd$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || null === current || $c2f83d7c13f283fd$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $c2f83d7c13f283fd$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || null === current || $c2f83d7c13f283fd$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c2f83d7c13f283fd$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c2f83d7c13f283fd$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c2f83d7c13f283fd$var$needsFormReset = !0);
            break;
        case 6:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c2f83d7c13f283fd$var$tagCaches = null;
            hoistableRoot = $c2f83d7c13f283fd$var$currentHoistableRoot;
            $c2f83d7c13f283fd$var$currentHoistableRoot = $c2f83d7c13f283fd$var$getHoistableRoot(root.containerInfo);
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$currentHoistableRoot = hoistableRoot;
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c2f83d7c13f283fd$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c2f83d7c13f283fd$var$needsFormReset && ($c2f83d7c13f283fd$var$needsFormReset = !1, $c2f83d7c13f283fd$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c2f83d7c13f283fd$var$currentHoistableRoot;
            $c2f83d7c13f283fd$var$currentHoistableRoot = $c2f83d7c13f283fd$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            $c2f83d7c13f283fd$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c2f83d7c13f283fd$var$globalMostRecentFallbackTime = $c2f83d7c13f283fd$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2f83d7c13f283fd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden;
            $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $c2f83d7c13f283fd$var$offscreenSubtreeIsHidden || $c2f83d7c13f283fd$var$offscreenSubtreeWasHidden || $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c2f83d7c13f283fd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $c2f83d7c13f283fd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c2f83d7c13f283fd$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2f83d7c13f283fd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $c2f83d7c13f283fd$var$recursivelyTraverseMutationEffects(root, finishedWork), $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork);
    }
}
function $c2f83d7c13f283fd$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($c2f83d7c13f283fd$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $c2f83d7c13f283fd$var$getHostSibling(finishedWork);
                    $c2f83d7c13f283fd$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($c2f83d7c13f283fd$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $c2f83d7c13f283fd$var$getHostSibling(finishedWork);
                    $c2f83d7c13f283fd$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $c2f83d7c13f283fd$var$getHostSibling(finishedWork);
                    $c2f83d7c13f283fd$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c2f83d7c13f283fd$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c2f83d7c13f283fd$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c2f83d7c13f283fd$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2f83d7c13f283fd$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c2f83d7c13f283fd$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c2f83d7c13f283fd$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c2f83d7c13f283fd$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $c2f83d7c13f283fd$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $c2f83d7c13f283fd$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c2f83d7c13f283fd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c2f83d7c13f283fd$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c2f83d7c13f283fd$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c2f83d7c13f283fd$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c2f83d7c13f283fd$var$commitClassCallbacks(finishedWork);
                $c2f83d7c13f283fd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $c2f83d7c13f283fd$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c2f83d7c13f283fd$var$commitHostMount(finishedWork);
                $c2f83d7c13f283fd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c2f83d7c13f283fd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c2f83d7c13f283fd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $c2f83d7c13f283fd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2f83d7c13f283fd$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c2f83d7c13f283fd$var$releaseCache(previousCache));
}
function $c2f83d7c13f283fd$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c2f83d7c13f283fd$var$releaseCache(current));
}
function $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2f83d7c13f283fd$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c2f83d7c13f283fd$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c2f83d7c13f283fd$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c2f83d7c13f283fd$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c2f83d7c13f283fd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c2f83d7c13f283fd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $c2f83d7c13f283fd$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c2f83d7c13f283fd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c2f83d7c13f283fd$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c2f83d7c13f283fd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c2f83d7c13f283fd$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c2f83d7c13f283fd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c2f83d7c13f283fd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2f83d7c13f283fd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c2f83d7c13f283fd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c2f83d7c13f283fd$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c2f83d7c13f283fd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c2f83d7c13f283fd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c2f83d7c13f283fd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c2f83d7c13f283fd$var$suspenseyCommitFlag = 8192;
function $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $c2f83d7c13f283fd$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2f83d7c13f283fd$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c2f83d7c13f283fd$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $c2f83d7c13f283fd$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c2f83d7c13f283fd$var$suspendResource($c2f83d7c13f283fd$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c2f83d7c13f283fd$var$currentHoistableRoot;
            $c2f83d7c13f283fd$var$currentHoistableRoot = $c2f83d7c13f283fd$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $c2f83d7c13f283fd$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c2f83d7c13f283fd$var$suspenseyCommitFlag, $c2f83d7c13f283fd$var$suspenseyCommitFlag = 16777216, $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(fiber), $c2f83d7c13f283fd$var$suspenseyCommitFlag = previousHoistableRoot) : $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $c2f83d7c13f283fd$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $c2f83d7c13f283fd$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c2f83d7c13f283fd$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c2f83d7c13f283fd$var$nextEffect = childToDelete;
            $c2f83d7c13f283fd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c2f83d7c13f283fd$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2f83d7c13f283fd$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c2f83d7c13f283fd$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c2f83d7c13f283fd$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $c2f83d7c13f283fd$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c2f83d7c13f283fd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c2f83d7c13f283fd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c2f83d7c13f283fd$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c2f83d7c13f283fd$var$nextEffect = childToDelete;
            $c2f83d7c13f283fd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c2f83d7c13f283fd$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c2f83d7c13f283fd$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c2f83d7c13f283fd$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $c2f83d7c13f283fd$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c2f83d7c13f283fd$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2f83d7c13f283fd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c2f83d7c13f283fd$var$nextEffect;){
        var fiber = $c2f83d7c13f283fd$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c2f83d7c13f283fd$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c2f83d7c13f283fd$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c2f83d7c13f283fd$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c2f83d7c13f283fd$var$nextEffect;){
            cache = $c2f83d7c13f283fd$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c2f83d7c13f283fd$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c2f83d7c13f283fd$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c2f83d7c13f283fd$var$nextEffect = sibling;
                break a;
            }
            $c2f83d7c13f283fd$var$nextEffect = returnFiber;
        }
    }
}
var $c2f83d7c13f283fd$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $c2f83d7c13f283fd$var$readContext($c2f83d7c13f283fd$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $c2f83d7c13f283fd$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c2f83d7c13f283fd$var$executionContext = 0, $c2f83d7c13f283fd$var$workInProgressRoot = null, $c2f83d7c13f283fd$var$workInProgress = null, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes = 0, $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0, $c2f83d7c13f283fd$var$workInProgressThrownValue = null, $c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c2f83d7c13f283fd$var$workInProgressRootIsPrerendering = !1, $c2f83d7c13f283fd$var$workInProgressRootDidAttachPingListener = !1, $c2f83d7c13f283fd$var$entangledRenderLanes = 0, $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 0, $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes = 0, $c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes = 0, $c2f83d7c13f283fd$var$workInProgressRootPingedLanes = 0, $c2f83d7c13f283fd$var$workInProgressDeferredLane = 0, $c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes = 0, $c2f83d7c13f283fd$var$workInProgressRootConcurrentErrors = null, $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors = null, $c2f83d7c13f283fd$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c2f83d7c13f283fd$var$globalMostRecentFallbackTime = 0, $c2f83d7c13f283fd$var$workInProgressRootRenderTargetTime = Infinity, $c2f83d7c13f283fd$var$workInProgressTransitions = null, $c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed = null, $c2f83d7c13f283fd$var$pendingEffectsStatus = 0, $c2f83d7c13f283fd$var$pendingEffectsRoot = null, $c2f83d7c13f283fd$var$pendingFinishedWork = null, $c2f83d7c13f283fd$var$pendingEffectsLanes = 0, $c2f83d7c13f283fd$var$pendingEffectsRemainingLanes = 0, $c2f83d7c13f283fd$var$pendingPassiveTransitions = null, $c2f83d7c13f283fd$var$pendingRecoverableErrors = null, $c2f83d7c13f283fd$var$nestedUpdateCount = 0, $c2f83d7c13f283fd$var$rootWithNestedUpdates = null;
function $c2f83d7c13f283fd$var$requestUpdateLane() {
    if (0 !== ($c2f83d7c13f283fd$var$executionContext & 2) && 0 !== $c2f83d7c13f283fd$var$workInProgressRootRenderLanes) return $c2f83d7c13f283fd$var$workInProgressRootRenderLanes & -$c2f83d7c13f283fd$var$workInProgressRootRenderLanes;
    if (null !== $c2f83d7c13f283fd$var$ReactSharedInternals.T) {
        var actionScopeLane = $c2f83d7c13f283fd$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $c2f83d7c13f283fd$var$requestTransitionLane();
    }
    return $c2f83d7c13f283fd$var$resolveUpdatePriority();
}
function $c2f83d7c13f283fd$var$requestDeferredLane() {
    0 === $c2f83d7c13f283fd$var$workInProgressDeferredLane && ($c2f83d7c13f283fd$var$workInProgressDeferredLane = 0 === ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 536870912) || $c2f83d7c13f283fd$var$isHydrating ? $c2f83d7c13f283fd$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $c2f83d7c13f283fd$var$workInProgressDeferredLane;
}
function $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c2f83d7c13f283fd$var$workInProgressRoot && (2 === $c2f83d7c13f283fd$var$workInProgressSuspendedReason || 9 === $c2f83d7c13f283fd$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $c2f83d7c13f283fd$var$prepareFreshStack(root, 0), $c2f83d7c13f283fd$var$markRootSuspended(root, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, !1);
    $c2f83d7c13f283fd$var$markRootUpdated$1(root, lane);
    if (0 === ($c2f83d7c13f283fd$var$executionContext & 2) || root !== $c2f83d7c13f283fd$var$workInProgressRoot) root === $c2f83d7c13f283fd$var$workInProgressRoot && (0 === ($c2f83d7c13f283fd$var$executionContext & 2) && ($c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c2f83d7c13f283fd$var$workInProgressRootExitStatus && $c2f83d7c13f283fd$var$markRootSuspended(root, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, !1)), $c2f83d7c13f283fd$var$ensureRootIsScheduled(root);
}
function $c2f83d7c13f283fd$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c2f83d7c13f283fd$var$executionContext & 6)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c2f83d7c13f283fd$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c2f83d7c13f283fd$var$renderRootConcurrent(root$jscomp$0, lanes) : $c2f83d7c13f283fd$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c2f83d7c13f283fd$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c2f83d7c13f283fd$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c2f83d7c13f283fd$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c2f83d7c13f283fd$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c2f83d7c13f283fd$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c2f83d7c13f283fd$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c2f83d7c13f283fd$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c2f83d7c13f283fd$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors;
                            $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors ? $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors.push.apply($c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c2f83d7c13f283fd$var$prepareFreshStack(root$jscomp$0, 0);
                $c2f83d7c13f283fd$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $c2f83d7c13f283fd$var$markRootSuspended(shouldTimeSlice, lanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, !$c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $c2f83d7c13f283fd$var$globalMostRecentFallbackTime + 300 - $c2f83d7c13f283fd$var$now(), 10 < exitStatus)) {
                    $c2f83d7c13f283fd$var$markRootSuspended(shouldTimeSlice, lanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, !$c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c2f83d7c13f283fd$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $c2f83d7c13f283fd$var$scheduleTimeout($c2f83d7c13f283fd$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors, $c2f83d7c13f283fd$var$workInProgressTransitions, $c2f83d7c13f283fd$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, $c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes, $c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes, $c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $c2f83d7c13f283fd$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors, $c2f83d7c13f283fd$var$workInProgressTransitions, $c2f83d7c13f283fd$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, $c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes, $c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes, $c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $c2f83d7c13f283fd$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c2f83d7c13f283fd$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($c2f83d7c13f283fd$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $c2f83d7c13f283fd$var$noop
        }, $c2f83d7c13f283fd$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $c2f83d7c13f283fd$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($c2f83d7c13f283fd$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $c2f83d7c13f283fd$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c2f83d7c13f283fd$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $c2f83d7c13f283fd$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c2f83d7c13f283fd$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c2f83d7c13f283fd$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c2f83d7c13f283fd$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $c2f83d7c13f283fd$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c2f83d7c13f283fd$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c2f83d7c13f283fd$var$flushSyncWork$1() {
    return 0 === ($c2f83d7c13f283fd$var$executionContext & 6) ? ($c2f83d7c13f283fd$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c2f83d7c13f283fd$var$resetWorkInProgressStack() {
    if (null !== $c2f83d7c13f283fd$var$workInProgress) {
        if (0 === $c2f83d7c13f283fd$var$workInProgressSuspendedReason) var interruptedWork = $c2f83d7c13f283fd$var$workInProgress.return;
        else interruptedWork = $c2f83d7c13f283fd$var$workInProgress, $c2f83d7c13f283fd$var$lastContextDependency = $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 = null, $c2f83d7c13f283fd$var$resetHooksOnUnwind(interruptedWork), $c2f83d7c13f283fd$var$thenableState = null, $c2f83d7c13f283fd$var$thenableIndexCounter = 0, interruptedWork = $c2f83d7c13f283fd$var$workInProgress;
        for(; null !== interruptedWork;)$c2f83d7c13f283fd$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c2f83d7c13f283fd$var$workInProgress = null;
    }
}
function $c2f83d7c13f283fd$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c2f83d7c13f283fd$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c2f83d7c13f283fd$var$resetWorkInProgressStack();
    $c2f83d7c13f283fd$var$workInProgressRoot = root;
    $c2f83d7c13f283fd$var$workInProgress = timeoutHandle = $c2f83d7c13f283fd$var$createWorkInProgress(root.current, null);
    $c2f83d7c13f283fd$var$workInProgressRootRenderLanes = lanes;
    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
    $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
    $c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c2f83d7c13f283fd$var$workInProgressRootIsPrerendering = $c2f83d7c13f283fd$var$checkIfRootIsPrerendering(root, lanes);
    $c2f83d7c13f283fd$var$workInProgressRootDidAttachPingListener = !1;
    $c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes = $c2f83d7c13f283fd$var$workInProgressDeferredLane = $c2f83d7c13f283fd$var$workInProgressRootPingedLanes = $c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes = $c2f83d7c13f283fd$var$workInProgressRootSkippedLanes = $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 0;
    $c2f83d7c13f283fd$var$workInProgressRootRecoverableErrors = $c2f83d7c13f283fd$var$workInProgressRootConcurrentErrors = null;
    $c2f83d7c13f283fd$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $c2f83d7c13f283fd$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $c2f83d7c13f283fd$var$entangledRenderLanes = lanes;
    $c2f83d7c13f283fd$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c2f83d7c13f283fd$var$handleThrow(root, thrownValue) {
    $c2f83d7c13f283fd$var$currentlyRenderingFiber = null;
    $c2f83d7c13f283fd$var$ReactSharedInternals.H = $c2f83d7c13f283fd$var$ContextOnlyDispatcher;
    thrownValue === $c2f83d7c13f283fd$var$SuspenseException || thrownValue === $c2f83d7c13f283fd$var$SuspenseActionException ? (thrownValue = $c2f83d7c13f283fd$var$getSuspendedThenable(), $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 3) : thrownValue === $c2f83d7c13f283fd$var$SuspenseyCommitException ? (thrownValue = $c2f83d7c13f283fd$var$getSuspendedThenable(), $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 4) : $c2f83d7c13f283fd$var$workInProgressSuspendedReason = thrownValue === $c2f83d7c13f283fd$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $4TMho._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $c2f83d7c13f283fd$var$workInProgressThrownValue = thrownValue;
    null === $c2f83d7c13f283fd$var$workInProgress && ($c2f83d7c13f283fd$var$workInProgressRootExitStatus = 1, $c2f83d7c13f283fd$var$logUncaughtError(root, $c2f83d7c13f283fd$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c2f83d7c13f283fd$var$pushDispatcher() {
    var prevDispatcher = $c2f83d7c13f283fd$var$ReactSharedInternals.H;
    $c2f83d7c13f283fd$var$ReactSharedInternals.H = $c2f83d7c13f283fd$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c2f83d7c13f283fd$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c2f83d7c13f283fd$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c2f83d7c13f283fd$var$ReactSharedInternals.A;
    $c2f83d7c13f283fd$var$ReactSharedInternals.A = $c2f83d7c13f283fd$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c2f83d7c13f283fd$var$renderDidSuspendDelayIfPossible() {
    $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 4;
    $c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings || ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 4194048) !== $c2f83d7c13f283fd$var$workInProgressRootRenderLanes && null !== $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current || ($c2f83d7c13f283fd$var$workInProgressRootIsPrerendering = !0);
    0 === ($c2f83d7c13f283fd$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c2f83d7c13f283fd$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c2f83d7c13f283fd$var$workInProgressRoot || $c2f83d7c13f283fd$var$markRootSuspended($c2f83d7c13f283fd$var$workInProgressRoot, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes, $c2f83d7c13f283fd$var$workInProgressDeferredLane, !1);
}
function $c2f83d7c13f283fd$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c2f83d7c13f283fd$var$executionContext;
    $c2f83d7c13f283fd$var$executionContext |= 2;
    var prevDispatcher = $c2f83d7c13f283fd$var$pushDispatcher(), prevAsyncDispatcher = $c2f83d7c13f283fd$var$pushAsyncDispatcher();
    if ($c2f83d7c13f283fd$var$workInProgressRoot !== root || $c2f83d7c13f283fd$var$workInProgressRootRenderLanes !== lanes) $c2f83d7c13f283fd$var$workInProgressTransitions = null, $c2f83d7c13f283fd$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c2f83d7c13f283fd$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c2f83d7c13f283fd$var$workInProgressSuspendedReason && null !== $c2f83d7c13f283fd$var$workInProgress) {
            var unitOfWork = $c2f83d7c13f283fd$var$workInProgress, thrownValue = $c2f83d7c13f283fd$var$workInProgressThrownValue;
            switch($c2f83d7c13f283fd$var$workInProgressSuspendedReason){
                case 8:
                    $c2f83d7c13f283fd$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c2f83d7c13f283fd$var$workInProgressSuspendedReason;
                    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
                    $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
                    $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c2f83d7c13f283fd$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c2f83d7c13f283fd$var$workInProgressSuspendedReason, $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0, $c2f83d7c13f283fd$var$workInProgressThrownValue = null, $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c2f83d7c13f283fd$var$workLoopSync();
        exitStatus = $c2f83d7c13f283fd$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $c2f83d7c13f283fd$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c2f83d7c13f283fd$var$lastContextDependency = $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 = null;
    $c2f83d7c13f283fd$var$executionContext = prevExecutionContext;
    $c2f83d7c13f283fd$var$ReactSharedInternals.H = prevDispatcher;
    $c2f83d7c13f283fd$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c2f83d7c13f283fd$var$workInProgress && ($c2f83d7c13f283fd$var$workInProgressRoot = null, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes = 0, $c2f83d7c13f283fd$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c2f83d7c13f283fd$var$workLoopSync() {
    for(; null !== $c2f83d7c13f283fd$var$workInProgress;)$c2f83d7c13f283fd$var$performUnitOfWork($c2f83d7c13f283fd$var$workInProgress);
}
function $c2f83d7c13f283fd$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c2f83d7c13f283fd$var$executionContext;
    $c2f83d7c13f283fd$var$executionContext |= 2;
    var prevDispatcher = $c2f83d7c13f283fd$var$pushDispatcher(), prevAsyncDispatcher = $c2f83d7c13f283fd$var$pushAsyncDispatcher();
    $c2f83d7c13f283fd$var$workInProgressRoot !== root || $c2f83d7c13f283fd$var$workInProgressRootRenderLanes !== lanes ? ($c2f83d7c13f283fd$var$workInProgressTransitions = null, $c2f83d7c13f283fd$var$workInProgressRootRenderTargetTime = $c2f83d7c13f283fd$var$now() + 500, $c2f83d7c13f283fd$var$prepareFreshStack(root, lanes)) : $c2f83d7c13f283fd$var$workInProgressRootIsPrerendering = $c2f83d7c13f283fd$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c2f83d7c13f283fd$var$workInProgressSuspendedReason && null !== $c2f83d7c13f283fd$var$workInProgress) {
            lanes = $c2f83d7c13f283fd$var$workInProgress;
            var thrownValue = $c2f83d7c13f283fd$var$workInProgressThrownValue;
            b: switch($c2f83d7c13f283fd$var$workInProgressSuspendedReason){
                case 1:
                    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
                    $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
                    $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($c2f83d7c13f283fd$var$isThenableResolved(thrownValue)) {
                        $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
                        $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
                        $c2f83d7c13f283fd$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 !== $c2f83d7c13f283fd$var$workInProgressSuspendedReason && 9 !== $c2f83d7c13f283fd$var$workInProgressSuspendedReason || $c2f83d7c13f283fd$var$workInProgressRoot !== root || ($c2f83d7c13f283fd$var$workInProgressSuspendedReason = 7);
                        $c2f83d7c13f283fd$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c2f83d7c13f283fd$var$isThenableResolved(thrownValue) ? ($c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0, $c2f83d7c13f283fd$var$workInProgressThrownValue = null, $c2f83d7c13f283fd$var$replaySuspendedUnitOfWork(lanes)) : ($c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0, $c2f83d7c13f283fd$var$workInProgressThrownValue = null, $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c2f83d7c13f283fd$var$workInProgress.tag){
                        case 26:
                            resource = $c2f83d7c13f283fd$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c2f83d7c13f283fd$var$workInProgress;
                            if (resource ? $c2f83d7c13f283fd$var$preloadResource(resource) : 1) {
                                $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
                                $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c2f83d7c13f283fd$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c2f83d7c13f283fd$var$workInProgress = returnFiber, $c2f83d7c13f283fd$var$completeUnitOfWork(returnFiber)) : $c2f83d7c13f283fd$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
                    $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
                    $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c2f83d7c13f283fd$var$workInProgressSuspendedReason = 0;
                    $c2f83d7c13f283fd$var$workInProgressThrownValue = null;
                    $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c2f83d7c13f283fd$var$resetWorkInProgressStack();
                    $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(462));
            }
        }
        $c2f83d7c13f283fd$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $c2f83d7c13f283fd$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $c2f83d7c13f283fd$var$lastContextDependency = $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 = null;
    $c2f83d7c13f283fd$var$ReactSharedInternals.H = prevDispatcher;
    $c2f83d7c13f283fd$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c2f83d7c13f283fd$var$executionContext = prevExecutionContext;
    if (null !== $c2f83d7c13f283fd$var$workInProgress) return 0;
    $c2f83d7c13f283fd$var$workInProgressRoot = null;
    $c2f83d7c13f283fd$var$workInProgressRootRenderLanes = 0;
    $c2f83d7c13f283fd$var$finishQueueingConcurrentUpdates();
    return $c2f83d7c13f283fd$var$workInProgressRootExitStatus;
}
function $c2f83d7c13f283fd$var$workLoopConcurrentByScheduler() {
    for(; null !== $c2f83d7c13f283fd$var$workInProgress && !$c2f83d7c13f283fd$var$shouldYield();)$c2f83d7c13f283fd$var$performUnitOfWork($c2f83d7c13f283fd$var$workInProgress);
}
function $c2f83d7c13f283fd$var$performUnitOfWork(unitOfWork) {
    var next = $c2f83d7c13f283fd$var$beginWork(unitOfWork.alternate, unitOfWork, $c2f83d7c13f283fd$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c2f83d7c13f283fd$var$completeUnitOfWork(unitOfWork) : $c2f83d7c13f283fd$var$workInProgress = next;
}
function $c2f83d7c13f283fd$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c2f83d7c13f283fd$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c2f83d7c13f283fd$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c2f83d7c13f283fd$var$resetHooksOnUnwind(next);
        default:
            $c2f83d7c13f283fd$var$unwindInterruptedWork(current, next), next = $c2f83d7c13f283fd$var$workInProgress = $c2f83d7c13f283fd$var$resetWorkInProgress(next, $c2f83d7c13f283fd$var$entangledRenderLanes), next = $c2f83d7c13f283fd$var$beginWork(current, next, $c2f83d7c13f283fd$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c2f83d7c13f283fd$var$completeUnitOfWork(unitOfWork) : $c2f83d7c13f283fd$var$workInProgress = next;
}
function $c2f83d7c13f283fd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c2f83d7c13f283fd$var$lastContextDependency = $c2f83d7c13f283fd$var$currentlyRenderingFiber$1 = null;
    $c2f83d7c13f283fd$var$resetHooksOnUnwind(unitOfWork);
    $c2f83d7c13f283fd$var$thenableState = null;
    $c2f83d7c13f283fd$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c2f83d7c13f283fd$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes)) {
            $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 1;
            $c2f83d7c13f283fd$var$logUncaughtError(root, $c2f83d7c13f283fd$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c2f83d7c13f283fd$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c2f83d7c13f283fd$var$workInProgress = returnFiber, error;
        $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 1;
        $c2f83d7c13f283fd$var$logUncaughtError(root, $c2f83d7c13f283fd$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c2f83d7c13f283fd$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c2f83d7c13f283fd$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c2f83d7c13f283fd$var$workInProgressRootIsPrerendering || 0 !== ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c2f83d7c13f283fd$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c2f83d7c13f283fd$var$unwindUnitOfWork(unitOfWork, root);
    } else $c2f83d7c13f283fd$var$completeUnitOfWork(unitOfWork);
}
function $c2f83d7c13f283fd$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c2f83d7c13f283fd$var$unwindUnitOfWork(completedWork, $c2f83d7c13f283fd$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c2f83d7c13f283fd$var$completeWork(completedWork.alternate, completedWork, $c2f83d7c13f283fd$var$entangledRenderLanes);
        if (null !== next) {
            $c2f83d7c13f283fd$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c2f83d7c13f283fd$var$workInProgress = completedWork;
            return;
        }
        $c2f83d7c13f283fd$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c2f83d7c13f283fd$var$workInProgressRootExitStatus && ($c2f83d7c13f283fd$var$workInProgressRootExitStatus = 5);
}
function $c2f83d7c13f283fd$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c2f83d7c13f283fd$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c2f83d7c13f283fd$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c2f83d7c13f283fd$var$workInProgress = unitOfWork;
            return;
        }
        $c2f83d7c13f283fd$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c2f83d7c13f283fd$var$workInProgressRootExitStatus = 6;
    $c2f83d7c13f283fd$var$workInProgress = null;
}
function $c2f83d7c13f283fd$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $c2f83d7c13f283fd$var$flushPendingEffects();
    while (0 !== $c2f83d7c13f283fd$var$pendingEffectsStatus);
    if (0 !== ($c2f83d7c13f283fd$var$executionContext & 6)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $c2f83d7c13f283fd$var$concurrentlyUpdatedLanes;
        $c2f83d7c13f283fd$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $c2f83d7c13f283fd$var$workInProgressRoot && ($c2f83d7c13f283fd$var$workInProgress = $c2f83d7c13f283fd$var$workInProgressRoot = null, $c2f83d7c13f283fd$var$workInProgressRootRenderLanes = 0);
        $c2f83d7c13f283fd$var$pendingFinishedWork = finishedWork;
        $c2f83d7c13f283fd$var$pendingEffectsRoot = root;
        $c2f83d7c13f283fd$var$pendingEffectsLanes = lanes;
        $c2f83d7c13f283fd$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $c2f83d7c13f283fd$var$pendingPassiveTransitions = transitions;
        $c2f83d7c13f283fd$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $c2f83d7c13f283fd$var$scheduleCallback$1($c2f83d7c13f283fd$var$NormalPriority$1, function() {
            $c2f83d7c13f283fd$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $c2f83d7c13f283fd$var$ReactSharedInternals.T;
            $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
            transitions = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
            $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $c2f83d7c13f283fd$var$executionContext;
            $c2f83d7c13f283fd$var$executionContext |= 4;
            try {
                $c2f83d7c13f283fd$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $c2f83d7c13f283fd$var$executionContext = spawnedLane, $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = transitions, $c2f83d7c13f283fd$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 1;
        $c2f83d7c13f283fd$var$flushMutationEffects();
        $c2f83d7c13f283fd$var$flushLayoutEffects();
        $c2f83d7c13f283fd$var$flushSpawnedWork();
    }
}
function $c2f83d7c13f283fd$var$flushMutationEffects() {
    if (1 === $c2f83d7c13f283fd$var$pendingEffectsStatus) {
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 0;
        var root = $c2f83d7c13f283fd$var$pendingEffectsRoot, finishedWork = $c2f83d7c13f283fd$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $c2f83d7c13f283fd$var$ReactSharedInternals.T;
            $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
            var previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
            $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c2f83d7c13f283fd$var$executionContext;
            $c2f83d7c13f283fd$var$executionContext |= 4;
            try {
                $c2f83d7c13f283fd$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $c2f83d7c13f283fd$var$selectionInformation, curFocusedElem = $c2f83d7c13f283fd$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $c2f83d7c13f283fd$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $c2f83d7c13f283fd$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $c2f83d7c13f283fd$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $c2f83d7c13f283fd$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $c2f83d7c13f283fd$var$_enabled = !!$c2f83d7c13f283fd$var$eventsEnabled;
                $c2f83d7c13f283fd$var$selectionInformation = $c2f83d7c13f283fd$var$eventsEnabled = null;
            } finally{
                $c2f83d7c13f283fd$var$executionContext = prevExecutionContext, $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority, $c2f83d7c13f283fd$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 2;
    }
}
function $c2f83d7c13f283fd$var$flushLayoutEffects() {
    if (2 === $c2f83d7c13f283fd$var$pendingEffectsStatus) {
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 0;
        var root = $c2f83d7c13f283fd$var$pendingEffectsRoot, finishedWork = $c2f83d7c13f283fd$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $c2f83d7c13f283fd$var$ReactSharedInternals.T;
            $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
            var previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
            $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c2f83d7c13f283fd$var$executionContext;
            $c2f83d7c13f283fd$var$executionContext |= 4;
            try {
                $c2f83d7c13f283fd$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $c2f83d7c13f283fd$var$executionContext = prevExecutionContext, $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority, $c2f83d7c13f283fd$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 3;
    }
}
function $c2f83d7c13f283fd$var$flushSpawnedWork() {
    if (4 === $c2f83d7c13f283fd$var$pendingEffectsStatus || 3 === $c2f83d7c13f283fd$var$pendingEffectsStatus) {
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 0;
        $c2f83d7c13f283fd$var$requestPaint();
        var root = $c2f83d7c13f283fd$var$pendingEffectsRoot, finishedWork = $c2f83d7c13f283fd$var$pendingFinishedWork, lanes = $c2f83d7c13f283fd$var$pendingEffectsLanes, recoverableErrors = $c2f83d7c13f283fd$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $c2f83d7c13f283fd$var$pendingEffectsStatus = 5 : ($c2f83d7c13f283fd$var$pendingEffectsStatus = 0, $c2f83d7c13f283fd$var$pendingFinishedWork = $c2f83d7c13f283fd$var$pendingEffectsRoot = null, $c2f83d7c13f283fd$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $c2f83d7c13f283fd$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($c2f83d7c13f283fd$var$injectedHook && "function" === typeof $c2f83d7c13f283fd$var$injectedHook.onCommitFiberRoot) try {
            $c2f83d7c13f283fd$var$injectedHook.onCommitFiberRoot($c2f83d7c13f283fd$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $c2f83d7c13f283fd$var$ReactSharedInternals.T;
            remainingLanes = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
            $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 2;
            $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $c2f83d7c13f283fd$var$ReactSharedInternals.T = finishedWork, $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($c2f83d7c13f283fd$var$pendingEffectsLanes & 3) && $c2f83d7c13f283fd$var$flushPendingEffects();
        $c2f83d7c13f283fd$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $c2f83d7c13f283fd$var$rootWithNestedUpdates ? $c2f83d7c13f283fd$var$nestedUpdateCount++ : ($c2f83d7c13f283fd$var$nestedUpdateCount = 0, $c2f83d7c13f283fd$var$rootWithNestedUpdates = root) : $c2f83d7c13f283fd$var$nestedUpdateCount = 0;
        $c2f83d7c13f283fd$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $c2f83d7c13f283fd$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c2f83d7c13f283fd$var$releaseCache(remainingLanes)));
}
function $c2f83d7c13f283fd$var$flushPendingEffects(wasDelayedCommit) {
    $c2f83d7c13f283fd$var$flushMutationEffects();
    $c2f83d7c13f283fd$var$flushLayoutEffects();
    $c2f83d7c13f283fd$var$flushSpawnedWork();
    return $c2f83d7c13f283fd$var$flushPassiveEffects(wasDelayedCommit);
}
function $c2f83d7c13f283fd$var$flushPassiveEffects() {
    if (5 !== $c2f83d7c13f283fd$var$pendingEffectsStatus) return !1;
    var root = $c2f83d7c13f283fd$var$pendingEffectsRoot, remainingLanes = $c2f83d7c13f283fd$var$pendingEffectsRemainingLanes;
    $c2f83d7c13f283fd$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $c2f83d7c13f283fd$var$lanesToEventPriority($c2f83d7c13f283fd$var$pendingEffectsLanes), prevTransition = $c2f83d7c13f283fd$var$ReactSharedInternals.T, previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
    try {
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
        renderPriority = $c2f83d7c13f283fd$var$pendingPassiveTransitions;
        $c2f83d7c13f283fd$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $c2f83d7c13f283fd$var$pendingEffectsRoot, lanes = $c2f83d7c13f283fd$var$pendingEffectsLanes;
        $c2f83d7c13f283fd$var$pendingEffectsStatus = 0;
        $c2f83d7c13f283fd$var$pendingFinishedWork = $c2f83d7c13f283fd$var$pendingEffectsRoot = null;
        $c2f83d7c13f283fd$var$pendingEffectsLanes = 0;
        if (0 !== ($c2f83d7c13f283fd$var$executionContext & 6)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(331));
        var prevExecutionContext = $c2f83d7c13f283fd$var$executionContext;
        $c2f83d7c13f283fd$var$executionContext |= 4;
        $c2f83d7c13f283fd$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $c2f83d7c13f283fd$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $c2f83d7c13f283fd$var$executionContext = prevExecutionContext;
        $c2f83d7c13f283fd$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($c2f83d7c13f283fd$var$injectedHook && "function" === typeof $c2f83d7c13f283fd$var$injectedHook.onPostCommitFiberRoot) try {
            $c2f83d7c13f283fd$var$injectedHook.onPostCommitFiberRoot($c2f83d7c13f283fd$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority, $c2f83d7c13f283fd$var$ReactSharedInternals.T = prevTransition, $c2f83d7c13f283fd$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $c2f83d7c13f283fd$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c2f83d7c13f283fd$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c2f83d7c13f283fd$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c2f83d7c13f283fd$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c2f83d7c13f283fd$var$markRootUpdated$1(rootFiber, 2), $c2f83d7c13f283fd$var$ensureRootIsScheduled(rootFiber));
}
function $c2f83d7c13f283fd$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c2f83d7c13f283fd$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c2f83d7c13f283fd$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed || !$c2f83d7c13f283fd$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c2f83d7c13f283fd$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c2f83d7c13f283fd$var$createClassErrorUpdate(2);
                instance = $c2f83d7c13f283fd$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c2f83d7c13f283fd$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c2f83d7c13f283fd$var$markRootUpdated$1(instance, 2), $c2f83d7c13f283fd$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c2f83d7c13f283fd$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c2f83d7c13f283fd$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c2f83d7c13f283fd$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c2f83d7c13f283fd$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c2f83d7c13f283fd$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c2f83d7c13f283fd$var$workInProgressRoot === root && ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c2f83d7c13f283fd$var$workInProgressRootExitStatus || 3 === $c2f83d7c13f283fd$var$workInProgressRootExitStatus && ($c2f83d7c13f283fd$var$workInProgressRootRenderLanes & 62914560) === $c2f83d7c13f283fd$var$workInProgressRootRenderLanes && 300 > $c2f83d7c13f283fd$var$now() - $c2f83d7c13f283fd$var$globalMostRecentFallbackTime ? 0 === ($c2f83d7c13f283fd$var$executionContext & 2) && $c2f83d7c13f283fd$var$prepareFreshStack(root, 0) : $c2f83d7c13f283fd$var$workInProgressRootPingedLanes |= pingedLanes, $c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes === $c2f83d7c13f283fd$var$workInProgressRootRenderLanes && ($c2f83d7c13f283fd$var$workInProgressSuspendedRetryLanes = 0));
    $c2f83d7c13f283fd$var$ensureRootIsScheduled(root);
}
function $c2f83d7c13f283fd$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c2f83d7c13f283fd$var$claimNextRetryLane());
    boundaryFiber = $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c2f83d7c13f283fd$var$markRootUpdated$1(boundaryFiber, retryLane), $c2f83d7c13f283fd$var$ensureRootIsScheduled(boundaryFiber));
}
function $c2f83d7c13f283fd$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c2f83d7c13f283fd$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c2f83d7c13f283fd$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c2f83d7c13f283fd$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c2f83d7c13f283fd$var$scheduleCallback$1(priorityLevel, callback) {
    return $c2f83d7c13f283fd$var$scheduleCallback$3(priorityLevel, callback);
}
var $c2f83d7c13f283fd$var$firstScheduledRoot = null, $c2f83d7c13f283fd$var$lastScheduledRoot = null, $c2f83d7c13f283fd$var$didScheduleMicrotask = !1, $c2f83d7c13f283fd$var$mightHavePendingSyncWork = !1, $c2f83d7c13f283fd$var$isFlushingWork = !1, $c2f83d7c13f283fd$var$currentEventTransitionLane = 0;
function $c2f83d7c13f283fd$var$ensureRootIsScheduled(root) {
    root !== $c2f83d7c13f283fd$var$lastScheduledRoot && null === root.next && (null === $c2f83d7c13f283fd$var$lastScheduledRoot ? $c2f83d7c13f283fd$var$firstScheduledRoot = $c2f83d7c13f283fd$var$lastScheduledRoot = root : $c2f83d7c13f283fd$var$lastScheduledRoot = $c2f83d7c13f283fd$var$lastScheduledRoot.next = root);
    $c2f83d7c13f283fd$var$mightHavePendingSyncWork = !0;
    $c2f83d7c13f283fd$var$didScheduleMicrotask || ($c2f83d7c13f283fd$var$didScheduleMicrotask = !0, $c2f83d7c13f283fd$var$scheduleImmediateRootScheduleTask());
}
function $c2f83d7c13f283fd$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c2f83d7c13f283fd$var$isFlushingWork && $c2f83d7c13f283fd$var$mightHavePendingSyncWork) {
        $c2f83d7c13f283fd$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $c2f83d7c13f283fd$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c2f83d7c13f283fd$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c2f83d7c13f283fd$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c2f83d7c13f283fd$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c2f83d7c13f283fd$var$getNextLanes(root$174, root$174 === $c2f83d7c13f283fd$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $c2f83d7c13f283fd$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c2f83d7c13f283fd$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $c2f83d7c13f283fd$var$isFlushingWork = !1;
    }
}
function $c2f83d7c13f283fd$var$processRootScheduleInImmediateTask() {
    $c2f83d7c13f283fd$var$processRootScheduleInMicrotask();
}
function $c2f83d7c13f283fd$var$processRootScheduleInMicrotask() {
    $c2f83d7c13f283fd$var$mightHavePendingSyncWork = $c2f83d7c13f283fd$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c2f83d7c13f283fd$var$currentEventTransitionLane && ($c2f83d7c13f283fd$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c2f83d7c13f283fd$var$currentEventTransitionLane), $c2f83d7c13f283fd$var$currentEventTransitionLane = 0);
    for(var currentTime = $c2f83d7c13f283fd$var$now(), prev = null, root = $c2f83d7c13f283fd$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c2f83d7c13f283fd$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c2f83d7c13f283fd$var$firstScheduledRoot = next : prev.next = next, null === next && ($c2f83d7c13f283fd$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c2f83d7c13f283fd$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $c2f83d7c13f283fd$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $c2f83d7c13f283fd$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $c2f83d7c13f283fd$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $c2f83d7c13f283fd$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c2f83d7c13f283fd$var$workInProgressRoot;
    suspendedLanes = $c2f83d7c13f283fd$var$workInProgressRootRenderLanes;
    suspendedLanes = $c2f83d7c13f283fd$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $c2f83d7c13f283fd$var$workInProgressSuspendedReason || 9 === $c2f83d7c13f283fd$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c2f83d7c13f283fd$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c2f83d7c13f283fd$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c2f83d7c13f283fd$var$cancelCallback$1(pingedLanes);
        switch($c2f83d7c13f283fd$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c2f83d7c13f283fd$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c2f83d7c13f283fd$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c2f83d7c13f283fd$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c2f83d7c13f283fd$var$NormalPriority$1;
        }
        pingedLanes = $c2f83d7c13f283fd$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c2f83d7c13f283fd$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c2f83d7c13f283fd$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c2f83d7c13f283fd$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $c2f83d7c13f283fd$var$pendingEffectsStatus && 5 !== $c2f83d7c13f283fd$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($c2f83d7c13f283fd$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c2f83d7c13f283fd$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c2f83d7c13f283fd$var$getNextLanes(root, root === $c2f83d7c13f283fd$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c2f83d7c13f283fd$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c2f83d7c13f283fd$var$scheduleTaskForRootDuringMicrotask(root, $c2f83d7c13f283fd$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c2f83d7c13f283fd$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c2f83d7c13f283fd$var$performSyncWorkOnRoot(root, lanes) {
    if ($c2f83d7c13f283fd$var$flushPendingEffects()) return null;
    $c2f83d7c13f283fd$var$performWorkOnRoot(root, lanes, !0);
}
function $c2f83d7c13f283fd$var$scheduleImmediateRootScheduleTask() {
    $c2f83d7c13f283fd$var$scheduleMicrotask(function() {
        0 !== ($c2f83d7c13f283fd$var$executionContext & 6) ? $c2f83d7c13f283fd$var$scheduleCallback$3($c2f83d7c13f283fd$var$ImmediatePriority, $c2f83d7c13f283fd$var$processRootScheduleInImmediateTask) : $c2f83d7c13f283fd$var$processRootScheduleInMicrotask();
    });
}
function $c2f83d7c13f283fd$var$requestTransitionLane() {
    0 === $c2f83d7c13f283fd$var$currentEventTransitionLane && ($c2f83d7c13f283fd$var$currentEventTransitionLane = $c2f83d7c13f283fd$var$claimNextTransitionLane());
    return $c2f83d7c13f283fd$var$currentEventTransitionLane;
}
function $c2f83d7c13f283fd$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $4TMho._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c2f83d7c13f283fd$var$sanitizeURL("" + actionProp);
}
function $c2f83d7c13f283fd$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c2f83d7c13f283fd$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c2f83d7c13f283fd$var$coerceFormActionProp((nativeEventTarget[$c2f83d7c13f283fd$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c2f83d7c13f283fd$var$internalPropsKey] || null) ? $c2f83d7c13f283fd$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c2f83d7c13f283fd$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c2f83d7c13f283fd$var$currentEventTransitionLane) {
                                var formData = submitter ? $c2f83d7c13f283fd$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c2f83d7c13f283fd$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c2f83d7c13f283fd$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c2f83d7c13f283fd$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c2f83d7c13f283fd$var$i$jscomp$inline_1528 = 0; $c2f83d7c13f283fd$var$i$jscomp$inline_1528 < $c2f83d7c13f283fd$var$simpleEventPluginEvents.length; $c2f83d7c13f283fd$var$i$jscomp$inline_1528++){
    var $c2f83d7c13f283fd$var$eventName$jscomp$inline_1529 = $c2f83d7c13f283fd$var$simpleEventPluginEvents[$c2f83d7c13f283fd$var$i$jscomp$inline_1528], $c2f83d7c13f283fd$var$domEventName$jscomp$inline_1530 = $c2f83d7c13f283fd$var$eventName$jscomp$inline_1529.toLowerCase(), $c2f83d7c13f283fd$var$capitalizedEvent$jscomp$inline_1531 = $c2f83d7c13f283fd$var$eventName$jscomp$inline_1529[0].toUpperCase() + $c2f83d7c13f283fd$var$eventName$jscomp$inline_1529.slice(1);
    $c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$domEventName$jscomp$inline_1530, "on" + $c2f83d7c13f283fd$var$capitalizedEvent$jscomp$inline_1531);
}
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$ANIMATION_END, "onAnimationEnd");
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$ANIMATION_ITERATION, "onAnimationIteration");
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$ANIMATION_START, "onAnimationStart");
$c2f83d7c13f283fd$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c2f83d7c13f283fd$var$registerSimpleEvent("focusin", "onFocus");
$c2f83d7c13f283fd$var$registerSimpleEvent("focusout", "onBlur");
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$TRANSITION_RUN, "onTransitionRun");
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$TRANSITION_START, "onTransitionStart");
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$TRANSITION_CANCEL, "onTransitionCancel");
$c2f83d7c13f283fd$var$registerSimpleEvent($c2f83d7c13f283fd$var$TRANSITION_END, "onTransitionEnd");
$c2f83d7c13f283fd$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c2f83d7c13f283fd$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c2f83d7c13f283fd$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c2f83d7c13f283fd$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c2f83d7c13f283fd$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c2f83d7c13f283fd$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c2f83d7c13f283fd$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c2f83d7c13f283fd$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c2f83d7c13f283fd$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c2f83d7c13f283fd$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c2f83d7c13f283fd$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c2f83d7c13f283fd$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c2f83d7c13f283fd$var$mediaEventTypes));
function $c2f83d7c13f283fd$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c2f83d7c13f283fd$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c2f83d7c13f283fd$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c2f83d7c13f283fd$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c2f83d7c13f283fd$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c2f83d7c13f283fd$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c2f83d7c13f283fd$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c2f83d7c13f283fd$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c2f83d7c13f283fd$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c2f83d7c13f283fd$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c2f83d7c13f283fd$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c2f83d7c13f283fd$var$listeningMarker]) {
        rootContainerElement[$c2f83d7c13f283fd$var$listeningMarker] = !0;
        $c2f83d7c13f283fd$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c2f83d7c13f283fd$var$nonDelegatedEvents.has(domEventName) || $c2f83d7c13f283fd$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c2f83d7c13f283fd$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c2f83d7c13f283fd$var$listeningMarker] || (ownerDocument[$c2f83d7c13f283fd$var$listeningMarker] = !0, $c2f83d7c13f283fd$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c2f83d7c13f283fd$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c2f83d7c13f283fd$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c2f83d7c13f283fd$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c2f83d7c13f283fd$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c2f83d7c13f283fd$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c2f83d7c13f283fd$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c2f83d7c13f283fd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c2f83d7c13f283fd$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c2f83d7c13f283fd$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c2f83d7c13f283fd$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c2f83d7c13f283fd$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c2f83d7c13f283fd$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticTouchEvent;
                        break;
                    case $c2f83d7c13f283fd$var$ANIMATION_END:
                    case $c2f83d7c13f283fd$var$ANIMATION_ITERATION:
                    case $c2f83d7c13f283fd$var$ANIMATION_START:
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticAnimationEvent;
                        break;
                    case $c2f83d7c13f283fd$var$TRANSITION_END:
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c2f83d7c13f283fd$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c2f83d7c13f283fd$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c2f83d7c13f283fd$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c2f83d7c13f283fd$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c2f83d7c13f283fd$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c2f83d7c13f283fd$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c2f83d7c13f283fd$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c2f83d7c13f283fd$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c2f83d7c13f283fd$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c2f83d7c13f283fd$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c2f83d7c13f283fd$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c2f83d7c13f283fd$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c2f83d7c13f283fd$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $c2f83d7c13f283fd$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $c2f83d7c13f283fd$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $c2f83d7c13f283fd$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $c2f83d7c13f283fd$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $c2f83d7c13f283fd$var$getParent(inCapturePhase);
                                reactEventName = $c2f83d7c13f283fd$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c2f83d7c13f283fd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c2f83d7c13f283fd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c2f83d7c13f283fd$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c2f83d7c13f283fd$var$getTargetInstForChangeEvent;
                else if ($c2f83d7c13f283fd$var$isTextInputElement(reactName)) {
                    if ($c2f83d7c13f283fd$var$isInputEventSupported) getTargetInstFunc = $c2f83d7c13f283fd$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c2f83d7c13f283fd$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c2f83d7c13f283fd$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c2f83d7c13f283fd$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c2f83d7c13f283fd$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c2f83d7c13f283fd$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c2f83d7c13f283fd$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c2f83d7c13f283fd$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c2f83d7c13f283fd$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c2f83d7c13f283fd$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c2f83d7c13f283fd$var$activeElement = handleEventFunc, $c2f83d7c13f283fd$var$activeElementInst = targetInst, $c2f83d7c13f283fd$var$lastSelection = null;
                    break;
                case "focusout":
                    $c2f83d7c13f283fd$var$lastSelection = $c2f83d7c13f283fd$var$activeElementInst = $c2f83d7c13f283fd$var$activeElement = null;
                    break;
                case "mousedown":
                    $c2f83d7c13f283fd$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c2f83d7c13f283fd$var$mouseDown = !1;
                    $c2f83d7c13f283fd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c2f83d7c13f283fd$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c2f83d7c13f283fd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c2f83d7c13f283fd$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c2f83d7c13f283fd$var$isComposing ? $c2f83d7c13f283fd$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c2f83d7c13f283fd$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c2f83d7c13f283fd$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c2f83d7c13f283fd$var$isComposing && (fallbackData = $c2f83d7c13f283fd$var$getData()) : ($c2f83d7c13f283fd$var$root = nativeEventTarget, $c2f83d7c13f283fd$var$startText = "value" in $c2f83d7c13f283fd$var$root ? $c2f83d7c13f283fd$var$root.value : $c2f83d7c13f283fd$var$root.textContent, $c2f83d7c13f283fd$var$isComposing = !0)), handleEventFunc = $c2f83d7c13f283fd$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c2f83d7c13f283fd$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c2f83d7c13f283fd$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c2f83d7c13f283fd$var$canUseTextInputEvent ? $c2f83d7c13f283fd$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c2f83d7c13f283fd$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c2f83d7c13f283fd$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c2f83d7c13f283fd$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c2f83d7c13f283fd$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c2f83d7c13f283fd$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c2f83d7c13f283fd$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c2f83d7c13f283fd$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c2f83d7c13f283fd$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c2f83d7c13f283fd$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c2f83d7c13f283fd$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c2f83d7c13f283fd$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $c2f83d7c13f283fd$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c2f83d7c13f283fd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c2f83d7c13f283fd$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c2f83d7c13f283fd$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c2f83d7c13f283fd$var$getListener(target, registrationName), null != stateNode && listeners.push($c2f83d7c13f283fd$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c2f83d7c13f283fd$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c2f83d7c13f283fd$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c2f83d7c13f283fd$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c2f83d7c13f283fd$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c2f83d7c13f283fd$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c2f83d7c13f283fd$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c2f83d7c13f283fd$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c2f83d7c13f283fd$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c2f83d7c13f283fd$var$noop$1() {}
function $c2f83d7c13f283fd$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c2f83d7c13f283fd$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value))) && "body" !== tag && $c2f83d7c13f283fd$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c2f83d7c13f283fd$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c2f83d7c13f283fd$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c2f83d7c13f283fd$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c2f83d7c13f283fd$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c2f83d7c13f283fd$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c2f83d7c13f283fd$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c2f83d7c13f283fd$var$setProp(domElement, tag, "name", props.name, props, null), $c2f83d7c13f283fd$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c2f83d7c13f283fd$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c2f83d7c13f283fd$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c2f83d7c13f283fd$var$setProp(domElement, tag, "encType", props.encType, props, null), $c2f83d7c13f283fd$var$setProp(domElement, tag, "method", props.method, props, null), $c2f83d7c13f283fd$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c2f83d7c13f283fd$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c2f83d7c13f283fd$var$noop$1);
            break;
        case "onScroll":
            null != value && $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) || !("__html" in value)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c2f83d7c13f283fd$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("toggle", domElement);
            $c2f83d7c13f283fd$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c2f83d7c13f283fd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c2f83d7c13f283fd$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c2f83d7c13f283fd$var$aliases.get(key) || key, $c2f83d7c13f283fd$var$setValueForAttribute(domElement, key, value);
    }
}
function $c2f83d7c13f283fd$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c2f83d7c13f283fd$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) || !("__html" in value)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c2f83d7c13f283fd$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value))) && $c2f83d7c13f283fd$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c2f83d7c13f283fd$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c2f83d7c13f283fd$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c2f83d7c13f283fd$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c2f83d7c13f283fd$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c2f83d7c13f283fd$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("error", domElement);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(137, tag));
                    default:
                        $c2f83d7c13f283fd$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c2f83d7c13f283fd$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c2f83d7c13f283fd$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c2f83d7c13f283fd$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $c2f83d7c13f283fd$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $c2f83d7c13f283fd$var$track(domElement);
            return;
        case "select":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c2f83d7c13f283fd$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c2f83d7c13f283fd$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c2f83d7c13f283fd$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $c2f83d7c13f283fd$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $4TMho._)(hasSrc));
                    break;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("toggle", domElement);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("cancel", domElement);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c2f83d7c13f283fd$var$mediaEventTypes.length; hasSrc++)$c2f83d7c13f283fd$var$listenToNonDelegatedEvent($c2f83d7c13f283fd$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("error", domElement);
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("error", domElement), $c2f83d7c13f283fd$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(137, tag));
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c2f83d7c13f283fd$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $c2f83d7c13f283fd$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c2f83d7c13f283fd$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c2f83d7c13f283fd$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c2f83d7c13f283fd$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c2f83d7c13f283fd$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $c2f83d7c13f283fd$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c2f83d7c13f283fd$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c2f83d7c13f283fd$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $c2f83d7c13f283fd$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $c2f83d7c13f283fd$var$updateOptions(domElement, !!lastProps, tag, !0) : $c2f83d7c13f283fd$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c2f83d7c13f283fd$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c2f83d7c13f283fd$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== (typeof propKey$205 === "undefined" ? "undefined" : (0, $4TMho._)(propKey$205));
                    break;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $c2f83d7c13f283fd$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c2f83d7c13f283fd$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($c2f83d7c13f283fd$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $c2f83d7c13f283fd$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $c2f83d7c13f283fd$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $c2f83d7c13f283fd$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $c2f83d7c13f283fd$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $c2f83d7c13f283fd$var$eventsEnabled = null, $c2f83d7c13f283fd$var$selectionInformation = null;
function $c2f83d7c13f283fd$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c2f83d7c13f283fd$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c2f83d7c13f283fd$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c2f83d7c13f283fd$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $4TMho._)(props.children) || "object" === (0, $4TMho._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c2f83d7c13f283fd$var$currentPopstateTransitionEvent = null;
function $c2f83d7c13f283fd$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c2f83d7c13f283fd$var$currentPopstateTransitionEvent) return !1;
        $c2f83d7c13f283fd$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c2f83d7c13f283fd$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c2f83d7c13f283fd$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c2f83d7c13f283fd$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c2f83d7c13f283fd$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c2f83d7c13f283fd$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c2f83d7c13f283fd$var$localPromise ? function scheduleMicrotask(callback) {
    return $c2f83d7c13f283fd$var$localPromise.resolve(null).then(callback).catch($c2f83d7c13f283fd$var$handleErrorInNextTick);
} : $c2f83d7c13f283fd$var$scheduleTimeout;
function $c2f83d7c13f283fd$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c2f83d7c13f283fd$var$isSingletonScope(type) {
    return "head" === type;
}
function $c2f83d7c13f283fd$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $c2f83d7c13f283fd$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $c2f83d7c13f283fd$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $c2f83d7c13f283fd$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$c2f83d7c13f283fd$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c2f83d7c13f283fd$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $c2f83d7c13f283fd$var$retryIfBlockedOn(suspenseInstance);
}
function $c2f83d7c13f283fd$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c2f83d7c13f283fd$var$clearContainerSparingly(node);
                $c2f83d7c13f283fd$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c2f83d7c13f283fd$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c2f83d7c13f283fd$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c2f83d7c13f283fd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c2f83d7c13f283fd$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c2f83d7c13f283fd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c2f83d7c13f283fd$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $c2f83d7c13f283fd$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function listener1() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $c2f83d7c13f283fd$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $c2f83d7c13f283fd$var$previousHydratableOnEnteringScopedSingleton = null;
function $c2f83d7c13f283fd$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c2f83d7c13f283fd$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c2f83d7c13f283fd$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(451));
    }
}
function $c2f83d7c13f283fd$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $c2f83d7c13f283fd$var$detachDeletedInstance(instance);
}
var $c2f83d7c13f283fd$var$preloadPropsMap = new Map(), $c2f83d7c13f283fd$var$preconnectsSet = new Set();
function $c2f83d7c13f283fd$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $c2f83d7c13f283fd$var$previousDispatcher = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.d;
$c2f83d7c13f283fd$var$ReactDOMSharedInternals.d = {
    f: $c2f83d7c13f283fd$var$flushSyncWork,
    r: $c2f83d7c13f283fd$var$requestFormReset,
    D: $c2f83d7c13f283fd$var$prefetchDNS,
    C: $c2f83d7c13f283fd$var$preconnect,
    L: $c2f83d7c13f283fd$var$preload,
    m: $c2f83d7c13f283fd$var$preloadModule,
    X: $c2f83d7c13f283fd$var$preinitScript,
    S: $c2f83d7c13f283fd$var$preinitStyle,
    M: $c2f83d7c13f283fd$var$preinitModuleScript
};
function $c2f83d7c13f283fd$var$flushSyncWork() {
    var previousWasRendering = $c2f83d7c13f283fd$var$previousDispatcher.f(), wasRendering = $c2f83d7c13f283fd$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c2f83d7c13f283fd$var$requestFormReset(form) {
    var formInst = $c2f83d7c13f283fd$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c2f83d7c13f283fd$var$requestFormReset$1(formInst) : $c2f83d7c13f283fd$var$previousDispatcher.r(form);
}
var $c2f83d7c13f283fd$var$globalDocument = "undefined" === typeof document ? null : document;
function $c2f83d7c13f283fd$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c2f83d7c13f283fd$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c2f83d7c13f283fd$var$preconnectsSet.has(limitedEscapedHref) || ($c2f83d7c13f283fd$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c2f83d7c13f283fd$var$setInitialProperties(href, "link", rel), $c2f83d7c13f283fd$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c2f83d7c13f283fd$var$prefetchDNS(href) {
    $c2f83d7c13f283fd$var$previousDispatcher.D(href);
    $c2f83d7c13f283fd$var$preconnectAs("dns-prefetch", href, null);
}
function $c2f83d7c13f283fd$var$preconnect(href, crossOrigin) {
    $c2f83d7c13f283fd$var$previousDispatcher.C(href, crossOrigin);
    $c2f83d7c13f283fd$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c2f83d7c13f283fd$var$preload(href, as, options) {
    $c2f83d7c13f283fd$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c2f83d7c13f283fd$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c2f83d7c13f283fd$var$getStyleKey(href);
                break;
            case "script":
                key = $c2f83d7c13f283fd$var$getScriptKey(href);
        }
        $c2f83d7c13f283fd$var$preloadPropsMap.has(key) || (href = $c2f83d7c13f283fd$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c2f83d7c13f283fd$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c2f83d7c13f283fd$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c2f83d7c13f283fd$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c2f83d7c13f283fd$var$setInitialProperties(as, "link", href), $c2f83d7c13f283fd$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c2f83d7c13f283fd$var$preloadModule(href, options) {
    $c2f83d7c13f283fd$var$previousDispatcher.m(href, options);
    var ownerDocument = $c2f83d7c13f283fd$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c2f83d7c13f283fd$var$getScriptKey(href);
        }
        if (!$c2f83d7c13f283fd$var$preloadPropsMap.has(key) && (href = $c2f83d7c13f283fd$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c2f83d7c13f283fd$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c2f83d7c13f283fd$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c2f83d7c13f283fd$var$setInitialProperties(as, "link", href);
            $c2f83d7c13f283fd$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c2f83d7c13f283fd$var$preinitStyle(href, precedence, options) {
    $c2f83d7c13f283fd$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c2f83d7c13f283fd$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c2f83d7c13f283fd$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c2f83d7c13f283fd$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c2f83d7c13f283fd$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c2f83d7c13f283fd$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c2f83d7c13f283fd$var$preloadPropsMap.get(key)) && $c2f83d7c13f283fd$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c2f83d7c13f283fd$var$markNodeAsHoistable(link);
                $c2f83d7c13f283fd$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c2f83d7c13f283fd$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c2f83d7c13f283fd$var$preinitScript(src, options) {
    $c2f83d7c13f283fd$var$previousDispatcher.X(src, options);
    var ownerDocument = $c2f83d7c13f283fd$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c2f83d7c13f283fd$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c2f83d7c13f283fd$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c2f83d7c13f283fd$var$getScriptSelectorFromKey(key)), resource || (src = $c2f83d7c13f283fd$var$assign({
            src: src,
            async: !0
        }, options), (options = $c2f83d7c13f283fd$var$preloadPropsMap.get(key)) && $c2f83d7c13f283fd$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c2f83d7c13f283fd$var$markNodeAsHoistable(resource), $c2f83d7c13f283fd$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c2f83d7c13f283fd$var$preinitModuleScript(src, options) {
    $c2f83d7c13f283fd$var$previousDispatcher.M(src, options);
    var ownerDocument = $c2f83d7c13f283fd$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c2f83d7c13f283fd$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c2f83d7c13f283fd$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c2f83d7c13f283fd$var$getScriptSelectorFromKey(key)), resource || (src = $c2f83d7c13f283fd$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c2f83d7c13f283fd$var$preloadPropsMap.get(key)) && $c2f83d7c13f283fd$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c2f83d7c13f283fd$var$markNodeAsHoistable(resource), $c2f83d7c13f283fd$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c2f83d7c13f283fd$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c2f83d7c13f283fd$var$rootInstanceStackCursor.current) ? $c2f83d7c13f283fd$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c2f83d7c13f283fd$var$getStyleKey(pendingProps.href), pendingProps = $c2f83d7c13f283fd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c2f83d7c13f283fd$var$getStyleKey(pendingProps.href);
                var styles$244 = $c2f83d7c13f283fd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($c2f83d7c13f283fd$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $c2f83d7c13f283fd$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c2f83d7c13f283fd$var$preloadPropsMap.set(type, pendingProps), styles$244 || $c2f83d7c13f283fd$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $4TMho._)(currentProps)) ? (currentProps = $c2f83d7c13f283fd$var$getScriptKey(pendingProps), pendingProps = $c2f83d7c13f283fd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(444, type));
    }
}
function $c2f83d7c13f283fd$var$getStyleKey(href) {
    return 'href="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c2f83d7c13f283fd$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c2f83d7c13f283fd$var$stylesheetPropsFromRawProps(rawProps) {
    return $c2f83d7c13f283fd$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c2f83d7c13f283fd$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c2f83d7c13f283fd$var$setInitialProperties(key, "link", preloadProps), $c2f83d7c13f283fd$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c2f83d7c13f283fd$var$getScriptKey(src) {
    return '[src="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c2f83d7c13f283fd$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c2f83d7c13f283fd$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c2f83d7c13f283fd$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c2f83d7c13f283fd$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c2f83d7c13f283fd$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c2f83d7c13f283fd$var$markNodeAsHoistable(instance);
            $c2f83d7c13f283fd$var$setInitialProperties(instance, "style", styleProps);
            $c2f83d7c13f283fd$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c2f83d7c13f283fd$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($c2f83d7c13f283fd$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $c2f83d7c13f283fd$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $c2f83d7c13f283fd$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c2f83d7c13f283fd$var$preloadPropsMap.get(styleProps)) && $c2f83d7c13f283fd$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c2f83d7c13f283fd$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c2f83d7c13f283fd$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $c2f83d7c13f283fd$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $c2f83d7c13f283fd$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c2f83d7c13f283fd$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $c2f83d7c13f283fd$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c2f83d7c13f283fd$var$preloadPropsMap.get(instance$250)) instance = $c2f83d7c13f283fd$var$assign({}, props), $c2f83d7c13f283fd$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c2f83d7c13f283fd$var$markNodeAsHoistable(styleProps);
            $c2f83d7c13f283fd$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c2f83d7c13f283fd$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c2f83d7c13f283fd$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c2f83d7c13f283fd$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c2f83d7c13f283fd$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c2f83d7c13f283fd$var$tagCaches = null;
function $c2f83d7c13f283fd$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c2f83d7c13f283fd$var$tagCaches) {
        var cache = new Map();
        var caches = $c2f83d7c13f283fd$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c2f83d7c13f283fd$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c2f83d7c13f283fd$var$internalHoistableMarker] || node[$c2f83d7c13f283fd$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c2f83d7c13f283fd$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c2f83d7c13f283fd$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $4TMho._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c2f83d7c13f283fd$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $c2f83d7c13f283fd$var$suspendedState = null;
function $c2f83d7c13f283fd$var$noop() {}
function $c2f83d7c13f283fd$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $c2f83d7c13f283fd$var$suspendedState) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(475));
    var state = $c2f83d7c13f283fd$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c2f83d7c13f283fd$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c2f83d7c13f283fd$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $4TMho._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $c2f83d7c13f283fd$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c2f83d7c13f283fd$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c2f83d7c13f283fd$var$stylesheetPropsFromRawProps(props);
            (key = $c2f83d7c13f283fd$var$preloadPropsMap.get(key)) && $c2f83d7c13f283fd$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c2f83d7c13f283fd$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c2f83d7c13f283fd$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c2f83d7c13f283fd$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $c2f83d7c13f283fd$var$waitForCommitToBeReady() {
    if (null === $c2f83d7c13f283fd$var$suspendedState) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(475));
    var state = $c2f83d7c13f283fd$var$suspendedState;
    state.stylesheets && 0 === state.count && $c2f83d7c13f283fd$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c2f83d7c13f283fd$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $c2f83d7c13f283fd$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $c2f83d7c13f283fd$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c2f83d7c13f283fd$var$precedencesByRoot = null;
function $c2f83d7c13f283fd$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c2f83d7c13f283fd$var$precedencesByRoot = new Map(), resources.forEach($c2f83d7c13f283fd$var$insertStylesheetIntoRoot, state), $c2f83d7c13f283fd$var$precedencesByRoot = null, $c2f83d7c13f283fd$var$onUnsuspend.call(state));
}
function $c2f83d7c13f283fd$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c2f83d7c13f283fd$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c2f83d7c13f283fd$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c2f83d7c13f283fd$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c2f83d7c13f283fd$var$HostTransitionContext = {
    $$typeof: $c2f83d7c13f283fd$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c2f83d7c13f283fd$var$sharedNotPendingObject,
    _currentValue2: $c2f83d7c13f283fd$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c2f83d7c13f283fd$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c2f83d7c13f283fd$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c2f83d7c13f283fd$var$createLaneMap(0);
    this.hiddenUpdates = $c2f83d7c13f283fd$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c2f83d7c13f283fd$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $c2f83d7c13f283fd$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c2f83d7c13f283fd$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c2f83d7c13f283fd$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c2f83d7c13f283fd$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c2f83d7c13f283fd$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c2f83d7c13f283fd$var$emptyContextObject;
    parentComponent = $c2f83d7c13f283fd$var$emptyContextObject;
    return parentComponent;
}
function $c2f83d7c13f283fd$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c2f83d7c13f283fd$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c2f83d7c13f283fd$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c2f83d7c13f283fd$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c2f83d7c13f283fd$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c2f83d7c13f283fd$var$entangleTransitions(element, rootFiber, lane));
}
function $c2f83d7c13f283fd$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c2f83d7c13f283fd$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c2f83d7c13f283fd$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c2f83d7c13f283fd$var$markRetryLaneImpl(fiber, retryLane);
}
function $c2f83d7c13f283fd$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c2f83d7c13f283fd$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $c2f83d7c13f283fd$var$_enabled = !0;
function $c2f83d7c13f283fd$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c2f83d7c13f283fd$var$ReactSharedInternals.T;
    $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
    var previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
    try {
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 2, $c2f83d7c13f283fd$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority, $c2f83d7c13f283fd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2f83d7c13f283fd$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c2f83d7c13f283fd$var$ReactSharedInternals.T;
    $c2f83d7c13f283fd$var$ReactSharedInternals.T = null;
    var previousPriority = $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p;
    try {
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = 8, $c2f83d7c13f283fd$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c2f83d7c13f283fd$var$ReactDOMSharedInternals.p = previousPriority, $c2f83d7c13f283fd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2f83d7c13f283fd$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c2f83d7c13f283fd$var$_enabled) {
        var blockedOn = $c2f83d7c13f283fd$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c2f83d7c13f283fd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c2f83d7c13f283fd$var$return_targetInst, targetContainer), $c2f83d7c13f283fd$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c2f83d7c13f283fd$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c2f83d7c13f283fd$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c2f83d7c13f283fd$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c2f83d7c13f283fd$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c2f83d7c13f283fd$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c2f83d7c13f283fd$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c2f83d7c13f283fd$var$ensureRootIsScheduled(fiber);
                                0 === ($c2f83d7c13f283fd$var$executionContext & 6) && ($c2f83d7c13f283fd$var$workInProgressRootRenderTargetTime = $c2f83d7c13f283fd$var$now() + 500, $c2f83d7c13f283fd$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(root, fiber, 2), $c2f83d7c13f283fd$var$flushSyncWork$1(), $c2f83d7c13f283fd$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c2f83d7c13f283fd$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c2f83d7c13f283fd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c2f83d7c13f283fd$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c2f83d7c13f283fd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c2f83d7c13f283fd$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c2f83d7c13f283fd$var$getEventTarget(nativeEvent);
    return $c2f83d7c13f283fd$var$findInstanceBlockingTarget(nativeEvent);
}
var $c2f83d7c13f283fd$var$return_targetInst = null;
function $c2f83d7c13f283fd$var$findInstanceBlockingTarget(targetNode) {
    $c2f83d7c13f283fd$var$return_targetInst = null;
    targetNode = $c2f83d7c13f283fd$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c2f83d7c13f283fd$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c2f83d7c13f283fd$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c2f83d7c13f283fd$var$return_targetInst = targetNode;
    return null;
}
function $c2f83d7c13f283fd$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c2f83d7c13f283fd$var$getCurrentPriorityLevel()){
                case $c2f83d7c13f283fd$var$ImmediatePriority:
                    return 2;
                case $c2f83d7c13f283fd$var$UserBlockingPriority:
                    return 8;
                case $c2f83d7c13f283fd$var$NormalPriority$1:
                case $c2f83d7c13f283fd$var$LowPriority:
                    return 32;
                case $c2f83d7c13f283fd$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c2f83d7c13f283fd$var$hasScheduledReplayAttempt = !1, $c2f83d7c13f283fd$var$queuedFocus = null, $c2f83d7c13f283fd$var$queuedDrag = null, $c2f83d7c13f283fd$var$queuedMouse = null, $c2f83d7c13f283fd$var$queuedPointers = new Map(), $c2f83d7c13f283fd$var$queuedPointerCaptures = new Map(), $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets = [], $c2f83d7c13f283fd$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c2f83d7c13f283fd$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c2f83d7c13f283fd$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c2f83d7c13f283fd$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c2f83d7c13f283fd$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c2f83d7c13f283fd$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c2f83d7c13f283fd$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c2f83d7c13f283fd$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c2f83d7c13f283fd$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c2f83d7c13f283fd$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c2f83d7c13f283fd$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c2f83d7c13f283fd$var$queuedFocus = $c2f83d7c13f283fd$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2f83d7c13f283fd$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c2f83d7c13f283fd$var$queuedDrag = $c2f83d7c13f283fd$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2f83d7c13f283fd$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c2f83d7c13f283fd$var$queuedMouse = $c2f83d7c13f283fd$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2f83d7c13f283fd$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c2f83d7c13f283fd$var$queuedPointers.set(pointerId, $c2f83d7c13f283fd$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2f83d7c13f283fd$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c2f83d7c13f283fd$var$queuedPointerCaptures.set(pointerId, $c2f83d7c13f283fd$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2f83d7c13f283fd$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c2f83d7c13f283fd$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c2f83d7c13f283fd$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c2f83d7c13f283fd$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c2f83d7c13f283fd$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c2f83d7c13f283fd$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $c2f83d7c13f283fd$var$requestUpdateLane();
                            lane = $c2f83d7c13f283fd$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $c2f83d7c13f283fd$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $c2f83d7c13f283fd$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $c2f83d7c13f283fd$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c2f83d7c13f283fd$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c2f83d7c13f283fd$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c2f83d7c13f283fd$var$currentReplayingEvent = null;
        } else return targetContainers = $c2f83d7c13f283fd$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c2f83d7c13f283fd$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c2f83d7c13f283fd$var$replayUnblockedEvents() {
    $c2f83d7c13f283fd$var$hasScheduledReplayAttempt = !1;
    null !== $c2f83d7c13f283fd$var$queuedFocus && $c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEvent($c2f83d7c13f283fd$var$queuedFocus) && ($c2f83d7c13f283fd$var$queuedFocus = null);
    null !== $c2f83d7c13f283fd$var$queuedDrag && $c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEvent($c2f83d7c13f283fd$var$queuedDrag) && ($c2f83d7c13f283fd$var$queuedDrag = null);
    null !== $c2f83d7c13f283fd$var$queuedMouse && $c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEvent($c2f83d7c13f283fd$var$queuedMouse) && ($c2f83d7c13f283fd$var$queuedMouse = null);
    $c2f83d7c13f283fd$var$queuedPointers.forEach($c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEventInMap);
    $c2f83d7c13f283fd$var$queuedPointerCaptures.forEach($c2f83d7c13f283fd$var$attemptReplayContinuousQueuedEventInMap);
}
function $c2f83d7c13f283fd$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c2f83d7c13f283fd$var$hasScheduledReplayAttempt || ($c2f83d7c13f283fd$var$hasScheduledReplayAttempt = !0, $kCnPN.unstable_scheduleCallback($kCnPN.unstable_NormalPriority, $c2f83d7c13f283fd$var$replayUnblockedEvents)));
}
var $c2f83d7c13f283fd$var$lastScheduledReplayQueue = null;
function $c2f83d7c13f283fd$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c2f83d7c13f283fd$var$lastScheduledReplayQueue !== formReplayingQueue && ($c2f83d7c13f283fd$var$lastScheduledReplayQueue = formReplayingQueue, $kCnPN.unstable_scheduleCallback($kCnPN.unstable_NormalPriority, function() {
        $c2f83d7c13f283fd$var$lastScheduledReplayQueue === formReplayingQueue && ($c2f83d7c13f283fd$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c2f83d7c13f283fd$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c2f83d7c13f283fd$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c2f83d7c13f283fd$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c2f83d7c13f283fd$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c2f83d7c13f283fd$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c2f83d7c13f283fd$var$queuedFocus && $c2f83d7c13f283fd$var$scheduleCallbackIfUnblocked($c2f83d7c13f283fd$var$queuedFocus, unblocked);
    null !== $c2f83d7c13f283fd$var$queuedDrag && $c2f83d7c13f283fd$var$scheduleCallbackIfUnblocked($c2f83d7c13f283fd$var$queuedDrag, unblocked);
    null !== $c2f83d7c13f283fd$var$queuedMouse && $c2f83d7c13f283fd$var$scheduleCallbackIfUnblocked($c2f83d7c13f283fd$var$queuedMouse, unblocked);
    $c2f83d7c13f283fd$var$queuedPointers.forEach(unblock);
    $c2f83d7c13f283fd$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets.length && (i = $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c2f83d7c13f283fd$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c2f83d7c13f283fd$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c2f83d7c13f283fd$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c2f83d7c13f283fd$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c2f83d7c13f283fd$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c2f83d7c13f283fd$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c2f83d7c13f283fd$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c2f83d7c13f283fd$var$ReactDOMHydrationRoot.prototype.render = $c2f83d7c13f283fd$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c2f83d7c13f283fd$var$requestUpdateLane();
    $c2f83d7c13f283fd$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c2f83d7c13f283fd$var$ReactDOMHydrationRoot.prototype.unmount = $c2f83d7c13f283fd$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $c2f83d7c13f283fd$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c2f83d7c13f283fd$var$flushSyncWork$1();
        container[$c2f83d7c13f283fd$var$internalContainerInstanceKey] = null;
    }
};
function $c2f83d7c13f283fd$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c2f83d7c13f283fd$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c2f83d7c13f283fd$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c2f83d7c13f283fd$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c2f83d7c13f283fd$var$attemptExplicitHydrationTarget(target);
    }
};
var $c2f83d7c13f283fd$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $ggE0n.version;
if ("19.1.0" !== $c2f83d7c13f283fd$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(527, $c2f83d7c13f283fd$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$c2f83d7c13f283fd$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c2f83d7c13f283fd$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c2f83d7c13f283fd$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c2f83d7c13f283fd$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c2f83d7c13f283fd$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c2f83d7c13f283fd$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c2f83d7c13f283fd$var$hook$jscomp$inline_2257.isDisabled && $c2f83d7c13f283fd$var$hook$jscomp$inline_2257.supportsFiber) try {
        $c2f83d7c13f283fd$var$rendererID = $c2f83d7c13f283fd$var$hook$jscomp$inline_2257.inject($c2f83d7c13f283fd$var$internals$jscomp$inline_2256), $c2f83d7c13f283fd$var$injectedHook = $c2f83d7c13f283fd$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$c2f83d7c13f283fd$export$882461b6382ed46c = function(container, options) {
    if (!$c2f83d7c13f283fd$var$isValidContainer(container)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c2f83d7c13f283fd$var$defaultOnUncaughtError, onCaughtError = $c2f83d7c13f283fd$var$defaultOnCaughtError, onRecoverableError = $c2f83d7c13f283fd$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $c2f83d7c13f283fd$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$c2f83d7c13f283fd$var$internalContainerInstanceKey] = options.current;
    $c2f83d7c13f283fd$var$listenToAllSupportedEvents(container);
    return new $c2f83d7c13f283fd$var$ReactDOMRoot(options);
};
$c2f83d7c13f283fd$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c2f83d7c13f283fd$var$isValidContainer(container)) throw Error($c2f83d7c13f283fd$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c2f83d7c13f283fd$var$defaultOnUncaughtError, onCaughtError = $c2f83d7c13f283fd$var$defaultOnCaughtError, onRecoverableError = $c2f83d7c13f283fd$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c2f83d7c13f283fd$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $c2f83d7c13f283fd$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c2f83d7c13f283fd$var$requestUpdateLane();
    isStrictMode = $c2f83d7c13f283fd$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $c2f83d7c13f283fd$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c2f83d7c13f283fd$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $c2f83d7c13f283fd$var$markRootUpdated$1(initialChildren, options);
    $c2f83d7c13f283fd$var$ensureRootIsScheduled(initialChildren);
    container[$c2f83d7c13f283fd$var$internalContainerInstanceKey] = initialChildren.current;
    $c2f83d7c13f283fd$var$listenToAllSupportedEvents(container);
    return new $c2f83d7c13f283fd$var$ReactDOMHydrationRoot(initialChildren);
};
$c2f83d7c13f283fd$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("kCnPN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8VZJc"));

});
parcelRegister("8VZJc", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6813878681e23390$export$c4744153514ff05d; }, function (v) { return $6813878681e23390$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6813878681e23390$export$3e506c1ccc9cc1a7; }, function (v) { return $6813878681e23390$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6813878681e23390$export$e26fe2ed2fa76875; }, function (v) { return $6813878681e23390$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6813878681e23390$export$502329bbf4b505b1; }, function (v) { return $6813878681e23390$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6813878681e23390$export$6e3807111c4874c4; }, function (v) { return $6813878681e23390$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6813878681e23390$export$c27134553091fb3a; }, function (v) { return $6813878681e23390$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6813878681e23390$export$33ee1acdc04fd2a2; }, function (v) { return $6813878681e23390$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6813878681e23390$export$b00a404bbd5edef2; }, function (v) { return $6813878681e23390$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6813878681e23390$export$d66a1c1c77bd778b; }, function (v) { return $6813878681e23390$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6813878681e23390$export$d3dfb8e4810cb555; }, function (v) { return $6813878681e23390$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6813878681e23390$export$72fdf0e06517287b; }, function (v) { return $6813878681e23390$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6813878681e23390$export$816d2913ae6b83b1; }, function (v) { return $6813878681e23390$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6813878681e23390$export$61bcfe829111a1d0; }, function (v) { return $6813878681e23390$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6813878681e23390$export$7ee8c9beb337bc3f; }, function (v) { return $6813878681e23390$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6813878681e23390$export$b5836b71941fa3ed; }, function (v) { return $6813878681e23390$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6813878681e23390$export$cf845f2c119da08a; }, function (v) { return $6813878681e23390$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4TMho = parcelRequire("4TMho");
var $6813878681e23390$export$c4744153514ff05d;
var $6813878681e23390$export$3e506c1ccc9cc1a7;
var $6813878681e23390$export$e26fe2ed2fa76875;
var $6813878681e23390$export$502329bbf4b505b1;
var $6813878681e23390$export$6e3807111c4874c4;
var $6813878681e23390$export$c27134553091fb3a;
var $6813878681e23390$export$33ee1acdc04fd2a2;
var $6813878681e23390$export$b00a404bbd5edef2;
var $6813878681e23390$export$d66a1c1c77bd778b;
var $6813878681e23390$export$d3dfb8e4810cb555;
var $6813878681e23390$export$72fdf0e06517287b;
var $6813878681e23390$export$816d2913ae6b83b1;
var $6813878681e23390$export$61bcfe829111a1d0;
var $6813878681e23390$export$7ee8c9beb337bc3f;
var $6813878681e23390$export$b5836b71941fa3ed;
var $6813878681e23390$export$cf845f2c119da08a;
"use strict";
function $6813878681e23390$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6813878681e23390$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6813878681e23390$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6813878681e23390$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6813878681e23390$var$compare(left, last)) rightIndex < length && 0 > $6813878681e23390$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6813878681e23390$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6813878681e23390$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6813878681e23390$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $4TMho._)(performance)) && "function" === typeof performance.now) {
    var $6813878681e23390$var$localPerformance = performance;
    $6813878681e23390$export$c4744153514ff05d = function() {
        return $6813878681e23390$var$localPerformance.now();
    };
} else {
    var $6813878681e23390$var$localDate = Date, $6813878681e23390$var$initialTime = $6813878681e23390$var$localDate.now();
    $6813878681e23390$export$c4744153514ff05d = function() {
        return $6813878681e23390$var$localDate.now() - $6813878681e23390$var$initialTime;
    };
}
var $6813878681e23390$var$taskQueue = [], $6813878681e23390$var$timerQueue = [], $6813878681e23390$var$taskIdCounter = 1, $6813878681e23390$var$currentTask = null, $6813878681e23390$var$currentPriorityLevel = 3, $6813878681e23390$var$isPerformingWork = !1, $6813878681e23390$var$isHostCallbackScheduled = !1, $6813878681e23390$var$isHostTimeoutScheduled = !1, $6813878681e23390$var$needsPaint = !1, $6813878681e23390$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6813878681e23390$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6813878681e23390$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6813878681e23390$var$advanceTimers(currentTime) {
    for(var timer = $6813878681e23390$var$peek($6813878681e23390$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6813878681e23390$var$pop($6813878681e23390$var$timerQueue);
        else if (timer.startTime <= currentTime) $6813878681e23390$var$pop($6813878681e23390$var$timerQueue), timer.sortIndex = timer.expirationTime, $6813878681e23390$var$push($6813878681e23390$var$taskQueue, timer);
        else break;
        timer = $6813878681e23390$var$peek($6813878681e23390$var$timerQueue);
    }
}
function $6813878681e23390$var$handleTimeout(currentTime) {
    $6813878681e23390$var$isHostTimeoutScheduled = !1;
    $6813878681e23390$var$advanceTimers(currentTime);
    if (!$6813878681e23390$var$isHostCallbackScheduled) {
        if (null !== $6813878681e23390$var$peek($6813878681e23390$var$taskQueue)) $6813878681e23390$var$isHostCallbackScheduled = !0, $6813878681e23390$var$isMessageLoopRunning || ($6813878681e23390$var$isMessageLoopRunning = !0, $6813878681e23390$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6813878681e23390$var$peek($6813878681e23390$var$timerQueue);
            null !== firstTimer && $6813878681e23390$var$requestHostTimeout($6813878681e23390$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6813878681e23390$var$isMessageLoopRunning = !1, $6813878681e23390$var$taskTimeoutID = -1, $6813878681e23390$var$frameInterval = 5, $6813878681e23390$var$startTime = -1;
function $6813878681e23390$var$shouldYieldToHost() {
    return $6813878681e23390$var$needsPaint ? !0 : $6813878681e23390$export$c4744153514ff05d() - $6813878681e23390$var$startTime < $6813878681e23390$var$frameInterval ? !1 : !0;
}
function $6813878681e23390$var$performWorkUntilDeadline() {
    $6813878681e23390$var$needsPaint = !1;
    if ($6813878681e23390$var$isMessageLoopRunning) {
        var currentTime = $6813878681e23390$export$c4744153514ff05d();
        $6813878681e23390$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6813878681e23390$var$isHostCallbackScheduled = !1;
                $6813878681e23390$var$isHostTimeoutScheduled && ($6813878681e23390$var$isHostTimeoutScheduled = !1, $6813878681e23390$var$localClearTimeout($6813878681e23390$var$taskTimeoutID), $6813878681e23390$var$taskTimeoutID = -1);
                $6813878681e23390$var$isPerformingWork = !0;
                var previousPriorityLevel = $6813878681e23390$var$currentPriorityLevel;
                try {
                    b: {
                        $6813878681e23390$var$advanceTimers(currentTime);
                        for($6813878681e23390$var$currentTask = $6813878681e23390$var$peek($6813878681e23390$var$taskQueue); null !== $6813878681e23390$var$currentTask && !($6813878681e23390$var$currentTask.expirationTime > currentTime && $6813878681e23390$var$shouldYieldToHost());){
                            var callback = $6813878681e23390$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6813878681e23390$var$currentTask.callback = null;
                                $6813878681e23390$var$currentPriorityLevel = $6813878681e23390$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6813878681e23390$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6813878681e23390$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6813878681e23390$var$currentTask.callback = continuationCallback;
                                    $6813878681e23390$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6813878681e23390$var$currentTask === $6813878681e23390$var$peek($6813878681e23390$var$taskQueue) && $6813878681e23390$var$pop($6813878681e23390$var$taskQueue);
                                $6813878681e23390$var$advanceTimers(currentTime);
                            } else $6813878681e23390$var$pop($6813878681e23390$var$taskQueue);
                            $6813878681e23390$var$currentTask = $6813878681e23390$var$peek($6813878681e23390$var$taskQueue);
                        }
                        if (null !== $6813878681e23390$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6813878681e23390$var$peek($6813878681e23390$var$timerQueue);
                            null !== firstTimer && $6813878681e23390$var$requestHostTimeout($6813878681e23390$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6813878681e23390$var$currentTask = null, $6813878681e23390$var$currentPriorityLevel = previousPriorityLevel, $6813878681e23390$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6813878681e23390$var$schedulePerformWorkUntilDeadline() : $6813878681e23390$var$isMessageLoopRunning = !1;
        }
    }
}
var $6813878681e23390$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6813878681e23390$var$localSetImmediate) $6813878681e23390$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $6813878681e23390$var$localSetImmediate($6813878681e23390$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6813878681e23390$var$channel = new MessageChannel(), $6813878681e23390$var$port = $6813878681e23390$var$channel.port2;
    $6813878681e23390$var$channel.port1.onmessage = $6813878681e23390$var$performWorkUntilDeadline;
    $6813878681e23390$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $6813878681e23390$var$port.postMessage(null);
    };
} else $6813878681e23390$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $6813878681e23390$var$localSetTimeout($6813878681e23390$var$performWorkUntilDeadline, 0);
};
function $6813878681e23390$var$requestHostTimeout(callback, ms) {
    $6813878681e23390$var$taskTimeoutID = $6813878681e23390$var$localSetTimeout(function() {
        callback($6813878681e23390$export$c4744153514ff05d());
    }, ms);
}
$6813878681e23390$export$3e506c1ccc9cc1a7 = 5;
$6813878681e23390$export$e26fe2ed2fa76875 = 1;
$6813878681e23390$export$502329bbf4b505b1 = 4;
$6813878681e23390$export$6e3807111c4874c4 = 3;
$6813878681e23390$export$c27134553091fb3a = null;
$6813878681e23390$export$33ee1acdc04fd2a2 = 2;
$6813878681e23390$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6813878681e23390$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6813878681e23390$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6813878681e23390$export$d3dfb8e4810cb555 = function() {
    return $6813878681e23390$var$currentPriorityLevel;
};
$6813878681e23390$export$72fdf0e06517287b = function(eventHandler) {
    switch($6813878681e23390$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6813878681e23390$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6813878681e23390$var$currentPriorityLevel;
    $6813878681e23390$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6813878681e23390$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6813878681e23390$export$816d2913ae6b83b1 = function() {
    $6813878681e23390$var$needsPaint = !0;
};
$6813878681e23390$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6813878681e23390$var$currentPriorityLevel;
    $6813878681e23390$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6813878681e23390$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6813878681e23390$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6813878681e23390$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $4TMho._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6813878681e23390$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6813878681e23390$var$push($6813878681e23390$var$timerQueue, priorityLevel), null === $6813878681e23390$var$peek($6813878681e23390$var$taskQueue) && priorityLevel === $6813878681e23390$var$peek($6813878681e23390$var$timerQueue) && ($6813878681e23390$var$isHostTimeoutScheduled ? ($6813878681e23390$var$localClearTimeout($6813878681e23390$var$taskTimeoutID), $6813878681e23390$var$taskTimeoutID = -1) : $6813878681e23390$var$isHostTimeoutScheduled = !0, $6813878681e23390$var$requestHostTimeout($6813878681e23390$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6813878681e23390$var$push($6813878681e23390$var$taskQueue, priorityLevel), $6813878681e23390$var$isHostCallbackScheduled || $6813878681e23390$var$isPerformingWork || ($6813878681e23390$var$isHostCallbackScheduled = !0, $6813878681e23390$var$isMessageLoopRunning || ($6813878681e23390$var$isMessageLoopRunning = !0, $6813878681e23390$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6813878681e23390$export$b5836b71941fa3ed = $6813878681e23390$var$shouldYieldToHost;
$6813878681e23390$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6813878681e23390$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6813878681e23390$var$currentPriorityLevel;
        $6813878681e23390$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6813878681e23390$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ggE0n", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bozkU"));

});
parcelRegister("bozkU", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $84bd58a98ecb3635$export$dca3b0875bd9a954; }, function (v) { return $84bd58a98ecb3635$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $84bd58a98ecb3635$export$16fa2f45be04daa8; }, function (v) { return $84bd58a98ecb3635$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $84bd58a98ecb3635$export$ffb0004e005737fa; }, function (v) { return $84bd58a98ecb3635$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $84bd58a98ecb3635$export$e2c29f18771995cb; }, function (v) { return $84bd58a98ecb3635$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $84bd58a98ecb3635$export$221d75b3f55bb0bd; }, function (v) { return $84bd58a98ecb3635$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $84bd58a98ecb3635$export$5f8d39834fd61797; }, function (v) { return $84bd58a98ecb3635$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $84bd58a98ecb3635$export$74bf444e3cd11ea5; }, function (v) { return $84bd58a98ecb3635$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $84bd58a98ecb3635$export$1ced07cd6b1985ce; }, function (v) { return $84bd58a98ecb3635$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $84bd58a98ecb3635$export$abd8e32b826d7ea7; }, function (v) { return $84bd58a98ecb3635$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $84bd58a98ecb3635$export$69a3209f1a06c04d; }, function (v) { return $84bd58a98ecb3635$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $84bd58a98ecb3635$export$e530037191fcd5d7; }, function (v) { return $84bd58a98ecb3635$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $84bd58a98ecb3635$export$fd42f52fd3ae1109; }, function (v) { return $84bd58a98ecb3635$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $84bd58a98ecb3635$export$c8a8987d4410bf2d; }, function (v) { return $84bd58a98ecb3635$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $84bd58a98ecb3635$export$7d1e3a5e95ceca43; }, function (v) { return $84bd58a98ecb3635$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $84bd58a98ecb3635$export$257a8862b851cb5b; }, function (v) { return $84bd58a98ecb3635$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $84bd58a98ecb3635$export$a8257692ac88316c; }, function (v) { return $84bd58a98ecb3635$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $84bd58a98ecb3635$export$488013bae63b21da; }, function (v) { return $84bd58a98ecb3635$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $84bd58a98ecb3635$export$7c73462e0d25e514; }, function (v) { return $84bd58a98ecb3635$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $84bd58a98ecb3635$export$7568632d0d33d16d; }, function (v) { return $84bd58a98ecb3635$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $84bd58a98ecb3635$export$f93f40ac0ca7e3a8; }, function (v) { return $84bd58a98ecb3635$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $84bd58a98ecb3635$export$1f96ae73734a86cc; }, function (v) { return $84bd58a98ecb3635$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $84bd58a98ecb3635$export$9a47ced3238df325; }, function (v) { return $84bd58a98ecb3635$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $84bd58a98ecb3635$export$35808ee640e87ca7; }, function (v) { return $84bd58a98ecb3635$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $84bd58a98ecb3635$export$fae74005e78b1a27; }, function (v) { return $84bd58a98ecb3635$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $84bd58a98ecb3635$export$dc8fbce3eb94dc1e; }, function (v) { return $84bd58a98ecb3635$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $84bd58a98ecb3635$export$6a7bc4e911dc01cf; }, function (v) { return $84bd58a98ecb3635$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $84bd58a98ecb3635$export$6d9c69b0de29b591; }, function (v) { return $84bd58a98ecb3635$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $84bd58a98ecb3635$export$f680877a34711e37; }, function (v) { return $84bd58a98ecb3635$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $84bd58a98ecb3635$export$d5a552a76deda3c2; }, function (v) { return $84bd58a98ecb3635$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $84bd58a98ecb3635$export$aaabe4eda9ed9969; }, function (v) { return $84bd58a98ecb3635$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $84bd58a98ecb3635$export$e5c5a5f917a5871c; }, function (v) { return $84bd58a98ecb3635$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $84bd58a98ecb3635$export$1538c33de8887b59; }, function (v) { return $84bd58a98ecb3635$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $84bd58a98ecb3635$export$fca7f784ae7a249a; }, function (v) { return $84bd58a98ecb3635$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $84bd58a98ecb3635$export$13e3392192263954; }, function (v) { return $84bd58a98ecb3635$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $84bd58a98ecb3635$export$b8f5890fc79d6aca; }, function (v) { return $84bd58a98ecb3635$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $84bd58a98ecb3635$export$60241385465d0a34; }, function (v) { return $84bd58a98ecb3635$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $84bd58a98ecb3635$export$306c0aa65ff9ec16; }, function (v) { return $84bd58a98ecb3635$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $84bd58a98ecb3635$export$7b286972b8d8ccbf; }, function (v) { return $84bd58a98ecb3635$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $84bd58a98ecb3635$export$83d89fbfd8236492; }, function (v) { return $84bd58a98ecb3635$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4TMho = parcelRequire("4TMho");
var $84bd58a98ecb3635$export$dca3b0875bd9a954;
var $84bd58a98ecb3635$export$16fa2f45be04daa8;
var $84bd58a98ecb3635$export$ffb0004e005737fa;
var $84bd58a98ecb3635$export$e2c29f18771995cb;
var $84bd58a98ecb3635$export$221d75b3f55bb0bd;
var $84bd58a98ecb3635$export$5f8d39834fd61797;
var $84bd58a98ecb3635$export$74bf444e3cd11ea5;
var $84bd58a98ecb3635$export$1ced07cd6b1985ce;
var $84bd58a98ecb3635$export$abd8e32b826d7ea7;
var $84bd58a98ecb3635$export$69a3209f1a06c04d;
var $84bd58a98ecb3635$export$e530037191fcd5d7;
var $84bd58a98ecb3635$export$fd42f52fd3ae1109;
var $84bd58a98ecb3635$export$c8a8987d4410bf2d;
var $84bd58a98ecb3635$export$7d1e3a5e95ceca43;
var $84bd58a98ecb3635$export$257a8862b851cb5b;
var $84bd58a98ecb3635$export$a8257692ac88316c;
var $84bd58a98ecb3635$export$488013bae63b21da;
var $84bd58a98ecb3635$export$7c73462e0d25e514;
var $84bd58a98ecb3635$export$7568632d0d33d16d;
var $84bd58a98ecb3635$export$f93f40ac0ca7e3a8;
var $84bd58a98ecb3635$export$1f96ae73734a86cc;
var $84bd58a98ecb3635$export$9a47ced3238df325;
var $84bd58a98ecb3635$export$35808ee640e87ca7;
var $84bd58a98ecb3635$export$fae74005e78b1a27;
var $84bd58a98ecb3635$export$dc8fbce3eb94dc1e;
var $84bd58a98ecb3635$export$6a7bc4e911dc01cf;
var $84bd58a98ecb3635$export$6d9c69b0de29b591;
var $84bd58a98ecb3635$export$f680877a34711e37;
var $84bd58a98ecb3635$export$d5a552a76deda3c2;
var $84bd58a98ecb3635$export$aaabe4eda9ed9969;
var $84bd58a98ecb3635$export$e5c5a5f917a5871c;
var $84bd58a98ecb3635$export$1538c33de8887b59;
var $84bd58a98ecb3635$export$fca7f784ae7a249a;
var $84bd58a98ecb3635$export$13e3392192263954;
var $84bd58a98ecb3635$export$b8f5890fc79d6aca;
var $84bd58a98ecb3635$export$60241385465d0a34;
var $84bd58a98ecb3635$export$306c0aa65ff9ec16;
var $84bd58a98ecb3635$export$7b286972b8d8ccbf;
var $84bd58a98ecb3635$export$83d89fbfd8236492;
"use strict";
var $84bd58a98ecb3635$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $84bd58a98ecb3635$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $84bd58a98ecb3635$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $84bd58a98ecb3635$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $84bd58a98ecb3635$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $84bd58a98ecb3635$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $84bd58a98ecb3635$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $84bd58a98ecb3635$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $84bd58a98ecb3635$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $84bd58a98ecb3635$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $84bd58a98ecb3635$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $84bd58a98ecb3635$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $84bd58a98ecb3635$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $4TMho._)(maybeIterable))) return null;
    maybeIterable = $84bd58a98ecb3635$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$84bd58a98ecb3635$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $84bd58a98ecb3635$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $84bd58a98ecb3635$var$assign = Object.assign, $84bd58a98ecb3635$var$emptyObject = {};
function $84bd58a98ecb3635$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $84bd58a98ecb3635$var$emptyObject;
    this.updater = updater || $84bd58a98ecb3635$var$ReactNoopUpdateQueue;
}
$84bd58a98ecb3635$var$Component.prototype.isReactComponent = {};
$84bd58a98ecb3635$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $4TMho._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$84bd58a98ecb3635$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $84bd58a98ecb3635$var$ComponentDummy() {}
$84bd58a98ecb3635$var$ComponentDummy.prototype = $84bd58a98ecb3635$var$Component.prototype;
function $84bd58a98ecb3635$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $84bd58a98ecb3635$var$emptyObject;
    this.updater = updater || $84bd58a98ecb3635$var$ReactNoopUpdateQueue;
}
var $84bd58a98ecb3635$var$pureComponentPrototype = $84bd58a98ecb3635$var$PureComponent.prototype = new $84bd58a98ecb3635$var$ComponentDummy();
$84bd58a98ecb3635$var$pureComponentPrototype.constructor = $84bd58a98ecb3635$var$PureComponent;
$84bd58a98ecb3635$var$assign($84bd58a98ecb3635$var$pureComponentPrototype, $84bd58a98ecb3635$var$Component.prototype);
$84bd58a98ecb3635$var$pureComponentPrototype.isPureReactComponent = !0;
var $84bd58a98ecb3635$var$isArrayImpl = Array.isArray, $84bd58a98ecb3635$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $84bd58a98ecb3635$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $84bd58a98ecb3635$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $84bd58a98ecb3635$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $84bd58a98ecb3635$var$cloneAndReplaceKey(oldElement, newKey) {
    return $84bd58a98ecb3635$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $84bd58a98ecb3635$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $4TMho._)(object)) && null !== object && object.$$typeof === $84bd58a98ecb3635$var$REACT_ELEMENT_TYPE;
}
function $84bd58a98ecb3635$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $84bd58a98ecb3635$var$userProvidedKeyEscapeRegex = /\/+/g;
function $84bd58a98ecb3635$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $4TMho._)(element)) && null !== element && null != element.key ? $84bd58a98ecb3635$var$escape("" + element.key) : index.toString(36);
}
function $84bd58a98ecb3635$var$noop$1() {}
function $84bd58a98ecb3635$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($84bd58a98ecb3635$var$noop$1, $84bd58a98ecb3635$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $84bd58a98ecb3635$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $4TMho._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $84bd58a98ecb3635$var$REACT_ELEMENT_TYPE:
                case $84bd58a98ecb3635$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $84bd58a98ecb3635$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $84bd58a98ecb3635$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $84bd58a98ecb3635$var$getElementKey(children, 0) : nameSoFar, $84bd58a98ecb3635$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($84bd58a98ecb3635$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $84bd58a98ecb3635$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($84bd58a98ecb3635$var$isValidElement(callback) && (callback = $84bd58a98ecb3635$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($84bd58a98ecb3635$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($84bd58a98ecb3635$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $84bd58a98ecb3635$var$getElementKey(nameSoFar, i), invokeCallback += $84bd58a98ecb3635$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $84bd58a98ecb3635$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $84bd58a98ecb3635$var$getElementKey(nameSoFar, i++), invokeCallback += $84bd58a98ecb3635$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $84bd58a98ecb3635$var$mapIntoArray($84bd58a98ecb3635$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $84bd58a98ecb3635$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $84bd58a98ecb3635$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $84bd58a98ecb3635$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $84bd58a98ecb3635$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $4TMho._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $4TMho._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $84bd58a98ecb3635$var$noop() {}
$84bd58a98ecb3635$export$dca3b0875bd9a954 = {
    map: $84bd58a98ecb3635$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $84bd58a98ecb3635$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $84bd58a98ecb3635$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $84bd58a98ecb3635$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$84bd58a98ecb3635$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$84bd58a98ecb3635$export$16fa2f45be04daa8 = $84bd58a98ecb3635$var$Component;
$84bd58a98ecb3635$export$ffb0004e005737fa = $84bd58a98ecb3635$var$REACT_FRAGMENT_TYPE;
$84bd58a98ecb3635$export$e2c29f18771995cb = $84bd58a98ecb3635$var$REACT_PROFILER_TYPE;
$84bd58a98ecb3635$export$221d75b3f55bb0bd = $84bd58a98ecb3635$var$PureComponent;
$84bd58a98ecb3635$export$5f8d39834fd61797 = $84bd58a98ecb3635$var$REACT_STRICT_MODE_TYPE;
$84bd58a98ecb3635$export$74bf444e3cd11ea5 = $84bd58a98ecb3635$var$REACT_SUSPENSE_TYPE;
$84bd58a98ecb3635$export$1ced07cd6b1985ce = $84bd58a98ecb3635$var$ReactSharedInternals;
$84bd58a98ecb3635$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function c(size) {
        return $84bd58a98ecb3635$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$84bd58a98ecb3635$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$84bd58a98ecb3635$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $84bd58a98ecb3635$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$84bd58a98ecb3635$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $84bd58a98ecb3635$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$84bd58a98ecb3635$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $84bd58a98ecb3635$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $84bd58a98ecb3635$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$84bd58a98ecb3635$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$84bd58a98ecb3635$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $84bd58a98ecb3635$var$ReactElement(type, key, void 0, void 0, null, props);
};
$84bd58a98ecb3635$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$84bd58a98ecb3635$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $84bd58a98ecb3635$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$84bd58a98ecb3635$export$a8257692ac88316c = $84bd58a98ecb3635$var$isValidElement;
$84bd58a98ecb3635$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $84bd58a98ecb3635$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $84bd58a98ecb3635$var$lazyInitializer
    };
};
$84bd58a98ecb3635$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $84bd58a98ecb3635$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$84bd58a98ecb3635$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $84bd58a98ecb3635$var$ReactSharedInternals.T, currentTransition = {};
    $84bd58a98ecb3635$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $84bd58a98ecb3635$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $4TMho._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($84bd58a98ecb3635$var$noop, $84bd58a98ecb3635$var$reportGlobalError);
    } catch (error) {
        $84bd58a98ecb3635$var$reportGlobalError(error);
    } finally{
        $84bd58a98ecb3635$var$ReactSharedInternals.T = prevTransition;
    }
};
$84bd58a98ecb3635$export$f93f40ac0ca7e3a8 = function() {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useCacheRefresh();
};
$84bd58a98ecb3635$export$1f96ae73734a86cc = function(usable) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.use(usable);
};
$84bd58a98ecb3635$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$84bd58a98ecb3635$export$35808ee640e87ca7 = function(callback, deps) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$84bd58a98ecb3635$export$fae74005e78b1a27 = function(Context) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useContext(Context);
};
$84bd58a98ecb3635$export$dc8fbce3eb94dc1e = function() {};
$84bd58a98ecb3635$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$84bd58a98ecb3635$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $84bd58a98ecb3635$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$84bd58a98ecb3635$export$f680877a34711e37 = function() {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useId();
};
$84bd58a98ecb3635$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$84bd58a98ecb3635$export$aaabe4eda9ed9969 = function(create, deps) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$84bd58a98ecb3635$export$e5c5a5f917a5871c = function(create, deps) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$84bd58a98ecb3635$export$1538c33de8887b59 = function(create, deps) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useMemo(create, deps);
};
$84bd58a98ecb3635$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$84bd58a98ecb3635$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$84bd58a98ecb3635$export$b8f5890fc79d6aca = function(initialValue) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useRef(initialValue);
};
$84bd58a98ecb3635$export$60241385465d0a34 = function(initialState) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useState(initialState);
};
$84bd58a98ecb3635$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$84bd58a98ecb3635$export$7b286972b8d8ccbf = function() {
    return $84bd58a98ecb3635$var$ReactSharedInternals.H.useTransition();
};
$84bd58a98ecb3635$export$83d89fbfd8236492 = "19.1.0";

});


parcelRegister("3og2D", function(module, exports) {
'use strict';
function $27800e797145a2f8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($27800e797145a2f8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$27800e797145a2f8$var$checkDCE();

module.exports = (parcelRequire("tibs3"));

});
parcelRegister("tibs3", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0580d073cde50740$export$69ce8ef3fe5cead0; }, function (v) { return $0580d073cde50740$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $0580d073cde50740$export$d39a5bbd09211389; }, function (v) { return $0580d073cde50740$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0580d073cde50740$export$cd75ccfd720a3cd4; }, function (v) { return $0580d073cde50740$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $0580d073cde50740$export$a0816fa17a9e79be; }, function (v) { return $0580d073cde50740$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $0580d073cde50740$export$7292efcadded39f3; }, function (v) { return $0580d073cde50740$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $0580d073cde50740$export$da407abadb9b8f86; }, function (v) { return $0580d073cde50740$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $0580d073cde50740$export$314cfea32580671c; }, function (v) { return $0580d073cde50740$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $0580d073cde50740$export$513ccb98c53b8039; }, function (v) { return $0580d073cde50740$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $0580d073cde50740$export$dbca993bc2d264a; }, function (v) { return $0580d073cde50740$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $0580d073cde50740$export$4797a8006f0655d0; }, function (v) { return $0580d073cde50740$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0580d073cde50740$export$c78a37762a8d58e1; }, function (v) { return $0580d073cde50740$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $0580d073cde50740$export$606f11b2eb45ecc6; }, function (v) { return $0580d073cde50740$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $0580d073cde50740$export$f7e8a0bf92324b1e; }, function (v) { return $0580d073cde50740$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $0580d073cde50740$export$83d89fbfd8236492; }, function (v) { return $0580d073cde50740$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4TMho = parcelRequire("4TMho");
var $0580d073cde50740$export$69ce8ef3fe5cead0;
var $0580d073cde50740$export$d39a5bbd09211389;
var $0580d073cde50740$export$cd75ccfd720a3cd4;
var $0580d073cde50740$export$a0816fa17a9e79be;
var $0580d073cde50740$export$7292efcadded39f3;
var $0580d073cde50740$export$da407abadb9b8f86;
var $0580d073cde50740$export$314cfea32580671c;
var $0580d073cde50740$export$513ccb98c53b8039;
var $0580d073cde50740$export$dbca993bc2d264a;
var $0580d073cde50740$export$4797a8006f0655d0;
var $0580d073cde50740$export$c78a37762a8d58e1;
var $0580d073cde50740$export$606f11b2eb45ecc6;
var $0580d073cde50740$export$f7e8a0bf92324b1e;
var $0580d073cde50740$export$83d89fbfd8236492;
"use strict";

var $ggE0n = parcelRequire("ggE0n");
function $0580d073cde50740$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $0580d073cde50740$var$noop() {}
var $0580d073cde50740$var$Internals = {
    d: {
        f: $0580d073cde50740$var$noop,
        r: function r() {
            throw Error($0580d073cde50740$var$formatProdErrorMessage(522));
        },
        D: $0580d073cde50740$var$noop,
        C: $0580d073cde50740$var$noop,
        L: $0580d073cde50740$var$noop,
        m: $0580d073cde50740$var$noop,
        X: $0580d073cde50740$var$noop,
        S: $0580d073cde50740$var$noop,
        M: $0580d073cde50740$var$noop
    },
    p: 0,
    findDOMNode: null
}, $0580d073cde50740$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $0580d073cde50740$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0580d073cde50740$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $0580d073cde50740$var$ReactSharedInternals = $ggE0n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $0580d073cde50740$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$0580d073cde50740$export$69ce8ef3fe5cead0 = $0580d073cde50740$var$Internals;
$0580d073cde50740$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($0580d073cde50740$var$formatProdErrorMessage(299));
    return $0580d073cde50740$var$createPortal$1(children, container, null, key);
};
$0580d073cde50740$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $0580d073cde50740$var$ReactSharedInternals.T, previousUpdatePriority = $0580d073cde50740$var$Internals.p;
    try {
        if ($0580d073cde50740$var$ReactSharedInternals.T = null, $0580d073cde50740$var$Internals.p = 2, fn) return fn();
    } finally{
        $0580d073cde50740$var$ReactSharedInternals.T = previousTransition, $0580d073cde50740$var$Internals.p = previousUpdatePriority, $0580d073cde50740$var$Internals.d.f();
    }
};
$0580d073cde50740$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $0580d073cde50740$var$Internals.d.C(href, options));
};
$0580d073cde50740$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $0580d073cde50740$var$Internals.d.D(href);
};
$0580d073cde50740$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $0580d073cde50740$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $0580d073cde50740$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $0580d073cde50740$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$0580d073cde50740$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $4TMho._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $0580d073cde50740$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $0580d073cde50740$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $0580d073cde50740$var$Internals.d.M(href);
    }
};
$0580d073cde50740$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $4TMho._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $0580d073cde50740$var$getCrossOriginStringAs(as, options.crossOrigin);
        $0580d073cde50740$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$0580d073cde50740$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $0580d073cde50740$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $0580d073cde50740$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $0580d073cde50740$var$Internals.d.m(href);
    }
};
$0580d073cde50740$export$4797a8006f0655d0 = function(form) {
    $0580d073cde50740$var$Internals.d.r(form);
};
$0580d073cde50740$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$0580d073cde50740$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $0580d073cde50740$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$0580d073cde50740$export$f7e8a0bf92324b1e = function() {
    return $0580d073cde50740$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$0580d073cde50740$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("djQmR", function(module, exports) {
'use strict';
module.exports = '3.26.0';

});

parcelRegister("jGFHY", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $e5524af77b969440$export$306c0aa65ff9ec16; }, function (v) { return $e5524af77b969440$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5524af77b969440$export$306c0aa65ff9ec16;
"use strict";

var $ggE0n = parcelRequire("ggE0n");
function $e5524af77b969440$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e5524af77b969440$var$objectIs = "function" === typeof Object.is ? Object.is : $e5524af77b969440$var$is, $e5524af77b969440$var$useState = $ggE0n.useState, $e5524af77b969440$var$useEffect = $ggE0n.useEffect, $e5524af77b969440$var$useLayoutEffect = $ggE0n.useLayoutEffect, $e5524af77b969440$var$useDebugValue = $ggE0n.useDebugValue;
function $e5524af77b969440$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $e5524af77b969440$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $e5524af77b969440$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $e5524af77b969440$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $e5524af77b969440$var$useEffect(function() {
        $e5524af77b969440$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $e5524af77b969440$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $e5524af77b969440$var$useDebugValue(value);
    return value;
}
function $e5524af77b969440$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$e5524af77b969440$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $e5524af77b969440$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $e5524af77b969440$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $e5524af77b969440$var$useSyncExternalStore$1 : $e5524af77b969440$var$useSyncExternalStore$2;
$e5524af77b969440$export$306c0aa65ff9ec16 = void 0 !== $ggE0n.useSyncExternalStore ? $ggE0n.useSyncExternalStore : $e5524af77b969440$var$shim;

});

parcelRegister("2QPpE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $213851937f5220b6$export$71511d61b312f219; });

var $3Hxpr = parcelRequire("3Hxpr");
function $213851937f5220b6$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $3Hxpr._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("3Hxpr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2b1f4dace316f7be$export$71511d61b312f219; });
function $2b1f4dace316f7be$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("90NkU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $68fa624b0058b215$export$71511d61b312f219; });

var $9MdM4 = parcelRequire("9MdM4");

var $DTVfA = parcelRequire("DTVfA");

var $at7Tp = parcelRequire("at7Tp");

var $d5mSM = parcelRequire("d5mSM");
function $68fa624b0058b215$export$71511d61b312f219(arr) {
    return (0, $9MdM4._)(arr) || (0, $DTVfA._)(arr) || (0, $d5mSM._)(arr) || (0, $at7Tp._)();
}

});
parcelRegister("9MdM4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $71e348100ec43b78$export$71511d61b312f219; });

var $gIYOR = parcelRequire("gIYOR");
function $71e348100ec43b78$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gIYOR._)(arr);
}

});
parcelRegister("gIYOR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c2cfeed658375ef3$export$71511d61b312f219; });
function $c2cfeed658375ef3$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("DTVfA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $077f05a7dd5a7d1a$export$71511d61b312f219; });
function $077f05a7dd5a7d1a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("at7Tp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $79f2bc22a0cfcadc$export$71511d61b312f219; });
function $79f2bc22a0cfcadc$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("d5mSM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $986d7e027c46ac1a$export$71511d61b312f219; });

var $gIYOR = parcelRequire("gIYOR");
function $986d7e027c46ac1a$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gIYOR._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gIYOR._)(o, minLen);
}

});


parcelRegister("gpEpt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf2e53ae99fda9f5$export$71511d61b312f219; });
function $bf2e53ae99fda9f5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eOJ9o", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ac98c22c37821d14$export$71511d61b312f219; });
function $ac98c22c37821d14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ac98c22c37821d14$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $ac98c22c37821d14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ac98c22c37821d14$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("3qQ3j", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $27fc2d546b8e5514$export$71511d61b312f219; });

var $h6th5 = parcelRequire("h6th5");

var $23lEd = parcelRequire("23lEd");

var $cJamc = parcelRequire("cJamc");
function $27fc2d546b8e5514$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $h6th5._)(derived);
    return (0, $cJamc._)(_this, (0, $23lEd._)() ? Reflect.construct(derived, args || [], (0, $h6th5._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("h6th5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c739b48b50fc7fc1$export$71511d61b312f219; });
function $c739b48b50fc7fc1$export$71511d61b312f219(o) {
    $c739b48b50fc7fc1$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c739b48b50fc7fc1$export$71511d61b312f219(o);
}

});

parcelRegister("23lEd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17eca7540878dcc2$export$71511d61b312f219; });
function $17eca7540878dcc2$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($17eca7540878dcc2$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("cJamc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9441b8b98c5bba2b$export$71511d61b312f219; });

var $gagO1 = parcelRequire("gagO1");

var $4TMho = parcelRequire("4TMho");
function $9441b8b98c5bba2b$export$71511d61b312f219(self, call) {
    if (call && ((0, $4TMho._)(call) === "object" || typeof call === "function")) return call;
    return (0, $gagO1._)(self);
}

});
parcelRegister("gagO1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bc4a9dcaad5d53e6$export$71511d61b312f219; });
function $bc4a9dcaad5d53e6$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("83AyS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5ddaf6e638d3c6b1$export$71511d61b312f219; });

var $cGsQi = parcelRequire("cGsQi");
function $5ddaf6e638d3c6b1$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cGsQi._)(subClass, superClass);
}

});
parcelRegister("cGsQi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $93bfc7cac5034a4d$export$71511d61b312f219; });
function $93bfc7cac5034a4d$export$71511d61b312f219(o, p) {
    $93bfc7cac5034a4d$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $93bfc7cac5034a4d$export$71511d61b312f219(o, p);
}

});


parcelRegister("3G0sq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2ad5a62b12ac1a0c$export$71511d61b312f219; });

var $bS9Hr = parcelRequire("bS9Hr");

var $h6th5 = parcelRequire("h6th5");

var $62979 = parcelRequire("62979");

var $cGsQi = parcelRequire("cGsQi");
function $2ad5a62b12ac1a0c$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2ad5a62b12ac1a0c$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $62979._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $bS9Hr._)(Class, arguments, (0, $h6th5._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $cGsQi._)(Wrapper, Class);
    };
    return $2ad5a62b12ac1a0c$export$71511d61b312f219(Class);
}

});
parcelRegister("bS9Hr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8a4c42fc3c545f08$export$71511d61b312f219; });

var $23lEd = parcelRequire("23lEd");

var $cGsQi = parcelRequire("cGsQi");
function $8a4c42fc3c545f08$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $23lEd._)()) $8a4c42fc3c545f08$export$71511d61b312f219 = Reflect.construct;
    else $8a4c42fc3c545f08$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $cGsQi._)(instance, Class.prototype);
        return instance;
    };
    return $8a4c42fc3c545f08$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("62979", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4649ffe4c6bb69e1$export$71511d61b312f219; });
function $4649ffe4c6bb69e1$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("dShRg", function(module, exports) {

module.exports = (parcelRequire("1K40G"))($parcel$resolve("4nmVh")).then(function() {
    return parcelRequire('dSrDj');
});

});

parcelRegister("j4SEU", function(module, exports) {

module.exports = (parcelRequire("1K40G"))($parcel$resolve("cQdA0")).then(function() {
    return parcelRequire('3bGcY');
});

});

var $6aa346ee751927ea$exports = {};
$parcel$extendImportMap({
    "jlwCP": "anchor.525a5184.js",
    "67bzn": "slider-plugins.35fee465.js",
    "2pzvU": "slider.c78a8b29.js",
    "4nmVh": "rive.a14584d2.js",
    "cQdA0": "lightbox.7b242e6a.js"
});

/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/ var $d728d85f208a7030$exports = {};
'use strict';

$d728d85f208a7030$exports = (parcelRequire("82g8Y"));


function $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5cde60a45dc0f6ff$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $4TMho = parcelRequire("4TMho");
var $37faaaff56909290$var$extendStatics = function extendStatics1(d, b) {
    $37faaaff56909290$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $37faaaff56909290$var$extendStatics(d, b);
};
function $37faaaff56909290$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $37faaaff56909290$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $37faaaff56909290$export$18ce0697a983be9b = function __assign1() {
    $37faaaff56909290$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37faaaff56909290$export$18ce0697a983be9b.apply(this, arguments);
};
function $37faaaff56909290$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $37faaaff56909290$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $4TMho._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $37faaaff56909290$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $37faaaff56909290$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $4TMho._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $37faaaff56909290$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $37faaaff56909290$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $4TMho._)(x)) === "symbol" ? x : "".concat(x);
}
function $37faaaff56909290$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $4TMho._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $37faaaff56909290$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $4TMho._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $37faaaff56909290$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $37faaaff56909290$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $37faaaff56909290$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $37faaaff56909290$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $37faaaff56909290$export$45d3717a4c69092e(o, m, p);
}
function $37faaaff56909290$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $37faaaff56909290$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $37faaaff56909290$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($37faaaff56909290$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $37faaaff56909290$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $37faaaff56909290$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $37faaaff56909290$export$10c90e4f7922046c(v) {
    return this instanceof $37faaaff56909290$export$10c90e4f7922046c ? (this.v = v, this) : new $37faaaff56909290$export$10c90e4f7922046c(v);
}
function $37faaaff56909290$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $37faaaff56909290$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $37faaaff56909290$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $37faaaff56909290$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $37faaaff56909290$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $37faaaff56909290$export$19a8beecd37a4c45 === "function" ? $37faaaff56909290$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $37faaaff56909290$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $37faaaff56909290$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $37faaaff56909290$var$ownKeys = function ownKeys1(o) {
    $37faaaff56909290$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $37faaaff56909290$var$ownKeys(o);
};
function $37faaaff56909290$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $37faaaff56909290$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $37faaaff56909290$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $37faaaff56909290$var$__setModuleDefault(result, mod);
    return result;
}
function $37faaaff56909290$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $37faaaff56909290$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $37faaaff56909290$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $37faaaff56909290$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $4TMho._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $37faaaff56909290$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $37faaaff56909290$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $37faaaff56909290$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $37faaaff56909290$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $37faaaff56909290$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $37faaaff56909290$export$2e2bcd8739ae039 = {
    __extends: $37faaaff56909290$export$a8ba968b8961cb8a,
    __assign: $37faaaff56909290$export$18ce0697a983be9b,
    __rest: $37faaaff56909290$export$3c9a16f847548506,
    __decorate: $37faaaff56909290$export$29e00dfd3077644b,
    __param: $37faaaff56909290$export$d5ad3fd78186038f,
    __esDecorate: $37faaaff56909290$export$3a84e1ae4e97e9b0,
    __runInitializers: $37faaaff56909290$export$d831c04e792af3d,
    __propKey: $37faaaff56909290$export$6a2a36740a146cb8,
    __setFunctionName: $37faaaff56909290$export$d1a06452d3489bc7,
    __metadata: $37faaaff56909290$export$f1db080c865becb9,
    __awaiter: $37faaaff56909290$export$1050f835b63b671e,
    __generator: $37faaaff56909290$export$67ebef60e6f28a6,
    __createBinding: $37faaaff56909290$export$45d3717a4c69092e,
    __exportStar: $37faaaff56909290$export$f33643c0debef087,
    __values: $37faaaff56909290$export$19a8beecd37a4c45,
    __read: $37faaaff56909290$export$8d051b38c9118094,
    __spread: $37faaaff56909290$export$afc72e2116322959,
    __spreadArrays: $37faaaff56909290$export$6388937ca91ccae8,
    __spreadArray: $37faaaff56909290$export$1216008129fb82ed,
    __await: $37faaaff56909290$export$10c90e4f7922046c,
    __asyncGenerator: $37faaaff56909290$export$e427f37a30a4de9b,
    __asyncDelegator: $37faaaff56909290$export$bbd80228419bb833,
    __asyncValues: $37faaaff56909290$export$e3b29a3d6162315f,
    __makeTemplateObject: $37faaaff56909290$export$4fb47efe1390b86f,
    __importStar: $37faaaff56909290$export$c21735bcef00d192,
    __importDefault: $37faaaff56909290$export$da59b14a69baef04,
    __classPrivateFieldGet: $37faaaff56909290$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $37faaaff56909290$export$d40a35129aaff81f,
    __classPrivateFieldIn: $37faaaff56909290$export$81fdc39f203e4e04,
    __addDisposableResource: $37faaaff56909290$export$88ac25d8e944e405,
    __disposeResources: $37faaaff56909290$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $37faaaff56909290$export$889dfb5d17574b0b
};



var $045332d6670dfa00$var$autoTemplateComponent = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5cde60a45dc0f6ff$export$71511d61b312f219)(function() {
        var components, allComponents;
        return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (parcelRequire("l0Yig"))
                    ];
                case 1:
                    components = _state.sent();
                    if (components) {
                        allComponents = Object.keys(components);
                        allComponents.forEach(function(component) {
                            var _Object_keys;
                            var parentComponent = components[component];
                            var hasChildren = (_Object_keys = Object.keys(parent)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.length;
                            // First level components
                            for(var child in parentComponent){
                                var childComponent = parentComponent[child];
                                if (childComponent instanceof Function) childComponent();
                            }
                            // Lower level components
                            if (hasChildren) for(var child1 in parentComponent){
                                var childComponent1 = parentComponent[child1][child1];
                                if (childComponent1 instanceof Function) childComponent1();
                            }
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    })();
};
var $045332d6670dfa00$export$2e2bcd8739ae039 = $045332d6670dfa00$var$autoTemplateComponent;


var $617e40c786b88f50$var$toggleMenu = function() {
    var header = document.getElementById('js--header');
    var sidebar = document.getElementById('js--sidebar');
    var body = document.getElementById('js--body');
    var btn = document.getElementById('js--btn-menu');
    btn.addEventListener('click', function(e) {
        toggleClass();
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && sidebar.classList.contains('js--active')) toggleClass();
    });
    toggleClass = function() {
        header.classList.toggle('js--active');
        sidebar.classList.toggle('js--active');
        btn.classList.toggle('js--active');
        body.classList.toggle('overflow-hidden');
        if (header.classList.contains('js--active')) {
            header.classList.add('theme--white');
            if (header.classList.contains('theme--trans')) header.classList.remove('theme--trans');
            if (header.classList.contains('theme--blue-oxford')) header.classList.remove('theme--blue-oxford');
        } else {
            header.classList.add(header.dataset.default);
            header.classList.remove('theme--white');
        }
    };
};
var $617e40c786b88f50$export$2e2bcd8739ae039 = $617e40c786b88f50$var$toggleMenu;



var $53pa5 = parcelRequire("53pa5");
var $ac0c57d620ff2fd4$exports = {};
'use strict';
function $ac0c57d620ff2fd4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ac0c57d620ff2fd4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ac0c57d620ff2fd4$var$checkDCE();

$ac0c57d620ff2fd4$exports = (parcelRequire("gJOMw"));


function $6f8aa9ddaa708685$export$2e2bcd8739ae039() {
    var toggleElement = document.querySelector('.js-cookie-banner-toggle');
    if (toggleElement !== null) toggleElement.addEventListener('click', function(event) {
        var _window;
        event.preventDefault();
        if ((_window = window) === null || _window === void 0 ? void 0 : _window.Cookiebot) window.Cookiebot.show();
    });
}


function $4373a2021ce9f24e$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $3ccfc551bc3797a6$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $c3e63dd72629c443$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



var $d5mSM = parcelRequire("d5mSM");
function $c6938abc98c6418f$export$71511d61b312f219(arr, i) {
    return (0, $4373a2021ce9f24e$export$71511d61b312f219)(arr) || (0, $3ccfc551bc3797a6$export$71511d61b312f219)(arr, i) || (0, $d5mSM._)(arr, i) || (0, $c3e63dd72629c443$export$71511d61b312f219)();
}




var $ggE0n = parcelRequire("ggE0n");

var $iom5D = parcelRequire("iom5D");
var $32cead6defcfe2a5$exports = {};
'use strict';
var $17d409ad60bc9be8$exports = {};
'use strict';
var $1b8b757b6af13439$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TMho = parcelRequire("4TMho");
function $1b8b757b6af13439$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$1b8b757b6af13439$exports = $1b8b757b6af13439$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$1b8b757b6af13439$var$EventEmitter.prototype._events = undefined;
$1b8b757b6af13439$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$1b8b757b6af13439$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$1b8b757b6af13439$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$1b8b757b6af13439$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$1b8b757b6af13439$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $1b8b757b6af13439$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($1b8b757b6af13439$var$isUndefined(handler)) return false;
    if ($1b8b757b6af13439$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($1b8b757b6af13439$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$1b8b757b6af13439$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$1b8b757b6af13439$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $1b8b757b6af13439$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($1b8b757b6af13439$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($1b8b757b6af13439$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$1b8b757b6af13439$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $1b8b757b6af13439$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$1b8b757b6af13439$var$EventEmitter.prototype.on = $1b8b757b6af13439$var$EventEmitter.prototype.addListener;
$1b8b757b6af13439$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$1b8b757b6af13439$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$1b8b757b6af13439$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$1b8b757b6af13439$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $1b8b757b6af13439$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($1b8b757b6af13439$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$1b8b757b6af13439$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($1b8b757b6af13439$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$1b8b757b6af13439$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($1b8b757b6af13439$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$1b8b757b6af13439$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($1b8b757b6af13439$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$1b8b757b6af13439$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $1b8b757b6af13439$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $1b8b757b6af13439$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $1b8b757b6af13439$var$isObject(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $4TMho._)(arg)) === 'object' && arg !== null;
}
function $1b8b757b6af13439$var$isUndefined(arg) {
    return arg === void 0;
}


var $405753375d0f8b8a$exports = {};
'use strict';

var $5f865a62ae7e9a86$exports = {};
'use strict';
function $5f865a62ae7e9a86$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$5f865a62ae7e9a86$exports = $5f865a62ae7e9a86$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $405753375d0f8b8a$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$5f865a62ae7e9a86$exports($405753375d0f8b8a$var$DerivedHelper, $1b8b757b6af13439$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $405753375d0f8b8a$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$405753375d0f8b8a$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$405753375d0f8b8a$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
$405753375d0f8b8a$exports = $405753375d0f8b8a$var$DerivedHelper;


var $d925bd2bfef0b5bb$exports = {};
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $d925bd2bfef0b5bb$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $d925bd2bfef0b5bb$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
$d925bd2bfef0b5bb$exports = {
    escapeFacetValue: $d925bd2bfef0b5bb$var$escapeFacetValue,
    unescapeFacetValue: $d925bd2bfef0b5bb$var$unescapeFacetValue
};


var $17d409ad60bc9be8$require$escapeFacetValue = $d925bd2bfef0b5bb$exports.escapeFacetValue;

var $83d4af1c5291ed1c$exports = {};

var $4TMho = parcelRequire("4TMho");
'use strict';
function $83d4af1c5291ed1c$var$clone(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) === 'object' && value !== null) return $83d4af1c5291ed1c$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $83d4af1c5291ed1c$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $83d4af1c5291ed1c$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($83d4af1c5291ed1c$var$isObjectOrArrayOrFunction(targetVal) && $83d4af1c5291ed1c$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $83d4af1c5291ed1c$var$_merge(targetVal, sourceVal);
        else target[key] = $83d4af1c5291ed1c$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $83d4af1c5291ed1c$var$merge(target) {
    if (!$83d4af1c5291ed1c$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($83d4af1c5291ed1c$var$isObjectOrArrayOrFunction(source)) $83d4af1c5291ed1c$var$_merge(target, source);
    }
    return target;
}
$83d4af1c5291ed1c$exports = $83d4af1c5291ed1c$var$merge;


var $bd3bf08bd2d9cc08$exports = {};
'use strict';
function $bd3bf08bd2d9cc08$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$bd3bf08bd2d9cc08$exports = $bd3bf08bd2d9cc08$var$objectHasKeys;


var $6b397be3d4f76b2c$exports = {};
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $6b397be3d4f76b2c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$6b397be3d4f76b2c$exports = $6b397be3d4f76b2c$var$_objectWithoutPropertiesLoose;


var $09055b27d475e479$exports = {};
'use strict';
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $09055b27d475e479$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$09055b27d475e479$var$RecommendParameters.prototype = {
    constructor: $09055b27d475e479$var$RecommendParameters,
    addParams: function addParams(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $09055b27d475e479$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function removeParams(id) {
        return new $09055b27d475e479$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function addFrequentlyBoughtTogether(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'bought-together'
        }));
    },
    addRelatedProducts: function addRelatedProducts(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'related-products'
        }));
    },
    addTrendingItems: function addTrendingItems(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-items'
        }));
    },
    addTrendingFacets: function addTrendingFacets(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-facets'
        }));
    },
    addLookingSimilar: function addLookingSimilar(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'looking-similar'
        }));
    },
    _buildQueries: function _buildQueries(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
$09055b27d475e479$exports = $09055b27d475e479$var$RecommendParameters;


var $fa19f60ef1346a09$exports = {};
'use strict';
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $fa19f60ef1346a09$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$fa19f60ef1346a09$var$RecommendResults.prototype = {
    constructor: $fa19f60ef1346a09$var$RecommendResults
};
$fa19f60ef1346a09$exports = $fa19f60ef1346a09$var$RecommendResults;


var $db9e77b79696fd6b$exports = {};
'use strict';

function $db9e77b79696fd6b$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $db9e77b79696fd6b$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $db9e77b79696fd6b$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $db9e77b79696fd6b$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $db9e77b79696fd6b$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getCompositionQueries: function getQueries(state) {
        return [
            {
                compositionID: state.index,
                requestBody: {
                    params: $db9e77b79696fd6b$var$requestBuilder._getCompositionHitsSearchParams(state)
                }
            }
        ];
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function _getHitsSearchParams(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($db9e77b79696fd6b$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $db9e77b79696fd6b$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $db9e77b79696fd6b$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $db9e77b79696fd6b$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf('*') > -1 ? [
            '*'
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $db9e77b79696fd6b$var$sortObject($83d4af1c5291ed1c$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getCompositionHitsSearchParams: function _getCompositionHitsSearchParams(state) {
        var facets = state.facets.concat(state.disjunctiveFacets.map(function(value) {
            if (state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements[value] && state.disjunctiveFacetsRefinements[value].length > 0) // only tag a disjunctiveFacet as disjunctive if it has a value selected
            // this helps avoid hitting the limit of 20 disjunctive facets in the Composition API
            return 'disjunctive(' + value + ')';
            return value;
        })).concat($db9e77b79696fd6b$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $db9e77b79696fd6b$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $db9e77b79696fd6b$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $db9e77b79696fd6b$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf('*') > -1 ? [
            '*'
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        var params = state.getQueryParams();
        delete params.highlightPreTag;
        delete params.highlightPostTag;
        // not a valid search parameter, it is handled in _getCompositionQueries
        delete params.index;
        return $db9e77b79696fd6b$var$sortObject($83d4af1c5291ed1c$exports({}, params, additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function _getDisjunctiveFacetSearchParams(state, facet, hierarchicalRootLevel) {
        var facetFilters = $db9e77b79696fd6b$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $db9e77b79696fd6b$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $db9e77b79696fd6b$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $db9e77b79696fd6b$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $db9e77b79696fd6b$var$sortObject($83d4af1c5291ed1c$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function _getNumericFilters(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function _getTagFilters(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function _getFacetFilters(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function _getHitsHierarchicalFacetsAttributes(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function _getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function getSearchForFacetQuery(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $db9e77b79696fd6b$var$sortObject($83d4af1c5291ed1c$exports({}, $db9e77b79696fd6b$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$db9e77b79696fd6b$exports = $db9e77b79696fd6b$var$requestBuilder;


var $90d1be0827ce12d4$exports = {};
'use strict';
var $a363a7a388d19faa$exports = {};
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$a363a7a388d19faa$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $351706cfd8fdd5af$exports = {};
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
$351706cfd8fdd5af$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $af79b7328e78fa7f$exports = {};
'use strict';
function $af79b7328e78fa7f$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$af79b7328e78fa7f$exports = $af79b7328e78fa7f$var$intersection;





var $4c55e80e083e9cec$exports = {};
'use strict';
function $4c55e80e083e9cec$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($4c55e80e083e9cec$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
$4c55e80e083e9cec$exports = $4c55e80e083e9cec$var$valToNumber;


var $ed552d16c5dcb225$exports = {};
'use strict';
$ed552d16c5dcb225$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $2b9bf870b8a104cf$exports = {};
'use strict';



var $2b9bf870b8a104cf$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($2b9bf870b8a104cf$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $a363a7a388d19faa$exports(mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $2b9bf870b8a104cf$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $2b9bf870b8a104cf$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($2b9bf870b8a104cf$var$lib.isRefined(refinementList, attribute, value)) return $2b9bf870b8a104cf$var$lib.removeRefinement(refinementList, attribute, value);
        return $2b9bf870b8a104cf$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$bd3bf08bd2d9cc08$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $6b397be3d4f76b2c$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$2b9bf870b8a104cf$exports = $2b9bf870b8a104cf$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $90d1be0827ce12d4$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $90d1be0827ce12d4$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $90d1be0827ce12d4$var$findArray(array, searchedValue) {
    return $351706cfd8fdd5af$exports(array, function(currentValue) {
        return $90d1be0827ce12d4$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $90d1be0827ce12d4$var$SearchParameters(newParameters) {
    var params = newParameters ? $90d1be0827ce12d4$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$ed552d16c5dcb225$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $90d1be0827ce12d4$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $90d1be0827ce12d4$var$SearchParameters.PARAMETERS = Object.keys(new $90d1be0827ce12d4$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $90d1be0827ce12d4$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $90d1be0827ce12d4$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $83d4af1c5291ed1c$exports(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $90d1be0827ce12d4$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $90d1be0827ce12d4$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $90d1be0827ce12d4$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $bd3bf08bd2d9cc08$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($bd3bf08bd2d9cc08$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$90d1be0827ce12d4$var$SearchParameters.prototype = {
    constructor: $90d1be0827ce12d4$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $2b9bf870b8a104cf$exports.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $2b9bf870b8a104cf$exports.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $2b9bf870b8a104cf$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $2b9bf870b8a104cf$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function addNumericRefinement(attribute, operator, value) {
        var val = $4c55e80e083e9cec$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $83d4af1c5291ed1c$exports({}, this.numericRefinements);
        mod[attribute] = $83d4af1c5291ed1c$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function getConjunctiveRefinements(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function getDisjunctiveRefinements(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function getHierarchicalRefinement(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function getExcludeRefinements(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function removeNumericRefinement(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $90d1be0827ce12d4$var$isEqualNumericRefinement(value.val, $4c55e80e083e9cec$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function getNumericRefinements(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function getNumericRefinement(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$bd3bf08bd2d9cc08$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $6b397be3d4f76b2c$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($2b9bf870b8a104cf$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $2b9bf870b8a104cf$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($2b9bf870b8a104cf$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $2b9bf870b8a104cf$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($2b9bf870b8a104cf$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $2b9bf870b8a104cf$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$2b9bf870b8a104cf$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $2b9bf870b8a104cf$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$2b9bf870b8a104cf$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $2b9bf870b8a104cf$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$2b9bf870b8a104cf$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $2b9bf870b8a104cf$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $2b9bf870b8a104cf$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $2b9bf870b8a104cf$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $2b9bf870b8a104cf$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $a363a7a388d19faa$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function addHierarchicalFacetRefinement(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $a363a7a388d19faa$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function removeHierarchicalFacetRefinement(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $a363a7a388d19faa$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function isDisjunctiveFacet(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function isHierarchicalFacet(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function isConjunctiveFacet(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $2b9bf870b8a104cf$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $2b9bf870b8a104cf$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $2b9bf870b8a104cf$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $4c55e80e083e9cec$exports(value);
        var isAttributeValueDefined = $90d1be0827ce12d4$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $af79b7328e78fa7f$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $af79b7328e78fa7f$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function getUnrefinedDisjunctiveFacets() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $90d1be0827ce12d4$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $90d1be0827ce12d4$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $6b397be3d4f76b2c$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function resetPage() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function _getHierarchicalFacetSortBy(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function _getHierarchicalFacetSeparator(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function _getHierarchicalRootPath(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function _getHierarchicalShowParentLevel(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function getHierarchicalFacetByName(hierarchicalFacetName) {
        return $351706cfd8fdd5af$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function getHierarchicalFacetBreadcrumb(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function toString() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $90d1be0827ce12d4$exports = $90d1be0827ce12d4$var$SearchParameters;


var $eeda65ad87ca4a97$exports = {};
'use strict';
var $14c307b7151be75b$exports = {};
'use strict';
$14c307b7151be75b$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $65ff423c2ab2502e$exports = {};
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
$65ff423c2ab2502e$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $5d2d99689962bcd8$exports = {};
'use strict';

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $5d2d99689962bcd8$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $351706cfd8fdd5af$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};


var $b8d85054783ffad1$exports = {};
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order and keep the highest numeric value
function $b8d85054783ffad1$var$mergeNumericMax() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            var accValue = typeof acc[key] === 'number' ? acc[key] : 0;
            var sourceValue = source[key];
            if (sourceValue === undefined) return;
            if (sourceValue >= accValue) {
                if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
                delete acc[key];
                acc[key] = sourceValue;
            }
        });
        return acc;
    }, {});
}
$b8d85054783ffad1$exports = $b8d85054783ffad1$var$mergeNumericMax;


var $91024fb75424817b$exports = {};
'use strict';
function $91024fb75424817b$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $91024fb75424817b$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $91024fb75424817b$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$91024fb75424817b$exports = $91024fb75424817b$var$orderBy;


var $eeda65ad87ca4a97$var$escapeFacetValue = $d925bd2bfef0b5bb$exports.escapeFacetValue;
var $eeda65ad87ca4a97$var$unescapeFacetValue = $d925bd2bfef0b5bb$exports.unescapeFacetValue;
var $c4f404c87871386c$exports = {};
'use strict';
$c4f404c87871386c$exports = $c4f404c87871386c$var$generateTrees;




var $c4f404c87871386c$var$escapeFacetValue = $d925bd2bfef0b5bb$exports.escapeFacetValue;
var $c4f404c87871386c$var$unescapeFacetValue = $d925bd2bfef0b5bb$exports.unescapeFacetValue;
function $c4f404c87871386c$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $5d2d99689962bcd8$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $c4f404c87871386c$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $c4f404c87871386c$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $351706cfd8fdd5af$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $c4f404c87871386c$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $91024fb75424817b$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $c4f404c87871386c$var$format(facetCount, facetValue, hierarchicalSeparator, $c4f404c87871386c$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $c4f404c87871386c$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $c4f404c87871386c$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $c4f404c87871386c$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $eeda65ad87ca4a97$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $eeda65ad87ca4a97$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $eeda65ad87ca4a97$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $351706cfd8fdd5af$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $eeda65ad87ca4a97$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $a363a7a388d19faa$exports(options, {
        persistHierarchicalRootCount: false
    });
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $eeda65ad87ca4a97$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $eeda65ad87ca4a97$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $eeda65ad87ca4a97$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $65ff423c2ab2502e$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $eeda65ad87ca4a97$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $eeda65ad87ca4a97$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $14c307b7151be75b$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $65ff423c2ab2502e$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $65ff423c2ab2502e$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = self.persistHierarchicalRootCount ? $b8d85054783ffad1$exports(self.hierarchicalFacets[position][attributeIndex].data, facetResults) : $a363a7a388d19faa$exports(facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $b8d85054783ffad1$exports(dataFromMainRequest, facetResults),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $eeda65ad87ca4a97$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($eeda65ad87ca4a97$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $65ff423c2ab2502e$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $65ff423c2ab2502e$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $a363a7a388d19faa$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($c4f404c87871386c$exports(state));
    /**
   * @type {Array}
   */ this.facets = $14c307b7151be75b$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $14c307b7151be75b$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $eeda65ad87ca4a97$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $351706cfd8fdd5af$exports(this.facets, predicate) || $351706cfd8fdd5af$exports(this.disjunctiveFacets, predicate) || $351706cfd8fdd5af$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $eeda65ad87ca4a97$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $351706cfd8fdd5af$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $eeda65ad87ca4a97$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $351706cfd8fdd5af$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $eeda65ad87ca4a97$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $351706cfd8fdd5af$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $eeda65ad87ca4a97$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $eeda65ad87ca4a97$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $eeda65ad87ca4a97$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $eeda65ad87ca4a97$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $eeda65ad87ca4a97$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $eeda65ad87ca4a97$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $a363a7a388d19faa$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$eeda65ad87ca4a97$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $eeda65ad87ca4a97$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $eeda65ad87ca4a97$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($91024fb75424817b$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $eeda65ad87ca4a97$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $eeda65ad87ca4a97$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $eeda65ad87ca4a97$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $a363a7a388d19faa$exports(opts, {
        sortBy: $eeda65ad87ca4a97$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $eeda65ad87ca4a97$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $eeda65ad87ca4a97$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $eeda65ad87ca4a97$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $5d2d99689962bcd8$exports(options.sortBy, $eeda65ad87ca4a97$var$SearchResults.DEFAULT_SORT);
            return $91024fb75424817b$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $eeda65ad87ca4a97$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $eeda65ad87ca4a97$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $eeda65ad87ca4a97$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $eeda65ad87ca4a97$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $eeda65ad87ca4a97$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $351706cfd8fdd5af$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $eeda65ad87ca4a97$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($eeda65ad87ca4a97$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($eeda65ad87ca4a97$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($eeda65ad87ca4a97$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($eeda65ad87ca4a97$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $eeda65ad87ca4a97$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $351706cfd8fdd5af$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $eeda65ad87ca4a97$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $351706cfd8fdd5af$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $351706cfd8fdd5af$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$eeda65ad87ca4a97$exports = $eeda65ad87ca4a97$var$SearchResults;


var $f59309a4f4487152$exports = {};
'use strict';

var $8d69daf3b50f828c$exports = {};
// @MAJOR: remove this function and use Array.prototype.flat
$8d69daf3b50f828c$exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};


function $f59309a4f4487152$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $f59309a4f4487152$var$sortAndMergeRecommendations(objectIDs, results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (objectIDs.includes(hit.objectID)) return;
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $f59309a4f4487152$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $351706cfd8fdd5af$exports($8d69daf3b50f828c$exports(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
$f59309a4f4487152$exports = $f59309a4f4487152$var$sortAndMergeRecommendations;



var $djQmR = parcelRequire("djQmR");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $17d409ad60bc9be8$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $djQmR + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $90d1be0827ce12d4$exports.make(opts);
    this.recommendState = new $09055b27d475e479$exports({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$5f865a62ae7e9a86$exports($17d409ad60bc9be8$var$AlgoliaSearchHelper, $1b8b757b6af13439$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.searchWithComposition = function() {
    this._runComposition({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $db9e77b79696fd6b$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $db9e77b79696fd6b$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $eeda65ad87ca4a97$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $eeda65ad87ca4a97$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $83d4af1c5291ed1c$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $6b397be3d4f76b2c$exports($db9e77b79696fd6b$exports._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function' && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $db9e77b79696fd6b$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    var hide = this.lastResults && this.lastResults.index === state.index && this.lastResults.renderingContent && this.lastResults.renderingContent.facetOrdering && this.lastResults.renderingContent.facetOrdering.values && this.lastResults.renderingContent.facetOrdering.values[facet] && this.lastResults.renderingContent.facetOrdering.values[facet].hide || [];
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f, i) {
            if (hide.indexOf(f.value) > -1) {
                content.facetHits.splice(i, 1);
                return;
            }
            f.escapedValue = $17d409ad60bc9be8$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Search for facet values using the Composition API & based on a query and the name of a faceted attribute.
 * This triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.searchForCompositionFacetValues = function(facet, query, maxFacetHits, userState) {
    if (typeof this.client.searchForFacetValues !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    searchForFacetValuesPromise = this.client.searchForFacetValues({
        compositionID: state.index,
        facetName: facet,
        searchForFacetValuesRequest: {
            params: {
                query: query,
                maxFacetHits: maxFacetHits,
                searchQuery: $db9e77b79696fd6b$exports._getCompositionHitsSearchParams(state)
            }
        }
    });
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = content.results[0];
        content.facetHits.forEach(function(f) {
            f.escapedValue = $17d409ad60bc9be8$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $17d409ad60bc9be8$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setCurrentPage = $17d409ad60bc9be8$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setPage = $17d409ad60bc9be8$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $90d1be0827ce12d4$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $90d1be0827ce12d4$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($bd3bf08bd2d9cc08$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $17d409ad60bc9be8$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getCurrentPage = $17d409ad60bc9be8$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getPage = $17d409ad60bc9be8$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $db9e77b79696fd6b$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $db9e77b79696fd6b$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
/**
 * Perform the underlying queries
 * @private
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._runComposition = function() {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = $db9e77b79696fd6b$exports._getCompositionQueries(derivedState);
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    if (queries.length > 1) throw new Error('Only one query is allowed when using a composition.');
    var query = queries[0];
    try {
        this.client.search(query).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit('fetch', {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $09055b27d475e479$exports());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit('fetch', {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('Please update algoliasearch/lite to the latest version in order to use recommend widgets.');
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    var rawContent = Object.keys(content).reduce(function(value, key) {
        if (key !== 'results') value[key] = content[key];
        return value;
    }, {});
    if (Object.keys(rawContent).length <= 0) rawContent = undefined;
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $eeda65ad87ca4a97$exports(state, specificResults, self._searchResultsOptions);
        if (rawContent !== undefined) helper.lastResults._rawContent = rawContent;
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $f59309a4f4487152$exports(ids, indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit('recommend:result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $fa19f60ef1346a09$exports(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit('recommend:result', {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit('recommend:change', {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $djQmR + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $405753375d0f8b8a$exports(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $17d409ad60bc9be8$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $17d409ad60bc9be8$exports = $17d409ad60bc9be8$var$AlgoliaSearchHelper;






/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $32cead6defcfe2a5$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $17d409ad60bc9be8$exports(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $32cead6defcfe2a5$var$algoliasearchHelper.version = (parcelRequire("djQmR"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $32cead6defcfe2a5$var$algoliasearchHelper.AlgoliaSearchHelper = $17d409ad60bc9be8$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $32cead6defcfe2a5$var$algoliasearchHelper.SearchParameters = $90d1be0827ce12d4$exports;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $32cead6defcfe2a5$var$algoliasearchHelper.RecommendParameters = $09055b27d475e479$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $32cead6defcfe2a5$var$algoliasearchHelper.SearchResults = $eeda65ad87ca4a97$exports;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $32cead6defcfe2a5$var$algoliasearchHelper.RecommendResults = $fa19f60ef1346a09$exports;
$32cead6defcfe2a5$exports = $32cead6defcfe2a5$var$algoliasearchHelper;


function $ae06a923ad950e1e$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        'https://www.algolia.com/doc/api-reference/widgets/',
        name,
        '/js/',
        connector ? '#connector' : ''
    ].join('');
}
function $ae06a923ad950e1e$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $ae06a923ad950e1e$export$110679b26359d23d(widget);
    }).join(', ');
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join('\n\n');
    };
}

function $ca7c76376182a382$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ca7c76376182a382$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ca7c76376182a382$var$_typeof(o);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $ca7c76376182a382$var$getTag(value) {
    if (value === null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
function $ca7c76376182a382$var$isObjectLike(value) {
    return $ca7c76376182a382$var$_typeof(value) === 'object' && value !== null;
}
function $ca7c76376182a382$export$53b83ca8eaab0383(value) {
    if (!$ca7c76376182a382$var$isObjectLike(value) || $ca7c76376182a382$var$getTag(value) !== '[object Object]') return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $a9a7146bbe265f53$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}


function $a341acb2f4de204b$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}


function $e2c5e310b54d33e0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e2c5e310b54d33e0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e2c5e310b54d33e0$var$_typeof(o);
}
var $e2c5e310b54d33e0$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $e2c5e310b54d33e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2c5e310b54d33e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2c5e310b54d33e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e2c5e310b54d33e0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2c5e310b54d33e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e2c5e310b54d33e0$var$_defineProperty(obj, key, value) {
    key = $e2c5e310b54d33e0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e2c5e310b54d33e0$var$_toPropertyKey(t) {
    var i = $e2c5e310b54d33e0$var$_toPrimitive(t, "string");
    return "symbol" == $e2c5e310b54d33e0$var$_typeof(i) ? i : String(i);
}
function $e2c5e310b54d33e0$var$_toPrimitive(t, r) {
    if ("object" != $e2c5e310b54d33e0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e2c5e310b54d33e0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e2c5e310b54d33e0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e2c5e310b54d33e0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e2c5e310b54d33e0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e2c5e310b54d33e0$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $e2c5e310b54d33e0$var$_objectWithoutProperties(right, $e2c5e310b54d33e0$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $e2c5e310b54d33e0$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $e2c5e310b54d33e0$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $e2c5e310b54d33e0$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $a9a7146bbe265f53$export$de3a4d4a0d731119)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $e2c5e310b54d33e0$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $e2c5e310b54d33e0$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $e2c5e310b54d33e0$var$_objectSpread($e2c5e310b54d33e0$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $e2c5e310b54d33e0$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $e2c5e310b54d33e0$var$_objectSpread($e2c5e310b54d33e0$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $e2c5e310b54d33e0$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $e2c5e310b54d33e0$var$_objectSpread($e2c5e310b54d33e0$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $e2c5e310b54d33e0$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $e2c5e310b54d33e0$var$_objectSpread($e2c5e310b54d33e0$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $e2c5e310b54d33e0$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $e2c5e310b54d33e0$var$_objectSpread($e2c5e310b54d33e0$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $e2c5e310b54d33e0$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $a341acb2f4de204b$export$f70730c3d1fc524e)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $e2c5e310b54d33e0$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $e2c5e310b54d33e0$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $e2c5e310b54d33e0$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $e2c5e310b54d33e0$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $e2c5e310b54d33e0$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $e2c5e310b54d33e0$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $e2c5e310b54d33e0$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $e2c5e310b54d33e0$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $e2c5e310b54d33e0$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $e2c5e310b54d33e0$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $e2c5e310b54d33e0$var$mergeFacets(ruleContextsMerged, right);
        return $e2c5e310b54d33e0$var$mergeWithRest(facetsMerged, right);
    });
};

function $1c8cc0c1c6330343$export$8793edee2d425525() {}


function $c2f7efbc26f85a0f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c2f7efbc26f85a0f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c2f7efbc26f85a0f$var$_typeof(o);
}
function $c2f7efbc26f85a0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2f7efbc26f85a0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2f7efbc26f85a0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c2f7efbc26f85a0f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2f7efbc26f85a0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2f7efbc26f85a0f$var$_defineProperty(obj, key, value) {
    key = $c2f7efbc26f85a0f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2f7efbc26f85a0f$var$_toPropertyKey(t) {
    var i = $c2f7efbc26f85a0f$var$_toPrimitive(t, "string");
    return "symbol" == $c2f7efbc26f85a0f$var$_typeof(i) ? i : String(i);
}
function $c2f7efbc26f85a0f$var$_toPrimitive(t, r) {
    if ("object" != $c2f7efbc26f85a0f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c2f7efbc26f85a0f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Refine the given search parameters.
 */ var $c2f7efbc26f85a0f$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'configure',
    connector: true
});
function $c2f7efbc26f85a0f$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, acc), {}, $c2f7efbc26f85a0f$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $c2f7efbc26f85a0f$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    return function(widgetParams) {
        if (!widgetParams || !(0, $ca7c76376182a382$export$53b83ca8eaab0383)(widgetParams.searchParameters)) throw new Error($c2f7efbc26f85a0f$var$withUsage('The `searchParameters` option expects an object.'));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $c2f7efbc26f85a0f$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $e2c5e310b54d33e0$export$8049d91f25899769)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: 'ais.configure',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $c2f7efbc26f85a0f$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, renderState), {}, {
                    configure: $c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $e2c5e310b54d33e0$export$8049d91f25899769)(new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $e2c5e310b54d33e0$export$8049d91f25899769)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters($c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, uiState), {}, {
                    configure: $c2f7efbc26f85a0f$var$_objectSpread($c2f7efbc26f85a0f$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $c2f7efbc26f85a0f$export$2e2bcd8739ae039 = $c2f7efbc26f85a0f$var$connectConfigure;



var $ggE0n = parcelRequire("ggE0n");
function $3e9453843be7bce4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3e9453843be7bce4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3e9453843be7bce4$var$_typeof(o);
}
/* eslint-disable complexity */ /*
 * Code taken from dequal/lite v2.0.0
 * https://github.com/lukeed/dequal/blob/9aa73181ac7e081cd330cac67d313632ac04bb02/src/lite.js
 *
 * It adds a 3rd argument `compare(a, b)` that lets execute custom logic to
 * compare values.
 * We use it to skip comparing function references.
 */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $3e9453843be7bce4$var$has = Object.prototype.hasOwnProperty;
function $3e9453843be7bce4$export$de8294bb3be0322f(foo, bar, compare) {
    // start of custom implementation
    if (compare !== null && compare !== void 0 && compare(foo, bar)) return true;
    // end of custom implementation
    var ctor;
    var len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $3e9453843be7bce4$export$de8294bb3be0322f(foo[len], bar[len], compare));
            }
            return len === -1;
        }
        if (!ctor || $3e9453843be7bce4$var$_typeof(foo) === 'object') {
            len = 0;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for(ctor in foo){
                if ($3e9453843be7bce4$var$has.call(foo, ctor) && ++len && !$3e9453843be7bce4$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$3e9453843be7bce4$export$de8294bb3be0322f(foo[ctor], bar[ctor], compare)) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    // eslint-disable-next-line no-self-compare
    return foo !== foo && bar !== bar;
}



function $943b2397f102d9d5$export$be9bb8d98a5619e9(state) {
    var _state$query, _state$page, _state$hitsPerPage;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchResults(state, [
        {
            query: (_state$query = state.query) !== null && _state$query !== void 0 ? _state$query : '',
            page: (_state$page = state.page) !== null && _state$page !== void 0 ? _state$page : 0,
            hitsPerPage: (_state$hitsPerPage = state.hitsPerPage) !== null && _state$hitsPerPage !== void 0 ? _state$hitsPerPage : 20,
            hits: [],
            nbHits: 0,
            nbPages: 0,
            params: '',
            exhaustiveNbHits: true,
            exhaustiveFacetsCount: true,
            processingTimeMS: 0,
            index: state.index
        }
    ], {
        /** used by connectors to prevent persisting these results */ __isArtificial: true
    });
}


function $02c1f4b77019b96f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $02c1f4b77019b96f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $02c1f4b77019b96f$var$_typeof(o);
}
function $02c1f4b77019b96f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02c1f4b77019b96f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02c1f4b77019b96f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $02c1f4b77019b96f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02c1f4b77019b96f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $02c1f4b77019b96f$var$_defineProperty(obj, key, value) {
    key = $02c1f4b77019b96f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $02c1f4b77019b96f$var$_toPropertyKey(t) {
    var i = $02c1f4b77019b96f$var$_toPrimitive(t, "string");
    return "symbol" == $02c1f4b77019b96f$var$_typeof(i) ? i : String(i);
}
function $02c1f4b77019b96f$var$_toPrimitive(t, r) {
    if ("object" != $02c1f4b77019b96f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $02c1f4b77019b96f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $02c1f4b77019b96f$export$cb51f617c98f90d3(indexWidget) {
    var helper = indexWidget.getHelper();
    var results = // On SSR, we get the results injected on the Index.
    indexWidget.getResults() || // On the browser, we create fallback results based on the helper state.
    (0, $943b2397f102d9d5$export$be9bb8d98a5619e9)(helper.state);
    var scopedResults = indexWidget.getScopedResults().map(function(scopedResult) {
        var fallbackResults = scopedResult.indexId === indexWidget.getIndexId() ? results : (0, $943b2397f102d9d5$export$be9bb8d98a5619e9)(scopedResult.helper.state);
        return $02c1f4b77019b96f$var$_objectSpread($02c1f4b77019b96f$var$_objectSpread({}, scopedResult), {}, {
            // We keep `results` from being `null`.
            results: scopedResult.results || fallbackResults
        });
    });
    return {
        results: results,
        scopedResults: scopedResults,
        recommendResults: helper.lastRecommendResults
    };
}



var $ggE0n = parcelRequire("ggE0n");

var $ggE0n = parcelRequire("ggE0n");
var $197036370167c5cc$export$899c7584ba03b94a = /*#__PURE__*/ (0, $ggE0n.createContext)(null);


/**
 * Throws an error if the condition is not met.
 *
 * The error is exhaustive in development, and becomes generic in production.
 *
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $498d3181c40291e9$export$f5708dca728d7177(condition, message) {
    if (condition) return;
    throw new Error('Invariant failed');
}


function $ff1c2cc87ff571fe$export$78be30f1ffebe6ed() {
    var context = (0, $ggE0n.useContext)((0, $197036370167c5cc$export$899c7584ba03b94a));
    (0, $498d3181c40291e9$export$f5708dca728d7177)(context !== null, 'The <Index> component must be used within <InstantSearch>.');
    return context;
}



var $ggE0n = parcelRequire("ggE0n");

var $ggE0n = parcelRequire("ggE0n");
var $1d7e551f1487fee4$export$4b9ddb9c6903c13 = /*#__PURE__*/ (0, $ggE0n.createContext)(null);



function $7b73f0fe3da59f00$export$607655cdd66d2a68() {
    var search = (0, $ggE0n.useContext)((0, $1d7e551f1487fee4$export$4b9ddb9c6903c13));
    (0, $498d3181c40291e9$export$f5708dca728d7177)(search !== null, "Hooks must be used inside the <InstantSearch> component.\n\nThey are not compatible with the `react-instantsearch-core@6.x` and `react-instantsearch-dom` packages, so make sure to use the <InstantSearch> component from `react-instantsearch-core@7.x`.");
    return search;
}



var $ggE0n = parcelRequire("ggE0n");

var $ggE0n = parcelRequire("ggE0n");
var $d53845fb07a4a03f$export$87f9401208449446 = /*#__PURE__*/ (0, $ggE0n.createContext)(null);


function $00cd4da9ce57bfe1$export$692e83606e644bf6() {
    return (0, $ggE0n.useContext)((0, $d53845fb07a4a03f$export$87f9401208449446));
}



var $ggE0n = parcelRequire("ggE0n");

var $ggE0n = parcelRequire("ggE0n");
var $fb27f5105220a630$export$92edcc5c9a39af56 = /*#__PURE__*/ (0, $ggE0n.createContext)(null);


function $f921733e63b96a3d$export$b7b167d1ffee3ddc() {
    return (0, $ggE0n.useContext)((0, $fb27f5105220a630$export$92edcc5c9a39af56));
}



var $ggE0n = parcelRequire("ggE0n");

function $f7e278e188731f8d$var$_slicedToArray(arr, i) {
    return $f7e278e188731f8d$var$_arrayWithHoles(arr) || $f7e278e188731f8d$var$_iterableToArrayLimit(arr, i) || $f7e278e188731f8d$var$_unsupportedIterableToArray(arr, i) || $f7e278e188731f8d$var$_nonIterableRest();
}
function $f7e278e188731f8d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f7e278e188731f8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f7e278e188731f8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f7e278e188731f8d$var$_arrayLikeToArray(o, minLen);
}
function $f7e278e188731f8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f7e278e188731f8d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f7e278e188731f8d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f7e278e188731f8d$export$e15835fface14b28(value) {
    var _useState = (0, $ggE0n.useState)(function() {
        return value;
    }), _useState2 = $f7e278e188731f8d$var$_slicedToArray(_useState, 2), stableValue = _useState2[0], setStableValue = _useState2[1];
    if (!(0, $3e9453843be7bce4$export$de8294bb3be0322f)(stableValue, value)) setStableValue(value);
    return stableValue;
}



var $ggE0n = parcelRequire("ggE0n");


var $ggE0n = parcelRequire("ggE0n");
var $ed9505452e43c384$var$useKey = 'use';
var $ed9505452e43c384$export$1f96ae73734a86cc = $ggE0n[$ed9505452e43c384$var$useKey];




var $ggE0n = parcelRequire("ggE0n");
var $b279185b17e60034$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $ggE0n.useLayoutEffect) : (0, $ggE0n.useEffect);



var $ggE0n = parcelRequire("ggE0n");

var $ggE0n = parcelRequire("ggE0n");
var $99be7a603fea01c0$export$f690384094665d60 = /*#__PURE__*/ (0, $ggE0n.createContext)(null);


function $3bff512125d1ba8b$export$b0820d56d4bdeee6() {
    return (0, $ggE0n.useContext)((0, $99be7a603fea01c0$export$f690384094665d60));
}


function $2306f57bad20e80f$export$bed784987806c3d2(_ref) {
    var _waitingForResultsRef;
    var widget = _ref.widget, parentIndex = _ref.parentIndex, props = _ref.props, shouldSsr = _ref.shouldSsr;
    var waitingForResultsRef = (0, $3bff512125d1ba8b$export$b0820d56d4bdeee6)();
    var prevPropsRef = (0, $ggE0n.useRef)(props);
    (0, $ggE0n.useEffect)(function() {
        prevPropsRef.current = props;
    }, [
        props
    ]);
    var prevWidgetRef = (0, $ggE0n.useRef)(widget);
    (0, $ggE0n.useEffect)(function() {
        prevWidgetRef.current = widget;
    }, [
        widget
    ]);
    var cleanupTimerRef = (0, $ggE0n.useRef)(null);
    var shouldAddWidgetEarly = shouldSsr && !parentIndex.getWidgets().includes(widget);
    var search = (0, $7b73f0fe3da59f00$export$607655cdd66d2a68)();
    // This effect is responsible for adding, removing, and updating the widget.
    // We need to support scenarios where the widget is remounted quickly, like in
    // Strict Mode, so that we don't lose its state, and therefore that we don't
    // break routing.
    (0, $b279185b17e60034$export$700979bc83e7db82)(function() {
        var previousWidget = prevWidgetRef.current;
        // Scenario 1: the widget is added for the first time.
        if (!cleanupTimerRef.current) {
            if (!shouldSsr) parentIndex.addWidgets([
                widget
            ]);
        } else {
            // We cancel the original effect cleanup because it may not be necessary if
            // props haven't changed. (We manually call it if it is below.)
            clearTimeout(cleanupTimerRef.current);
            // Warning: if an unstable function prop is provided, `dequal` is not able
            // to keep its reference and therefore will consider that props did change.
            // This could unsollicitely remove/add the widget, therefore forget its state,
            // and could be a source of confusion.
            // If users face this issue, we should advise them to provide stable function
            // references.
            var arePropsEqual = (0, $3e9453843be7bce4$export$de8294bb3be0322f)(props, prevPropsRef.current);
            // If props did change, then we execute the cleanup function instantly
            // and then add the widget back. This lets us add the widget without
            // waiting for the scheduled cleanup function to finish (that we canceled
            // above).
            if (!arePropsEqual) {
                parentIndex.removeWidgets([
                    previousWidget
                ]);
                parentIndex.addWidgets([
                    widget
                ]);
            }
        }
        return function() {
            // We don't remove the widget right away, but rather schedule it so that
            // we're able to cancel it in the next effect.
            cleanupTimerRef.current = setTimeout(function() {
                search._schedule(function() {
                    if (search._preventWidgetCleanup) return;
                    parentIndex.removeWidgets([
                        previousWidget
                    ]);
                });
            });
        };
    }, [
        parentIndex,
        widget,
        shouldSsr,
        search,
        props
    ]);
    if (shouldAddWidgetEarly || (waitingForResultsRef === null || waitingForResultsRef === void 0 ? void 0 : (_waitingForResultsRef = waitingForResultsRef.current) === null || _waitingForResultsRef === void 0 ? void 0 : _waitingForResultsRef.status) === 'pending') parentIndex.addWidgets([
        widget
    ]);
    if (typeof window === 'undefined' && waitingForResultsRef !== null && waitingForResultsRef !== void 0 && waitingForResultsRef.current && // We need the widgets contained in the index to be added before we trigger the search request.
    widget.$$type !== 'ais.index') {
        var _search$helper;
        (0, $ed9505452e43c384$export$1f96ae73734a86cc)(waitingForResultsRef.current);
        // If we made a second request because of DynamicWidgets, we need to wait for the second result,
        // except for DynamicWidgets itself which needs to render its children after the first result.
        if (widget.$$type !== 'ais.dynamicWidgets' && (_search$helper = search.helper) !== null && _search$helper !== void 0 && _search$helper.lastResults) (0, $ed9505452e43c384$export$1f96ae73734a86cc)(waitingForResultsRef.current);
    }
}


function $ef79e46e7636cdf2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ef79e46e7636cdf2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ef79e46e7636cdf2$var$_typeof(o);
}
var $ef79e46e7636cdf2$var$_excluded = [
    "instantSearchInstance",
    "widgetParams"
], $ef79e46e7636cdf2$var$_excluded2 = [
    "widgetParams"
];
function $ef79e46e7636cdf2$var$_slicedToArray(arr, i) {
    return $ef79e46e7636cdf2$var$_arrayWithHoles(arr) || $ef79e46e7636cdf2$var$_iterableToArrayLimit(arr, i) || $ef79e46e7636cdf2$var$_unsupportedIterableToArray(arr, i) || $ef79e46e7636cdf2$var$_nonIterableRest();
}
function $ef79e46e7636cdf2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ef79e46e7636cdf2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ef79e46e7636cdf2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ef79e46e7636cdf2$var$_arrayLikeToArray(o, minLen);
}
function $ef79e46e7636cdf2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ef79e46e7636cdf2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ef79e46e7636cdf2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ef79e46e7636cdf2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef79e46e7636cdf2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef79e46e7636cdf2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ef79e46e7636cdf2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef79e46e7636cdf2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ef79e46e7636cdf2$var$_defineProperty(obj, key, value) {
    key = $ef79e46e7636cdf2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef79e46e7636cdf2$var$_toPropertyKey(t) {
    var i = $ef79e46e7636cdf2$var$_toPrimitive(t, "string");
    return "symbol" == $ef79e46e7636cdf2$var$_typeof(i) ? i : String(i);
}
function $ef79e46e7636cdf2$var$_toPrimitive(t, r) {
    if ("object" != $ef79e46e7636cdf2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ef79e46e7636cdf2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ef79e46e7636cdf2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ef79e46e7636cdf2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ef79e46e7636cdf2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ef79e46e7636cdf2$export$7b345619fa263f7e(connector) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var additionalWidgetProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var serverContext = (0, $00cd4da9ce57bfe1$export$692e83606e644bf6)();
    var ssrContext = (0, $f921733e63b96a3d$export$b7b167d1ffee3ddc)();
    var search = (0, $7b73f0fe3da59f00$export$607655cdd66d2a68)();
    var parentIndex = (0, $ff1c2cc87ff571fe$export$78be30f1ffebe6ed)();
    var stableProps = (0, $f7e278e188731f8d$export$e15835fface14b28)(props);
    var stableAdditionalWidgetProperties = (0, $f7e278e188731f8d$export$e15835fface14b28)(additionalWidgetProperties);
    var shouldSetStateRef = (0, $ggE0n.useRef)(true);
    var previousRenderStateRef = (0, $ggE0n.useRef)(null);
    var previousStatusRef = (0, $ggE0n.useRef)(search.status);
    var widget = (0, $ggE0n.useMemo)(function() {
        var createWidget = connector(function(connectorState, isFirstRender) {
            // We skip the `init` widget render because:
            // - We rely on `getWidgetRenderState` to compute the initial state before
            //   the InstantSearch.js lifecycle starts.
            // - It prevents UI flashes when updating the widget props.
            if (isFirstRender) {
                shouldSetStateRef.current = true;
                return;
            }
            // There are situations where InstantSearch.js may render widgets slightly
            // after they're removed by React, and thus try to update the React state
            // on unmounted components. React 16 and 17 consider them as memory leaks
            // and display a warning.
            // This happens in <DynamicWidgets> when `attributesToRender` contains a
            // value without an attribute previously mounted. React will unmount the
            // component controlled by that attribute, but InstantSearch.js will stay
            // unaware of this change until the render pass finishes, and therefore
            // notifies of a state change.
            // This ref lets us track this situation and ignore these state updates.
            if (shouldSetStateRef.current) {
                var instantSearchInstance = connectorState.instantSearchInstance, widgetParams = connectorState.widgetParams, renderState = $ef79e46e7636cdf2$var$_objectWithoutProperties(connectorState, $ef79e46e7636cdf2$var$_excluded);
                // We only update the state when a widget render state param changes,
                // except for functions. We ignore function reference changes to avoid
                // infinite loops. It's safe to omit them because they get updated
                // every time another render param changes.
                if (!(0, $3e9453843be7bce4$export$de8294bb3be0322f)(renderState, previousRenderStateRef.current, function(a, b) {
                    return (a === null || a === void 0 ? void 0 : a.constructor) === Function && (b === null || b === void 0 ? void 0 : b.constructor) === Function;
                }) || instantSearchInstance.status !== previousStatusRef.current) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    setState(renderState);
                    previousRenderStateRef.current = renderState;
                    previousStatusRef.current = instantSearchInstance.status;
                }
            }
        }, function() {
            // We'll ignore the next state update until we know for sure that
            // InstantSearch.js re-inits the component.
            shouldSetStateRef.current = false;
        });
        return $ef79e46e7636cdf2$var$_objectSpread($ef79e46e7636cdf2$var$_objectSpread({}, createWidget(stableProps)), stableAdditionalWidgetProperties);
    }, [
        connector,
        stableProps,
        stableAdditionalWidgetProperties
    ]);
    var _useState = (0, $ggE0n.useState)(function() {
        if (widget.getWidgetRenderState) {
            var _widget$getWidgetSear;
            // The helper exists because we've started InstantSearch.
            var helper = parentIndex.getHelper();
            var uiState = parentIndex.getWidgetUiState({})[parentIndex.getIndexId()];
            helper.state = ((_widget$getWidgetSear = widget.getWidgetSearchParameters) === null || _widget$getWidgetSear === void 0 ? void 0 : _widget$getWidgetSear.call(widget, helper.state, {
                uiState: uiState
            })) || helper.state;
            var _getIndexSearchResult = (0, $02c1f4b77019b96f$export$cb51f617c98f90d3)(parentIndex), results = _getIndexSearchResult.results, scopedResults = _getIndexSearchResult.scopedResults, recommendResults = _getIndexSearchResult.recommendResults;
            // We get the widget render state by providing the same parameters as
            // InstantSearch provides to the widget's `render` method.
            // See https://github.com/algolia/instantsearch/blob/019cd18d0de6dd320284aa4890541b7fe2198c65/src/widgets/index/index.ts#L604-L617
            var _widget$getWidgetRend = widget.getWidgetRenderState({
                helper: helper,
                parent: parentIndex,
                instantSearchInstance: search,
                results: widget.dependsOn === 'recommend' && recommendResults && ssrContext ? recommendResults[ssrContext.recommendIdx.current++] : results,
                scopedResults: scopedResults,
                state: helper.state,
                renderState: search.renderState,
                templatesConfig: search.templatesConfig,
                createURL: parentIndex.createURL,
                searchMetadata: {
                    isSearchStalled: search.status === 'stalled'
                },
                status: search.status,
                error: search.error
            }), widgetParams = _widget$getWidgetRend.widgetParams, renderState = $ef79e46e7636cdf2$var$_objectWithoutProperties(_widget$getWidgetRend, $ef79e46e7636cdf2$var$_excluded2);
            return renderState;
        }
        return {};
    }), _useState2 = $ef79e46e7636cdf2$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    (0, $2306f57bad20e80f$export$bed784987806c3d2)({
        widget: widget,
        parentIndex: parentIndex,
        props: stableProps,
        shouldSsr: Boolean(serverContext)
    });
    return state;
}


function $6c33fbedaadb9df6$export$9bc811ec545fbcb6(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $c2f7efbc26f85a0f$export$2e2bcd8739ae039), {
        searchParameters: props
    }, additionalWidgetProperties);
}


function $3240ea332fbba201$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3240ea332fbba201$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3240ea332fbba201$var$_typeof(o);
}
function $3240ea332fbba201$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3240ea332fbba201$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3240ea332fbba201$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3240ea332fbba201$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3240ea332fbba201$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3240ea332fbba201$var$_defineProperty(obj, key, value) {
    key = $3240ea332fbba201$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3240ea332fbba201$var$_toPropertyKey(t) {
    var i = $3240ea332fbba201$var$_toPrimitive(t, "string");
    return "symbol" == $3240ea332fbba201$var$_typeof(i) ? i : String(i);
}
function $3240ea332fbba201$var$_toPrimitive(t, r) {
    if ("object" != $3240ea332fbba201$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3240ea332fbba201$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3240ea332fbba201$export$de5f40ff1ff419d2(props) {
    (0, $6c33fbedaadb9df6$export$9bc811ec545fbcb6)($3240ea332fbba201$var$_objectSpread({}, props), {
        $$widgetType: 'ais.configure'
    });
    return null;
}

var $cedb4c362cb59905$exports = {};
function $cedb4c362cb59905$var$_extends() {
    return $cedb4c362cb59905$exports = $cedb4c362cb59905$var$_extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cedb4c362cb59905$exports.__esModule = true, $cedb4c362cb59905$exports["default"] = $cedb4c362cb59905$exports, $cedb4c362cb59905$var$_extends.apply(null, arguments);
}
$cedb4c362cb59905$exports = $cedb4c362cb59905$var$_extends, $cedb4c362cb59905$exports.__esModule = true, $cedb4c362cb59905$exports["default"] = $cedb4c362cb59905$exports;


var $fbc7209d88dc680e$exports = {};
var $a3a27b97d81af2f6$exports = {};
function $a3a27b97d81af2f6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$a3a27b97d81af2f6$exports = $a3a27b97d81af2f6$var$_objectWithoutPropertiesLoose, $a3a27b97d81af2f6$exports.__esModule = true, $a3a27b97d81af2f6$exports["default"] = $a3a27b97d81af2f6$exports;


function $fbc7209d88dc680e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a3a27b97d81af2f6$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$fbc7209d88dc680e$exports = $fbc7209d88dc680e$var$_objectWithoutProperties, $fbc7209d88dc680e$exports.__esModule = true, $fbc7209d88dc680e$exports["default"] = $fbc7209d88dc680e$exports;


function $ca477697f7684c0d$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(' ');
}


var $3e3be695d45b2806$var$_excluded = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent",
    "banner",
    "bannerComponent"
];
// Should be imported from a shared package in the future
function $3e3be695d45b2806$var$createDefaultBannerComponent(_ref) {
    var createElement = _ref.createElement;
    return function DefaultBanner(_ref2) {
        var classNames = _ref2.classNames, banner = _ref2.banner;
        if (!banner.image.urls[0].url) return null;
        return createElement("aside", {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-banner', classNames.bannerRoot)
        }, banner.link ? createElement("a", {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-banner-link', classNames.bannerLink),
            href: banner.link.url,
            target: banner.link.target
        }, createElement("img", {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-banner-image', classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        })) : createElement("img", {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-banner-image', classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        }));
    };
}
function $3e3be695d45b2806$export$abc871145e3e685(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var DefaultBannerComponent = $3e3be695d45b2806$var$createDefaultBannerComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Hits(userProps) {
        var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, banner = userProps.banner, BannerComponent = userProps.bannerComponent, props = (0, (/*@__PURE__*/$parcel$interopDefault($fbc7209d88dc680e$exports)))(userProps, $3e3be695d45b2806$var$_excluded);
        return createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cedb4c362cb59905$exports)))({}, props, {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits', classNames.root, hits.length === 0 && (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits--empty', classNames.emptyRoot), props.className)
        }), banner && (BannerComponent ? createElement(BannerComponent, {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-banner', classNames.bannerRoot),
            banner: banner
        }) : createElement(DefaultBannerComponent, {
            classNames: classNames,
            banner: banner
        })), hits.length === 0 && EmptyComponent ? createElement(EmptyComponent, null) : createElement("ol", {
            className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-list', classNames.list)
        }, hits.map(function(hit, index) {
            return createElement(ItemComponent, {
                key: hit.objectID,
                hit: hit,
                index: index,
                className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-Hits-item', classNames.item),
                onClick: function onClick() {
                    sendEvent('click:internal', hit, 'Hit Clicked');
                },
                onAuxClick: function onAuxClick() {
                    sendEvent('click:internal', hit, 'Hit Clicked');
                }
            });
        })));
    };
}



var $ggE0n = parcelRequire("ggE0n");
function $623b10cbbd9fca41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $623b10cbbd9fca41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $623b10cbbd9fca41$var$_typeof(o);
}
function $623b10cbbd9fca41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $623b10cbbd9fca41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $623b10cbbd9fca41$var$ownKeys(Object(t), !0).forEach(function(r) {
            $623b10cbbd9fca41$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $623b10cbbd9fca41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $623b10cbbd9fca41$var$_defineProperty(obj, key, value) {
    key = $623b10cbbd9fca41$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $623b10cbbd9fca41$var$_toPropertyKey(t) {
    var i = $623b10cbbd9fca41$var$_toPrimitive(t, "string");
    return "symbol" == $623b10cbbd9fca41$var$_typeof(i) ? i : String(i);
}
function $623b10cbbd9fca41$var$_toPrimitive(t, r) {
    if ("object" != $623b10cbbd9fca41$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $623b10cbbd9fca41$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $623b10cbbd9fca41$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $623b10cbbd9fca41$var$_objectSpread($623b10cbbd9fca41$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $53615b747f9de6c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $53615b747f9de6c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $53615b747f9de6c0$var$_typeof(o);
}
function $53615b747f9de6c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53615b747f9de6c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53615b747f9de6c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $53615b747f9de6c0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53615b747f9de6c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $53615b747f9de6c0$var$_defineProperty(obj, key, value) {
    key = $53615b747f9de6c0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $53615b747f9de6c0$var$_toPropertyKey(t) {
    var i = $53615b747f9de6c0$var$_toPrimitive(t, "string");
    return "symbol" == $53615b747f9de6c0$var$_typeof(i) ? i : String(i);
}
function $53615b747f9de6c0$var$_toPrimitive(t, r) {
    if ("object" != $53615b747f9de6c0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $53615b747f9de6c0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $53615b747f9de6c0$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $53615b747f9de6c0$var$_objectSpread($53615b747f9de6c0$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}

function $b3b5db2136378fe8$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}


function $73ae0484fe128d08$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== 'function') throw new Error("The render function is not valid (received type ".concat((0, $b3b5db2136378fe8$export$11cc42aebef2ef3a)(rendering), ").\n\n").concat(usage));
}

function $485f4c76ce9799b0$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $485f4c76ce9799b0$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}


function $b1887a5c6aea2bb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1887a5c6aea2bb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1887a5c6aea2bb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b1887a5c6aea2bb8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1887a5c6aea2bb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b1887a5c6aea2bb8$var$_defineProperty(obj, key, value) {
    key = $b1887a5c6aea2bb8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b1887a5c6aea2bb8$var$_toPropertyKey(t) {
    var i = $b1887a5c6aea2bb8$var$_toPrimitive(t, "string");
    return "symbol" == $b1887a5c6aea2bb8$var$_typeof(i) ? i : String(i);
}
function $b1887a5c6aea2bb8$var$_toPrimitive(t, r) {
    if ("object" != $b1887a5c6aea2bb8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b1887a5c6aea2bb8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b1887a5c6aea2bb8$var$_slicedToArray(arr, i) {
    return $b1887a5c6aea2bb8$var$_arrayWithHoles(arr) || $b1887a5c6aea2bb8$var$_iterableToArrayLimit(arr, i) || $b1887a5c6aea2bb8$var$_unsupportedIterableToArray(arr, i) || $b1887a5c6aea2bb8$var$_nonIterableRest();
}
function $b1887a5c6aea2bb8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b1887a5c6aea2bb8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b1887a5c6aea2bb8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b1887a5c6aea2bb8$var$_arrayLikeToArray(o, minLen);
}
function $b1887a5c6aea2bb8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b1887a5c6aea2bb8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b1887a5c6aea2bb8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b1887a5c6aea2bb8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b1887a5c6aea2bb8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b1887a5c6aea2bb8$var$_typeof(o);
}
function $b1887a5c6aea2bb8$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $b1887a5c6aea2bb8$export$2f82a8f6391c6db9(_ref) {
    var helper = _ref.helper, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $b1887a5c6aea2bb8$var$_typeof(args[0]) === 'object') return [
        args[0]
    ];
    var _args$0$split = args[0].split(':'), _args$0$split2 = $b1887a5c6aea2bb8$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === 'click' || eventType === 'conversion') && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $b1887a5c6aea2bb8$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === 'view') {
        if (instantSearchInstance.status !== 'idle') return [];
        return hitsChunks.map(function(batch, i) {
            var _helper$lastResults;
            return {
                insightsMethod: 'viewedObjectIDs',
                widgetType: widgetType,
                eventType: eventType,
                payload: $b1887a5c6aea2bb8$var$_objectSpread({
                    eventName: eventName || 'Hits Viewed',
                    index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === 'click') return hitsChunks.map(function(batch, i) {
        var _helper$lastResults2;
        return {
            insightsMethod: 'clickedObjectIDsAfterSearch',
            widgetType: widgetType,
            eventType: eventType,
            payload: $b1887a5c6aea2bb8$var$_objectSpread({
                eventName: eventName || 'Hit Clicked',
                index: ((_helper$lastResults2 = helper.lastResults) === null || _helper$lastResults2 === void 0 ? void 0 : _helper$lastResults2.index) || helper.state.index,
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === 'conversion') return hitsChunks.map(function(batch, i) {
        var _helper$lastResults3;
        return {
            insightsMethod: 'convertedObjectIDsAfterSearch',
            widgetType: widgetType,
            eventType: eventType,
            payload: $b1887a5c6aea2bb8$var$_objectSpread({
                eventName: eventName || 'Hit Converted',
                index: ((_helper$lastResults3 = helper.lastResults) === null || _helper$lastResults3 === void 0 ? void 0 : _helper$lastResults3.index) || helper.state.index,
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $b1887a5c6aea2bb8$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, helper = _ref2.helper, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $b1887a5c6aea2bb8$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            helper: helper,
            methodName: 'sendEvent',
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === 'click' && payload.eventModifier === 'internal' && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $b1887a5c6aea2bb8$export$5a3d9973824d9b76(_ref3) {
    var helper = _ref3.helper, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $b1887a5c6aea2bb8$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            helper: helper,
            methodName: 'bindEvent',
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $485f4c76ce9799b0$export$44b4521aa38272f2)(payloads)) : '';
    };
    return bindEventForHits;
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $22d2651e56707261$var$htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
// Used to match HTML entities and HTML characters.
var $22d2651e56707261$var$regexUnescapedHtml = /[&<>"']/g;
var $22d2651e56707261$var$regexHasUnescapedHtml = RegExp($22d2651e56707261$var$regexUnescapedHtml.source);
function $22d2651e56707261$export$4e7f196112fea3c5(value) {
    return value && $22d2651e56707261$var$regexHasUnescapedHtml.test(value) ? value.replace($22d2651e56707261$var$regexUnescapedHtml, function(character) {
        return $22d2651e56707261$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $22d2651e56707261$var$htmlCharacters = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
// Used to match HTML entities and HTML characters.
var $22d2651e56707261$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $22d2651e56707261$var$regexHasEscapedHtml = RegExp($22d2651e56707261$var$regexEscapedHtml.source);
function $22d2651e56707261$export$e8bacd2802a88316(value) {
    return value && $22d2651e56707261$var$regexHasEscapedHtml.test(value) ? value.replace($22d2651e56707261$var$regexEscapedHtml, function(character) {
        return $22d2651e56707261$var$htmlCharacters[character];
    }) : value;
}



function $83855ad73d0a9c34$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $83855ad73d0a9c34$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $83855ad73d0a9c34$var$_typeof(o);
}
function $83855ad73d0a9c34$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $83855ad73d0a9c34$var$_extends() {
    $83855ad73d0a9c34$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $83855ad73d0a9c34$var$_extends.apply(this, arguments);
}
function $83855ad73d0a9c34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $83855ad73d0a9c34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $83855ad73d0a9c34$var$ownKeys(Object(t), !0).forEach(function(r) {
            $83855ad73d0a9c34$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $83855ad73d0a9c34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $83855ad73d0a9c34$var$_defineProperty(obj, key, value) {
    key = $83855ad73d0a9c34$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $83855ad73d0a9c34$var$_toPropertyKey(t) {
    var i = $83855ad73d0a9c34$var$_toPrimitive(t, "string");
    return "symbol" == $83855ad73d0a9c34$var$_typeof(i) ? i : String(i);
}
function $83855ad73d0a9c34$var$_toPrimitive(t, r) {
    if ("object" != $83855ad73d0a9c34$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $83855ad73d0a9c34$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $83855ad73d0a9c34$export$1e7338a8952eaf35 = {
    highlightPreTag: '__ais-highlight__',
    highlightPostTag: '__/ais-highlight__'
};
var $83855ad73d0a9c34$export$62e796b7905e8e6b = {
    highlightPreTag: '<mark>',
    highlightPostTag: '</mark>'
};
// @MAJOR: in the future, this should only escape, not replace
function $83855ad73d0a9c34$var$replaceTagsAndEscape(value) {
    return (0, $22d2651e56707261$export$4e7f196112fea3c5)(value).replace(new RegExp($83855ad73d0a9c34$export$1e7338a8952eaf35.highlightPreTag, 'g'), $83855ad73d0a9c34$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($83855ad73d0a9c34$export$1e7338a8952eaf35.highlightPostTag, 'g'), $83855ad73d0a9c34$export$62e796b7905e8e6b.highlightPostTag);
}
function $83855ad73d0a9c34$var$recursiveEscape(input) {
    if ((0, $ca7c76376182a382$export$53b83ca8eaab0383)(input) && typeof input.value !== 'string') return Object.keys(input).reduce(function(acc, key) {
        return $83855ad73d0a9c34$var$_objectSpread($83855ad73d0a9c34$var$_objectSpread({}, acc), {}, $83855ad73d0a9c34$var$_defineProperty({}, key, $83855ad73d0a9c34$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($83855ad73d0a9c34$var$recursiveEscape);
    return $83855ad73d0a9c34$var$_objectSpread($83855ad73d0a9c34$var$_objectSpread({}, input), {}, {
        value: $83855ad73d0a9c34$var$replaceTagsAndEscape(input.value)
    });
}
function $83855ad73d0a9c34$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $83855ad73d0a9c34$var$_extends({}, ($83855ad73d0a9c34$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $83855ad73d0a9c34$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $83855ad73d0a9c34$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $83855ad73d0a9c34$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $83855ad73d0a9c34$var$_objectSpread($83855ad73d0a9c34$var$_objectSpread({}, h), {}, {
            highlighted: $83855ad73d0a9c34$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


function $7069794f1717ba4e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7069794f1717ba4e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7069794f1717ba4e$var$_typeof(o);
}
function $7069794f1717ba4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7069794f1717ba4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7069794f1717ba4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7069794f1717ba4e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7069794f1717ba4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7069794f1717ba4e$var$_defineProperty(obj, key, value) {
    key = $7069794f1717ba4e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7069794f1717ba4e$var$_toPropertyKey(t) {
    var i = $7069794f1717ba4e$var$_toPrimitive(t, "string");
    return "symbol" == $7069794f1717ba4e$var$_typeof(i) ? i : String(i);
}
function $7069794f1717ba4e$var$_toPrimitive(t, r) {
    if ("object" != $7069794f1717ba4e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7069794f1717ba4e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7069794f1717ba4e$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'hits',
    connector: true
});
var $7069794f1717ba4e$export$2e2bcd8739ae039 = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $7069794f1717ba4e$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: 'ais.hits',
            init: function init(initOptions) {
                renderFn($7069794f1717ba4e$var$_objectSpread($7069794f1717ba4e$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($7069794f1717ba4e$var$_objectSpread($7069794f1717ba4e$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent('view:internal', renderState.items);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $7069794f1717ba4e$var$_objectSpread($7069794f1717ba4e$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $b1887a5c6aea2bb8$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $b1887a5c6aea2bb8$export$5a3d9973824d9b76)({
                    helper: helper,
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    items: [],
                    results: undefined,
                    banner: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $83855ad73d0a9c34$export$9adb036445aab889)(results.hits);
                var hitsWithAbsolutePosition = (0, $623b10cbbd9fca41$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $53615b747f9de6c0$export$b8f834386ea30952)(hitsWithAbsolutePosition, results.queryID);
                var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                return {
                    hits: items,
                    items: items,
                    results: results,
                    banner: banner,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $83855ad73d0a9c34$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $7069794f1717ba4e$var$_objectSpread($7069794f1717ba4e$var$_objectSpread({}, acc), {}, $7069794f1717ba4e$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $83855ad73d0a9c34$export$1e7338a8952eaf35));
            }
        };
    };
};



function $609603fe60e4a7ff$export$1dc18a9d9332e2a7(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $7069794f1717ba4e$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


var $51e227cba8706de3$var$_excluded = [
    "escapeHTML",
    "transformItems",
    "hitComponent",
    "bannerComponent"
], $51e227cba8706de3$var$_excluded2 = [
    "hit",
    "index"
];
function $51e227cba8706de3$var$_extends() {
    $51e227cba8706de3$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51e227cba8706de3$var$_extends.apply(this, arguments);
}
function $51e227cba8706de3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $51e227cba8706de3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $51e227cba8706de3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// @MAJOR: Move default hit component back to the UI library
// once flavour specificities are erased
function $51e227cba8706de3$var$DefaultHitComponent(_ref) {
    var hit = _ref.hit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", {
        style: {
            wordBreak: 'break-all'
        }
    }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
var $51e227cba8706de3$var$HitsUiComponent = (0, $3e3be695d45b2806$export$abc871145e3e685)({
    createElement: (0, $ggE0n.createElement),
    Fragment: (0, $ggE0n.Fragment)
});
function $51e227cba8706de3$export$9abb8533010f1d93(_ref2) {
    var escapeHTML = _ref2.escapeHTML, transformItems = _ref2.transformItems, _ref2$hitComponent = _ref2.hitComponent, HitComponent = _ref2$hitComponent === void 0 ? $51e227cba8706de3$var$DefaultHitComponent : _ref2$hitComponent, BannerComponent = _ref2.bannerComponent, props = $51e227cba8706de3$var$_objectWithoutProperties(_ref2, $51e227cba8706de3$var$_excluded);
    var _useHits = (0, $609603fe60e4a7ff$export$1dc18a9d9332e2a7)({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    }, {
        $$widgetType: 'ais.hits'
    }), hits = _useHits.hits, banner = _useHits.banner, sendEvent = _useHits.sendEvent;
    var itemComponent = (0, $ggE0n.useMemo)(function() {
        return function(_ref3) {
            var hit = _ref3.hit, index = _ref3.index, itemProps = $51e227cba8706de3$var$_objectWithoutProperties(_ref3, $51e227cba8706de3$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("li", $51e227cba8706de3$var$_extends({
                key: hit.objectID
            }, itemProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(HitComponent, {
                hit: hit,
                sendEvent: sendEvent
            }));
        };
    }, [
        HitComponent,
        sendEvent
    ]);
    var bannerComponent = BannerComponent === false ? function bannerComponent() {
        return null;
    } : BannerComponent;
    var uiProps = {
        hits: hits,
        sendEvent: sendEvent,
        itemComponent: itemComponent,
        banner: banner,
        bannerComponent: bannerComponent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($51e227cba8706de3$var$HitsUiComponent, $51e227cba8706de3$var$_extends({}, props, uiProps));
}


var $ggE0n = parcelRequire("ggE0n");





function $5cc39feb27af2667$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5cc39feb27af2667$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5cc39feb27af2667$var$_typeof(o);
}
var $5cc39feb27af2667$export$d900da7fa9a86f36 = '_ALGOLIA';
function $5cc39feb27af2667$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $5cc39feb27af2667$var$_typeof(document)) !== 'object' || typeof document.cookie !== 'string') return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(';');
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $5cc39feb27af2667$export$61f1c6e9cd2ed687() {
    return $5cc39feb27af2667$var$getCookie($5cc39feb27af2667$export$d900da7fa9a86f36);
}
function $5cc39feb27af2667$export$2e2bcd8739ae039() {
    return $5cc39feb27af2667$export$61f1c6e9cd2ed687();
}


// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $b59046fa9f922e9f$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}

// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $d5310fb412dd8d48$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.appId && searchClient.apiKey) // searchClient v5
    return [
        searchClient.appId,
        searchClient.apiKey
    ];
    else if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = 'x-algolia-application-id';
        var API_KEY = 'x-algolia-api-key';
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $1c357bac8b9248d2$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined') return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}


/**
 * Create UUID according to
 * https://www.ietf.org/rfc/rfc4122.txt.
 *
 * @returns Generated UUID.
 */ function $7c5361c0c87badae$export$5dbf9a24b655dde4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        /* eslint-disable no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        /* eslint-enable */ return v.toString(16);
    });
}


function $fd610d368d455f7e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fd610d368d455f7e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fd610d368d455f7e$var$_typeof(o);
}
function $fd610d368d455f7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd610d368d455f7e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd610d368d455f7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fd610d368d455f7e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd610d368d455f7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fd610d368d455f7e$var$_defineProperty(obj, key, value) {
    key = $fd610d368d455f7e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fd610d368d455f7e$var$_toPropertyKey(t) {
    var i = $fd610d368d455f7e$var$_toPrimitive(t, "string");
    return "symbol" == $fd610d368d455f7e$var$_typeof(i) ? i : String(i);
}
function $fd610d368d455f7e$var$_toPrimitive(t, r) {
    if ("object" != $fd610d368d455f7e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fd610d368d455f7e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fd610d368d455f7e$var$_slicedToArray(arr, i) {
    return $fd610d368d455f7e$var$_arrayWithHoles(arr) || $fd610d368d455f7e$var$_iterableToArrayLimit(arr, i) || $fd610d368d455f7e$var$_unsupportedIterableToArray(arr, i) || $fd610d368d455f7e$var$_nonIterableRest();
}
function $fd610d368d455f7e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd610d368d455f7e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $fd610d368d455f7e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fd610d368d455f7e$var$_toConsumableArray(arr) {
    return $fd610d368d455f7e$var$_arrayWithoutHoles(arr) || $fd610d368d455f7e$var$_iterableToArray(arr) || $fd610d368d455f7e$var$_unsupportedIterableToArray(arr) || $fd610d368d455f7e$var$_nonIterableSpread();
}
function $fd610d368d455f7e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd610d368d455f7e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fd610d368d455f7e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fd610d368d455f7e$var$_arrayLikeToArray(o, minLen);
}
function $fd610d368d455f7e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fd610d368d455f7e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fd610d368d455f7e$var$_arrayLikeToArray(arr);
}
function $fd610d368d455f7e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $fd610d368d455f7e$var$ALGOLIA_INSIGHTS_VERSION = '2.17.2';
var $fd610d368d455f7e$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($fd610d368d455f7e$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $fd610d368d455f7e$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || 'aa';
        if (typeof pointer === 'string') potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $fd610d368d455f7e$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === 'ais.insights' && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $fd610d368d455f7e$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $d5310fb412dd8d48$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey2 = $fd610d368d455f7e$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedInitParams = undefined;
        var queuedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                'setUserToken',
                'init'
            ].map(function(key) {
                var _ref3 = (0, $b59046fa9f922e9f$export$71aa6c912b956294)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $fd610d368d455f7e$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $fd610d368d455f7e$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $fd610d368d455f7e$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedInitParams = _map2[1];
        }
        // If user called `aa('setUserToken')` before creating the Insights middleware,
        // we temporarily store the token and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient('getUserToken', null, function(_error, userToken) {
            userTokenBeforeInit = $fd610d368d455f7e$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$fd610d368d455f7e$var$isModernInsightsClient(insightsClient)) insightsClient('init', $fd610d368d455f7e$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: 'ais.insights',
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = '[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init';
                try {
                    var script = document.createElement('script');
                    script.async = true;
                    script.src = $fd610d368d455f7e$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit('error', new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit('error', new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient('addAlgoliaAgent', 'insights-middleware');
                helper = instantSearchInstance.mainHelper;
                var queueAtStart = insightsClient.queue;
                if (Array.isArray(queueAtStart)) {
                    var _map3 = [
                        'setUserToken',
                        'init'
                    ].map(function(key) {
                        var _ref7 = (0, $b59046fa9f922e9f$export$71aa6c912b956294)(queueAtStart.slice().reverse(), function(_ref9) {
                            var _ref10 = $fd610d368d455f7e$var$_slicedToArray(_ref9, 1), method = _ref10[0];
                            return method === key;
                        }) || [], _ref8 = $fd610d368d455f7e$var$_slicedToArray(_ref7, 2), value = _ref8[1];
                        return value;
                    });
                    var _map4 = $fd610d368d455f7e$var$_slicedToArray(_map3, 2);
                    queuedUserToken = _map4[0];
                    queuedInitParams = _map4[1];
                }
                initialParameters = $fd610d368d455f7e$var$getInitialParameters(instantSearchInstance);
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($fd610d368d455f7e$var$_objectSpread($fd610d368d455f7e$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $fd610d368d455f7e$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($fd610d368d455f7e$var$_objectSpread($fd610d368d455f7e$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                function setUserToken(token) {
                    setUserTokenToSearch(token, true);
                    insightsClient('setUserToken', token);
                }
                var anonymousUserToken = undefined;
                var anonymousTokenFromInsights = (0, $5cc39feb27af2667$export$61f1c6e9cd2ed687)();
                if (anonymousTokenFromInsights) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken on instantsearch and insights. If it's not set as an insights
                // userToken before a sendEvent, insights automatically generates a new anonymous token,
                // causing a state change and an unnecessary query on instantsearch.
                anonymousUserToken = anonymousTokenFromInsights;
                else {
                    var token = "anonymous-".concat((0, $7c5361c0c87badae$export$5dbf9a24b655dde4)());
                    anonymousUserToken = token;
                }
                var userTokenFromInit;
                // With SSR, the token could be be set on the state. We make sure
                // that insights is in sync with that token since, there is no
                // insights lib on the server.
                var tokenFromSearchParameters = initialParameters.userToken;
                // When the first query is sent, the token is possibly not yet set by
                // the insights onChange callbacks (if insights isn't yet loaded).
                // It is explicitly being set here so that the first query has the
                // initial tokens set and ensure a second query isn't automatically
                // made when the onChange callback actually changes the state.
                if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.userToken) userTokenFromInit = insightsInitParams.userToken;
                if (userTokenFromInit) setUserToken(userTokenFromInit);
                else if (tokenFromSearchParameters) setUserToken(tokenFromSearchParameters);
                else if (userTokenBeforeInit) setUserToken(userTokenBeforeInit);
                else if (queuedUserToken) setUserToken(queuedUserToken);
                else if (anonymousUserToken) {
                    var _queuedInitParams;
                    setUserToken(anonymousUserToken);
                    if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.useCookie || (_queuedInitParams = queuedInitParams) !== null && _queuedInitParams !== void 0 && _queuedInitParams.useCookie) {
                        var _queuedInitParams2;
                        $fd610d368d455f7e$var$saveTokenAsCookie(anonymousUserToken, (insightsInitParams === null || insightsInitParams === void 0 ? void 0 : insightsInitParams.cookieDuration) || ((_queuedInitParams2 = queuedInitParams) === null || _queuedInitParams2 === void 0 ? void 0 : _queuedInitParams2.cookieDuration));
                    }
                }
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient('onUserTokenChange', function(token) {
                    return setUserTokenToSearch(token, true);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($fd610d368d455f7e$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var _getAppIdAndApiKey3 = (0, $d5310fb412dd8d48$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey4 = $fd610d368d455f7e$var$_slicedToArray(_getAppIdAndApiKey3, 2), latestAppId = _getAppIdAndApiKey4[0], latestApiKey = _getAppIdAndApiKey4[1];
                    var extraParams = {
                        headers: {
                            'X-Algolia-Application-Id': latestAppId,
                            'X-Algolia-API-Key': latestApiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                var viewedObjectIDs = new Set();
                var lastQueryId;
                instantSearchInstance.mainHelper.derivedHelpers[0].on('result', function(_ref11) {
                    var results = _ref11.results;
                    if (results && (!results.queryID || results.queryID !== lastQueryId)) {
                        lastQueryId = results.queryID;
                        viewedObjectIDs.clear();
                    }
                });
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        if (event.insightsMethod === 'viewedObjectIDs') {
                            var _payload = event.payload;
                            var difference = _payload.objectIDs.filter(function(objectID) {
                                return !viewedObjectIDs.has(objectID);
                            });
                            if (difference.length === 0) return;
                            difference.forEach(function(objectID) {
                                return viewedObjectIDs.add(objectID);
                            });
                            _payload.objectIDs = difference;
                        }
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            'instantsearch'
                        ];
                        if ($$automatic) event.payload.algoliaSource.push('instantsearch-automatic');
                        if (event.eventModifier === 'internal') event.payload.algoliaSource.push('instantsearch-internal');
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient('onUserTokenChange', undefined);
                instantSearchInstance.sendEventToInsights = (0, $1c8cc0c1c6330343$export$8793edee2d425525);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($fd610d368d455f7e$var$_objectSpread($fd610d368d455f7e$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
function $fd610d368d455f7e$var$getInitialParameters(instantSearchInstance) {
    var _instantSearchInstanc, _instantSearchInstanc2;
    // in SSR, the initial state we use in this domain is set on the main index
    var stateFromInitialResults = ((_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : (_instantSearchInstanc2 = _instantSearchInstanc[instantSearchInstance.indexName]) === null || _instantSearchInstanc2 === void 0 ? void 0 : _instantSearchInstanc2.state) || {};
    var stateFromHelper = instantSearchInstance.mainHelper.state;
    return {
        userToken: stateFromInitialResults.userToken || stateFromHelper.userToken,
        clickAnalytics: stateFromInitialResults.clickAnalytics || stateFromHelper.clickAnalytics
    };
}
function $fd610d368d455f7e$var$saveTokenAsCookie(token, cookieDuration) {
    var MONTH = 2592000000;
    var d = new Date();
    d.setTime(d.getTime() + (cookieDuration || MONTH * 6));
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "_ALGOLIA=".concat(token, ";").concat(expires, ";path=/");
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $fd610d368d455f7e$var$isModernInsightsClient(client) {
    var _split$map = (client.version || '').split('.').map(Number), _split$map2 = $fd610d368d455f7e$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $fd610d368d455f7e$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === 'number' ? userToken.toString() : userToken;
}


function $88af57b1ec675f81$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === 'stalled'
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $88af57b1ec675f81$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && '_state' in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === 'stalled'
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}


function $939b544e79195a3a$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $88af57b1ec675f81$export$dbf1227de6c1fbc6)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === 'ais.index') $939b544e79195a3a$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $939b544e79195a3a$export$4b4254890acf93e7() {
    return (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf('Algolia Crawler')) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $939b544e79195a3a$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement('meta');
        var refNode = document.querySelector('head');
        payloadContainer.name = 'instantsearch:widgets';
        return {
            $$type: 'ais.metadata',
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $939b544e79195a3a$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


var $cc94aaa37c6879ba$exports = {};
'use strict';
var $fb676d8319020e02$exports = {};

var $4TMho = parcelRequire("4TMho");
'use strict';
var $fb0083729c85d7a1$exports = {};

var $4TMho = parcelRequire("4TMho");
'use strict';
var $d84de8b2ea55ae1e$exports = {};
'use strict';
var $d84de8b2ea55ae1e$var$replace = String.prototype.replace;
var $d84de8b2ea55ae1e$var$percentTwenties = /%20/g;
var $d84de8b2ea55ae1e$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$d84de8b2ea55ae1e$exports = {
    'default': $d84de8b2ea55ae1e$var$Format.RFC3986,
    formatters: {
        RFC1738: function RFC1738(value) {
            return $d84de8b2ea55ae1e$var$replace.call(value, $d84de8b2ea55ae1e$var$percentTwenties, '+');
        },
        RFC3986: function RFC3986(value) {
            return String(value);
        }
    },
    RFC1738: $d84de8b2ea55ae1e$var$Format.RFC1738,
    RFC3986: $d84de8b2ea55ae1e$var$Format.RFC3986
};


var $fb0083729c85d7a1$var$has = Object.prototype.hasOwnProperty;
var $fb0083729c85d7a1$var$isArray = Array.isArray;
var $fb0083729c85d7a1$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $fb0083729c85d7a1$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($fb0083729c85d7a1$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $fb0083729c85d7a1$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $fb0083729c85d7a1$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if ((typeof source === "undefined" ? "undefined" : (0, $4TMho._)(source)) !== 'object') {
        if ($fb0083729c85d7a1$var$isArray(target)) target.push(source);
        else if (target && (typeof target === "undefined" ? "undefined" : (0, $4TMho._)(target)) === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$fb0083729c85d7a1$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || (typeof target === "undefined" ? "undefined" : (0, $4TMho._)(target)) !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($fb0083729c85d7a1$var$isArray(target) && !$fb0083729c85d7a1$var$isArray(source)) mergeTarget = $fb0083729c85d7a1$var$arrayToObject(target, options);
    if ($fb0083729c85d7a1$var$isArray(target) && $fb0083729c85d7a1$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($fb0083729c85d7a1$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && (typeof targetItem === "undefined" ? "undefined" : (0, $4TMho._)(targetItem)) === 'object' && item && (typeof item === "undefined" ? "undefined" : (0, $4TMho._)(item)) === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($fb0083729c85d7a1$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $fb0083729c85d7a1$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $fb0083729c85d7a1$var$decode = function decode(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $fb0083729c85d7a1$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if ((typeof str === "undefined" ? "undefined" : (0, $4TMho._)(str)) === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $d84de8b2ea55ae1e$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $fb0083729c85d7a1$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($fb0083729c85d7a1$var$hexTable[0xC0 | c >> 6] + $fb0083729c85d7a1$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($fb0083729c85d7a1$var$hexTable[0xE0 | c >> 12] + $fb0083729c85d7a1$var$hexTable[0x80 | c >> 6 & 0x3F] + $fb0083729c85d7a1$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $fb0083729c85d7a1$var$hexTable[0xF0 | c >> 18] + $fb0083729c85d7a1$var$hexTable[0x80 | c >> 12 & 0x3F] + $fb0083729c85d7a1$var$hexTable[0x80 | c >> 6 & 0x3F] + $fb0083729c85d7a1$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $fb0083729c85d7a1$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if ((typeof val === "undefined" ? "undefined" : (0, $4TMho._)(val)) === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $fb0083729c85d7a1$var$compactQueue(queue);
    return value;
};
var $fb0083729c85d7a1$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $fb0083729c85d7a1$var$isBuffer = function isBuffer(obj) {
    if (!obj || (typeof obj === "undefined" ? "undefined" : (0, $4TMho._)(obj)) !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $fb0083729c85d7a1$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $fb0083729c85d7a1$var$maybeMap = function maybeMap(val, fn) {
    if ($fb0083729c85d7a1$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$fb0083729c85d7a1$exports = {
    arrayToObject: $fb0083729c85d7a1$var$arrayToObject,
    assign: $fb0083729c85d7a1$var$assign,
    combine: $fb0083729c85d7a1$var$combine,
    compact: $fb0083729c85d7a1$var$compact,
    decode: $fb0083729c85d7a1$var$decode,
    encode: $fb0083729c85d7a1$var$encode,
    isBuffer: $fb0083729c85d7a1$var$isBuffer,
    isRegExp: $fb0083729c85d7a1$var$isRegExp,
    maybeMap: $fb0083729c85d7a1$var$maybeMap,
    merge: $fb0083729c85d7a1$var$merge
};



var $fb676d8319020e02$var$has = Object.prototype.hasOwnProperty;
var $fb676d8319020e02$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $fb676d8319020e02$var$isArray = Array.isArray;
var $fb676d8319020e02$var$split = String.prototype.split;
var $fb676d8319020e02$var$push = Array.prototype.push;
var $fb676d8319020e02$var$pushToArray = function pushToArray(arr, valueOrArray) {
    $fb676d8319020e02$var$push.apply(arr, $fb676d8319020e02$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $fb676d8319020e02$var$toISO = Date.prototype.toISOString;
var $fb676d8319020e02$var$defaultFormat = $d84de8b2ea55ae1e$exports.default;
var $fb676d8319020e02$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: $fb0083729c85d7a1$exports.encode,
    encodeValuesOnly: false,
    format: $fb676d8319020e02$var$defaultFormat,
    formatter: $d84de8b2ea55ae1e$exports.formatters[$fb676d8319020e02$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $fb676d8319020e02$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $fb676d8319020e02$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || (typeof v === "undefined" ? "undefined" : (0, $4TMho._)(v)) === 'symbol' || (typeof v === "undefined" ? "undefined" : (0, $4TMho._)(v)) === 'bigint';
};
var $fb676d8319020e02$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $fb676d8319020e02$var$isArray(obj)) obj = $fb0083729c85d7a1$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $fb676d8319020e02$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($fb676d8319020e02$var$isNonNullishPrimitive(obj) || $fb0083729c85d7a1$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $fb676d8319020e02$var$defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = $fb676d8319020e02$var$split.call(String(obj), ',');
                var valuesJoined = '';
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], $fb676d8319020e02$var$defaults.encoder, charset, 'value', format));
                return [
                    formatter(keyValue) + '=' + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $fb676d8319020e02$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $fb676d8319020e02$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(',') || null : void 0
        }
    ];
    else if ($fb676d8319020e02$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = (typeof key === "undefined" ? "undefined" : (0, $4TMho._)(key)) === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $fb676d8319020e02$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? '.' + key : '[' + key + ']');
        $fb676d8319020e02$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $fb676d8319020e02$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $fb676d8319020e02$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $fb676d8319020e02$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $d84de8b2ea55ae1e$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$fb676d8319020e02$var$has.call($d84de8b2ea55ae1e$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $d84de8b2ea55ae1e$exports.formatters[format];
    var filter = $fb676d8319020e02$var$defaults.filter;
    if (typeof opts.filter === 'function' || $fb676d8319020e02$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $fb676d8319020e02$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? $fb676d8319020e02$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $fb676d8319020e02$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? $fb676d8319020e02$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $fb676d8319020e02$var$defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $fb676d8319020e02$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $fb676d8319020e02$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $fb676d8319020e02$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $fb676d8319020e02$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $fb676d8319020e02$var$defaults.strictNullHandling
    };
};
$fb676d8319020e02$exports = function(object, opts) {
    var obj = object;
    var options = $fb676d8319020e02$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($fb676d8319020e02$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if ((typeof obj === "undefined" ? "undefined" : (0, $4TMho._)(obj)) !== 'object' || obj === null) return '';
    var arrayFormat;
    if (opts && opts.arrayFormat in $fb676d8319020e02$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $fb676d8319020e02$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $fb676d8319020e02$var$pushToArray(keys, $fb676d8319020e02$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $0fae22409999fbcb$exports = {};
'use strict';

var $0fae22409999fbcb$var$has = Object.prototype.hasOwnProperty;
var $0fae22409999fbcb$var$isArray = Array.isArray;
var $0fae22409999fbcb$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: $fb0083729c85d7a1$exports.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $0fae22409999fbcb$var$interpretNumericEntities = function interpretNumericEntities(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $0fae22409999fbcb$var$parseArrayValue = function parseArrayValue(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $0fae22409999fbcb$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $0fae22409999fbcb$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $0fae22409999fbcb$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $0fae22409999fbcb$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $0fae22409999fbcb$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $0fae22409999fbcb$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $0fae22409999fbcb$var$defaults.decoder, charset, 'key');
            val = $fb0083729c85d7a1$exports.maybeMap($0fae22409999fbcb$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $0fae22409999fbcb$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $0fae22409999fbcb$var$interpretNumericEntities(val);
        if (part.indexOf('[]=') > -1) val = $0fae22409999fbcb$var$isArray(val) ? [
            val
        ] : val;
        if ($0fae22409999fbcb$var$has.call(obj, key)) obj[key] = $fb0083729c85d7a1$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $0fae22409999fbcb$var$parseObject = function parseObject(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $0fae22409999fbcb$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $0fae22409999fbcb$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $0fae22409999fbcb$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $0fae22409999fbcb$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $0fae22409999fbcb$var$parseObject(keys, val, options, valuesParsed);
};
var $0fae22409999fbcb$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $0fae22409999fbcb$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var charset = typeof opts.charset === 'undefined' ? $0fae22409999fbcb$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === 'undefined' ? $0fae22409999fbcb$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $0fae22409999fbcb$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $0fae22409999fbcb$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $0fae22409999fbcb$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $0fae22409999fbcb$var$defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $0fae22409999fbcb$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $fb0083729c85d7a1$exports.isRegExp(opts.delimiter) ? opts.delimiter : $0fae22409999fbcb$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $0fae22409999fbcb$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $0fae22409999fbcb$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $0fae22409999fbcb$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $0fae22409999fbcb$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $0fae22409999fbcb$var$defaults.strictNullHandling
    };
};
$0fae22409999fbcb$exports = function(str, opts) {
    var options = $0fae22409999fbcb$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $0fae22409999fbcb$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $0fae22409999fbcb$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $fb0083729c85d7a1$exports.merge(obj, newObj, options);
    }
    return $fb0083729c85d7a1$exports.compact(obj);
};



$cc94aaa37c6879ba$exports = {
    formats: $d84de8b2ea55ae1e$exports,
    parse: $0fae22409999fbcb$exports,
    stringify: $fb676d8319020e02$exports
};



function $2d9ca598e78ca7ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2d9ca598e78ca7ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2d9ca598e78ca7ea$var$_typeof(o);
}
function $2d9ca598e78ca7ea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2d9ca598e78ca7ea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2d9ca598e78ca7ea$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2d9ca598e78ca7ea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2d9ca598e78ca7ea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2d9ca598e78ca7ea$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2d9ca598e78ca7ea$var$_defineProperty(obj, key, value) {
    key = $2d9ca598e78ca7ea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2d9ca598e78ca7ea$var$_toPropertyKey(t) {
    var i = $2d9ca598e78ca7ea$var$_toPrimitive(t, "string");
    return "symbol" == $2d9ca598e78ca7ea$var$_typeof(i) ? i : String(i);
}
function $2d9ca598e78ca7ea$var$_toPrimitive(t, r) {
    if ("object" != $2d9ca598e78ca7ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2d9ca598e78ca7ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2d9ca598e78ca7ea$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $2d9ca598e78ca7ea$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $2d9ca598e78ca7ea$var$_classCallCheck(this, BrowserHistory);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "$$type", 'ais.browser');
        /**
     * Transforms a UI state into a title for the page.
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "getLocation", void 0);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "writeTimer", void 0);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $2d9ca598e78ca7ea$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "_start", void 0);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "_dispose", void 0);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "_push", void 0);
        $2d9ca598e78ca7ea$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === 'undefined' ? true : cleanUrlOnDispose;
        (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $2d9ca598e78ca7ea$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $2d9ca598e78ca7ea$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($cc94aaa37c6879ba$exports))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $2d9ca598e78ca7ea$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || '', url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener('popstate', _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($cc94aaa37c6879ba$exports))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener('popstate', _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $2d9ca598e78ca7ea$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function createURL(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? '' : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === '' ? '' : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function parseURL(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function getLocation() {
        return (0, $1c357bac8b9248d2$export$39f19eed34acd2f1)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error('You need to provide `getLocation` to the `history` router in environments where `window` does not exist.');
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $2d9ca598e78ca7ea$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}


function $f03fd403aa96e189$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f03fd403aa96e189$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f03fd403aa96e189$var$_typeof(o);
}
var $f03fd403aa96e189$var$_excluded = [
    "configure"
];
function $f03fd403aa96e189$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f03fd403aa96e189$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f03fd403aa96e189$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f03fd403aa96e189$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f03fd403aa96e189$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f03fd403aa96e189$var$_defineProperty(obj, key, value) {
    key = $f03fd403aa96e189$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f03fd403aa96e189$var$_toPropertyKey(t) {
    var i = $f03fd403aa96e189$var$_toPrimitive(t, "string");
    return "symbol" == $f03fd403aa96e189$var$_typeof(i) ? i : String(i);
}
function $f03fd403aa96e189$var$_toPrimitive(t, r) {
    if ("object" != $f03fd403aa96e189$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f03fd403aa96e189$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f03fd403aa96e189$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f03fd403aa96e189$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f03fd403aa96e189$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f03fd403aa96e189$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $f03fd403aa96e189$var$_objectWithoutProperties(uiState, $f03fd403aa96e189$var$_excluded);
    return trackedUiState;
}
function $f03fd403aa96e189$export$2e2bcd8739ae039() {
    return {
        $$type: 'ais.simple',
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $f03fd403aa96e189$var$_objectSpread($f03fd403aa96e189$var$_objectSpread({}, state), {}, $f03fd403aa96e189$var$_defineProperty({}, indexId, $f03fd403aa96e189$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $f03fd403aa96e189$var$_objectSpread($f03fd403aa96e189$var$_objectSpread({}, state), {}, $f03fd403aa96e189$var$_defineProperty({}, indexId, $f03fd403aa96e189$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}


function $6e5acc38b6035d6f$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $6e5acc38b6035d6f$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($6e5acc38b6035d6f$var$isPrimitive(first) || $6e5acc38b6035d6f$var$isPrimitive(second) || typeof first === 'function' || typeof second === 'function') return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$6e5acc38b6035d6f$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}


function $5ce42100fb742e1a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5ce42100fb742e1a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ce42100fb742e1a$var$_typeof(o);
}
function $5ce42100fb742e1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ce42100fb742e1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ce42100fb742e1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5ce42100fb742e1a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ce42100fb742e1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5ce42100fb742e1a$var$_defineProperty(obj, key, value) {
    key = $5ce42100fb742e1a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ce42100fb742e1a$var$_toPropertyKey(t) {
    var i = $5ce42100fb742e1a$var$_toPrimitive(t, "string");
    return "symbol" == $5ce42100fb742e1a$var$_typeof(i) ? i : String(i);
}
function $5ce42100fb742e1a$var$_toPrimitive(t, r) {
    if ("object" != $5ce42100fb742e1a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5ce42100fb742e1a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5ce42100fb742e1a$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $2d9ca598e78ca7ea$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $f03fd403aa96e189$export$2e2bcd8739ae039)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $5ce42100fb742e1a$var$_objectSpread($5ce42100fb742e1a$var$_objectSpread({}, acc), {}, $5ce42100fb742e1a$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || '__unknown__', ", stateMapping:").concat(stateMapping.$$type || '__unknown__', "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $6e5acc38b6035d6f$export$248d38f6296296c5)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $5ce42100fb742e1a$var$_objectSpread($5ce42100fb742e1a$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};



function $60dca3dbb9baf5ef$export$a9c9a0d43506297d(widget) {
    return widget.$$type === 'ais.index';
}

function $186c27026185aabe$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}


var $0ed74cc99fc9317e$var$id = 0;
function $0ed74cc99fc9317e$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== 'recommend') return;
    widget.$$id = $0ed74cc99fc9317e$var$id++;
}
function $0ed74cc99fc9317e$export$13e2e3d76152aecf() {
    $0ed74cc99fc9317e$var$id = 0;
}


function $94fbdaa6f0254731$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $94fbdaa6f0254731$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $94fbdaa6f0254731$var$_typeof(o);
}
var $94fbdaa6f0254731$var$_excluded = [
    "initialSearchParameters"
], $94fbdaa6f0254731$var$_excluded2 = [
    "initialRecommendParameters"
];
function $94fbdaa6f0254731$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94fbdaa6f0254731$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94fbdaa6f0254731$var$ownKeys(Object(t), !0).forEach(function(r) {
            $94fbdaa6f0254731$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94fbdaa6f0254731$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94fbdaa6f0254731$var$_defineProperty(obj, key, value) {
    key = $94fbdaa6f0254731$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $94fbdaa6f0254731$var$_toPropertyKey(t) {
    var i = $94fbdaa6f0254731$var$_toPrimitive(t, "string");
    return "symbol" == $94fbdaa6f0254731$var$_typeof(i) ? i : String(i);
}
function $94fbdaa6f0254731$var$_toPrimitive(t, r) {
    if ("object" != $94fbdaa6f0254731$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $94fbdaa6f0254731$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $94fbdaa6f0254731$var$_toConsumableArray(arr) {
    return $94fbdaa6f0254731$var$_arrayWithoutHoles(arr) || $94fbdaa6f0254731$var$_iterableToArray(arr) || $94fbdaa6f0254731$var$_unsupportedIterableToArray(arr) || $94fbdaa6f0254731$var$_nonIterableSpread();
}
function $94fbdaa6f0254731$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94fbdaa6f0254731$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94fbdaa6f0254731$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94fbdaa6f0254731$var$_arrayLikeToArray(o, minLen);
}
function $94fbdaa6f0254731$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $94fbdaa6f0254731$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $94fbdaa6f0254731$var$_arrayLikeToArray(arr);
}
function $94fbdaa6f0254731$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $94fbdaa6f0254731$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $94fbdaa6f0254731$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $94fbdaa6f0254731$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $94fbdaa6f0254731$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'index-widget'
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $94fbdaa6f0254731$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit('change', {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $94fbdaa6f0254731$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $94fbdaa6f0254731$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $94fbdaa6f0254731$var$_objectWithoutProperties(widgetSearchParametersOptions, $94fbdaa6f0254731$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)(widget)) return state;
        if (widget.dependsOn === 'search' && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $94fbdaa6f0254731$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $94fbdaa6f0254731$var$_objectWithoutProperties(widgetRecommendParametersOptions, $94fbdaa6f0254731$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)(widget) && widget.dependsOn === 'recommend' && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $94fbdaa6f0254731$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $94fbdaa6f0254731$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $94fbdaa6f0254731$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $94fbdaa6f0254731$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($94fbdaa6f0254731$var$_toConsumableArray($94fbdaa6f0254731$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $94fbdaa6f0254731$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($94fbdaa6f0254731$var$withUsage('The `indexName` option is required.'));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: 'ais.index',
        $$widgetType: 'ais.index',
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== 'recommend' || (0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $94fbdaa6f0254731$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === 'function') return localInstantSearchInstance._createURL($94fbdaa6f0254731$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($94fbdaa6f0254731$var$_defineProperty({}, indexId, $94fbdaa6f0254731$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($94fbdaa6f0254731$var$withUsage('The `addWidgets` method expects an array of widgets.'));
            if (widgets.some(function(widget) {
                return typeof widget.init !== 'function' && typeof widget.render !== 'function';
            })) throw new Error($94fbdaa6f0254731$var$withUsage('The widget definition expects a `render` and/or an `init` method.'));
            widgets.forEach(function(widget) {
                if ((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === 'recommend') localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === 'recommend') hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $0ed74cc99fc9317e$export$50b3ac0e47148c0b)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $94fbdaa6f0254731$var$privateHelperSetState(helper, {
                    state: $94fbdaa6f0254731$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $94fbdaa6f0254731$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $88af57b1ec675f81$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $94fbdaa6f0254731$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $88af57b1ec675f81$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($94fbdaa6f0254731$var$withUsage('The `removeWidgets` method expects an array of widgets.'));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== 'function';
            })) throw new Error($94fbdaa6f0254731$var$withUsage('The widget definition expects a `dispose` method.'));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === 'recommend') localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === 'recommend') hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $94fbdaa6f0254731$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $94fbdaa6f0254731$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $94fbdaa6f0254731$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $94fbdaa6f0254731$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $94fbdaa6f0254731$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $94fbdaa6f0254731$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $e2c5e310b54d33e0$export$8049d91f25899769).apply(void 0, [
                    mainHelper.state
                ].concat($94fbdaa6f0254731$var$_toConsumableArray((0, $186c27026185aabe$export$1c33c9881dac6797)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on('change', function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $94fbdaa6f0254731$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on('search', function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on('result', function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on('recommend:result', function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $88af57b1ec675f81$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
                    $94fbdaa6f0254731$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $88af57b1ec675f81$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on('change', function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $94fbdaa6f0254731$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === 'error' && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $88af57b1ec675f81$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
                    $94fbdaa6f0254731$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $88af57b1ec675f81$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $94fbdaa6f0254731$var$_objectSpread($94fbdaa6f0254731$var$_objectSpread({}, uiState), {}, $94fbdaa6f0254731$var$_defineProperty({}, indexId, $94fbdaa6f0254731$var$_objectSpread($94fbdaa6f0254731$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $94fbdaa6f0254731$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $94fbdaa6f0254731$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === 'function' ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $94fbdaa6f0254731$var$_objectSpread($94fbdaa6f0254731$var$_objectSpread({}, state), {}, $94fbdaa6f0254731$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $94fbdaa6f0254731$export$2e2bcd8739ae039 = $94fbdaa6f0254731$var$index;
function $94fbdaa6f0254731$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $94fbdaa6f0254731$var$_objectSpread($94fbdaa6f0254731$var$_objectSpread({}, instantSearchInstance.renderState), {}, $94fbdaa6f0254731$var$_defineProperty({}, parentIndexName, $94fbdaa6f0254731$var$_objectSpread($94fbdaa6f0254731$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}


var $03699098be8fa0a7$var$NAMESPACE = 'ais';
var $03699098be8fa0a7$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : '';
        var modifier = modifierName ? "--".concat(modifierName) : '';
        return "".concat($03699098be8fa0a7$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};


function $6173eb95478317e5$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split('.');
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}


var $728482e4bb20deaf$var$suit = (0, $03699098be8fa0a7$export$d8556a2a8f973135)('Highlight');
function $728482e4bb20deaf$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $6173eb95478317e5$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $728482e4bb20deaf$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    return attributeValue.replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}


function $6ff05dcff942f411$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6ff05dcff942f411$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6ff05dcff942f411$var$_typeof(o);
}
function $6ff05dcff942f411$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute('data-insights-method');
    var serializedPayload = domElement.getAttribute('data-insights-payload');
    if (typeof serializedPayload !== 'string') throw new Error('The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.');
    try {
        var payload = (0, $485f4c76ce9799b0$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error('The insights helper was unable to parse `data-insights-payload`.');
    }
}
function $6ff05dcff942f411$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($6ff05dcff942f411$var$_typeof(payload) !== 'object') throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $485f4c76ce9799b0$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return "data-insights-method=\"".concat(method, "\" data-insights-payload=\"").concat(serializedPayload, "\"");
}
function $6ff05dcff942f411$export$2e2bcd8739ae039(method, payload) {
    return $6ff05dcff942f411$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}



function $2fee0229cc85da11$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join('');
}


function $260e17925c3b7ba5$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== '') elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}


var $53019c3baf4acade$var$hasAlphanumeric = new RegExp(/\w/i);
function $53019c3baf4acade$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$53019c3baf4acade$var$hasAlphanumeric.test((0, $22d2651e56707261$export$e8bacd2802a88316)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $068d8bcbebfe01a2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $068d8bcbebfe01a2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $068d8bcbebfe01a2$var$_typeof(o);
}
function $068d8bcbebfe01a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $068d8bcbebfe01a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $068d8bcbebfe01a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $068d8bcbebfe01a2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $068d8bcbebfe01a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $068d8bcbebfe01a2$var$_defineProperty(obj, key, value) {
    key = $068d8bcbebfe01a2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $068d8bcbebfe01a2$var$_toPropertyKey(t) {
    var i = $068d8bcbebfe01a2$var$_toPrimitive(t, "string");
    return "symbol" == $068d8bcbebfe01a2$var$_typeof(i) ? i : String(i);
}
function $068d8bcbebfe01a2$var$_toPrimitive(t, r) {
    if ("object" != $068d8bcbebfe01a2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $068d8bcbebfe01a2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $068d8bcbebfe01a2$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $068d8bcbebfe01a2$var$_objectSpread($068d8bcbebfe01a2$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $068d8bcbebfe01a2$var$_objectSpread($068d8bcbebfe01a2$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $53019c3baf4acade$export$60c97785b669d08a)(parts, i)
        });
    });
}


var $5a21cf4d28d384ae$var$suit = (0, $03699098be8fa0a7$export$d8556a2a8f973135)('ReverseHighlight');
function $5a21cf4d28d384ae$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $6173eb95478317e5$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $5a21cf4d28d384ae$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    var reverseHighlightedValue = (0, $2fee0229cc85da11$export$a34fe2fceda1929e)((0, $068d8bcbebfe01a2$export$8d1202a2cf66e93)((0, $260e17925c3b7ba5$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}



var $ce392bcdf57f8fc1$var$suit = (0, $03699098be8fa0a7$export$d8556a2a8f973135)('ReverseSnippet');
function $ce392bcdf57f8fc1$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $6173eb95478317e5$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $ce392bcdf57f8fc1$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    var reverseHighlightedValue = (0, $2fee0229cc85da11$export$a34fe2fceda1929e)((0, $068d8bcbebfe01a2$export$8d1202a2cf66e93)((0, $260e17925c3b7ba5$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}



var $3082b80b48169aa7$var$suit = (0, $03699098be8fa0a7$export$d8556a2a8f973135)('Snippet');
function $3082b80b48169aa7$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $6173eb95478317e5$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $3082b80b48169aa7$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    return attributeValue.replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}


function $d953e23ebd620264$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}


function $97cf28631393a188$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $97cf28631393a188$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $97cf28631393a188$var$_typeof(o);
}
function $97cf28631393a188$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97cf28631393a188$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97cf28631393a188$var$ownKeys(Object(t), !0).forEach(function(r) {
            $97cf28631393a188$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97cf28631393a188$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $97cf28631393a188$var$_defineProperty(obj, key, value) {
    key = $97cf28631393a188$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $97cf28631393a188$var$_toPropertyKey(t) {
    var i = $97cf28631393a188$var$_toPrimitive(t, "string");
    return "symbol" == $97cf28631393a188$var$_typeof(i) ? i : String(i);
}
function $97cf28631393a188$var$_toPrimitive(t, r) {
    if ("object" != $97cf28631393a188$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $97cf28631393a188$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $97cf28631393a188$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $d953e23ebd620264$export$f5dd818bff069720)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $728482e4bb20deaf$export$2e2bcd8739ae039)($97cf28631393a188$var$_objectSpread($97cf28631393a188$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\nThe highlight helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $5a21cf4d28d384ae$export$2e2bcd8739ae039)($97cf28631393a188$var$_objectSpread($97cf28631393a188$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\n  The reverseHighlight helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $3082b80b48169aa7$export$2e2bcd8739ae039)($97cf28631393a188$var$_objectSpread($97cf28631393a188$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\nThe snippet helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $ce392bcdf57f8fc1$export$2e2bcd8739ae039)($97cf28631393a188$var$_objectSpread($97cf28631393a188$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\n  The reverseSnippet helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $6ff05dcff942f411$export$2e2bcd8739ae039)(method, $97cf28631393a188$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error("\nThe insights helper expects a JSON object of the format:\n{ \"method\": \"method-name\", \"payload\": { \"eventName\": \"name of the event\" } }");
            }
        }
    };
}


var $ae60064040d2ea2e$var$nextMicroTask = Promise.resolve();
function $ae60064040d2ea2e$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $ae60064040d2ea2e$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error('The deferred function should be called before calling `wait()`');
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

function $44102f9417d68246$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $44102f9417d68246$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $44102f9417d68246$var$_typeof(o);
}
function $44102f9417d68246$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44102f9417d68246$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44102f9417d68246$var$ownKeys(Object(t), !0).forEach(function(r) {
            $44102f9417d68246$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44102f9417d68246$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $44102f9417d68246$var$_defineProperty(obj, key, value) {
    key = $44102f9417d68246$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $44102f9417d68246$var$_toPropertyKey(t) {
    var i = $44102f9417d68246$var$_toPrimitive(t, "string");
    return "symbol" == $44102f9417d68246$var$_typeof(i) ? i : String(i);
}
function $44102f9417d68246$var$_toPrimitive(t, r) {
    if ("object" != $44102f9417d68246$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $44102f9417d68246$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $44102f9417d68246$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $44102f9417d68246$var$_objectSpread($44102f9417d68246$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}

function $2b9876638c75ff44$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2b9876638c75ff44$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2b9876638c75ff44$var$_typeof(o);
}
function $2b9876638c75ff44$var$_slicedToArray(arr, i) {
    return $2b9876638c75ff44$var$_arrayWithHoles(arr) || $2b9876638c75ff44$var$_iterableToArrayLimit(arr, i) || $2b9876638c75ff44$var$_unsupportedIterableToArray(arr, i) || $2b9876638c75ff44$var$_nonIterableRest();
}
function $2b9876638c75ff44$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2b9876638c75ff44$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2b9876638c75ff44$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2b9876638c75ff44$var$_arrayLikeToArray(o, minLen);
}
function $2b9876638c75ff44$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2b9876638c75ff44$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2b9876638c75ff44$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2b9876638c75ff44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b9876638c75ff44$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b9876638c75ff44$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2b9876638c75ff44$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b9876638c75ff44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2b9876638c75ff44$var$_defineProperty(obj, key, value) {
    key = $2b9876638c75ff44$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b9876638c75ff44$var$_toPropertyKey(t) {
    var i = $2b9876638c75ff44$var$_toPrimitive(t, "string");
    return "symbol" == $2b9876638c75ff44$var$_typeof(i) ? i : String(i);
}
function $2b9876638c75ff44$var$_toPrimitive(t, r) {
    if ("object" != $2b9876638c75ff44$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2b9876638c75ff44$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2b9876638c75ff44$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!('transporter' in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== 'function')) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $2b9876638c75ff44$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $2b9876638c75ff44$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $2b9876638c75ff44$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ('transporter' in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = Array.isArray(requests) ? // search client
            requests.map(function(request) {
                return $2b9876638c75ff44$var$_objectSpread($2b9876638c75ff44$var$_objectSpread({}, request), {}, {
                    params: $2b9876638c75ff44$var$serializeQueryParameters(request.params)
                });
            }) : // composition client
            $2b9876638c75ff44$var$serializeQueryParameters(requests.requestBody.params);
            return client.transporter.responsesCache.get({
                method: 'search',
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: 'search',
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!('transporter' in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $2b9876638c75ff44$var$_objectSpread($2b9876638c75ff44$var$_objectSpread({}, client.cache), {}, $2b9876638c75ff44$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $2b9876638c75ff44$var$deserializeQueryParameters(parameters) {
    return parameters.split('&').reduce(function(acc, parameter) {
        var _parameter$split = parameter.split('='), _parameter$split2 = $2b9876638c75ff44$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : '';
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $2b9876638c75ff44$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]';
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode('%s=%s', key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join('&');
}



function $cbd21276633c705c$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d)).forEach(function(widget) {
        return $cbd21276633c705c$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}


var $bca2d7f3ebdf52d7$export$2e2bcd8739ae039 = '4.79.0';


function $1792368430fd2311$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1792368430fd2311$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1792368430fd2311$var$_typeof(o);
}
function $1792368430fd2311$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1792368430fd2311$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1792368430fd2311$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1792368430fd2311$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1792368430fd2311$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1792368430fd2311$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1792368430fd2311$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1792368430fd2311$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1792368430fd2311$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1792368430fd2311$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1792368430fd2311$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1792368430fd2311$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1792368430fd2311$var$_setPrototypeOf(subClass, superClass);
}
function $1792368430fd2311$var$_setPrototypeOf(o, p) {
    $1792368430fd2311$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1792368430fd2311$var$_setPrototypeOf(o, p);
}
function $1792368430fd2311$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1792368430fd2311$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1792368430fd2311$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1792368430fd2311$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1792368430fd2311$var$_possibleConstructorReturn(this, result);
    };
}
function $1792368430fd2311$var$_possibleConstructorReturn(self, call) {
    if (call && ($1792368430fd2311$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1792368430fd2311$var$_assertThisInitialized(self);
}
function $1792368430fd2311$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1792368430fd2311$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1792368430fd2311$var$_getPrototypeOf(o) {
    $1792368430fd2311$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1792368430fd2311$var$_getPrototypeOf(o);
}
function $1792368430fd2311$var$_defineProperty(obj, key, value) {
    key = $1792368430fd2311$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1792368430fd2311$var$_toPropertyKey(t) {
    var i = $1792368430fd2311$var$_toPrimitive(t, "string");
    return "symbol" == $1792368430fd2311$var$_typeof(i) ? i : String(i);
}
function $1792368430fd2311$var$_toPrimitive(t, r) {
    if ("object" != $1792368430fd2311$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1792368430fd2311$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1792368430fd2311$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'instantsearch'
});
function $1792368430fd2311$var$defaultCreateURL() {
    return '#';
}
var $1792368430fd2311$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $1792368430fd2311$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $1792368430fd2311$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $1792368430fd2311$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $1792368430fd2311$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "client", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "indexName", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "compositionID", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "onStateChange", null);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "future", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "helper", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "started", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "renderState", {});
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_manuallyResetScheduleSearch", false);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_resetScheduleSearch", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_createURL", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "_insights", void 0);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "middleware", []);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "status", 'idle');
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "error", undefined);
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "scheduleSearch", (0, $ae60064040d2ea2e$export$260e5c0943f31606)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "scheduleRender", (0, $ae60064040d2ea2e$export$260e5c0943f31606)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = 'idle';
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $1792368430fd2311$var$_assertThisInitialized(_this)
            });
            _this.emit('render');
        }));
        $1792368430fd2311$var$_defineProperty($1792368430fd2311$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $ae60064040d2ea2e$export$260e5c0943f31606)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? '' : _options$indexName, compositionID = options.compositionID, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $1792368430fd2311$var$_objectSpread($1792368430fd2311$var$_objectSpread({}, $1792368430fd2311$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($1792368430fd2311$var$withUsage('The `searchClient` option is required.'));
        if (typeof searchClient.search !== 'function') throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === 'function') searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $bca2d7f3ebdf52d7$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== 'function') throw new Error($1792368430fd2311$var$withUsage('The `insightsClient` option should be a function.'));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.compositionID = compositionID;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $94fbdaa6f0254731$export$2e2bcd8739ae039)({
            // we use an index widget to render compositions
            // this only works because there's only one composition index allow for now
            indexName: _this.compositionID || _this.indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $97cf28631393a188$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $1792368430fd2311$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $1c8cc0c1c6330343$export$8793edee2d425525);
        if (routing) {
            var routerOptions = typeof routing === 'boolean' ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $5ce42100fb742e1a$export$1fe5128387816284)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === 'boolean' ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $fd610d368d455f7e$export$91e0bf09562e2c44)(insightsOptions));
        }
        if ((0, $939b544e79195a3a$export$4b4254890acf93e7)()) _this.use((0, $939b544e79195a3a$export$8ee9d2447935ed96)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $1792368430fd2311$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === 'stalled';
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $1792368430fd2311$var$_objectSpread({
                        $$type: '__unknown__',
                        $$internal: false,
                        subscribe: (0, $1c8cc0c1c6330343$export$8793edee2d425525),
                        started: (0, $1c8cc0c1c6330343$export$8793edee2d425525),
                        unsubscribe: (0, $1c8cc0c1c6330343$export$8793edee2d425525),
                        onStateChange: (0, $1c8cc0c1c6330343$export$8793edee2d425525)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($1792368430fd2311$var$withUsage('The `addWidgets` method expects an array of widgets. Please use `addWidget`.'));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== 'function' && typeof widget.render !== 'function';
                })) throw new Error($1792368430fd2311$var$withUsage('The widget definition expects a `render` and/or an `init` method.'));
                if (this.compositionID && widgets.some((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d))) throw new Error($1792368430fd2311$var$withUsage('The `index` widget cannot be used with a composition-based InstantSearch implementation.'));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($1792368430fd2311$var$withUsage('The `removeWidgets` method expects an array of widgets. Please use `removeWidget`.'));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== 'function';
                })) throw new Error($1792368430fd2311$var$withUsage('The widget definition expects a `dispose` method.'));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($1792368430fd2311$var$withUsage('The `start` method has already been called once.'));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                if (this.compositionID) mainHelper.searchForFacetValues = mainHelper.searchForCompositionFacetValues.bind(mainHelper);
                mainHelper.search = function() {
                    _this3.status = 'loading';
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) {
                        if (_this3.compositionID) mainHelper.searchWithComposition();
                        else mainHelper.searchOnlyWithDerivedHelpers();
                    }
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $1c8cc0c1c6330343$export$8793edee2d425525));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($32cead6defcfe2a5$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once('search', function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on('change', function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on('error', function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = 'error';
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit('error', error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $2b9876638c75ff44$export$7edf4eca27ca3a19)(this.client, this._initialResults);
                    (0, $44102f9417d68246$export$53ef00b131a96aa6)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $ae60064040d2ea2e$export$260e5c0943f31606)((0, $1c8cc0c1c6330343$export$8793edee2d425525));
                    if (this._manuallyResetScheduleSearch) // If `_manuallyResetScheduleSearch` is passed, it means that we don't
                    // want to rely on a single `defer` to reset the `scheduleSearch`.
                    // Instead, the consumer will call `_resetScheduleSearch` to restore
                    // the original `scheduleSearch` function.
                    // This happens in the React flavour after rendering.
                    this._resetScheduleSearch = function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    };
                    else // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $ae60064040d2ea2e$export$260e5c0943f31606)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === 'undefined') mainHelper.derivedHelpers[0].once('result', function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $fd610d368d455f7e$export$91e0bf09562e2c44)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = 'stalled';
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($1792368430fd2311$var$withUsage('The `start` method needs to be called before `setUiState`.'));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === 'function' ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $cbd21276633c705c$export$fd5e8f1329b3d5e0)(typeof finalUiState === 'function' ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $cbd21276633c705c$export$fd5e8f1329b3d5e0)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($1792368430fd2311$var$withUsage('The `start` method needs to be called before `createURL`.'));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($1792368430fd2311$var$withUsage('The `start` method needs to be called before `refresh`.'));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($1b8b757b6af13439$exports))));
var $1792368430fd2311$export$2e2bcd8739ae039 = $1792368430fd2311$var$InstantSearch;



var $ggE0n = parcelRequire("ggE0n");
var $193a666be44e8045$exports = {};
'use strict';

$193a666be44e8045$exports = (parcelRequire("jGFHY"));


var $521da4078d21263e$export$2e2bcd8739ae039 = '7.16.0';




var $ggE0n = parcelRequire("ggE0n");
function $052b606e1f5a20e7$var$_slicedToArray(arr, i) {
    return $052b606e1f5a20e7$var$_arrayWithHoles(arr) || $052b606e1f5a20e7$var$_iterableToArrayLimit(arr, i) || $052b606e1f5a20e7$var$_unsupportedIterableToArray(arr, i) || $052b606e1f5a20e7$var$_nonIterableRest();
}
function $052b606e1f5a20e7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $052b606e1f5a20e7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $052b606e1f5a20e7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $052b606e1f5a20e7$var$_arrayLikeToArray(o, minLen);
}
function $052b606e1f5a20e7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $052b606e1f5a20e7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $052b606e1f5a20e7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $052b606e1f5a20e7$export$91db9bc4f8ac944a() {
    var _useReducer = (0, $ggE0n.useReducer)(function(x) {
        return x + 1;
    }, 0), _useReducer2 = $052b606e1f5a20e7$var$_slicedToArray(_useReducer, 2), forceUpdate = _useReducer2[1];
    return forceUpdate;
}






function $48fec8737000b746$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $48fec8737000b746$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $48fec8737000b746$var$_typeof(o);
}
function $48fec8737000b746$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48fec8737000b746$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48fec8737000b746$var$ownKeys(Object(t), !0).forEach(function(r) {
            $48fec8737000b746$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48fec8737000b746$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $48fec8737000b746$var$_defineProperty(obj, key, value) {
    key = $48fec8737000b746$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $48fec8737000b746$var$_toPropertyKey(t) {
    var i = $48fec8737000b746$var$_toPrimitive(t, "string");
    return "symbol" == $48fec8737000b746$var$_typeof(i) ? i : String(i);
}
function $48fec8737000b746$var$_toPrimitive(t, r) {
    if ("object" != $48fec8737000b746$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $48fec8737000b746$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $48fec8737000b746$var$defaultUserAgents = [
    "react (".concat((0, $ggE0n.version), ")"),
    "react-instantsearch (".concat((0, $521da4078d21263e$export$2e2bcd8739ae039), ")"),
    "react-instantsearch-core (".concat((0, $521da4078d21263e$export$2e2bcd8739ae039), ")")
];
var $48fec8737000b746$var$serverUserAgent = "react-instantsearch-server (".concat((0, $521da4078d21263e$export$2e2bcd8739ae039), ")");
var $48fec8737000b746$var$nextUserAgent = function nextUserAgent(nextVersion) {
    return nextVersion ? "next.js (".concat(nextVersion, ")") : null;
};
function $48fec8737000b746$export$c42eabfabffc4866(props) {
    var forceUpdate = (0, $052b606e1f5a20e7$export$91db9bc4f8ac944a)();
    var serverContext = (0, $00cd4da9ce57bfe1$export$692e83606e644bf6)();
    var serverState = (0, $f921733e63b96a3d$export$b7b167d1ffee3ddc)();
    var waitingForResultsRef = (0, $3bff512125d1ba8b$export$b0820d56d4bdeee6)();
    var initialResults = serverState === null || serverState === void 0 ? void 0 : serverState.initialResults;
    var prevPropsRef = (0, $ggE0n.useRef)(props);
    var shouldRenderAtOnce = serverContext || initialResults || waitingForResultsRef;
    var searchRef = (0, $ggE0n.useRef)(null);
    // As we need to render on mount with SSR, using the local ref above in `StrictMode` will
    // create and start two instances of InstantSearch. To avoid this, we instead discard it and use
    // an upward ref from `InstantSearchSSRContext` as it has already been mounted a second time at this point.
    if (serverState) searchRef = serverState.ssrSearchRef;
    if (searchRef.current === null) {
        // We don't use the `instantsearch()` function because it comes with other
        // top-level APIs that we don't need.
        // See https://github.com/algolia/instantsearch/blob/5b529f43d8acc680f85837eaaa41f7fd03a3f833/src/index.es.ts#L63-L86
        var search = new (0, $1792368430fd2311$export$2e2bcd8739ae039)(props);
        search._schedule = function _schedule(cb) {
            search._schedule.queue.push(cb);
            clearTimeout(search._schedule.timer);
            search._schedule.timer = setTimeout(function() {
                search._schedule.queue.forEach(function(callback) {
                    callback();
                });
                search._schedule.queue = [];
            }, 0);
        };
        search._schedule.queue = [];
        if (shouldRenderAtOnce) {
            // InstantSearch.js has a private Initial Results API that lets us inject
            // results on the search instance.
            // On the server, we default the initial results to an empty object so that
            // InstantSearch.js doesn't schedule a search that isn't used, leading to
            // an additional network request. (This is equivalent to monkey-patching
            // `scheduleSearch` to a noop.)
            search._initialResults = initialResults || {};
            // We don't rely on the `defer` to reset the schedule search, but will call
            // `search._resetScheduleSearch()` manually in the effect after children
            // mount in `InstantSearch`.
            search._manuallyResetScheduleSearch = true;
        }
        $48fec8737000b746$var$addAlgoliaAgents(props.searchClient, [].concat($48fec8737000b746$var$defaultUserAgents, [
            serverContext && $48fec8737000b746$var$serverUserAgent,
            $48fec8737000b746$var$nextUserAgent($48fec8737000b746$var$getNextVersion())
        ]));
        // On the server, we start the search early to compute the search parameters.
        // On SSR, we start the search early to directly catch up with the lifecycle
        // and render.
        if (shouldRenderAtOnce) search.start();
        if (serverContext) // We notify `getServerState()` of the InstantSearch internals to retrieve
        // the server state and pass it to the render on SSR.
        serverContext.notifyServer({
            search: search
        });
        $48fec8737000b746$var$warnNextRouter(props.routing);
        $48fec8737000b746$var$warnNextAppDir(Boolean(waitingForResultsRef));
        searchRef.current = search;
    }
    var _search = searchRef.current;
    var prevProps = prevPropsRef.current;
    if (prevProps.indexName !== props.indexName) {
        _search.helper.setIndex(props.indexName || '').search();
        prevPropsRef.current = props;
    }
    if (prevProps.searchClient !== props.searchClient) {
        $48fec8737000b746$var$addAlgoliaAgents(props.searchClient, [].concat($48fec8737000b746$var$defaultUserAgents, [
            serverContext && $48fec8737000b746$var$serverUserAgent
        ]));
        _search.mainHelper.setClient(props.searchClient).search();
        prevPropsRef.current = props;
    }
    if (prevProps.onStateChange !== props.onStateChange) {
        _search.onStateChange = props.onStateChange;
        prevPropsRef.current = props;
    }
    if (prevProps.searchFunction !== props.searchFunction) {
        // Updating the `searchFunction` to `undefined` is not supported by
        // InstantSearch.js, so it will throw an error.
        // This is a fair behavior until we add an update API in InstantSearch.js.
        _search._searchFunction = props.searchFunction;
        prevPropsRef.current = props;
    }
    if (prevProps.stalledSearchDelay !== props.stalledSearchDelay) {
        var _props$stalledSearchD;
        // The default `stalledSearchDelay` in InstantSearch.js is 200ms.
        // We need to reset it when it's undefined to get back to the original value.
        _search._stalledSearchDelay = (_props$stalledSearchD = props.stalledSearchDelay) !== null && _props$stalledSearchD !== void 0 ? _props$stalledSearchD : 200;
        prevPropsRef.current = props;
    }
    if (!(0, $3e9453843be7bce4$export$de8294bb3be0322f)(prevProps.future, props.future)) {
        _search.future = $48fec8737000b746$var$_objectSpread($48fec8737000b746$var$_objectSpread({}, (0, $1792368430fd2311$export$8bd42a83af1ca676)), props.future);
        prevPropsRef.current = props;
    }
    var cleanupTimerRef = (0, $ggE0n.useRef)(null);
    var store = (0, $193a666be44e8045$exports.useSyncExternalStore)((0, $ggE0n.useCallback)(function() {
        var search = searchRef.current;
        // Scenario 1: the component mounts.
        if (cleanupTimerRef.current === null) // On SSR, the instance is already started so we don't start it again.
        {
            if (!search.started) {
                search.start();
                forceUpdate();
            }
        } else {
            // We cancel the previous cleanup function because we don't want to
            // dispose the search during an update.
            clearTimeout(cleanupTimerRef.current);
            search._preventWidgetCleanup = false;
        }
        return function() {
            function cleanup() {
                search.dispose();
            }
            clearTimeout(search._schedule.timer);
            // We clean up only when the component that uses this subscription unmounts,
            // but not when it updates, because it would dispose the instance, which
            // would remove all the widgets and break routing.
            // Executing the cleanup function in a `setTimeout()` lets us cancel it
            // in the next effect.
            // (There might be better ways to do this.)
            cleanupTimerRef.current = setTimeout(cleanup);
            // We need to prevent the `useWidget` cleanup function so that widgets
            // are not removed before the instance is disposed, triggering
            // an unwanted search request.
            search._preventWidgetCleanup = true;
        };
    }, [
        forceUpdate
    ]), function() {
        return searchRef.current;
    }, function() {
        return searchRef.current;
    });
    return store;
}
function $48fec8737000b746$var$addAlgoliaAgents(searchClient, userAgents) {
    if (typeof searchClient.addAlgoliaAgent !== 'function') return;
    userAgents.filter(Boolean).forEach(function(userAgent) {
        searchClient.addAlgoliaAgent(userAgent);
    });
}
function $48fec8737000b746$var$warnNextRouter(routing) {
    var _routing$router, isUsingNextRouter;
}
function $48fec8737000b746$var$warnNextAppDir(isRscContextDefined) {
    var _next;
    return;
}
/**
 * Gets the version of Next.js if it is available in the `window` object,
 * otherwise it returns the NEXT_RUNTIME environment variable (in SSR),
 * which is either `nodejs` or `edge`.
 */ function $48fec8737000b746$var$getNextVersion() {
    var _next2, _process$env;
    return typeof window !== 'undefined' && ((_next2 = window.next) === null || _next2 === void 0 ? void 0 : _next2.version) || undefined;
}


var $204762a302987aec$var$_excluded = [
    "children"
];
function $204762a302987aec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $204762a302987aec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $204762a302987aec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $204762a302987aec$export$ad8f235d2c2c71c0(_ref) {
    var children = _ref.children, props = $204762a302987aec$var$_objectWithoutProperties(_ref, $204762a302987aec$var$_excluded);
    var search = (0, $48fec8737000b746$export$c42eabfabffc4866)(props);
    if (!search.started) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $1d7e551f1487fee4$export$4b9ddb9c6903c13).Provider, {
        value: search
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $197036370167c5cc$export$899c7584ba03b94a).Provider, {
        value: search.mainIndex
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($204762a302987aec$var$ResetScheduleSearch, {
        search: search
    })));
}
function $204762a302987aec$var$ResetScheduleSearch(_ref2) {
    var search = _ref2.search;
    (0, $ggE0n.useEffect)(function() {
        if (search._resetScheduleSearch) search._resetScheduleSearch();
    }, [
        search
    ]);
    return null;
}

function $aff4afc3d3bedc2e$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}


function $8e335589a1e3c8b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e335589a1e3c8b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e335589a1e3c8b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e335589a1e3c8b3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e335589a1e3c8b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e335589a1e3c8b3$var$_defineProperty(obj, key, value) {
    key = $8e335589a1e3c8b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e335589a1e3c8b3$var$_toPropertyKey(t) {
    var i = $8e335589a1e3c8b3$var$_toPrimitive(t, "string");
    return "symbol" == $8e335589a1e3c8b3$var$_typeof(i) ? i : String(i);
}
function $8e335589a1e3c8b3$var$_toPrimitive(t, r) {
    if ("object" != $8e335589a1e3c8b3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e335589a1e3c8b3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e335589a1e3c8b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e335589a1e3c8b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e335589a1e3c8b3$var$_typeof(o);
}
function $8e335589a1e3c8b3$var$_slicedToArray(arr, i) {
    return $8e335589a1e3c8b3$var$_arrayWithHoles(arr) || $8e335589a1e3c8b3$var$_iterableToArrayLimit(arr, i) || $8e335589a1e3c8b3$var$_unsupportedIterableToArray(arr, i) || $8e335589a1e3c8b3$var$_nonIterableRest();
}
function $8e335589a1e3c8b3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e335589a1e3c8b3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8e335589a1e3c8b3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8e335589a1e3c8b3$var$_arrayLikeToArray(o, minLen);
}
function $8e335589a1e3c8b3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8e335589a1e3c8b3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8e335589a1e3c8b3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8e335589a1e3c8b3$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? 'Filter Applied' : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(':'), _args$0$split2 = $8e335589a1e3c8b3$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === 'string' ? attr : attr(facetValue);
        if (args.length === 1 && $8e335589a1e3c8b3$var$_typeof(args[0]) === 'object') instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === 'click' && args.length >= 2 && args.length <= 4) {
            if (!(0, $aff4afc3d3bedc2e$export$12368a7050a31bdd)(helper, attribute, facetValue)) {
                var _helper$lastResults;
                // send event only when the facet is being checked "ON"
                instantSearchInstance.sendEventToInsights({
                    insightsMethod: 'clickedFilters',
                    widgetType: widgetType,
                    eventType: eventType,
                    eventModifier: eventModifier,
                    payload: $8e335589a1e3c8b3$var$_objectSpread({
                        eventName: eventName,
                        index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                        filters: [
                            "".concat(attribute, ":").concat(facetValue)
                        ]
                    }, additionalData),
                    attribute: attribute
                });
            }
        }
    };
    return sendEventForFacet;
}


function $d94dfbc709fa6dac$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d94dfbc709fa6dac$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d94dfbc709fa6dac$var$_typeof(o);
}
var $d94dfbc709fa6dac$var$_excluded = [
    "name",
    "escapedValue"
], $d94dfbc709fa6dac$var$_excluded2 = [
    "escapedValue",
    "value"
];
function $d94dfbc709fa6dac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d94dfbc709fa6dac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d94dfbc709fa6dac$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d94dfbc709fa6dac$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d94dfbc709fa6dac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d94dfbc709fa6dac$var$_defineProperty(obj, key, value) {
    key = $d94dfbc709fa6dac$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d94dfbc709fa6dac$var$_toPropertyKey(t) {
    var i = $d94dfbc709fa6dac$var$_toPrimitive(t, "string");
    return "symbol" == $d94dfbc709fa6dac$var$_typeof(i) ? i : String(i);
}
function $d94dfbc709fa6dac$var$_toPrimitive(t, r) {
    if ("object" != $d94dfbc709fa6dac$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d94dfbc709fa6dac$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d94dfbc709fa6dac$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d94dfbc709fa6dac$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d94dfbc709fa6dac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d94dfbc709fa6dac$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'refinement-list',
    connector: true
});
var $d94dfbc709fa6dac$var$DEFAULT_SORT = [
    'isRefined',
    'count:desc',
    'name:asc'
];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */ var $d94dfbc709fa6dac$var$connectRefinementList = function connectRefinementList(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $d94dfbc709fa6dac$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$operator = _ref.operator, operator = _ref$operator === void 0 ? 'or' : _ref$operator, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $d94dfbc709fa6dac$var$DEFAULT_SORT : _ref$sortBy, _ref$escapeFacetValue = _ref.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($d94dfbc709fa6dac$var$withUsage('The `attribute` option is required.'));
        if (!/^(and|or)$/.test(operator)) throw new Error($d94dfbc709fa6dac$var$withUsage("The `operator` must one of: `\"and\"`, `\"or\"` (got \"".concat(operator, "\").")));
        if (showMore === true && showMoreLimit <= limit) throw new Error($d94dfbc709fa6dac$var$withUsage('`showMoreLimit` should be greater than `limit`.'));
        var formatItems = function formatItems(_ref2) {
            var label = _ref2.name, value = _ref2.escapedValue, item = $d94dfbc709fa6dac$var$_objectWithoutProperties(_ref2, $d94dfbc709fa6dac$var$_excluded);
            return $d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, item), {}, {
                value: value,
                label: label,
                highlighted: label
            });
        };
        var lastResultsFromMainSearch;
        var lastItemsFromMainSearch = [];
        var hasExhaustiveItems = true;
        var triggerRefine;
        var sendEvent;
        var isShowingMore = false;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        var searchForFacetValues = function searchForFacetValues() {
            return function() {};
        };
        var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
            return function(renderOptions) {
                return function(query) {
                    var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
                    if (query === '' && lastItemsFromMainSearch) // render with previous data from the helper.
                    renderFn($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, widget.getWidgetRenderState($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, renderOptions), {}, {
                        results: lastResultsFromMainSearch
                    }))), {}, {
                        instantSearchInstance: instantSearchInstance
                    }), false);
                    else {
                        var tags = {
                            highlightPreTag: escapeFacetValues ? (0, $83855ad73d0a9c34$export$1e7338a8952eaf35).highlightPreTag : (0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPreTag,
                            highlightPostTag: escapeFacetValues ? (0, $83855ad73d0a9c34$export$1e7338a8952eaf35).highlightPostTag : (0, $83855ad73d0a9c34$export$62e796b7905e8e6b).highlightPostTag
                        };
                        helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
                        // doesn't support a greater number.
                        // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
                        Math.min(getLimit(), 100), tags).then(function(results) {
                            var facetValues = escapeFacetValues ? (0, $83855ad73d0a9c34$export$9ae2e822836b2e1a)(results.facetHits) : results.facetHits;
                            var normalizedFacetValues = transformItems(facetValues.map(function(_ref3) {
                                var escapedValue = _ref3.escapedValue, value = _ref3.value, item = $d94dfbc709fa6dac$var$_objectWithoutProperties(_ref3, $d94dfbc709fa6dac$var$_excluded2);
                                return $d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, item), {}, {
                                    value: escapedValue,
                                    label: value
                                });
                            }), {
                                results: searchResults
                            });
                            renderFn($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, widget.getWidgetRenderState($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, renderOptions), {}, {
                                results: lastResultsFromMainSearch
                            }))), {}, {
                                items: normalizedFacetValues,
                                canToggleShowMore: false,
                                canRefine: true,
                                isFromSearch: true,
                                instantSearchInstance: instantSearchInstance
                            }), false);
                        });
                    }
                };
            };
        };
        return {
            $$type: 'ais.refinementList',
            init: function init(initOptions) {
                renderFn($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, renderState), {}, {
                    refinementList: $d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, renderState.refinementList), {}, $d94dfbc709fa6dac$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var facetValues = [];
                if (!sendEvent || !triggerRefine || !searchForFacetValues) {
                    sendEvent = (0, $8e335589a1e3c8b3$export$75bfa3473d01f29f)({
                        instantSearchInstance: instantSearchInstance,
                        helper: helper,
                        attribute: attribute,
                        widgetType: this.$$type
                    });
                    triggerRefine = function triggerRefine(facetValue) {
                        sendEvent('click:internal', facetValue);
                        helper.toggleFacetRefinement(attribute, facetValue).search();
                    };
                    searchForFacetValues = createSearchForFacetValues(helper, this);
                }
                if (results) {
                    var values = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $d94dfbc709fa6dac$var$DEFAULT_SORT
                    });
                    facetValues = values && Array.isArray(values) ? values : [];
                    items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
                        results: results
                    });
                    var maxValuesPerFacetConfig = state.maxValuesPerFacet;
                    var currentLimit = getLimit();
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
                    lastResultsFromMainSearch = results;
                    lastItemsFromMainSearch = items;
                    if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                }
                // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                // function
                var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
                var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
                var canShowMore = showMore && !hasExhaustiveItems;
                var canToggleShowMore = canShowLess || canShowMore;
                return {
                    createURL: function createURL(facetValue) {
                        return _createURL(function(uiState) {
                            return _this.getWidgetUiState(uiState, {
                                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                                helper: helper
                            });
                        });
                    },
                    items: items,
                    refine: triggerRefine,
                    searchForItems: searchFacetValues,
                    isFromSearch: false,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    canToggleShowMore: canToggleShowMore,
                    toggleShowMore: cachedToggleShowMore,
                    sendEvent: sendEvent,
                    hasExhaustiveItems: hasExhaustiveItems
                };
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                var withoutMaxValuesPerFacet = state.setQueryParameter('maxValuesPerFacet', undefined);
                if (operator === 'and') return withoutMaxValuesPerFacet.removeFacet(attribute);
                return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var values = operator === 'or' ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
                return $d94dfbc709fa6dac$var$removeEmptyRefinementsFromUiState($d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, uiState), {}, {
                    refinementList: $d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, uiState.refinementList), {}, $d94dfbc709fa6dac$var$_defineProperty({}, attribute, values))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var isDisjunctive = operator === 'or';
                if (searchParameters.isHierarchicalFacet(attribute)) return searchParameters;
                if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var values = uiState.refinementList && uiState.refinementList[attribute];
                var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter('maxValuesPerFacet', nextMaxValuesPerFacet);
                if (!values) {
                    var key = isDisjunctive ? 'disjunctiveFacetsRefinements' : 'facetsRefinements';
                    return withMaxValuesPerFacet.setQueryParameters($d94dfbc709fa6dac$var$_defineProperty({}, key, $d94dfbc709fa6dac$var$_objectSpread($d94dfbc709fa6dac$var$_objectSpread({}, withMaxValuesPerFacet[key]), {}, $d94dfbc709fa6dac$var$_defineProperty({}, attribute, []))));
                }
                return values.reduce(function(parameters, value) {
                    return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
                }, withMaxValuesPerFacet);
            }
        };
    };
};
function $d94dfbc709fa6dac$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.refinementList) return indexUiState;
    if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) delete indexUiState.refinementList[attribute];
    if (Object.keys(indexUiState.refinementList).length === 0) delete indexUiState.refinementList;
    return indexUiState;
}
var $d94dfbc709fa6dac$export$2e2bcd8739ae039 = $d94dfbc709fa6dac$var$connectRefinementList;



function $aac22500be3fad43$export$5da5a5848a7e380(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $d94dfbc709fa6dac$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $52c40fbe513f5efb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $52c40fbe513f5efb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $52c40fbe513f5efb$var$_typeof(o);
}
var $52c40fbe513f5efb$var$_excluded = [
    "configure"
];
function $52c40fbe513f5efb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52c40fbe513f5efb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52c40fbe513f5efb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $52c40fbe513f5efb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52c40fbe513f5efb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $52c40fbe513f5efb$var$_defineProperty(obj, key, value) {
    key = $52c40fbe513f5efb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $52c40fbe513f5efb$var$_toPropertyKey(t) {
    var i = $52c40fbe513f5efb$var$_toPrimitive(t, "string");
    return "symbol" == $52c40fbe513f5efb$var$_typeof(i) ? i : String(i);
}
function $52c40fbe513f5efb$var$_toPrimitive(t, r) {
    if ("object" != $52c40fbe513f5efb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $52c40fbe513f5efb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $52c40fbe513f5efb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $52c40fbe513f5efb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $52c40fbe513f5efb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $52c40fbe513f5efb$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $52c40fbe513f5efb$var$_objectWithoutProperties(uiState, $52c40fbe513f5efb$var$_excluded);
    return trackedUiState;
}
function $52c40fbe513f5efb$export$2e2bcd8739ae039() {
    return {
        $$type: 'ais.simple',
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $52c40fbe513f5efb$var$_objectSpread($52c40fbe513f5efb$var$_objectSpread({}, state), {}, $52c40fbe513f5efb$var$_defineProperty({}, indexId, $52c40fbe513f5efb$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $52c40fbe513f5efb$var$_objectSpread($52c40fbe513f5efb$var$_objectSpread({}, state), {}, $52c40fbe513f5efb$var$_defineProperty({}, indexId, $52c40fbe513f5efb$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}





var $ggE0n = parcelRequire("ggE0n");

var $3og2D = parcelRequire("3og2D");
/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @returns search parameters with refinements cleared
 */ function $9218e897dfacb8f0$export$c8b9db57471d846b(_ref) {
    var helper = _ref.helper, _ref$attributesToClea = _ref.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
    var finalState = helper.state.setPage(0);
    finalState = attributesToClear.reduce(function(state, attribute) {
        if (finalState.isNumericRefined(attribute)) return state.removeNumericRefinement(attribute);
        if (finalState.isHierarchicalFacet(attribute)) return state.removeHierarchicalFacetRefinement(attribute);
        if (finalState.isDisjunctiveFacet(attribute)) return state.removeDisjunctiveFacetRefinement(attribute);
        if (finalState.isConjunctiveFacet(attribute)) return state.removeFacetRefinement(attribute);
        return state;
    }, finalState);
    if (attributesToClear.indexOf('query') !== -1) finalState = finalState.setQuery('');
    return finalState;
}

function $510b342e2e872f5b$export$ad628980c7383a99(value) {
    if (typeof value === 'string') return value.replace(/^\\-/, '-');
    return value;
}
function $510b342e2e872f5b$export$40415fcf01f0c9e8(value) {
    if (typeof value === 'number' && value < 0 || typeof value === 'string') return String(value).replace(/^-/, '\\-');
    return value;
}



function $8256e59f633418c3$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $510b342e2e872f5b$export$40415fcf01f0c9e8)(name)
    };
    var facet = (0, $b59046fa9f922e9f$export$71aa6c912b956294)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === 'hierarchical') {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $b59046fa9f922e9f$export$71aa6c912b956294)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $8256e59f633418c3$export$d9f33760e70a0a(_results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var results = _results || {};
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($8256e59f633418c3$var$getRefinement(state, 'facet', attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: 'exclude',
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($8256e59f633418c3$var$getRefinement(state, 'disjunctive', attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $510b342e2e872f5b$export$ad628980c7383a99)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($8256e59f633418c3$var$getRefinement(state, 'hierarchical', attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: 'numeric',
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: 'tag',
            attribute: '_tags',
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: 'query',
        type: 'query',
        name: state.query,
        query: state.query
    });
    return refinements;
}


function $d96a83fad06df924$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d96a83fad06df924$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d96a83fad06df924$var$_typeof(o);
}
function $d96a83fad06df924$var$_toConsumableArray(arr) {
    return $d96a83fad06df924$var$_arrayWithoutHoles(arr) || $d96a83fad06df924$var$_iterableToArray(arr) || $d96a83fad06df924$var$_unsupportedIterableToArray(arr) || $d96a83fad06df924$var$_nonIterableSpread();
}
function $d96a83fad06df924$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d96a83fad06df924$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d96a83fad06df924$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d96a83fad06df924$var$_arrayLikeToArray(o, minLen);
}
function $d96a83fad06df924$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d96a83fad06df924$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d96a83fad06df924$var$_arrayLikeToArray(arr);
}
function $d96a83fad06df924$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d96a83fad06df924$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d96a83fad06df924$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d96a83fad06df924$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d96a83fad06df924$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d96a83fad06df924$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d96a83fad06df924$var$_defineProperty(obj, key, value) {
    key = $d96a83fad06df924$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d96a83fad06df924$var$_toPropertyKey(t) {
    var i = $d96a83fad06df924$var$_toPrimitive(t, "string");
    return "symbol" == $d96a83fad06df924$var$_typeof(i) ? i : String(i);
}
function $d96a83fad06df924$var$_toPrimitive(t, r) {
    if ("object" != $d96a83fad06df924$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d96a83fad06df924$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d96a83fad06df924$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'clear-refinements',
    connector: true
});
var $d96a83fad06df924$var$connectClearRefinements = function connectClearRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $d96a83fad06df924$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$includedAttribut = _ref.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            'query'
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) throw new Error($d96a83fad06df924$var$withUsage('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
        var connectorState = {
            refine: (0, $1c8cc0c1c6330343$export$8793edee2d425525),
            createURL: function createURL() {
                return '';
            },
            attributesToClear: []
        };
        var cachedRefine = function cachedRefine() {
            return connectorState.refine();
        };
        var cachedCreateURL = function cachedCreateURL() {
            return connectorState.createURL();
        };
        return {
            $$type: 'ais.clearRefinements',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($d96a83fad06df924$var$_objectSpread($d96a83fad06df924$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($d96a83fad06df924$var$_objectSpread($d96a83fad06df924$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $d96a83fad06df924$var$_objectSpread($d96a83fad06df924$var$_objectSpread({}, renderState), {}, {
                    clearRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var createURL = _ref2.createURL, scopedResults = _ref2.scopedResults, results = _ref2.results;
                connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
                    return attributesToClear.concat($d96a83fad06df924$var$getAttributesToClear({
                        scopedResult: scopedResult,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        transformItems: transformItems,
                        results: results
                    }));
                }, []);
                connectorState.refine = function() {
                    connectorState.attributesToClear.forEach(function(_ref3) {
                        var indexHelper = _ref3.helper, items = _ref3.items;
                        indexHelper.setState((0, $9218e897dfacb8f0$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        })).search();
                    });
                };
                connectorState.createURL = function() {
                    return createURL((0, $e2c5e310b54d33e0$export$8049d91f25899769).apply(void 0, $d96a83fad06df924$var$_toConsumableArray(connectorState.attributesToClear.map(function(_ref4) {
                        var indexHelper = _ref4.helper, items = _ref4.items;
                        return (0, $9218e897dfacb8f0$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        });
                    }))));
                };
                var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
                    return attributeToClear.items.length > 0;
                });
                return {
                    canRefine: canRefine,
                    hasRefinements: canRefine,
                    refine: cachedRefine,
                    createURL: cachedCreateURL,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $d96a83fad06df924$var$getAttributesToClear(_ref5) {
    var scopedResult = _ref5.scopedResult, includedAttributes = _ref5.includedAttributes, excludedAttributes = _ref5.excludedAttributes, transformItems = _ref5.transformItems, results = _ref5.results;
    var includesQuery = includedAttributes.indexOf('query') !== -1 || excludedAttributes.indexOf('query') === -1;
    return {
        helper: scopedResult.helper,
        items: transformItems((0, $a341acb2f4de204b$export$f70730c3d1fc524e)((0, $8256e59f633418c3$export$d9f33760e70a0a)(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
            return refinement.attribute;
        }).filter(function(attribute) {
            return(// If the array is empty (default case), we keep all the attributes
            includedAttributes.length === 0 || // Otherwise, only add the specified attributes
            includedAttributes.indexOf(attribute) !== -1);
        }).filter(function(attribute) {
            return(// If the query is included, we ignore the default `excludedAttributes = ['query']`
            attribute === 'query' && includesQuery || // Otherwise, ignore the excluded attributes
            excludedAttributes.indexOf(attribute) === -1);
        })), {
            results: results
        })
    };
}
var $d96a83fad06df924$export$2e2bcd8739ae039 = $d96a83fad06df924$var$connectClearRefinements;



function $1f65d342571fa7e6$export$60a47f8af66e226a(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $d96a83fad06df924$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $13ba506f4e2ad0e3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $13ba506f4e2ad0e3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $13ba506f4e2ad0e3$var$_typeof(o);
}
function $13ba506f4e2ad0e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13ba506f4e2ad0e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13ba506f4e2ad0e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $13ba506f4e2ad0e3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13ba506f4e2ad0e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $13ba506f4e2ad0e3$var$_defineProperty(obj, key, value) {
    key = $13ba506f4e2ad0e3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $13ba506f4e2ad0e3$var$_toPropertyKey(t) {
    var i = $13ba506f4e2ad0e3$var$_toPrimitive(t, "string");
    return "symbol" == $13ba506f4e2ad0e3$var$_typeof(i) ? i : String(i);
}
function $13ba506f4e2ad0e3$var$_toPrimitive(t, r) {
    if ("object" != $13ba506f4e2ad0e3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $13ba506f4e2ad0e3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $13ba506f4e2ad0e3$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'search-box',
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $13ba506f4e2ad0e3$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $13ba506f4e2ad0e3$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $13ba506f4e2ad0e3$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $13ba506f4e2ad0e3$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: 'ais.searchBox',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($13ba506f4e2ad0e3$var$_objectSpread($13ba506f4e2ad0e3$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($13ba506f4e2ad0e3$var$_objectSpread($13ba506f4e2ad0e3$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter('query', undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $13ba506f4e2ad0e3$var$_objectSpread($13ba506f4e2ad0e3$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery('').search();
                    };
                }
                return {
                    query: state.query || '',
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === 'stalled'
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || '';
                if (query === '' || uiState && uiState.query === query) return uiState;
                return $13ba506f4e2ad0e3$var$_objectSpread($13ba506f4e2ad0e3$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter('query', uiState.query || '');
            }
        };
    };
};
var $13ba506f4e2ad0e3$export$2e2bcd8739ae039 = $13ba506f4e2ad0e3$var$connectSearchBox;



function $7732a887e1609a22$export$34d981d965dcc5b5(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $13ba506f4e2ad0e3$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}



var $2QPpE = parcelRequire("2QPpE");
function $077ff55a4e79d1c1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $077ff55a4e79d1c1$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $077ff55a4e79d1c1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $2QPpE = parcelRequire("2QPpE");

function $90b0ccd61728c39a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $499a28b1dcbc98e8$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $90b0ccd61728c39a$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




var $4TMho = parcelRequire("4TMho");

var $2QPpE = parcelRequire("2QPpE");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ 
var $90NkU = parcelRequire("90NkU");
function $8deb5a1aa1f00721$export$e08e3b67e392101e() {
    for(var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++){
        callbacks[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                if (typeof callback === 'function') callback.apply(void 0, (0, $90NkU._)(args));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}




var $90NkU = parcelRequire("90NkU");


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $14195c176ed33023$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).useLayoutEffect : function() {};




var $90NkU = parcelRequire("90NkU");


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0770c91df2f1295f$export$7f54fc3180508a52(fn) {
    var ref = (0, $ggE0n.useRef)(null);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $ggE0n.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var f = ref.current;
        return f === null || f === void 0 ? void 0 : f.apply(void 0, (0, $90NkU._)(args));
    }, []);
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c7f0bd9bbe5da866$export$14d238f342723f25(defaultValue) {
    var _$fCAlL$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(defaultValue), 2), value = _$fCAlL$useState[0], setValue = _$fCAlL$useState[1];
    var effect = (0, $ggE0n.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    var nextRef = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        if (!effect.current) return;
        // Run the generator to the next yield.
        var newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    var queue = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(fn) {
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}



var $ggE0n = parcelRequire("ggE0n");


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
var $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$defaultContext);
var $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext(false);
// This is only used in React < 18.
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    var cur = (0, $ggE0n.useContext)($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$SSRContext);
    var counter = $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useCounter(cur === $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$defaultContext);
    var _$670gB$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(true), 2), isSSR = _$670gB$useState[0], setIsSSR = _$670gB$useState[1];
    var value = (0, $ggE0n.useMemo)(function() {
        return {
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$defaultContext ? '' : "".concat(cur.prefix, "-").concat(counter),
            current: 0
        };
    }, [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $ggE0n.useLayoutEffect)(function() {
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
var $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $110c9ade4cf71f7a$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
var $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useCounter() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ctx = (0, $ggE0n.useContext)($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$SSRContext);
    var ref = (0, $ggE0n.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        var currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            var prevComponentValue = $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    var ctx = (0, $ggE0n.useContext)($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$defaultContext && $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$canUseDOM;
    var counter = $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    var prefix = "react-aria".concat(ctx.prefix);
    return defaultId || "".concat(prefix, "-").concat(counter);
}
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).useId();
    var _$670gB$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)($110c9ade4cf71f7a$export$535bd6ca7f90a273()), 1), didSSR = _$670gB$useState[0];
    var prefix = didSSR || false ? 'react-aria' : "react-aria".concat($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$defaultContext.prefix);
    return defaultId || "".concat(prefix, "-").concat(id);
}
var $110c9ade4cf71f7a$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n)))['useId'] === 'function' ? $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useModernSSRSafeId : $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return function() {};
}
function $110c9ade4cf71f7a$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n)))['useSyncExternalStore']($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$subscribe, $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$getSnapshot, $110c9ade4cf71f7a$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $ggE0n.useContext)($110c9ade4cf71f7a$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
var $7fc455d18519c289$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var $7fc455d18519c289$export$d41a04c74483c6ef = new Map();
// This allows us to clean up the idsUpdaterMap when the id is no longer used.
// Map is a strong reference, so unused ids wouldn't be cleaned up otherwise.
// This can happen in suspended components where mount/unmount is not called.
var $7fc455d18519c289$var$$bdb11010cef70236$var$registry;
if (typeof FinalizationRegistry !== 'undefined') $7fc455d18519c289$var$$bdb11010cef70236$var$registry = new FinalizationRegistry(function(heldValue) {
    $7fc455d18519c289$export$d41a04c74483c6ef.delete(heldValue);
});
function $7fc455d18519c289$export$f680877a34711e37(defaultId) {
    var _$eKkEp$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(defaultId), 2), value = _$eKkEp$useState[0], setValue = _$eKkEp$useState[1];
    var nextId = (0, $ggE0n.useRef)(null);
    var res = (0, $110c9ade4cf71f7a$export$619500959fc48b26)(value);
    var cleanupRef = (0, $ggE0n.useRef)(null);
    if ($7fc455d18519c289$var$$bdb11010cef70236$var$registry) $7fc455d18519c289$var$$bdb11010cef70236$var$registry.register(cleanupRef, res);
    if ($7fc455d18519c289$var$$bdb11010cef70236$var$canUseDOM) {
        var cacheIdRef = $7fc455d18519c289$export$d41a04c74483c6ef.get(res);
        if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
        else $7fc455d18519c289$export$d41a04c74483c6ef.set(res, [
            nextId
        ]);
    }
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var r = res;
        return function() {
            // In Suspense, the cleanup function may be not called
            // when it is though, also remove it from the finalization registry.
            if ($7fc455d18519c289$var$$bdb11010cef70236$var$registry) $7fc455d18519c289$var$$bdb11010cef70236$var$registry.unregister(cleanupRef);
            $7fc455d18519c289$export$d41a04c74483c6ef.delete(r);
        };
    }, [
        res
    ]);
    (0, $ggE0n.useEffect)(function() {
        var newId = nextId.current;
        if (newId) setValue(newId);
        return function() {
            if (newId) nextId.current = null;
        };
    });
    return res;
}
function $7fc455d18519c289$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    var setIdsA = $7fc455d18519c289$export$d41a04c74483c6ef.get(idA);
    if (setIdsA) {
        setIdsA.forEach(function(ref) {
            return ref.current = idB;
        });
        return idB;
    }
    var setIdsB = $7fc455d18519c289$export$d41a04c74483c6ef.get(idB);
    if (setIdsB) {
        setIdsB.forEach(function(ref) {
            return ref.current = idA;
        });
        return idA;
    }
    return idB;
}
function $7fc455d18519c289$export$b4cc09c592e8fdb8() {
    var depArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var id = $7fc455d18519c289$export$f680877a34711e37();
    var _$1dbecbe27a04f9af$export$14d238f342723f25 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $c7f0bd9bbe5da866$export$14d238f342723f25)(id), 2), resolvedId = _$1dbecbe27a04f9af$export$14d238f342723f25[0], setResolvedId = _$1dbecbe27a04f9af$export$14d238f342723f25[1];
    var updateId = (0, $ggE0n.useCallback)(function() {
        setResolvedId(function() {
            return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            id
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            document.getElementById(id) ? id : undefined
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId
    ].concat((0, $90NkU._)(depArray)));
    return resolvedId;
}



var $4TMho = parcelRequire("4TMho");
function $4b0249324a8da0b8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, $4TMho._)(e))) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4b0249324a8da0b8$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4b0249324a8da0b8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4b0249324a8da0b8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4b0249324a8da0b8$export$2e2bcd8739ae039 = $4b0249324a8da0b8$export$4f5d2d50c9deca37;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $850b305c152381bf$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    var result = (0, $2QPpE._)({}, args[0]);
    for(var i = 1; i < args.length; i++){
        var props = args[i];
        for(var key in props){
            var a = result[key];
            var b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $8deb5a1aa1f00721$export$e08e3b67e392101e)(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (0, $4b0249324a8da0b8$export$2e2bcd8739ae039)(a, b);
            else if (key === 'id' && a && b) result.id = (0, $7fc455d18519c289$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c90706a3f6fff521$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    if (refs.length === 1 && refs[0]) return refs[0];
    return function(value) {
        var hasCleanup = false;
        var cleanups = refs.map(function(ref) {
            var cleanup = $c90706a3f6fff521$var$$5dc95899b306f630$var$setRef(ref, value);
            hasCleanup || (hasCleanup = typeof cleanup == 'function');
            return cleanup;
        });
        if (hasCleanup) return function() {
            cleanups.forEach(function(cleanup, i) {
                if (typeof cleanup === 'function') cleanup();
                else $c90706a3f6fff521$var$$5dc95899b306f630$var$setRef(refs[i], null);
            });
        };
    };
}
function $c90706a3f6fff521$var$$5dc95899b306f630$var$setRef(ref, value) {
    if (typeof ref === 'function') return ref(value);
    else if (ref != null) ref.current = value;
}


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c25977d36d6c3204$export$4338b53315abf666(ref) {
    var objRef = (0, $ggE0n.useRef)(null);
    var cleanupRef = (0, $ggE0n.useRef)(undefined);
    var refEffect = (0, $ggE0n.useCallback)(function(instance) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var refCleanup = refCallback(instance);
            return function() {
                if (typeof refCleanup === 'function') refCleanup();
                else refCallback(null);
            };
        } else if (ref) {
            ref.current = instance;
            return function() {
                ref.current = null;
            };
        }
    }, [
        ref
    ]);
    return (0, $ggE0n.useMemo)(function() {
        return {
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (cleanupRef.current) {
                    cleanupRef.current();
                    cleanupRef.current = undefined;
                }
                if (value != null) cleanupRef.current = refEffect(value);
            }
        };
    }, [
        refEffect
    ]);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e2b7517996df0b67$export$c62b8e45d58ddad9 = Symbol('default');
function $e2b7517996df0b67$export$2881499e37b75b9a(param) {
    var values = param.values, children = param.children;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $c6938abc98c6418f$export$71511d61b312f219)(_step.value, 2), Context = _step_value[0], value = _step_value[1];
            children = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Context.Provider, {
                value: value
            }, children);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return children;
}
function $e2b7517996df0b67$export$4d86445c2cf5e3(props) {
    var className = props.className, style = props.style, children = props.children, defaultClassName = props.defaultClassName, defaultChildren = props.defaultChildren, defaultStyle = props.defaultStyle, values = props.values;
    return (0, $ggE0n.useMemo)(function() {
        var computedClassName;
        var computedStyle;
        var computedChildren;
        if (typeof className === 'function') computedClassName = className((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, values), {
            defaultClassName: defaultClassName
        }));
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, values), {
            defaultStyle: defaultStyle || {}
        }));
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, values), {
            defaultChildren: defaultChildren
        }));
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
            style: computedStyle || defaultStyle ? (0, $2QPpE._)({}, defaultStyle, computedStyle) : undefined,
            children: computedChildren !== null && computedChildren !== void 0 ? computedChildren : defaultChildren,
            'data-rac': ''
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values
    ]);
}
function $e2b7517996df0b67$export$c245e6201fed2f75(value, wrap) {
    return function(renderProps) {
        return wrap(typeof value === 'function' ? value(renderProps) : value, renderProps);
    };
}
function $e2b7517996df0b67$export$fabf2dc03a41866e(context, slot) {
    var ctx = (0, $ggE0n.useContext)(context);
    if (slot === null) return null;
    if (ctx && (typeof ctx === "undefined" ? "undefined" : (0, $4TMho._)(ctx)) === 'object' && 'slots' in ctx && ctx.slots) {
        var slotKey = slot || $e2b7517996df0b67$export$c62b8e45d58ddad9;
        if (!ctx.slots[slotKey]) {
            var availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map(function(p) {
                return '"'.concat(p, '"');
            }));
            var errorMessage = slot ? 'Invalid slot "'.concat(slot, '".') : 'A slot prop is required.';
            throw new Error("".concat(errorMessage, " Valid slot names are ").concat(availableSlots, "."));
        }
        return ctx.slots[slotKey];
    }
    // @ts-ignore
    return ctx;
}
function $e2b7517996df0b67$export$29f1550f4b0d4415(props, ref, context) {
    var ctx = $e2b7517996df0b67$export$fabf2dc03a41866e(context, props.slot) || {};
    // @ts-ignore - TS says "Type 'unique symbol' cannot be used as an index type." but not sure why.
    var contextRef = ctx.ref, contextProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(ctx, [
        "ref"
    ]);
    var mergedRef = (0, $c25977d36d6c3204$export$4338b53315abf666)((0, $ggE0n.useMemo)(function() {
        return (0, $c90706a3f6fff521$export$c9058316764c140e)(ref, contextRef);
    }, [
        ref,
        contextRef
    ]));
    var mergedProps = (0, $850b305c152381bf$export$9d1611c77c2fe928)(contextProps, props);
    // mergeProps does not merge `style`. Adding this there might be a breaking change.
    if ('style' in contextProps && contextProps.style && 'style' in props && props.style) {
        if (typeof contextProps.style === 'function' || typeof props.style === 'function') mergedProps.style = function(renderProps) {
            var contextStyle = typeof contextProps.style === 'function' ? contextProps.style(renderProps) : contextProps.style;
            var defaultStyle = (0, $2QPpE._)({}, renderProps.defaultStyle, contextStyle);
            var style = typeof props.style === 'function' ? props.style((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, renderProps), {
                defaultStyle: defaultStyle
            })) : props.style;
            return (0, $2QPpE._)({}, defaultStyle, style);
        };
        else mergedProps.style = (0, $2QPpE._)({}, contextProps.style, props.style);
    }
    return [
        mergedProps,
        mergedRef
    ];
}
function $e2b7517996df0b67$export$9d4c57ee4c6ffdd8() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    // Initial state is typically based on the parent having an aria-label or aria-labelledby.
    // If it does, this value should be false so that we don't update the state and cause a rerender when we go through the layoutEffect
    var _$iETbY$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(initialState), 2), hasSlot = _$iETbY$useState[0], setHasSlot = _$iETbY$useState[1];
    var hasRun = (0, $ggE0n.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    var ref = (0, $ggE0n.useCallback)(function(el) {
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function $e2b7517996df0b67$export$ef03459518577ad4(props) {
    var prefix = /^(data-.*)$/;
    var filteredProps = {};
    for(var prop in props)if (!prefix.test(prop)) filteredProps[prop] = props[prop];
    return filteredProps;
}



var $2QPpE = parcelRequire("2QPpE");




var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React doesn't understand the <template> element, which doesn't have children like a normal element.
// It will throw an error during hydration when it expects the firstChild to contain content rendered
// on the server, when in reality, the browser will have placed this inside the `content` document fragment.
// This monkey patches the firstChild property for our special hidden template elements to work around this error.
// See https://github.com/facebook/react/issues/19932
if (typeof HTMLTemplateElement !== 'undefined') {
    var $cfc4721022845f0c$var$getFirstChild = Object.getOwnPropertyDescriptor(Node.prototype, 'firstChild').get;
    Object.defineProperty(HTMLTemplateElement.prototype, 'firstChild', {
        configurable: true,
        enumerable: true,
        get: function get() {
            if (this.dataset.reactAriaHidden) return this.content.firstChild;
            else return $cfc4721022845f0c$var$getFirstChild.call(this);
        }
    });
}
var $cfc4721022845f0c$export$94b6d0abf7d33e8c = (0, $ggE0n.createContext)(false);
function $cfc4721022845f0c$export$8dc98ba7eadeaa56(props) {
    var isHidden = (0, $ggE0n.useContext)($cfc4721022845f0c$export$94b6d0abf7d33e8c);
    if (isHidden) return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, props.children);
    var children = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($cfc4721022845f0c$export$94b6d0abf7d33e8c.Provider, {
        value: true
    }, props.children);
    // In SSR, portals are not supported by React. Instead, always render into a <template>
    // element, which the browser will never display to the user. In addition, the
    // content is not part of the accessible DOM tree, so it won't affect ids or other accessibility attributes.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("template", {
        "data-react-aria-hidden": true
    }, children);
}
function $cfc4721022845f0c$export$86427a43e3e48ebb(fn) {
    var Wrapper = function(props, ref) {
        var isHidden = (0, $ggE0n.useContext)($cfc4721022845f0c$export$94b6d0abf7d33e8c);
        if (isHidden) return null;
        return fn(props, ref);
    };
    // @ts-ignore - for react dev tools
    Wrapper.displayName = fn.displayName || fn.name;
    return (0, $ggE0n.forwardRef)(Wrapper);
}
function $cfc4721022845f0c$export$b5d7cc18bb8d2b59() {
    return (0, $ggE0n.useContext)($cfc4721022845f0c$export$94b6d0abf7d33e8c);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4fa91534e9375925$export$75b6ee27786ba447 = (0, $ggE0n.createContext)({});
var $4fa91534e9375925$export$b04be29aa201d4f5 = (0, $cfc4721022845f0c$export$86427a43e3e48ebb)(function Label(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $4fa91534e9375925$export$75b6ee27786ba447), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var tmp = props.elementType, ElementType = tmp === void 0 ? 'label' : tmp, labelProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "elementType"
    ]);
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(ElementType, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        className: "react-aria-Label"
    }, labelProps), {
        ref: ref
    }));
});



var $2QPpE = parcelRequire("2QPpE");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $b53961de50607290$export$7d15b64cf5a3a4c4(value) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    var newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $b53961de50607290$export$e1a7b8e69ef6c52f(value, step) {
    var roundedValue = value;
    var stepString = step.toString();
    var pointIndex = stepString.indexOf('.');
    var precision = pointIndex >= 0 ? stepString.length - pointIndex : 0;
    if (precision > 0) {
        var pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $b53961de50607290$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    var remainder = (value - (isNaN(min) ? 0 : min)) % step;
    var snappedValue = $b53961de50607290$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($b53961de50607290$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($b53961de50607290$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $b53961de50607290$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $b53961de50607290$export$b6268554fba451f(value, digits) {
    var base = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    var pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    'id'
]);
var $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
// See LinkDOMProps in dom.d.ts.
var $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    'href',
    'hrefLang',
    'target',
    'rel',
    'download',
    'ping',
    'referrerPolicy'
]);
var $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $eec1da6bbd30ba7f$export$457c3d6518dd4c6f(props) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var labelable = opts.labelable, isLink = opts.isLink, propNames = opts.propNames;
    var filteredProps = {};
    for(var prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $eec1da6bbd30ba7f$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}



var $90NkU = parcelRequire("90NkU");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c7019d53357f553d$export$d6875122194c7b44(props, defaultLabel) {
    var id = props.id, label = props['aria-label'], labelledBy = props['aria-labelledby'];
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $7fc455d18519c289$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        var ids = new Set([
            id
        ].concat((0, $90NkU._)(labelledBy.trim().split(/\s+/))));
        labelledBy = (0, $90NkU._)(ids).join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9f59e5b1923f1fb3$export$8467354a121f1b9f(props) {
    var id = props.id, label = props.label, ariaLabelledby = props['aria-labelledby'], ariaLabel = props['aria-label'], tmp = props.labelElementType, labelElementType = tmp === void 0 ? 'label' : tmp;
    id = (0, $7fc455d18519c289$export$f680877a34711e37)(id);
    var labelId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? "".concat(labelId, " ").concat(ariaLabelledby) : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else !ariaLabelledby && ariaLabel;
    var fieldProps = (0, $c7019d53357f553d$export$d6875122194c7b44)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
var $6553a2858fcb0be1$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
var $6553a2858fcb0be1$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $6553a2858fcb0be1$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    if (Intl.Locale) {
        var locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        var textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === 'rtl';
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $6553a2858fcb0be1$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    var lang = localeString.split('-')[0];
    return $6553a2858fcb0be1$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}





var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
var $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $05f7eb35b0647c97$export$f09106e7c6677ec5() {
    var locale = typeof window !== 'undefined' && window[$05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (e) {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: (0, $6553a2858fcb0be1$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
    };
}
var $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$currentLocale = $05f7eb35b0647c97$export$f09106e7c6677ec5();
var $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$currentLocale = $05f7eb35b0647c97$export$f09106e7c6677ec5();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var listener = _step.value;
            listener($05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$currentLocale);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $05f7eb35b0647c97$export$188ec29ebc2bdc3a() {
    var isSSR = (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)();
    var _$ffhGL$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)($05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$currentLocale), 2), defaultLocale = _$ffhGL$useState[0], setDefaultLocale = _$ffhGL$useState[1];
    (0, $ggE0n.useEffect)(function() {
        if ($05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener('languagechange', $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return function() {
            $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener('languagechange', $05f7eb35b0647c97$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: 'en-US',
        direction: 'ltr'
    };
    return defaultLocale;
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $541452378073fc0a$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext(null);
function $541452378073fc0a$export$a54013f0d02a8f82(props) {
    var locale = props.locale, children = props.children;
    var defaultLocale = (0, $05f7eb35b0647c97$export$188ec29ebc2bdc3a)();
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).useMemo(function() {
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $6553a2858fcb0be1$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($541452378073fc0a$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $541452378073fc0a$export$43bb16f9c6d9e3f7() {
    var defaultLocale = (0, $05f7eb35b0647c97$export$188ec29ebc2bdc3a)();
    var context = (0, $ggE0n.useContext)($541452378073fc0a$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $2QPpE = parcelRequire("2QPpE");


var $90NkU = parcelRequire("90NkU");
var $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
var $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
        signDisplay: 'exceptZero'
    }).resolvedOptions().signDisplay === 'exceptZero';
// eslint-disable-next-line no-empty
} catch (e) {}
var $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat('de-DE', {
        style: 'unit',
        unit: 'degree'
    }).resolvedOptions().style === 'unit';
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
var $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            'ja-JP': " \u5EA6",
            'zh-TW': "\u5EA6",
            'sl-SI': " \xb0"
        }
    }
};
var $f92957428704dfd4$export$cc77c4ff7e8673c5 = /*#__PURE__*/ function() {
    "use strict";
    function $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gpEpt._)(this, $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5);
        this.numberFormatter = $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
    (0, $eOJ9o._)($488c6ddbf4ef74c2$export$cc77c4ff7e8673c5, [
        {
            /** Formats a number value as a string, according to the locale and options provided to the constructor. */ key: "format",
            value: function format(value) {
                var res = '';
                if (!$f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $f92957428704dfd4$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
                else res = this.numberFormatter.format(value);
                if (this.options.style === 'unit' && !$f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsUnit) {
                    var _UNITS_unit;
                    var _this_resolvedOptions = this.resolvedOptions(), unit = _this_resolvedOptions.unit, tmp = _this_resolvedOptions.unitDisplay, unitDisplay = tmp === void 0 ? 'short' : tmp, locale = _this_resolvedOptions.locale;
                    if (!unit) return res;
                    var values = (_UNITS_unit = $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
                    res += values[locale] || values.default;
                }
                return res;
            }
        },
        {
            /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ key: "formatToParts",
            value: function formatToParts(value) {
                // TODO: implement signDisplay for formatToParts
                return this.numberFormatter.formatToParts(value);
            }
        },
        {
            /** Formats a number range as a string. */ key: "formatRange",
            value: function formatRange(start, end) {
                if (typeof this.numberFormatter.formatRange === 'function') return this.numberFormatter.formatRange(start, end);
                if (end < start) throw new RangeError('End date must be >= start date');
                // Very basic fallback for old browsers.
                return "".concat(this.format(start), " \u2013 ").concat(this.format(end));
            }
        },
        {
            /** Formats a number range as an array of parts. */ key: "formatRangeToParts",
            value: function formatRangeToParts(start, end) {
                if (typeof this.numberFormatter.formatRangeToParts === 'function') return this.numberFormatter.formatRangeToParts(start, end);
                if (end < start) throw new RangeError('End date must be >= start date');
                var startParts = this.numberFormatter.formatToParts(start);
                var endParts = this.numberFormatter.formatToParts(end);
                return (0, $90NkU._)(startParts.map(function(p) {
                    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, p), {
                        source: 'startRange'
                    });
                })).concat([
                    {
                        type: 'literal',
                        value: " \u2013 ",
                        source: 'shared'
                    }
                ], (0, $90NkU._)(endParts.map(function(p) {
                    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, p), {
                        source: 'endRange'
                    });
                })));
            }
        },
        {
            /** Returns the resolved formatting options based on the values passed to the constructor. */ key: "resolvedOptions",
            value: function resolvedOptions() {
                var options = this.numberFormatter.resolvedOptions();
                if (!$f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, options), {
                    signDisplay: this.options.signDisplay
                });
                if (!$f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === 'unit') options = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, options), {
                    style: 'unit',
                    unit: this.options.unit,
                    unitDisplay: this.options.unitDisplay
                });
                return options;
            }
        }
    ]);
    return $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5;
}();
function $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var numberingSystem = options.numberingSystem;
    if (numberingSystem && locale.includes('-nu-')) {
        if (!locale.includes('-u-')) locale += '-u-';
        locale += "-nu-".concat(numberingSystem);
    }
    if (options.style === 'unit' && !$f92957428704dfd4$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        var unit = options.unit, tmp = options.unitDisplay, unitDisplay = tmp === void 0 ? 'short' : tmp;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error("Unsupported unit ".concat(unit, " with unitDisplay = ").concat(unitDisplay));
        options = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, options), {
            style: 'decimal'
        });
    }
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : '');
    if ($f92957428704dfd4$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    var numberFormatter = new Intl.NumberFormat(locale, options);
    $f92957428704dfd4$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $f92957428704dfd4$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === 'auto') return numberFormat.format(num);
    else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));
    else {
        var needsPositiveSign = false;
        if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === 'exceptZero') {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            var negative = numberFormat.format(-num);
            var noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            var minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
            if ((0, $90NkU._)(minus).length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
            var positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2755bcda8571d348$export$b7a616150fdb9f44() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    return (0, $ggE0n.useMemo)(function() {
        return new (0, $f92957428704dfd4$export$cc77c4ff7e8673c5)(locale, options);
    }, [
        locale,
        options
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e9fffec33ef32ddc$export$ed5abd763a836edc(props) {
    var tmp = props.value, value = tmp === void 0 ? 0 : tmp, tmp1 = props.minValue, minValue = tmp1 === void 0 ? 0 : tmp1, tmp2 = props.maxValue, maxValue = tmp2 === void 0 ? 100 : tmp2, valueLabel = props.valueLabel, isIndeterminate = props.isIndeterminate, tmp3 = props.formatOptions, formatOptions = tmp3 === void 0 ? {
        style: 'percent'
    } : tmp3;
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    var _$2xLm1$useLabel = (0, $9f59e5b1923f1fb3$export$8467354a121f1b9f)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    })), labelProps = _$2xLm1$useLabel.labelProps, fieldProps = _$2xLm1$useLabel.fieldProps;
    value = (0, $b53961de50607290$export$7d15b64cf5a3a4c4)(value, minValue, maxValue);
    var percentage = (value - minValue) / (maxValue - minValue);
    var formatter = (0, $2755bcda8571d348$export$b7a616150fdb9f44)(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        var valueToFormat = formatOptions.style === 'percent' ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, fieldProps), {
            'aria-valuenow': isIndeterminate ? undefined : value,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-valuetext': isIndeterminate ? undefined : valueLabel,
            role: 'progressbar'
        })),
        labelProps: labelProps
    };
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $0fdb024d56a6a9b7$export$e9f3bf65a26ce129 = (0, $ggE0n.createContext)(null);
var $0fdb024d56a6a9b7$export$c17561cb55d4db30 = (0, $ggE0n.forwardRef)(function ProgressBar(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $0fdb024d56a6a9b7$export$e9f3bf65a26ce129), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var tmp = props.value, value = tmp === void 0 ? 0 : tmp, tmp1 = props.minValue, minValue = tmp1 === void 0 ? 0 : tmp1, tmp2 = props.maxValue, maxValue = tmp2 === void 0 ? 100 : tmp2, tmp3 = props.isIndeterminate, isIndeterminate = tmp3 === void 0 ? false : tmp3;
    value = (0, $b53961de50607290$export$7d15b64cf5a3a4c4)(value, minValue, maxValue);
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var _$hU2kz$useProgressBar = (0, $e9fffec33ef32ddc$export$ed5abd763a836edc)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        label: label
    })), progressBarProps = _$hU2kz$useProgressBar.progressBarProps, labelProps = _$hU2kz$useProgressBar.labelProps;
    // Calculate the width of the progress bar as a percentage
    var percentage = isIndeterminate ? undefined : (value - minValue) / (maxValue - minValue) * 100;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        defaultClassName: 'react-aria-ProgressBar',
        values: {
            percentage: percentage,
            valueText: progressBarProps['aria-valuetext'],
            isIndeterminate: isIndeterminate
        }
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, progressBarProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $4fa91534e9375925$export$75b6ee27786ba447).Provider, {
        value: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
            ref: labelRef,
            elementType: 'span'
        })
    }, renderProps.children));
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $4TMho = parcelRequire("4TMho");
var $e7c771ec74591764$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
var $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer = null;
function $e7c771ec74591764$export$a9b970dcc4ae71a9(message) {
    var assertiveness = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'assertive', timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e7c771ec74591764$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;
    if (!$e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer) {
        $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer = new $e7c771ec74591764$var$$319e236875307eab$var$LiveAnnouncer();
        // wait for the live announcer regions to be added to the dom, then announce
        // otherwise Safari won't announce the message if it's added too quickly
        // found most times less than 100ms were not consistent when announcing with Safari
        // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
        // https://github.com/reactwg/react-18/discussions/102
        // if we're in a test environment, announce without waiting
        // @ts-ignore
        if (!(typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined')) setTimeout(function() {
            if ($e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer === null || $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer.isAttached()) $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer === null || $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer === void 0 || $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
        }, 100);
        else $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
    } else $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $e7c771ec74591764$export$d10ae4f68404609a(assertiveness) {
    if ($e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer) $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer.clear(assertiveness);
}
function $e7c771ec74591764$export$d8686216b8b81b2f() {
    if ($e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer) {
        $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer.destroy();
        $e7c771ec74591764$var$$319e236875307eab$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
var $e7c771ec74591764$var$$319e236875307eab$var$LiveAnnouncer = /*#__PURE__*/ function() {
    "use strict";
    function $319e236875307eab$var$LiveAnnouncer() {
        (0, $gpEpt._)(this, $319e236875307eab$var$LiveAnnouncer);
        this.node = null;
        this.assertiveLog = null;
        this.politeLog = null;
        if (typeof document !== 'undefined') {
            this.node = document.createElement('div');
            this.node.dataset.liveAnnouncer = 'true';
            // copied from VisuallyHidden
            Object.assign(this.node.style, {
                border: 0,
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap'
            });
            this.assertiveLog = this.createLog('assertive');
            this.node.appendChild(this.assertiveLog);
            this.politeLog = this.createLog('polite');
            this.node.appendChild(this.politeLog);
            document.body.prepend(this.node);
        }
    }
    (0, $eOJ9o._)($319e236875307eab$var$LiveAnnouncer, [
        {
            key: "isAttached",
            value: function isAttached() {
                var _this_node;
                return (_this_node = this.node) === null || _this_node === void 0 ? void 0 : _this_node.isConnected;
            }
        },
        {
            key: "createLog",
            value: function createLog(ariaLive) {
                var node = document.createElement('div');
                node.setAttribute('role', 'log');
                node.setAttribute('aria-live', ariaLive);
                node.setAttribute('aria-relevant', 'additions');
                return node;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (!this.node) return;
                document.body.removeChild(this.node);
                this.node = null;
            }
        },
        {
            key: "announce",
            value: function announce(message) {
                var assertiveness = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'assertive', timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e7c771ec74591764$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;
                var _this_assertiveLog, _this_politeLog;
                if (!this.node) return;
                var node = document.createElement('div');
                if ((typeof message === "undefined" ? "undefined" : (0, $4TMho._)(message)) === 'object') {
                    // To read an aria-labelledby, the element must have an appropriate role, such as img.
                    node.setAttribute('role', 'img');
                    node.setAttribute('aria-labelledby', message['aria-labelledby']);
                } else node.textContent = message;
                if (assertiveness === 'assertive') (_this_assertiveLog = this.assertiveLog) === null || _this_assertiveLog === void 0 || _this_assertiveLog.appendChild(node);
                else (_this_politeLog = this.politeLog) === null || _this_politeLog === void 0 || _this_politeLog.appendChild(node);
                if (message !== '') setTimeout(function() {
                    node.remove();
                }, timeout);
            }
        },
        {
            key: "clear",
            value: function clear(assertiveness) {
                if (!this.node) return;
                if ((!assertiveness || assertiveness === 'assertive') && this.assertiveLog) this.assertiveLog.innerHTML = '';
                if ((!assertiveness || assertiveness === 'polite') && this.politeLog) this.politeLog.innerHTML = '';
            }
        }
    ]);
    return $319e236875307eab$var$LiveAnnouncer;
}();




var $2QPpE = parcelRequire("2QPpE");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0e32e36d6fc7d24d$export$de79e2c695e052f3(element) {
    if ($0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        var scrollableElements = $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
var $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $0e32e36d6fc7d24d$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scrollableElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, element = _step_value.element, scrollTop = _step_value.scrollTop, scrollLeft = _step_value.scrollLeft;
            element.scrollTop = scrollTop;
            element.scrollLeft = scrollLeft;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}


var $4TMho = parcelRequire("4TMho");
var $435fb34f0a5eae0b$export$b204af158042fbac = function(el) {
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
var $435fb34f0a5eae0b$export$f21a1ffae260145a = function(el) {
    if (el && 'window' in el && el.window === el) return el;
    var doc = $435fb34f0a5eae0b$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/**
 * Type guard that checks if a value is a Node. Verifies the presence and type of the nodeType property.
 */ function $435fb34f0a5eae0b$var$$431fbd86ca7dc216$var$isNode(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $4TMho._)(value)) === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
function $435fb34f0a5eae0b$export$af51f0f06c0f328a(node) {
    return $435fb34f0a5eae0b$var$$431fbd86ca7dc216$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'host' in node;
}

var $2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])'
];
var $2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR = $2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
var $2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR = $2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $2b9fd0f27f1738b9$export$4c063cf1350e6fed(element) {
    return element.matches($2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $2b9fd0f27f1738b9$export$bebd5a1431fec25d(element) {
    return element.matches($2b9fd0f27f1738b9$var$$b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a9e9d769f7a52024$export$525bc4921d56d4a(nativeEvent) {
    var event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = function() {
        return event.defaultPrevented;
    };
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = function() {
        return event.cancelBubble;
    };
    event.persist = function() {};
    return event;
}
function $a9e9d769f7a52024$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $a9e9d769f7a52024$export$715c682d09d639cc(onBlur) {
    var stateRef = (0, $ggE0n.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var state = stateRef.current;
        return function() {
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    var dispatchBlur = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $ggE0n.useCallback)(function(e) {
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            var target = e.target;
            var onBlurHandler = function(e) {
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    var event = $a9e9d769f7a52024$export$525bc4921d56d4a(e);
                    dispatchBlur(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(function() {
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    var relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
var $a9e9d769f7a52024$export$fda7da73ab5d4c48 = false;
function $a9e9d769f7a52024$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $2b9fd0f27f1738b9$export$4c063cf1350e6fed)(target))target = target.parentElement;
    var window = (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(target);
    var activeElement = window.document.activeElement;
    if (!activeElement || activeElement === target) return;
    $a9e9d769f7a52024$export$fda7da73ab5d4c48 = true;
    var isRefocusing = false;
    var onBlur = function(e) {
        if (e.target === activeElement || isRefocusing) e.stopImmediatePropagation();
    };
    var onFocusOut = function(e) {
        if (e.target === activeElement || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    var onFocus = function(e) {
        if (e.target === target || isRefocusing) e.stopImmediatePropagation();
    };
    var onFocusIn = function(e) {
        if (e.target === target || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    window.addEventListener('blur', onBlur, true);
    window.addEventListener('focusout', onFocusOut, true);
    window.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('focus', onFocus, true);
    var cleanup = function() {
        cancelAnimationFrame(raf);
        window.removeEventListener('blur', onBlur, true);
        window.removeEventListener('focusout', onFocusOut, true);
        window.removeEventListener('focusin', onFocusIn, true);
        window.removeEventListener('focus', onFocus, true);
        $a9e9d769f7a52024$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    var raf = requestAnimationFrame(cleanup);
    return cleanup;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ccce5714e9b7278a$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some(function(brand) {
        return re.test(brand.brand);
    })) || re.test(window.navigator.userAgent);
}
function $ccce5714e9b7278a$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(fn) {
    var res = null;
    return function() {
        if (res == null) res = fn();
        return res;
    };
}
var $ccce5714e9b7278a$export$9ac100e40613ea10 = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
var $ccce5714e9b7278a$export$186c6964ca17d99 = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
var $ccce5714e9b7278a$export$7bef049ce92e4224 = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $ccce5714e9b7278a$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
var $ccce5714e9b7278a$export$fedb369cb70207f1 = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$export$186c6964ca17d99() || $ccce5714e9b7278a$export$7bef049ce92e4224();
});
var $ccce5714e9b7278a$export$e1865c3bedcd822b = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$export$9ac100e40613ea10() || $ccce5714e9b7278a$export$fedb369cb70207f1();
});
var $ccce5714e9b7278a$export$78551043582a6a98 = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$ccce5714e9b7278a$export$6446a186d09e379e();
});
var $ccce5714e9b7278a$export$6446a186d09e379e = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
var $ccce5714e9b7278a$export$a11b0059900ceec8 = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
var $ccce5714e9b7278a$export$b7d78993b74f766d = $ccce5714e9b7278a$var$$c87311424ea30a05$var$cached(function() {
    return $ccce5714e9b7278a$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $32af1881d810b59b$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $ccce5714e9b7278a$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $32af1881d810b59b$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $ccce5714e9b7278a$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}



var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality = null;
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
var $33b4709e5e6e943f$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$changeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            handler(modality, e);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $ccce5714e9b7278a$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($33b4709e5e6e943f$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality = 'keyboard';
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $32af1881d810b59b$export$60278871457622de)(e)) {
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
    }
}
function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document || (0, $a9e9d769f7a52024$export$fda7da73ab5d4c48) || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    if (0, $a9e9d769f7a52024$export$fda7da73ab5d4c48) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || $33b4709e5e6e943f$export$d90243b58daecda7.get((0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(element))) return;
    var windowObject = (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(element);
    var documentObject = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    var focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', function() {
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $33b4709e5e6e943f$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = function(element, loadListener) {
    var windowObject = (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(element);
    var documentObject = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$33b4709e5e6e943f$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $33b4709e5e6e943f$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $33b4709e5e6e943f$export$d90243b58daecda7.delete(windowObject);
};
function $33b4709e5e6e943f$export$2f1888112f558a7d(element) {
    var documentObject = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(element);
    var loadListener;
    if (documentObject.readyState !== 'loading') $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = function() {
            $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return function() {
        return $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
    };
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $33b4709e5e6e943f$export$2f1888112f558a7d();
function $33b4709e5e6e943f$export$b9b3dfddab17db27() {
    return $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $33b4709e5e6e943f$export$630ff653c5ada6a9() {
    return $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality;
}
function $33b4709e5e6e943f$export$8397ddfc504fdb9a(modality) {
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality = modality;
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $33b4709e5e6e943f$export$98e20ec92f614cfe() {
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    var _$28AnR$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)($33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality), 2), modality = _$28AnR$useState[0], setModality = _$28AnR$useState[1];
    (0, $ggE0n.useEffect)(function() {
        var handler = function() {
            setModality($33b4709e5e6e943f$var$$507fabe10e71c6fb$var$currentModality);
        };
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return function() {
            $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)() ? null : modality;
}
var $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var document1 = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(e === null || e === void 0 ? void 0 : e.target);
    var IHTMLInputElement = typeof window !== 'undefined' ? (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    var IHTMLTextAreaElement = typeof window !== 'undefined' ? (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    var IHTMLElement = typeof window !== 'undefined' ? (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    var IKeyboardEvent = typeof window !== 'undefined' ? (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    isTextInput = isTextInput || document1.activeElement instanceof IHTMLInputElement && !$33b4709e5e6e943f$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(document1.activeElement.type) || document1.activeElement instanceof IHTMLTextAreaElement || document1.activeElement instanceof IHTMLElement && document1.activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$33b4709e5e6e943f$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $33b4709e5e6e943f$export$ffd9e5021c1fb2d6() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isTextInput = props.isTextInput, autoFocus = props.autoFocus;
    var _$28AnR$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(autoFocus || $33b4709e5e6e943f$export$b9b3dfddab17db27()), 2), isFocusVisibleState = _$28AnR$useState[0], setFocusVisible = _$28AnR$useState[1];
    $33b4709e5e6e943f$export$ec71b4b83ac08ec3(function(isFocusVisible) {
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $33b4709e5e6e943f$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $ggE0n.useEffect)(function() {
        var handler = function(modality, e) {
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$33b4709e5e6e943f$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($33b4709e5e6e943f$export$b9b3dfddab17db27());
        };
        $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return function() {
            $33b4709e5e6e943f$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}



/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $5321c8b607a1147e$var$$f4e2df6bd15f8569$var$_tableNestedRows = false;
var $5321c8b607a1147e$var$$f4e2df6bd15f8569$var$_shadowDOM = false;
function $5321c8b607a1147e$export$d9d8a0f82de49530() {
    $5321c8b607a1147e$var$$f4e2df6bd15f8569$var$_tableNestedRows = true;
}
function $5321c8b607a1147e$export$1b00cb14a96194e6() {
    return $5321c8b607a1147e$var$$f4e2df6bd15f8569$var$_tableNestedRows;
}
function $5321c8b607a1147e$export$12b151d9882e9985() {
    $5321c8b607a1147e$var$$f4e2df6bd15f8569$var$_shadowDOM = true;
}
function $5321c8b607a1147e$export$98658e8c59125e6a() {
    return $5321c8b607a1147e$var$$f4e2df6bd15f8569$var$_shadowDOM;
}


// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
function $3b911e3383514511$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $5321c8b607a1147e$export$98658e8c59125e6a)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    var currentNode = otherNode;
    while(currentNode !== null){
        if (currentNode === node) return true;
        if (currentNode.tagName === 'SLOT' && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $435fb34f0a5eae0b$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
var $3b911e3383514511$export$cd4e5573fbe2b576 = function() {
    var doc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var _activeElement_shadowRoot;
    if (!(0, $5321c8b607a1147e$export$98658e8c59125e6a)()) return doc.activeElement;
    var activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement))activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $3b911e3383514511$export$e58f029f0fbfdb29(event) {
    if ((0, $5321c8b607a1147e$export$98658e8c59125e6a)() && event.target.shadowRoot) {
        if (event.composedPath) return event.composedPath()[0];
    }
    return event.target;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.

var $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
var $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === 'undefined') return;
    function isTransitionEvent(event) {
        return 'propertyName' in event;
    }
    var onTransitionStart = function(e) {
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        var transitions = $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener('transitioncancel', onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    var onTransitionEnd = function(e) {
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        var properties = $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener('transitioncancel', onTransitionEnd);
            $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cb = _step.value;
                    cb();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener('DOMContentLoaded', $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
/**
 * Cleans up any elements that are no longer in the document.
 * This is necessary because we can't rely on transitionend events to fire
 * for elements that are removed from the document while transitioning.
 */ function $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$cleanupDetachedElements() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $c6938abc98c6418f$export$71511d61b312f219)(_step.value, 1), eventTarget = _step_value[0];
            // the explicit instanceof check, since it may be different in different contexts.
            if ('isConnected' in eventTarget && !eventTarget.isConnected) $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(eventTarget);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $97317328b6cdbf62$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(function() {
        $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$cleanupDetachedElements();
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $97317328b6cdbf62$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9134fa2a0acdb388$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(element);
    var activeElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument);
    if ((0, $33b4709e5e6e943f$export$630ff653c5ada6a9)() === 'virtual') {
        var lastFocusedElement = activeElement;
        (0, $97317328b6cdbf62$export$24490316f764c430)(function() {
            // If focus did not move and the element is still in the document, focus it.
            if ((0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument) === lastFocusedElement && element.isConnected) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(element);
        });
    } else (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(element);
}




var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $5ae8d92fff8cd693$export$f8168d8dd8fd66e6(props) {
    var isDisabled = props.isDisabled, onFocusProp = props.onFocus, onBlurProp = props.onBlur, onFocusChange = props.onFocusChange;
    var onBlur = (0, $ggE0n.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    var onSyntheticFocus = (0, $a9e9d769f7a52024$export$715c682d09d639cc)(onBlur);
    var onFocus = (0, $ggE0n.useCallback)(function(e) {
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(e.target);
        var activeElement = ownerDocument ? (0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument) : (0, $3b911e3383514511$export$cd4e5573fbe2b576)();
        if (e.target === e.currentTarget && activeElement === (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent)) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $2QPpE = parcelRequire("2QPpE");

function $7dabec0f4770a84c$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    var shouldStopPropagation = true;
    return function(e) {
        var event = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, e), {
            preventDefault: function() {
                e.preventDefault();
            },
            isDefaultPrevented: function() {
                return e.isDefaultPrevented();
            },
            stopPropagation: function() {
                shouldStopPropagation = true;
            },
            continuePropagation: function() {
                shouldStopPropagation = false;
            },
            isPropagationStopped: function() {
                return shouldStopPropagation;
            }
        });
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $34773c96e36fc8c5$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $7dabec0f4770a84c$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $7dabec0f4770a84c$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3b77abc8798b57d4$export$4debdb1a3f0fa79e(context, ref) {
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return function() {
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $61b10cd69c787297$export$f9762fab77588ecb = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext(null);
function $61b10cd69c787297$var$$f645667febf57a63$var$useFocusableContext(ref) {
    var context = (0, $ggE0n.useContext)($61b10cd69c787297$export$f9762fab77588ecb) || {};
    (0, $3b77abc8798b57d4$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    var _ = context.ref, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(context, [
        "ref"
    ]);
    return otherProps;
}
var $61b10cd69c787297$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).forwardRef(function FocusableProvider(props, ref) {
    var children = props.children, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "children"
    ]);
    var objRef = (0, $c25977d36d6c3204$export$4338b53315abf666)(ref);
    var context = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        ref: objRef
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($61b10cd69c787297$export$f9762fab77588ecb.Provider, {
        value: context
    }, children);
});
function $61b10cd69c787297$export$4c014de7c8940b4c(props, domRef) {
    var _$a1ea59d68270f0dd$export$f8168d8dd8fd66e6 = (0, $5ae8d92fff8cd693$export$f8168d8dd8fd66e6)(props), focusProps = _$a1ea59d68270f0dd$export$f8168d8dd8fd66e6.focusProps;
    var _$46d819fcbaf35654$export$8f71654801c2f7cd = (0, $34773c96e36fc8c5$export$8f71654801c2f7cd)(props), keyboardProps = _$46d819fcbaf35654$export$8f71654801c2f7cd.keyboardProps;
    var interactions = (0, $850b305c152381bf$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    var domProps = $61b10cd69c787297$var$$f645667febf57a63$var$useFocusableContext(domRef);
    var interactionProps = props.isDisabled ? {} : domProps;
    var autoFocusRef = (0, $ggE0n.useRef)(props.autoFocus);
    (0, $ggE0n.useEffect)(function() {
        if (autoFocusRef.current && domRef.current) (0, $9134fa2a0acdb388$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    // Always set a tabIndex so that Safari allows focusing native buttons and inputs.
    var tabIndex = props.excludeFromTabOrder ? -1 : 0;
    if (props.isDisabled) tabIndex = undefined;
    return {
        focusableProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, interactions), {
            tabIndex: tabIndex
        }), interactionProps)
    };
}
var $61b10cd69c787297$export$35a3bebf7ef2d934 = (0, $ggE0n.forwardRef)(function(_param, ref) {
    var children = _param.children, props = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_param, [
        "children"
    ]);
    ref = (0, $c25977d36d6c3204$export$4338b53315abf666)(ref);
    var _$f645667febf57a63$export$4c014de7c8940b4c = $61b10cd69c787297$export$4c014de7c8940b4c(props, ref), focusableProps = _$f645667febf57a63$export$4c014de7c8940b4c.focusableProps;
    var child = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Children.only(children);
    (0, $ggE0n.useEffect)(function() {
        return;
    }, [
        ref,
        props.isDisabled
    ]);
    // @ts-ignore
    var childRef = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).version, 10) < 19 ? child.ref : child.props.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).cloneElement(child, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)(focusableProps, child.props)), {
        // @ts-ignore
        ref: (0, $c90706a3f6fff521$export$c9058316764c140e)(childRef, ref)
    }));
});


var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $3Hxpr = parcelRequire("3Hxpr");




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
var $8a556ecdb074077a$var$$14c0b72509d70225$var$state = 'default';
var $8a556ecdb074077a$var$$14c0b72509d70225$var$savedUserSelect = '';
var $8a556ecdb074077a$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $8a556ecdb074077a$export$16a4697467175487(target) {
    if ((0, $ccce5714e9b7278a$export$fedb369cb70207f1)()) {
        if ($8a556ecdb074077a$var$$14c0b72509d70225$var$state === 'default') {
            var documentObject = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(target);
            $8a556ecdb074077a$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = 'none';
        }
        $8a556ecdb074077a$var$$14c0b72509d70225$var$state = 'disabled';
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        var property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
        $8a556ecdb074077a$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style[property]);
        target.style[property] = 'none';
    }
}
function $8a556ecdb074077a$export$b0d6fa1ab32e3295(target) {
    if ((0, $ccce5714e9b7278a$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($8a556ecdb074077a$var$$14c0b72509d70225$var$state !== 'disabled') return;
        $8a556ecdb074077a$var$$14c0b72509d70225$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(function() {
            (0, $97317328b6cdbf62$export$24490316f764c430)(function() {
                // Avoid race conditions
                if ($8a556ecdb074077a$var$$14c0b72509d70225$var$state === 'restoring') {
                    var documentObject = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === 'none') documentObject.documentElement.style.webkitUserSelect = $8a556ecdb074077a$var$$14c0b72509d70225$var$savedUserSelect || '';
                    $8a556ecdb074077a$var$$14c0b72509d70225$var$savedUserSelect = '';
                    $8a556ecdb074077a$var$$14c0b72509d70225$var$state = 'default';
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $8a556ecdb074077a$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            var targetOldUserSelect = $8a556ecdb074077a$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            var property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
            if (target.style[property] === 'none') target.style[property] = targetOldUserSelect;
            if (target.getAttribute('style') === '') target.removeAttribute('style');
            $8a556ecdb074077a$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $713e48b6846d0b14$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext({
    register: function() {}
});
$713e48b6846d0b14$export$5165eccb35aaadb5.displayName = 'PressResponderContext';


function $0c74f27332d0fa9f$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $06da3a589453089e$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $0eb939add8aa0722$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $06da3a589453089e$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $0c74f27332d0fa9f$export$71511d61b312f219)(receiver, descriptor);
}


function $bfde233c9d67a552$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $7caec834217ccce9$export$71511d61b312f219(obj, privateMap, value) {
    (0, $bfde233c9d67a552$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $e8bc283af1956fc3$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $8843e553c5a92965$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $06da3a589453089e$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $e8bc283af1956fc3$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e863324b7200d517$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $ggE0n.createContext)({
    isNative: true,
    open: $e863324b7200d517$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: function(href) {
        return href;
    }
});
function $e863324b7200d517$export$323e4fc2fa4753fb(props) {
    var children = props.children, navigate = props.navigate, useHref = props.useHref;
    var ctx = (0, $ggE0n.useMemo)(function() {
        return {
            isNative: false,
            open: function(target, modifiers, href, routerOptions) {
                $e863324b7200d517$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, function(link) {
                    if ($e863324b7200d517$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $e863324b7200d517$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || function(href) {
                return href;
            }
        };
    }, [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($e863324b7200d517$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $e863324b7200d517$export$9a302a45f65d0572() {
    return (0, $ggE0n.useContext)($e863324b7200d517$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $e863324b7200d517$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    var target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $e863324b7200d517$export$95185d699e05d4d7(target, modifiers) {
    var setOpening = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var _window_event_type, _window_event;
    var metaKey = modifiers.metaKey, ctrlKey = modifiers.ctrlKey, altKey = modifiers.altKey, shiftKey = modifiers.shiftKey;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $ccce5714e9b7278a$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith('key')) && target.target === '_blank') {
        if ((0, $ccce5714e9b7278a$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    var event = (0, $ccce5714e9b7278a$export$78551043582a6a98)() && (0, $ccce5714e9b7278a$export$9ac100e40613ea10)() && !(0, $ccce5714e9b7278a$export$7bef049ce92e4224)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $e863324b7200d517$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $e863324b7200d517$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$e863324b7200d517$export$95185d699e05d4d7.isOpening = false;
function $e863324b7200d517$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        var link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $e863324b7200d517$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $e863324b7200d517$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, function(link) {
        return $e863324b7200d517$export$95185d699e05d4d7(link, modifiers);
    });
}
function $e863324b7200d517$export$bdc77b0c0a3a85d6(props) {
    var router = $e863324b7200d517$export$9a302a45f65d0572();
    var _props_href;
    var href = router.useHref((_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $e863324b7200d517$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $e863324b7200d517$export$7e924b3091a3bd18(props) {
    var router = $e863324b7200d517$export$9a302a45f65d0572();
    var _props_href;
    var href = router.useHref((_props_href = props === null || props === void 0 ? void 0 : props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? href : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}


var $90NkU = parcelRequire("90NkU");

var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $af8e150eb57cc5a4$export$4eaf04e54aa8eed6() {
    var globalListeners = (0, $ggE0n.useRef)(new Map());
    var addGlobalListener = (0, $ggE0n.useCallback)(function(eventTarget, type, listener, options) {
        // Make sure we remove the listener after it is called with the `once` option.
        var fn = (options === null || options === void 0 ? void 0 : options.once) ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            globalListeners.current.delete(listener);
            listener.apply(void 0, (0, $90NkU._)(args));
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    var removeGlobalListener = (0, $ggE0n.useCallback)(function(eventTarget, type, listener, options) {
        var _globalListeners_current_get;
        var fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    var removeAllGlobalListeners = (0, $ggE0n.useCallback)(function() {
        globalListeners.current.forEach(function(value, key) {
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $ggE0n.useEffect)(function() {
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


parcelRequire("3og2D");

var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    var context = (0, $ggE0n.useContext)((0, $713e48b6846d0b14$export$5165eccb35aaadb5));
    if (context) {
        var register = context.register, contextProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(context, [
            "register"
        ]);
        props = (0, $850b305c152381bf$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $3b77abc8798b57d4$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $741a5668c6acdbac$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
var $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PressEvent = /*#__PURE__*/ function() {
    "use strict";
    function $f6c31cce2adf654f$var$PressEvent(type, pointerType, originalEvent, state) {
        (0, $gpEpt._)(this, $f6c31cce2adf654f$var$PressEvent);
        (0, $7caec834217ccce9$export$71511d61b312f219)(this, $741a5668c6acdbac$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $8843e553c5a92965$export$71511d61b312f219)(this, $741a5668c6acdbac$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        var _state_target;
        var currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
        var rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
        var x, y = 0;
        var clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
    }
    (0, $eOJ9o._)($f6c31cce2adf654f$var$PressEvent, [
        {
            key: "continuePropagation",
            value: function continuePropagation() {
                (0, $8843e553c5a92965$export$71511d61b312f219)(this, $741a5668c6acdbac$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
            }
        },
        {
            key: "shouldStopPropagation",
            get: function get() {
                return (0, $0eb939add8aa0722$export$71511d61b312f219)(this, $741a5668c6acdbac$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
            }
        }
    ]);
    return $f6c31cce2adf654f$var$PressEvent;
}();
var $741a5668c6acdbac$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol('linkClicked');
var $741a5668c6acdbac$var$$f6c31cce2adf654f$var$STYLE_ID = 'react-aria-pressable-style';
var $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE = 'data-react-aria-pressable';
function $741a5668c6acdbac$export$45712eceda6fad21(props) {
    var _$f6c31cce2adf654f$var$usePressResponderContext = $741a5668c6acdbac$var$$f6c31cce2adf654f$var$usePressResponderContext(props), onPress = _$f6c31cce2adf654f$var$usePressResponderContext.onPress, onPressChange = _$f6c31cce2adf654f$var$usePressResponderContext.onPressChange, onPressStart = _$f6c31cce2adf654f$var$usePressResponderContext.onPressStart, onPressEnd = _$f6c31cce2adf654f$var$usePressResponderContext.onPressEnd, onPressUp = _$f6c31cce2adf654f$var$usePressResponderContext.onPressUp, onClick = _$f6c31cce2adf654f$var$usePressResponderContext.onClick, isDisabled = _$f6c31cce2adf654f$var$usePressResponderContext.isDisabled, isPressedProp = _$f6c31cce2adf654f$var$usePressResponderContext.isPressed, preventFocusOnPress = _$f6c31cce2adf654f$var$usePressResponderContext.preventFocusOnPress, shouldCancelOnPointerExit = _$f6c31cce2adf654f$var$usePressResponderContext.shouldCancelOnPointerExit, allowTextSelectionOnPress = _$f6c31cce2adf654f$var$usePressResponderContext.allowTextSelectionOnPress, domRef = _$f6c31cce2adf654f$var$usePressResponderContext.ref, domProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$f6c31cce2adf654f$var$usePressResponderContext, [
        "onPress",
        "onPressChange",
        "onPressStart",
        "onPressEnd",
        "onPressUp",
        "onClick",
        "isDisabled",
        "isPressed",
        "preventFocusOnPress",
        "shouldCancelOnPointerExit",
        "allowTextSelectionOnPress",
        "ref"
    ]);
    var _$7mdmh$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isPressed = _$7mdmh$useState[0], setPressed = _$7mdmh$useState[1];
    var ref = (0, $ggE0n.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null,
        disposables: []
    });
    var _$7mdmh$useGlobalListeners = (0, $af8e150eb57cc5a4$export$4eaf04e54aa8eed6)(), addGlobalListener = _$7mdmh$useGlobalListeners.addGlobalListener, removeAllGlobalListeners = _$7mdmh$useGlobalListeners.removeAllGlobalListeners;
    var triggerPressStart = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(originalEvent, pointerType) {
        var state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        var shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            var event = new $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PressEvent('pressstart', pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    var triggerPressEnd = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(originalEvent, pointerType) {
        var wasPressed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var state = ref.current;
        if (!state.didFirePressStart) return false;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        var shouldStopPropagation = true;
        if (onPressEnd) {
            var event = new $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PressEvent('pressend', pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            var event1 = new $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PressEvent('press', pointerType, originalEvent);
            onPress(event1);
            shouldStopPropagation && (shouldStopPropagation = event1.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    var triggerPressUp = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(originalEvent, pointerType) {
        var state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            var event = new $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PressEvent('pressup', pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    var cancel = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        var state = ref.current;
        if (state.isPressed && state.target) {
            if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $8a556ecdb074077a$export$b0d6fa1ab32e3295)(state.target);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = state.disposables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var dispose = _step.value;
                    dispose();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            state.disposables = [];
        }
    });
    var cancelOnPointerExit = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        if (shouldCancelOnPointerExit) cancel(e);
    });
    var triggerClick = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        onClick === null || onClick === void 0 || onClick(e);
    });
    var triggerSyntheticClick = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e, target) {
        // Some third-party libraries pass in onClick instead of onPress.
        // Create a fake mouse event and trigger onClick as well.
        // This matches the browser's native activation behavior for certain elements (e.g. button).
        // https://html.spec.whatwg.org/#activation
        // https://html.spec.whatwg.org/#fire-a-synthetic-pointer-event
        if (onClick) {
            var event = new MouseEvent('click', e);
            (0, $a9e9d769f7a52024$export$c2b7abe5d61ec696)(event, target);
            onClick((0, $a9e9d769f7a52024$export$525bc4921d56d4a)(event));
        }
    });
    var pressProps = (0, $ggE0n.useMemo)(function() {
        var state = ref.current;
        var pressProps = {
            onKeyDown: function(e) {
                if ($741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && (0, $3b911e3383514511$export$4282f70798064fe0)(e.currentTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent))) {
                    var _state_metaKeyEvents;
                    if ($741a5668c6acdbac$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard((0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent), e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    var shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        state.pointerType = 'keyboard';
                        shouldStopPropagation = triggerPressStart(e, 'keyboard');
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        var originalTarget = e.currentTarget;
                        var pressUp = function(e) {
                            if ($741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && (0, $3b911e3383514511$export$4282f70798064fe0)(originalTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e)) && state.target) triggerPressUp($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard');
                        };
                        addGlobalListener((0, $435fb34f0a5eae0b$export$b204af158042fbac)(e.currentTarget), 'keyup', (0, $8deb5a1aa1f00721$export$e08e3b67e392101e)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $ccce5714e9b7278a$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === 'Meta') state.metaKeyEvents = new Map();
            },
            onClick: function(e) {
                if (e && !(0, $3b911e3383514511$export$4282f70798064fe0)(e.currentTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $e863324b7200d517$export$95185d699e05d4d7).isOpening) {
                    var shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === 'virtual' || (0, $32af1881d810b59b$export$60278871457622de)(e.nativeEvent))) {
                        var stopPressStart = triggerPressStart(e, 'virtual');
                        var stopPressUp = triggerPressUp(e, 'virtual');
                        var stopPressEnd = triggerPressEnd(e, 'virtual');
                        triggerClick(e);
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    } else if (state.isPressed && state.pointerType !== 'keyboard') {
                        var pointerType = state.pointerType || e.nativeEvent.pointerType || 'virtual';
                        var stopPressUp1 = triggerPressUp($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(e.currentTarget, e), pointerType);
                        var stopPressEnd1 = triggerPressEnd($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(e.currentTarget, e), pointerType, true);
                        shouldStopPropagation = stopPressUp1 && stopPressEnd1;
                        state.isOverTarget = false;
                        triggerClick(e);
                        cancel(e);
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        var onKeyUp = function(e) {
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($741a5668c6acdbac$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard((0, $3b911e3383514511$export$e58f029f0fbfdb29)(e), e.key)) e.preventDefault();
                var target = (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e);
                var wasPressed = (0, $3b911e3383514511$export$4282f70798064fe0)(state.target, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e));
                triggerPressEnd($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard', wasPressed);
                if (wasPressed) triggerSyntheticClick(e, state.target);
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== 'Enter' && $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && (0, $3b911e3383514511$export$4282f70798064fe0)(state.target, target) && !e[$741a5668c6acdbac$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$741a5668c6acdbac$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $e863324b7200d517$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === 'Meta' && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                var events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = events.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var event = _step.value;
                        (_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent('keyup', event));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = function(e) {
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !(0, $3b911e3383514511$export$4282f70798064fe0)(e.currentTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $32af1881d810b59b$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                state.pointerType = e.pointerType;
                var shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!allowTextSelectionOnPress) (0, $8a556ecdb074077a$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    // Release pointer capture so that touch interactions can leave the original target.
                    // This enables onPointerLeave and onPointerEnter to fire.
                    var target = (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent);
                    if ('releasePointerCapture' in target) target.releasePointerCapture(e.pointerId);
                    addGlobalListener((0, $435fb34f0a5eae0b$export$b204af158042fbac)(e.currentTarget), 'pointerup', onPointerUp, false);
                    addGlobalListener((0, $435fb34f0a5eae0b$export$b204af158042fbac)(e.currentTarget), 'pointercancel', onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = function(e) {
                if (!(0, $3b911e3383514511$export$4282f70798064fe0)(e.currentTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                if (e.button === 0) {
                    if (preventFocusOnPress) {
                        var dispose = (0, $a9e9d769f7a52024$export$cabe61c495ee3649)(e.target);
                        if (dispose) state.disposables.push(dispose);
                    }
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = function(e) {
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!(0, $3b911e3383514511$export$4282f70798064fe0)(e.currentTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent)) || state.pointerType === 'virtual') return;
                // Only handle left clicks. If isPressed is true, delay until onClick.
                if (e.button === 0 && !state.isPressed) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            pressProps.onPointerEnter = function(e) {
                if (e.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = true;
                    triggerPressStart($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                }
            };
            pressProps.onPointerLeave = function(e) {
                if (e.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            var onPointerUp = function(e) {
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ((0, $3b911e3383514511$export$4282f70798064fe0)(state.target, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e)) && state.pointerType != null) {
                        // Wait for onClick to fire onPress. This avoids browser issues when the DOM
                        // is mutated between onPointerUp and onClick, and is more compatible with third party libraries.
                        // https://github.com/adobe/react-spectrum/issues/1513
                        // https://issues.chromium.org/issues/40732224
                        // However, iOS and Android do not focus or fire onClick after a long press.
                        // We work around this by triggering a click ourselves after a timeout.
                        // This timeout is canceled during the click event in case the real one fires first.
                        // The timeout must be at least 32ms, because Safari on iOS delays the click event on
                        // non-form elements without certain ARIA roles (for hover emulation).
                        // https://github.com/WebKit/WebKit/blob/dccfae42bb29bd4bdef052e469f604a9387241c0/Source/WebKit/WebProcess/WebPage/ios/WebPageIOS.mm#L875-L892
                        var clicked = false;
                        var timeout = setTimeout(function() {
                            if (state.isPressed && state.target instanceof HTMLElement) {
                                if (clicked) cancel(e);
                                else {
                                    (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(state.target);
                                    state.target.click();
                                }
                            }
                        }, 80);
                        // Use a capturing listener to track if a click occurred.
                        // If stopPropagation is called it may never reach our handler.
                        addGlobalListener(e.currentTarget, 'click', function() {
                            return clicked = true;
                        }, true);
                        state.disposables.push(function() {
                            return clearTimeout(timeout);
                        });
                    } else cancel(e);
                    // Ignore subsequent onPointerLeave event before onClick on touch devices.
                    state.isOverTarget = false;
                }
            };
            var onPointerCancel = function(e) {
                cancel(e);
            };
            pressProps.onDragStart = function(e) {
                if (!(0, $3b911e3383514511$export$4282f70798064fe0)(e.currentTarget, (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else var e, e1, e2, e3, e4, e5, e6, e7, e8;
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp,
        triggerClick,
        triggerSyntheticClick
    ]);
    (0, $ggE0n.useEffect)(function() {
        if (!domRef || false) return;
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(domRef.current);
        if (!ownerDocument || !ownerDocument.head || ownerDocument.getElementById($741a5668c6acdbac$var$$f6c31cce2adf654f$var$STYLE_ID)) return;
        var style = ownerDocument.createElement('style');
        style.id = $741a5668c6acdbac$var$$f6c31cce2adf654f$var$STYLE_ID;
        // touchAction: 'manipulation' is supposed to be equivalent, but in
        // Safari it causes onPointerCancel not to fire on scroll.
        // https://bugs.webkit.org/show_bug.cgi?id=240917
        style.textContent = "\n@layer {\n  [".concat($741a5668c6acdbac$var$$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE, "] {\n    touch-action: pan-x pan-y pinch-zoom;\n  }\n}\n    ").trim();
        ownerDocument.head.prepend(style);
    }, [
        domRef
    ]);
    (0, $ggE0n.useEffect)(function() {
        var state = ref.current;
        return function() {
            var _state_target;
            if (!allowTextSelectionOnPress) (0, $8a556ecdb074077a$export$b0d6fa1ab32e3295)((_state_target = state.target) !== null && _state_target !== void 0 ? _state_target : undefined);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = state.disposables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var dispose = _step.value;
                    dispose();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            state.disposables = [];
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, pressProps, (0, $3Hxpr._)({}, $741a5668c6acdbac$var$$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE, true))
    };
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    var key = event.key, code = event.code;
    var element = currentTarget;
    var role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(element).HTMLInputElement && !$741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === 'link' || !role && $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== 'Enter');
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    var targetTouches = event.targetTouches;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    var changedTouches = event.changedTouches;
    for(var i = 0; i < changedTouches.length; i++){
        var touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$createTouchEvent(target, e) {
    var clientX = 0;
    var clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    var clientX = e.clientX;
    var clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    var offsetX = 0;
    var offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    var rect = target.getBoundingClientRect();
    var pointRect = $741a5668c6acdbac$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $741a5668c6acdbac$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(target) {
    if (target instanceof HTMLInputElement) return false;
    if (target instanceof HTMLButtonElement) return target.type !== 'submit' && target.type !== 'reset';
    if ($741a5668c6acdbac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    return $741a5668c6acdbac$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(target);
}
var $741a5668c6acdbac$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $741a5668c6acdbac$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $741a5668c6acdbac$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $80defd8d9879a189$export$ea18c227d4417cc3(props, ref) {
    var tmp = props.elementType, elementType = tmp === void 0 ? 'button' : tmp, isDisabled = props.isDisabled, onPress = props.onPress, onPressStart = props.onPressStart, onPressEnd = props.onPressEnd, onPressUp = props.onPressUp, onPressChange = props.onPressChange, preventFocusOnPress = props.preventFocusOnPress, allowFocusWhenDisabled = props.allowFocusWhenDisabled, onClick = props.onClick, href = props.href, target = props.target, rel = props.rel, tmp1 = props.type, type = tmp1 === void 0 ? 'button' : tmp1;
    var additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: 'button',
        href: elementType === 'a' && !isDisabled ? href : undefined,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    var _$bwqiF$usePress = (0, $741a5668c6acdbac$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    }), pressProps = _$bwqiF$usePress.pressProps, isPressed = _$bwqiF$usePress.isPressed;
    var _$bwqiF$useFocusable = (0, $61b10cd69c787297$export$4c014de7c8940b4c)(props, ref), focusableProps = _$bwqiF$useFocusable.focusableProps;
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    var buttonProps = (0, $850b305c152381bf$export$9d1611c77c2fe928)(focusableProps, pressProps, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            'aria-current': props['aria-current']
        })
    };
}




var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $2d409168e187362c$export$420e68273165f4ec(props) {
    var isDisabled = props.isDisabled, onBlurWithin = props.onBlurWithin, onFocusWithin = props.onFocusWithin, onFocusWithinChange = props.onFocusWithinChange;
    var state = (0, $ggE0n.useRef)({
        isFocusWithin: false
    });
    var _$3b9Q0$useGlobalListeners = (0, $af8e150eb57cc5a4$export$4eaf04e54aa8eed6)(), addGlobalListener = _$3b9Q0$useGlobalListeners.addGlobalListener, removeAllGlobalListeners = _$3b9Q0$useGlobalListeners.removeAllGlobalListeners;
    var onBlur = (0, $ggE0n.useCallback)(function(e) {
        // Ignore events bubbling through portals.
        if (!e.currentTarget.contains(e.target)) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    var onSyntheticFocus = (0, $a9e9d769f7a52024$export$715c682d09d639cc)(onBlur);
    var onFocus = (0, $ggE0n.useCallback)(function(e) {
        // Ignore events bubbling through portals.
        if (!e.currentTarget.contains(e.target)) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(e.target);
        var activeElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e.nativeEvent)) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            var currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', function(e) {
                if (state.current.isFocusWithin && !(0, $3b911e3383514511$export$4282f70798064fe0)(currentTarget, e.target)) {
                    var nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: e.target
                    });
                    (0, $a9e9d769f7a52024$export$c2b7abe5d61ec696)(nativeEvent, currentTarget);
                    var event = (0, $a9e9d769f7a52024$export$525bc4921d56d4a)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $ggE0n = parcelRequire("ggE0n");
function $0d787cea72c4b240$export$4e328f61c538687f() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = props.autoFocus, autoFocus = tmp === void 0 ? false : tmp, isTextInput = props.isTextInput, within = props.within;
    var state = (0, $ggE0n.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $33b4709e5e6e943f$export$b9b3dfddab17db27)()
    });
    var _$isWE5$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isFocused = _$isWE5$useState[0], setFocused = _$isWE5$useState[1];
    var _$isWE5$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        return state.current.isFocused && state.current.isFocusVisible;
    }), 2), isFocusVisibleState = _$isWE5$useState1[0], setFocusVisible = _$isWE5$useState1[1];
    var updateState = (0, $ggE0n.useCallback)(function() {
        return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
    }, []);
    var onFocusChange = (0, $ggE0n.useCallback)(function(isFocused) {
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $33b4709e5e6e943f$export$ec71b4b83ac08ec3)(function(isFocusVisible) {
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    var _$isWE5$useFocus = (0, $5ae8d92fff8cd693$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    }), focusProps = _$isWE5$useFocus.focusProps;
    var _$isWE5$useFocusWithin = (0, $2d409168e187362c$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    }), focusWithinProps = _$isWE5$useFocusWithin.focusWithinProps;
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
var $b825a66cb81adbfc$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
var $b825a66cb81adbfc$var$$6179b936705e76d3$var$hoverCount = 0;
function $b825a66cb81adbfc$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $b825a66cb81adbfc$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(function() {
        $b825a66cb81adbfc$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $b825a66cb81adbfc$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $b825a66cb81adbfc$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $b825a66cb81adbfc$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $b825a66cb81adbfc$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    $b825a66cb81adbfc$var$$6179b936705e76d3$var$hoverCount++;
    return function() {
        $b825a66cb81adbfc$var$$6179b936705e76d3$var$hoverCount--;
        if ($b825a66cb81adbfc$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $b825a66cb81adbfc$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    };
}
function $b825a66cb81adbfc$export$ae780daf29e6d456(props) {
    var onHoverStart = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, isDisabled = props.isDisabled;
    var _$AWxnT$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isHovered = _$AWxnT$useState[0], setHovered = _$AWxnT$useState[1];
    var state = (0, $ggE0n.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $ggE0n.useEffect)($b825a66cb81adbfc$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    var _$AWxnT$useGlobalListeners = (0, $af8e150eb57cc5a4$export$4eaf04e54aa8eed6)(), addGlobalListener = _$AWxnT$useGlobalListeners.addGlobalListener, removeAllGlobalListeners = _$AWxnT$useGlobalListeners.removeAllGlobalListeners;
    var _$AWxnT$useMemo = (0, $ggE0n.useMemo)(function() {
        var triggerHoverStart = function(event, pointerType) {
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            var target = event.currentTarget;
            state.target = target;
            // When an element that is hovered over is removed, no pointerleave event is fired by the browser,
            // even though the originally hovered target may have shrunk in size so it is no longer hovered.
            // However, a pointerover event will be fired on the new target the mouse is over.
            // In Chrome this happens immediately. In Safari and Firefox, it happens upon moving the mouse one pixel.
            addGlobalListener((0, $435fb34f0a5eae0b$export$b204af158042fbac)(event.target), 'pointerover', function(e) {
                if (state.isHovered && state.target && !(0, $3b911e3383514511$export$4282f70798064fe0)(state.target, e.target)) triggerHoverEnd(e, e.pointerType);
            }, {
                capture: true
            });
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        var triggerHoverEnd = function(event, pointerType) {
            var target = state.target;
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered || !target) return;
            state.isHovered = false;
            removeAllGlobalListeners();
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        var hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = function(e) {
                if ($b825a66cb81adbfc$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = function(e) {
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else var e, e1;
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state,
        addGlobalListener,
        removeAllGlobalListeners
    ]), hoverProps = _$AWxnT$useMemo.hoverProps, triggerHoverEnd = _$AWxnT$useMemo.triggerHoverEnd;
    (0, $ggE0n.useEffect)(function() {
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $28c5f096242aff4d$var$$d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes = new Set([
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'name',
    'value'
]);
var $28c5f096242aff4d$export$24d547caef80ccd1 = (0, $ggE0n.createContext)({});
var $28c5f096242aff4d$export$353f5b6fc5456de1 = (0, $cfc4721022845f0c$export$86427a43e3e48ebb)(function Button(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $28c5f096242aff4d$export$24d547caef80ccd1), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    props = $28c5f096242aff4d$var$$d2b4bc8c273e7be6$var$disablePendingProps(props);
    var ctx = props;
    var isPending = ctx.isPending;
    var _$fM325$useButton = (0, $80defd8d9879a189$export$ea18c227d4417cc3)(props, ref), buttonProps = _$fM325$useButton.buttonProps, isPressed = _$fM325$useButton.isPressed;
    var _$fM325$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)(props), focusProps = _$fM325$useFocusRing.focusProps, isFocused = _$fM325$useFocusRing.isFocused, isFocusVisible = _$fM325$useFocusRing.isFocusVisible;
    var _$fM325$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        isDisabled: props.isDisabled || isPending
    })), hoverProps = _$fM325$useHover.hoverProps, isHovered = _$fM325$useHover.isHovered;
    var renderValues = {
        isHovered: isHovered,
        isPressed: (ctx.isPressed || isPressed) && !isPending,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: props.isDisabled || false,
        isPending: isPending !== null && isPending !== void 0 ? isPending : false
    };
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: renderValues,
        defaultClassName: 'react-aria-Button'
    }));
    var buttonId = (0, $7fc455d18519c289$export$f680877a34711e37)(buttonProps.id);
    var progressId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var ariaLabelledby = buttonProps['aria-labelledby'];
    if (isPending) {
        // aria-labelledby wins over aria-label
        // https://www.w3.org/TR/accname-1.2/#computation-steps
        if (ariaLabelledby) ariaLabelledby = "".concat(ariaLabelledby, " ").concat(progressId);
        else if (buttonProps['aria-label']) ariaLabelledby = "".concat(buttonId, " ").concat(progressId);
    }
    var wasPending = (0, $ggE0n.useRef)(isPending);
    (0, $ggE0n.useEffect)(function() {
        var message = {
            'aria-labelledby': ariaLabelledby || buttonId
        };
        if (!wasPending.current && isFocused && isPending) (0, $e7c771ec74591764$export$a9b970dcc4ae71a9)(message, 'assertive');
        else if (wasPending.current && isFocused && !isPending) (0, $e7c771ec74591764$export$a9b970dcc4ae71a9)(message, 'assertive');
        wasPending.current = isPending;
    }, [
        isPending,
        isFocused,
        ariaLabelledby,
        buttonId
    ]);
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("button", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
        propNames: $28c5f096242aff4d$var$$d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes
    }), (0, $850b305c152381bf$export$9d1611c77c2fe928)(buttonProps, focusProps, hoverProps), renderProps), {
        type: buttonProps.type === 'submit' && isPending ? 'button' : buttonProps.type,
        id: buttonId,
        ref: ref,
        "aria-labelledby": ariaLabelledby,
        slot: props.slot || undefined,
        "aria-disabled": isPending ? 'true' : buttonProps['aria-disabled'],
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": renderValues.isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-pending": isPending || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $0fdb024d56a6a9b7$export$e9f3bf65a26ce129).Provider, {
        value: {
            id: progressId
        }
    }, renderProps.children));
});
function $28c5f096242aff4d$var$$d2b4bc8c273e7be6$var$disablePendingProps(props) {
    // Don't allow interaction while isPending is true
    if (props.isPending) {
        props.onPress = undefined;
        props.onPressStart = undefined;
        props.onPressEnd = undefined;
        props.onPressChange = undefined;
        props.onPressUp = undefined;
        props.onKeyDown = undefined;
        props.onKeyUp = undefined;
        props.onClick = undefined;
        props.href = undefined;
    }
    return props;
}


var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $0669a7cc0abfc405$export$b085522c77523c51 = (0, $ggE0n.createContext)(null);
var $0669a7cc0abfc405$export$ebe63fadcdce34ed = (0, $ggE0n.createContext)(null);
var $0669a7cc0abfc405$export$44644b8a16031b5b = (0, $ggE0n.createContext)(null);
var $0669a7cc0abfc405$export$717b2c0a523a0b53 = (0, $ggE0n.createContext)(null);
var $0669a7cc0abfc405$export$265015d6dc85bf21 = (0, $ggE0n.createContext)(null);
var $0669a7cc0abfc405$export$d688439359537581 = (0, $ggE0n.createContext)({});



var $2QPpE = parcelRequire("2QPpE");





var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8aa3776baa04dfea$export$2de4954e8ae13b9f = (0, $ggE0n.createContext)({
    placement: 'bottom'
});
var $8aa3776baa04dfea$export$746d02f47f4d381 = (0, $ggE0n.forwardRef)(function OverlayArrow(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $8aa3776baa04dfea$export$2de4954e8ae13b9f), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var placement = props.placement;
    var style = {
        position: 'absolute',
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)'
    };
    if (placement != null) style[placement] = '100%';
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        defaultClassName: 'react-aria-OverlayArrow',
        values: {
            placement: placement
        }
    }));
    // remove undefined values from renderProps.style object so that it can be
    // spread merged with the other style object
    if (renderProps.style) Object.keys(renderProps.style).forEach(function(key) {
        return renderProps.style[key] === undefined && delete renderProps.style[key];
    });
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, DOMProps, renderProps), {
        style: (0, $2QPpE._)({}, style, renderProps.style),
        ref: ref,
        "data-placement": placement
    }));
});




var $2QPpE = parcelRequire("2QPpE");


var $bdffeb8deb40af36$export$2e2bcd8739ae039 = {};
$bdffeb8deb40af36$export$2e2bcd8739ae039 = {
    "dismiss": "\u062A\u062C\u0627\u0647\u0644"
};


var $9da9189fa0d0e6b3$export$2e2bcd8739ae039 = {};
$9da9189fa0d0e6b3$export$2e2bcd8739ae039 = {
    "dismiss": "\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435"
};


var $ec6dba5b320488e4$export$2e2bcd8739ae039 = {};
$ec6dba5b320488e4$export$2e2bcd8739ae039 = {
    "dismiss": "Odstranit"
};


var $18c0efefc339b7dc$export$2e2bcd8739ae039 = {};
$18c0efefc339b7dc$export$2e2bcd8739ae039 = {
    "dismiss": "Luk"
};


var $005dd6655878424a$export$2e2bcd8739ae039 = {};
$005dd6655878424a$export$2e2bcd8739ae039 = {
    "dismiss": "Schlie\xdfen"
};


var $9e07615240051b02$export$2e2bcd8739ae039 = {};
$9e07615240051b02$export$2e2bcd8739ae039 = {
    "dismiss": "\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7"
};


var $cceaea3ab6d8c1dd$export$2e2bcd8739ae039 = {};
$cceaea3ab6d8c1dd$export$2e2bcd8739ae039 = {
    "dismiss": "Dismiss"
};


var $2d2364091726fab2$export$2e2bcd8739ae039 = {};
$2d2364091726fab2$export$2e2bcd8739ae039 = {
    "dismiss": "Descartar"
};


var $1b93b4e6153b7acf$export$2e2bcd8739ae039 = {};
$1b93b4e6153b7acf$export$2e2bcd8739ae039 = {
    "dismiss": "L\xf5peta"
};


var $69d086635ff82f70$export$2e2bcd8739ae039 = {};
$69d086635ff82f70$export$2e2bcd8739ae039 = {
    "dismiss": "Hylk\xe4\xe4"
};


var $210a122421c133d8$export$2e2bcd8739ae039 = {};
$210a122421c133d8$export$2e2bcd8739ae039 = {
    "dismiss": "Rejeter"
};


var $0e79072a112b9e25$export$2e2bcd8739ae039 = {};
$0e79072a112b9e25$export$2e2bcd8739ae039 = {
    "dismiss": "\u05D4\u05EA\u05E2\u05DC\u05DD"
};


var $f3eee5d6de398020$export$2e2bcd8739ae039 = {};
$f3eee5d6de398020$export$2e2bcd8739ae039 = {
    "dismiss": "Odbaci"
};


var $66b248d425c2c981$export$2e2bcd8739ae039 = {};
$66b248d425c2c981$export$2e2bcd8739ae039 = {
    "dismiss": "Elutas\xedt\xe1s"
};


var $de38c2fbd99b5361$export$2e2bcd8739ae039 = {};
$de38c2fbd99b5361$export$2e2bcd8739ae039 = {
    "dismiss": "Ignora"
};


var $379c6084ee21f00e$export$2e2bcd8739ae039 = {};
$379c6084ee21f00e$export$2e2bcd8739ae039 = {
    "dismiss": "\u9589\u3058\u308B"
};


var $ffed41d5db587eba$export$2e2bcd8739ae039 = {};
$ffed41d5db587eba$export$2e2bcd8739ae039 = {
    "dismiss": "\uBB34\uC2DC"
};


var $74a6a4acdb979663$export$2e2bcd8739ae039 = {};
$74a6a4acdb979663$export$2e2bcd8739ae039 = {
    "dismiss": "Atmesti"
};


var $8246060cb9c0e0dd$export$2e2bcd8739ae039 = {};
$8246060cb9c0e0dd$export$2e2bcd8739ae039 = {
    "dismiss": "Ner\u0101d\u012Bt"
};


var $9527dcd9fe9ef9d6$export$2e2bcd8739ae039 = {};
$9527dcd9fe9ef9d6$export$2e2bcd8739ae039 = {
    "dismiss": "Lukk"
};


var $a40a5de678a90546$export$2e2bcd8739ae039 = {};
$a40a5de678a90546$export$2e2bcd8739ae039 = {
    "dismiss": "Negeren"
};


var $5b12759521ef0e4a$export$2e2bcd8739ae039 = {};
$5b12759521ef0e4a$export$2e2bcd8739ae039 = {
    "dismiss": "Zignoruj"
};


var $2f6f78f2c9673376$export$2e2bcd8739ae039 = {};
$2f6f78f2c9673376$export$2e2bcd8739ae039 = {
    "dismiss": "Descartar"
};


var $3e5118ff8795e7bb$export$2e2bcd8739ae039 = {};
$3e5118ff8795e7bb$export$2e2bcd8739ae039 = {
    "dismiss": "Dispensar"
};


var $1431e6db03c441bd$export$2e2bcd8739ae039 = {};
$1431e6db03c441bd$export$2e2bcd8739ae039 = {
    "dismiss": "Revocare"
};


var $4beba6f614626e67$export$2e2bcd8739ae039 = {};
$4beba6f614626e67$export$2e2bcd8739ae039 = {
    "dismiss": "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C"
};


var $3777a073836764f3$export$2e2bcd8739ae039 = {};
$3777a073836764f3$export$2e2bcd8739ae039 = {
    "dismiss": "Zru\u0161i\u0165"
};


var $bcf53c478c9e501d$export$2e2bcd8739ae039 = {};
$bcf53c478c9e501d$export$2e2bcd8739ae039 = {
    "dismiss": "Opusti"
};


var $a48cb634dd084f6e$export$2e2bcd8739ae039 = {};
$a48cb634dd084f6e$export$2e2bcd8739ae039 = {
    "dismiss": "Odbaci"
};


var $cc866d44d7311a9d$export$2e2bcd8739ae039 = {};
$cc866d44d7311a9d$export$2e2bcd8739ae039 = {
    "dismiss": "Avvisa"
};


var $528b143b91a21a51$export$2e2bcd8739ae039 = {};
$528b143b91a21a51$export$2e2bcd8739ae039 = {
    "dismiss": "Kapat"
};


var $10551d7c1f5a9e13$export$2e2bcd8739ae039 = {};
$10551d7c1f5a9e13$export$2e2bcd8739ae039 = {
    "dismiss": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
};


var $1af8eff75d00f781$export$2e2bcd8739ae039 = {};
$1af8eff75d00f781$export$2e2bcd8739ae039 = {
    "dismiss": "\u53D6\u6D88"
};


var $7688f1bda31d100f$export$2e2bcd8739ae039 = {};
$7688f1bda31d100f$export$2e2bcd8739ae039 = {
    "dismiss": "\u95DC\u9589"
};


var $f074878a71ddd3a4$export$2e2bcd8739ae039 = {};
$f074878a71ddd3a4$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $bdffeb8deb40af36$export$2e2bcd8739ae039),
    "bg-BG": (0, $9da9189fa0d0e6b3$export$2e2bcd8739ae039),
    "cs-CZ": (0, $ec6dba5b320488e4$export$2e2bcd8739ae039),
    "da-DK": (0, $18c0efefc339b7dc$export$2e2bcd8739ae039),
    "de-DE": (0, $005dd6655878424a$export$2e2bcd8739ae039),
    "el-GR": (0, $9e07615240051b02$export$2e2bcd8739ae039),
    "en-US": (0, $cceaea3ab6d8c1dd$export$2e2bcd8739ae039),
    "es-ES": (0, $2d2364091726fab2$export$2e2bcd8739ae039),
    "et-EE": (0, $1b93b4e6153b7acf$export$2e2bcd8739ae039),
    "fi-FI": (0, $69d086635ff82f70$export$2e2bcd8739ae039),
    "fr-FR": (0, $210a122421c133d8$export$2e2bcd8739ae039),
    "he-IL": (0, $0e79072a112b9e25$export$2e2bcd8739ae039),
    "hr-HR": (0, $f3eee5d6de398020$export$2e2bcd8739ae039),
    "hu-HU": (0, $66b248d425c2c981$export$2e2bcd8739ae039),
    "it-IT": (0, $de38c2fbd99b5361$export$2e2bcd8739ae039),
    "ja-JP": (0, $379c6084ee21f00e$export$2e2bcd8739ae039),
    "ko-KR": (0, $ffed41d5db587eba$export$2e2bcd8739ae039),
    "lt-LT": (0, $74a6a4acdb979663$export$2e2bcd8739ae039),
    "lv-LV": (0, $8246060cb9c0e0dd$export$2e2bcd8739ae039),
    "nb-NO": (0, $9527dcd9fe9ef9d6$export$2e2bcd8739ae039),
    "nl-NL": (0, $a40a5de678a90546$export$2e2bcd8739ae039),
    "pl-PL": (0, $5b12759521ef0e4a$export$2e2bcd8739ae039),
    "pt-BR": (0, $2f6f78f2c9673376$export$2e2bcd8739ae039),
    "pt-PT": (0, $3e5118ff8795e7bb$export$2e2bcd8739ae039),
    "ro-RO": (0, $1431e6db03c441bd$export$2e2bcd8739ae039),
    "ru-RU": (0, $4beba6f614626e67$export$2e2bcd8739ae039),
    "sk-SK": (0, $3777a073836764f3$export$2e2bcd8739ae039),
    "sl-SI": (0, $bcf53c478c9e501d$export$2e2bcd8739ae039),
    "sr-SP": (0, $a48cb634dd084f6e$export$2e2bcd8739ae039),
    "sv-SE": (0, $cc866d44d7311a9d$export$2e2bcd8739ae039),
    "tr-TR": (0, $528b143b91a21a51$export$2e2bcd8739ae039),
    "uk-UA": (0, $10551d7c1f5a9e13$export$2e2bcd8739ae039),
    "zh-CN": (0, $1af8eff75d00f781$export$2e2bcd8739ae039),
    "zh-TW": (0, $7688f1bda31d100f$export$2e2bcd8739ae039)
};



var $ggE0n = parcelRequire("ggE0n");


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $3Hxpr = parcelRequire("3Hxpr");

var $11d7852987212578$var$$5b160d28a433310d$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
var $11d7852987212578$var$$5b160d28a433310d$var$stringsSymbol = Symbol.for('react-aria.i18n.strings');
var $11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings = undefined;
var $11d7852987212578$export$c17fa47878dc55b6 = /*#__PURE__*/ function() {
    "use strict";
    function $5b160d28a433310d$export$c17fa47878dc55b6(messages) {
        var defaultLocale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'en-US';
        (0, $gpEpt._)(this, $5b160d28a433310d$export$c17fa47878dc55b6);
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(function(param) {
            var _param = (0, $c6938abc98c6418f$export$71511d61b312f219)(param, 2), v = _param[1];
            return v;
        }));
        this.defaultLocale = defaultLocale;
    }
    (0, $eOJ9o._)($5b160d28a433310d$export$c17fa47878dc55b6, [
        {
            /** Returns a localized string for the given key and locale. */ key: "getStringForLocale",
            value: function getStringForLocale(key, locale) {
                var strings = this.getStringsForLocale(locale);
                var string = strings[key];
                if (!string) throw new Error("Could not find intl message ".concat(key, " in ").concat(locale, " locale"));
                return string;
            }
        },
        {
            /** Returns all localized strings for the given locale. */ key: "getStringsForLocale",
            value: function getStringsForLocale(locale) {
                var strings = this.strings[locale];
                if (!strings) {
                    strings = $11d7852987212578$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
                    this.strings[locale] = strings;
                }
                return strings;
            }
        }
    ], [
        {
            key: "getGlobalDictionaryForPackage",
            value: function getGlobalDictionaryForPackage(packageName) {
                if (typeof window === 'undefined') return null;
                var locale = window[$11d7852987212578$var$$5b160d28a433310d$var$localeSymbol];
                if ($11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings === undefined) {
                    var globalStrings = window[$11d7852987212578$var$$5b160d28a433310d$var$stringsSymbol];
                    if (!globalStrings) return null;
                    $11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings = {};
                    for(var pkg in globalStrings)$11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $5b160d28a433310d$export$c17fa47878dc55b6((0, $3Hxpr._)({}, locale, globalStrings[pkg]), locale);
                }
                var dictionary = $11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings === null || $11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $11d7852987212578$var$$5b160d28a433310d$var$cachedGlobalStrings[packageName];
                if (!dictionary) throw new Error('Strings for package "'.concat(packageName, '" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.'));
                return dictionary;
            }
        }
    ]);
    return $5b160d28a433310d$export$c17fa47878dc55b6;
}();
function $11d7852987212578$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings) {
    var defaultLocale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'en-US';
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    var language = $11d7852987212578$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(var key in strings){
        if (key.startsWith(language + '-')) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $11d7852987212578$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split('-')[0];
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");
var $8c3c9b101bb1fdda$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
var $8c3c9b101bb1fdda$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
var $8c3c9b101bb1fdda$export$2f817fcdc4b89ae0 = /*#__PURE__*/ function() {
    "use strict";
    function $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale, strings) {
        (0, $gpEpt._)(this, $6db58dc88e78b024$export$2f817fcdc4b89ae0);
        this.locale = locale;
        this.strings = strings;
    }
    (0, $eOJ9o._)($6db58dc88e78b024$export$2f817fcdc4b89ae0, [
        {
            /** Formats a localized string for the given key with the provided variables. */ key: "format",
            value: function format(key, variables) {
                var message = this.strings.getStringForLocale(key, this.locale);
                return typeof message === 'function' ? message(variables, this) : message;
            }
        },
        {
            key: "plural",
            value: function plural(count, options) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'cardinal';
                var opt = options['=' + count];
                if (opt) return typeof opt === 'function' ? opt() : opt;
                var key = this.locale + ':' + type;
                var pluralRules = $8c3c9b101bb1fdda$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
                if (!pluralRules) {
                    pluralRules = new Intl.PluralRules(this.locale, {
                        type: type
                    });
                    $8c3c9b101bb1fdda$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
                }
                var selected = pluralRules.select(count);
                opt = options[selected] || options.other;
                return typeof opt === 'function' ? opt() : opt;
            }
        },
        {
            key: "number",
            value: function number(value) {
                var numberFormat = $8c3c9b101bb1fdda$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
                if (!numberFormat) {
                    numberFormat = new Intl.NumberFormat(this.locale);
                    $8c3c9b101bb1fdda$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
                }
                return numberFormat.format(value);
            }
        },
        {
            key: "select",
            value: function select(options, value) {
                var opt = options[value] || options.other;
                return typeof opt === 'function' ? opt() : opt;
            }
        }
    ]);
    return $6db58dc88e78b024$export$2f817fcdc4b89ae0;
}();



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e3ba67447894b71b$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $e3ba67447894b71b$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    var dictionary = $e3ba67447894b71b$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $11d7852987212578$export$c17fa47878dc55b6)(strings);
        $e3ba67447894b71b$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $e3ba67447894b71b$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $11d7852987212578$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $e3ba67447894b71b$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $e3ba67447894b71b$export$f12b703ca79dfbb1(strings, packageName) {
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    var dictionary = $e3ba67447894b71b$export$87b761675e8eaa10(strings, packageName);
    return (0, $ggE0n.useMemo)(function() {
        return new (0, $8c3c9b101bb1fdda$export$2f817fcdc4b89ae0)(locale, dictionary);
    }, [
        locale,
        dictionary
    ]);
}



var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $1bc22ae41938fdeb$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap'
};
function $1bc22ae41938fdeb$export$a966af930f325cab() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var style = props.style, isFocusable = props.isFocusable;
    var _$7JYt2$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isFocused = _$7JYt2$useState[0], setFocused = _$7JYt2$useState[1];
    var _$7JYt2$useFocusWithin = (0, $2d409168e187362c$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: function(val) {
            return setFocused(val);
        }
    }), focusWithinProps = _$7JYt2$useFocusWithin.focusWithinProps;
    // If focused, don't hide the element.
    var combinedStyles = (0, $ggE0n.useMemo)(function() {
        if (isFocused) return style;
        else if (style) return (0, $2QPpE._)({}, $1bc22ae41938fdeb$var$$5c3e21d68f1c4674$var$styles, style);
        else return $1bc22ae41938fdeb$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, focusWithinProps), {
            style: combinedStyles
        })
    };
}
function $1bc22ae41938fdeb$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var children = props.children, tmp = props.elementType, Element = tmp === void 0 ? 'div' : tmp, isFocusable = props.isFocusable, style = props.style, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "children",
        "elementType",
        "isFocusable",
        "style"
    ]);
    var _$5c3e21d68f1c4674$export$a966af930f325cab = $1bc22ae41938fdeb$export$a966af930f325cab(props), visuallyHiddenProps = _$5c3e21d68f1c4674$export$a966af930f325cab.visuallyHiddenProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Element, (0, $850b305c152381bf$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}


function $07c93e097165d85d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $07c93e097165d85d$export$2317d149ed6f78c4(props) {
    var onDismiss = props.onDismiss, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "onDismiss"
    ]);
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($07c93e097165d85d$var$$parcel$interopDefault((0, $f074878a71ddd3a4$export$2e2bcd8739ae039)), '@react-aria/overlays');
    var labels = (0, $c7019d53357f553d$export$d6875122194c7b44)(otherProps, stringFormatter.format('dismiss'));
    var onClick = function() {
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $1bc22ae41938fdeb$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("button", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labels), {
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    })));
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8f7f03ece6f1e0cd$export$60d741e20e0aa309 = (0, $ggE0n.createContext)({});
function $8f7f03ece6f1e0cd$export$78efe591171d7d45(props) {
    var getContainer = props.getContainer;
    var _$96b38030c423d352$export$9fc1347d4195ccb3 = $8f7f03ece6f1e0cd$export$9fc1347d4195ccb3(), ctxGetContainer = _$96b38030c423d352$export$9fc1347d4195ccb3.getContainer;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($8f7f03ece6f1e0cd$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? undefined : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function $8f7f03ece6f1e0cd$export$9fc1347d4195ccb3() {
    var _useContext;
    return (_useContext = (0, $ggE0n.useContext)($8f7f03ece6f1e0cd$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}



var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f12953e97e637e2a$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).forwardRef(function(_param, ref) {
    var children = _param.children, props = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_param, [
        "children"
    ]);
    var isRegistered = (0, $ggE0n.useRef)(false);
    var prevContext = (0, $ggE0n.useContext)((0, $713e48b6846d0b14$export$5165eccb35aaadb5));
    ref = (0, $c25977d36d6c3204$export$4338b53315abf666)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    var context = (0, $850b305c152381bf$export$9d1611c77c2fe928)(prevContext || {}, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        ref: ref,
        register: function() {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    }));
    (0, $3b77abc8798b57d4$export$4debdb1a3f0fa79e)(prevContext, ref);
    (0, $ggE0n.useEffect)(function() {
        if (!isRegistered.current) isRegistered.current = true; // only warn once in strict mode.
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $713e48b6846d0b14$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
});
function $f12953e97e637e2a$export$cf75428e0b9ed1ea(param) {
    var children = param.children;
    var context = (0, $ggE0n.useMemo)(function() {
        return {
            register: function() {}
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $713e48b6846d0b14$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
}



var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $106578d297ce64c3$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    var windowObject = (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    var _element_style = element.style, display = _element_style.display, visibility = _element_style.visibility;
    var isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        var _element_ownerDocument_defaultView = element.ownerDocument.defaultView, getComputedStyle = _element_ownerDocument_defaultView.getComputedStyle;
        var _getComputedStyle = getComputedStyle(element), computedDisplay = _getComputedStyle.display, computedVisibility = _getComputedStyle.visibility;
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $106578d297ce64c3$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $106578d297ce64c3$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== '#comment' && $106578d297ce64c3$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $106578d297ce64c3$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $106578d297ce64c3$export$e989c0fffaa6b27a(element.parentElement, element));
}



var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


// https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/ShadowTreeWalker.ts
var $dba4a2cd998fbf91$export$63eb3ababa9c55c4 = /*#__PURE__*/ function() {
    "use strict";
    function $dfc540311bf7f109$export$63eb3ababa9c55c4(doc, root, whatToShow, filter) {
        var _this = this;
        (0, $gpEpt._)(this, $dfc540311bf7f109$export$63eb3ababa9c55c4);
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                var shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    var walker = _this._doc.createTreeWalker(shadowRoot, _this.whatToShow, {
                        acceptNode: _this._acceptNode
                    });
                    _this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    var _this_filter;
                    if (typeof _this.filter === 'function') return _this.filter(node);
                    else if ((_this_filter = _this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) return _this.filter.acceptNode(node);
                    else if (_this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter !== null && filter !== void 0 ? filter : null;
        this.whatToShow = whatToShow !== null && whatToShow !== void 0 ? whatToShow : NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        var shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            var walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
    (0, $eOJ9o._)($dfc540311bf7f109$export$63eb3ababa9c55c4, [
        {
            key: "currentNode",
            get: function get() {
                return this._currentNode;
            },
            set: function set(node) {
                if (!(0, $3b911e3383514511$export$4282f70798064fe0)(this.root, node)) throw new Error('Cannot set currentNode to a node that is not contained by the root node.');
                var walkers = [];
                var curNode = node;
                var currentWalkerCurrentNode = node;
                this._currentNode = node;
                while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    var shadowRoot = curNode;
                    var walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    walkers.push(walker);
                    walker.currentNode = currentWalkerCurrentNode;
                    this._currentSetFor.add(walker);
                    curNode = currentWalkerCurrentNode = shadowRoot.host;
                } else curNode = curNode.parentNode;
                var walker1 = this._doc.createTreeWalker(this.root, this.whatToShow, {
                    acceptNode: this._acceptNode
                });
                walkers.push(walker1);
                walker1.currentNode = currentWalkerCurrentNode;
                this._currentSetFor.add(walker1);
                this._walkerStack = walkers;
            }
        },
        {
            key: "doc",
            get: function get() {
                return this._doc;
            }
        },
        {
            key: "firstChild",
            value: function firstChild() {
                var currentNode = this.currentNode;
                var newNode = this.nextNode();
                if (!(0, $3b911e3383514511$export$4282f70798064fe0)(currentNode, newNode)) {
                    this.currentNode = currentNode;
                    return null;
                }
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
        },
        {
            key: "lastChild",
            value: function lastChild() {
                var walker = this._walkerStack[0];
                var newNode = walker.lastChild();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
        },
        {
            key: "nextNode",
            value: function nextNode() {
                var nextNode = this._walkerStack[0].nextNode();
                if (nextNode) {
                    var shadowRoot = nextNode.shadowRoot;
                    if (shadowRoot) {
                        var _this_filter;
                        var nodeResult;
                        if (typeof this.filter === 'function') nodeResult = this.filter(nextNode);
                        else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                        if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                            this.currentNode = nextNode;
                            return nextNode;
                        }
                        // _acceptNode should have added new walker for this shadow,
                        // go in recursively.
                        var newNode = this.nextNode();
                        if (newNode) this.currentNode = newNode;
                        return newNode;
                    }
                    if (nextNode) this.currentNode = nextNode;
                    return nextNode;
                } else {
                    if (this._walkerStack.length > 1) {
                        this._walkerStack.shift();
                        var newNode1 = this.nextNode();
                        if (newNode1) this.currentNode = newNode1;
                        return newNode1;
                    } else return null;
                }
            }
        },
        {
            key: "previousNode",
            value: function previousNode() {
                var currentWalker = this._walkerStack[0];
                if (currentWalker.currentNode === currentWalker.root) {
                    if (this._currentSetFor.has(currentWalker)) {
                        this._currentSetFor.delete(currentWalker);
                        if (this._walkerStack.length > 1) {
                            this._walkerStack.shift();
                            var newNode = this.previousNode();
                            if (newNode) this.currentNode = newNode;
                            return newNode;
                        } else return null;
                    }
                    return null;
                }
                var previousNode = currentWalker.previousNode();
                if (previousNode) {
                    var shadowRoot = previousNode.shadowRoot;
                    if (shadowRoot) {
                        var _this_filter;
                        var nodeResult;
                        if (typeof this.filter === 'function') nodeResult = this.filter(previousNode);
                        else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                        if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                            if (previousNode) this.currentNode = previousNode;
                            return previousNode;
                        }
                        // _acceptNode should have added new walker for this shadow,
                        // go in recursively.
                        var newNode1 = this.lastChild();
                        if (newNode1) this.currentNode = newNode1;
                        return newNode1;
                    }
                    if (previousNode) this.currentNode = previousNode;
                    return previousNode;
                } else {
                    if (this._walkerStack.length > 1) {
                        this._walkerStack.shift();
                        var newNode2 = this.previousNode();
                        if (newNode2) this.currentNode = newNode2;
                        return newNode2;
                    } else return null;
                }
            }
        },
        {
            /**
     * @deprecated
     */ key: "nextSibling",
            value: function nextSibling() {
                // if (__DEV__) {
                //     throw new Error("Method not implemented.");
                // }
                return null;
            }
        },
        {
            /**
     * @deprecated
     */ key: "previousSibling",
            value: function previousSibling() {
                // if (__DEV__) {
                //     throw new Error("Method not implemented.");
                // }
                return null;
            }
        },
        {
            /**
     * @deprecated
     */ key: "parentNode",
            value: function parentNode() {
                // if (__DEV__) {
                //     throw new Error("Method not implemented.");
                // }
                return null;
            }
        }
    ]);
    return $dfc540311bf7f109$export$63eb3ababa9c55c4;
}();
function $dba4a2cd998fbf91$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
    if ((0, $5321c8b607a1147e$export$98658e8c59125e6a)()) return new $dba4a2cd998fbf91$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
    return doc.createTreeWalker(root, whatToShow, filter);
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext(null);
var $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = 'react-aria-focus-scope-restore';
var $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = null;
function $67c1d94bd0a42a56$export$20e40289641fbbb6(props) {
    var children = props.children, contain = props.contain, restoreFocus = props.restoreFocus, autoFocus = props.autoFocus;
    var startRef = (0, $ggE0n.useRef)(null);
    var endRef = (0, $ggE0n.useRef)(null);
    var scopeRef = (0, $ggE0n.useRef)([]);
    var _ref = (0, $ggE0n.useContext)($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$FocusContext) || {}, parentNode = _ref.parentNode;
    // Create a tree node here so we can add children to it even before it is added to the tree.
    var node = (0, $ggE0n.useMemo)(function() {
        return new $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
    }, [
        scopeRef
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        var parent = parentNode || $67c1d94bd0a42a56$export$d06fae2ee68b101e.root;
        if ($67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope && !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isAncestorScope($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            var activeNode = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $67c1d94bd0a42a56$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var node = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        var node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        var nodes = [];
        var stopPropagation = function(e) {
            return e.stopPropagation();
        };
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    node.removeEventListener($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        children
    ]);
    $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $ggE0n.useEffect)(function() {
        var activeElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined));
        var scope = null;
        if ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // We need to traverse the focusScope tree and find the bottom most scope that
                // contains the active element and set that as the activeScope.
                for(var _iterator = $67c1d94bd0a42a56$export$d06fae2ee68b101e.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    if (node.scopeRef && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (scope === $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        return function() {
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            var parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope || $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(parentScope))) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $67c1d94bd0a42a56$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    var focusManager = (0, $ggE0n.useMemo)(function() {
        return $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    }, []);
    var value = (0, $ggE0n.useMemo)(function() {
        return {
            focusManager: focusManager,
            parentNode: node
        };
    }, [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $67c1d94bd0a42a56$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $ggE0n.useContext)($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var _scope_;
            var node = from || (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : undefined));
            var sentinel = scope[0].previousElementSibling;
            var scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var _scope_;
            var node = from || (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : undefined));
            var sentinel = scope[scope.length - 1].nextElementSibling;
            var scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            var nextNode = walker.nextNode();
            if (nextNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            var previousNode = walker.previousNode();
            if (previousNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    var scope = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    var focusedNode = (0, $ggE0n.useRef)(undefined);
    var raf = (0, $ggE0n.useRef)(undefined);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        var onKeyDown = function(e) {
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            var focusedElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument);
            var scope = scopeRef.current;
            if (!scope || !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            var scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        var onFocus = function(e) {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope || $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isAncestorScope($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope((0, $3b911e3383514511$export$e58f029f0fbfdb29)(e), scopeRef.current)) {
                $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e);
            } else if ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope((0, $3b911e3383514511$export$e58f029f0fbfdb29)(e), scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope.current) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusFirstInScope($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e);
        };
        var onBlur = function(e) {
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(function() {
                // Patches infinite focus coersion loop for Android Talkback where the user isn't able to move the virtual cursor
                // if within a containing focus scope. Bug filed against Chrome: https://issuetracker.google.com/issues/384844019.
                // Note that this means focus can leave focus containing modals due to this, but it is isolated to Chrome Talkback.
                var modality = (0, $33b4709e5e6e943f$export$630ff653c5ada6a9)();
                var shouldSkipFocusRestore = (modality === 'virtual' || modality === null) && (0, $ccce5714e9b7278a$export$a11b0059900ceec8)() && (0, $ccce5714e9b7278a$export$6446a186d09e379e)();
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                var activeElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument);
                if (!shouldSkipFocusRestore && activeElement && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(activeElement, scopeRef)) {
                    $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    var target = (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e);
                    if (target && target.isConnected) {
                        var _focusedNode_current;
                        focusedNode.current = target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope.current) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusFirstInScope($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener('keydown', onKeyDown, false);
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener('focusin', onFocus, false);
        });
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener('focusout', onBlur, false);
        });
        return function() {
            ownerDocument.removeEventListener('keydown', onKeyDown, false);
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener('focusin', onFocus, false);
            });
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener('focusout', onBlur, false);
            });
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        return function() {
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some(function(node) {
        return node.contains(element);
    });
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(element) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // node.contains in isElementInScope covers child scopes that are also DOM children,
        // but does not cover child scopes in portals.
        for(var _iterator = $67c1d94bd0a42a56$export$d06fae2ee68b101e.traverse($67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scope))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, s = _step_value.scopeRef;
            if (s && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $67c1d94bd0a42a56$export$1258395f99bf9cbf(element) {
    return $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(element, $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope);
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    var parent = (_focusScopeTree_getTreeNode = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(element) {
    var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (element != null && !scroll) try {
        (0, $9134fa2a0acdb388$export$80f3e147d781571c)(element);
    } catch (e) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (e) {
    // ignore
    }
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getFirstInScope(scope) {
    var tabbable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var sentinel = scope[0].previousElementSibling;
    var scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    var nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    return nextNode;
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusFirstInScope(scope) {
    var tabbable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    var autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).useRef(autoFocus);
    (0, $ggE0n.useEffect)(function() {
        if (autoFocusRef.current) {
            $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope((0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument), $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (restore || contain) return;
        var scope = scopeRef.current;
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(scope ? scope[0] : undefined);
        var onFocus = function(e) {
            var target = (0, $3b911e3383514511$export$e58f029f0fbfdb29)(e);
            if ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener('focusin', onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener('focusin', onFocus, false);
            });
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    var scope = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    var nodeToRestoreRef = (0, $ggE0n.useRef)(typeof document !== 'undefined' ? (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined)) : null);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var scope = scopeRef.current;
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        var onFocus = function() {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope || $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isAncestorScope($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope((0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument), scopeRef.current)) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener('focusin', onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener('focusin', onFocus, false);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        var onKeyDown = function(e) {
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            var focusedElement = ownerDocument.activeElement;
            if (!$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(focusedElement, scopeRef) || !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef)) return;
            var treeNode = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !nodeToRestore.isConnected || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
        return function() {
            if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var ownerDocument = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        var treeNode = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return function() {
            var treeNode = $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            var activeElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)(ownerDocument);
            if (restoreFocus && nodeToRestore && (activeElement && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInChildScope(activeElement, scopeRef) || activeElement === ownerDocument.body && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                var clonedTree = $67c1d94bd0a42a56$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(function() {
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        var treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $67c1d94bd0a42a56$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                var node = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$getFirstInScope(treeNode.scopeRef.current, true);
                                $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$restoreFocusToElement(node);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($67c1d94bd0a42a56$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(node);
}
function $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(root, opts, scope) {
    var filter = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? (0, $2b9fd0f27f1738b9$export$bebd5a1431fec25d) : (0, $2b9fd0f27f1738b9$export$4c063cf1350e6fed);
    // Ensure that root is an Element or fall back appropriately
    var rootElement = (root === null || root === void 0 ? void 0 : root.nodeType) === Node.ELEMENT_NODE ? root : null;
    // Determine the document to use
    var doc = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(rootElement);
    // Create a TreeWalker, ensuring the root is an Element or Document
    var walker = (0, $dba4a2cd998fbf91$export$4d0f8be8b12a7ef6)(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (filter(node) && (0, $106578d297ce64c3$export$e989c0fffaa6b27a)(node) && (!scope || $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $67c1d94bd0a42a56$export$c5251b9e124bf29(ref) {
    var defaultOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.wrap, wrap = tmp1 === void 0 ? defaultOptions.wrap : tmp1, tmp2 = opts.accept, accept = tmp2 === void 0 ? defaultOptions.accept : tmp2;
            var node = from || (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)(root));
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.wrap, wrap = tmp1 === void 0 ? defaultOptions.wrap : tmp1, tmp2 = opts.accept, accept = tmp2 === void 0 ? defaultOptions.accept : tmp2;
            var node = from || (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)(root));
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                var next = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$last(walker);
                if (next) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                var lastNode = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.accept, accept = tmp1 === void 0 ? defaultOptions.accept : tmp1;
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            var nextNode = walker.nextNode();
            if (nextNode) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.accept, accept = tmp1 === void 0 ? defaultOptions.accept : tmp1;
            var walker = $67c1d94bd0a42a56$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            var next = $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$last(walker);
            if (next) $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$last(walker) {
    var next = undefined;
    var last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
var $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$Tree = /*#__PURE__*/ function() {
    "use strict";
    function $9bf71ea28793e738$var$Tree() {
        (0, $gpEpt._)(this, $9bf71ea28793e738$var$Tree);
        this.fastMap = new Map();
        this.root = new $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
    (0, $eOJ9o._)($9bf71ea28793e738$var$Tree, [
        {
            key: "size",
            get: function get() {
                return this.fastMap.size;
            }
        },
        {
            key: "getTreeNode",
            value: function getTreeNode(data) {
                return this.fastMap.get(data);
            }
        },
        {
            key: "addTreeNode",
            value: function addTreeNode(scopeRef, parent, nodeToRestore) {
                var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
                if (!parentNode) return;
                var node = new $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$TreeNode({
                    scopeRef: scopeRef
                });
                parentNode.addChild(node);
                node.parent = parentNode;
                this.fastMap.set(scopeRef, node);
                if (nodeToRestore) node.nodeToRestore = nodeToRestore;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                this.fastMap.set(node.scopeRef, node);
            }
        },
        {
            key: "removeTreeNode",
            value: function removeTreeNode(scopeRef) {
                // never remove the root
                if (scopeRef === null) return;
                var node = this.fastMap.get(scopeRef);
                if (!node) return;
                var parentNode = node.parent;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
                    // if we are, then replace the siblings restore with the restore from the scope we're removing
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var current = _step.value;
                        if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var children = node.children;
                if (parentNode) {
                    parentNode.removeChild(node);
                    if (children.size > 0) children.forEach(function(child) {
                        return parentNode && parentNode.addChild(child);
                    });
                }
                this.fastMap.delete(node.scopeRef);
            }
        },
        {
            key: "traverse",
            value: // Pre Order Depth First
            function traverse() {
                var node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, err;
                var _arguments = arguments;
                return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            node = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.root;
                            if (!(node.scopeRef != null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                node
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!(node.children.size > 0)) return [
                                3,
                                10
                            ];
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = node.children[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            child = _step.value;
                            return [
                                5,
                                (0, $37faaaff56909290$export$19a8beecd37a4c45)(this.traverse(child))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "clone",
            value: function clone() {
                var _node_parent;
                var newTree = new $9bf71ea28793e738$var$Tree();
                var _node_parent_scopeRef;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return newTree;
            }
        }
    ]);
    return $9bf71ea28793e738$var$Tree;
}();
var $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$TreeNode = /*#__PURE__*/ function() {
    "use strict";
    function $9bf71ea28793e738$var$TreeNode(props) {
        (0, $gpEpt._)(this, $9bf71ea28793e738$var$TreeNode);
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
    (0, $eOJ9o._)($9bf71ea28793e738$var$TreeNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.children.add(node);
                node.parent = this;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.children.delete(node);
                node.parent = undefined;
            }
        }
    ]);
    return $9bf71ea28793e738$var$TreeNode;
}();
var $67c1d94bd0a42a56$export$d06fae2ee68b101e = new $67c1d94bd0a42a56$var$$9bf71ea28793e738$var$Tree();



var $ggE0n = parcelRequire("ggE0n");

var $3og2D = parcelRequire("3og2D");


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f6c6a069114ca6a7$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createContext(null);
function $f6c6a069114ca6a7$export$c6fdb837b070b4ff(props) {
    var isSSR = (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)();
    var tmp = props.portalContainer, portalContainer = tmp === void 0 ? isSSR ? null : document.body : tmp, isExiting = props.isExiting;
    var _$1CM7W$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), contain = _$1CM7W$useState[0], setContain = _$1CM7W$useState[1];
    var contextValue = (0, $ggE0n.useMemo)(function() {
        return {
            contain: contain,
            setContain: setContain
        };
    }, [
        contain,
        setContain
    ]);
    var _$96b38030c423d352$export$9fc1347d4195ccb3 = (0, $8f7f03ece6f1e0cd$export$9fc1347d4195ccb3)(), getContainer = _$96b38030c423d352$export$9fc1347d4195ccb3.getContainer;
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    var contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $67c1d94bd0a42a56$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: (props.shouldContainFocus || contain) && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($f6c6a069114ca6a7$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f12953e97e637e2a$export$cf75428e0b9ed1ea), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($3og2D))).createPortal(contents, portalContainer);
}
function $f6c6a069114ca6a7$export$14c98a7594375490() {
    var ctx = (0, $ggE0n.useContext)($f6c6a069114ca6a7$export$a2200b96afd16271);
    var setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}


var $2QPpE = parcelRequire("2QPpE");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.

var $90NkU = parcelRequire("90NkU");
var $d4acd2b54a25cec0$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
var $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack = [];
function $d4acd2b54a25cec0$export$1c3ebcada18427bf(targets) {
    var root = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.body;
    var visibleNodes = new Set(targets);
    var hiddenNodes = new Set();
    var walk = function(root) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Keep live announcer and top layer elements (e.g. toasts) visible.
            for(var _iterator = root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                visibleNodes.add(element);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var acceptNode = function(node) {
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Skip this node but continue to children if one of the targets is inside the node.
                for(var _iterator = visibleNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var target = _step.value;
                    if (node.contains(target)) return NodeFilter.FILTER_SKIP;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        var acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            var node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    var hide = function(node) {
        var _refCountMap_get;
        var refCount = (_refCountMap_get = $d4acd2b54a25cec0$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
        if (refCount === 0) node.setAttribute('aria-hidden', 'true');
        hiddenNodes.add(node);
        $d4acd2b54a25cec0$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.length) $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack[$d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    var observer = new MutationObserver(function(changes) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var change = _step.value;
                if (change.type !== 'childList' || change.addedNodes.length === 0) return "continue";
                // If the parent element of the added nodes is not within one of the targets,
                // and not already inside a hidden node, hide all of the new children.
                if (!(0, $90NkU._)(visibleNodes).concat((0, $90NkU._)(hiddenNodes)).some(function(node) {
                    return node.contains(change.target);
                })) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = change.removedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step1.value;
                            if (node instanceof Element) {
                                visibleNodes.delete(node);
                                hiddenNodes.delete(node);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = change.addedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var node1 = _step2.value;
                            if ((node1 instanceof HTMLElement || node1 instanceof SVGElement) && (node1.dataset.liveAnnouncer === 'true' || node1.dataset.reactAriaTopLayer === 'true')) visibleNodes.add(node1);
                            else if (node1 instanceof Element) walk(node1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            };
            for(var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    var observerWrapper = {
        visibleNodes: visibleNodes,
        hiddenNodes: hiddenNodes,
        observe: function() {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect: function() {
            observer.disconnect();
        }
    };
    $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return function() {
        observer.disconnect();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = hiddenNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                var count = $d4acd2b54a25cec0$var$$5e3802645cc19319$var$refCountMap.get(node);
                if (count == null) continue;
                if (count === 1) {
                    node.removeAttribute('aria-hidden');
                    $d4acd2b54a25cec0$var$$5e3802645cc19319$var$refCountMap.delete(node);
                } else $d4acd2b54a25cec0$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack[$d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.pop();
            if ($d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.length) $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack[$d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.splice($d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}
function $d4acd2b54a25cec0$export$1020fa7f77e17884(element) {
    var observer = $d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack[$d4acd2b54a25cec0$var$$5e3802645cc19319$var$observerStack.length - 1];
    if (observer && !observer.visibleNodes.has(element)) {
        observer.visibleNodes.add(element);
        return function() {
            observer.visibleNodes.delete(element);
        };
    }
}



var $2QPpE = parcelRequire("2QPpE");




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: 'totalWidth',
    height: 'totalHeight'
};
var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
var $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    var width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    var scroll = {};
    var _visualViewport_scale;
    var isPinchZoomedIn = ((_visualViewport_scale = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === null || $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.scale) !== null && _visualViewport_scale !== void 0 ? _visualViewport_scale : 1) > 1;
    if (containerNode.tagName === 'BODY') {
        var documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === null || $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === null || $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if ($7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport) {
            top = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.offsetTop;
            left = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.offsetLeft;
        }
    } else {
        var ref;
        ref = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(containerNode), width = ref.width, height = ref.height, top = ref.top, left = ref.left, ref;
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $ccce5714e9b7278a$export$78551043582a6a98)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        var _visualViewport_pageTop;
        top = (_visualViewport_pageTop = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === null || $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.pageTop) !== null && _visualViewport_pageTop !== void 0 ? _visualViewport_pageTop : 0;
        var _visualViewport_pageLeft;
        left = (_visualViewport_pageLeft = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === null || $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$visualViewport.pageLeft) !== null && _visualViewport_pageLeft !== void 0 ? _visualViewport_pageLeft : 0;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    var _containerDimensions_scroll_axis;
    var containerScroll = (_containerDimensions_scroll_axis = containerDimensions.scroll[axis]) !== null && _containerDimensions_scroll_axis !== void 0 ? _containerDimensions_scroll_axis : 0;
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    var boundarySize = boundaryDimensions[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    var boundaryStartEdge = boundaryDimensions.scroll[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[axis]] + padding;
    var boundaryEndEdge = boundarySize + boundaryDimensions.scroll[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[axis]] - padding;
    var startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[axis]];
    var endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getMargins(node) {
    var style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($7cd317bb39b1b9a9$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    var _input_split = (0, $c6938abc98c6418f$export$71511d61b312f219)(input.split(' '), 2), placement = _input_split[0], crossPlacement = _input_split[1];
    var axis = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[placement] || 'right';
    var crossAxis = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    var size = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    var crossSize = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    var placement = placementInfo.placement, crossPlacement = placementInfo.crossPlacement, axis = placementInfo.axis, crossAxis = placementInfo.crossAxis, size = placementInfo.size, crossSize = placementInfo.crossSize;
    var position = {};
    var _childOffset_crossAxis;
    // button position
    position[crossAxis] = (_childOffset_crossAxis = childOffset[crossAxis]) !== null && _childOffset_crossAxis !== void 0 ? _childOffset_crossAxis : 0;
    var _childOffset_crossSize, _overlaySize_crossSize, _childOffset_crossSize1, _overlaySize_crossSize1;
    if (crossPlacement === 'center') // at this point the overlay center should match the button center
    position[crossAxis] += (((_childOffset_crossSize = childOffset[crossSize]) !== null && _childOffset_crossSize !== void 0 ? _childOffset_crossSize : 0) - ((_overlaySize_crossSize = overlaySize[crossSize]) !== null && _overlaySize_crossSize !== void 0 ? _overlaySize_crossSize : 0)) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += ((_childOffset_crossSize1 = childOffset[crossSize]) !== null && _childOffset_crossSize1 !== void 0 ? _childOffset_crossSize1 : 0) - ((_overlaySize_crossSize1 = overlaySize[crossSize]) !== null && _overlaySize_crossSize1 !== void 0 ? _overlaySize_crossSize1 : 0);
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    var minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    var maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $b53961de50607290$export$7d15b64cf5a3a4c4)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        var containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    var containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$TOTAL_SIZE.height];
    var _position_bottom;
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    var overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - ((_position_bottom = position.bottom) !== null && _position_bottom !== void 0 ? _position_bottom : 0) - overlayHeight);
    var _boundaryDimensions_scroll_top, _margins_top, _margins_bottom, _boundaryDimensions_scroll_top1, _margins_top1, _margins_bottom1;
    var maxHeight = heightGrowthDirection !== 'top' ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + ((_boundaryDimensions_scroll_top = boundaryDimensions.scroll.top) !== null && _boundaryDimensions_scroll_top !== void 0 ? _boundaryDimensions_scroll_top : 0) - overlayTop // this is the top of the overlay
     - (((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0) + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + ((_boundaryDimensions_scroll_top1 = boundaryDimensions.scroll.top) !== null && _boundaryDimensions_scroll_top1 !== void 0 ? _boundaryDimensions_scroll_top1 : 0 // this is the top of the boundary
    )) - (((_margins_top1 = margins.top) !== null && _margins_top1 !== void 0 ? _margins_top1 : 0) + ((_margins_bottom1 = margins.bottom) !== null && _margins_bottom1 !== void 0 ? _margins_bottom1 : 0) + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    var placement = placementInfo.placement, axis = placementInfo.axis, size = placementInfo.size;
    var _boundaryDimensions_scroll_axis, _margins_axis;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - ((_boundaryDimensions_scroll_axis = boundaryDimensions.scroll[axis]) !== null && _boundaryDimensions_scroll_axis !== void 0 ? _boundaryDimensions_scroll_axis : 0) + containerOffsetWithBoundary[axis] - ((_margins_axis = margins[axis]) !== null && _margins_axis !== void 0 ? _margins_axis : 0) - margins[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    var _margins_axis1;
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - ((_margins_axis1 = margins[axis]) !== null && _margins_axis1 !== void 0 ? _margins_axis1 : 0) - margins[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $7cd317bb39b1b9a9$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    var placementInfo = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    var size = placementInfo.size, crossAxis = placementInfo.crossAxis, crossSize = placementInfo.crossSize, placement = placementInfo.placement, crossPlacement = placementInfo.crossPlacement;
    var position = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    var normalizedOffset = offset;
    var space = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        var flippedPlacementInfo = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$parsePlacement("".concat($7cd317bb39b1b9a9$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement], " ").concat(crossPlacement));
        var flippedPosition = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        var flippedSpace = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    var heightGrowthDirection = 'bottom';
    if (placementInfo.axis === 'top') {
        if (placementInfo.placement === 'top') heightGrowthDirection = 'top';
        else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossAxis === 'top') {
        if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';
        else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
    }
    var delta = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    var maxHeight = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    var arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    // childOffset[crossAxis] + .5 * childOffset[crossSize] = absolute position with respect to the trigger's coordinate system that would place the arrow in the center of the trigger
    // position[crossAxis] - margins[AXIS[crossAxis]] = value use to transform the position to a value with respect to the overlay's coordinate system. A child element's (aka arrow) position absolute's "0"
    // is positioned after the margin of its parent (aka overlay) so we need to subtract it to get the proper coordinate transform
    var preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - position[crossAxis] - margins[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[crossAxis]];
    // Min/Max position limits for the arrow with respect to the overlay
    var arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    var _margins_left, _margins_right, _margins_top, _margins_bottom;
    // overlaySize[crossSize] - margins = true size of the overlay
    var overlayMargin = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[crossAxis] === 'left' ? ((_margins_left = margins.left) !== null && _margins_left !== void 0 ? _margins_left : 0) + ((_margins_right = margins.right) !== null && _margins_right !== void 0 ? _margins_right : 0) : ((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0);
    var arrowMaxPosition = overlaySize[crossSize] - overlayMargin - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    // Same margin accomodation done here as well as for the preferredArrowPosition
    var arrowOverlappingChildMinEdge = childOffset[crossAxis] + arrowSize / 2 - (position[crossAxis] + margins[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[crossAxis]]);
    var arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - arrowSize / 2 - (position[crossAxis] + margins[$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$AXIS[crossAxis]]);
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    var arrowPositionOverlappingChild = (0, $b53961de50607290$export$7d15b64cf5a3a4c4)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $b53961de50607290$export$7d15b64cf5a3a4c4)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $7cd317bb39b1b9a9$export$b3ceb0cbf1056d98(opts) {
    var placement = opts.placement, targetNode = opts.targetNode, overlayNode = opts.overlayNode, scrollNode = opts.scrollNode, padding = opts.padding, shouldFlip = opts.shouldFlip, boundaryElement = opts.boundaryElement, offset = opts.offset, crossOffset = opts.crossOffset, maxHeight = opts.maxHeight, tmp = opts.arrowSize, arrowSize = tmp === void 0 ? 0 : tmp, tmp1 = opts.arrowBoundaryOffset, arrowBoundaryOffset = tmp1 === void 0 ? 0 : tmp1;
    var container = overlayNode instanceof HTMLElement ? $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    var isViewportContainer = container === document.documentElement;
    var containerPositionStyle = window.getComputedStyle(container).position;
    var isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    var childOffset = isViewportContainer ? $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(targetNode) : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isViewportContainer) {
        var _window_getComputedStyle = window.getComputedStyle(targetNode), marginTop = _window_getComputedStyle.marginTop, marginLeft = _window_getComputedStyle.marginLeft;
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    var overlaySize = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(overlayNode);
    var margins = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getMargins(overlayNode);
    var _margins_left, _margins_right;
    overlaySize.width += ((_margins_left = margins.left) !== null && _margins_left !== void 0 ? _margins_left : 0) + ((_margins_right = margins.right) !== null && _margins_right !== void 0 ? _margins_right : 0);
    var _margins_top, _margins_bottom;
    overlaySize.height += ((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0);
    var scrollSize = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getScroll(scrollNode);
    var boundaryDimensions = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    var containerDimensions = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    var containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(container) : $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getPosition(container, boundaryElement);
    if (container.tagName === 'HTML' && boundaryElement.tagName === 'BODY') {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return $7cd317bb39b1b9a9$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(node) {
    var _node_getBoundingClientRect = node.getBoundingClientRect(), top = _node_getBoundingClientRect.top, left = _node_getBoundingClientRect.left, width = _node_getBoundingClientRect.width, height = _node_getBoundingClientRect.height;
    var _document_documentElement = document.documentElement, scrollTop = _document_documentElement.scrollTop, scrollLeft = _document_documentElement.scrollLeft, clientTop = _document_documentElement.clientTop, clientLeft = _document_documentElement.clientLeft;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getPosition(node, parent) {
    var style = window.getComputedStyle(node);
    var offset;
    if (style.position === 'fixed') {
        var _node_getBoundingClientRect = node.getBoundingClientRect(), top = _node_getBoundingClientRect.top, left = _node_getBoundingClientRect.left, width = _node_getBoundingClientRect.width, height = _node_getBoundingClientRect.height;
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(node);
        var parentOffset = $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getOffset(parent);
        var parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    var offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$7cd317bb39b1b9a9$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $7cd317bb39b1b9a9$var$$edcf132a9284368a$var$isContainingBlock(node) {
    var style = window.getComputedStyle(node);
    return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' || 'backdropFilter' in style && style.backdropFilter !== 'none' || 'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4b2032e9054520ff$export$f6211563215e3b37 = new WeakMap();
function $4b2032e9054520ff$export$18fc8428861184da(opts) {
    var triggerRef = opts.triggerRef, isOpen = opts.isOpen, onClose = opts.onClose;
    (0, $ggE0n.useEffect)(function() {
        if (!isOpen || onClose === null) return;
        var onScroll = function(e) {
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            var target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            // Ignore scroll events on any input or textarea as the cursor position can cause it to scroll
            // such as in a combobox. Clicking the dropdown button places focus on the input, and if the
            // text inside the input extends beyond the 'end', then it will scroll so the cursor is visible at the end.
            if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
            var onCloseHandler = onClose || $4b2032e9054520ff$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return function() {
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}



var $ggE0n = parcelRequire("ggE0n");

var $ggE0n = parcelRequire("ggE0n");
function $e75879033f372928$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== 'undefined';
}
function $e75879033f372928$export$683480f191c0e3ea(options) {
    var ref = options.ref, box = options.box, onResize = options.onResize;
    (0, $ggE0n.useEffect)(function() {
        var element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$e75879033f372928$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener('resize', onResize, false);
            return function() {
                window.removeEventListener('resize', onResize, false);
            };
        } else {
            var resizeObserverInstance = new window.ResizeObserver(function(entries) {
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element, {
                box: box
            });
            return function() {
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref,
        box
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $b2a3ee768845f8f9$export$d39e1813b3bdd0e1(props) {
    var _$39EOa$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), direction = _$39EOa$useLocale.direction;
    var tmp = props.arrowSize, arrowSize = tmp === void 0 ? 0 : tmp, targetRef = props.targetRef, overlayRef = props.overlayRef, tmp1 = props.scrollRef, scrollRef = tmp1 === void 0 ? overlayRef : tmp1, tmp2 = props.placement, placement = tmp2 === void 0 ? 'bottom' : tmp2, tmp3 = props.containerPadding, containerPadding = tmp3 === void 0 ? 12 : tmp3, tmp4 = props.shouldFlip, shouldFlip = tmp4 === void 0 ? true : tmp4, tmp5 = props.boundaryElement, boundaryElement = tmp5 === void 0 ? typeof document !== 'undefined' ? document.body : null : tmp5, tmp6 = props.offset, offset = tmp6 === void 0 ? 0 : tmp6, tmp7 = props.crossOffset, crossOffset = tmp7 === void 0 ? 0 : tmp7, tmp8 = props.shouldUpdatePosition, shouldUpdatePosition = tmp8 === void 0 ? true : tmp8, tmp9 = props.isOpen, isOpen = tmp9 === void 0 ? true : tmp9, onClose = props.onClose, maxHeight = props.maxHeight, tmp10 = props.arrowBoundaryOffset, arrowBoundaryOffset = tmp10 === void 0 ? 0 : tmp10;
    var _$39EOa$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), position = _$39EOa$useState[0], setPosition = _$39EOa$useState[1];
    var deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    var lastScale = (0, $ggE0n.useRef)($b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.scale);
    (0, $ggE0n.useEffect)(function() {
        if (isOpen) lastScale.current = $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.scale;
    }, [
        isOpen
    ]);
    var updatePosition = (0, $ggE0n.useCallback)(function() {
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !boundaryElement) return;
        if (($b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
        // Determine a scroll anchor based on the focused element.
        // This stores the offset of the anchor element from the scroll container
        // so it can be restored after repositioning. This way if the overlay height
        // changes, the focused element appears to stay in the same position.
        var anchor = null;
        if (scrollRef.current && scrollRef.current.contains(document.activeElement)) {
            var _document_activeElement;
            var anchorRect = (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.getBoundingClientRect();
            var scrollRect = scrollRef.current.getBoundingClientRect();
            var _anchorRect_top;
            // Anchor from the top if the offset is in the top half of the scrollable element,
            // otherwise anchor from the bottom.
            anchor = {
                type: 'top',
                offset: ((_anchorRect_top = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.top) !== null && _anchorRect_top !== void 0 ? _anchorRect_top : 0) - scrollRect.top
            };
            if (anchor.offset > scrollRect.height / 2) {
                anchor.type = 'bottom';
                var _anchorRect_bottom;
                anchor.offset = ((_anchorRect_bottom = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.bottom) !== null && _anchorRect_bottom !== void 0 ? _anchorRect_bottom : 0) - scrollRect.bottom;
            }
        }
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        var overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            var _window_visualViewport;
            overlay.style.top = '0px';
            overlay.style.bottom = '';
            var _window_visualViewport_height;
            overlay.style.maxHeight = ((_window_visualViewport_height = (_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) !== null && _window_visualViewport_height !== void 0 ? _window_visualViewport_height : window.innerHeight) + 'px';
        }
        var position = (0, $7cd317bb39b1b9a9$export$b3ceb0cbf1056d98)({
            placement: $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current || overlayRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        if (!position.position) return;
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = '';
        overlay.style.bottom = '';
        overlay.style.left = '';
        overlay.style.right = '';
        Object.keys(position.position).forEach(function(key) {
            return overlay.style[key] = position.position[key] + 'px';
        });
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : '';
        // Restore scroll position relative to anchor element.
        if (anchor && document.activeElement && scrollRef.current) {
            var anchorRect1 = document.activeElement.getBoundingClientRect();
            var scrollRect1 = scrollRef.current.getBoundingClientRect();
            var newOffset = anchorRect1[anchor.type] - scrollRect1[anchor.type];
            scrollRef.current.scrollTop += newOffset - anchor.offset;
        }
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: targetRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    var isResizing = (0, $ggE0n.useRef)(false);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var timeout;
        var onResize = function() {
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        var onScroll = function() {
            if (isResizing.current) onResize();
        };
        $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.addEventListener('resize', onResize);
        $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.addEventListener('scroll', onScroll);
        return function() {
            $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.removeEventListener('resize', onResize);
            $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === null || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$visualViewport.removeEventListener('scroll', onScroll);
        };
    }, [
        updatePosition
    ]);
    var close = (0, $ggE0n.useCallback)(function() {
        if (!isResizing.current) onClose === null || onClose === void 0 || onClose();
    }, [
        onClose,
        isResizing
    ]);
    (0, $4b2032e9054520ff$export$18fc8428861184da)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    var _position_maxHeight, _position_placement;
    return {
        overlayProps: {
            style: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
                position: 'absolute',
                zIndex: 100000
            }, position === null || position === void 0 ? void 0 : position.position), {
                maxHeight: (_position_maxHeight = position === null || position === void 0 ? void 0 : position.maxHeight) !== null && _position_maxHeight !== void 0 ? _position_maxHeight : '100vh'
            })
        },
        placement: (_position_placement = position === null || position === void 0 ? void 0 : position.placement) !== null && _position_placement !== void 0 ? _position_placement : null,
        arrowProps: {
            'aria-hidden': 'true',
            role: 'presentation',
            style: {
                left: position === null || position === void 0 ? void 0 : position.arrowOffsetLeft,
                top: position === null || position === void 0 ? void 0 : position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        window.addEventListener('resize', onResize, false);
        return function() {
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $b2a3ee768845f8f9$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}



var $2QPpE = parcelRequire("2QPpE");


var $ggE0n = parcelRequire("ggE0n");


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $257d8d26c55c5dd9$export$872b660ac5a1ff98(props) {
    var ref = props.ref, onInteractOutside = props.onInteractOutside, isDisabled = props.isDisabled, onInteractOutsideStart = props.onInteractOutsideStart;
    var stateRef = (0, $ggE0n.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    var onPointerDown = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        if (onInteractOutside && $257d8d26c55c5dd9$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    var triggerInteractOutside = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $ggE0n.useEffect)(function() {
        var state = stateRef.current;
        if (isDisabled) return;
        var element = ref.current;
        var documentObject = (0, $435fb34f0a5eae0b$export$b204af158042fbac)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== 'undefined') {
            var onClick = function(e) {
                if (state.isPointerDown && $257d8d26c55c5dd9$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            // Use click instead of pointerup to avoid Android Chrome issue
            // https://issues.chromium.org/issues/40732224
            documentObject.addEventListener('pointerdown', onPointerDown, true);
            documentObject.addEventListener('click', onClick, true);
            return function() {
                documentObject.removeEventListener('pointerdown', onPointerDown, true);
                documentObject.removeEventListener('click', onClick, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $257d8d26c55c5dd9$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        var ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest('[data-react-aria-top-layer]')) return false;
    }
    if (!ref.current) return false;
    // When the event source is inside a Shadow DOM, event.target is just the shadow root.
    // Using event.composedPath instead means we can get the actual element inside the shadow root.
    // This only works if the shadow root is open, there is no way to detect if it is closed.
    // If the event composed path contains the ref, interaction is inside.
    return !event.composedPath().includes(ref.current);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $a304c1bfca7428a8$export$ea8f71083e90600f(props, ref) {
    var onClose = props.onClose, shouldCloseOnBlur = props.shouldCloseOnBlur, isOpen = props.isOpen, tmp = props.isDismissable, isDismissable = tmp === void 0 ? false : tmp, tmp1 = props.isKeyboardDismissDisabled, isKeyboardDismissDisabled = tmp1 === void 0 ? false : tmp1, shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside;
    (0, $ggE0n.useEffect)(function() {
        if (isOpen && !$a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.includes(ref)) {
            $a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
            return function() {
                var index = $a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
                if (index >= 0) $a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
            };
        }
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    var onHide = function() {
        if ($a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays[$a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    var onInteractOutsideStart = function(e) {
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays[$a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    var onInteractOutside = function(e) {
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays[$a304c1bfca7428a8$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    var onKeyDown = function(e) {
        if (e.key === 'Escape' && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $257d8d26c55c5dd9$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : undefined,
        onInteractOutsideStart: onInteractOutsideStart
    });
    var _$jtpZv$useFocusWithin = (0, $2d409168e187362c$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: function(e) {
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $67c1d94bd0a42a56$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose === null || onClose === void 0 || onClose();
        }
    }), focusWithinProps = _$jtpZv$useFocusWithin.focusWithinProps;
    var onPointerDownUnderlay = function(e) {
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: (0, $2QPpE._)({
            onKeyDown: onKeyDown
        }, focusWithinProps),
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e9a8111392ef6431$export$2bb74740c4e19def(node, checkForOverflow) {
    if (!node) return false;
    var style = window.getComputedStyle(node);
    var isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6639b0c48472043a$export$cfa2225e87938781(node, checkForOverflow) {
    var scrollableNode = node;
    if ((0, $e9a8111392ef6431$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $e9a8111392ef6431$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
var $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
var $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
var $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$restore;
function $57b0cdde0a666cb7$export$ee0f7cc6afcd1c18() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isDisabled = options.isDisabled;
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (isDisabled) return;
        $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $ccce5714e9b7278a$export$fedb369cb70207f1)()) $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$restore = $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$restore = $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return function() {
            $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return (0, $8deb5a1aa1f00721$export$e08e3b67e392101e)(scrollbarWidth > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
    ('scrollbarGutter' in document.documentElement.style ? $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'scrollbarGutter', 'stable') : $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', "".concat(scrollbarWidth, "px"))), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    var scrollable;
    var restoreScrollableStyles;
    var onTouchStart = function(e) {
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $6639b0c48472043a$export$cfa2225e87938781)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === 'auto') restoreScrollableStyles = $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(scrollable, 'overscrollBehavior', 'contain');
    };
    var onTouchMove = function(e) {
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    var onTouchEnd = function() {
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    var onFocus = function(e) {
        var target = e.target;
        if ($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view.
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(function() {
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(function() {
                        $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$visualViewport.addEventListener('resize', function() {
                        return $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    }, {
                        once: true
                    });
                }
            });
        }
    };
    var restoreStyles = null;
    var setupStyles = function() {
        if (restoreStyles) return;
        var onWindowScroll = function() {
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        var scrollX = window.pageXOffset;
        var scrollY = window.pageYOffset;
        restoreStyles = (0, $8deb5a1aa1f00721$export$e08e3b67e392101e)($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$addEvent(window, 'scroll', onWindowScroll), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', "".concat(window.innerWidth - document.documentElement.clientWidth, "px")), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(document.body, 'marginTop', "-".concat(scrollY, "px")), function() {
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    var removeEvents = (0, $8deb5a1aa1f00721$export$e08e3b67e392101e)($57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$addEvent(document, 'focus', onFocus, true));
    return function() {
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 || restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 || restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    var cur = element.style[style];
    element.style[style] = value;
    return function() {
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    // internal function, so it's ok to ignore the difficult to fix type error
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return function() {
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    var root = document.scrollingElement || document.documentElement;
    var nextTarget = target;
    while(nextTarget && nextTarget !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        var scrollable = (0, $6639b0c48472043a$export$cfa2225e87938781)(nextTarget);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
            var scrollableTop = scrollable.getBoundingClientRect().top;
            var targetTop = nextTarget.getBoundingClientRect().top;
            if (targetTop > scrollableTop + nextTarget.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        nextTarget = scrollable.parentElement;
    }
}
function $57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$57b0cdde0a666cb7$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a4b5055efcd083ca$export$542a6fd13ac93354(props, state) {
    var triggerRef = props.triggerRef, popoverRef = props.popoverRef, groupRef = props.groupRef, isNonModal = props.isNonModal, isKeyboardDismissDisabled = props.isKeyboardDismissDisabled, shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "triggerRef",
        "popoverRef",
        "groupRef",
        "isNonModal",
        "isKeyboardDismissDisabled",
        "shouldCloseOnInteractOutside"
    ]);
    var isSubmenu = otherProps['trigger'] === 'SubmenuTrigger';
    var _$a11501f3d1d39e6c$export$ea8f71083e90600f = (0, $a304c1bfca7428a8$export$ea8f71083e90600f)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal || isSubmenu,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, groupRef !== null && groupRef !== void 0 ? groupRef : popoverRef), overlayProps = _$a11501f3d1d39e6c$export$ea8f71083e90600f.overlayProps, underlayProps = _$a11501f3d1d39e6c$export$ea8f71083e90600f.underlayProps;
    var _$2a41e45df1593e64$export$d39e1813b3bdd0e1 = (0, $b2a3ee768845f8f9$export$d39e1813b3bdd0e1)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal && !isSubmenu ? state.close : null
    })), positionProps = _$2a41e45df1593e64$export$d39e1813b3bdd0e1.overlayProps, arrowProps = _$2a41e45df1593e64$export$d39e1813b3bdd0e1.arrowProps, placement = _$2a41e45df1593e64$export$d39e1813b3bdd0e1.placement;
    (0, $57b0cdde0a666cb7$export$ee0f7cc6afcd1c18)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (state.isOpen && popoverRef.current) {
            var _groupRef_current, _groupRef_current1;
            if (isNonModal) return (0, $d4acd2b54a25cec0$export$1020fa7f77e17884)((_groupRef_current = groupRef === null || groupRef === void 0 ? void 0 : groupRef.current) !== null && _groupRef_current !== void 0 ? _groupRef_current : popoverRef.current);
            else return (0, $d4acd2b54a25cec0$export$1c3ebcada18427bf)([
                (_groupRef_current1 = groupRef === null || groupRef === void 0 ? void 0 : groupRef.current) !== null && _groupRef_current1 !== void 0 ? _groupRef_current1 : popoverRef.current
            ]);
        }
    }, [
        isNonModal,
        state.isOpen,
        popoverRef,
        groupRef
    ]);
    return {
        popoverProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}





var $3og2D = parcelRequire("3og2D");

var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7bf9e6b27a0164fe$export$6d3443f2c48bfc20(ref) {
    var isReady = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _$jJMAe$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(true), 2), isEntering = _$jJMAe$useState[0], setEntering = _$jJMAe$useState[1];
    var isAnimationReady = isEntering && isReady;
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (isAnimationReady && ref.current && 'getAnimations' in ref.current) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = ref.current.getAnimations()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var animation = _step.value;
                    if (animation instanceof CSSTransition) animation.cancel();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, [
        ref,
        isAnimationReady
    ]);
    $7bf9e6b27a0164fe$var$$d3f049242431219c$var$useAnimation(ref, isAnimationReady, (0, $ggE0n.useCallback)(function() {
        return setEntering(false);
    }, []));
    return isAnimationReady;
}
function $7bf9e6b27a0164fe$export$45fda7c47f93fd48(ref, isOpen) {
    var _$jJMAe$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(isOpen ? 'open' : 'closed'), 2), exitState = _$jJMAe$useState[0], setExitState = _$jJMAe$useState[1];
    switch(exitState){
        case 'open':
            // If isOpen becomes false, set the state to exiting.
            if (!isOpen) setExitState('exiting');
            break;
        case 'closed':
        case 'exiting':
            // If we are exiting and isOpen becomes true, the animation was interrupted.
            // Reset the state to open.
            if (isOpen) setExitState('open');
            break;
    }
    var isExiting = exitState === 'exiting';
    $7bf9e6b27a0164fe$var$$d3f049242431219c$var$useAnimation(ref, isExiting, (0, $ggE0n.useCallback)(function() {
        // Set the state to closed, which will cause the element to be unmounted.
        setExitState(function(state) {
            return state === 'exiting' ? 'closed' : state;
        });
    }, []));
    return isExiting;
}
function $7bf9e6b27a0164fe$var$$d3f049242431219c$var$useAnimation(ref, isActive, onEnd) {
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (isActive && ref.current) {
            if (!('getAnimations' in ref.current)) {
                // JSDOM
                onEnd();
                return;
            }
            var animations = ref.current.getAnimations();
            if (animations.length === 0) {
                onEnd();
                return;
            }
            var canceled = false;
            Promise.all(animations.map(function(a) {
                return a.finished;
            })).then(function() {
                if (!canceled) (0, $3og2D.flushSync)(function() {
                    onEnd();
                });
            }).catch(function() {});
            return function() {
                canceled = true;
            };
        }
    }, [
        ref,
        isActive,
        onEnd
    ]);
}





var $ggE0n = parcelRequire("ggE0n");


var $90NkU = parcelRequire("90NkU");

var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e8d739d764b8c43b$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    var _$3whtM$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(value || defaultValue), 2), stateValue = _$3whtM$useState[0], setStateValue = _$3whtM$useState[1];
    var isControlledRef = (0, $ggE0n.useRef)(value !== undefined);
    var isControlled = value !== undefined;
    (0, $ggE0n.useEffect)(function() {
        var wasControlled = isControlledRef.current;
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var currentValue = isControlled ? value : stateValue;
    var setValue = (0, $ggE0n.useCallback)(function(value) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var onChangeCaller = function(value) {
            for(var _len = arguments.length, onChangeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                onChangeArgs[_key - 1] = arguments[_key];
            }
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange.apply(void 0, [
                    value
                ].concat((0, $90NkU._)(onChangeArgs)));
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === 'function') {
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            var updateFunction = function(oldValue) {
                for(var _len = arguments.length, functionArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    functionArgs[_key - 1] = arguments[_key];
                }
                var interceptedValue = value.apply(void 0, [
                    isControlled ? currentValue : oldValue
                ].concat((0, $90NkU._)(functionArgs)));
                onChangeCaller.apply(void 0, [
                    interceptedValue
                ].concat((0, $90NkU._)(args)));
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller.apply(void 0, [
                value
            ].concat((0, $90NkU._)(args)));
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $995b915c2e36d0af$export$61c6a8c84e605fb6(props) {
    var _$hnMvi$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange), 2), isOpen = _$hnMvi$useControlledState[0], setOpen = _$hnMvi$useControlledState[1];
    var open = (0, $ggE0n.useCallback)(function() {
        setOpen(true);
    }, [
        setOpen
    ]);
    var close = (0, $ggE0n.useCallback)(function() {
        setOpen(false);
    }, [
        setOpen
    ]);
    var toggle = (0, $ggE0n.useCallback)(function() {
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}



var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $13b1a1463e05bd62$export$9b9a0cd73afb7ca4 = (0, $ggE0n.createContext)(null);
// Stores a ref for the portal container for a group of popovers (e.g. submenus).
var $13b1a1463e05bd62$var$$07b14b47974efb58$var$PopoverGroupContext = (0, $ggE0n.createContext)(null);
var $13b1a1463e05bd62$export$5b6b19405a83ff9d = (0, $ggE0n.forwardRef)(function Popover(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $13b1a1463e05bd62$export$9b9a0cd73afb7ca4), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var contextState = (0, $ggE0n.useContext)((0, $e4ccc8b3c0827610$export$d2f961adcb0afbe));
    var localState = (0, $995b915c2e36d0af$export$61c6a8c84e605fb6)(props);
    var state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    var isExiting = (0, $7bf9e6b27a0164fe$export$45fda7c47f93fd48)(ref, state.isOpen) || props.isExiting || false;
    var isHidden = (0, $cfc4721022845f0c$export$b5d7cc18bb8d2b59)();
    var _$ehFet$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), direction = _$ehFet$useLocale.direction;
    // If we are in a hidden tree, we still need to preserve our children.
    if (isHidden) {
        var children = props.children;
        if (typeof children === 'function') children = children({
            trigger: props.trigger || null,
            placement: 'bottom',
            isEntering: false,
            isExiting: false,
            defaultChildren: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, children);
    }
    if (state && !state.isOpen && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($13b1a1463e05bd62$var$$07b14b47974efb58$var$PopoverInner, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        triggerRef: props.triggerRef,
        state: state,
        popoverRef: ref,
        isExiting: isExiting,
        dir: direction
    }));
});
function $13b1a1463e05bd62$var$$07b14b47974efb58$var$PopoverInner(_param) {
    var state = _param.state, isExiting = _param.isExiting, UNSTABLE_portalContainer = _param.UNSTABLE_portalContainer, clearContexts = _param.clearContexts, props = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_param, [
        "state",
        "isExiting",
        "UNSTABLE_portalContainer",
        "clearContexts"
    ]);
    // Calculate the arrow size internally (and remove props.arrowSize from PopoverProps)
    // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
    var arrowRef = (0, $ggE0n.useRef)(null);
    var _$ehFet$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(0), 2), arrowWidth = _$ehFet$useState[0], setArrowWidth = _$ehFet$useState[1];
    var containerRef = (0, $ggE0n.useRef)(null);
    var groupCtx = (0, $ggE0n.useContext)($13b1a1463e05bd62$var$$07b14b47974efb58$var$PopoverGroupContext);
    var isSubPopover = groupCtx && props.trigger === 'SubmenuTrigger';
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (arrowRef.current && state.isOpen) setArrowWidth(arrowRef.current.getBoundingClientRect().width);
    }, [
        state.isOpen,
        arrowRef
    ]);
    var _props_offset;
    var _$ehFet$usePopover = (0, $a4b5055efcd083ca$export$542a6fd13ac93354)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        offset: (_props_offset = props.offset) !== null && _props_offset !== void 0 ? _props_offset : 8,
        arrowSize: arrowWidth,
        // If this is a submenu/subdialog, use the root popover's container
        // to detect outside interaction and add aria-hidden.
        groupRef: isSubPopover ? groupCtx : containerRef
    }), state), popoverProps = _$ehFet$usePopover.popoverProps, underlayProps = _$ehFet$usePopover.underlayProps, arrowProps = _$ehFet$usePopover.arrowProps, placement = _$ehFet$usePopover.placement;
    var ref = props.popoverRef;
    var isEntering = (0, $7bf9e6b27a0164fe$export$6d3443f2c48bfc20)(ref, !!placement) || props.isEntering || false;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        defaultClassName: 'react-aria-Popover',
        values: {
            trigger: props.trigger || null,
            placement: placement,
            isEntering: isEntering,
            isExiting: isExiting
        }
    }));
    // Automatically render Popover with role=dialog except when isNonModal is true,
    // or a dialog is already nested inside the popover.
    var shouldBeDialog = !props.isNonModal || props.trigger === 'SubmenuTrigger';
    var _$ehFet$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isDialog = _$ehFet$useState1[0], setDialog = _$ehFet$useState1[1];
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (ref.current) setDialog(shouldBeDialog && !ref.current.querySelector('[role=dialog]'));
    }, [
        ref,
        shouldBeDialog
    ]);
    (0, $ggE0n.useEffect)(function() {
        if (isDialog && ref.current && !ref.current.contains(document.activeElement)) (0, $9134fa2a0acdb388$export$80f3e147d781571c)(ref.current);
    }, [
        isDialog,
        ref
    ]);
    var children = (0, $ggE0n.useMemo)(function() {
        var children = renderProps.children;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (clearContexts) try {
            for(var _iterator = clearContexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var Context = _step.value;
                children = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Context.Provider, {
                    value: null
                }, children);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return children;
    }, [
        renderProps.children,
        clearContexts
    ]);
    var style = (0, $2QPpE._)({}, popoverProps.style, renderProps.style);
    var overlay = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)((0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), popoverProps), renderProps), {
        role: isDialog ? 'dialog' : undefined,
        tabIndex: isDialog ? -1 : undefined,
        "aria-label": props['aria-label'],
        "aria-labelledby": props['aria-labelledby'],
        ref: ref,
        slot: props.slot || undefined,
        style: style,
        dir: props.dir,
        "data-trigger": props.trigger,
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }), !props.isNonModal && (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $07c93e097165d85d$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $8aa3776baa04dfea$export$2de4954e8ae13b9f).Provider, {
        value: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, arrowProps), {
            placement: placement,
            ref: arrowRef
        })
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $07c93e097165d85d$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }));
    // If this is a root popover, render an extra div to act as the portal container for submenus/subdialogs.
    if (!isSubPopover) return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f6c6a069114ca6a7$export$c6fdb837b070b4ff), (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        shouldContainFocus: isDialog,
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer
    }), !props.isNonModal && state.isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        "data-testid": "underlay"
    }, underlayProps), {
        style: {
            position: 'fixed',
            inset: 0
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", {
        ref: containerRef,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($13b1a1463e05bd62$var$$07b14b47974efb58$var$PopoverGroupContext.Provider, {
        value: containerRef
    }, overlay)));
    var _ref;
    // Submenus/subdialogs are mounted into the root popover's container.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f6c6a069114ca6a7$export$c6fdb837b070b4ff), (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        shouldContainFocus: isDialog,
        isExiting: isExiting,
        portalContainer: (_ref = UNSTABLE_portalContainer !== null && UNSTABLE_portalContainer !== void 0 ? UNSTABLE_portalContainer : groupCtx === null || groupCtx === void 0 ? void 0 : groupCtx.current) !== null && _ref !== void 0 ? _ref : undefined
    }), overlay);
}



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $3Hxpr = parcelRequire("3Hxpr");

var $83AyS = parcelRequire("83AyS");

var $2QPpE = parcelRequire("2QPpE");




var $2QPpE = parcelRequire("2QPpE");



var $90NkU = parcelRequire("90NkU");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $3Hxpr = parcelRequire("3Hxpr");

var $90NkU = parcelRequire("90NkU");

var $4148727eaffbac3a$export$d68d59712b04d9d1 = /*#__PURE__*/ function() {
    "use strict";
    function $23b9f4fcf0fe224b$export$d68d59712b04d9d1(type, key) {
        (0, $gpEpt._)(this, $23b9f4fcf0fe224b$export$d68d59712b04d9d1);
        this.value = null;
        this.level = 0;
        this.hasChildNodes = false;
        this.rendered = null;
        this.textValue = '';
        this['aria-label'] = undefined;
        this.index = 0;
        this.parentKey = null;
        this.prevKey = null;
        this.nextKey = null;
        this.firstChildKey = null;
        this.lastChildKey = null;
        this.props = {};
        this.colSpan = null;
        this.colIndex = null;
        this.type = type;
        this.key = key;
    }
    (0, $eOJ9o._)($23b9f4fcf0fe224b$export$d68d59712b04d9d1, [
        {
            key: "childNodes",
            get: function get() {
                throw new Error('childNodes is not supported');
            }
        },
        {
            key: "clone",
            value: function clone() {
                var node = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(this.type, this.key);
                node.value = this.value;
                node.level = this.level;
                node.hasChildNodes = this.hasChildNodes;
                node.rendered = this.rendered;
                node.textValue = this.textValue;
                node['aria-label'] = this['aria-label'];
                node.index = this.index;
                node.parentKey = this.parentKey;
                node.prevKey = this.prevKey;
                node.nextKey = this.nextKey;
                node.firstChildKey = this.firstChildKey;
                node.lastChildKey = this.lastChildKey;
                node.props = this.props;
                node.render = this.render;
                node.colSpan = this.colSpan;
                node.colIndex = this.colIndex;
                return node;
            }
        }
    ]);
    return $23b9f4fcf0fe224b$export$d68d59712b04d9d1;
}();
var $4148727eaffbac3a$export$408d25a4e12db025 = /*#__PURE__*/ function() {
    "use strict";
    function $23b9f4fcf0fe224b$export$408d25a4e12db025() {
        (0, $gpEpt._)(this, $23b9f4fcf0fe224b$export$408d25a4e12db025);
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.frozen = false;
    }
    (0, $eOJ9o._)($23b9f4fcf0fe224b$export$408d25a4e12db025, [
        {
            key: "size",
            get: function get() {
                return this.keyMap.size;
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                return this.keyMap.keys();
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                var node;
                return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            node = this.firstKey != null ? this.keyMap.get(this.firstKey) : undefined;
                            _state.label = 1;
                        case 1:
                            if (!node) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                node
                            ];
                        case 2:
                            _state.sent();
                            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : undefined;
                            return [
                                3,
                                1
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "getChildren",
            value: function getChildren(key) {
                var keyMap = this.keyMap;
                return (0, $3Hxpr._)({}, Symbol.iterator, function() {
                    var parent, node;
                    return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                parent = keyMap.get(key);
                                node = (parent === null || parent === void 0 ? void 0 : parent.firstChildKey) != null ? keyMap.get(parent.firstChildKey) : null;
                                _state.label = 1;
                            case 1:
                                if (!node) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    node
                                ];
                            case 2:
                                _state.sent();
                                node = node.nextKey != null ? keyMap.get(node.nextKey) : undefined;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getKeyBefore",
            value: function getKeyBefore(key) {
                var node = this.keyMap.get(key);
                if (!node) return null;
                if (node.prevKey != null) {
                    node = this.keyMap.get(node.prevKey);
                    while(node && node.type !== 'item' && node.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
                    var _node_key;
                    return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
                }
                return node.parentKey;
            }
        },
        {
            key: "getKeyAfter",
            value: function getKeyAfter(key) {
                var node = this.keyMap.get(key);
                if (!node) return null;
                if (node.type !== 'item' && node.firstChildKey != null) return node.firstChildKey;
                while(node){
                    if (node.nextKey != null) return node.nextKey;
                    if (node.parentKey != null) node = this.keyMap.get(node.parentKey);
                    else return null;
                }
                return null;
            }
        },
        {
            key: "getFirstKey",
            value: function getFirstKey() {
                return this.firstKey;
            }
        },
        {
            key: "getLastKey",
            value: function getLastKey() {
                var node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
                while((node === null || node === void 0 ? void 0 : node.lastChildKey) != null)node = this.keyMap.get(node.lastChildKey);
                var _node_key;
                return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                var _this_keyMap_get;
                return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
            }
        },
        {
            key: "at",
            value: function at() {
                throw new Error('Not implemented');
            }
        },
        {
            key: "clone",
            value: function clone() {
                // We need to clone using this.constructor so that subclasses have the right prototype.
                // TypeScript isn't happy about this yet.
                // https://github.com/microsoft/TypeScript/issues/3841
                var Constructor = this.constructor;
                var collection = new Constructor();
                collection.keyMap = new Map(this.keyMap);
                collection.firstKey = this.firstKey;
                collection.lastKey = this.lastKey;
                return collection;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                if (this.frozen) throw new Error('Cannot add a node to a frozen collection');
                this.keyMap.set(node.key, node);
            }
        },
        {
            key: "removeNode",
            value: function removeNode(key) {
                if (this.frozen) throw new Error('Cannot remove a node to a frozen collection');
                this.keyMap.delete(key);
            }
        },
        {
            key: "commit",
            value: function commit(firstKey, lastKey) {
                var isSSR = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.frozen) throw new Error('Cannot commit a frozen collection');
                this.firstKey = firstKey;
                this.lastKey = lastKey;
                this.frozen = !isSSR;
            }
        },
        {
            // TODO: this is pretty specific to menu, will need to check if it is generic enough
            // Will need to handle varying levels I assume but will revisit after I get searchable menu working for base menu
            // TODO: an alternative is to simply walk the collection and add all item nodes that match the filter and any sections/separators we encounter
            // to an array, then walk that new array and fix all the next/Prev keys while adding them to the new collection
            key: "UNSTABLE_filter",
            value: function UNSTABLE_filter(filterFn) {
                var newCollection = new $23b9f4fcf0fe224b$export$408d25a4e12db025();
                // This tracks the absolute last node we've visited in the collection when filtering, used for setting up the filteredCollection's lastKey and
                // for updating the next/prevKey for every non-filtered node.
                var lastNode = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        if (node.type === 'section' && node.hasChildNodes) {
                            var clonedSection = node.clone();
                            var lastChildInSection = null;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = this.getChildren(node.key)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var child = _step1.value;
                                    if ($4148727eaffbac3a$var$$23b9f4fcf0fe224b$var$shouldKeepNode(child, filterFn, this, newCollection)) {
                                        var clonedChild = child.clone();
                                        // eslint-disable-next-line max-depth
                                        if (lastChildInSection == null) clonedSection.firstChildKey = clonedChild.key;
                                        // eslint-disable-next-line max-depth
                                        if (newCollection.firstKey == null) newCollection.firstKey = clonedSection.key;
                                        // eslint-disable-next-line max-depth
                                        if (lastChildInSection && lastChildInSection.parentKey === clonedChild.parentKey) {
                                            lastChildInSection.nextKey = clonedChild.key;
                                            clonedChild.prevKey = lastChildInSection.key;
                                        } else clonedChild.prevKey = null;
                                        clonedChild.nextKey = null;
                                        newCollection.addNode(clonedChild);
                                        lastChildInSection = clonedChild;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            // Add newly filtered section to collection if it has any valid child nodes, otherwise remove it and its header if any
                            if (lastChildInSection) {
                                if (lastChildInSection.type !== 'header') {
                                    clonedSection.lastChildKey = lastChildInSection.key;
                                    // If the old prev section was filtered out, will need to attach to whatever came before
                                    // eslint-disable-next-line max-depth
                                    if (lastNode == null) clonedSection.prevKey = null;
                                    else if (lastNode.type === 'section' || lastNode.type === 'separator') {
                                        lastNode.nextKey = clonedSection.key;
                                        clonedSection.prevKey = lastNode.key;
                                    }
                                    clonedSection.nextKey = null;
                                    lastNode = clonedSection;
                                    newCollection.addNode(clonedSection);
                                } else {
                                    if (newCollection.firstKey === clonedSection.key) newCollection.firstKey = null;
                                    newCollection.removeNode(lastChildInSection.key);
                                }
                            }
                        } else if (node.type === 'separator') {
                            // will need to check if previous section key exists, if it does then we add the separator to the collection.
                            // After the full collection is created we'll need to remove it it is the last node in the section (aka no following section after the separator)
                            var clonedSeparator = node.clone();
                            clonedSeparator.nextKey = null;
                            if ((lastNode === null || lastNode === void 0 ? void 0 : lastNode.type) === 'section') {
                                lastNode.nextKey = clonedSeparator.key;
                                clonedSeparator.prevKey = lastNode.key;
                                lastNode = clonedSeparator;
                                newCollection.addNode(clonedSeparator);
                            }
                        } else {
                            // At this point, the node is either a subdialogtrigger node or a standard row/item
                            var clonedNode = node.clone();
                            if ($4148727eaffbac3a$var$$23b9f4fcf0fe224b$var$shouldKeepNode(clonedNode, filterFn, this, newCollection)) {
                                if (newCollection.firstKey == null) newCollection.firstKey = clonedNode.key;
                                if (lastNode != null && lastNode.type !== 'section' && lastNode.type !== 'separator' && lastNode.parentKey === clonedNode.parentKey) {
                                    lastNode.nextKey = clonedNode.key;
                                    clonedNode.prevKey = lastNode.key;
                                } else clonedNode.prevKey = null;
                                clonedNode.nextKey = null;
                                newCollection.addNode(clonedNode);
                                lastNode = clonedNode;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if ((lastNode === null || lastNode === void 0 ? void 0 : lastNode.type) === 'separator' && lastNode.nextKey === null) {
                    var lastSection;
                    if (lastNode.prevKey != null) {
                        lastSection = newCollection.getItem(lastNode.prevKey);
                        lastSection.nextKey = null;
                    }
                    newCollection.removeNode(lastNode.key);
                    lastNode = lastSection;
                }
                newCollection.lastKey = (lastNode === null || lastNode === void 0 ? void 0 : lastNode.key) || null;
                return newCollection;
            }
        }
    ]);
    return $23b9f4fcf0fe224b$export$408d25a4e12db025;
}();
function $4148727eaffbac3a$var$$23b9f4fcf0fe224b$var$shouldKeepNode(node, filterFn, oldCollection, newCollection) {
    if (node.type === 'subdialogtrigger' || node.type === 'submenutrigger') {
        // Subdialog wrapper should only have one child, if it passes the filter add it to the new collection since we don't need to
        // do any extra handling for its first/next key
        var triggerChild = (0, $90NkU._)(oldCollection.getChildren(node.key))[0];
        if (triggerChild && filterFn(triggerChild.textValue)) {
            var clonedChild = triggerChild.clone();
            newCollection.addNode(clonedChild);
            return true;
        } else return false;
    } else if (node.type === 'header') return true;
    else return filterFn(node.textValue);
}



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $83AyS = parcelRequire("83AyS");



/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8d55ea1ab8df4077$export$410b0c854570d131 = /*#__PURE__*/ function() {
    "use strict";
    function $681cc3c98f569e39$export$410b0c854570d131(ownerDocument) {
        (0, $gpEpt._)(this, $681cc3c98f569e39$export$410b0c854570d131);
        this._firstChild = null;
        this._lastChild = null;
        this._previousSibling = null;
        this._nextSibling = null;
        this._parentNode = null;
        this._minInvalidChildIndex = null;
        this.ownerDocument = ownerDocument;
    }
    (0, $eOJ9o._)($681cc3c98f569e39$export$410b0c854570d131, [
        {
            key: Symbol.iterator,
            value: function value1() {
                var node;
                return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            node = this.firstChild;
                            _state.label = 1;
                        case 1:
                            if (!node) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                node
                            ];
                        case 2:
                            _state.sent();
                            node = node.nextSibling;
                            return [
                                3,
                                1
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "firstChild",
            get: function get() {
                return this._firstChild;
            },
            set: function set(firstChild) {
                this._firstChild = firstChild;
                this.ownerDocument.markDirty(this);
            }
        },
        {
            key: "lastChild",
            get: function get() {
                return this._lastChild;
            },
            set: function set(lastChild) {
                this._lastChild = lastChild;
                this.ownerDocument.markDirty(this);
            }
        },
        {
            key: "previousSibling",
            get: function get() {
                return this._previousSibling;
            },
            set: function set(previousSibling) {
                this._previousSibling = previousSibling;
                this.ownerDocument.markDirty(this);
            }
        },
        {
            key: "nextSibling",
            get: function get() {
                return this._nextSibling;
            },
            set: function set(nextSibling) {
                this._nextSibling = nextSibling;
                this.ownerDocument.markDirty(this);
            }
        },
        {
            key: "parentNode",
            get: function get() {
                return this._parentNode;
            },
            set: function set(parentNode) {
                this._parentNode = parentNode;
                this.ownerDocument.markDirty(this);
            }
        },
        {
            key: "isConnected",
            get: function get() {
                var _this_parentNode;
                return ((_this_parentNode = this.parentNode) === null || _this_parentNode === void 0 ? void 0 : _this_parentNode.isConnected) || false;
            }
        },
        {
            key: "invalidateChildIndices",
            value: function invalidateChildIndices(child) {
                if (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || child.index < this._minInvalidChildIndex.index) {
                    this._minInvalidChildIndex = child;
                    this.ownerDocument.markDirty(this);
                }
            }
        },
        {
            key: "updateChildIndices",
            value: function updateChildIndices() {
                var node = this._minInvalidChildIndex;
                while(node){
                    node.index = node.previousSibling ? node.previousSibling.index + 1 : 0;
                    node = node.nextSibling;
                }
                this._minInvalidChildIndex = null;
            }
        },
        {
            key: "appendChild",
            value: function appendChild(child) {
                if (child.parentNode) child.parentNode.removeChild(child);
                if (this.firstChild == null) this.firstChild = child;
                if (this.lastChild) {
                    this.lastChild.nextSibling = child;
                    child.index = this.lastChild.index + 1;
                    child.previousSibling = this.lastChild;
                } else {
                    child.previousSibling = null;
                    child.index = 0;
                }
                child.parentNode = this;
                child.nextSibling = null;
                this.lastChild = child;
                this.ownerDocument.markDirty(this);
                if (this.isConnected) this.ownerDocument.queueUpdate();
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(newNode, referenceNode) {
                if (referenceNode == null) return this.appendChild(newNode);
                if (newNode.parentNode) newNode.parentNode.removeChild(newNode);
                newNode.nextSibling = referenceNode;
                newNode.previousSibling = referenceNode.previousSibling;
                // Ensure that the newNode's index is less than that of the reference node so that
                // invalidateChildIndices will properly use the newNode as the _minInvalidChildIndex, thus making sure
                // we will properly update the indexes of all sibiling nodes after the newNode. The value here doesn't matter
                // since updateChildIndices should calculate the proper indexes.
                newNode.index = referenceNode.index - 1;
                if (this.firstChild === referenceNode) this.firstChild = newNode;
                else if (referenceNode.previousSibling) referenceNode.previousSibling.nextSibling = newNode;
                referenceNode.previousSibling = newNode;
                newNode.parentNode = referenceNode.parentNode;
                this.invalidateChildIndices(newNode);
                if (this.isConnected) this.ownerDocument.queueUpdate();
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                if (child.parentNode !== this || !this.ownerDocument.isMounted) return;
                if (this._minInvalidChildIndex === child) this._minInvalidChildIndex = null;
                if (child.nextSibling) {
                    this.invalidateChildIndices(child.nextSibling);
                    child.nextSibling.previousSibling = child.previousSibling;
                }
                if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
                if (this.firstChild === child) this.firstChild = child.nextSibling;
                if (this.lastChild === child) this.lastChild = child.previousSibling;
                child.parentNode = null;
                child.nextSibling = null;
                child.previousSibling = null;
                child.index = 0;
                this.ownerDocument.markDirty(child);
                if (this.isConnected) this.ownerDocument.queueUpdate();
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener() {}
        },
        {
            key: "removeEventListener",
            value: function removeEventListener() {}
        },
        {
            key: "previousVisibleSibling",
            get: function get() {
                var node = this.previousSibling;
                while(node && node.isHidden)node = node.previousSibling;
                return node;
            }
        },
        {
            key: "nextVisibleSibling",
            get: function get() {
                var node = this.nextSibling;
                while(node && node.isHidden)node = node.nextSibling;
                return node;
            }
        },
        {
            key: "firstVisibleChild",
            get: function get() {
                var node = this.firstChild;
                while(node && node.isHidden)node = node.nextSibling;
                return node;
            }
        },
        {
            key: "lastVisibleChild",
            get: function get() {
                var node = this.lastChild;
                while(node && node.isHidden)node = node.previousSibling;
                return node;
            }
        }
    ]);
    return $681cc3c98f569e39$export$410b0c854570d131;
}();
var $8d55ea1ab8df4077$export$dc064fe9e59310fd = /*#__PURE__*/ function($681cc3c98f569e39$export$410b0c854570d131) {
    "use strict";
    (0, $83AyS._)($681cc3c98f569e39$export$dc064fe9e59310fd, $681cc3c98f569e39$export$410b0c854570d131);
    function $681cc3c98f569e39$export$dc064fe9e59310fd(type, ownerDocument) {
        (0, $gpEpt._)(this, $681cc3c98f569e39$export$dc064fe9e59310fd);
        var _this;
        _this = (0, $3qQ3j._)(this, $681cc3c98f569e39$export$dc064fe9e59310fd, [
            ownerDocument
        ]), _this.nodeType = 8 // COMMENT_NODE (we'd use ELEMENT_NODE but React DevTools will fail to get its dimensions)
        , _this.isMutated = true, _this._index = 0, _this.hasSetProps = false, _this.isHidden = false;
        _this.node = new (0, $4148727eaffbac3a$export$d68d59712b04d9d1)(type, "react-aria-".concat(++ownerDocument.nodeId));
        return _this;
    }
    (0, $eOJ9o._)($681cc3c98f569e39$export$dc064fe9e59310fd, [
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(index) {
                this._index = index;
                this.ownerDocument.markDirty(this);
            }
        },
        {
            key: "level",
            get: function get() {
                if (this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd) return this.parentNode.level + (this.node.type === 'item' ? 1 : 0);
                return 0;
            }
        },
        {
            /**
   * Lazily gets a mutable instance of a Node. If the node has already
   * been cloned during this update cycle, it just returns the existing one.
   */ key: "getMutableNode",
            value: function getMutableNode() {
                if (!this.isMutated) {
                    this.node = this.node.clone();
                    this.isMutated = true;
                }
                this.ownerDocument.markDirty(this);
                return this.node;
            }
        },
        {
            key: "updateNode",
            value: function updateNode() {
                var _this_previousVisibleSibling, _this_firstVisibleChild, _this_lastVisibleChild;
                var nextSibling = this.nextVisibleSibling;
                var node = this.getMutableNode();
                node.index = this.index;
                node.level = this.level;
                node.parentKey = this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.node.key : null;
                var _this_previousVisibleSibling_node_key;
                node.prevKey = (_this_previousVisibleSibling_node_key = (_this_previousVisibleSibling = this.previousVisibleSibling) === null || _this_previousVisibleSibling === void 0 ? void 0 : _this_previousVisibleSibling.node.key) !== null && _this_previousVisibleSibling_node_key !== void 0 ? _this_previousVisibleSibling_node_key : null;
                var _nextSibling_node_key;
                node.nextKey = (_nextSibling_node_key = nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.node.key) !== null && _nextSibling_node_key !== void 0 ? _nextSibling_node_key : null;
                node.hasChildNodes = !!this.firstChild;
                var _this_firstVisibleChild_node_key;
                node.firstChildKey = (_this_firstVisibleChild_node_key = (_this_firstVisibleChild = this.firstVisibleChild) === null || _this_firstVisibleChild === void 0 ? void 0 : _this_firstVisibleChild.node.key) !== null && _this_firstVisibleChild_node_key !== void 0 ? _this_firstVisibleChild_node_key : null;
                var _this_lastVisibleChild_node_key;
                node.lastChildKey = (_this_lastVisibleChild_node_key = (_this_lastVisibleChild = this.lastVisibleChild) === null || _this_lastVisibleChild === void 0 ? void 0 : _this_lastVisibleChild.node.key) !== null && _this_lastVisibleChild_node_key !== void 0 ? _this_lastVisibleChild_node_key : null;
                // Update the colIndex of sibling nodes if this node has a colSpan.
                if ((node.colSpan != null || node.colIndex != null) && nextSibling) {
                    var _node_colIndex, _node_colSpan;
                    // This queues the next sibling for update, which means this happens recursively.
                    var nextColIndex = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + ((_node_colSpan = node.colSpan) !== null && _node_colSpan !== void 0 ? _node_colSpan : 1);
                    if (nextColIndex !== nextSibling.node.colIndex) {
                        var siblingNode = nextSibling.getMutableNode();
                        siblingNode.colIndex = nextColIndex;
                    }
                }
            }
        },
        {
            key: "setProps",
            value: function setProps(obj, ref, rendered, render) {
                var node = this.getMutableNode();
                var value1 = obj.value, textValue = obj.textValue, id = obj.id, props = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(obj, [
                    "value",
                    "textValue",
                    "id"
                ]);
                props.ref = ref;
                node.props = props;
                node.rendered = rendered;
                node.render = render;
                node.value = value1;
                node.textValue = textValue || (typeof props.children === 'string' ? props.children : '') || obj['aria-label'] || '';
                if (id != null && id !== node.key) {
                    if (this.hasSetProps) throw new Error('Cannot change the id of an item');
                    node.key = id;
                }
                if (props.colSpan != null) node.colSpan = props.colSpan;
                this.hasSetProps = true;
                if (this.isConnected) this.ownerDocument.queueUpdate();
            }
        },
        {
            key: "style",
            get: function get() {
                // React sets display: none to hide elements during Suspense.
                // We'll handle this by setting the element to hidden and invalidating
                // its siblings/parent. Hidden elements remain in the Document, but
                // are removed from the Collection.
                var element = this;
                return {
                    get display () {
                        return element.isHidden ? 'none' : '';
                    },
                    set display (value){
                        var isHidden = value === 'none';
                        if (element.isHidden !== isHidden) {
                            var _element_parentNode, _element_parentNode1;
                            // Mark parent node dirty if this element is currently the first or last visible child.
                            if (((_element_parentNode = element.parentNode) === null || _element_parentNode === void 0 ? void 0 : _element_parentNode.firstVisibleChild) === element || ((_element_parentNode1 = element.parentNode) === null || _element_parentNode1 === void 0 ? void 0 : _element_parentNode1.lastVisibleChild) === element) element.ownerDocument.markDirty(element.parentNode);
                            // Mark sibling visible elements dirty.
                            var prev = element.previousVisibleSibling;
                            var next = element.nextVisibleSibling;
                            if (prev) element.ownerDocument.markDirty(prev);
                            if (next) element.ownerDocument.markDirty(next);
                            // Mark self dirty.
                            element.isHidden = isHidden;
                            element.ownerDocument.markDirty(element);
                        }
                    }
                };
            }
        },
        {
            key: "hasAttribute",
            value: function hasAttribute() {}
        },
        {
            key: "setAttribute",
            value: function setAttribute() {}
        },
        {
            key: "setAttributeNS",
            value: function setAttributeNS() {}
        },
        {
            key: "removeAttribute",
            value: function removeAttribute() {}
        }
    ]);
    return $681cc3c98f569e39$export$dc064fe9e59310fd;
}($8d55ea1ab8df4077$export$410b0c854570d131);
var $8d55ea1ab8df4077$export$b34a105447964f9f = /*#__PURE__*/ function($681cc3c98f569e39$export$410b0c854570d131) {
    "use strict";
    (0, $83AyS._)($681cc3c98f569e39$export$b34a105447964f9f, $681cc3c98f569e39$export$410b0c854570d131);
    function $681cc3c98f569e39$export$b34a105447964f9f(collection) {
        (0, $gpEpt._)(this, $681cc3c98f569e39$export$b34a105447964f9f);
        var _this;
        // @ts-ignore
        _this = (0, $3qQ3j._)(this, $681cc3c98f569e39$export$b34a105447964f9f, [
            null
        ]), _this.nodeType = 11 // DOCUMENT_FRAGMENT_NODE
        , _this.ownerDocument = _this, _this.dirtyNodes = new Set(), _this.isSSR = false, _this.nodeId = 0, _this.nodesByProps = new WeakMap(), _this.isMounted = true, _this.nextCollection = null, _this.subscriptions = new Set(), _this.queuedRender = false, _this.inSubscription = false;
        _this.collection = collection;
        _this.nextCollection = collection;
        return _this;
    }
    (0, $eOJ9o._)($681cc3c98f569e39$export$b34a105447964f9f, [
        {
            key: "isConnected",
            get: function get() {
                return this.isMounted;
            }
        },
        {
            key: "createElement",
            value: function createElement(type) {
                return new $8d55ea1ab8df4077$export$dc064fe9e59310fd(type, this);
            }
        },
        {
            key: "getMutableCollection",
            value: function getMutableCollection() {
                if (!this.nextCollection) this.nextCollection = this.collection.clone();
                return this.nextCollection;
            }
        },
        {
            key: "markDirty",
            value: function markDirty(node) {
                this.dirtyNodes.add(node);
            }
        },
        {
            key: "addNode",
            value: function addNode(element) {
                if (element.isHidden) return;
                var collection = this.getMutableCollection();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (!collection.getItem(element.node.key)) try {
                    for(var _iterator = element[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this.addNode(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                collection.addNode(element.node);
            }
        },
        {
            key: "removeNode",
            value: function removeNode(node) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = node[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this.removeNode(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var collection = this.getMutableCollection();
                collection.removeNode(node.node.key);
            }
        },
        {
            /** Finalizes the collection update, updating all nodes and freezing the collection. */ key: "getCollection",
            value: function getCollection() {
                // If in a subscription update, return a clone of the existing collection.
                // This ensures React will queue a render. React will call getCollection again
                // during render, at which point all the updates will be complete and we can return
                // the new collection.
                if (this.inSubscription) return this.collection.clone();
                // Reset queuedRender to false when getCollection is called during render.
                this.queuedRender = false;
                this.updateCollection();
                return this.collection;
            }
        },
        {
            key: "updateCollection",
            value: function updateCollection() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // First, remove disconnected nodes and update the indices of dirty element children.
                    for(var _iterator = this.dirtyNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (element instanceof $8d55ea1ab8df4077$export$dc064fe9e59310fd && (!element.isConnected || element.isHidden)) this.removeNode(element);
                        else element.updateChildIndices();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Next, update dirty collection nodes.
                    for(var _iterator1 = this.dirtyNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var element1 = _step1.value;
                        if (element1 instanceof $8d55ea1ab8df4077$export$dc064fe9e59310fd) {
                            if (element1.isConnected && !element1.isHidden) {
                                element1.updateNode();
                                this.addNode(element1);
                            }
                            element1.isMutated = false;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                this.dirtyNodes.clear();
                // Finally, update the collection.
                if (this.nextCollection) {
                    var _this_firstVisibleChild, _this_lastVisibleChild;
                    var _this_firstVisibleChild_node_key, _this_lastVisibleChild_node_key;
                    this.nextCollection.commit((_this_firstVisibleChild_node_key = (_this_firstVisibleChild = this.firstVisibleChild) === null || _this_firstVisibleChild === void 0 ? void 0 : _this_firstVisibleChild.node.key) !== null && _this_firstVisibleChild_node_key !== void 0 ? _this_firstVisibleChild_node_key : null, (_this_lastVisibleChild_node_key = (_this_lastVisibleChild = this.lastVisibleChild) === null || _this_lastVisibleChild === void 0 ? void 0 : _this_lastVisibleChild.node.key) !== null && _this_lastVisibleChild_node_key !== void 0 ? _this_lastVisibleChild_node_key : null, this.isSSR);
                    if (!this.isSSR) {
                        this.collection = this.nextCollection;
                        this.nextCollection = null;
                    }
                }
            }
        },
        {
            key: "queueUpdate",
            value: function queueUpdate() {
                if (this.dirtyNodes.size === 0 || this.queuedRender) return;
                // Only trigger subscriptions once during an update, when the first item changes.
                // React's useSyncExternalStore will call getCollection immediately, to check whether the snapshot changed.
                // If so, React will queue a render to happen after the current commit to our fake DOM finishes.
                // We track whether getCollection is called in a subscription, and once it is called during render,
                // we reset queuedRender back to false.
                this.queuedRender = true;
                this.inSubscription = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.subscriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fn = _step.value;
                        fn();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.inSubscription = false;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscriptions.add(fn);
                return function() {
                    return _this.subscriptions.delete(fn);
                };
            }
        },
        {
            key: "resetAfterSSR",
            value: function resetAfterSSR() {
                if (this.isSSR) {
                    this.isSSR = false;
                    this.firstChild = null;
                    this.lastChild = null;
                    this.nodeId = 0;
                }
            }
        }
    ]);
    return $681cc3c98f569e39$export$b34a105447964f9f;
}($8d55ea1ab8df4077$export$410b0c854570d131);



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $414393ab94c55ee2$export$727c8fc270210f13(props) {
    var children = props.children, items = props.items, idScope = props.idScope, addIdAndValue = props.addIdAndValue, tmp = props.dependencies, dependencies = tmp === void 0 ? [] : tmp;
    // Invalidate the cache whenever the parent value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var cache = (0, $ggE0n.useMemo)(function() {
        return new WeakMap();
    }, dependencies);
    return (0, $ggE0n.useMemo)(function() {
        if (items && typeof children === 'function') {
            var res = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    var rendered = cache.get(item);
                    if (!rendered) {
                        rendered = children(item);
                        var _rendered_props_id, _ref;
                        // @ts-ignore
                        var key = (_ref = (_rendered_props_id = rendered.props.id) !== null && _rendered_props_id !== void 0 ? _rendered_props_id : item.key) !== null && _ref !== void 0 ? _ref : item.id;
                        if (key == null) throw new Error('Could not determine key for item');
                        if (idScope) key = idScope + ':' + key;
                        // Note: only works if wrapped Item passes through id...
                        rendered = (0, $ggE0n.cloneElement)(rendered, addIdAndValue ? {
                            key: key,
                            id: key,
                            value: item
                        } : {
                            key: key
                        });
                        cache.set(item, rendered);
                    }
                    res.push(rendered);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return res;
        } else if (typeof children !== 'function') return children;
    }, [
        children,
        items,
        cache,
        idScope,
        addIdAndValue
    ]);
}




var $3og2D = parcelRequire("3og2D");


var $ggE0n = parcelRequire("ggE0n");



/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $94f17837fc908958$var$$e1995378a142960e$var$ShallowRenderContext = (0, $ggE0n.createContext)(false);
var $94f17837fc908958$var$$e1995378a142960e$var$CollectionDocumentContext = (0, $ggE0n.createContext)(null);
function $94f17837fc908958$export$bf788dd355e3a401(props) {
    // If a document was provided above us, we're already in a hidden tree. Just render the content.
    var doc = (0, $ggE0n.useContext)($94f17837fc908958$var$$e1995378a142960e$var$CollectionDocumentContext);
    if (doc) // even though the actual implementation since React 16 did.
    // We must return ReactElement so that TS does not complain that <CollectionBuilder>
    // is not a valid JSX element with React 16 and 17 types.
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return props.content;
    // Otherwise, render a hidden copy of the children so that we can build the collection before constructing the state.
    // This should always come before the real DOM content so we have built the collection by the time it renders during SSR.
    // This is fine. CollectionDocumentContext never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _$e1995378a142960e$var$useCollectionDocument = $94f17837fc908958$var$$e1995378a142960e$var$useCollectionDocument(props.createCollection), collection = _$e1995378a142960e$var$useCollectionDocument.collection, document = _$e1995378a142960e$var$useCollectionDocument.document;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $cfc4721022845f0c$export$8dc98ba7eadeaa56), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$CollectionDocumentContext.Provider, {
        value: document
    }, props.content)), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$CollectionInner, {
        render: props.children,
        collection: collection
    }));
}
function $94f17837fc908958$var$$e1995378a142960e$var$CollectionInner(param) {
    var collection = param.collection, render = param.render;
    return render(collection);
}
// React 16 and 17 don't support useSyncExternalStore natively, and the shim provided by React does not support getServerSnapshot.
// This wrapper uses the shim, but additionally calls getServerSnapshot during SSR (according to SSRProvider).
function $94f17837fc908958$var$$e1995378a142960e$var$useSyncExternalStoreFallback(subscribe, getSnapshot, getServerSnapshot) {
    var isSSR = (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)();
    var isSSRRef = (0, $ggE0n.useRef)(isSSR);
    // This is read immediately inside the wrapper, which also runs during render.
    // We just need a ref to avoid invalidating the callback itself, which
    // would cause React to re-run the callback more than necessary.
    // eslint-disable-next-line rulesdir/pure-render
    isSSRRef.current = isSSR;
    var getSnapshotWrapper = (0, $ggE0n.useCallback)(function() {
        return isSSRRef.current ? getServerSnapshot() : getSnapshot();
    }, [
        getSnapshot,
        getServerSnapshot
    ]);
    return (0, $193a666be44e8045$exports.useSyncExternalStore)(subscribe, getSnapshotWrapper);
}
var $94f17837fc908958$var$$e1995378a142960e$var$useSyncExternalStore = typeof (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n)))['useSyncExternalStore'] === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n)))['useSyncExternalStore'] : $94f17837fc908958$var$$e1995378a142960e$var$useSyncExternalStoreFallback;
function $94f17837fc908958$var$$e1995378a142960e$var$useCollectionDocument(createCollection) {
    // The document instance is mutable, and should never change between renders.
    // useSyncExternalStore is used to subscribe to updates, which vends immutable Collection objects.
    var _$95feo$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        return new (0, $8d55ea1ab8df4077$export$b34a105447964f9f)((createCollection === null || createCollection === void 0 ? void 0 : createCollection()) || new (0, $4148727eaffbac3a$export$408d25a4e12db025)());
    }), 1), document = _$95feo$useState[0];
    var subscribe = (0, $ggE0n.useCallback)(function(fn) {
        return document.subscribe(fn);
    }, [
        document
    ]);
    var getSnapshot = (0, $ggE0n.useCallback)(function() {
        var collection = document.getCollection();
        if (document.isSSR) // We do this _after_ getting the collection above so that the collection still has content in it from SSR
        // during the current render, before React has finished the client render.
        document.resetAfterSSR();
        return collection;
    }, [
        document
    ]);
    var getServerSnapshot = (0, $ggE0n.useCallback)(function() {
        document.isSSR = true;
        return document.getCollection();
    }, [
        document
    ]);
    var collection = $94f17837fc908958$var$$e1995378a142960e$var$useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        document.isMounted = true;
        return function() {
            // Mark unmounted so we can skip all of the collection updates caused by
            // React calling removeChild on every item in the collection.
            document.isMounted = false;
        };
    }, [
        document
    ]);
    return {
        collection: collection,
        document: document
    };
}
var $94f17837fc908958$var$$e1995378a142960e$var$SSRContext = (0, $ggE0n.createContext)(null);
function $94f17837fc908958$var$$e1995378a142960e$var$useSSRCollectionNode(Type, props, ref, rendered, children, render) {
    // During SSR, portals are not supported, so the collection children will be wrapped in an SSRContext.
    // Since SSR occurs only once, we assume that the elements are rendered in order and never re-render.
    // Therefore we can create elements in our collection document during render so that they are in the
    // collection by the time we need to use the collection to render to the real DOM.
    // After hydration, we switch to client rendering using the portal.
    var itemRef = (0, $ggE0n.useCallback)(function(element) {
        element === null || element === void 0 || element.setProps(props, ref, rendered, render);
    }, [
        props,
        ref,
        rendered,
        render
    ]);
    var parentNode = (0, $ggE0n.useContext)($94f17837fc908958$var$$e1995378a142960e$var$SSRContext);
    if (parentNode) {
        // Guard against double rendering in strict mode.
        var element = parentNode.ownerDocument.nodesByProps.get(props);
        if (!element) {
            element = parentNode.ownerDocument.createElement(Type);
            element.setProps(props, ref, rendered, render);
            parentNode.appendChild(element);
            parentNode.ownerDocument.updateCollection();
            parentNode.ownerDocument.nodesByProps.set(props, element);
        }
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$SSRContext.Provider, {
            value: element
        }, children) : null;
    }
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Type, {
        ref: itemRef
    }, children);
}
function $94f17837fc908958$export$18af5c7a9e9b3664(type, render) {
    var Component = function(param) {
        var node = param.node;
        return render(node.props, node.props.ref, node);
    };
    var Result = (0, $ggE0n.forwardRef)(function(props, ref) {
        var focusableProps = (0, $ggE0n.useContext)((0, $61b10cd69c787297$export$f9762fab77588ecb));
        var isShallow = (0, $ggE0n.useContext)($94f17837fc908958$var$$e1995378a142960e$var$ShallowRenderContext);
        if (!isShallow) {
            if (render.length >= 3) throw new Error(render.name + ' cannot be rendered outside a collection.');
            return render(props, ref);
        }
        return $94f17837fc908958$var$$e1995378a142960e$var$useSSRCollectionNode(type, props, ref, 'children' in props ? props.children : null, null, function(node) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $61b10cd69c787297$export$f9762fab77588ecb).Provider, {
                value: focusableProps
            }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Component, {
                node: node
            }));
        });
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $94f17837fc908958$export$e953bb1cd0f19726(type, render) {
    var useChildren = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $94f17837fc908958$var$$e1995378a142960e$var$useCollectionChildren;
    var Component = function(param) {
        var node = param.node;
        return render(node.props, node.props.ref, node);
    };
    var Result = (0, $ggE0n.forwardRef)(function(props, ref) {
        var children = useChildren(props);
        var _useSSRCollectionNode;
        return (_useSSRCollectionNode = $94f17837fc908958$var$$e1995378a142960e$var$useSSRCollectionNode(type, props, ref, null, children, function(node) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Component, {
                node: node
            });
        })) !== null && _useSSRCollectionNode !== void 0 ? _useSSRCollectionNode : (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null);
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $94f17837fc908958$var$$e1995378a142960e$var$useCollectionChildren(options) {
    return (0, $414393ab94c55ee2$export$727c8fc270210f13)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, options), {
        addIdAndValue: true
    }));
}
var $94f17837fc908958$var$$e1995378a142960e$var$CollectionContext = (0, $ggE0n.createContext)(null);
function $94f17837fc908958$export$fb8073518f34e6ec(props) {
    var ctx = (0, $ggE0n.useContext)($94f17837fc908958$var$$e1995378a142960e$var$CollectionContext);
    var dependencies = ((ctx === null || ctx === void 0 ? void 0 : ctx.dependencies) || []).concat(props.dependencies);
    var idScope = props.idScope || (ctx === null || ctx === void 0 ? void 0 : ctx.idScope);
    var children = $94f17837fc908958$var$$e1995378a142960e$var$useCollectionChildren((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        idScope: idScope,
        dependencies: dependencies
    }));
    var doc = (0, $ggE0n.useContext)($94f17837fc908958$var$$e1995378a142960e$var$CollectionDocumentContext);
    if (doc) children = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$CollectionRoot, null, children);
    // Propagate dependencies and idScope to child collections.
    ctx = (0, $ggE0n.useMemo)(function() {
        return {
            dependencies: dependencies,
            idScope: idScope
        };
    }, [
        idScope
    ].concat((0, $90NkU._)(dependencies)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$CollectionContext.Provider, {
        value: ctx
    }, children);
}
function $94f17837fc908958$var$$e1995378a142960e$var$CollectionRoot(param) {
    var children = param.children;
    var doc = (0, $ggE0n.useContext)($94f17837fc908958$var$$e1995378a142960e$var$CollectionDocumentContext);
    var wrappedChildren = (0, $ggE0n.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$CollectionDocumentContext.Provider, {
            value: null
        }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$ShallowRenderContext.Provider, {
            value: true
        }, children));
    }, [
        children
    ]);
    // During SSR, we render the content directly, and append nodes to the document during render.
    // The collection children return null so that nothing is actually rendered into the HTML.
    return (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)() ? (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($94f17837fc908958$var$$e1995378a142960e$var$SSRContext.Provider, {
        value: doc
    }, wrappedChildren) : (0, $3og2D.createPortal)(wrappedChildren, doc);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ee24387ab14ed14c$export$d40e14dec8b060a8 = (0, $ggE0n.createContext)(null);
var $ee24387ab14ed14c$export$6e2c8f0811a474ce = (0, $94f17837fc908958$export$e953bb1cd0f19726)('section', function(props, ref, section) {
    var _$18I52$useContext = (0, $ggE0n.useContext)($ee24387ab14ed14c$export$d40e14dec8b060a8), name = _$18I52$useContext.name, render = _$18I52$useContext.render;
    return render(props, ref, section, 'react-aria-Section');
});
var $ee24387ab14ed14c$export$a164736487e3f0ae = {
    CollectionRoot: function(param) {
        var collection = param.collection, renderDropIndicator = param.renderDropIndicator;
        return $ee24387ab14ed14c$var$$7135fc7d473fd974$var$useCollectionRender(collection, null, renderDropIndicator);
    },
    CollectionBranch: function(param) {
        var collection = param.collection, parent = param.parent, renderDropIndicator = param.renderDropIndicator;
        return $ee24387ab14ed14c$var$$7135fc7d473fd974$var$useCollectionRender(collection, parent, renderDropIndicator);
    }
};
function $ee24387ab14ed14c$var$$7135fc7d473fd974$var$useCollectionRender(collection, parent, renderDropIndicator) {
    return (0, $414393ab94c55ee2$export$727c8fc270210f13)({
        items: parent ? collection.getChildren(parent.key) : collection,
        dependencies: [
            renderDropIndicator
        ],
        children: function(node) {
            var rendered = node.render(node);
            if (!renderDropIndicator || node.type !== 'item') return rendered;
            return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, renderDropIndicator({
                type: 'item',
                key: node.key,
                dropPosition: 'before'
            }), rendered, $ee24387ab14ed14c$export$2dbbd341daed716d(collection, node, renderDropIndicator));
        }
    });
}
function $ee24387ab14ed14c$export$2dbbd341daed716d(collection, node, renderDropIndicator) {
    var key = node.key;
    var keyAfter = collection.getKeyAfter(key);
    var nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    while(nextItemInFlattenedCollection != null && nextItemInFlattenedCollection.type !== 'item'){
        keyAfter = collection.getKeyAfter(nextItemInFlattenedCollection.key);
        nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    }
    var nextItemInSameLevel = node.nextKey != null ? collection.getItem(node.nextKey) : null;
    while(nextItemInSameLevel != null && nextItemInSameLevel.type !== 'item')nextItemInSameLevel = nextItemInSameLevel.nextKey != null ? collection.getItem(nextItemInSameLevel.nextKey) : null;
    // Render one or more "after" drop indicators when the next item in the flattened collection
    // has a smaller level, is not an item, or there are no more items in the collection.
    // Otherwise, the "after" position is equivalent to the next item's "before" position.
    var afterIndicators = [];
    if (nextItemInSameLevel == null) {
        var current = node;
        while(current && (!nextItemInFlattenedCollection || current.parentKey !== nextItemInFlattenedCollection.parentKey && nextItemInFlattenedCollection.level < current.level)){
            var indicator = renderDropIndicator({
                type: 'item',
                key: current.key,
                dropPosition: 'after'
            });
            if ((0, $ggE0n.isValidElement)(indicator)) afterIndicators.push((0, $ggE0n.cloneElement)(indicator, {
                key: "".concat(current.key, "-after")
            }));
            current = current.parentKey != null ? collection.getItem(current.parentKey) : null;
        }
    }
    return afterIndicators;
}
var $ee24387ab14ed14c$export$4feb769f8ddf26c5 = (0, $ggE0n.createContext)($ee24387ab14ed14c$export$a164736487e3f0ae);
function $ee24387ab14ed14c$export$90e00781bc59d8f9(focusedKey) {
    return (0, $ggE0n.useMemo)(function() {
        return focusedKey != null ? new Set([
            focusedKey
        ]) : null;
    }, [
        focusedKey
    ]);
}




var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $30c9cc7a993d0a2b$export$e0e4026c12a8bdbb = (0, $ggE0n.createContext)({});
var $30c9cc7a993d0a2b$export$8b251419efc915eb = (0, $94f17837fc908958$export$18af5c7a9e9b3664)('header', function Header(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $30c9cc7a993d0a2b$export$e0e4026c12a8bdbb), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("header", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        className: "react-aria-Header"
    }, props), {
        ref: ref
    }), props.children);
});



var $2QPpE = parcelRequire("2QPpE");




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $372108dec3fdf83d$export$744d98a3b8a94e1c = (0, $ggE0n.createContext)({});
var $372108dec3fdf83d$export$16e4d70cc375e707 = (0, $ggE0n.forwardRef)(function Keyboard(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $372108dec3fdf83d$export$744d98a3b8a94e1c), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("kbd", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        dir: "ltr"
    }, props), {
        ref: ref
    }));
});





var $2QPpE = parcelRequire("2QPpE");





var $2QPpE = parcelRequire("2QPpE");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f61ff31b02d46109$export$52210f68a14655d0(props) {
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    var ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === 'vertical') ariaOrientation = 'vertical';
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== 'hr') return {
        separatorProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, domProps), {
            role: 'separator',
            'aria-orientation': ariaOrientation
        })
    };
    return {
        separatorProps: domProps
    };
}





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4e5edef11bc269d7$export$6615d83f6de245ce = (0, $ggE0n.createContext)({});
var $4e5edef11bc269d7$export$1ff3c3f08ae963c0 = (0, $94f17837fc908958$export$18af5c7a9e9b3664)('separator', function Separator(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $4e5edef11bc269d7$export$6615d83f6de245ce), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var elementType = props.elementType, orientation = props.orientation, style = props.style, className = props.className, slot = props.slot, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "elementType",
        "orientation",
        "style",
        "className",
        "slot"
    ]);
    var Element = elementType || 'hr';
    if (Element === 'hr' && orientation === 'vertical') Element = 'div';
    var _$i9JCE$useSeparator = (0, $f61ff31b02d46109$export$52210f68a14655d0)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        elementType: elementType,
        orientation: orientation
    })), separatorProps = _$i9JCE$useSeparator.separatorProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Element, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), separatorProps), {
        style: style,
        className: className !== null && className !== void 0 ? className : 'react-aria-Separator',
        ref: ref,
        slot: slot || undefined
    }));
});



var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $fbbc6fda6285b143$export$9afb8bc826b033ea = (0, $ggE0n.createContext)({});
var $fbbc6fda6285b143$export$5f1af8db9871e1d6 = (0, $ggE0n.forwardRef)(function Text(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $fbbc6fda6285b143$export$9afb8bc826b033ea), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var tmp = props.elementType, ElementType = tmp === void 0 ? 'span' : tmp, domProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "elementType"
    ]);
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(ElementType, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        className: "react-aria-Text"
    }, domProps), {
        ref: ref
    }));
});



var $2QPpE = parcelRequire("2QPpE");


var $2QPpE = parcelRequire("2QPpE");







var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $a34d4855f0a68343$export$37fb8590cf2c088c = (0, $ggE0n.createContext)({});
var $a34d4855f0a68343$var$$3985021b0ad6602f$var$filterHoverProps = function(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onHoverStart = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "onHoverStart",
        "onHoverChange",
        "onHoverEnd"
    ]);
    return otherProps;
};
var $a34d4855f0a68343$export$f5b8910cec6cf069 = (0, $cfc4721022845f0c$export$86427a43e3e48ebb)(function Input(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $a34d4855f0a68343$export$37fb8590cf2c088c), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _$jMZTB$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)(props), hoverProps = _$jMZTB$useHover.hoverProps, isHovered = _$jMZTB$useHover.isHovered;
    var _$jMZTB$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)({
        isTextInput: true,
        autoFocus: props.autoFocus
    }), isFocused = _$jMZTB$useFocusRing.isFocused, isFocusVisible = _$jMZTB$useFocusRing.isFocusVisible, focusProps = _$jMZTB$useFocusRing.focusProps;
    var isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Input'
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("input", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)($a34d4855f0a68343$var$$3985021b0ad6602f$var$filterHoverProps(props), focusProps, hoverProps), renderProps), {
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    }));
});




var $2QPpE = parcelRequire("2QPpE");






var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $aef12de62ee30fed$export$ff05c3ac10437e03 = (0, $ggE0n.createContext)(null);
var $aef12de62ee30fed$export$f551688fc98f2e09 = (0, $ggE0n.forwardRef)(function FieldError(props, ref) {
    var validation = (0, $ggE0n.useContext)($aef12de62ee30fed$export$ff05c3ac10437e03);
    if (!(validation === null || validation === void 0 ? void 0 : validation.isInvalid)) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($aef12de62ee30fed$var$$ee014567cb39d3f0$var$FieldErrorInner, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        ref: ref
    }));
});
var $aef12de62ee30fed$var$$ee014567cb39d3f0$var$FieldErrorInner = (0, $ggE0n.forwardRef)(function(props, ref) {
    var validation = (0, $ggE0n.useContext)($aef12de62ee30fed$export$ff05c3ac10437e03);
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        defaultClassName: 'react-aria-FieldError',
        defaultChildren: validation.validationErrors.length === 0 ? undefined : validation.validationErrors.join(' '),
        values: validation
    }));
    if (renderProps.children == null) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $fbbc6fda6285b143$export$5f1af8db9871e1d6), (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        slot: "errorMessage"
    }, domProps, renderProps), {
        ref: ref
    }));
});



var $2QPpE = parcelRequire("2QPpE");





var $2QPpE = parcelRequire("2QPpE");



var $90NkU = parcelRequire("90NkU");

var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $7aa741b584fcccb5$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
var $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, $7aa741b584fcccb5$export$aca958c65c314e6c), {
    customError: true,
    valid: false
});
var $7aa741b584fcccb5$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $7aa741b584fcccb5$export$aca958c65c314e6c,
    validationErrors: []
};
var $7aa741b584fcccb5$export$571b5131b7e65c11 = (0, $ggE0n.createContext)({});
var $7aa741b584fcccb5$export$a763b9476acd3eb = '__formValidationState' + Date.now();
function $7aa741b584fcccb5$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$7aa741b584fcccb5$export$a763b9476acd3eb]) {
        var _props_$e5be200c675c3b3a$export$a763b9476acd3eb = props[$7aa741b584fcccb5$export$a763b9476acd3eb], realtimeValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.realtimeValidation, displayValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.displayValidation, updateValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.updateValidation, resetValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.resetValidation, commitValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.commitValidation;
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    var isInvalid = props.isInvalid, validationState = props.validationState, name = props.name, value = props.value, builtinValidation = props.builtinValidation, validate = props.validate, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? 'aria' : tmp;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === 'invalid');
    // If the isInvalid prop is controlled, update validation result in realtime.
    var controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    var clientError = (0, $ggE0n.useMemo)(function() {
        if (!validate || value == null) return null;
        var validateErrors = $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$runValidate(validate, value);
        return $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$getValidationResult(validateErrors);
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = undefined;
    // Get relevant server errors from the form.
    var serverErrors = (0, $ggE0n.useContext)($7aa741b584fcccb5$export$571b5131b7e65c11);
    var serverErrorMessages = (0, $ggE0n.useMemo)(function() {
        if (name) return Array.isArray(name) ? name.flatMap(function(name) {
            return $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        }) : $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    var _$69F46$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(serverErrors), 2), lastServerErrors = _$69F46$useState[0], setLastServerErrors = _$69F46$useState[1];
    var _$69F46$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isServerErrorCleared = _$69F46$useState1[0], setServerErrorCleared = _$69F46$useState1[1];
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    var serverError = (0, $ggE0n.useMemo)(function() {
        return $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages);
    }, [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    var nextValidation = (0, $ggE0n.useRef)($7aa741b584fcccb5$export$dad6ae84456c676a);
    var _$69F46$useState2 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)($7aa741b584fcccb5$export$dad6ae84456c676a), 2), currentValidity = _$69F46$useState2[0], setCurrentValidity = _$69F46$useState2[1];
    var lastError = (0, $ggE0n.useRef)($7aa741b584fcccb5$export$dad6ae84456c676a);
    var commitValidation = function() {
        if (!commitQueued) return;
        setCommitQueued(false);
        var error = clientError || builtinValidation || nextValidation.current;
        if (!$7aa741b584fcccb5$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    var _$69F46$useState3 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), commitQueued = _$69F46$useState3[0], setCommitQueued = _$69F46$useState3[1];
    (0, $ggE0n.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    var realtimeValidation = controlledError || serverError || clientError || builtinValidation || $7aa741b584fcccb5$export$dad6ae84456c676a;
    var displayValidation = validationBehavior === 'native' ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation: function(value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === 'aria' && !$7aa741b584fcccb5$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation: function() {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            var error = $7aa741b584fcccb5$export$dad6ae84456c676a;
            if (!$7aa741b584fcccb5$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === 'native') setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation: function() {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === 'native') setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === 'function') {
        var e = validate(value);
        if (e && typeof e !== 'boolean') return $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $7aa741b584fcccb5$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every(function(a, i) {
        return a === b.validationErrors[i];
    }) && Object.entries(a.validationDetails).every(function(param) {
        var _param = (0, $c6938abc98c6418f$export$71511d61b312f219)(param, 2), k = _param[0], v = _param[1];
        return b.validationDetails[k] === v;
    });
}
function $7aa741b584fcccb5$export$75ee7c75d68f5b0e() {
    for(var _len = arguments.length, results = new Array(_len), _key = 0; _key < _len; _key++){
        results[_key] = arguments[_key];
    }
    var errors = new Set();
    var isInvalid = false;
    var validationDetails = (0, $2QPpE._)({}, $7aa741b584fcccb5$export$aca958c65c314e6c);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            var _validationDetails, _key1;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = v.validationErrors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e = _step1.value;
                    errors.add(e);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // Only these properties apply for checkboxes.
            isInvalid || (isInvalid = v.isInvalid);
            for(var key in validationDetails)(_validationDetails = validationDetails)[_key1 = key] || (_validationDetails[_key1] = v.validationDetails[key]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: (0, $90NkU._)(errors),
        validationDetails: validationDetails
    };
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $2bf90da467e9636b$export$c24727297075ec6a = (0, $ggE0n.createContext)(null);
var $2bf90da467e9636b$export$a7fed597f4b8afd8 = (0, $ggE0n.forwardRef)(function Form(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $2bf90da467e9636b$export$c24727297075ec6a), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var validationErrors = props.validationErrors, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? 'native' : tmp, children = props.children, className = props.className, domProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "validationErrors",
        "validationBehavior",
        "children",
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("form", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        noValidate: validationBehavior !== 'native'
    }, domProps), {
        ref: ref,
        className: className || 'react-aria-Form'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($2bf90da467e9636b$export$c24727297075ec6a.Provider, {
        value: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
            validationBehavior: validationBehavior
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $7aa741b584fcccb5$export$571b5131b7e65c11).Provider, {
        value: validationErrors !== null && validationErrors !== void 0 ? validationErrors : {}
    }, children)));
});



var $2QPpE = parcelRequire("2QPpE");






var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $b758c97c918eb1ee$export$f9c6924e160136d1 = (0, $ggE0n.createContext)({});
var $b758c97c918eb1ee$export$eb2fcfdbd7ba97d4 = (0, $ggE0n.forwardRef)(function Group(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $b758c97c918eb1ee$export$f9c6924e160136d1), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var isDisabled = props.isDisabled, isInvalid = props.isInvalid, onHoverStart = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "isDisabled",
        "isInvalid",
        "onHoverStart",
        "onHoverChange",
        "onHoverEnd"
    ]);
    var _$gZciS$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)({
        onHoverStart: onHoverStart,
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd,
        isDisabled: isDisabled
    }), hoverProps = _$gZciS$useHover.hoverProps, isHovered = _$gZciS$useHover.isHovered;
    var _$gZciS$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)({
        within: true
    }), isFocused = _$gZciS$useFocusRing.isFocused, isFocusVisible = _$gZciS$useFocusRing.isFocusVisible, focusProps = _$gZciS$useFocusRing.focusProps;
    isDisabled !== null && isDisabled !== void 0 ? isDisabled : isDisabled = !!props['aria-disabled'] && props['aria-disabled'] !== 'false';
    isInvalid !== null && isInvalid !== void 0 ? isInvalid : isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            isHovered: isHovered,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Group'
    }));
    var _props_role, _props_slot;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)(otherProps, focusProps, hoverProps), renderProps), {
        ref: ref,
        role: (_props_role = props.role) !== null && _props_role !== void 0 ? _props_role : 'group',
        slot: (_props_slot = props.slot) !== null && _props_slot !== void 0 ? _props_slot : undefined,
        "data-focus-within": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-invalid": isInvalid || undefined
    }), renderProps.children);
});






var $2QPpE = parcelRequire("2QPpE");


var $64e256a22b67f183$export$2e2bcd8739ae039 = {};
$64e256a22b67f183$export$2e2bcd8739ae039 = {
    "Clear search": "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
};


var $65006080fa20fac7$export$2e2bcd8739ae039 = {};
$65006080fa20fac7$export$2e2bcd8739ae039 = {
    "Clear search": "\u0418\u0437\u0447\u0438\u0441\u0442\u0432\u0430\u043D\u0435 \u043D\u0430 \u0442\u044A\u0440\u0441\u0435\u043D\u0435"
};


var $b55cf5ee513de6df$export$2e2bcd8739ae039 = {};
$b55cf5ee513de6df$export$2e2bcd8739ae039 = {
    "Clear search": "Vymazat hled\xe1n\xed"
};


var $b1a1e16ea99fb30c$export$2e2bcd8739ae039 = {};
$b1a1e16ea99fb30c$export$2e2bcd8739ae039 = {
    "Clear search": "Ryd s\xf8gning"
};


var $cb48973a31c88f0d$export$2e2bcd8739ae039 = {};
$cb48973a31c88f0d$export$2e2bcd8739ae039 = {
    "Clear search": "Suche zur\xfccksetzen"
};


var $eb44a993eac12619$export$2e2bcd8739ae039 = {};
$eb44a993eac12619$export$2e2bcd8739ae039 = {
    "Clear search": "\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2"
};


var $e5c2a7ba9ecb6849$export$2e2bcd8739ae039 = {};
$e5c2a7ba9ecb6849$export$2e2bcd8739ae039 = {
    "Clear search": "Clear search"
};


var $77def9719373467b$export$2e2bcd8739ae039 = {};
$77def9719373467b$export$2e2bcd8739ae039 = {
    "Clear search": "Borrar b\xfasqueda"
};


var $55addcc5b7feebc0$export$2e2bcd8739ae039 = {};
$55addcc5b7feebc0$export$2e2bcd8739ae039 = {
    "Clear search": "T\xfchjenda otsing"
};


var $76d77e2ba2791cec$export$2e2bcd8739ae039 = {};
$76d77e2ba2791cec$export$2e2bcd8739ae039 = {
    "Clear search": "Tyhjenn\xe4 haku"
};


var $6b40e4c4a5ddcfea$export$2e2bcd8739ae039 = {};
$6b40e4c4a5ddcfea$export$2e2bcd8739ae039 = {
    "Clear search": "Effacer la recherche"
};


var $c05eb75f680bb55a$export$2e2bcd8739ae039 = {};
$c05eb75f680bb55a$export$2e2bcd8739ae039 = {
    "Clear search": "\u05E0\u05E7\u05D4 \u05D7\u05D9\u05E4\u05D5\u05E9"
};


var $ca5486ac41de02da$export$2e2bcd8739ae039 = {};
$ca5486ac41de02da$export$2e2bcd8739ae039 = {
    "Clear search": "Obri\u0161i pretragu"
};


var $9d34b9c9ede3595a$export$2e2bcd8739ae039 = {};
$9d34b9c9ede3595a$export$2e2bcd8739ae039 = {
    "Clear search": "Keres\xe9s t\xf6rl\xe9se"
};


var $fb6d1e4a31eb0669$export$2e2bcd8739ae039 = {};
$fb6d1e4a31eb0669$export$2e2bcd8739ae039 = {
    "Clear search": "Cancella ricerca"
};


var $4d397d5c1227c993$export$2e2bcd8739ae039 = {};
$4d397d5c1227c993$export$2e2bcd8739ae039 = {
    "Clear search": "\u691C\u7D22\u3092\u30AF\u30EA\u30A2"
};


var $b4c832ca1e5e6835$export$2e2bcd8739ae039 = {};
$b4c832ca1e5e6835$export$2e2bcd8739ae039 = {
    "Clear search": "\uAC80\uC0C9 \uC9C0\uC6B0\uAE30"
};


var $dbc0811abd36a328$export$2e2bcd8739ae039 = {};
$dbc0811abd36a328$export$2e2bcd8739ae039 = {
    "Clear search": "I\u0161valyti ie\u0161k\u0105"
};


var $a23bbaa029a2fe2f$export$2e2bcd8739ae039 = {};
$a23bbaa029a2fe2f$export$2e2bcd8739ae039 = {
    "Clear search": "Not\u012Br\u012Bt mekl\u0113\u0161anu"
};


var $13de6a0678ccf8ae$export$2e2bcd8739ae039 = {};
$13de6a0678ccf8ae$export$2e2bcd8739ae039 = {
    "Clear search": "T\xf8m s\xf8k"
};


var $1ded5ad577a16ec9$export$2e2bcd8739ae039 = {};
$1ded5ad577a16ec9$export$2e2bcd8739ae039 = {
    "Clear search": "Zoekactie wissen"
};


var $a8aaf4437bf6ad12$export$2e2bcd8739ae039 = {};
$a8aaf4437bf6ad12$export$2e2bcd8739ae039 = {
    "Clear search": "Wyczy\u015B\u0107 zawarto\u015B\u0107 wyszukiwania"
};


var $f7d27b3ee4ece9c3$export$2e2bcd8739ae039 = {};
$f7d27b3ee4ece9c3$export$2e2bcd8739ae039 = {
    "Clear search": "Limpar pesquisa"
};


var $d3cb45ce0df6f14e$export$2e2bcd8739ae039 = {};
$d3cb45ce0df6f14e$export$2e2bcd8739ae039 = {
    "Clear search": "Limpar pesquisa"
};


var $64800ccbfb436623$export$2e2bcd8739ae039 = {};
$64800ccbfb436623$export$2e2bcd8739ae039 = {
    "Clear search": "\u015Eterge\u0163i c\u0103utarea"
};


var $3ca8f591a855f3c7$export$2e2bcd8739ae039 = {};
$3ca8f591a855f3c7$export$2e2bcd8739ae039 = {
    "Clear search": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A"
};


var $ced6d8f1294896a2$export$2e2bcd8739ae039 = {};
$ced6d8f1294896a2$export$2e2bcd8739ae039 = {
    "Clear search": "Vymaza\u0165 vyh\u013Ead\xe1vanie"
};


var $49bb4994fc6b4807$export$2e2bcd8739ae039 = {};
$49bb4994fc6b4807$export$2e2bcd8739ae039 = {
    "Clear search": "Po\u010Disti iskanje"
};


var $cbbd7e3422d8167c$export$2e2bcd8739ae039 = {};
$cbbd7e3422d8167c$export$2e2bcd8739ae039 = {
    "Clear search": "Obri\u0161i pretragu"
};


var $d69ac77406f8a3a2$export$2e2bcd8739ae039 = {};
$d69ac77406f8a3a2$export$2e2bcd8739ae039 = {
    "Clear search": "Rensa s\xf6kning"
};


var $dd6cd940ec283eb9$export$2e2bcd8739ae039 = {};
$dd6cd940ec283eb9$export$2e2bcd8739ae039 = {
    "Clear search": "Aramay\u0131 temizle"
};


var $339ea2438e02512c$export$2e2bcd8739ae039 = {};
$339ea2438e02512c$export$2e2bcd8739ae039 = {
    "Clear search": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u0448\u0443\u043A"
};


var $a7104609c948934d$export$2e2bcd8739ae039 = {};
$a7104609c948934d$export$2e2bcd8739ae039 = {
    "Clear search": "\u6E05\u9664\u641C\u7D22"
};


var $e844a0b6b6b2d3e7$export$2e2bcd8739ae039 = {};
$e844a0b6b6b2d3e7$export$2e2bcd8739ae039 = {
    "Clear search": "\u6E05\u9664\u641C\u5C0B\u689D\u4EF6"
};


var $ed040b7f3095f347$export$2e2bcd8739ae039 = {};
$ed040b7f3095f347$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $64e256a22b67f183$export$2e2bcd8739ae039),
    "bg-BG": (0, $65006080fa20fac7$export$2e2bcd8739ae039),
    "cs-CZ": (0, $b55cf5ee513de6df$export$2e2bcd8739ae039),
    "da-DK": (0, $b1a1e16ea99fb30c$export$2e2bcd8739ae039),
    "de-DE": (0, $cb48973a31c88f0d$export$2e2bcd8739ae039),
    "el-GR": (0, $eb44a993eac12619$export$2e2bcd8739ae039),
    "en-US": (0, $e5c2a7ba9ecb6849$export$2e2bcd8739ae039),
    "es-ES": (0, $77def9719373467b$export$2e2bcd8739ae039),
    "et-EE": (0, $55addcc5b7feebc0$export$2e2bcd8739ae039),
    "fi-FI": (0, $76d77e2ba2791cec$export$2e2bcd8739ae039),
    "fr-FR": (0, $6b40e4c4a5ddcfea$export$2e2bcd8739ae039),
    "he-IL": (0, $c05eb75f680bb55a$export$2e2bcd8739ae039),
    "hr-HR": (0, $ca5486ac41de02da$export$2e2bcd8739ae039),
    "hu-HU": (0, $9d34b9c9ede3595a$export$2e2bcd8739ae039),
    "it-IT": (0, $fb6d1e4a31eb0669$export$2e2bcd8739ae039),
    "ja-JP": (0, $4d397d5c1227c993$export$2e2bcd8739ae039),
    "ko-KR": (0, $b4c832ca1e5e6835$export$2e2bcd8739ae039),
    "lt-LT": (0, $dbc0811abd36a328$export$2e2bcd8739ae039),
    "lv-LV": (0, $a23bbaa029a2fe2f$export$2e2bcd8739ae039),
    "nb-NO": (0, $13de6a0678ccf8ae$export$2e2bcd8739ae039),
    "nl-NL": (0, $1ded5ad577a16ec9$export$2e2bcd8739ae039),
    "pl-PL": (0, $a8aaf4437bf6ad12$export$2e2bcd8739ae039),
    "pt-BR": (0, $f7d27b3ee4ece9c3$export$2e2bcd8739ae039),
    "pt-PT": (0, $d3cb45ce0df6f14e$export$2e2bcd8739ae039),
    "ro-RO": (0, $64800ccbfb436623$export$2e2bcd8739ae039),
    "ru-RU": (0, $3ca8f591a855f3c7$export$2e2bcd8739ae039),
    "sk-SK": (0, $ced6d8f1294896a2$export$2e2bcd8739ae039),
    "sl-SI": (0, $49bb4994fc6b4807$export$2e2bcd8739ae039),
    "sr-SP": (0, $cbbd7e3422d8167c$export$2e2bcd8739ae039),
    "sv-SE": (0, $d69ac77406f8a3a2$export$2e2bcd8739ae039),
    "tr-TR": (0, $dd6cd940ec283eb9$export$2e2bcd8739ae039),
    "uk-UA": (0, $339ea2438e02512c$export$2e2bcd8739ae039),
    "zh-CN": (0, $a7104609c948934d$export$2e2bcd8739ae039),
    "zh-TW": (0, $e844a0b6b6b2d3e7$export$2e2bcd8739ae039)
};





var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c799dbebbb3cf444$export$5add1d006293d136(ref, initialValue, onReset) {
    var resetValue = (0, $ggE0n.useRef)(initialValue);
    var handleReset = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        if (onReset) onReset(resetValue.current);
    });
    (0, $ggE0n.useEffect)(function() {
        var _ref_current;
        var form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener('reset', handleReset);
        return function() {
            form === null || form === void 0 || form.removeEventListener('reset', handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}



var $ggE0n = parcelRequire("ggE0n");



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fb08f700a6e84f93$export$294aa081a6c6f55d(props) {
    var description = props.description, errorMessage = props.errorMessage, isInvalid = props.isInvalid, validationState = props.validationState;
    var _$d191a55c9702f145$export$8467354a121f1b9f = (0, $9f59e5b1923f1fb3$export$8467354a121f1b9f)(props), labelProps = _$d191a55c9702f145$export$8467354a121f1b9f.labelProps, fieldProps = _$d191a55c9702f145$export$8467354a121f1b9f.fieldProps;
    var descriptionId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    var errorMessageId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $850b305c152381bf$export$9d1611c77c2fe928)(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}





var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $76355b41addb9c3e$export$b8473d3665f3a75a(props, state, ref) {
    var validationBehavior = props.validationBehavior, focus = props.focus;
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (validationBehavior === 'native' && (ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.disabled) {
            var errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(' ') || 'Invalid value.' : '';
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute('title')) ref.current.title = '';
            if (!state.realtimeValidation.isInvalid) state.updateValidation($76355b41addb9c3e$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    var onReset = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        state.resetValidation();
    });
    var onInvalid = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        var form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $76355b41addb9c3e$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $33b4709e5e6e943f$export$8397ddfc504fdb9a)('keyboard');
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    var onChange = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        state.commitValidation();
    });
    (0, $ggE0n.useEffect)(function() {
        var input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        var form = input.form;
        input.addEventListener('invalid', onInvalid);
        input.addEventListener('change', onChange);
        form === null || form === void 0 || form.addEventListener('reset', onReset);
        return function() {
            input.removeEventListener('invalid', onInvalid);
            input.removeEventListener('change', onChange);
            form === null || form === void 0 || form.removeEventListener('reset', onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $76355b41addb9c3e$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    var validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $76355b41addb9c3e$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $76355b41addb9c3e$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $76355b41addb9c3e$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(var i = 0; i < form.elements.length; i++){
        var element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b87ec6f44a7b3294$export$712718f7aec83d5(props, ref) {
    var tmp = props.inputElementType, inputElementType = tmp === void 0 ? 'input' : tmp, tmp1 = props.isDisabled, isDisabled = tmp1 === void 0 ? false : tmp1, tmp2 = props.isRequired, isRequired = tmp2 === void 0 ? false : tmp2, tmp3 = props.isReadOnly, isReadOnly = tmp3 === void 0 ? false : tmp3, tmp4 = props.type, type = tmp4 === void 0 ? 'text' : tmp4, tmp5 = props.validationBehavior, validationBehavior = tmp5 === void 0 ? 'aria' : tmp5;
    var _$ig234$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.value, props.defaultValue || '', props.onChange), 2), value = _$ig234$useControlledState[0], setValue = _$ig234$useControlledState[1];
    var _$ig234$useFocusable = (0, $61b10cd69c787297$export$4c014de7c8940b4c)(props, ref), focusableProps = _$ig234$useFocusable.focusableProps;
    var validationState = (0, $7aa741b584fcccb5$export$fc1a364ae1f3ff10)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        value: value
    }));
    var _validationState_displayValidation = validationState.displayValidation, isInvalid = _validationState_displayValidation.isInvalid, validationErrors = _validationState_displayValidation.validationErrors, validationDetails = _validationState_displayValidation.validationDetails;
    var _$ig234$useField = (0, $fb08f700a6e84f93$export$294aa081a6c6f55d)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    })), labelProps = _$ig234$useField.labelProps, fieldProps = _$ig234$useField.fieldProps, descriptionProps = _$ig234$useField.descriptionProps, errorMessageProps = _$ig234$useField.errorMessageProps;
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    var inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    (0, $c799dbebbb3cf444$export$5add1d006293d136)(ref, value, setValue);
    (0, $76355b41addb9c3e$export$b8473d3665f3a75a)(props, validationState, ref);
    (0, $ggE0n.useEffect)(function() {
        // This works around a React/Chrome bug that prevents textarea elements from validating when controlled.
        // We prevent React from updating defaultValue (i.e. children) of textarea when `value` changes,
        // which causes Chrome to skip validation. Only updating `value` is ok in our case since our
        // textareas are always controlled. React is planning on removing this synchronization in a
        // future major version.
        // https://github.com/facebook/react/issues/19474
        // https://github.com/facebook/react/issues/11896
        if (ref.current instanceof (0, $435fb34f0a5eae0b$export$f21a1ffae260145a)(ref.current).HTMLTextAreaElement) {
            var input = ref.current;
            Object.defineProperty(input, 'defaultValue', {
                get: function() {
                    return input.value;
                },
                set: function() {},
                configurable: true
            });
        }
    }, [
        ref
    ]);
    var _obj;
    return {
        labelProps: labelProps,
        inputProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, inputElementType === 'input' ? inputOnlyProps : undefined, (0, $2QPpE._)((_obj = {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === 'native',
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            'aria-invalid': isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-activedescendant': props['aria-activedescendant'],
            'aria-autocomplete': props['aria-autocomplete'],
            'aria-haspopup': props['aria-haspopup'],
            'aria-controls': props['aria-controls'],
            value: value,
            onChange: function(e) {
                return setValue(e.target.value);
            },
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            autoCorrect: props.autoCorrect,
            spellCheck: props.spellCheck
        }, (0, $3Hxpr._)(_obj, parseInt((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint', props.enterKeyHint), // Clipboard events
        (0, $3Hxpr._)(_obj, "onCopy", props.onCopy), (0, $3Hxpr._)(_obj, "onCut", props.onCut), (0, $3Hxpr._)(_obj, "onPaste", props.onPaste), // Composition events
        (0, $3Hxpr._)(_obj, "onCompositionEnd", props.onCompositionEnd), (0, $3Hxpr._)(_obj, "onCompositionStart", props.onCompositionStart), (0, $3Hxpr._)(_obj, "onCompositionUpdate", props.onCompositionUpdate), // Selection events
        (0, $3Hxpr._)(_obj, "onSelect", props.onSelect), // Input events
        (0, $3Hxpr._)(_obj, "onBeforeInput", props.onBeforeInput), (0, $3Hxpr._)(_obj, "onInput", props.onInput), _obj), focusableProps, fieldProps)),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}


function $cc65740c351ea10d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cc65740c351ea10d$export$9bb30bbe003b82e0(props, state, inputRef) {
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($cc65740c351ea10d$var$$parcel$interopDefault((0, $ed040b7f3095f347$export$2e2bcd8739ae039)), '@react-aria/searchfield');
    var isDisabled = props.isDisabled, isReadOnly = props.isReadOnly, onSubmit = props.onSubmit, onClear = props.onClear, tmp = props.type, type = tmp === void 0 ? 'search' : tmp;
    var onKeyDown = function(e) {
        var key = e.key;
        if (key === 'Enter' && (isDisabled || isReadOnly)) e.preventDefault();
        if (isDisabled || isReadOnly) return;
        // for backward compatibility;
        // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
        if (key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(state.value);
        }
        if (key === 'Escape') {
            // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
            // the hook
            if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) e.continuePropagation();
            else {
                e.preventDefault();
                state.setValue('');
                if (onClear) onClear();
            }
        }
    };
    var onClearButtonClick = function() {
        state.setValue('');
        if (onClear) onClear();
    };
    var onPressStart = function() {
        var // the input and close the keyboard
        _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 || _inputRef_current.focus();
    };
    var _$kTEqN$useTextField = (0, $b87ec6f44a7b3294$export$712718f7aec83d5)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, $8deb5a1aa1f00721$export$e08e3b67e392101e)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type: type
    }), inputRef), labelProps = _$kTEqN$useTextField.labelProps, inputProps = _$kTEqN$useTextField.inputProps, descriptionProps = _$kTEqN$useTextField.descriptionProps, errorMessageProps = _$kTEqN$useTextField.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$kTEqN$useTextField, [
        "labelProps",
        "inputProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    return (0, $2QPpE._)({
        labelProps: labelProps,
        inputProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, inputProps), {
            // already handled by useSearchFieldState
            defaultValue: undefined
        }),
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart: onPressStart
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    }, validation);
}





var $ggE0n = parcelRequire("ggE0n");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ce5cefc8253012aa$export$3f8be18b0f41eaf2(props) {
    var _$58ylH$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)($ce5cefc8253012aa$var$$0b2218c4e3fe7d7e$var$toString(props.value), $ce5cefc8253012aa$var$$0b2218c4e3fe7d7e$var$toString(props.defaultValue) || '', props.onChange), 2), value = _$58ylH$useControlledState[0], setValue = _$58ylH$useControlledState[1];
    return {
        value: value,
        setValue: setValue
    };
}
function $ce5cefc8253012aa$var$$0b2218c4e3fe7d7e$var$toString(val) {
    if (val == null) return;
    return val.toString();
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $0a8692081e116c4c$export$d1c4e4c63cb03a11 = (0, $ggE0n.createContext)(null);
var $0a8692081e116c4c$export$b94867ecbd698f21 = (0, $cfc4721022845f0c$export$86427a43e3e48ebb)(function SearchField(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $0a8692081e116c4c$export$d1c4e4c63cb03a11), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _ref = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)((0, $2bf90da467e9636b$export$c24727297075ec6a)) || {}, formValidationBehavior = _ref.validationBehavior;
    var _props_validationBehavior, _ref1;
    var validationBehavior = (_ref1 = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref1 !== void 0 ? _ref1 : 'native';
    var inputRef = (0, $ggE0n.useRef)(null);
    var _$64fa3d84918910a7$export$29f1550f4b0d4415 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)({}, inputRef, (0, $a34d4855f0a68343$export$37fb8590cf2c088c)), 2), inputContextProps = _$64fa3d84918910a7$export$29f1550f4b0d4415[0], mergedInputRef = _$64fa3d84918910a7$export$29f1550f4b0d4415[1];
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var state = (0, $ce5cefc8253012aa$export$3f8be18b0f41eaf2)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        validationBehavior: validationBehavior
    }));
    var _$8iEQ9$useSearchField = (0, $cc65740c351ea10d$export$9bb30bbe003b82e0)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        label: label,
        validationBehavior: validationBehavior
    }), state, mergedInputRef), labelProps = _$8iEQ9$useSearchField.labelProps, inputProps = _$8iEQ9$useSearchField.inputProps, clearButtonProps = _$8iEQ9$useSearchField.clearButtonProps, descriptionProps = _$8iEQ9$useSearchField.descriptionProps, errorMessageProps = _$8iEQ9$useSearchField.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$8iEQ9$useSearchField, [
        "labelProps",
        "inputProps",
        "clearButtonProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            state: state
        },
        defaultClassName: 'react-aria-SearchField'
    }));
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, DOMProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $4fa91534e9375925$export$75b6ee27786ba447),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
                    ref: labelRef
                })
            ],
            [
                (0, $a34d4855f0a68343$export$37fb8590cf2c088c),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)(inputProps, inputContextProps)), {
                    ref: mergedInputRef
                })
            ],
            [
                (0, $28c5f096242aff4d$export$24d547caef80ccd1),
                clearButtonProps
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $aef12de62ee30fed$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, renderProps.children));
});



var $2QPpE = parcelRequire("2QPpE");









var $2QPpE = parcelRequire("2QPpE");






var $ggE0n = parcelRequire("ggE0n");
var $d36085cbf49dba3a$export$2dc6166a7e65358c = (0, $ggE0n.createContext)({});
var $d36085cbf49dba3a$var$$216918bed6669f72$var$filterHoverProps = function(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onHoverStart = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "onHoverStart",
        "onHoverChange",
        "onHoverEnd"
    ]);
    return otherProps;
};
var $d36085cbf49dba3a$export$f5c9f3c2c4054eec = (0, $ggE0n.forwardRef)(function TextArea(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $d36085cbf49dba3a$export$2dc6166a7e65358c), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _$9Usiy$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)(props), hoverProps = _$9Usiy$useHover.hoverProps, isHovered = _$9Usiy$useHover.isHovered;
    var _$9Usiy$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)({
        isTextInput: true,
        autoFocus: props.autoFocus
    }), isFocused = _$9Usiy$useFocusRing.isFocused, isFocusVisible = _$9Usiy$useFocusRing.isFocusVisible, focusProps = _$9Usiy$useFocusRing.focusProps;
    var isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-TextArea'
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("textarea", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)($d36085cbf49dba3a$var$$216918bed6669f72$var$filterHoverProps(props), focusProps, hoverProps), renderProps), {
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    }));
});







var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $809d5642d1d63314$export$2129e27b3ef0d483 = (0, $ggE0n.createContext)(null);
var $809d5642d1d63314$export$2c73285ae9390cec = (0, $cfc4721022845f0c$export$86427a43e3e48ebb)(function TextField(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $809d5642d1d63314$export$2129e27b3ef0d483), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _ref = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)((0, $2bf90da467e9636b$export$c24727297075ec6a)) || {}, formValidationBehavior = _ref.validationBehavior;
    var _props_validationBehavior, _ref1;
    var validationBehavior = (_ref1 = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref1 !== void 0 ? _ref1 : 'native';
    var inputRef = (0, $ggE0n.useRef)(null);
    var _$64fa3d84918910a7$export$29f1550f4b0d4415 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)({}, inputRef, (0, $a34d4855f0a68343$export$37fb8590cf2c088c)), 2), inputContextProps = _$64fa3d84918910a7$export$29f1550f4b0d4415[0], mergedInputRef = _$64fa3d84918910a7$export$29f1550f4b0d4415[1];
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var _$jmnGn$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)('input'), 2), inputElementType = _$jmnGn$useState[0], setInputElementType = _$jmnGn$useState[1];
    var _$jmnGn$useTextField = (0, $b87ec6f44a7b3294$export$712718f7aec83d5)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        inputElementType: inputElementType,
        label: label,
        validationBehavior: validationBehavior
    }), mergedInputRef), labelProps = _$jmnGn$useTextField.labelProps, inputProps = _$jmnGn$useTextField.inputProps, descriptionProps = _$jmnGn$useTextField.descriptionProps, errorMessageProps = _$jmnGn$useTextField.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$jmnGn$useTextField, [
        "labelProps",
        "inputProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    // Intercept setting the input ref so we can determine what kind of element we have.
    // useTextField uses this to determine what props to include.
    var inputOrTextAreaRef = (0, $ggE0n.useCallback)(function(el) {
        mergedInputRef.current = el;
        if (el) setInputElementType(el instanceof HTMLTextAreaElement ? 'textarea' : 'input');
    }, [
        mergedInputRef
    ]);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-TextField'
    }));
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, DOMProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $4fa91534e9375925$export$75b6ee27786ba447),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
                    ref: labelRef
                })
            ],
            [
                (0, $a34d4855f0a68343$export$37fb8590cf2c088c),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)(inputProps, inputContextProps)), {
                    ref: inputOrTextAreaRef
                })
            ],
            [
                (0, $d36085cbf49dba3a$export$2dc6166a7e65358c),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, inputProps), {
                    ref: inputOrTextAreaRef
                })
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $aef12de62ee30fed$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, renderProps.children));
});


var $85927f7b2068e08e$export$2e2bcd8739ae039 = {};
$85927f7b2068e08e$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u0645\u0642\u062A\u0631\u062D\u0627\u062A"
};


var $3a21d8639aced415$export$2e2bcd8739ae039 = {};
$3a21d8639aced415$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F"
};


var $3aaea96190cd9ee3$export$2e2bcd8739ae039 = {};
$3aaea96190cd9ee3$export$2e2bcd8739ae039 = {
    "collectionLabel": "N\xe1vrhy"
};


var $fb47c621fc290b6f$export$2e2bcd8739ae039 = {};
$fb47c621fc290b6f$export$2e2bcd8739ae039 = {
    "collectionLabel": "Forslag"
};


var $1397b7781e717e01$export$2e2bcd8739ae039 = {};
$1397b7781e717e01$export$2e2bcd8739ae039 = {
    "collectionLabel": "Empfehlungen"
};


var $3b7ff17170cb8bdf$export$2e2bcd8739ae039 = {};
$3b7ff17170cb8bdf$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u03A0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2"
};


var $54c54bc96a4fa759$export$2e2bcd8739ae039 = {};
$54c54bc96a4fa759$export$2e2bcd8739ae039 = {
    "collectionLabel": "Suggestions"
};


var $f4f60f20695254aa$export$2e2bcd8739ae039 = {};
$f4f60f20695254aa$export$2e2bcd8739ae039 = {
    "collectionLabel": "Sugerencias"
};


var $d784ef382b4f581d$export$2e2bcd8739ae039 = {};
$d784ef382b4f581d$export$2e2bcd8739ae039 = {
    "collectionLabel": "Soovitused"
};


var $1a2094e8ffd4a760$export$2e2bcd8739ae039 = {};
$1a2094e8ffd4a760$export$2e2bcd8739ae039 = {
    "collectionLabel": "Ehdotukset"
};


var $b96d8fd5be894496$export$2e2bcd8739ae039 = {};
$b96d8fd5be894496$export$2e2bcd8739ae039 = {
    "collectionLabel": "Suggestions"
};


var $f1f483be43f531e7$export$2e2bcd8739ae039 = {};
$f1f483be43f531e7$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u05D4\u05E6\u05E2\u05D5\u05EA"
};


var $4b75dcafbcbff8ce$export$2e2bcd8739ae039 = {};
$4b75dcafbcbff8ce$export$2e2bcd8739ae039 = {
    "collectionLabel": "Prijedlozi"
};


var $11bb36e93d768c97$export$2e2bcd8739ae039 = {};
$11bb36e93d768c97$export$2e2bcd8739ae039 = {
    "collectionLabel": "Javaslatok"
};


var $1502079ab613ed8b$export$2e2bcd8739ae039 = {};
$1502079ab613ed8b$export$2e2bcd8739ae039 = {
    "collectionLabel": "Suggerimenti"
};


var $641af01a8d02aaa9$export$2e2bcd8739ae039 = {};
$641af01a8d02aaa9$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u5019\u88DC"
};


var $496bbb24136e22b3$export$2e2bcd8739ae039 = {};
$496bbb24136e22b3$export$2e2bcd8739ae039 = {
    "collectionLabel": "\uC81C\uC548"
};


var $1ca2fb46cfde5221$export$2e2bcd8739ae039 = {};
$1ca2fb46cfde5221$export$2e2bcd8739ae039 = {
    "collectionLabel": "Pasi\u016Blymai"
};


var $158af1ac91e71433$export$2e2bcd8739ae039 = {};
$158af1ac91e71433$export$2e2bcd8739ae039 = {
    "collectionLabel": "Ieteikumi"
};


var $f74aac568c6178b9$export$2e2bcd8739ae039 = {};
$f74aac568c6178b9$export$2e2bcd8739ae039 = {
    "collectionLabel": "Forslag"
};


var $fe4a182941ae8ada$export$2e2bcd8739ae039 = {};
$fe4a182941ae8ada$export$2e2bcd8739ae039 = {
    "collectionLabel": "Suggesties"
};


var $eef543e25614cf60$export$2e2bcd8739ae039 = {};
$eef543e25614cf60$export$2e2bcd8739ae039 = {
    "collectionLabel": "Sugestie"
};


var $995b48cdabc7db10$export$2e2bcd8739ae039 = {};
$995b48cdabc7db10$export$2e2bcd8739ae039 = {
    "collectionLabel": "Sugest\xf5es"
};


var $e436d1ad1b03734a$export$2e2bcd8739ae039 = {};
$e436d1ad1b03734a$export$2e2bcd8739ae039 = {
    "collectionLabel": "Sugest\xf5es"
};


var $6735c6aac7ab937a$export$2e2bcd8739ae039 = {};
$6735c6aac7ab937a$export$2e2bcd8739ae039 = {
    "collectionLabel": "Sugestii"
};


var $9ca4aac6ca7d37de$export$2e2bcd8739ae039 = {};
$9ca4aac6ca7d37de$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F"
};


var $60cb6f3371b82a56$export$2e2bcd8739ae039 = {};
$60cb6f3371b82a56$export$2e2bcd8739ae039 = {
    "collectionLabel": "N\xe1vrhy"
};


var $63427c0dda2e9671$export$2e2bcd8739ae039 = {};
$63427c0dda2e9671$export$2e2bcd8739ae039 = {
    "collectionLabel": "Predlogi"
};


var $91ddea7c86428119$export$2e2bcd8739ae039 = {};
$91ddea7c86428119$export$2e2bcd8739ae039 = {
    "collectionLabel": "Predlozi"
};


var $c83343975b61d616$export$2e2bcd8739ae039 = {};
$c83343975b61d616$export$2e2bcd8739ae039 = {
    "collectionLabel": "F\xf6rslag"
};


var $2e75679314fab030$export$2e2bcd8739ae039 = {};
$2e75679314fab030$export$2e2bcd8739ae039 = {
    "collectionLabel": "\xd6neriler"
};


var $8c6eeec0c76470ef$export$2e2bcd8739ae039 = {};
$8c6eeec0c76470ef$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457"
};


var $4ed7df937c224c82$export$2e2bcd8739ae039 = {};
$4ed7df937c224c82$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u5EFA\u8BAE"
};


var $6ae14bdfb8e9705d$export$2e2bcd8739ae039 = {};
$6ae14bdfb8e9705d$export$2e2bcd8739ae039 = {
    "collectionLabel": "\u5EFA\u8B70"
};


var $9d962ba6bfe64454$export$2e2bcd8739ae039 = {};
$9d962ba6bfe64454$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $85927f7b2068e08e$export$2e2bcd8739ae039),
    "bg-BG": (0, $3a21d8639aced415$export$2e2bcd8739ae039),
    "cs-CZ": (0, $3aaea96190cd9ee3$export$2e2bcd8739ae039),
    "da-DK": (0, $fb47c621fc290b6f$export$2e2bcd8739ae039),
    "de-DE": (0, $1397b7781e717e01$export$2e2bcd8739ae039),
    "el-GR": (0, $3b7ff17170cb8bdf$export$2e2bcd8739ae039),
    "en-US": (0, $54c54bc96a4fa759$export$2e2bcd8739ae039),
    "es-ES": (0, $f4f60f20695254aa$export$2e2bcd8739ae039),
    "et-EE": (0, $d784ef382b4f581d$export$2e2bcd8739ae039),
    "fi-FI": (0, $1a2094e8ffd4a760$export$2e2bcd8739ae039),
    "fr-FR": (0, $b96d8fd5be894496$export$2e2bcd8739ae039),
    "he-IL": (0, $f1f483be43f531e7$export$2e2bcd8739ae039),
    "hr-HR": (0, $4b75dcafbcbff8ce$export$2e2bcd8739ae039),
    "hu-HU": (0, $11bb36e93d768c97$export$2e2bcd8739ae039),
    "it-IT": (0, $1502079ab613ed8b$export$2e2bcd8739ae039),
    "ja-JP": (0, $641af01a8d02aaa9$export$2e2bcd8739ae039),
    "ko-KR": (0, $496bbb24136e22b3$export$2e2bcd8739ae039),
    "lt-LT": (0, $1ca2fb46cfde5221$export$2e2bcd8739ae039),
    "lv-LV": (0, $158af1ac91e71433$export$2e2bcd8739ae039),
    "nb-NO": (0, $f74aac568c6178b9$export$2e2bcd8739ae039),
    "nl-NL": (0, $fe4a182941ae8ada$export$2e2bcd8739ae039),
    "pl-PL": (0, $eef543e25614cf60$export$2e2bcd8739ae039),
    "pt-BR": (0, $995b48cdabc7db10$export$2e2bcd8739ae039),
    "pt-PT": (0, $e436d1ad1b03734a$export$2e2bcd8739ae039),
    "ro-RO": (0, $6735c6aac7ab937a$export$2e2bcd8739ae039),
    "ru-RU": (0, $9ca4aac6ca7d37de$export$2e2bcd8739ae039),
    "sk-SK": (0, $60cb6f3371b82a56$export$2e2bcd8739ae039),
    "sl-SI": (0, $63427c0dda2e9671$export$2e2bcd8739ae039),
    "sr-SP": (0, $91ddea7c86428119$export$2e2bcd8739ae039),
    "sv-SE": (0, $c83343975b61d616$export$2e2bcd8739ae039),
    "tr-TR": (0, $2e75679314fab030$export$2e2bcd8739ae039),
    "uk-UA": (0, $8c6eeec0c76470ef$export$2e2bcd8739ae039),
    "zh-CN": (0, $4ed7df937c224c82$export$2e2bcd8739ae039),
    "zh-TW": (0, $6ae14bdfb8e9705d$export$2e2bcd8739ae039)
};


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Custom event names for updating the autocomplete's aria-activedecendant.
var $224495606d4f1cf8$export$447a38995de2c711 = 'react-aria-clear-focus';
var $224495606d4f1cf8$export$831c820ad60f9d12 = 'react-aria-focus';


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e99d72990a7c514f$export$16792effe837dba3(e) {
    if ((0, $ccce5714e9b7278a$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}



function $195d094bc4c5c9ef$export$76e4e37e5339496d(to) {
    var from = $195d094bc4c5c9ef$export$759df0d867455a91((0, $435fb34f0a5eae0b$export$b204af158042fbac)(to));
    if (from !== to) {
        if (from) $195d094bc4c5c9ef$export$6c5dc7e81d2cc29a(from, to);
        if (to) $195d094bc4c5c9ef$export$2b35b76d2e30e129(to, from);
    }
}
function $195d094bc4c5c9ef$export$6c5dc7e81d2cc29a(from, to) {
    from.dispatchEvent(new FocusEvent('blur', {
        relatedTarget: to
    }));
    from.dispatchEvent(new FocusEvent('focusout', {
        bubbles: true,
        relatedTarget: to
    }));
}
function $195d094bc4c5c9ef$export$2b35b76d2e30e129(to, from) {
    to.dispatchEvent(new FocusEvent('focus', {
        relatedTarget: from
    }));
    to.dispatchEvent(new FocusEvent('focusin', {
        bubbles: true,
        relatedTarget: from
    }));
}
function $195d094bc4c5c9ef$export$759df0d867455a91(document) {
    var activeElement = (0, $3b911e3383514511$export$cd4e5573fbe2b576)(document);
    var activeDescendant = activeElement === null || activeElement === void 0 ? void 0 : activeElement.getAttribute('aria-activedescendant');
    if (activeDescendant) return document.getElementById(activeDescendant) || activeElement;
    return activeElement;
}




var $ggE0n = parcelRequire("ggE0n");

function $ab70b1d113c9ad28$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ab70b1d113c9ad28$export$1e40b3ca02d92d21(props, state) {
    var inputRef = props.inputRef, collectionRef = props.collectionRef, filter = props.filter, tmp = props.disableAutoFocusFirst, disableAutoFocusFirst = tmp === void 0 ? false : tmp;
    var collectionId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var timeout = (0, $ggE0n.useRef)(undefined);
    var delayNextActiveDescendant = (0, $ggE0n.useRef)(false);
    var queuedActiveDescendant = (0, $ggE0n.useRef)(null);
    var lastCollectionNode = (0, $ggE0n.useRef)(null);
    // For mobile screen readers, we don't want virtual focus, instead opting to disable FocusScope's restoreFocus and manually
    // moving focus back to the subtriggers
    var shouldUseVirtualFocus = (0, $33b4709e5e6e943f$export$630ff653c5ada6a9)() !== 'virtual';
    (0, $ggE0n.useEffect)(function() {
        return function() {
            return clearTimeout(timeout.current);
        };
    }, []);
    var updateActiveDescendant = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        // Ensure input is focused if the user clicks on the collection directly.
        if (!e.isTrusted && shouldUseVirtualFocus && inputRef.current && (0, $3b911e3383514511$export$cd4e5573fbe2b576)((0, $435fb34f0a5eae0b$export$b204af158042fbac)(inputRef.current)) !== inputRef.current) inputRef.current.focus();
        var target = e.target;
        if (e.isTrusted || !target || queuedActiveDescendant.current === target.id) return;
        clearTimeout(timeout.current);
        if (target !== collectionRef.current) {
            if (delayNextActiveDescendant.current) {
                queuedActiveDescendant.current = target.id;
                timeout.current = setTimeout(function() {
                    state.setFocusedNodeId(target.id);
                }, 500);
            } else {
                queuedActiveDescendant.current = target.id;
                state.setFocusedNodeId(target.id);
            }
        } else {
            queuedActiveDescendant.current = null;
            state.setFocusedNodeId(null);
        }
        delayNextActiveDescendant.current = false;
    });
    var callbackRef = (0, $ggE0n.useCallback)(function(collectionNode) {
        var _lastCollectionNode_current;
        if (collectionNode != null) {
            var // of the letter you just typed. If we recieve another focus event then we clear the queued update
            // We track lastCollectionNode to do proper cleanup since callbackRefs just pass null when unmounting. This also handles
            // React 19's extra call of the callback ref in strict mode
            _lastCollectionNode_current1;
            (_lastCollectionNode_current1 = lastCollectionNode.current) === null || _lastCollectionNode_current1 === void 0 || _lastCollectionNode_current1.removeEventListener('focusin', updateActiveDescendant);
            lastCollectionNode.current = collectionNode;
            collectionNode.addEventListener('focusin', updateActiveDescendant);
        } else (_lastCollectionNode_current = lastCollectionNode.current) === null || _lastCollectionNode_current === void 0 || _lastCollectionNode_current.removeEventListener('focusin', updateActiveDescendant);
    }, [
        updateActiveDescendant
    ]);
    // Make sure to memo so that React doesn't keep registering a new event listeners on every rerender of the wrapped collection
    var mergedCollectionRef = (0, $c25977d36d6c3204$export$4338b53315abf666)((0, $ggE0n.useMemo)(function() {
        return (0, $c90706a3f6fff521$export$c9058316764c140e)(collectionRef, callbackRef);
    }, [
        collectionRef,
        callbackRef
    ]));
    var focusFirstItem = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        var _collectionRef_current;
        delayNextActiveDescendant.current = true;
        (_collectionRef_current = collectionRef.current) === null || _collectionRef_current === void 0 || _collectionRef_current.dispatchEvent(new CustomEvent((0, $224495606d4f1cf8$export$831c820ad60f9d12), {
            cancelable: true,
            bubbles: true,
            detail: {
                focusStrategy: 'first'
            }
        }));
    });
    var clearVirtualFocus = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(clearFocusKey) {
        var _collectionRef_current;
        (0, $195d094bc4c5c9ef$export$76e4e37e5339496d)((0, $3b911e3383514511$export$cd4e5573fbe2b576)());
        queuedActiveDescendant.current = null;
        state.setFocusedNodeId(null);
        var clearFocusEvent = new CustomEvent((0, $224495606d4f1cf8$export$447a38995de2c711), {
            cancelable: true,
            bubbles: true,
            detail: {
                clearFocusKey: clearFocusKey
            }
        });
        clearTimeout(timeout.current);
        delayNextActiveDescendant.current = false;
        (_collectionRef_current = collectionRef.current) === null || _collectionRef_current === void 0 || _collectionRef_current.dispatchEvent(clearFocusEvent);
    });
    // TODO: update to see if we can tell what kind of event (paste vs backspace vs typing) is happening instead
    var onChange = function(value) {
        // Tell wrapped collection to focus the first element in the list when typing forward and to clear focused key when deleting text
        // for screen reader announcements
        if (state.inputValue !== value && state.inputValue.length <= value.length && !disableAutoFocusFirst) focusFirstItem();
        else clearVirtualFocus(true);
        state.setInputValue(value);
    };
    var keyDownTarget = (0, $ggE0n.useRef)(null);
    // For textfield specific keydown operations
    var onKeyDown = function(e) {
        var _collectionRef_current;
        keyDownTarget.current = e.target;
        if (e.nativeEvent.isComposing) return;
        var focusedNodeId = queuedActiveDescendant.current;
        switch(e.key){
            case 'a':
                if ((0, $e99d72990a7c514f$export$16792effe837dba3)(e)) return;
                break;
            case 'Escape':
                // Early return for Escape here so it doesn't leak the Escape event from the simulated collection event below and
                // close the dialog prematurely. Ideally that should be up to the discretion of the input element hence the check
                // for isPropagationStopped
                if (e.isDefaultPrevented()) return;
                break;
            case ' ':
                // Space shouldn't trigger onAction so early return.
                return;
            case 'Tab':
                // Don't propogate Tab down to the collection, otherwise we will try to focus the collection via useSelectableCollection's Tab handler (aka shift tab logic)
                // We want FocusScope to handle Tab if one exists (aka sub dialog), so special casepropogate
                if ('continuePropagation' in e) e.continuePropagation();
                return;
            case 'Home':
            case 'End':
            case 'PageDown':
            case 'PageUp':
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    var _collectionRef_current1;
                    if ((e.key === 'Home' || e.key === 'End') && focusedNodeId == null && e.shiftKey) return;
                    // Prevent these keys from moving the text cursor in the input
                    e.preventDefault();
                    // Move virtual focus into the wrapped collection
                    var focusCollection = new CustomEvent((0, $224495606d4f1cf8$export$831c820ad60f9d12), {
                        cancelable: true,
                        bubbles: true
                    });
                    (_collectionRef_current1 = collectionRef.current) === null || _collectionRef_current1 === void 0 || _collectionRef_current1.dispatchEvent(focusCollection);
                    break;
                }
        }
        // Emulate the keyboard events that happen in the input field in the wrapped collection. This is for triggering things like onAction via Enter
        // or moving focus from one item to another. Stop propagation on the input event if it isn't already stopped so it doesn't leak out. For events
        // like ESC, the dispatched event below will bubble out of the collection and be stopped if handled by useSelectableCollection, otherwise will bubble
        // as expected
        if (!e.isPropagationStopped()) e.stopPropagation();
        var shouldPerformDefaultAction = true;
        if (focusedNodeId == null) shouldPerformDefaultAction = ((_collectionRef_current = collectionRef.current) === null || _collectionRef_current === void 0 ? void 0 : _collectionRef_current.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent))) || false;
        else {
            var item = document.getElementById(focusedNodeId);
            shouldPerformDefaultAction = (item === null || item === void 0 ? void 0 : item.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent))) || false;
        }
        if (shouldPerformDefaultAction) switch(e.key){
            case 'ArrowLeft':
            case 'ArrowRight':
                // Clear the activedescendant so NVDA announcements aren't interrupted but retain the focused key in the collection so the
                // user's keyboard navigation restarts from where they left off
                clearVirtualFocus();
                break;
        }
    };
    var onKeyUpCapture = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        // Dispatch simulated key up events for things like triggering links in listbox
        // Make sure to stop the propagation of the input keyup event so that the simulated keyup/down pair
        // is detected by usePress instead of the original keyup originating from the input
        if (e.target === keyDownTarget.current) {
            var _collectionRef_current;
            e.stopImmediatePropagation();
            var focusedNodeId = queuedActiveDescendant.current;
            if (focusedNodeId == null) (_collectionRef_current = collectionRef.current) === null || _collectionRef_current === void 0 || _collectionRef_current.dispatchEvent(new KeyboardEvent(e.type, e));
            else {
                var item = document.getElementById(focusedNodeId);
                item === null || item === void 0 || item.dispatchEvent(new KeyboardEvent(e.type, e));
            }
        }
    });
    (0, $ggE0n.useEffect)(function() {
        document.addEventListener('keyup', onKeyUpCapture, true);
        return function() {
            document.removeEventListener('keyup', onKeyUpCapture, true);
        };
    }, [
        onKeyUpCapture
    ]);
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($ab70b1d113c9ad28$var$$parcel$interopDefault((0, $9d962ba6bfe64454$export$2e2bcd8739ae039)), '@react-aria/autocomplete');
    var collectionProps = (0, $c7019d53357f553d$export$d6875122194c7b44)({
        id: collectionId,
        'aria-label': stringFormatter.format('collectionLabel')
    });
    var filterFn = (0, $ggE0n.useCallback)(function(nodeTextValue) {
        if (filter) return filter(nodeTextValue, state.inputValue);
        return true;
    }, [
        state.inputValue,
        filter
    ]);
    // Be sure to clear/restore the virtual + collection focus when blurring/refocusing the field so we only show the
    // focus ring on the virtually focused collection when are actually interacting with the Autocomplete
    var onBlur = function(e) {
        if (!e.isTrusted) return;
        var lastFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (lastFocusedNode) (0, $195d094bc4c5c9ef$export$6c5dc7e81d2cc29a)(lastFocusedNode, e.relatedTarget);
    };
    var onFocus = function(e) {
        if (!e.isTrusted) return;
        var curFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (curFocusedNode) {
            var target = e.target;
            queueMicrotask(function() {
                (0, $195d094bc4c5c9ef$export$6c5dc7e81d2cc29a)(target, curFocusedNode);
                (0, $195d094bc4c5c9ef$export$2b35b76d2e30e129)(curFocusedNode, target);
            });
        }
    };
    var _state_focusedNodeId;
    return {
        textFieldProps: {
            value: state.inputValue,
            onChange: onChange,
            onKeyDown: onKeyDown,
            autoComplete: 'off',
            'aria-haspopup': 'listbox',
            'aria-controls': collectionId,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            'aria-autocomplete': 'list',
            'aria-activedescendant': (_state_focusedNodeId = state.focusedNodeId) !== null && _state_focusedNodeId !== void 0 ? _state_focusedNodeId : undefined,
            // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
            autoCorrect: 'off',
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: 'false',
            enterKeyHint: 'go',
            onBlur: onBlur,
            onFocus: onFocus
        },
        collectionProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(collectionProps, {
            shouldUseVirtualFocus: shouldUseVirtualFocus,
            disallowTypeAhead: true
        }),
        collectionRef: mergedCollectionRef,
        filter: filter != null ? filterFn : undefined
    };
}




var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $253dc73d182fc85d$export$ce1595f6e1a63433(props) {
    var propsOnInputChange = props.onInputChange, propsInputValue = props.inputValue, tmp = props.defaultInputValue, propsDefaultInputValue = tmp === void 0 ? '' : tmp;
    var onInputChange = function(value) {
        if (propsOnInputChange) propsOnInputChange(value);
    };
    var _$LM92H$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), focusedNodeId = _$LM92H$useState[0], setFocusedNodeId = _$LM92H$useState[1];
    var _$LM92H$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(propsInputValue, propsDefaultInputValue, onInputChange), 2), inputValue = _$LM92H$useControlledState[0], setInputValue = _$LM92H$useControlledState[1];
    return {
        inputValue: inputValue,
        setInputValue: setInputValue,
        focusedNodeId: focusedNodeId,
        setFocusedNodeId: setFocusedNodeId
    };
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $97969277f870840a$export$36e687af51cd0967 = (0, $ggE0n.createContext)(null);
var $97969277f870840a$export$68ee3368b6d68148 = (0, $ggE0n.createContext)(null);
var $97969277f870840a$export$65d2a03b8800d6e3 = (0, $ggE0n.createContext)(null);
function $97969277f870840a$export$2f2b9559550c7bbc(props) {
    var ctx = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)($97969277f870840a$export$36e687af51cd0967, props.slot);
    props = (0, $850b305c152381bf$export$9d1611c77c2fe928)(ctx, props);
    var filter = props.filter, disableAutoFocusFirst = props.disableAutoFocusFirst;
    var state = (0, $253dc73d182fc85d$export$ce1595f6e1a63433)(props);
    var inputRef = (0, $ggE0n.useRef)(null);
    var collectionRef = (0, $ggE0n.useRef)(null);
    var _$llkzs$useAutocomplete = (0, $ab70b1d113c9ad28$export$1e40b3ca02d92d21)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        filter: filter,
        disableAutoFocusFirst: disableAutoFocusFirst,
        inputRef: inputRef,
        collectionRef: collectionRef
    }), state), textFieldProps = _$llkzs$useAutocomplete.textFieldProps, collectionProps = _$llkzs$useAutocomplete.collectionProps, mergedCollectionRef = _$llkzs$useAutocomplete.collectionRef, filterFn = _$llkzs$useAutocomplete.filter;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $97969277f870840a$export$68ee3368b6d68148,
                state
            ],
            [
                (0, $0a8692081e116c4c$export$d1c4e4c63cb03a11),
                textFieldProps
            ],
            [
                (0, $809d5642d1d63314$export$2129e27b3ef0d483),
                textFieldProps
            ],
            [
                (0, $a34d4855f0a68343$export$37fb8590cf2c088c),
                {
                    ref: inputRef
                }
            ],
            [
                $97969277f870840a$export$65d2a03b8800d6e3,
                {
                    filter: filterFn,
                    collectionProps: collectionProps,
                    collectionRef: mergedCollectionRef
                }
            ]
        ]
    }, props.children);
}



var $2QPpE = parcelRequire("2QPpE");


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $0d3f9695692cbfb6$export$6f49b4016bfc8d56 = new WeakMap();




var $2QPpE = parcelRequire("2QPpE");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $109bc39d96a319f7$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $ccce5714e9b7278a$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $109bc39d96a319f7$export$c3d8340acf92597f(collectionRef, key) {
    var _collectionRef_current, _collectionRef_current1;
    var selector = '[data-key="'.concat(CSS.escape(String(key)), '"]');
    var collection = (_collectionRef_current = collectionRef.current) === null || _collectionRef_current === void 0 ? void 0 : _collectionRef_current.dataset.collection;
    if (collection) selector = '[data-collection="'.concat(CSS.escape(collection), '"]').concat(selector);
    return (_collectionRef_current1 = collectionRef.current) === null || _collectionRef_current1 === void 0 ? void 0 : _collectionRef_current1.querySelector(selector);
}
var $109bc39d96a319f7$var$$feb5ffebff200149$var$collectionMap = new WeakMap();
function $109bc39d96a319f7$export$881eb0d9f3605d9d(collection) {
    var id = (0, $7fc455d18519c289$export$f680877a34711e37)();
    $109bc39d96a319f7$var$$feb5ffebff200149$var$collectionMap.set(collection, id);
    return id;
}
function $109bc39d96a319f7$export$6aeb1680a0ae8741(collection) {
    return $109bc39d96a319f7$var$$feb5ffebff200149$var$collectionMap.get(collection);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ var $ce2fbebc4cc284fe$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $ce2fbebc4cc284fe$export$e32c88dfddc6e1d8(options) {
    var keyboardDelegate = options.keyboardDelegate, selectionManager = options.selectionManager, onTypeSelect = options.onTypeSelect;
    var state = (0, $ggE0n.useRef)({
        search: '',
        timeout: undefined
    }).current;
    var onKeyDown = function(e) {
        var character = $ce2fbebc4cc284fe$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === ' ' && state.search.trim().length > 0) {
            e.preventDefault();
            if (!('continuePropagation' in e)) e.stopPropagation();
        }
        state.search += character;
        if (keyboardDelegate.getKeyForSearch != null) {
            // Use the delegate to find a key to focus.
            // Prioritize items after the currently focused item, falling back to searching the whole list.
            var key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
            // If no key found, search from the top.
            if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
            if (key != null) {
                selectionManager.setFocusedKey(key);
                if (onTypeSelect) onTypeSelect(key);
            }
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(function() {
            state.search = '';
        }, $ce2fbebc4cc284fe$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : undefined
        }
    };
}
function $ce2fbebc4cc284fe$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return '';
}



/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $aff1107a686a387e$export$94ed1c92c7beeb22(node, checkForOverflow) {
    var scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $e9a8111392ef6431$export$2bb74740c4e19def)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d3940bd7bb9376be$export$53a0910f038337bd(scrollView, element) {
    var offsetX = $d3940bd7bb9376be$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'left');
    var offsetY = $d3940bd7bb9376be$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'top');
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    var x = scrollView.scrollLeft;
    var y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left + scroll padding
    var _getComputedStyle = getComputedStyle(scrollView), borderTopWidth = _getComputedStyle.borderTopWidth, borderLeftWidth = _getComputedStyle.borderLeftWidth, scrollPaddingTop = _getComputedStyle.scrollPaddingTop, scrollPaddingRight = _getComputedStyle.scrollPaddingRight, scrollPaddingBottom = _getComputedStyle.scrollPaddingBottom, scrollPaddingLeft = _getComputedStyle.scrollPaddingLeft;
    var borderAdjustedX = x + parseInt(borderLeftWidth, 10);
    var borderAdjustedY = y + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    var maxX = borderAdjustedX + scrollView.clientWidth;
    var maxY = borderAdjustedY + scrollView.clientHeight;
    // Get scroll padding values as pixels - defaults to 0 if no scroll padding
    // is used.
    var scrollPaddingTopNumber = parseInt(scrollPaddingTop, 10) || 0;
    var scrollPaddingBottomNumber = parseInt(scrollPaddingBottom, 10) || 0;
    var scrollPaddingRightNumber = parseInt(scrollPaddingRight, 10) || 0;
    var scrollPaddingLeftNumber = parseInt(scrollPaddingLeft, 10) || 0;
    if (offsetX <= x + scrollPaddingLeftNumber) x = offsetX - parseInt(borderLeftWidth, 10) - scrollPaddingLeftNumber;
    else if (offsetX + width > maxX - scrollPaddingRightNumber) x += offsetX + width - maxX + scrollPaddingRightNumber;
    if (offsetY <= borderAdjustedY + scrollPaddingTopNumber) y = offsetY - parseInt(borderTopWidth, 10) - scrollPaddingTopNumber;
    else if (offsetY + height > maxY - scrollPaddingBottomNumber) y += offsetY + height - maxY + scrollPaddingBottomNumber;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $d3940bd7bb9376be$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    var prop = axis === 'left' ? 'offsetLeft' : 'offsetTop';
    var sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $d3940bd7bb9376be$export$c826860796309d1b(targetElement, opts) {
    if (targetElement && document.contains(targetElement)) {
        var root = document.scrollingElement || document.documentElement;
        var isScrollPrevented = window.getComputedStyle(root).overflow === 'hidden';
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            var _targetElement_getBoundingClientRect = targetElement.getBoundingClientRect(), originalLeft = _targetElement_getBoundingClientRect.left, originalTop = _targetElement_getBoundingClientRect.top;
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: 'nearest'
            });
            var _targetElement_getBoundingClientRect1 = targetElement.getBoundingClientRect(), newLeft = _targetElement_getBoundingClientRect1.left, newTop = _targetElement_getBoundingClientRect1.top;
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: 'center',
                    inline: 'center'
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: 'nearest'
                });
            }
        } else {
            var scrollParents = (0, $aff1107a686a387e$export$94ed1c92c7beeb22)(targetElement);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
                for(var _iterator = scrollParents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var scrollParent = _step.value;
                    $d3940bd7bb9376be$export$53a0910f038337bd(scrollParent, targetElement);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $468cd85a4db23b7b$export$90fc3a17d93f704c(ref, event, handler, options) {
    var handleEvent = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(handler);
    var isDisabled = handler == null;
    (0, $ggE0n.useEffect)(function() {
        if (isDisabled || !ref.current) return;
        var element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return function() {
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f3702843cc83fd03$export$72ef708ab07251f1(effect, dependencies) {
    var isInitialMount = (0, $ggE0n.useRef)(true);
    var lastDeps = (0, $ggE0n.useRef)(null);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        isInitialMount.current = true;
        return function() {
            isInitialMount.current = false;
        };
    }, []);
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some(function(dep, i) {
            return !Object.is(dep, lastDeps[i]);
        })) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}



var $3og2D = parcelRequire("3og2D");

var $ggE0n = parcelRequire("ggE0n");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $62c6d771f62f84ba$export$d6daf82dcd84e87c(options) {
    var manager = options.selectionManager, delegate = options.keyboardDelegate, ref = options.ref, tmp = options.autoFocus, autoFocus = tmp === void 0 ? false : tmp, tmp1 = options.shouldFocusWrap, shouldFocusWrap = tmp1 === void 0 ? false : tmp1, tmp2 = options.disallowEmptySelection, disallowEmptySelection = tmp2 === void 0 ? false : tmp2, tmp3 = options.disallowSelectAll, disallowSelectAll = tmp3 === void 0 ? false : tmp3, tmp4 = options.escapeKeyBehavior, escapeKeyBehavior = tmp4 === void 0 ? 'clearSelection' : tmp4, tmp5 = options.selectOnFocus, selectOnFocus = tmp5 === void 0 ? manager.selectionBehavior === 'replace' : tmp5, tmp6 = options.disallowTypeAhead, disallowTypeAhead = tmp6 === void 0 ? false : tmp6, shouldUseVirtualFocus = options.shouldUseVirtualFocus, tmp7 = options.allowsTabNavigation, allowsTabNavigation = tmp7 === void 0 ? false : tmp7, isVirtualized = options.isVirtualized, tmp8 = options.scrollRef, scrollRef = tmp8 === void 0 ? ref : tmp8, tmp9 = options.linkBehavior, linkBehavior = tmp9 === void 0 ? 'action' : tmp9;
    var _$3H3GQ$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), direction = _$3H3GQ$useLocale.direction;
    var router = (0, $e863324b7200d517$export$9a302a45f65d0572)();
    var onKeyDown = function(e) {
        var _ref_current;
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === 'Tab') e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(e.target))) return;
        var navigateToKey = function(key, childFocus) {
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === 'selection' && selectOnFocus && !(0, $109bc39d96a319f7$export$d3e3bd3e26688c04)(e)) {
                    (0, $3og2D.flushSync)(function() {
                        manager.setFocusedKey(key, childFocus);
                    });
                    var item = (0, $109bc39d96a319f7$export$c3d8340acf92597f)(ref, key);
                    var itemProps = manager.getItemProps(key);
                    if (item) router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === 'override') return;
                if (e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(key);
                else if (selectOnFocus && !(0, $109bc39d96a319f7$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case 'ArrowDown':
                if (delegate.getKeyBelow) {
                    var _delegate_getKeyBelow, _delegate_getFirstKey, _delegate_getFirstKey1;
                    var nextKey = manager.focusedKey != null ? (_delegate_getKeyBelow = delegate.getKeyBelow) === null || _delegate_getKeyBelow === void 0 ? void 0 : _delegate_getKeyBelow.call(delegate, manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowUp':
                if (delegate.getKeyAbove) {
                    var _delegate_getKeyAbove, _delegate_getLastKey, _delegate_getLastKey1;
                    var nextKey1 = manager.focusedKey != null ? (_delegate_getKeyAbove = delegate.getKeyAbove) === null || _delegate_getKeyAbove === void 0 ? void 0 : _delegate_getKeyAbove.call(delegate, manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey1 == null && shouldFocusWrap) nextKey1 = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    if (nextKey1 != null) {
                        e.preventDefault();
                        navigateToKey(nextKey1);
                    }
                }
                break;
            case 'ArrowLeft':
                if (delegate.getKeyLeftOf) {
                    var _delegate_getKeyLeftOf, _delegate_getFirstKey2, _delegate_getLastKey2;
                    var nextKey2 = manager.focusedKey != null ? (_delegate_getKeyLeftOf = delegate.getKeyLeftOf) === null || _delegate_getKeyLeftOf === void 0 ? void 0 : _delegate_getKeyLeftOf.call(delegate, manager.focusedKey) : null;
                    if (nextKey2 == null && shouldFocusWrap) nextKey2 = direction === 'rtl' ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    if (nextKey2 != null) {
                        e.preventDefault();
                        navigateToKey(nextKey2, direction === 'rtl' ? 'first' : 'last');
                    }
                }
                break;
            case 'ArrowRight':
                if (delegate.getKeyRightOf) {
                    var _delegate_getKeyRightOf, _delegate_getLastKey3, _delegate_getFirstKey3;
                    var nextKey3 = manager.focusedKey != null ? (_delegate_getKeyRightOf = delegate.getKeyRightOf) === null || _delegate_getKeyRightOf === void 0 ? void 0 : _delegate_getKeyRightOf.call(delegate, manager.focusedKey) : null;
                    if (nextKey3 == null && shouldFocusWrap) nextKey3 = direction === 'rtl' ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    if (nextKey3 != null) {
                        e.preventDefault();
                        navigateToKey(nextKey3, direction === 'rtl' ? 'last' : 'first');
                    }
                }
                break;
            case 'Home':
                if (delegate.getFirstKey) {
                    if (manager.focusedKey === null && e.shiftKey) return;
                    e.preventDefault();
                    var firstKey = delegate.getFirstKey(manager.focusedKey, (0, $e99d72990a7c514f$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if (firstKey != null) {
                        if ((0, $e99d72990a7c514f$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(firstKey);
                        else if (selectOnFocus) manager.replaceSelection(firstKey);
                    }
                }
                break;
            case 'End':
                if (delegate.getLastKey) {
                    if (manager.focusedKey === null && e.shiftKey) return;
                    e.preventDefault();
                    var lastKey = delegate.getLastKey(manager.focusedKey, (0, $e99d72990a7c514f$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if (lastKey != null) {
                        if ((0, $e99d72990a7c514f$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(lastKey);
                        else if (selectOnFocus) manager.replaceSelection(lastKey);
                    }
                }
                break;
            case 'PageDown':
                if (delegate.getKeyPageBelow && manager.focusedKey != null) {
                    var nextKey4 = delegate.getKeyPageBelow(manager.focusedKey);
                    if (nextKey4 != null) {
                        e.preventDefault();
                        navigateToKey(nextKey4);
                    }
                }
                break;
            case 'PageUp':
                if (delegate.getKeyPageAbove && manager.focusedKey != null) {
                    var nextKey5 = delegate.getKeyPageAbove(manager.focusedKey);
                    if (nextKey5 != null) {
                        e.preventDefault();
                        navigateToKey(nextKey5);
                    }
                }
                break;
            case 'a':
                if ((0, $e99d72990a7c514f$export$16792effe837dba3)(e) && manager.selectionMode === 'multiple' && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case 'Escape':
                if (escapeKeyBehavior === 'clearSelection' && !disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case 'Tab':
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        var walker = (0, $67c1d94bd0a42a56$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        var next = undefined;
                        var last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    /// TODO: should this happen all the time??
    var scrollPos = (0, $ggE0n.useRef)({
        top: 0,
        left: 0
    });
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(scrollRef, 'scroll', isVirtualized ? undefined : function() {
        var _scrollRef_current, _scrollRef_current1;
        var _scrollRef_current_scrollTop, _scrollRef_current_scrollLeft;
        scrollPos.current = {
            top: (_scrollRef_current_scrollTop = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.scrollTop) !== null && _scrollRef_current_scrollTop !== void 0 ? _scrollRef_current_scrollTop : 0,
            left: (_scrollRef_current_scrollLeft = (_scrollRef_current1 = scrollRef.current) === null || _scrollRef_current1 === void 0 ? void 0 : _scrollRef_current1.scrollLeft) !== null && _scrollRef_current_scrollLeft !== void 0 ? _scrollRef_current_scrollLeft : 0
        };
    });
    var onFocus = function(e) {
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            var _delegate_getLastKey, _delegate_getFirstKey;
            var navigateToKey = function(key) {
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus && !manager.isSelected(key)) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            var relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate));
            else navigateToKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate));
        } else if (!isVirtualized && scrollRef.current) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (manager.focusedKey != null && scrollRef.current) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            var element = (0, $109bc39d96a319f7$export$c3d8340acf92597f)(ref, manager.focusedKey);
            if (element instanceof HTMLElement) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement) && !shouldUseVirtualFocus) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(element);
                var modality = (0, $33b4709e5e6e943f$export$630ff653c5ada6a9)();
                if (modality === 'keyboard') (0, $d3940bd7bb9376be$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    var onBlur = function(e) {
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    // Ref to track whether the first item in the collection should be automatically focused. Specifically used for autocomplete when user types
    // to focus the first key AFTER the collection updates.
    // TODO: potentially expand the usage of this
    var shouldVirtualFocusFirst = (0, $ggE0n.useRef)(false);
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(ref, (0, $224495606d4f1cf8$export$831c820ad60f9d12), !shouldUseVirtualFocus ? undefined : function(e) {
        var detail = e.detail;
        e.stopPropagation();
        manager.setFocused(true);
        // If the user is typing forwards, autofocus the first option in the list.
        if ((detail === null || detail === void 0 ? void 0 : detail.focusStrategy) === 'first') shouldVirtualFocusFirst.current = true;
    });
    var updateActiveDescendant = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        var _delegate_getFirstKey;
        var _delegate_getFirstKey1;
        var keyToFocus = (_delegate_getFirstKey1 = (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate)) !== null && _delegate_getFirstKey1 !== void 0 ? _delegate_getFirstKey1 : null;
        // If no focusable items exist in the list, make sure to clear any activedescendant that may still exist
        if (keyToFocus == null) {
            (0, $195d094bc4c5c9ef$export$76e4e37e5339496d)(ref.current);
            // If there wasn't a focusable key but the collection had items, then that means we aren't in an intermediate load state and all keys are disabled.
            // Reset shouldVirtualFocusFirst so that we don't erronously autofocus an item when the collection is filtered again.
            if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
        } else {
            manager.setFocusedKey(keyToFocus);
            // Only set shouldVirtualFocusFirst to false if we've successfully set the first key as the focused key
            // If there wasn't a key to focus, we might be in a temporary loading state so we'll want to still focus the first key
            // after the collection updates after load
            shouldVirtualFocusFirst.current = false;
        }
    });
    (0, $f3702843cc83fd03$export$72ef708ab07251f1)(function() {
        if (shouldVirtualFocusFirst.current) updateActiveDescendant();
    }, [
        manager.collection,
        updateActiveDescendant
    ]);
    var resetFocusFirstFlag = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        // If user causes the focused key to change in any other way, clear shouldVirtualFocusFirst so we don't
        // accidentally move focus from under them. Skip this if the collection was empty because we might be in a load
        // state and will still want to focus the first item after load
        if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
    });
    (0, $f3702843cc83fd03$export$72ef708ab07251f1)(function() {
        resetFocusFirstFlag();
    }, [
        manager.focusedKey,
        resetFocusFirstFlag
    ]);
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(ref, (0, $224495606d4f1cf8$export$447a38995de2c711), !shouldUseVirtualFocus ? undefined : function(e) {
        var _e_detail;
        e.stopPropagation();
        manager.setFocused(false);
        if ((_e_detail = e.detail) === null || _e_detail === void 0 ? void 0 : _e_detail.clearFocusKey) manager.setFocusedKey(null);
    });
    var autoFocusRef = (0, $ggE0n.useRef)(autoFocus);
    var didAutoFocusRef = (0, $ggE0n.useRef)(false);
    (0, $ggE0n.useEffect)(function() {
        if (autoFocusRef.current) {
            var _delegate_getFirstKey, _delegate_getLastKey;
            var focusedKey = null;
            var _delegate_getFirstKey1;
            // Check focus strategy to determine which item to focus
            if (autoFocus === 'first') focusedKey = (_delegate_getFirstKey1 = (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate)) !== null && _delegate_getFirstKey1 !== void 0 ? _delegate_getFirstKey1 : null;
            var _delegate_getLastKey1;
            if (autoFocus === 'last') focusedKey = (_delegate_getLastKey1 = (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate)) !== null && _delegate_getLastKey1 !== void 0 ? _delegate_getLastKey1 : null;
            // If there are any selected keys, make the first one the new focus target
            var selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (manager.canSelectItem(key)) {
                            focusedKey = key;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus && ref.current) (0, $9134fa2a0acdb388$export$80f3e147d781571c)(ref.current);
            // Wait until the collection has items to autofocus.
            if (manager.collection.size > 0) {
                autoFocusRef.current = false;
                didAutoFocusRef.current = true;
            }
        }
    });
    // Scroll the focused element into view when the focusedKey changes.
    var lastFocusedKey = (0, $ggE0n.useRef)(manager.focusedKey);
    var raf = (0, $ggE0n.useRef)(null);
    (0, $ggE0n.useEffect)(function() {
        if (manager.isFocused && manager.focusedKey != null && (manager.focusedKey !== lastFocusedKey.current || didAutoFocusRef.current) && scrollRef.current && ref.current) {
            var modality = (0, $33b4709e5e6e943f$export$630ff653c5ada6a9)();
            var element = (0, $109bc39d96a319f7$export$c3d8340acf92597f)(ref, manager.focusedKey);
            if (!(element instanceof HTMLElement)) // The collection may initially be empty (e.g. virtualizer), so wait until the element exists.
            return;
            if (modality === 'keyboard' || didAutoFocusRef.current) {
                if (raf.current) cancelAnimationFrame(raf.current);
                raf.current = requestAnimationFrame(function() {
                    if (scrollRef.current) {
                        (0, $d3940bd7bb9376be$export$53a0910f038337bd)(scrollRef.current, element);
                        // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                        if (modality !== 'virtual') (0, $d3940bd7bb9376be$export$c826860796309d1b)(element, {
                            containingElement: ref.current
                        });
                    }
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (!shouldUseVirtualFocus && manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null && ref.current) (0, $9134fa2a0acdb388$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        didAutoFocusRef.current = false;
    });
    (0, $ggE0n.useEffect)(function() {
        return function() {
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(ref, 'react-aria-focus-scope-restore', function(e) {
        e.preventDefault();
        manager.setFocused(true);
    });
    var handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: function(e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    var _$fb3050f43d946246$export$e32c88dfddc6e1d8 = (0, $ce2fbebc4cc284fe$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    }), typeSelectProps = _$fb3050f43d946246$export$e32c88dfddc6e1d8.typeSelectProps;
    if (!disallowTypeAhead) handlers = (0, $850b305c152381bf$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    var tabIndex = undefined;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    var collectionId = (0, $109bc39d96a319f7$export$881eb0d9f3605d9d)(manager.collection);
    return {
        collectionProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(handlers, {
            tabIndex: tabIndex,
            'data-collection': collectionId
        })
    };
}



var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4b6fb35838f7fecf$export$8f5ed9ff9f511381 = /*#__PURE__*/ function() {
    "use strict";
    function $657e4dc4a6e88df0$export$8f5ed9ff9f511381(ref) {
        (0, $gpEpt._)(this, $657e4dc4a6e88df0$export$8f5ed9ff9f511381);
        this.ref = ref;
    }
    (0, $eOJ9o._)($657e4dc4a6e88df0$export$8f5ed9ff9f511381, [
        {
            key: "getItemRect",
            value: function getItemRect(key) {
                var container = this.ref.current;
                if (!container) return null;
                var item = key != null ? (0, $109bc39d96a319f7$export$c3d8340acf92597f)(this.ref, key) : null;
                if (!item) return null;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                return {
                    x: itemRect.left - containerRect.left + container.scrollLeft,
                    y: itemRect.top - containerRect.top + container.scrollTop,
                    width: itemRect.width,
                    height: itemRect.height
                };
            }
        },
        {
            key: "getContentSize",
            value: function getContentSize() {
                var container = this.ref.current;
                var _container_scrollWidth, _container_scrollHeight;
                return {
                    width: (_container_scrollWidth = container === null || container === void 0 ? void 0 : container.scrollWidth) !== null && _container_scrollWidth !== void 0 ? _container_scrollWidth : 0,
                    height: (_container_scrollHeight = container === null || container === void 0 ? void 0 : container.scrollHeight) !== null && _container_scrollHeight !== void 0 ? _container_scrollHeight : 0
                };
            }
        },
        {
            key: "getVisibleRect",
            value: function getVisibleRect() {
                var container = this.ref.current;
                var _container_scrollLeft, _container_scrollTop, _container_offsetWidth, _container_offsetHeight;
                return {
                    x: (_container_scrollLeft = container === null || container === void 0 ? void 0 : container.scrollLeft) !== null && _container_scrollLeft !== void 0 ? _container_scrollLeft : 0,
                    y: (_container_scrollTop = container === null || container === void 0 ? void 0 : container.scrollTop) !== null && _container_scrollTop !== void 0 ? _container_scrollTop : 0,
                    width: (_container_offsetWidth = container === null || container === void 0 ? void 0 : container.offsetWidth) !== null && _container_offsetWidth !== void 0 ? _container_offsetWidth : 0,
                    height: (_container_offsetHeight = container === null || container === void 0 ? void 0 : container.offsetHeight) !== null && _container_offsetHeight !== void 0 ? _container_offsetHeight : 0
                };
            }
        }
    ]);
    return $657e4dc4a6e88df0$export$8f5ed9ff9f511381;
}();



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ec5997dede11a976$export$a05409b8bb224a5a = /*#__PURE__*/ function() {
    "use strict";
    function $2a25aae57d74318e$export$a05409b8bb224a5a() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $2a25aae57d74318e$export$a05409b8bb224a5a);
        if (args.length === 1) {
            var opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || 'all';
            this.orientation = opts.orientation || 'vertical';
            this.direction = opts.direction;
            this.layout = opts.layout || 'stack';
            this.layoutDelegate = opts.layoutDelegate || new (0, $4b6fb35838f7fecf$export$8f5ed9ff9f511381)(opts.ref);
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = 'stack';
            this.orientation = 'vertical';
            this.disabledBehavior = 'all';
            this.layoutDelegate = new (0, $4b6fb35838f7fecf$export$8f5ed9ff9f511381)(this.ref);
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === 'stack' && this.orientation === 'vertical') {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
    (0, $eOJ9o._)($2a25aae57d74318e$export$a05409b8bb224a5a, [
        {
            key: "isDisabled",
            value: function isDisabled(item) {
                var _item_props;
                return this.disabledBehavior === 'all' && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
            }
        },
        {
            key: "findNextNonDisabled",
            value: function findNextNonDisabled(key, getNext) {
                var nextKey = key;
                while(nextKey != null){
                    var item = this.collection.getItem(nextKey);
                    if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !this.isDisabled(item)) return nextKey;
                    nextKey = getNext(nextKey);
                }
                return null;
            }
        },
        {
            key: "getNextKey",
            value: function getNextKey(key) {
                var _this = this;
                var nextKey = key;
                nextKey = this.collection.getKeyAfter(nextKey);
                return this.findNextNonDisabled(nextKey, function(key) {
                    return _this.collection.getKeyAfter(key);
                });
            }
        },
        {
            key: "getPreviousKey",
            value: function getPreviousKey(key) {
                var _this = this;
                var nextKey = key;
                nextKey = this.collection.getKeyBefore(nextKey);
                return this.findNextNonDisabled(nextKey, function(key) {
                    return _this.collection.getKeyBefore(key);
                });
            }
        },
        {
            key: "findKey",
            value: function findKey(key, nextKey, shouldSkip) {
                var tempKey = key;
                var itemRect = this.layoutDelegate.getItemRect(tempKey);
                if (!itemRect || tempKey == null) return null;
                // Find the item above or below in the same column.
                var prevRect = itemRect;
                do {
                    tempKey = nextKey(tempKey);
                    if (tempKey == null) break;
                    itemRect = this.layoutDelegate.getItemRect(tempKey);
                }while (itemRect && shouldSkip(prevRect, itemRect) && tempKey != null);
                return tempKey;
            }
        },
        {
            key: "isSameRow",
            value: function isSameRow(prevRect, itemRect) {
                return prevRect.y === itemRect.y || prevRect.x !== itemRect.x;
            }
        },
        {
            key: "isSameColumn",
            value: function isSameColumn(prevRect, itemRect) {
                return prevRect.x === itemRect.x || prevRect.y !== itemRect.y;
            }
        },
        {
            key: "getKeyBelow",
            value: function getKeyBelow(key) {
                var _this = this;
                if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, function(key) {
                    return _this.getNextKey(key);
                }, this.isSameRow);
                else return this.getNextKey(key);
            }
        },
        {
            key: "getKeyAbove",
            value: function getKeyAbove(key) {
                var _this = this;
                if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, function(key) {
                    return _this.getPreviousKey(key);
                }, this.isSameRow);
                else return this.getPreviousKey(key);
            }
        },
        {
            key: "getNextColumn",
            value: function getNextColumn(key, right) {
                return right ? this.getPreviousKey(key) : this.getNextKey(key);
            }
        },
        {
            key: "getKeyRightOf",
            value: function getKeyRightOf(key) {
                var _this = this;
                // This is a temporary solution for CardView until we refactor useSelectableCollection.
                // https://github.com/orgs/adobe/projects/19/views/32?pane=issue&itemId=77825042
                var layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyRightOf' : 'getKeyLeftOf';
                if (this.layoutDelegate[layoutDelegateMethod]) {
                    key = this.layoutDelegate[layoutDelegateMethod](key);
                    return this.findNextNonDisabled(key, function(key) {
                        return _this.layoutDelegate[layoutDelegateMethod](key);
                    });
                }
                if (this.layout === 'grid') {
                    if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'rtl');
                    else return this.findKey(key, function(key) {
                        return _this.getNextColumn(key, _this.direction === 'rtl');
                    }, this.isSameColumn);
                } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'rtl');
                return null;
            }
        },
        {
            key: "getKeyLeftOf",
            value: function getKeyLeftOf(key) {
                var _this = this;
                var layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyLeftOf' : 'getKeyRightOf';
                if (this.layoutDelegate[layoutDelegateMethod]) {
                    key = this.layoutDelegate[layoutDelegateMethod](key);
                    return this.findNextNonDisabled(key, function(key) {
                        return _this.layoutDelegate[layoutDelegateMethod](key);
                    });
                }
                if (this.layout === 'grid') {
                    if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'ltr');
                    else return this.findKey(key, function(key) {
                        return _this.getNextColumn(key, _this.direction === 'ltr');
                    }, this.isSameColumn);
                } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'ltr');
                return null;
            }
        },
        {
            key: "getFirstKey",
            value: function getFirstKey() {
                var _this = this;
                var key = this.collection.getFirstKey();
                return this.findNextNonDisabled(key, function(key) {
                    return _this.collection.getKeyAfter(key);
                });
            }
        },
        {
            key: "getLastKey",
            value: function getLastKey() {
                var _this = this;
                var key = this.collection.getLastKey();
                return this.findNextNonDisabled(key, function(key) {
                    return _this.collection.getKeyBefore(key);
                });
            }
        },
        {
            key: "getKeyPageAbove",
            value: function getKeyPageAbove(key) {
                var menu = this.ref.current;
                var itemRect = this.layoutDelegate.getItemRect(key);
                if (!itemRect) return null;
                if (menu && !(0, $e9a8111392ef6431$export$2bb74740c4e19def)(menu)) return this.getFirstKey();
                var nextKey = key;
                if (this.orientation === 'horizontal') {
                    var pageX = Math.max(0, itemRect.x + itemRect.width - this.layoutDelegate.getVisibleRect().width);
                    while(itemRect && itemRect.x > pageX && nextKey != null){
                        nextKey = this.getKeyAbove(nextKey);
                        itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
                    }
                } else {
                    var pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
                    while(itemRect && itemRect.y > pageY && nextKey != null){
                        nextKey = this.getKeyAbove(nextKey);
                        itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
                    }
                }
                return nextKey !== null && nextKey !== void 0 ? nextKey : this.getFirstKey();
            }
        },
        {
            key: "getKeyPageBelow",
            value: function getKeyPageBelow(key) {
                var menu = this.ref.current;
                var itemRect = this.layoutDelegate.getItemRect(key);
                if (!itemRect) return null;
                if (menu && !(0, $e9a8111392ef6431$export$2bb74740c4e19def)(menu)) return this.getLastKey();
                var nextKey = key;
                if (this.orientation === 'horizontal') {
                    var pageX = Math.min(this.layoutDelegate.getContentSize().width, itemRect.y - itemRect.width + this.layoutDelegate.getVisibleRect().width);
                    while(itemRect && itemRect.x < pageX && nextKey != null){
                        nextKey = this.getKeyBelow(nextKey);
                        itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
                    }
                } else {
                    var pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y - itemRect.height + this.layoutDelegate.getVisibleRect().height);
                    while(itemRect && itemRect.y < pageY && nextKey != null){
                        nextKey = this.getKeyBelow(nextKey);
                        itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
                    }
                }
                return nextKey !== null && nextKey !== void 0 ? nextKey : this.getLastKey();
            }
        },
        {
            key: "getKeyForSearch",
            value: function getKeyForSearch(search, fromKey) {
                if (!this.collator) return null;
                var collection = this.collection;
                var key = fromKey || this.getFirstKey();
                while(key != null){
                    var item = collection.getItem(key);
                    if (!item) return null;
                    var substring = item.textValue.slice(0, search.length);
                    if (item.textValue && this.collator.compare(substring, search) === 0) return key;
                    key = this.getNextKey(key);
                }
                return null;
            }
        }
    ]);
    return $2a25aae57d74318e$export$a05409b8bb224a5a;
}();



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $0058623f38789090$var$$325a3faab7a68acd$var$cache = new Map();
function $0058623f38789090$export$a16aca283550c30d(options) {
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : '');
    if ($0058623f38789090$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $0058623f38789090$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    var formatter = new Intl.Collator(locale, options);
    $0058623f38789090$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d091a875d44d9ce8$export$b95089534ab7c1fd(props) {
    var selectionManager = props.selectionManager, collection = props.collection, disabledKeys = props.disabledKeys, ref = props.ref, keyboardDelegate = props.keyboardDelegate, layoutDelegate = props.layoutDelegate;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    var collator = (0, $0058623f38789090$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    var disabledBehavior = selectionManager.disabledBehavior;
    var delegate = (0, $ggE0n.useMemo)(function() {
        return keyboardDelegate || new (0, $ec5997dede11a976$export$a05409b8bb224a5a)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator,
            layoutDelegate: layoutDelegate
        });
    }, [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    var _$ae20dd8cbca75726$export$d6daf82dcd84e87c = (0, $62c6d771f62f84ba$export$d6daf82dcd84e87c)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    })), collectionProps = _$ae20dd8cbca75726$export$d6daf82dcd84e87c.collectionProps;
    return {
        listProps: collectionProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $971531339f8087c3$export$38eaa17faae8f579(props, state, ref) {
    var tmp = props.shouldFocusWrap, shouldFocusWrap = tmp === void 0 ? true : tmp, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "shouldFocusWrap",
        "onKeyDown",
        "onKeyUp"
    ]);
    !props['aria-label'] && props['aria-labelledby'];
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    var _$ieN2F$useSelectableList = (0, $d091a875d44d9ce8$export$b95089534ab7c1fd)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: 'override'
    })), listProps = _$ieN2F$useSelectableList.listProps;
    (0, $0d3f9695692cbfb6$export$6f49b4016bfc8d56).set(state, {
        onClose: props.onClose,
        onAction: props.onAction,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus
    });
    return {
        menuProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
            role: 'menu'
        }, listProps), {
            onKeyDown: function(e) {
                var _listProps_onKeyDown;
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== 'Escape' || props.shouldUseVirtualFocus) (_listProps_onKeyDown = listProps.onKeyDown) === null || _listProps_onKeyDown === void 0 || _listProps_onKeyDown.call(listProps, e);
            }
        }))
    };
}


var $2QPpE = parcelRequire("2QPpE");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $90NkU = parcelRequire("90NkU");
function $6e2161e155c41f6f$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === 'function') return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $6e2161e155c41f6f$export$fbdeaa6a76694f71(iterable) {
    return $6e2161e155c41f6f$export$5f3398f8733f90e2(iterable, 0);
}
function $6e2161e155c41f6f$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    var i = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (i === index) return item;
            i++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $6e2161e155c41f6f$export$7475b2c64539e4cf(iterable) {
    var lastItem = undefined;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            lastItem = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return lastItem;
}
function $6e2161e155c41f6f$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    var aAncestors = (0, $90NkU._)($6e2161e155c41f6f$var$$c5a24bc478652b5f$var$getAncestors(collection, a)).concat([
        a
    ]);
    var bAncestors = (0, $90NkU._)($6e2161e155c41f6f$var$$c5a24bc478652b5f$var$getAncestors(collection, b)).concat([
        b
    ]);
    var firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex(function(a, i) {
        return a !== bAncestors[i];
    });
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex(function(node) {
        return node === b;
    }) >= 0) return 1;
    else if (bAncestors.findIndex(function(node) {
        return node === a;
    }) >= 0) return -1;
    // 🤷
    return -1;
}
function $6e2161e155c41f6f$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    var parents = [];
    var currNode = node;
    while((currNode === null || currNode === void 0 ? void 0 : currNode.parentKey) != null){
        currNode = collection.getItem(currNode.parentKey);
        if (currNode) parents.unshift(currNode);
    }
    return parents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $067b2222b10dede4$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $067b2222b10dede4$export$77d5aafae4e095b2(collection) {
    var count = $067b2222b10dede4$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    // TS isn't smart enough to know we've ensured count is a number, so use a new variable
    var counter = 0;
    var countItems = function(items) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.type === 'section') countItems((0, $6e2161e155c41f6f$export$1005530eda016c13)(item, collection));
                else if (item.type === 'item') counter++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    countItems(collection);
    $067b2222b10dede4$var$$453cc9f0df89c0a5$var$cache.set(collection, counter);
    return counter;
}





var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $b484270dee1cc590$var$$ef06256079686ba0$var$descriptionId = 0;
var $b484270dee1cc590$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $b484270dee1cc590$export$f8aeda7b10753fa1(description) {
    var _$hQ5Hp$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(), 2), id = _$hQ5Hp$useState[0], setId = _$hQ5Hp$useState[1];
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        if (!description) return;
        var desc = $b484270dee1cc590$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            var id = "react-aria-description-".concat($b484270dee1cc590$var$$ef06256079686ba0$var$descriptionId++);
            setId(id);
            var node = document.createElement('div');
            node.id = id;
            node.style.display = 'none';
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $b484270dee1cc590$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return function() {
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $b484270dee1cc590$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        'aria-describedby': description ? id : undefined
    };
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4ee3e88c9a959dfa$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $4ee3e88c9a959dfa$export$c24ed0104d07eab9(props) {
    var isDisabled = props.isDisabled, onLongPressStart = props.onLongPressStart, onLongPressEnd = props.onLongPressEnd, onLongPress = props.onLongPress, tmp = props.threshold, threshold = tmp === void 0 ? $4ee3e88c9a959dfa$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD : tmp, accessibilityDescription = props.accessibilityDescription;
    var timeRef = (0, $ggE0n.useRef)(undefined);
    var _$4k2kv$useGlobalListeners = (0, $af8e150eb57cc5a4$export$4eaf04e54aa8eed6)(), addGlobalListener = _$4k2kv$useGlobalListeners.addGlobalListener, removeGlobalListener = _$4k2kv$useGlobalListeners.removeGlobalListener;
    var _$f6c31cce2adf654f$export$45712eceda6fad21 = (0, $741a5668c6acdbac$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart: function(e) {
            e.continuePropagation();
            if (e.pointerType === 'mouse' || e.pointerType === 'touch') {
                if (onLongPressStart) onLongPressStart((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, e), {
                    type: 'longpressstart'
                }));
                timeRef.current = setTimeout(function() {
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent('pointercancel', {
                        bubbles: true
                    }));
                    // Ensure target is focused. On touch devices, browsers typically focus on pointer up.
                    if ((0, $435fb34f0a5eae0b$export$b204af158042fbac)(e.target).activeElement !== e.target) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(e.target);
                    if (onLongPress) onLongPress((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, e), {
                        type: 'longpress'
                    }));
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === 'touch') {
                    var onContextMenu = function(e) {
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, 'contextmenu', onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, 'pointerup', function() {
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(function() {
                            removeGlobalListener(e.target, 'contextmenu', onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd: function(e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, e), {
                type: 'longpressend'
            }));
        }
    }), pressProps = _$f6c31cce2adf654f$export$45712eceda6fad21.pressProps;
    var descriptionProps = (0, $b484270dee1cc590$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $47447c09a61acb27$export$ecf600387e221c37(options) {
    var id = options.id, manager = options.selectionManager, key = options.key, ref = options.ref, shouldSelectOnPressUp = options.shouldSelectOnPressUp, shouldUseVirtualFocus = options.shouldUseVirtualFocus, focus = options.focus, isDisabled = options.isDisabled, onAction = options.onAction, allowsDifferentPressOrigin = options.allowsDifferentPressOrigin, tmp = options.linkBehavior, linkBehavior = tmp === void 0 ? 'action' : tmp;
    var router = (0, $e863324b7200d517$export$9a302a45f65d0572)();
    id = (0, $7fc455d18519c289$export$f680877a34711e37)(id);
    var onSelect = function(e) {
        if (e.pointerType === 'keyboard' && (0, $109bc39d96a319f7$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === 'none') return;
            if (manager.isLink(key)) {
                if (linkBehavior === 'selection' && ref.current) {
                    var itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === 'override' || linkBehavior === 'none') return;
            }
            if (manager.selectionMode === 'single') {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === 'toggle' || e && ((0, $e99d72990a7c514f$export$16792effe837dba3)(e) || e.pointerType === 'touch' || e.pointerType === 'virtual')) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $ggE0n.useEffect)(function() {
        var isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused) {
            if (!shouldUseVirtualFocus) {
                if (focus) focus();
                else if (document.activeElement !== ref.current && ref.current) (0, $9134fa2a0acdb388$export$80f3e147d781571c)(ref.current);
            } else (0, $195d094bc4c5c9ef$export$76e4e37e5339496d)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    var itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus: function(e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = function(e) {
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    var isLinkOverride = manager.isLink(key) && linkBehavior === 'override';
    var hasLinkAction = manager.isLink(key) && linkBehavior !== 'selection' && linkBehavior !== 'none';
    var allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    var allowsActions = (onAction || hasLinkAction) && !isDisabled;
    var hasPrimaryAction = allowsActions && (manager.selectionBehavior === 'replace' ? !allowsSelection : !allowsSelection || manager.isEmpty);
    var hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === 'replace';
    var hasAction = hasPrimaryAction || hasSecondaryAction;
    var modality = (0, $ggE0n.useRef)(null);
    var longPressEnabled = hasAction && allowsSelection;
    var longPressEnabledOnPressStart = (0, $ggE0n.useRef)(false);
    var hadPrimaryActionOnPressStart = (0, $ggE0n.useRef)(false);
    var performAction = function(e) {
        if (onAction) onAction();
        if (hasLinkAction && ref.current) {
            var itemProps = manager.getItemProps(key);
            router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
        }
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    var itemPressProps = {
        ref: ref
    };
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = function(e) {
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === 'keyboard' && (!hasAction || $47447c09a61acb27$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin and interacting with mouse, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = function(e) {
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== 'mouse') {
                if (e.pointerType === 'keyboard' && !$47447c09a61acb27$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== 'keyboard' && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? undefined : function(e) {
                if (e.pointerType === 'mouse' && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : function(e) {
                if (e.pointerType !== 'keyboard' && e.pointerType !== 'mouse' && allowsSelection) onSelect(e);
            };
        }
    } else {
        itemPressProps.onPressStart = function(e) {
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === 'mouse' && !hasPrimaryAction || e.pointerType === 'keyboard' && (!allowsActions || $47447c09a61acb27$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = function(e) {
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === 'touch' || e.pointerType === 'pen' || e.pointerType === 'virtual' || e.pointerType === 'keyboard' && hasAction && $47447c09a61acb27$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === 'mouse' && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps['data-collection'] = (0, $109bc39d96a319f7$export$6aeb1680a0ae8741)(manager.collection);
    itemProps['data-key'] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    // When using virtual focus, make sure the focused key gets updated on press.
    if (shouldUseVirtualFocus) itemPressProps = (0, $850b305c152381bf$export$9d1611c77c2fe928)(itemPressProps, {
        onPressStart: function(e) {
            if (e.pointerType !== 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        },
        onPress: function(e) {
            if (e.pointerType === 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        }
    });
    var _$581M0$usePress = (0, $741a5668c6acdbac$export$45712eceda6fad21)(itemPressProps), pressProps = _$581M0$usePress.pressProps, isPressed = _$581M0$usePress.isPressed;
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    var onDoubleClick = hasSecondaryAction ? function(e) {
        if (modality.current === 'mouse') {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    var _$581M0$useLongPress = (0, $4ee3e88c9a959dfa$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress: function(e) {
            if (e.pointerType === 'touch') {
                onSelect(e);
                manager.setSelectionBehavior('toggle');
            }
        }
    }), longPressProps = _$581M0$useLongPress.longPressProps;
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    var onDragStartCapture = function(e) {
        if (modality.current === 'touch' && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    var onClick = manager.isLink(key) ? function(e) {
        if (!(0, $e863324b7200d517$export$95185d699e05d4d7).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction || shouldUseVirtualFocus && !isDisabled ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick,
            id: id
        }, shouldUseVirtualFocus ? {
            onMouseDown: function(e) {
                return e.preventDefault();
            }
        } : undefined),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $47447c09a61acb27$var$$880e95eb8b93ba9a$var$isActionKey() {
    var event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === 'Enter';
}
function $47447c09a61acb27$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    var event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === ' ' || (event === null || event === void 0 ? void 0 : event.code) === 'Space';
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f2887b520d09fce0$export$9d32628fc2aea7da(props, state, ref) {
    var id = props.id, key = props.key, closeOnSelect = props.closeOnSelect, isVirtualized = props.isVirtualized, hasPopup = props['aria-haspopup'], pressStartProp = props.onPressStart, pressUpProp = props.onPressUp, pressProp = props.onPress, onPressChange = props.onPressChange, onPressEnd = props.onPressEnd, hoverStartProp = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onFocus = props.onFocus, onFocusChange = props.onFocusChange, onBlur = props.onBlur, tmp = props.selectionManager, selectionManager = tmp === void 0 ? state.selectionManager : tmp;
    var isTrigger = !!hasPopup;
    var isTriggerExpanded = isTrigger && props['aria-expanded'] === 'true';
    var _props_isDisabled;
    var isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : selectionManager.isDisabled(key);
    var _props_isSelected;
    var isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : selectionManager.isSelected(key);
    var data = (0, $0d3f9695692cbfb6$export$6f49b4016bfc8d56).get(state);
    var item = state.collection.getItem(key);
    var onClose = props.onClose || data.onClose;
    var router = (0, $e863324b7200d517$export$9a302a45f65d0572)();
    var performAction = function(e) {
        var _item_props;
        if (isTrigger) return;
        if (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.onAction) item.props.onAction();
        else if (props.onAction) props.onAction(key);
        if (data.onAction) {
            // Must reassign to variable otherwise `this` binding gets messed up. Something to do with WeakMap.
            var onAction = data.onAction;
            onAction(key);
        }
        if (e.target instanceof HTMLAnchorElement && item) router.open(e.target, e, item.props.href, item.props.routerOptions);
    };
    var role = 'menuitem';
    if (!isTrigger) {
        if (selectionManager.selectionMode === 'single') role = 'menuitemradio';
        else if (selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    }
    var labelId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)();
    var descriptionId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)();
    var keyboardId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)();
    var ariaProps = {
        id: id,
        'aria-disabled': isDisabled || undefined,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined,
        'aria-controls': props['aria-controls'],
        'aria-haspopup': hasPopup,
        'aria-expanded': props['aria-expanded']
    };
    if (selectionManager.selectionMode !== 'none' && !isTrigger) ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        ariaProps['aria-posinset'] = item === null || item === void 0 ? void 0 : item.index;
        ariaProps['aria-setsize'] = (0, $067b2222b10dede4$export$77d5aafae4e095b2)(state.collection);
    }
    var onPressStart = function(e) {
        if (e.pointerType === 'keyboard') performAction(e);
        pressStartProp === null || pressStartProp === void 0 || pressStartProp(e);
    };
    var maybeClose = function() {
        // Pressing a menu item should close by default in single selection mode but not multiple
        // selection mode, except if overridden by the closeOnSelect prop.
        if (!isTrigger && onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : selectionManager.selectionMode !== 'multiple' || selectionManager.isLink(key))) onClose();
    };
    var onPressUp = function(e) {
        // If interacting with mouse, allow the user to mouse down on the trigger button,
        // drag, and release over an item (matching native behavior).
        if (e.pointerType === 'mouse') {
            performAction(e);
            maybeClose();
        }
        pressUpProp === null || pressUpProp === void 0 || pressUpProp(e);
    };
    var onPress = function(e) {
        if (e.pointerType !== 'keyboard' && e.pointerType !== 'mouse') {
            performAction(e);
            maybeClose();
        }
        pressProp === null || pressProp === void 0 || pressProp(e);
    };
    var _$7Kjv5$useSelectableItem = (0, $47447c09a61acb27$export$ecf600387e221c37)({
        id: id,
        selectionManager: selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: 'none',
        shouldUseVirtualFocus: data.shouldUseVirtualFocus
    }), itemProps = _$7Kjv5$useSelectableItem.itemProps, isFocused = _$7Kjv5$useSelectableItem.isFocused;
    var _$7Kjv5$usePress = (0, $741a5668c6acdbac$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    }), pressProps = _$7Kjv5$usePress.pressProps, isPressed = _$7Kjv5$usePress.isPressed;
    var _$7Kjv5$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart: function(e) {
            // Hovering over an already expanded sub dialog trigger should keep focus in the dialog.
            if (!(0, $33b4709e5e6e943f$export$b9b3dfddab17db27)() && !(isTriggerExpanded && hasPopup)) {
                selectionManager.setFocused(true);
                selectionManager.setFocusedKey(key);
            }
            hoverStartProp === null || hoverStartProp === void 0 || hoverStartProp(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    }), hoverProps = _$7Kjv5$useHover.hoverProps;
    var _$7Kjv5$useKeyboard = (0, $34773c96e36fc8c5$export$8f71654801c2f7cd)({
        onKeyDown: function(e) {
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case ' ':
                    if (!isDisabled && selectionManager.selectionMode === 'none' && !isTrigger && closeOnSelect !== false && onClose) onClose();
                    break;
                case 'Enter':
                    // The Enter key should always close on select, except if overridden.
                    if (!isDisabled && closeOnSelect !== false && !isTrigger && onClose) onClose();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    }), keyboardProps = _$7Kjv5$useKeyboard.keyboardProps;
    var _$7Kjv5$useFocus = (0, $5ae8d92fff8cd693$export$f8168d8dd8fd66e6)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    }), focusProps = _$7Kjv5$useFocus.focusProps;
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(item === null || item === void 0 ? void 0 : item.props);
    delete domProps.id;
    var linkProps = (0, $e863324b7200d517$export$7e924b3091a3bd18)(item === null || item === void 0 ? void 0 : item.props);
    return {
        menuItemProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, ariaProps, (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, linkProps, isTrigger ? {
            onFocus: itemProps.onFocus,
            'data-collection': itemProps['data-collection'],
            'data-key': itemProps['data-key']
        } : itemProps, pressProps, hoverProps, keyboardProps, focusProps, data.shouldUseVirtualFocus || isTrigger ? {
            onMouseDown: function(e) {
                return e.preventDefault();
            }
        } : undefined)), {
            // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
            tabIndex: itemProps.tabIndex != null && isTriggerExpanded && !data.shouldUseVirtualFocus ? -1 : itemProps.tabIndex
        }),
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && selectionManager.isFocused && (0, $33b4709e5e6e943f$export$b9b3dfddab17db27)() && !isTriggerExpanded,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $57ad39daabbfc941$export$73f7a44322579622(props) {
    var heading = props.heading, ariaLabel = props['aria-label'];
    var headingId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}


var $2QPpE = parcelRequire("2QPpE");

var $f04beab5faed2638$export$2e2bcd8739ae039 = {};
$f04beab5faed2638$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u0627\u0636\u063A\u0637 \u0645\u0637\u0648\u0644\u0627\u064B \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 Alt + \u0627\u0644\u0633\u0647\u0645 \u0644\u0623\u0633\u0641\u0644 \u0644\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629"
};


var $3aa78d47acb4a0f1$export$2e2bcd8739ae039 = {};
$3aa78d47acb4a0f1$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E \u0438\u043B\u0438 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Alt+ \u0441\u0442\u0440\u0435\u043B\u043A\u0430 \u043D\u0430\u0434\u043E\u043B\u0443, \u0437\u0430 \u0434\u0430 \u043E\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u043C\u0435\u043D\u044E\u0442\u043E"
};


var $955460ae1227f99c$export$2e2bcd8739ae039 = {};
$955460ae1227f99c$export$2e2bcd8739ae039 = {
    "longPressMessage": "Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u0161ipka dol\u016F otev\u0159ete nab\xeddku"
};


var $36bfcdf2c3331fed$export$2e2bcd8739ae039 = {};
$36bfcdf2c3331fed$export$2e2bcd8739ae039 = {
    "longPressMessage": "Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen"
};


var $c14a3f97d80510ef$export$2e2bcd8739ae039 = {};
$c14a3f97d80510ef$export$2e2bcd8739ae039 = {
    "longPressMessage": "Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen"
};


var $05332a14b7b2069f$export$2e2bcd8739ae039 = {};
$05332a14b7b2069f$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u03A0\u03B9\u03AD\u03C3\u03C4\u03B5 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B1 \u03AE \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Alt + \u03BA\u03AC\u03C4\u03C9 \u03B2\u03AD\u03BB\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03BD\u03BF\u03AF\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03BC\u03B5\u03BD\u03BF\u03CD"
};


var $843eec3f0ac66f95$export$2e2bcd8739ae039 = {};
$843eec3f0ac66f95$export$2e2bcd8739ae039 = {
    "longPressMessage": "Long press or press Alt + ArrowDown to open menu"
};


var $57c951e3874655c6$export$2e2bcd8739ae039 = {};
$57c951e3874655c6$export$2e2bcd8739ae039 = {
    "longPressMessage": "Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa"
};


var $8f2b61aa6161f80d$export$2e2bcd8739ae039 = {};
$8f2b61aa6161f80d$export$2e2bcd8739ae039 = {
    "longPressMessage": "Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool"
};


var $901c5a34239fd906$export$2e2bcd8739ae039 = {};
$901c5a34239fd906$export$2e2bcd8739ae039 = {
    "longPressMessage": "Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli"
};


var $e0514af4ca309ebb$export$2e2bcd8739ae039 = {};
$e0514af4ca309ebb$export$2e2bcd8739ae039 = {
    "longPressMessage": "Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu."
};


var $0e54a8d6532edb79$export$2e2bcd8739ae039 = {};
$0e54a8d6532edb79$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u05DC\u05D7\u05E5 \u05DC\u05D7\u05D9\u05E6\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05D0\u05D5 \u05D4\u05E7\u05E9 Alt + ArrowDown \u05DB\u05D3\u05D9 \u05DC\u05E4\u05EA\u05D5\u05D7 \u05D0\u05EA \u05D4\u05EA\u05E4\u05E8\u05D9\u05D8"
};


var $bb61ecfdb43d68f7$export$2e2bcd8739ae039 = {};
$bb61ecfdb43d68f7$export$2e2bcd8739ae039 = {
    "longPressMessage": "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};


var $69858d9d2fdf3125$export$2e2bcd8739ae039 = {};
$69858d9d2fdf3125$export$2e2bcd8739ae039 = {
    "longPressMessage": "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz"
};


var $b8569c4b5523e5eb$export$2e2bcd8739ae039 = {};
$b8569c4b5523e5eb$export$2e2bcd8739ae039 = {
    "longPressMessage": "Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu"
};


var $752f57298fcf2f13$export$2e2bcd8739ae039 = {};
$752f57298fcf2f13$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u9577\u62BC\u3057\u307E\u305F\u306F Alt+\u4E0B\u77E2\u5370\u30AD\u30FC\u3067\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F"
};


var $6171d9869a76ec94$export$2e2bcd8739ae039 = {};
$6171d9869a76ec94$export$2e2bcd8739ae039 = {
    "longPressMessage": "\uAE38\uAC8C \uB204\uB974\uAC70\uB098 Alt + \uC544\uB798\uCABD \uD654\uC0B4\uD45C\uB97C \uB20C\uB7EC \uBA54\uB274 \uC5F4\uAE30"
};


var $64553badc13ea831$export$2e2bcd8739ae039 = {};
$64553badc13ea831$export$2e2bcd8739ae039 = {
    "longPressMessage": "Nor\u0117dami atidaryti meniu, nuspaud\u0119 palaikykite arba paspauskite \u201EAlt + ArrowDown\u201C."
};


var $74020031a2eb13ae$export$2e2bcd8739ae039 = {};
$74020031a2eb13ae$export$2e2bcd8739ae039 = {
    "longPressMessage": "Lai atv\u0113rtu izv\u0113lni, turiet nospiestu vai nospiediet tausti\u0146u kombin\u0101ciju Alt + lejupv\u0113rst\u0101 bulti\u0146a"
};


var $09be5e1afbda9464$export$2e2bcd8739ae039 = {};
$09be5e1afbda9464$export$2e2bcd8739ae039 = {
    "longPressMessage": "Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen"
};


var $c1902d8743822dae$export$2e2bcd8739ae039 = {};
$c1902d8743822dae$export$2e2bcd8739ae039 = {
    "longPressMessage": "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};


var $218712f8463bcd78$export$2e2bcd8739ae039 = {};
$218712f8463bcd78$export$2e2bcd8739ae039 = {
    "longPressMessage": "Naci\u015Bnij i przytrzymaj lub naci\u015Bnij klawisze Alt + Strza\u0142ka w d\xf3\u0142, aby otworzy\u0107 menu"
};


var $1d98b67707724e59$export$2e2bcd8739ae039 = {};
$1d98b67707724e59$export$2e2bcd8739ae039 = {
    "longPressMessage": "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};


var $19897edd3039cfd7$export$2e2bcd8739ae039 = {};
$19897edd3039cfd7$export$2e2bcd8739ae039 = {
    "longPressMessage": "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};


var $f9cdc10bf459888c$export$2e2bcd8739ae039 = {};
$f9cdc10bf459888c$export$2e2bcd8739ae039 = {
    "longPressMessage": "Ap\u0103sa\u021Bi lung sau ap\u0103sa\u021Bi pe Alt + s\u0103geat\u0103 \xeen jos pentru a deschide meniul"
};


var $9f59f1c545b3ccd7$export$2e2bcd8739ae039 = {};
$9f59f1c545b3ccd7$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438 \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 Alt + \u0421\u0442\u0440\u0435\u043B\u043A\u0430 \u0432\u043D\u0438\u0437, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u043D\u044E"
};


var $df37721a436f0df6$export$2e2bcd8739ae039 = {};
$df37721a436f0df6$export$2e2bcd8739ae039 = {
    "longPressMessage": "Ponuku otvor\xedte dlh\xfdm stla\u010Den\xedm alebo stla\u010Den\xedm kl\xe1vesu Alt + kl\xe1vesu so \u0161\xedpkou nadol"
};


var $5f712d7edbee2d3b$export$2e2bcd8739ae039 = {};
$5f712d7edbee2d3b$export$2e2bcd8739ae039 = {
    "longPressMessage": "Za odprtje menija pritisnite in dr\u017Eite gumb ali pritisnite Alt+pu\u0161\u010Dica navzdol"
};


var $5cca556d9db15c87$export$2e2bcd8739ae039 = {};
$5cca556d9db15c87$export$2e2bcd8739ae039 = {
    "longPressMessage": "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};


var $5e63e150d013d86e$export$2e2bcd8739ae039 = {};
$5e63e150d013d86e$export$2e2bcd8739ae039 = {
    "longPressMessage": "H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn"
};


var $df67b447a5bb4888$export$2e2bcd8739ae039 = {};
$df67b447a5bb4888$export$2e2bcd8739ae039 = {
    "longPressMessage": "Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u0131n veya Alt + A\u015Fa\u011F\u0131 Ok tu\u015Funa bas\u0131n"
};


var $5e1fca1750e5e4b5$export$2e2bcd8739ae039 = {};
$5e1fca1750e5e4b5$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u0414\u043E\u0432\u0433\u043E \u0430\u0431\u043E \u0437\u0432\u0438\u0447\u0430\u0439\u043D\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u044E \u043A\u043B\u0430\u0432\u0456\u0448 Alt \u0456 \u0441\u0442\u0440\u0456\u043B\u043A\u0430 \u0432\u043D\u0438\u0437, \u0449\u043E\u0431 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043C\u0435\u043D\u044E"
};


var $d47798761e51fc09$export$2e2bcd8739ae039 = {};
$d47798761e51fc09$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u957F\u6309\u6216\u6309 Alt + \u5411\u4E0B\u65B9\u5411\u952E\u4EE5\u6253\u5F00\u83DC\u5355"
};


var $4a27c39dac82be4c$export$2e2bcd8739ae039 = {};
$4a27c39dac82be4c$export$2e2bcd8739ae039 = {
    "longPressMessage": "\u9577\u6309\u6216\u6309 Alt+\u5411\u4E0B\u9375\u4EE5\u958B\u555F\u529F\u80FD\u8868"
};


var $1b5b69fcf25275ed$export$2e2bcd8739ae039 = {};
$1b5b69fcf25275ed$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $f04beab5faed2638$export$2e2bcd8739ae039),
    "bg-BG": (0, $3aa78d47acb4a0f1$export$2e2bcd8739ae039),
    "cs-CZ": (0, $955460ae1227f99c$export$2e2bcd8739ae039),
    "da-DK": (0, $36bfcdf2c3331fed$export$2e2bcd8739ae039),
    "de-DE": (0, $c14a3f97d80510ef$export$2e2bcd8739ae039),
    "el-GR": (0, $05332a14b7b2069f$export$2e2bcd8739ae039),
    "en-US": (0, $843eec3f0ac66f95$export$2e2bcd8739ae039),
    "es-ES": (0, $57c951e3874655c6$export$2e2bcd8739ae039),
    "et-EE": (0, $8f2b61aa6161f80d$export$2e2bcd8739ae039),
    "fi-FI": (0, $901c5a34239fd906$export$2e2bcd8739ae039),
    "fr-FR": (0, $e0514af4ca309ebb$export$2e2bcd8739ae039),
    "he-IL": (0, $0e54a8d6532edb79$export$2e2bcd8739ae039),
    "hr-HR": (0, $bb61ecfdb43d68f7$export$2e2bcd8739ae039),
    "hu-HU": (0, $69858d9d2fdf3125$export$2e2bcd8739ae039),
    "it-IT": (0, $b8569c4b5523e5eb$export$2e2bcd8739ae039),
    "ja-JP": (0, $752f57298fcf2f13$export$2e2bcd8739ae039),
    "ko-KR": (0, $6171d9869a76ec94$export$2e2bcd8739ae039),
    "lt-LT": (0, $64553badc13ea831$export$2e2bcd8739ae039),
    "lv-LV": (0, $74020031a2eb13ae$export$2e2bcd8739ae039),
    "nb-NO": (0, $09be5e1afbda9464$export$2e2bcd8739ae039),
    "nl-NL": (0, $c1902d8743822dae$export$2e2bcd8739ae039),
    "pl-PL": (0, $218712f8463bcd78$export$2e2bcd8739ae039),
    "pt-BR": (0, $1d98b67707724e59$export$2e2bcd8739ae039),
    "pt-PT": (0, $19897edd3039cfd7$export$2e2bcd8739ae039),
    "ro-RO": (0, $f9cdc10bf459888c$export$2e2bcd8739ae039),
    "ru-RU": (0, $9f59f1c545b3ccd7$export$2e2bcd8739ae039),
    "sk-SK": (0, $df37721a436f0df6$export$2e2bcd8739ae039),
    "sl-SI": (0, $5f712d7edbee2d3b$export$2e2bcd8739ae039),
    "sr-SP": (0, $5cca556d9db15c87$export$2e2bcd8739ae039),
    "sv-SE": (0, $5e63e150d013d86e$export$2e2bcd8739ae039),
    "tr-TR": (0, $df67b447a5bb4888$export$2e2bcd8739ae039),
    "uk-UA": (0, $5e1fca1750e5e4b5$export$2e2bcd8739ae039),
    "zh-CN": (0, $d47798761e51fc09$export$2e2bcd8739ae039),
    "zh-TW": (0, $4a27c39dac82be4c$export$2e2bcd8739ae039)
};







var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $69ae150e85dff522$export$f9d5c8beee7d008d(props, state, ref) {
    var type = props.type;
    var isOpen = state.isOpen;
    (0, $ggE0n.useEffect)(function() {
        if (ref && ref.current) (0, $4b2032e9054520ff$export$f6211563215e3b37).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    var ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    var overlayId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : undefined,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}


function $29d3cc55e55a1021$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $29d3cc55e55a1021$export$dc9c12ed27dd1b49(props, state, ref) {
    var tmp = props.type, type = tmp === void 0 ? 'menu' : tmp, isDisabled = props.isDisabled, tmp1 = props.trigger, trigger = tmp1 === void 0 ? 'press' : tmp1;
    var menuTriggerId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var _$czs6v$useOverlayTrigger = (0, $69ae150e85dff522$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref), triggerProps = _$czs6v$useOverlayTrigger.triggerProps, overlayProps = _$czs6v$useOverlayTrigger.overlayProps;
    var onKeyDown = function(e) {
        if (isDisabled) return;
        if (trigger === 'longPress' && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case 'Enter':
            case ' ':
                if (trigger === 'longPress') return;
            // fallthrough
            case 'ArrowDown':
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('first');
                break;
            case 'ArrowUp':
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('last');
                break;
            default:
                // Allow other keys.
                if ('continuePropagation' in e) e.continuePropagation();
        }
    };
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($29d3cc55e55a1021$var$$parcel$interopDefault((0, $1b5b69fcf25275ed$export$2e2bcd8739ae039)), '@react-aria/menu');
    var _$czs6v$useLongPress = (0, $4ee3e88c9a959dfa$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== 'longPress',
        accessibilityDescription: stringFormatter.format('longPressMessage'),
        onLongPressStart: function() {
            state.close();
        },
        onLongPress: function() {
            state.open('first');
        }
    }), longPressProps = _$czs6v$useLongPress.longPressProps;
    var pressProps = {
        preventFocusOnPress: true,
        onPressStart: function(e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) {
                (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(e.target);
                // If opened with a screen reader, auto focus the first item.
                // Otherwise, the menu itself will be focused.
                state.open(e.pointerType === 'virtual' ? 'first' : null);
            }
        },
        onPress: function(e) {
            if (e.pointerType === 'touch' && !isDisabled) {
                (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(e.target);
                state.toggle();
            }
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
        menuTriggerProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, triggerProps, trigger === 'press' ? pressProps : longPressProps), {
            id: menuTriggerId,
            onKeyDown: onKeyDown
        }),
        menuProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, overlayProps), {
            'aria-labelledby': menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        })
    };
}


var $2QPpE = parcelRequire("2QPpE");


var $ggE0n = parcelRequire("ggE0n");


var $a628cdebe9da215b$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS = 2;
var $a628cdebe9da215b$var$$d275435c250248f8$var$THROTTLE_TIME = 50;
var $a628cdebe9da215b$var$$d275435c250248f8$var$TIMEOUT_TIME = 1000;
var $a628cdebe9da215b$var$$d275435c250248f8$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $a628cdebe9da215b$export$85ec83e04c95f50a(options) {
    var menuRef = options.menuRef, submenuRef = options.submenuRef, isOpen = options.isOpen, isDisabled = options.isDisabled;
    var prevPointerPos = (0, $ggE0n.useRef)(undefined);
    var submenuRect = (0, $ggE0n.useRef)(undefined);
    var lastProcessedTime = (0, $ggE0n.useRef)(0);
    var timeout = (0, $ggE0n.useRef)(undefined);
    var autoCloseTimeout = (0, $ggE0n.useRef)(undefined);
    var submenuSide = (0, $ggE0n.useRef)(undefined);
    var movementsTowardsSubmenuCount = (0, $ggE0n.useRef)(2);
    var _$fUfeP$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), preventPointerEvents = _$fUfeP$useState[0], setPreventPointerEvents = _$fUfeP$useState[1];
    var updateSubmenuRect = function() {
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: submenuRef,
        onResize: updateSubmenuRect
    });
    var reset = function() {
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $a628cdebe9da215b$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        prevPointerPos.current = undefined;
    };
    var modality = (0, $33b4709e5e6e943f$export$98e20ec92f614cfe)();
    // Prevent mouse down over safe triangle. Clicking while pointer-events: none is applied
    // will cause focus to move unexpectedly since it will go to an element behind the menu.
    var onPointerDown = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(e) {
        if (preventPointerEvents) e.preventDefault();
    });
    (0, $ggE0n.useEffect)(function() {
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = 'none';
        else menuRef.current.style.pointerEvents = '';
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $ggE0n.useEffect)(function() {
        var submenu = submenuRef.current;
        var menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== 'pointer' || !menu) {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        var onPointerMove = function(e) {
            if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
            var currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $a628cdebe9da215b$var$$d275435c250248f8$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            var mouseX = e.clientX, mouseY = e.clientY;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? 'left' : 'right';
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ var prevMouseX = prevPointerPos.current.x;
            var prevMouseY = prevPointerPos.current.y;
            var toSubmenuX = submenuSide.current === 'right' ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            var angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $a628cdebe9da215b$var$$d275435c250248f8$var$ANGLE_PADDING;
            var angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $a628cdebe9da215b$var$$d275435c250248f8$var$ANGLE_PADDING;
            var anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === 'left' ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            var isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $a628cdebe9da215b$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $a628cdebe9da215b$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(function() {
                reset();
                autoCloseTimeout.current = setTimeout(function() {
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    var target = document.elementFromPoint(mouseX, mouseY);
                    if (target && menu.contains(target)) target.dispatchEvent(new PointerEvent('pointerover', {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $a628cdebe9da215b$var$$d275435c250248f8$var$TIMEOUT_TIME);
        };
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerdown', onPointerDown, true);
        return function() {
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerdown', onPointerDown, true);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $a628cdebe9da215b$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        onPointerDown,
        submenuRef
    ]);
}




var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7a8856d865383694$export$7138b0d059a6e743(props, state, ref) {
    var parentMenuRef = props.parentMenuRef, submenuRef = props.submenuRef, tmp = props.type, type = tmp === void 0 ? 'menu' : tmp, isDisabled = props.isDisabled, tmp1 = props.delay, delay = tmp1 === void 0 ? 200 : tmp1, shouldUseVirtualFocus = props.shouldUseVirtualFocus;
    var submenuTriggerId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var overlayId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var _$dXlYe$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), direction = _$dXlYe$useLocale.direction;
    var openTimeout = (0, $ggE0n.useRef)(undefined);
    var cancelOpenTimeout = (0, $ggE0n.useCallback)(function() {
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    var onSubmenuOpen = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(focusStrategy) {
        cancelOpenTimeout();
        state.open(focusStrategy);
    });
    var onSubmenuClose = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function() {
        cancelOpenTimeout();
        state.close();
    });
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        return function() {
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    var submenuKeyDown = function(e) {
        // If focus is not within the menu, assume virtual focus is being used.
        // This means some other input element is also within the popover, so we shouldn't close the menu.
        if (!e.currentTarget.contains(document.activeElement)) return;
        switch(e.key){
            case 'ArrowLeft':
                if (direction === 'ltr' && e.currentTarget.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(ref.current);
                }
                break;
            case 'ArrowRight':
                if (direction === 'rtl' && e.currentTarget.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(ref.current);
                }
                break;
            case 'Escape':
                var _submenuRef_current;
                // TODO: can remove this when we fix collection event leaks
                if ((_submenuRef_current = submenuRef.current) === null || _submenuRef_current === void 0 ? void 0 : _submenuRef_current.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(ref.current);
                }
                break;
        }
    };
    var _state_focusStrategy;
    var submenuProps = (0, $2QPpE._)({
        id: overlayId,
        'aria-labelledby': submenuTriggerId,
        submenuLevel: state.submenuLevel
    }, type === 'menu' && {
        onClose: state.closeAll,
        autoFocus: (_state_focusStrategy = state.focusStrategy) !== null && _state_focusStrategy !== void 0 ? _state_focusStrategy : undefined,
        onKeyDown: submenuKeyDown
    });
    var submenuTriggerKeyDown = function(e) {
        switch(e.key){
            case 'ArrowRight':
                if (!isDisabled) {
                    if (direction === 'ltr') {
                        e.preventDefault();
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(submenuRef.current);
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case 'ArrowLeft':
                if (!isDisabled) {
                    if (direction === 'rtl') {
                        e.preventDefault();
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(submenuRef.current);
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    var onPressStart = function(e) {
        if (!isDisabled && (e.pointerType === 'virtual' || e.pointerType === 'keyboard')) onSubmenuOpen('first');
    };
    var onPress = function(e) {
        if (!isDisabled && (e.pointerType === 'touch' || e.pointerType === 'mouse')) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    var onHoverChange = function(isHovered) {
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(function() {
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    var onBlur = function(e) {
        var _parentMenuRef_current;
        if (state.isOpen && ((_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.contains(e.relatedTarget))) onSubmenuClose();
    };
    var shouldCloseOnInteractOutside = function(target) {
        if (target !== ref.current) return true;
        return false;
    };
    (0, $a628cdebe9da215b$export$85ec83e04c95f50a)({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            'aria-controls': state.isOpen ? overlayId : undefined,
            'aria-haspopup': !isDisabled ? type : undefined,
            'aria-expanded': state.isOpen ? 'true' : 'false',
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            onBlur: onBlur,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}




var $2QPpE = parcelRequire("2QPpE");



var $90NkU = parcelRequire("90NkU");


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c2b891d144210dfb$export$79fefeb1c2091ac3(props) {
    var overlayTriggerState = (0, $995b915c2e36d0af$export$61c6a8c84e605fb6)(props);
    var _$8bn9m$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), focusStrategy = _$8bn9m$useState[0], setFocusStrategy = _$8bn9m$useState[1];
    var _$8bn9m$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)([]), 2), expandedKeysStack = _$8bn9m$useState1[0], setExpandedKeysStack = _$8bn9m$useState1[1];
    var closeAll = function() {
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    var openSubmenu = function(triggerKey, level) {
        setExpandedKeysStack(function(oldStack) {
            if (level > oldStack.length) return oldStack;
            return (0, $90NkU._)(oldStack.slice(0, level)).concat([
                triggerKey
            ]);
        });
    };
    var closeSubmenu = function(triggerKey, level) {
        setExpandedKeysStack(function(oldStack) {
            var key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
        focusStrategy: focusStrategy
    }, overlayTriggerState), {
        open: function() {
            var focusStrategy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle: function() {
            var focusStrategy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close: function() {
            closeAll();
        },
        expandedKeysStack: expandedKeysStack,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    });
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a2789ec3d0864402$export$cfc51cf86138bf98(props, state) {
    var triggerKey = props.triggerKey;
    var expandedKeysStack = state.expandedKeysStack, openSubmenu = state.openSubmenu, closeSubmenu = state.closeSubmenu, closeAll = state.close;
    var _$7exkJ$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(expandedKeysStack === null || expandedKeysStack === void 0 ? void 0 : expandedKeysStack.length), 1), submenuLevel = _$7exkJ$useState[0];
    var isOpen = (0, $ggE0n.useMemo)(function() {
        return expandedKeysStack[submenuLevel] === triggerKey;
    }, [
        expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    var _$7exkJ$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), focusStrategy = _$7exkJ$useState1[0], setFocusStrategy = _$7exkJ$useState1[1];
    var open = (0, $ggE0n.useCallback)(function(focusStrategy) {
        setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
        openSubmenu(triggerKey, submenuLevel);
    }, [
        openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    var close = (0, $ggE0n.useCallback)(function() {
        setFocusStrategy(null);
        closeSubmenu(triggerKey, submenuLevel);
    }, [
        closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    var toggle = (0, $ggE0n.useCallback)(function(focusStrategy) {
        setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $ggE0n.useMemo)(function() {
        return {
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: function() {},
            toggle: toggle
        };
    }, [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


var $90NkU = parcelRequire("90NkU");


var $7d38444744a757dc$export$863faf230ee2118a = /*#__PURE__*/ function() {
    "use strict";
    function $05ca4cd7c4a5a999$export$863faf230ee2118a(nodes) {
        var _this = this;
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, expandedKeys = _ref.expandedKeys;
        (0, $gpEpt._)(this, $05ca4cd7c4a5a999$export$863faf230ee2118a);
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        var visit = function(node) {
            _this.keyMap.set(node.key, node);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (node.childNodes && (node.type === 'section' || expandedKeys.has(node.key))) try {
                for(var _iterator = node.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    visit(child);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                visit(node);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var last = null;
        var index = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = this.keyMap[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $c6938abc98c6418f$export$71511d61b312f219)(_step1.value, 2), key = _step_value[0], node1 = _step_value[1];
                if (last) {
                    last.nextKey = key;
                    node1.prevKey = last.key;
                } else {
                    this.firstKey = key;
                    node1.prevKey = undefined;
                }
                if (node1.type === 'item') node1.index = index++;
                last = node1;
                // Set nextKey as undefined since this might be the last node
                // If it isn't the last node, last.nextKey will properly set at start of new loop
                last.nextKey = undefined;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _last_key;
        this.lastKey = (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
    (0, $eOJ9o._)($05ca4cd7c4a5a999$export$863faf230ee2118a, [
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                5,
                                (0, $37faaaff56909290$export$19a8beecd37a4c45)(this.iterable)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "size",
            get: function get() {
                return this.keyMap.size;
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                return this.keyMap.keys();
            }
        },
        {
            key: "getKeyBefore",
            value: function getKeyBefore(key) {
                var node = this.keyMap.get(key);
                var _node_prevKey;
                return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
            }
        },
        {
            key: "getKeyAfter",
            value: function getKeyAfter(key) {
                var node = this.keyMap.get(key);
                var _node_nextKey;
                return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
            }
        },
        {
            key: "getFirstKey",
            value: function getFirstKey() {
                return this.firstKey;
            }
        },
        {
            key: "getLastKey",
            value: function getLastKey() {
                return this.lastKey;
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                var _this_keyMap_get;
                return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
            }
        },
        {
            key: "at",
            value: function at(idx) {
                var keys = (0, $90NkU._)(this.getKeys());
                return this.getItem(keys[idx]);
            }
        }
    ]);
    return $05ca4cd7c4a5a999$export$863faf230ee2118a;
}();



var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $83AyS = parcelRequire("83AyS");

var $3G0sq = parcelRequire("3G0sq");
var $5c8f0ce8e12e4d46$export$52baac22726c72bf = /*#__PURE__*/ function(Set1) {
    "use strict";
    (0, $83AyS._)($e40ea825a81a3709$export$52baac22726c72bf, Set1);
    function $e40ea825a81a3709$export$52baac22726c72bf(keys, anchorKey, currentKey) {
        (0, $gpEpt._)(this, $e40ea825a81a3709$export$52baac22726c72bf);
        var _this;
        _this = (0, $3qQ3j._)(this, $e40ea825a81a3709$export$52baac22726c72bf, [
            keys
        ]);
        if (keys instanceof $e40ea825a81a3709$export$52baac22726c72bf) {
            _this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : keys.anchorKey;
            _this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : keys.currentKey;
        } else {
            _this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : null;
            _this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : null;
        }
        return _this;
    }
    return $e40ea825a81a3709$export$52baac22726c72bf;
}((0, $3G0sq._)(Set));



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $a24f982606f0f9ec$export$6c8a5aaad13c9852 = /*#__PURE__*/ function() {
    "use strict";
    function $d496c0a20b6e58ec$export$6c8a5aaad13c9852(collection, state, options) {
        (0, $gpEpt._)(this, $d496c0a20b6e58ec$export$6c8a5aaad13c9852);
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
        this.layoutDelegate = (options === null || options === void 0 ? void 0 : options.layoutDelegate) || null;
    }
    (0, $eOJ9o._)($d496c0a20b6e58ec$export$6c8a5aaad13c9852, [
        {
            key: "selectionMode",
            get: /**
   * The type of selection that is allowed in the collection.
   */ function get() {
                return this.state.selectionMode;
            }
        },
        {
            key: "disallowEmptySelection",
            get: /**
   * Whether the collection allows empty selection.
   */ function get() {
                return this.state.disallowEmptySelection;
            }
        },
        {
            key: "selectionBehavior",
            get: /**
   * The selection behavior for the collection.
   */ function get() {
                return this.state.selectionBehavior;
            }
        },
        {
            /**
   * Sets the selection behavior for the collection.
   */ key: "setSelectionBehavior",
            value: function setSelectionBehavior(selectionBehavior) {
                this.state.setSelectionBehavior(selectionBehavior);
            }
        },
        {
            key: "isFocused",
            get: /**
   * Whether the collection is currently focused.
   */ function get() {
                return this.state.isFocused;
            }
        },
        {
            /**
   * Sets whether the collection is focused.
   */ key: "setFocused",
            value: function setFocused(isFocused) {
                this.state.setFocused(isFocused);
            }
        },
        {
            key: "focusedKey",
            get: /**
   * The current focused key in the collection.
   */ function get() {
                return this.state.focusedKey;
            }
        },
        {
            key: "childFocusStrategy",
            get: /** Whether the first or last child of the focused key should receive focus. */ function get() {
                return this.state.childFocusStrategy;
            }
        },
        {
            /**
   * Sets the focused key.
   */ key: "setFocusedKey",
            value: function setFocusedKey(key, childFocusStrategy) {
                if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
            }
        },
        {
            key: "selectedKeys",
            get: /**
   * The currently selected keys in the collection.
   */ function get() {
                return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
            }
        },
        {
            key: "rawSelection",
            get: /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ function get() {
                return this.state.selectedKeys;
            }
        },
        {
            /**
   * Returns whether a key is selected.
   */ key: "isSelected",
            value: function isSelected(key) {
                if (this.state.selectionMode === 'none') return false;
                var mappedKey = this.getKey(key);
                if (mappedKey == null) return false;
                return this.state.selectedKeys === 'all' ? this.canSelectItem(mappedKey) : this.state.selectedKeys.has(mappedKey);
            }
        },
        {
            key: "isEmpty",
            get: /**
   * Whether the selection is empty.
   */ function get() {
                return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
            }
        },
        {
            key: "isSelectAll",
            get: /**
   * Whether all items in the collection are selected.
   */ function get() {
                if (this.isEmpty) return false;
                if (this.state.selectedKeys === 'all') return true;
                if (this._isSelectAll != null) return this._isSelectAll;
                var allKeys = this.getSelectAllKeys();
                var selectedKeys = this.state.selectedKeys;
                this._isSelectAll = allKeys.every(function(k) {
                    return selectedKeys.has(k);
                });
                return this._isSelectAll;
            }
        },
        {
            key: "firstSelectedKey",
            get: function get() {
                var first = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.state.selectedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var item = this.collection.getItem(key);
                        if (!first || item && (0, $6e2161e155c41f6f$export$8c434b3a7a4dad6)(this.collection, item, first) < 0) first = item;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _first_key;
                return (_first_key = first === null || first === void 0 ? void 0 : first.key) !== null && _first_key !== void 0 ? _first_key : null;
            }
        },
        {
            key: "lastSelectedKey",
            get: function get() {
                var last = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.state.selectedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var item = this.collection.getItem(key);
                        if (!last || item && (0, $6e2161e155c41f6f$export$8c434b3a7a4dad6)(this.collection, item, last) > 0) last = item;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _last_key;
                return (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
            }
        },
        {
            key: "disabledKeys",
            get: function get() {
                return this.state.disabledKeys;
            }
        },
        {
            key: "disabledBehavior",
            get: function get() {
                return this.state.disabledBehavior;
            }
        },
        {
            /**
   * Extends the selection to the given key.
   */ key: "extendSelection",
            value: function extendSelection(toKey) {
                if (this.selectionMode === 'none') return;
                if (this.selectionMode === 'single') {
                    this.replaceSelection(toKey);
                    return;
                }
                var mappedToKey = this.getKey(toKey);
                if (mappedToKey == null) return;
                var selection;
                // Only select the one key if coming from a select all.
                if (this.state.selectedKeys === 'all') selection = new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)([
                    mappedToKey
                ], mappedToKey, mappedToKey);
                else {
                    var selectedKeys = this.state.selectedKeys;
                    var _selectedKeys_anchorKey;
                    var anchorKey = (_selectedKeys_anchorKey = selectedKeys.anchorKey) !== null && _selectedKeys_anchorKey !== void 0 ? _selectedKeys_anchorKey : mappedToKey;
                    selection = new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)(selectedKeys, anchorKey, mappedToKey);
                    var _selectedKeys_currentKey;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.getKeyRange(anchorKey, (_selectedKeys_currentKey = selectedKeys.currentKey) !== null && _selectedKeys_currentKey !== void 0 ? _selectedKeys_currentKey : mappedToKey)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            selection.delete(key);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = this.getKeyRange(mappedToKey, anchorKey)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key1 = _step1.value;
                            if (this.canSelectItem(key1)) selection.add(key1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                this.state.setSelectedKeys(selection);
            }
        },
        {
            key: "getKeyRange",
            value: function getKeyRange(from, to) {
                var fromItem = this.collection.getItem(from);
                var toItem = this.collection.getItem(to);
                if (fromItem && toItem) {
                    if ((0, $6e2161e155c41f6f$export$8c434b3a7a4dad6)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
                    return this.getKeyRangeInternal(to, from);
                }
                return [];
            }
        },
        {
            key: "getKeyRangeInternal",
            value: function getKeyRangeInternal(from, to) {
                var _this_layoutDelegate;
                if ((_this_layoutDelegate = this.layoutDelegate) === null || _this_layoutDelegate === void 0 ? void 0 : _this_layoutDelegate.getKeyRange) return this.layoutDelegate.getKeyRange(from, to);
                var keys = [];
                var key = from;
                while(key != null){
                    var item = this.collection.getItem(key);
                    if (item && (item.type === 'item' || item.type === 'cell' && this.allowsCellSelection)) keys.push(key);
                    if (key === to) return keys;
                    key = this.collection.getKeyAfter(key);
                }
                return [];
            }
        },
        {
            key: "getKey",
            value: function getKey(key) {
                var item = this.collection.getItem(key);
                if (!item) return key;
                // If cell selection is allowed, just return the key.
                if (item.type === 'cell' && this.allowsCellSelection) return key;
                // Find a parent item to select
                while(item && item.type !== 'item' && item.parentKey != null)item = this.collection.getItem(item.parentKey);
                if (!item || item.type !== 'item') return null;
                return item.key;
            }
        },
        {
            /**
   * Toggles whether the given key is selected.
   */ key: "toggleSelection",
            value: function toggleSelection(key) {
                if (this.selectionMode === 'none') return;
                if (this.selectionMode === 'single' && !this.isSelected(key)) {
                    this.replaceSelection(key);
                    return;
                }
                var mappedKey = this.getKey(key);
                if (mappedKey == null) return;
                var keys = new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
                if (keys.has(mappedKey)) keys.delete(mappedKey);
                else if (this.canSelectItem(mappedKey)) {
                    keys.add(mappedKey);
                    keys.anchorKey = mappedKey;
                    keys.currentKey = mappedKey;
                }
                if (this.disallowEmptySelection && keys.size === 0) return;
                this.state.setSelectedKeys(keys);
            }
        },
        {
            /**
   * Replaces the selection with only the given key.
   */ key: "replaceSelection",
            value: function replaceSelection(key) {
                if (this.selectionMode === 'none') return;
                var mappedKey = this.getKey(key);
                if (mappedKey == null) return;
                var selection = this.canSelectItem(mappedKey) ? new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)([
                    mappedKey
                ], mappedKey, mappedKey) : new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)();
                this.state.setSelectedKeys(selection);
            }
        },
        {
            /**
   * Replaces the selection with the given keys.
   */ key: "setSelectedKeys",
            value: function setSelectedKeys(keys) {
                if (this.selectionMode === 'none') return;
                var selection = new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var mappedKey = this.getKey(key);
                        if (mappedKey != null) {
                            selection.add(mappedKey);
                            if (this.selectionMode === 'single') break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.state.setSelectedKeys(selection);
            }
        },
        {
            key: "getSelectAllKeys",
            value: function getSelectAllKeys() {
                var _this = this;
                var keys = [];
                var addKeys = function(key) {
                    while(key != null){
                        if (_this.canSelectItem(key)) {
                            var _getFirstItem;
                            var item = _this.collection.getItem(key);
                            if ((item === null || item === void 0 ? void 0 : item.type) === 'item') keys.push(key);
                            var _getFirstItem_key;
                            // Add child keys. If cell selection is allowed, then include item children too.
                            if ((item === null || item === void 0 ? void 0 : item.hasChildNodes) && (_this.allowsCellSelection || item.type !== 'item')) addKeys((_getFirstItem_key = (_getFirstItem = (0, $6e2161e155c41f6f$export$fbdeaa6a76694f71)((0, $6e2161e155c41f6f$export$1005530eda016c13)(item, _this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null);
                        }
                        key = _this.collection.getKeyAfter(key);
                    }
                };
                addKeys(this.collection.getFirstKey());
                return keys;
            }
        },
        {
            /**
   * Selects all items in the collection.
   */ key: "selectAll",
            value: function selectAll() {
                if (!this.isSelectAll && this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
            }
        },
        {
            /**
   * Removes all keys from the selection.
   */ key: "clearSelection",
            value: function clearSelection() {
                if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)());
            }
        },
        {
            /**
   * Toggles between select all and an empty selection.
   */ key: "toggleSelectAll",
            value: function toggleSelectAll() {
                if (this.isSelectAll) this.clearSelection();
                else this.selectAll();
            }
        },
        {
            key: "select",
            value: function select(key, e) {
                if (this.selectionMode === 'none') return;
                if (this.selectionMode === 'single') {
                    if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
                    else this.replaceSelection(key);
                } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual')) this.toggleSelection(key);
                else this.replaceSelection(key);
            }
        },
        {
            /**
   * Returns whether the current selection is equal to the given selection.
   */ key: "isSelectionEqual",
            value: function isSelectionEqual(selection) {
                if (selection === this.state.selectedKeys) return true;
                // Check if the set of keys match.
                var selectedKeys = this.selectedKeys;
                if (selection.size !== selectedKeys.size) return false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!selectedKeys.has(key)) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = selectedKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var key1 = _step1.value;
                        if (!selection.has(key1)) return false;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return true;
            }
        },
        {
            key: "canSelectItem",
            value: function canSelectItem(key) {
                var _item_props;
                if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
                var item = this.collection.getItem(key);
                if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === 'cell' && !this.allowsCellSelection) return false;
                return true;
            }
        },
        {
            key: "isDisabled",
            value: function isDisabled(key) {
                var _this_collection_getItem_props, _this_collection_getItem;
                return this.state.disabledBehavior === 'all' && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
            }
        },
        {
            key: "isLink",
            value: function isLink(key) {
                var _this_collection_getItem_props, _this_collection_getItem;
                return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
            }
        },
        {
            key: "getItemProps",
            value: function getItemProps(key) {
                var _this_collection_getItem;
                return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
            }
        },
        {
            key: "withCollection",
            value: function withCollection(collection) {
                return new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(collection, this.state, {
                    allowsCellSelection: this.allowsCellSelection,
                    layoutDelegate: this.layoutDelegate || undefined
                });
            }
        }
    ]);
    return $d496c0a20b6e58ec$export$6c8a5aaad13c9852;
}();



var $4TMho = parcelRequire("4TMho");



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1f900f16d6e37a6d$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = setA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!setB.has(item)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $1f900f16d6e37a6d$export$253fe78d46329472(props) {
    var tmp = props.selectionMode, selectionMode = tmp === void 0 ? 'none' : tmp, tmp1 = props.disallowEmptySelection, disallowEmptySelection = tmp1 === void 0 ? false : tmp1, allowDuplicateSelectionEvents = props.allowDuplicateSelectionEvents, tmp2 = props.selectionBehavior, selectionBehaviorProp = tmp2 === void 0 ? 'toggle' : tmp2, tmp3 = props.disabledBehavior, disabledBehavior = tmp3 === void 0 ? 'all' : tmp3;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    var isFocusedRef = (0, $ggE0n.useRef)(false);
    var _$6tM1y$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), setFocused = _$6tM1y$useState[1];
    var focusedKeyRef = (0, $ggE0n.useRef)(null);
    var childFocusStrategyRef = (0, $ggE0n.useRef)(null);
    var _$6tM1y$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), setFocusedKey = _$6tM1y$useState1[1];
    var selectedKeysProp = (0, $ggE0n.useMemo)(function() {
        return $1f900f16d6e37a6d$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    var defaultSelectedKeys = (0, $ggE0n.useMemo)(function() {
        return $1f900f16d6e37a6d$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)());
    }, [
        props.defaultSelectedKeys
    ]);
    var _$6tM1y$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange), 2), selectedKeys = _$6tM1y$useControlledState[0], setSelectedKeys = _$6tM1y$useControlledState[1];
    var disabledKeysProp = (0, $ggE0n.useMemo)(function() {
        return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
    }, [
        props.disabledKeys
    ]);
    var _$6tM1y$useState2 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(selectionBehaviorProp), 2), selectionBehavior = _$6tM1y$useState2[0], setSelectionBehavior = _$6tM1y$useState2[1];
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === 'replace' && selectionBehavior === 'toggle' && (typeof selectedKeys === "undefined" ? "undefined" : (0, $4TMho._)(selectedKeys)) === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
    // If the selectionBehavior prop changes, update the state as well.
    var lastSelectionBehavior = (0, $ggE0n.useRef)(selectionBehaviorProp);
    (0, $ggE0n.useEffect)(function() {
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused: function(f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey: function(k) {
            var childFocusStrategy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'first';
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys: function(keys) {
            if (allowDuplicateSelectionEvents || !$1f900f16d6e37a6d$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $1f900f16d6e37a6d$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === 'all' ? 'all' : new (0, $5c8f0ce8e12e4d46$export$52baac22726c72bf)(selection);
}



var $ggE0n = parcelRequire("ggE0n");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");


var $90NkU = parcelRequire("90NkU");



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $789b7ec638084747$export$bf788dd355e3a401 = /*#__PURE__*/ function() {
    "use strict";
    function $eb2240fc39a57fa5$export$bf788dd355e3a401() {
        (0, $gpEpt._)(this, $eb2240fc39a57fa5$export$bf788dd355e3a401);
        this.cache = new WeakMap();
    }
    (0, $eOJ9o._)($eb2240fc39a57fa5$export$bf788dd355e3a401, [
        {
            key: "build",
            value: function build(props, context) {
                var _this = this;
                this.context = context;
                return $789b7ec638084747$var$$eb2240fc39a57fa5$var$iterable(function() {
                    return _this.iterateCollection(props);
                });
            }
        },
        {
            key: "iterateCollection",
            value: function iterateCollection(props) {
                var children, items, index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, err, items1, index1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, item1, nodes, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, node, err, err;
                return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            children = props.children, items = props.items;
                            if (!((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).isValidElement(children) && children.type === (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment)) return [
                                3,
                                2
                            ];
                            return [
                                5,
                                (0, $37faaaff56909290$export$19a8beecd37a4c45)(this.iterateCollection({
                                    children: children.props.children,
                                    items: items
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                25
                            ];
                        case 2:
                            if (!(typeof children === 'function')) return [
                                3,
                                11
                            ];
                            if (!items) throw new Error('props.children was a function but props.items is missing');
                            index = 0;
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = items[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            item = _step.value;
                            return [
                                5,
                                (0, $37faaaff56909290$export$19a8beecd37a4c45)(this.getFullNode({
                                    value: item,
                                    index: index
                                }, {
                                    renderer: children
                                }))
                            ];
                        case 5:
                            _state.sent();
                            index++;
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                3,
                                25
                            ];
                        case 11:
                            items1 = [];
                            (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Children.forEach(children, function(child) {
                                if (child) items1.push(child);
                            });
                            index1 = 0;
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 12;
                        case 12:
                            _state.trys.push([
                                12,
                                23,
                                24,
                                25
                            ]);
                            _iterator1 = items1[Symbol.iterator]();
                            _state.label = 13;
                        case 13:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                22
                            ];
                            item1 = _step1.value;
                            nodes = this.getFullNode({
                                element: item1,
                                index: index1
                            }, {});
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 14;
                        case 14:
                            _state.trys.push([
                                14,
                                19,
                                20,
                                21
                            ]);
                            _iterator2 = nodes[Symbol.iterator]();
                            _state.label = 15;
                        case 15:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                18
                            ];
                            node = _step2.value;
                            index1++;
                            return [
                                4,
                                node
                            ];
                        case 16:
                            _state.sent();
                            _state.label = 17;
                        case 17:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                15
                            ];
                        case 18:
                            return [
                                3,
                                21
                            ];
                        case 19:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                21
                            ];
                        case 20:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 21:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                13
                            ];
                        case 22:
                            return [
                                3,
                                25
                            ];
                        case 23:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                25
                            ];
                        case 24:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 25:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "getKey",
            value: function getKey(item, partialNode, state, parentKey) {
                if (item.key != null) return item.key;
                if (partialNode.type === 'cell' && partialNode.key != null) return "".concat(parentKey).concat(partialNode.key);
                var v = partialNode.value;
                if (v != null) {
                    var _v_key;
                    var key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
                    if (key == null) throw new Error('No key found for item');
                    return key;
                }
                return parentKey ? "".concat(parentKey, ".").concat(partialNode.index) : "$.".concat(partialNode.index);
            }
        },
        {
            key: "getChildState",
            value: function getChildState(state, partialNode) {
                return {
                    renderer: partialNode.renderer || state.renderer
                };
            }
        },
        {
            key: "getFullNode",
            value: function getFullNode(partialNode, state, parentKey, parentNode) {
                var children, _partialNode_index, index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, err, element, cached, type, name, childNodes, _partialNode_index1, index1, result, childNode, _childNode_key, nodeKey, nodes, children1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, node, _childNode_value, _ref, _parentNode_type, err, builder, _partialNode_value, _partialNode_textValue, node1;
                return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).isValidElement(partialNode.element) && partialNode.element.type === (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment)) return [
                                3,
                                9
                            ];
                            children = [];
                            (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Children.forEach(partialNode.element.props.children, function(child) {
                                children.push(child);
                            });
                            index = (_partialNode_index = partialNode.index) !== null && _partialNode_index !== void 0 ? _partialNode_index : 0;
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = children[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            child = _step.value;
                            return [
                                5,
                                (0, $37faaaff56909290$export$19a8beecd37a4c45)(this.getFullNode({
                                    element: child,
                                    index: index++
                                }, state, parentKey, parentNode))
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                        case 9:
                            // If there's a value instead of an element on the node, and a parent renderer function is available,
                            // use it to render an element for the value.
                            element = partialNode.element;
                            if (!(!element && partialNode.value && state && state.renderer)) return [
                                3,
                                12
                            ];
                            cached = this.cache.get(partialNode.value);
                            if (!(cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context)))) return [
                                3,
                                11
                            ];
                            cached.index = partialNode.index;
                            cached.parentKey = parentNode ? parentNode.key : null;
                            return [
                                4,
                                cached
                            ];
                        case 10:
                            _state.sent();
                            return [
                                2
                            ];
                        case 11:
                            element = state.renderer(partialNode.value);
                            _state.label = 12;
                        case 12:
                            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).isValidElement(element)) return [
                                3,
                                23
                            ];
                            type = element.type;
                            if (typeof type !== 'function' && typeof type.getCollectionNode !== 'function') {
                                name = element.type;
                                throw new Error("Unknown element <".concat(name, "> in collection."));
                            }
                            childNodes = type.getCollectionNode(element.props, this.context);
                            index1 = (_partialNode_index1 = partialNode.index) !== null && _partialNode_index1 !== void 0 ? _partialNode_index1 : 0;
                            result = childNodes.next();
                            _state.label = 13;
                        case 13:
                            if (!(!result.done && result.value)) return [
                                3,
                                22
                            ];
                            childNode = result.value;
                            partialNode.index = index1;
                            nodeKey = (_childNode_key = childNode.key) !== null && _childNode_key !== void 0 ? _childNode_key : null;
                            if (nodeKey == null) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                            nodes = this.getFullNode((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, childNode), {
                                key: nodeKey,
                                index: index1,
                                wrapper: $789b7ec638084747$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                            }), this.getChildState(state, childNode), parentKey ? "".concat(parentKey).concat(element.key) : element.key, parentNode);
                            children1 = (0, $90NkU._)(nodes);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 14;
                        case 14:
                            _state.trys.push([
                                14,
                                19,
                                20,
                                21
                            ]);
                            _iterator1 = children1[Symbol.iterator]();
                            _state.label = 15;
                        case 15:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                18
                            ];
                            node = _step1.value;
                            // Cache the node based on its value
                            node.value = (_ref = (_childNode_value = childNode.value) !== null && _childNode_value !== void 0 ? _childNode_value : partialNode.value) !== null && _ref !== void 0 ? _ref : null;
                            if (node.value) this.cache.set(node.value, node);
                            // The partial node may have specified a type for the child in order to specify a constraint.
                            // Verify that the full node that was built recursively matches this type.
                            if (partialNode.type && node.type !== partialNode.type) throw new Error("Unsupported type <".concat($789b7ec638084747$var$$eb2240fc39a57fa5$var$capitalize(node.type), "> in <").concat($789b7ec638084747$var$$eb2240fc39a57fa5$var$capitalize((_parentNode_type = parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) !== null && _parentNode_type !== void 0 ? _parentNode_type : 'unknown parent type'), ">. Only <").concat($789b7ec638084747$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type), "> is supported."));
                            index1++;
                            return [
                                4,
                                node
                            ];
                        case 16:
                            _state.sent();
                            _state.label = 17;
                        case 17:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                15
                            ];
                        case 18:
                            return [
                                3,
                                21
                            ];
                        case 19:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                21
                            ];
                        case 20:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 21:
                            result = childNodes.next(children1);
                            return [
                                3,
                                13
                            ];
                        case 22:
                            return [
                                2
                            ];
                        case 23:
                            // Ignore invalid elements
                            if (partialNode.key == null || partialNode.type == null) return [
                                2
                            ];
                            // Create full node
                            builder = this;
                            node1 = {
                                type: partialNode.type,
                                props: partialNode.props,
                                key: partialNode.key,
                                parentKey: parentNode ? parentNode.key : null,
                                value: (_partialNode_value = partialNode.value) !== null && _partialNode_value !== void 0 ? _partialNode_value : null,
                                level: parentNode ? parentNode.level + 1 : 0,
                                index: partialNode.index,
                                rendered: partialNode.rendered,
                                textValue: (_partialNode_textValue = partialNode.textValue) !== null && _partialNode_textValue !== void 0 ? _partialNode_textValue : '',
                                'aria-label': partialNode['aria-label'],
                                wrapper: partialNode.wrapper,
                                shouldInvalidate: partialNode.shouldInvalidate,
                                hasChildNodes: partialNode.hasChildNodes || false,
                                childNodes: $789b7ec638084747$var$$eb2240fc39a57fa5$var$iterable(function() {
                                    var index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, nodes, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, node, err, err;
                                    return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!partialNode.hasChildNodes || !partialNode.childNodes) return [
                                                    2
                                                ];
                                                index = 0;
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    12,
                                                    13,
                                                    14
                                                ]);
                                                _iterator = partialNode.childNodes()[Symbol.iterator]();
                                                _state.label = 2;
                                            case 2:
                                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                    3,
                                                    11
                                                ];
                                                child = _step.value;
                                                // Ensure child keys are globally unique by prepending the parent node's key
                                                if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                                                // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                                                // children having a key of `abc`.
                                                child.key = "".concat(node1.key).concat(child.key);
                                                nodes = builder.getFullNode((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, child), {
                                                    index: index
                                                }), builder.getChildState(state, child), node1.key, node1);
                                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                                _state.label = 3;
                                            case 3:
                                                _state.trys.push([
                                                    3,
                                                    8,
                                                    9,
                                                    10
                                                ]);
                                                _iterator1 = nodes[Symbol.iterator]();
                                                _state.label = 4;
                                            case 4:
                                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                                    3,
                                                    7
                                                ];
                                                node = _step1.value;
                                                index++;
                                                return [
                                                    4,
                                                    node
                                                ];
                                            case 5:
                                                _state.sent();
                                                _state.label = 6;
                                            case 6:
                                                _iteratorNormalCompletion1 = true;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 7:
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 8:
                                                err = _state.sent();
                                                _didIteratorError1 = true;
                                                _iteratorError1 = err;
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                try {
                                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                        _iterator1.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError1) {
                                                        throw _iteratorError1;
                                                    }
                                                }
                                                return [
                                                    7
                                                ];
                                            case 10:
                                                _iteratorNormalCompletion = true;
                                                return [
                                                    3,
                                                    2
                                                ];
                                            case 11:
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 12:
                                                err = _state.sent();
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 13:
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                                return [
                                                    7
                                                ];
                                            case 14:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })
                            };
                            return [
                                4,
                                node1
                            ];
                        case 24:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return $eb2240fc39a57fa5$export$bf788dd355e3a401;
}();
// Wraps an iterator function as an iterable object, and caches the results.
function $789b7ec638084747$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    var cache = [];
    var iterable = null;
    return (0, $3Hxpr._)({}, Symbol.iterator, function() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, item1, err;
        return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = cache[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    item = _step.value;
                    return [
                        4,
                        item
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    if (!iterable) iterable = iterator();
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 9;
                case 9:
                    _state.trys.push([
                        9,
                        14,
                        15,
                        16
                    ]);
                    _iterator1 = iterable[Symbol.iterator]();
                    _state.label = 10;
                case 10:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        13
                    ];
                    item1 = _step1.value;
                    cache.push(item1);
                    return [
                        4,
                        item1
                    ];
                case 11:
                    _state.sent();
                    _state.label = 12;
                case 12:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        10
                    ];
                case 13:
                    return [
                        3,
                        16
                    ];
                case 14:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        16
                    ];
                case 15:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        2
                    ];
            }
        });
    });
}
function $789b7ec638084747$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return function(element) {
        return outer(inner(element));
    };
    if (outer) return outer;
    if (inner) return inner;
}
function $789b7ec638084747$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c5d0ddcadaa927c8$export$6cd28814d92fa9c9(props, factory, context) {
    var builder = (0, $ggE0n.useMemo)(function() {
        return new (0, $789b7ec638084747$export$bf788dd355e3a401)();
    }, []);
    var children = props.children, items = props.items, collection = props.collection;
    var result = (0, $ggE0n.useMemo)(function() {
        if (collection) return collection;
        var nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $204153d432e1e178$export$728d6ba534403756(props) {
    var onExpandedChange = props.onExpandedChange;
    var _$75HV2$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), onExpandedChange), 2), expandedKeys = _$75HV2$useControlledState[0], setExpandedKeys = _$75HV2$useControlledState[1];
    var selectionState = (0, $1f900f16d6e37a6d$export$253fe78d46329472)(props);
    var disabledKeys = (0, $ggE0n.useMemo)(function() {
        return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
    }, [
        props.disabledKeys
    ]);
    var tree = (0, $c5d0ddcadaa927c8$export$6cd28814d92fa9c9)(props, (0, $ggE0n.useCallback)(function(nodes) {
        return new (0, $7d38444744a757dc$export$863faf230ee2118a)(nodes, {
            expandedKeys: expandedKeys
        });
    }, [
        expandedKeys
    ]), null);
    (0, $ggE0n.useEffect)(function() {
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    var onToggle = function(key) {
        setExpandedKeys($204153d432e1e178$var$$875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $a24f982606f0f9ec$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $204153d432e1e178$var$$875d6693e12af071$var$toggleKey(set, key) {
    var res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}






var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $bd93902f54c16aa6$export$c7e742effb1c51e2 = (0, $ggE0n.createContext)(null);
var $bd93902f54c16aa6$export$24aad8519b95b41b = (0, $ggE0n.createContext)(null);
var $bd93902f54c16aa6$export$795aec4671cbae19 = (0, $ggE0n.createContext)(null);
var $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SelectionManagerContext = (0, $ggE0n.createContext)(null);
function $bd93902f54c16aa6$export$27d2ad3c5815583e(props) {
    var state = (0, $c2b891d144210dfb$export$79fefeb1c2091ac3)(props);
    var ref = (0, $ggE0n.useRef)(null);
    var _$kM2ZM$useMenuTrigger = (0, $29d3cc55e55a1021$export$dc9c12ed27dd1b49)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        type: 'menu'
    }), state, ref), menuTriggerProps = _$kM2ZM$useMenuTrigger.menuTriggerProps, menuProps = _$kM2ZM$useMenuTrigger.menuProps;
    // Allows menu width to match button
    var _$kM2ZM$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), buttonWidth = _$kM2ZM$useState[0], setButtonWidth = _$kM2ZM$useState[1];
    var onResize = (0, $ggE0n.useCallback)(function() {
        if (ref.current) setButtonWidth(ref.current.offsetWidth + 'px');
    }, [
        ref
    ]);
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: ref,
        onResize: onResize
    });
    var scrollRef = (0, $ggE0n.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $bd93902f54c16aa6$export$c7e742effb1c51e2,
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, menuProps), {
                    ref: scrollRef
                })
            ],
            [
                (0, $e4ccc8b3c0827610$export$d2f961adcb0afbe),
                state
            ],
            [
                $bd93902f54c16aa6$export$795aec4671cbae19,
                state
            ],
            [
                (0, $13b1a1463e05bd62$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'MenuTrigger',
                    triggerRef: ref,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': buttonWidth
                    },
                    'aria-labelledby': menuProps['aria-labelledby']
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f12953e97e637e2a$export$3351871ee4b288b8), (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, menuTriggerProps), {
        ref: ref,
        isPressed: state.isOpen
    }), props.children));
}
var $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext = (0, $ggE0n.createContext)(null);
var $bd93902f54c16aa6$export$ecabc99eeffab7ca = (0, $94f17837fc908958$export$e953bb1cd0f19726)('submenutrigger', function(props, ref, item) {
    var _$kM2ZM$useContext = (0, $ggE0n.useContext)((0, $ee24387ab14ed14c$export$4feb769f8ddf26c5)), CollectionBranch = _$kM2ZM$useContext.CollectionBranch;
    var state = (0, $ggE0n.useContext)($bd93902f54c16aa6$export$24aad8519b95b41b);
    var rootMenuTriggerState = (0, $ggE0n.useContext)($bd93902f54c16aa6$export$795aec4671cbae19);
    var submenuTriggerState = (0, $a2789ec3d0864402$export$cfc51cf86138bf98)({
        triggerKey: item.key
    }, rootMenuTriggerState);
    var submenuRef = (0, $ggE0n.useRef)(null);
    var itemRef = (0, $c25977d36d6c3204$export$4338b53315abf666)(ref);
    var _$kM2ZM$useContext1 = (0, $ggE0n.useContext)($bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext), parentMenuRef = _$kM2ZM$useContext1.parentMenuRef, shouldUseVirtualFocus = _$kM2ZM$useContext1.shouldUseVirtualFocus;
    var _$kM2ZM$useSubmenuTrigger = (0, $7a8856d865383694$export$7138b0d059a6e743)({
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        delay: props.delay,
        shouldUseVirtualFocus: shouldUseVirtualFocus
    }, submenuTriggerState, itemRef), submenuTriggerProps = _$kM2ZM$useSubmenuTrigger.submenuTriggerProps, submenuProps = _$kM2ZM$useSubmenuTrigger.submenuProps, popoverProps = _$kM2ZM$useSubmenuTrigger.popoverProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuItemContext,
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, submenuTriggerProps), {
                    onAction: undefined,
                    ref: itemRef
                })
            ],
            [
                $bd93902f54c16aa6$export$c7e742effb1c51e2,
                submenuProps
            ],
            [
                (0, $e4ccc8b3c0827610$export$d2f961adcb0afbe),
                submenuTriggerState
            ],
            [
                (0, $13b1a1463e05bd62$export$9b9a0cd73afb7ca4),
                (0, $2QPpE._)({
                    ref: submenuRef,
                    trigger: 'SubmenuTrigger',
                    triggerRef: itemRef,
                    placement: 'end top',
                    'aria-labelledby': submenuProps['aria-labelledby']
                }, popoverProps)
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }), props.children[1]);
}, function(props) {
    return props.children[0];
});
var $bd93902f54c16aa6$export$d9b273488cd8ce6f = (0, $ggE0n.forwardRef)(function Menu(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $bd93902f54c16aa6$export$c7e742effb1c51e2), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    // Delay rendering the actual menu until we have the collection so that auto focus works properly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $94f17837fc908958$export$bf788dd355e3a401), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $94f17837fc908958$export$fb8073518f34e6ec), props)
    }, function(collection) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuInner, {
            props: props,
            collection: collection,
            menuRef: ref
        });
    });
});
function $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuInner(param) {
    var props = param.props, collection = param.collection, ref = param.menuRef;
    var _ref = (0, $ggE0n.useContext)((0, $97969277f870840a$export$65d2a03b8800d6e3)) || {}, filter = _ref.filter, autocompleteMenuProps = _ref.collectionProps, collectionRef = _ref.collectionRef;
    // Memoed so that useAutocomplete callback ref is properly only called once on mount and not everytime a rerender happens
    ref = (0, $c25977d36d6c3204$export$4338b53315abf666)((0, $ggE0n.useMemo)(function() {
        return (0, $c90706a3f6fff521$export$c9058316764c140e)(ref, collectionRef !== undefined ? collectionRef : null);
    }, [
        collectionRef,
        ref
    ]));
    var filteredCollection = (0, $ggE0n.useMemo)(function() {
        return filter ? collection.UNSTABLE_filter(filter) : collection;
    }, [
        collection,
        filter
    ]);
    var state = (0, $204153d432e1e178$export$728d6ba534403756)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        collection: filteredCollection,
        children: undefined
    }));
    var triggerState = (0, $ggE0n.useContext)($bd93902f54c16aa6$export$795aec4671cbae19);
    var _$kM2ZM$useContext = (0, $ggE0n.useContext)((0, $ee24387ab14ed14c$export$4feb769f8ddf26c5)), isVirtualized = _$kM2ZM$useContext.isVirtualized, CollectionRoot = _$kM2ZM$useContext.CollectionRoot;
    var _$kM2ZM$useMenu = (0, $971531339f8087c3$export$38eaa17faae8f579)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props, autocompleteMenuProps), {
        isVirtualized: isVirtualized,
        onClose: props.onClose || (triggerState === null || triggerState === void 0 ? void 0 : triggerState.close)
    }), state, ref), menuProps = _$kM2ZM$useMenu.menuProps;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)({
        defaultClassName: 'react-aria-Menu',
        className: props.className,
        style: props.style,
        values: {
            isEmpty: state.collection.size === 0
        }
    });
    var emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", {
        role: "menuitem",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState());
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $67c1d94bd0a42a56$export$20e40289641fbbb6), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), menuProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        onScroll: props.onScroll
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $bd93902f54c16aa6$export$24aad8519b95b41b,
                state
            ],
            [
                (0, $4e5edef11bc269d7$export$6615d83f6de245ce),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $ee24387ab14ed14c$export$d40e14dec8b060a8),
                {
                    name: 'MenuSection',
                    render: $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuSectionInner
                }
            ],
            [
                $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext,
                {
                    parentMenuRef: ref,
                    shouldUseVirtualFocus: autocompleteMenuProps === null || autocompleteMenuProps === void 0 ? void 0 : autocompleteMenuProps.shouldUseVirtualFocus
                }
            ],
            [
                $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuItemContext,
                null
            ],
            [
                (0, $97969277f870840a$export$65d2a03b8800d6e3),
                null
            ],
            [
                $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SelectionManagerContext,
                state.selectionManager
            ],
            /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */ /* We assume the context can never change between defined and undefined. */ /* eslint-disable-next-line react-hooks/rules-of-hooks */ [
                $bd93902f54c16aa6$export$795aec4671cbae19,
                triggerState !== null && triggerState !== void 0 ? triggerState : (0, $c2b891d144210dfb$export$79fefeb1c2091ac3)({})
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, $ee24387ab14ed14c$export$90e00781bc59d8f9)(state.selectionManager.focusedKey),
        scrollRef: ref
    })), emptyState));
}
// A subclass of SelectionManager that forwards focus-related properties to the parent,
// but has its own local selection state.
var $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$GroupSelectionManager = /*#__PURE__*/ function($kM2ZM$SelectionManager) {
    "use strict";
    (0, $83AyS._)($3674c52c6b3c5bce$var$GroupSelectionManager, $kM2ZM$SelectionManager);
    function $3674c52c6b3c5bce$var$GroupSelectionManager(parent, state) {
        (0, $gpEpt._)(this, $3674c52c6b3c5bce$var$GroupSelectionManager);
        var _this;
        _this = (0, $3qQ3j._)(this, $3674c52c6b3c5bce$var$GroupSelectionManager, [
            parent.collection,
            state
        ]);
        _this.parent = parent;
        return _this;
    }
    (0, $eOJ9o._)($3674c52c6b3c5bce$var$GroupSelectionManager, [
        {
            key: "focusedKey",
            get: function get() {
                return this.parent.focusedKey;
            }
        },
        {
            key: "isFocused",
            get: function get() {
                return this.parent.isFocused;
            }
        },
        {
            key: "setFocusedKey",
            value: function setFocusedKey(key, childFocusStrategy) {
                return this.parent.setFocusedKey(key, childFocusStrategy);
            }
        },
        {
            key: "setFocused",
            value: function setFocused(isFocused) {
                this.parent.setFocused(isFocused);
            }
        },
        {
            key: "childFocusStrategy",
            get: function get() {
                return this.parent.childFocusStrategy;
            }
        }
    ]);
    return $3674c52c6b3c5bce$var$GroupSelectionManager;
}((0, $a24f982606f0f9ec$export$6c8a5aaad13c9852));
function $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuSectionInner(props, ref, section) {
    var className = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'react-aria-MenuSection';
    var _section_props, _section_props1;
    var state = (0, $ggE0n.useContext)($bd93902f54c16aa6$export$24aad8519b95b41b);
    var _$kM2ZM$useContext = (0, $ggE0n.useContext)((0, $ee24387ab14ed14c$export$4feb769f8ddf26c5)), CollectionBranch = _$kM2ZM$useContext.CollectionBranch;
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(), 2), headingRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], heading = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var _section_props_arialabel;
    var _$kM2ZM$useMenuSection = (0, $57ad39daabbfc941$export$73f7a44322579622)({
        heading: heading,
        'aria-label': (_section_props_arialabel = section.props['aria-label']) !== null && _section_props_arialabel !== void 0 ? _section_props_arialabel : undefined
    }), headingProps = _$kM2ZM$useMenuSection.headingProps, groupProps = _$kM2ZM$useMenuSection.groupProps;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)({
        defaultClassName: className,
        className: (_section_props = section.props) === null || _section_props === void 0 ? void 0 : _section_props.className,
        style: (_section_props1 = section.props) === null || _section_props1 === void 0 ? void 0 : _section_props1.style,
        values: {}
    });
    var parent = (0, $ggE0n.useContext)($bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SelectionManagerContext);
    var selectionState = (0, $1f900f16d6e37a6d$export$253fe78d46329472)(props);
    var manager = props.selectionMode != null ? new $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$GroupSelectionManager(parent, selectionState) : parent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("section", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), groupProps, renderProps), {
        ref: ref
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $30c9cc7a993d0a2b$export$e0e4026c12a8bdbb),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, headingProps), {
                    ref: headingRef
                })
            ],
            [
                $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SelectionManagerContext,
                manager
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section
    })));
}
var $bd93902f54c16aa6$export$4b1545b4f2016d26 = (0, $94f17837fc908958$export$e953bb1cd0f19726)('section', $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuSectionInner);
var $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuItemContext = (0, $ggE0n.createContext)(null);
var $bd93902f54c16aa6$export$2ce376c2cc3355c8 = (0, $94f17837fc908958$export$18af5c7a9e9b3664)('item', function MenuItem(props, forwardedRef, item) {
    var _useSlottedContext;
    var ref;
    ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, forwardedRef, $bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuItemContext), 2), props = ref[0], forwardedRef = ref[1], ref;
    var id = (_useSlottedContext = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)($bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$MenuItemContext)) === null || _useSlottedContext === void 0 ? void 0 : _useSlottedContext.id;
    var state = (0, $ggE0n.useContext)($bd93902f54c16aa6$export$24aad8519b95b41b);
    var ref1 = (0, $c25977d36d6c3204$export$4338b53315abf666)(forwardedRef);
    var selectionManager = (0, $ggE0n.useContext)($bd93902f54c16aa6$var$$3674c52c6b3c5bce$var$SelectionManagerContext);
    var _$kM2ZM$useMenuItem = (0, $f2887b520d09fce0$export$9d32628fc2aea7da)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        id: id,
        key: item.key,
        selectionManager: selectionManager
    }), state, ref1), menuItemProps = _$kM2ZM$useMenuItem.menuItemProps, labelProps = _$kM2ZM$useMenuItem.labelProps, descriptionProps = _$kM2ZM$useMenuItem.descriptionProps, keyboardShortcutProps = _$kM2ZM$useMenuItem.keyboardShortcutProps, states = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$kM2ZM$useMenuItem, [
        "menuItemProps",
        "labelProps",
        "descriptionProps",
        "keyboardShortcutProps"
    ]);
    var _$kM2ZM$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)({
        isDisabled: states.isDisabled
    }), hoverProps = _$kM2ZM$useHover.hoverProps, isHovered = _$kM2ZM$useHover.isHovered;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-MenuItem',
        values: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, states), {
            isHovered: isHovered,
            isFocusVisible: states.isFocusVisible,
            selectionMode: selectionManager.selectionMode,
            selectionBehavior: selectionManager.selectionBehavior,
            hasSubmenu: !!props['aria-haspopup'],
            isOpen: props['aria-expanded'] === 'true'
        })
    }));
    var ElementType = props.href ? 'a' : 'div';
    var _obj;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(ElementType, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)(menuItemProps, hoverProps), renderProps), {
        ref: ref1,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": selectionManager.selectionMode === 'none' ? undefined : selectionManager.selectionMode,
        "data-has-submenu": !!props['aria-haspopup'] || undefined,
        "data-open": props['aria-expanded'] === 'true' || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: (_obj = {}, (0, $3Hxpr._)(_obj, (0, $e2b7517996df0b67$export$c62b8e45d58ddad9), labelProps), (0, $3Hxpr._)(_obj, "label", labelProps), (0, $3Hxpr._)(_obj, "description", descriptionProps), _obj)
                }
            ],
            [
                (0, $372108dec3fdf83d$export$744d98a3b8a94e1c),
                keyboardShortcutProps
            ]
        ]
    }, renderProps.children));
});



var $2QPpE = parcelRequire("2QPpE");




var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ac1d22f6838c208e$export$d55e7ee900f34e93(props, ref) {
    var tmp = props.role, role = tmp === void 0 ? 'dialog' : tmp;
    var titleId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)();
    titleId = props['aria-label'] ? undefined : titleId;
    var isRefocusing = (0, $ggE0n.useRef)(false);
    (0, $ggE0n.useEffect)(function() {
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $9134fa2a0acdb388$export$80f3e147d781571c)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            var timeout = setTimeout(function() {
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $9134fa2a0acdb388$export$80f3e147d781571c)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return function() {
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $f6c6a069114ca6a7$export$14c98a7594375490)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props, {
            labelable: true
        })), {
            role: role,
            tabIndex: -1,
            'aria-labelledby': props['aria-labelledby'] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: function(e) {
                if (isRefocusing.current) e.stopPropagation();
            }
        }),
        titleProps: {
            id: titleId
        }
    };
}






var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e4ccc8b3c0827610$export$8b93a07348a7730c = (0, $ggE0n.createContext)(null);
var $e4ccc8b3c0827610$export$d2f961adcb0afbe = (0, $ggE0n.createContext)(null);
function $e4ccc8b3c0827610$export$2e1e1122cf0cba88(props) {
    // Use useMenuTriggerState instead of useOverlayTriggerState in case a menu is embedded in the dialog.
    // This is needed to handle submenus.
    var state = (0, $c2b891d144210dfb$export$79fefeb1c2091ac3)(props);
    var buttonRef = (0, $ggE0n.useRef)(null);
    var _$6IYYA$useOverlayTrigger = (0, $69ae150e85dff522$export$f9d5c8beee7d008d)({
        type: 'dialog'
    }, state, buttonRef), triggerProps = _$6IYYA$useOverlayTrigger.triggerProps, overlayProps = _$6IYYA$useOverlayTrigger.overlayProps;
    // Allows popover width to match trigger element
    var _$6IYYA$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), buttonWidth = _$6IYYA$useState[0], setButtonWidth = _$6IYYA$useState[1];
    var onResize = (0, $ggE0n.useCallback)(function() {
        if (buttonRef.current) setButtonWidth(buttonRef.current.offsetWidth + 'px');
    }, [
        buttonRef
    ]);
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: buttonRef,
        onResize: onResize
    });
    // Label dialog by the trigger as a fallback if there is no title slot.
    // This is done in RAC instead of hooks because otherwise we cannot distinguish
    // between context and props. Normally aria-labelledby overrides the title
    // but when sent by context we want the title to win.
    triggerProps.id = (0, $7fc455d18519c289$export$f680877a34711e37)();
    overlayProps['aria-labelledby'] = triggerProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $e4ccc8b3c0827610$export$d2f961adcb0afbe,
                state
            ],
            [
                (0, $bd93902f54c16aa6$export$795aec4671cbae19),
                state
            ],
            [
                $e4ccc8b3c0827610$export$8b93a07348a7730c,
                overlayProps
            ],
            [
                (0, $13b1a1463e05bd62$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'DialogTrigger',
                    triggerRef: buttonRef,
                    'aria-labelledby': overlayProps['aria-labelledby'],
                    style: {
                        '--trigger-width': buttonWidth
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f12953e97e637e2a$export$3351871ee4b288b8), (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, triggerProps), {
        ref: buttonRef,
        isPressed: state.isOpen
    }), props.children));
}
var $e4ccc8b3c0827610$export$3ddf2d174ce01153 = (0, $ggE0n.forwardRef)(function Dialog(props, ref) {
    var originalAriaLabelledby = props['aria-labelledby'];
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $e4ccc8b3c0827610$export$8b93a07348a7730c), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _$6IYYA$useDialog = (0, $ac1d22f6838c208e$export$d55e7ee900f34e93)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        // Only pass aria-labelledby from props, not context.
        // Context is used as a fallback below.
        'aria-labelledby': originalAriaLabelledby
    }), ref), dialogProps = _$6IYYA$useDialog.dialogProps, titleProps = _$6IYYA$useDialog.titleProps;
    var state = (0, $ggE0n.useContext)($e4ccc8b3c0827610$export$d2f961adcb0afbe);
    if (!dialogProps['aria-label'] && !dialogProps['aria-labelledby']) // If aria-labelledby exists on props, we know it came from context.
    // Use that as a fallback in case there is no title slot.
    {
        if (props['aria-labelledby']) dialogProps['aria-labelledby'] = props['aria-labelledby'];
    }
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)({
        defaultClassName: 'react-aria-Dialog',
        className: props.className,
        style: props.style,
        children: props.children,
        values: {
            close: (state === null || state === void 0 ? void 0 : state.close) || function() {}
        }
    });
    var _obj, _obj1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("section", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), dialogProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $0669a7cc0abfc405$export$d688439359537581),
                {
                    slots: (_obj = {}, (0, $3Hxpr._)(_obj, (0, $e2b7517996df0b67$export$c62b8e45d58ddad9), {}), (0, $3Hxpr._)(_obj, "title", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, titleProps), {
                        level: 2
                    })), _obj)
                }
            ],
            [
                (0, $28c5f096242aff4d$export$24d547caef80ccd1),
                {
                    slots: (_obj1 = {}, (0, $3Hxpr._)(_obj1, (0, $e2b7517996df0b67$export$c62b8e45d58ddad9), {}), (0, $3Hxpr._)(_obj1, "close", {
                        onPress: function() {
                            return state === null || state === void 0 ? void 0 : state.close();
                        }
                    }), _obj1)
                }
            ]
        ]
    }, renderProps.children));
});


var $2QPpE = parcelRequire("2QPpE");






var $2QPpE = parcelRequire("2QPpE");







var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $55943cdc38696795$export$dbc0f175b25fb0fb(props, state, ref) {
    var _$a11501f3d1d39e6c$export$ea8f71083e90600f = (0, $a304c1bfca7428a8$export$ea8f71083e90600f)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        isOpen: state.isOpen,
        onClose: state.close
    }), ref), overlayProps = _$a11501f3d1d39e6c$export$ea8f71083e90600f.overlayProps, underlayProps = _$a11501f3d1d39e6c$export$ea8f71083e90600f.underlayProps;
    (0, $57b0cdde0a666cb7$export$ee0f7cc6afcd1c18)({
        isDisabled: !state.isOpen
    });
    (0, $f6c6a069114ca6a7$export$14c98a7594375490)();
    (0, $ggE0n.useEffect)(function() {
        if (state.isOpen && ref.current) return (0, $d4acd2b54a25cec0$export$1c3ebcada18427bf)([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(overlayProps),
        underlayProps: underlayProps
    };
}




var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
function $61b7bd50a3682491$export$d699905dd57c73ca() {
    var isSSR = (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)();
    var _$fuDHA$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        return isSSR ? {
            width: 0,
            height: 0
        } : $61b7bd50a3682491$var$$5df64b3807dc15ee$var$getViewportSize();
    }), 2), size = _$fuDHA$useState[0], setSize = _$fuDHA$useState[1];
    (0, $ggE0n.useEffect)(function() {
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        var onResize = function() {
            setSize(function(size) {
                var newSize = $61b7bd50a3682491$var$$5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport) window.addEventListener('resize', onResize);
        else $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport.addEventListener('resize', onResize);
        return function() {
            if (!$61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport) window.removeEventListener('resize', onResize);
            else $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport.removeEventListener('resize', onResize);
        };
    }, []);
    return size;
}
function $61b7bd50a3682491$var$$5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport && ($61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport === null || $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport && ($61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport === null || $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $61b7bd50a3682491$var$$5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $203bd87f5067e9a4$export$ab57792b9b6974a6 = (0, $ggE0n.createContext)(null);
var $203bd87f5067e9a4$var$$f3f84453ead64de5$var$InternalModalContext = (0, $ggE0n.createContext)(null);
var $203bd87f5067e9a4$export$2b77a92f1a5ad772 = (0, $ggE0n.forwardRef)(function Modal(props, ref) {
    var ctx = (0, $ggE0n.useContext)($203bd87f5067e9a4$var$$f3f84453ead64de5$var$InternalModalContext);
    if (ctx) return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalContent, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        modalRef: ref
    }), props.children);
    var isDismissable = props.isDismissable, isKeyboardDismissDisabled = props.isKeyboardDismissDisabled, isOpen = props.isOpen, defaultOpen = props.defaultOpen, onOpenChange = props.onOpenChange, children = props.children, isEntering = props.isEntering, isExiting = props.isExiting, UNSTABLE_portalContainer = props.UNSTABLE_portalContainer, shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "isDismissable",
        "isKeyboardDismissDisabled",
        "isOpen",
        "defaultOpen",
        "onOpenChange",
        "children",
        "isEntering",
        "isExiting",
        "UNSTABLE_portalContainer",
        "shouldCloseOnInteractOutside"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($203bd87f5067e9a4$export$8948f78d83984c69, {
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        isEntering: isEntering,
        isExiting: isExiting,
        UNSTABLE_portalContainer: UNSTABLE_portalContainer,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalContent, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        modalRef: ref
    }), children));
});
function $203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalOverlayWithForwardRef(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $203bd87f5067e9a4$export$ab57792b9b6974a6), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var contextState = (0, $ggE0n.useContext)((0, $e4ccc8b3c0827610$export$d2f961adcb0afbe));
    var localState = (0, $995b915c2e36d0af$export$61c6a8c84e605fb6)(props);
    var state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    var objectRef = (0, $c25977d36d6c3204$export$4338b53315abf666)(ref);
    var modalRef = (0, $ggE0n.useRef)(null);
    var isOverlayExiting = (0, $7bf9e6b27a0164fe$export$45fda7c47f93fd48)(objectRef, state.isOpen);
    var isModalExiting = (0, $7bf9e6b27a0164fe$export$45fda7c47f93fd48)(modalRef, state.isOpen);
    var isExiting = isOverlayExiting || isModalExiting || props.isExiting || false;
    var isSSR = (0, $110c9ade4cf71f7a$export$535bd6ca7f90a273)();
    if (!state.isOpen && !isExiting || isSSR) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalOverlayInner, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        state: state,
        isExiting: isExiting,
        overlayRef: objectRef,
        modalRef: modalRef
    }));
}
var $203bd87f5067e9a4$export$8948f78d83984c69 = (0, $ggE0n.forwardRef)($203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalOverlayWithForwardRef);
function $203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalOverlayInner(_param) {
    var UNSTABLE_portalContainer = _param.UNSTABLE_portalContainer, props = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_param, [
        "UNSTABLE_portalContainer"
    ]);
    var modalRef = props.modalRef;
    var state = props.state;
    var _$daTMi$useModalOverlay = (0, $55943cdc38696795$export$dbc0f175b25fb0fb)(props, state, modalRef), modalProps = _$daTMi$useModalOverlay.modalProps, underlayProps = _$daTMi$useModalOverlay.underlayProps;
    var entering = (0, $7bf9e6b27a0164fe$export$6d3443f2c48bfc20)(props.overlayRef) || props.isEntering || false;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        defaultClassName: 'react-aria-ModalOverlay',
        values: {
            isEntering: entering,
            isExiting: props.isExiting,
            state: state
        }
    }));
    var viewport = (0, $61b7bd50a3682491$export$d699905dd57c73ca)();
    var style = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, renderProps.style), {
        '--visual-viewport-height': viewport.height + 'px'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f6c6a069114ca6a7$export$c6fdb837b070b4ff), {
        isExiting: props.isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)((0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), underlayProps), renderProps), {
        style: style,
        ref: props.overlayRef,
        "data-entering": entering || undefined,
        "data-exiting": props.isExiting || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $203bd87f5067e9a4$var$$f3f84453ead64de5$var$InternalModalContext,
                {
                    modalProps: modalProps,
                    modalRef: modalRef,
                    isExiting: props.isExiting,
                    isDismissable: props.isDismissable
                }
            ],
            [
                (0, $e4ccc8b3c0827610$export$d2f961adcb0afbe),
                state
            ]
        ]
    }, renderProps.children)));
}
function $203bd87f5067e9a4$var$$f3f84453ead64de5$var$ModalContent(props) {
    var _$daTMi$useContext = (0, $ggE0n.useContext)($203bd87f5067e9a4$var$$f3f84453ead64de5$var$InternalModalContext), modalProps = _$daTMi$useContext.modalProps, modalRef = _$daTMi$useContext.modalRef, isExiting = _$daTMi$useContext.isExiting, isDismissable = _$daTMi$useContext.isDismissable;
    var state = (0, $ggE0n.useContext)((0, $e4ccc8b3c0827610$export$d2f961adcb0afbe));
    var mergedRefs = (0, $ggE0n.useMemo)(function() {
        return (0, $c90706a3f6fff521$export$c9058316764c140e)(props.modalRef, modalRef);
    }, [
        props.modalRef,
        modalRef
    ]);
    var ref = (0, $c25977d36d6c3204$export$4338b53315abf666)(mergedRefs);
    var entering = (0, $7bf9e6b27a0164fe$export$6d3443f2c48bfc20)(ref);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        defaultClassName: 'react-aria-Modal',
        values: {
            isEntering: entering,
            isExiting: isExiting,
            state: state
        }
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)((0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), modalProps), renderProps), {
        ref: ref,
        "data-entering": entering || undefined,
        "data-exiting": isExiting || undefined
    }), isDismissable && (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $07c93e097165d85d$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }), renderProps.children);
}






var $ggE0n = parcelRequire("ggE0n");

var $2QPpE = parcelRequire("2QPpE");




var $90NkU = parcelRequire("90NkU");





var $60c763996479b340$export$2e2bcd8739ae039 = {};
$60c763996479b340$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u0625\u0644\u0649 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " \u0627\u0644\u0645\u062D\u062F\u062F");
    },
    "finishRangeSelectionPrompt": "\u0627\u0646\u0642\u0631 \u0644\u0625\u0646\u0647\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    "maximumDate": "\u0622\u062E\u0631 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D",
    "minimumDate": "\u0623\u0648\u0644 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D",
    "next": "\u0627\u0644\u062A\u0627\u0644\u064A",
    "previous": "\u0627\u0644\u0633\u0627\u0628\u0642",
    "selectedDateDescription": function(args) {
        return "\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u0627\u0646\u0642\u0631 \u0644\u0628\u062F\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    "todayDate": function(args) {
        return "\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date, " \u0645\u062D\u062F\u062F");
    }
};


var $272eb5917492a7a4$export$2e2bcd8739ae039 = {};
$272eb5917492a7a4$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u0434\u043E ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0435 ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0434\u043E\u0432\u044A\u0440\u0448\u0438\u0442\u0435 \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B",
    "maximumDate": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
    "minimumDate": "\u041F\u044A\u0440\u0432\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
    "next": "\u041D\u0430\u043F\u0440\u0435\u0434",
    "previous": "\u041D\u0430\u0437\u0430\u0434",
    "selectedDateDescription": function(args) {
        return "\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0438\u0441\u0442\u044A\u043F\u0438\u0442\u0435 \u043A\u044A\u043C \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B",
    "todayDate": function(args) {
        return "\u0414\u043D\u0435\u0441, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u0414\u043D\u0435\u0441, ".concat(args.date, " \u0441\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438");
    }
};


var $d8a021741031c6b5$export$2e2bcd8739ae039 = {};
$d8a021741031c6b5$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " a\u017E ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "Vybr\xe1no ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "Kliknut\xedm dokon\u010D\xedte v\xfdb\u011Br rozsahu dat",
    "maximumDate": "Posledn\xed dostupn\xe9 datum",
    "minimumDate": "Prvn\xed dostupn\xe9 datum",
    "next": "Dal\u0161\xed",
    "previous": "P\u0159edchoz\xed",
    "selectedDateDescription": function(args) {
        return "Vybran\xe9 datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Vybran\xe9 obdob\xed: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kliknut\xedm zah\xe1j\xedte v\xfdb\u011Br rozsahu dat",
    "todayDate": function(args) {
        return "Dnes, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Dnes, vybr\xe1no ".concat(args.date);
    }
};


var $a3a4a8c1c0f83d95$export$2e2bcd8739ae039 = {};
$a3a4a8c1c0f83d95$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " til ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " valgt");
    },
    "finishRangeSelectionPrompt": "Klik for at fuldf\xf8re valg af datoomr\xe5de",
    "maximumDate": "Sidste ledige dato",
    "minimumDate": "F\xf8rste ledige dato",
    "next": "N\xe6ste",
    "previous": "Forrige",
    "selectedDateDescription": function(args) {
        return "Valgt dato: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valgt interval: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Klik for at starte valg af datoomr\xe5de",
    "todayDate": function(args) {
        return "I dag, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "I dag, ".concat(args.date, " valgt");
    }
};


var $9402534fd16269aa$export$2e2bcd8739ae039 = {};
$9402534fd16269aa$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " bis ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " ausgew\xe4hlt");
    },
    "finishRangeSelectionPrompt": "Klicken, um die Auswahl des Datumsbereichs zu beenden",
    "maximumDate": "Letztes verf\xfcgbares Datum",
    "minimumDate": "Erstes verf\xfcgbares Datum",
    "next": "Weiter",
    "previous": "Zur\xfcck",
    "selectedDateDescription": function(args) {
        return "Ausgew\xe4hltes Datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Ausgew\xe4hlter Bereich: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
    "todayDate": function(args) {
        return "Heute, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Heute, ".concat(args.date, " ausgew\xe4hlt");
    }
};


var $a45735bfc3b54494$export$2e2bcd8739ae039 = {};
$a45735bfc3b54494$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u03AD\u03C9\u03C2 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5 ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03CD\u03C1\u03BF\u03C5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD",
    "maximumDate": "\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
    "minimumDate": "\u03A0\u03C1\u03CE\u03C4\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
    "next": "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF",
    "previous": "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF",
    "selectedDateDescription": function(args) {
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03CD\u03C1\u03BF\u03C5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD",
    "todayDate": function(args) {
        return "\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1, \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03C4\u03B7\u03BA\u03B5 ".concat(args.date);
    }
};


var $cb743b7e394bd216$export$2e2bcd8739ae039 = {};
$cb743b7e394bd216$export$2e2bcd8739ae039 = {
    "previous": "Previous",
    "next": "Next",
    "selectedDateDescription": function(args) {
        return "Selected Date: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Selected Range: ".concat(args.dateRange);
    },
    "todayDate": function(args) {
        return "Today, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Today, ".concat(args.date, " selected");
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " selected");
    },
    "startRangeSelectionPrompt": "Click to start selecting date range",
    "finishRangeSelectionPrompt": "Click to finish selecting date range",
    "minimumDate": "First available date",
    "maximumDate": "Last available date",
    "dateRange": function(args) {
        return "".concat(args.startDate, " to ").concat(args.endDate);
    }
};


var $d93980ec9208315d$export$2e2bcd8739ae039 = {};
$d93980ec9208315d$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " a ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " seleccionado");
    },
    "finishRangeSelectionPrompt": "Haga clic para terminar de seleccionar rango de fechas",
    "maximumDate": "\xdaltima fecha disponible",
    "minimumDate": "Primera fecha disponible",
    "next": "Siguiente",
    "previous": "Anterior",
    "selectedDateDescription": function(args) {
        return "Fecha seleccionada: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervalo seleccionado: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Haga clic para comenzar a seleccionar un rango de fechas",
    "todayDate": function(args) {
        return "Hoy, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Hoy, ".concat(args.date, " seleccionado");
    }
};


var $a99940fe19e59d8e$export$2e2bcd8739ae039 = {};
$a99940fe19e59d8e$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " kuni ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " valitud");
    },
    "finishRangeSelectionPrompt": "Kl\xf5psake kuup\xe4evavahemiku valimise l\xf5petamiseks",
    "maximumDate": "Viimane saadaolev kuup\xe4ev",
    "minimumDate": "Esimene saadaolev kuup\xe4ev",
    "next": "J\xe4rgmine",
    "previous": "Eelmine",
    "selectedDateDescription": function(args) {
        return "Valitud kuup\xe4ev: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valitud vahemik: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kl\xf5psake kuup\xe4evavahemiku valimiseks",
    "todayDate": function(args) {
        return "T\xe4na, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "T\xe4na, ".concat(args.date, " valitud");
    }
};


var $d09dc8cd8a2b6d12$export$2e2bcd8739ae039 = {};
$d09dc8cd8a2b6d12$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u2013 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " valittu");
    },
    "finishRangeSelectionPrompt": "Lopeta p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.",
    "maximumDate": "Viimeinen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4",
    "minimumDate": "Ensimm\xe4inen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4",
    "next": "Seuraava",
    "previous": "Edellinen",
    "selectedDateDescription": function(args) {
        return "Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valittu aikav\xe4li: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Aloita p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.",
    "todayDate": function(args) {
        return "T\xe4n\xe4\xe4n, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "T\xe4n\xe4\xe4n, ".concat(args.date, " valittu");
    }
};


var $ab0e0339f3ba5978$export$2e2bcd8739ae039 = {};
$ab0e0339f3ba5978$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \xe0 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " s\xe9lectionn\xe9");
    },
    "finishRangeSelectionPrompt": "Cliquer pour finir de s\xe9lectionner la plage de dates",
    "maximumDate": "Derni\xe8re date disponible",
    "minimumDate": "Premi\xe8re date disponible",
    "next": "Suivant",
    "previous": "Pr\xe9c\xe9dent",
    "selectedDateDescription": function(args) {
        return "Date s\xe9lectionn\xe9e\xa0: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Plage s\xe9lectionn\xe9e\xa0: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Cliquer pour commencer \xe0 s\xe9lectionner la plage de dates",
    "todayDate": function(args) {
        return "Aujourd'hui, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Aujourd\u2019hui, ".concat(args.date, " s\xe9lectionn\xe9");
    }
};


var $502f7e29e97b7b4c$export$2e2bcd8739ae039 = {};
$502f7e29e97b7b4c$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u05E2\u05D3 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " \u05E0\u05D1\u05D7\u05E8");
    },
    "finishRangeSelectionPrompt": "\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D9\u05D9\u05DD \u05D0\u05EA \u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
    "maximumDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05D0\u05D7\u05E8\u05D5\u05DF",
    "minimumDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05E8\u05D0\u05E9\u05D5\u05DF",
    "next": "\u05D4\u05D1\u05D0",
    "previous": "\u05D4\u05E7\u05D5\u05D3\u05DD",
    "selectedDateDescription": function(args) {
        return "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05D1\u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
    "todayDate": function(args) {
        return "\u05D4\u05D9\u05D5\u05DD, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u05D4\u05D9\u05D5\u05DD, ".concat(args.date, " \u05E0\u05D1\u05D7\u05E8");
    }
};


var $706605d9a0b540bb$export$2e2bcd8739ae039 = {};
$706605d9a0b540bb$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " do ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " odabran");
    },
    "finishRangeSelectionPrompt": "Kliknite da dovr\u0161ite raspon odabranih datuma",
    "maximumDate": "Posljednji raspolo\u017Eivi datum",
    "minimumDate": "Prvi raspolo\u017Eivi datum",
    "next": "Sljede\u0107i",
    "previous": "Prethodni",
    "selectedDateDescription": function(args) {
        return "Odabrani datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Odabrani raspon: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kliknite da zapo\u010Dnete raspon odabranih datuma",
    "todayDate": function(args) {
        return "Danas, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Danas, odabran ".concat(args.date);
    }
};


var $c31056a390b73ce5$export$2e2bcd8739ae039 = {};
$c31056a390b73ce5$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, "\u2013").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " kiv\xe1lasztva");
    },
    "finishRangeSelectionPrompt": "Kattintson a d\xe1tumtartom\xe1ny kijel\xf6l\xe9s\xe9nek befejez\xe9s\xe9hez",
    "maximumDate": "Utols\xf3 el\xe9rhet\u0151 d\xe1tum",
    "minimumDate": "Az els\u0151 el\xe9rhet\u0151 d\xe1tum",
    "next": "K\xf6vetkez\u0151",
    "previous": "El\u0151z\u0151",
    "selectedDateDescription": function(args) {
        return "Kijel\xf6lt d\xe1tum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Kijel\xf6lt tartom\xe1ny: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kattintson a d\xe1tumtartom\xe1ny kijel\xf6l\xe9s\xe9nek ind\xedt\xe1s\xe1hoz",
    "todayDate": function(args) {
        return "Ma, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Ma, ".concat(args.date, " kijel\xf6lve");
    }
};


var $3d5ec7453c9508f7$export$2e2bcd8739ae039 = {};
$3d5ec7453c9508f7$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "Da ".concat(args.startDate, " a ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " selezionata");
    },
    "finishRangeSelectionPrompt": "Fai clic per completare la selezione dell\u2019intervallo di date",
    "maximumDate": "Ultima data disponibile",
    "minimumDate": "Prima data disponibile",
    "next": "Successivo",
    "previous": "Precedente",
    "selectedDateDescription": function(args) {
        return "Data selezionata: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervallo selezionato: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Fai clic per selezionare l\u2019intervallo di date",
    "todayDate": function(args) {
        return "Oggi, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Oggi, ".concat(args.date, " selezionata");
    }
};


var $2cf59f375982040e$export$2e2bcd8739ae039 = {};
$2cf59f375982040e$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u304B\u3089 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " \u3092\u9078\u629E");
    },
    "finishRangeSelectionPrompt": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u7D42\u4E86",
    "maximumDate": "\u6700\u7D42\u5229\u7528\u53EF\u80FD\u65E5",
    "minimumDate": "\u6700\u521D\u306E\u5229\u7528\u53EF\u80FD\u65E5",
    "next": "\u6B21\u3078",
    "previous": "\u524D\u3078",
    "selectedDateDescription": function(args) {
        return "\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u9078\u629E\u7BC4\u56F2 : ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u958B\u59CB",
    "todayDate": function(args) {
        return "\u672C\u65E5\u3001".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u672C\u65E5\u3001".concat(args.date, " \u3092\u9078\u629E");
    }
};


var $7aeede3cde2707ba$export$2e2bcd8739ae039 = {};
$7aeede3cde2707ba$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " ~ ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " \uC120\uD0DD\uB428");
    },
    "finishRangeSelectionPrompt": "\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC644\uB8CC\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
    "maximumDate": "\uB9C8\uC9C0\uB9C9\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790",
    "minimumDate": "\uCC98\uC74C\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790",
    "next": "\uB2E4\uC74C",
    "previous": "\uC774\uC804",
    "selectedDateDescription": function(args) {
        return "\uC120\uD0DD \uC77C\uC790: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\uC120\uD0DD \uBC94\uC704: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC2DC\uC791\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
    "todayDate": function(args) {
        return "\uC624\uB298, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\uC624\uB298, ".concat(args.date, " \uC120\uD0DD\uB428");
    }
};


var $1c7ee748cdcf202b$export$2e2bcd8739ae039 = {};
$1c7ee748cdcf202b$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "Nuo ".concat(args.startDate, " iki ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "Pasirinkta ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "Spustel\u0117kite, kad baigtum\u0117te pasirinkti dat\u0173 interval\u0105",
    "maximumDate": "Paskutin\u0117 galima data",
    "minimumDate": "Pirmoji galima data",
    "next": "Paskesnis",
    "previous": "Ankstesnis",
    "selectedDateDescription": function(args) {
        return "Pasirinkta data: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Pasirinktas intervalas: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Spustel\u0117kite, kad prad\u0117tum\u0117te pasirinkti dat\u0173 interval\u0105",
    "todayDate": function(args) {
        return "\u0160iandien, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u0160iandien, pasirinkta ".concat(args.date);
    }
};


var $c4d908988e42bca3$export$2e2bcd8739ae039 = {};
$c4d908988e42bca3$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "No ".concat(args.startDate, " l\u012Bdz ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "Atlas\u012Bts: ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "Noklik\u0161\u0137iniet, lai pabeigtu datumu diapazona atlasi",
    "maximumDate": "P\u0113d\u0113jais pieejamais datums",
    "minimumDate": "Pirmais pieejamais datums",
    "next": "T\u0101l\u0101k",
    "previous": "Atpaka\u013C",
    "selectedDateDescription": function(args) {
        return "Atlas\u012Btais datums: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Atlas\u012Btais diapazons: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Noklik\u0161\u0137iniet, lai s\u0101ktu datumu diapazona atlasi",
    "todayDate": function(args) {
        return "\u0160odien, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Atlas\u012Bta \u0161odiena, ".concat(args.date);
    }
};


var $90fbbe5505fea26b$export$2e2bcd8739ae039 = {};
$90fbbe5505fea26b$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " til ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " valgt");
    },
    "finishRangeSelectionPrompt": "Klikk for \xe5 fullf\xf8re valg av datoomr\xe5de",
    "maximumDate": "Siste tilgjengelige dato",
    "minimumDate": "F\xf8rste tilgjengelige dato",
    "next": "Neste",
    "previous": "Forrige",
    "selectedDateDescription": function(args) {
        return "Valgt dato: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valgt omr\xe5de: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Klikk for \xe5 starte valg av datoomr\xe5de",
    "todayDate": function(args) {
        return "I dag, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "I dag, ".concat(args.date, " valgt");
    }
};


var $f0e439733d1a6cb2$export$2e2bcd8739ae039 = {};
$f0e439733d1a6cb2$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " tot ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " geselecteerd");
    },
    "finishRangeSelectionPrompt": "Klik om de selectie van het datumbereik te voltooien",
    "maximumDate": "Laatste beschikbare datum",
    "minimumDate": "Eerste beschikbare datum",
    "next": "Volgende",
    "previous": "Vorige",
    "selectedDateDescription": function(args) {
        return "Geselecteerde datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Geselecteerd bereik: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Klik om het datumbereik te selecteren",
    "todayDate": function(args) {
        return "Vandaag, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Vandaag, ".concat(args.date, " geselecteerd");
    }
};


var $c7f536c6f33388c6$export$2e2bcd8739ae039 = {};
$c7f536c6f33388c6$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " do ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "Wybrano ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "Kliknij, aby zako\u0144czy\u0107 wyb\xf3r zakresu dat",
    "maximumDate": "Ostatnia dost\u0119pna data",
    "minimumDate": "Pierwsza dost\u0119pna data",
    "next": "Dalej",
    "previous": "Wstecz",
    "selectedDateDescription": function(args) {
        return "Wybrana data: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Wybrany zakres: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kliknij, aby rozpocz\u0105\u0107 wyb\xf3r zakresu dat",
    "todayDate": function(args) {
        return "Dzisiaj, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Dzisiaj wybrano ".concat(args.date);
    }
};


var $7182c2fde3423c28$export$2e2bcd8739ae039 = {};
$7182c2fde3423c28$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " a ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " selecionado");
    },
    "finishRangeSelectionPrompt": "Clique para concluir a sele\xe7\xe3o do intervalo de datas",
    "maximumDate": "\xdaltima data dispon\xedvel",
    "minimumDate": "Primeira data dispon\xedvel",
    "next": "Pr\xf3ximo",
    "previous": "Anterior",
    "selectedDateDescription": function(args) {
        return "Data selecionada: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervalo selecionado: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Clique para iniciar a sele\xe7\xe3o do intervalo de datas",
    "todayDate": function(args) {
        return "Hoje, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Hoje, ".concat(args.date, " selecionado");
    }
};


var $b5eca76a9f55fa67$export$2e2bcd8739ae039 = {};
$b5eca76a9f55fa67$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " a ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " selecionado");
    },
    "finishRangeSelectionPrompt": "Clique para terminar de selecionar o intervalo de datas",
    "maximumDate": "\xdaltima data dispon\xedvel",
    "minimumDate": "Primeira data dispon\xedvel",
    "next": "Pr\xf3ximo",
    "previous": "Anterior",
    "selectedDateDescription": function(args) {
        return "Data selecionada: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervalo selecionado: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Clique para come\xe7ar a selecionar o intervalo de datas",
    "todayDate": function(args) {
        return "Hoje, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Hoje, ".concat(args.date, " selecionado");
    }
};


var $747837a0da01f124$export$2e2bcd8739ae039 = {};
$747837a0da01f124$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "De la ".concat(args.startDate, " p\xe2n\u0103 la ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " selectat\u0103");
    },
    "finishRangeSelectionPrompt": "Ap\u0103sa\u0163i pentru a finaliza selec\u0163ia razei pentru dat\u0103",
    "maximumDate": "Ultima dat\u0103 disponibil\u0103",
    "minimumDate": "Prima dat\u0103 disponibil\u0103",
    "next": "Urm\u0103torul",
    "previous": "\xcenainte",
    "selectedDateDescription": function(args) {
        return "Dat\u0103 selectat\u0103: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Interval selectat: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Ap\u0103sa\u0163i pentru a \xeencepe selec\u0163ia razei pentru dat\u0103",
    "todayDate": function(args) {
        return "Ast\u0103zi, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Azi, ".concat(args.date, " selectat\u0103");
    }
};


var $84ecb4fbf113b897$export$2e2bcd8739ae039 = {};
$84ecb4fbf113b897$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "\u0421 ".concat(args.startDate, " \u043F\u043E ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043E ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0434\u0430\u0442",
    "maximumDate": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
    "minimumDate": "\u041F\u0435\u0440\u0432\u0430\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
    "next": "\u0414\u0430\u043B\u0435\u0435",
    "previous": "\u041D\u0430\u0437\u0430\u0434",
    "selectedDateDescription": function(args) {
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0434\u0430\u0442",
    "todayDate": function(args) {
        return "\u0421\u0435\u0433\u043E\u0434\u043D\u044F, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432\u044B\u0431\u0440\u0430\u043D\u043E ".concat(args.date);
    }
};


var $14961735585fa6a3$export$2e2bcd8739ae039 = {};
$14961735585fa6a3$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "Od ".concat(args.startDate, " do ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "Vybrat\xfd d\xe1tum ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "Kliknut\xedm dokon\u010D\xedte v\xfdber rozsahu d\xe1tumov",
    "maximumDate": "Posledn\xfd dostupn\xfd d\xe1tum",
    "minimumDate": "Prv\xfd dostupn\xfd d\xe1tum",
    "next": "Nasleduj\xface",
    "previous": "Predch\xe1dzaj\xface",
    "selectedDateDescription": function(args) {
        return "Vybrat\xfd d\xe1tum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Vybrat\xfd rozsah: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kliknut\xedm spust\xedte v\xfdber rozsahu d\xe1tumov",
    "todayDate": function(args) {
        return "Dnes ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Vybrat\xfd dne\u0161n\xfd d\xe1tum ".concat(args.date);
    }
};


var $bf4a1da40889aaef$export$2e2bcd8739ae039 = {};
$bf4a1da40889aaef$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " do ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " izbrano");
    },
    "finishRangeSelectionPrompt": "Kliknite za dokon\u010Danje izbire datumskega obsega",
    "maximumDate": "Zadnji razpolo\u017Eljivi datum",
    "minimumDate": "Prvi razpolo\u017Eljivi datum",
    "next": "Naprej",
    "previous": "Nazaj",
    "selectedDateDescription": function(args) {
        return "Izbrani datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Izbrano obmo\u010Dje: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kliknite za za\u010Detek izbire datumskega obsega",
    "todayDate": function(args) {
        return "Danes, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Danes, ".concat(args.date, " izbrano");
    }
};


var $b4a2df098a806dec$export$2e2bcd8739ae039 = {};
$b4a2df098a806dec$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " do ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " izabran");
    },
    "finishRangeSelectionPrompt": "Kliknite da dovr\u0161ite opseg izabranih datuma",
    "maximumDate": "Zadnji raspolo\u017Eivi datum",
    "minimumDate": "Prvi raspolo\u017Eivi datum",
    "next": "Slede\u0107i",
    "previous": "Prethodni",
    "selectedDateDescription": function(args) {
        return "Izabrani datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Izabrani period: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Kliknite da zapo\u010Dnete opseg izabranih datuma",
    "todayDate": function(args) {
        return "Danas, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Danas, izabran ".concat(args.date);
    }
};


var $45fed381552ac5d4$export$2e2bcd8739ae039 = {};
$45fed381552ac5d4$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " till ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " har valts");
    },
    "finishRangeSelectionPrompt": "Klicka f\xf6r att avsluta val av datumintervall",
    "maximumDate": "Sista tillg\xe4ngliga datum",
    "minimumDate": "F\xf6rsta tillg\xe4ngliga datum",
    "next": "N\xe4sta",
    "previous": "F\xf6reg\xe5ende",
    "selectedDateDescription": function(args) {
        return "Valt datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valt intervall: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Klicka f\xf6r att v\xe4lja datumintervall",
    "todayDate": function(args) {
        return "Idag, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Idag, ".concat(args.date, " har valts");
    }
};


var $b1d1365e2bc7f0eb$export$2e2bcd8739ae039 = {};
$b1d1365e2bc7f0eb$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " - ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "".concat(args.date, " se\xe7ildi");
    },
    "finishRangeSelectionPrompt": "Tarih aral\u0131\u011F\u0131 se\xe7imini tamamlamak i\xe7in t\u0131klay\u0131n",
    "maximumDate": "Son m\xfcsait tarih",
    "minimumDate": "\u0130lk m\xfcsait tarih",
    "next": "Sonraki",
    "previous": "\xd6nceki",
    "selectedDateDescription": function(args) {
        return "Se\xe7ilen Tarih: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Se\xe7ilen Aral\u0131k: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "Tarih aral\u0131\u011F\u0131 se\xe7imini ba\u015Flatmak i\xe7in t\u0131klay\u0131n",
    "todayDate": function(args) {
        return "Bug\xfcn, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "Bug\xfcn, ".concat(args.date, " se\xe7ildi");
    }
};


var $cdaae435f993884e$export$2e2bcd8739ae039 = {};
$cdaae435f993884e$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u2014 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "\u0412\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442",
    "maximumDate": "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430",
    "minimumDate": "\u041F\u0435\u0440\u0448\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430",
    "next": "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
    "previous": "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
    "selectedDateDescription": function(args) {
        return "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442",
    "todayDate": function(args) {
        return "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, \u0432\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date);
    }
};


var $6e96b6db8a655a66$export$2e2bcd8739ae039 = {};
$6e96b6db8a655a66$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u81F3 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "\u5DF2\u9009\u62E9 ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "\u5355\u51FB\u4EE5\u5B8C\u6210\u9009\u62E9\u65E5\u671F\u8303\u56F4",
    "maximumDate": "\u6700\u540E\u4E00\u4E2A\u53EF\u7528\u65E5\u671F",
    "minimumDate": "\u7B2C\u4E00\u4E2A\u53EF\u7528\u65E5\u671F",
    "next": "\u4E0B\u4E00\u9875",
    "previous": "\u4E0A\u4E00\u9875",
    "selectedDateDescription": function(args) {
        return "\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u5355\u51FB\u4EE5\u5F00\u59CB\u9009\u62E9\u65E5\u671F\u8303\u56F4",
    "todayDate": function(args) {
        return "\u4ECA\u5929\uFF0C\u5373 ".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u5DF2\u9009\u62E9\u4ECA\u5929\uFF0C\u5373 ".concat(args.date);
    }
};


var $aee9293166fed427$export$2e2bcd8739ae039 = {};
$aee9293166fed427$export$2e2bcd8739ae039 = {
    "dateRange": function(args) {
        return "".concat(args.startDate, " \u81F3 ").concat(args.endDate);
    },
    "dateSelected": function(args) {
        return "\u5DF2\u9078\u53D6 ".concat(args.date);
    },
    "finishRangeSelectionPrompt": "\u6309\u4E00\u4E0B\u4EE5\u5B8C\u6210\u9078\u53D6\u65E5\u671F\u7BC4\u570D",
    "maximumDate": "\u6700\u5F8C\u4E00\u500B\u53EF\u7528\u65E5\u671F",
    "minimumDate": "\u7B2C\u4E00\u500B\u53EF\u7528\u65E5\u671F",
    "next": "\u4E0B\u4E00\u9801",
    "previous": "\u4E0A\u4E00\u9801",
    "selectedDateDescription": function(args) {
        return "\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.dateRange);
    },
    "startRangeSelectionPrompt": "\u6309\u4E00\u4E0B\u4EE5\u958B\u59CB\u9078\u53D6\u65E5\u671F\u7BC4\u570D",
    "todayDate": function(args) {
        return "\u4ECA\u5929\uFF0C".concat(args.date);
    },
    "todayDateSelected": function(args) {
        return "\u5DF2\u9078\u53D6\u4ECA\u5929\uFF0C".concat(args.date);
    }
};


var $d76dbf185a4c1508$export$2e2bcd8739ae039 = {};
$d76dbf185a4c1508$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $60c763996479b340$export$2e2bcd8739ae039),
    "bg-BG": (0, $272eb5917492a7a4$export$2e2bcd8739ae039),
    "cs-CZ": (0, $d8a021741031c6b5$export$2e2bcd8739ae039),
    "da-DK": (0, $a3a4a8c1c0f83d95$export$2e2bcd8739ae039),
    "de-DE": (0, $9402534fd16269aa$export$2e2bcd8739ae039),
    "el-GR": (0, $a45735bfc3b54494$export$2e2bcd8739ae039),
    "en-US": (0, $cb743b7e394bd216$export$2e2bcd8739ae039),
    "es-ES": (0, $d93980ec9208315d$export$2e2bcd8739ae039),
    "et-EE": (0, $a99940fe19e59d8e$export$2e2bcd8739ae039),
    "fi-FI": (0, $d09dc8cd8a2b6d12$export$2e2bcd8739ae039),
    "fr-FR": (0, $ab0e0339f3ba5978$export$2e2bcd8739ae039),
    "he-IL": (0, $502f7e29e97b7b4c$export$2e2bcd8739ae039),
    "hr-HR": (0, $706605d9a0b540bb$export$2e2bcd8739ae039),
    "hu-HU": (0, $c31056a390b73ce5$export$2e2bcd8739ae039),
    "it-IT": (0, $3d5ec7453c9508f7$export$2e2bcd8739ae039),
    "ja-JP": (0, $2cf59f375982040e$export$2e2bcd8739ae039),
    "ko-KR": (0, $7aeede3cde2707ba$export$2e2bcd8739ae039),
    "lt-LT": (0, $1c7ee748cdcf202b$export$2e2bcd8739ae039),
    "lv-LV": (0, $c4d908988e42bca3$export$2e2bcd8739ae039),
    "nb-NO": (0, $90fbbe5505fea26b$export$2e2bcd8739ae039),
    "nl-NL": (0, $f0e439733d1a6cb2$export$2e2bcd8739ae039),
    "pl-PL": (0, $c7f536c6f33388c6$export$2e2bcd8739ae039),
    "pt-BR": (0, $7182c2fde3423c28$export$2e2bcd8739ae039),
    "pt-PT": (0, $b5eca76a9f55fa67$export$2e2bcd8739ae039),
    "ro-RO": (0, $747837a0da01f124$export$2e2bcd8739ae039),
    "ru-RU": (0, $84ecb4fbf113b897$export$2e2bcd8739ae039),
    "sk-SK": (0, $14961735585fa6a3$export$2e2bcd8739ae039),
    "sl-SI": (0, $bf4a1da40889aaef$export$2e2bcd8739ae039),
    "sr-SP": (0, $b4a2df098a806dec$export$2e2bcd8739ae039),
    "sv-SE": (0, $45fed381552ac5d4$export$2e2bcd8739ae039),
    "tr-TR": (0, $b1d1365e2bc7f0eb$export$2e2bcd8739ae039),
    "uk-UA": (0, $cdaae435f993884e$export$2e2bcd8739ae039),
    "zh-CN": (0, $6e96b6db8a655a66$export$2e2bcd8739ae039),
    "zh-TW": (0, $aee9293166fed427$export$2e2bcd8739ae039)
};




var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


var $4TMho = parcelRequire("4TMho");


var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dbab1b4d381c444e$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $acc76a7a17331648$var$$3b62074eb05584b2$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $acc76a7a17331648$export$f297eb839006d339(era, year, month, day) {
    year = $acc76a7a17331648$export$c36e0ecb2d4fa69d(era, year);
    var y1 = year - 1;
    var monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($acc76a7a17331648$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $acc76a7a17331648$var$$3b62074eb05584b2$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $acc76a7a17331648$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $acc76a7a17331648$export$c36e0ecb2d4fa69d(era, year) {
    return era === 'BC' ? 1 - year : year;
}
function $acc76a7a17331648$export$4475b7e617eb123c(year) {
    var era = 'AD';
    if (year <= 0) {
        era = 'BC';
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
var $acc76a7a17331648$var$$3b62074eb05584b2$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
var $acc76a7a17331648$export$80ee6245ec4f29ec = /*#__PURE__*/ function() {
    "use strict";
    function $3b62074eb05584b2$export$80ee6245ec4f29ec() {
        (0, $gpEpt._)(this, $3b62074eb05584b2$export$80ee6245ec4f29ec);
        this.identifier = 'gregory';
    }
    (0, $eOJ9o._)($3b62074eb05584b2$export$80ee6245ec4f29ec, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var jd0 = jd;
                var depoch = jd0 - $acc76a7a17331648$var$$3b62074eb05584b2$var$EPOCH;
                var quadricent = Math.floor(depoch / 146097);
                var dqc = (0, $dbab1b4d381c444e$export$842a2cf37af977e1)(depoch, 146097);
                var cent = Math.floor(dqc / 36524);
                var dcent = (0, $dbab1b4d381c444e$export$842a2cf37af977e1)(dqc, 36524);
                var quad = Math.floor(dcent / 1461);
                var dquad = (0, $dbab1b4d381c444e$export$842a2cf37af977e1)(dcent, 1461);
                var yindex = Math.floor(dquad / 365);
                var extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
                var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, $c6938abc98c6418f$export$71511d61b312f219)($acc76a7a17331648$export$4475b7e617eb123c(extendedYear), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
                var yearDay = jd0 - $acc76a7a17331648$export$f297eb839006d339(era, year, 1, 1);
                var leapAdj = 2;
                if (jd0 < $acc76a7a17331648$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
                else if ($acc76a7a17331648$export$553d7fa8e3805fc0(year)) leapAdj = 1;
                var month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
                var day = jd0 - $acc76a7a17331648$export$f297eb839006d339(era, year, month, 1) + 1;
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $acc76a7a17331648$export$f297eb839006d339(date.era, date.year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return $acc76a7a17331648$var$$3b62074eb05584b2$var$daysInMonth[$acc76a7a17331648$export$553d7fa8e3805fc0(date.year) ? 'leapyear' : 'standard'][date.month - 1];
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "getMonthsInYear",
            value: function getMonthsInYear(date) {
                return 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return $acc76a7a17331648$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                return 9999;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'BC',
                    'AD'
                ];
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === 'BC';
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                if (date.year <= 0) {
                    date.era = date.era === 'BC' ? 'AD' : 'BC';
                    date.year = 1 - date.year;
                }
            }
        }
    ]);
    return $3b62074eb05584b2$export$80ee6245ec4f29ec;
}();


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $0bc8c577ea38feca$var$$735220c2d4774dd3$var$ONE_HOUR = 3600000;
function $0bc8c577ea38feca$export$e16d8520af44a096(date, duration) {
    var mutableDate = date.copy();
    var days = 'hour' in mutableDate ? $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addTimeFields(mutableDate, duration) : 0;
    $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceYearMonth(mutableDate);
    $0bc8c577ea38feca$var$$735220c2d4774dd3$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    var maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _mutableDate_calendar_isInverseEra, _mutableDate_calendar;
        var isInverseEra = (_mutableDate_calendar_isInverseEra = (_mutableDate_calendar = mutableDate.calendar).isInverseEra) === null || _mutableDate_calendar_isInverseEra === void 0 ? void 0 : _mutableDate_calendar_isInverseEra.call(_mutableDate_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    var maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addYears(date, years) {
    var _date_calendar_isInverseEra, _date_calendar;
    if ((_date_calendar_isInverseEra = (_date_calendar = date.calendar).isInverseEra) === null || _date_calendar_isInverseEra === void 0 ? void 0 : _date_calendar_isInverseEra.call(_date_calendar, date)) years = -years;
    date.year += years;
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceYearMonth(date) {
    while(date.month < 1){
        $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    var monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addYears(date, 1);
    }
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceYearMonth(date);
    }
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $0bc8c577ea38feca$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $0bc8c577ea38feca$var$$735220c2d4774dd3$var$constrainMonthDay(date);
}
function $0bc8c577ea38feca$export$3e2544e88a25bff8(duration) {
    var inverseDuration = {};
    for(var key in duration)if (typeof duration[key] === 'number') inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $0bc8c577ea38feca$export$4e2d2ead65e5f7e3(date, duration) {
    return $0bc8c577ea38feca$export$e16d8520af44a096(date, $0bc8c577ea38feca$export$3e2544e88a25bff8(duration));
}
function $0bc8c577ea38feca$export$adaa4cf7ef1b65be(date, fields) {
    var mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $0bc8c577ea38feca$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $0bc8c577ea38feca$export$e5d5e1c1822b6e56(value, fields) {
    var mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $0bc8c577ea38feca$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$nonNegativeMod(time.minute, 60);
    var days = Math.floor(time.hour / 24);
    time.hour = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $0bc8c577ea38feca$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$nonNegativeMod(a, b) {
    var result = a % b;
    if (result < 0) result += b;
    return result;
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $0bc8c577ea38feca$var$$735220c2d4774dd3$var$balanceTime(time);
}
function $0bc8c577ea38feca$export$7ed87b6bc2506470(time, duration) {
    var res = time.copy();
    $0bc8c577ea38feca$var$$735220c2d4774dd3$var$addTimeFields(res, duration);
    return res;
}
function $0bc8c577ea38feca$export$fe34d3a381cd7501(time, duration) {
    return $0bc8c577ea38feca$export$7ed87b6bc2506470(time, $0bc8c577ea38feca$export$3e2544e88a25bff8(duration));
}
function $0bc8c577ea38feca$export$d52ced6badfb9a4c(value, field, amount, options) {
    var mutable = value.copy();
    switch(field){
        case 'era':
            {
                var eras = value.calendar.getEras();
                var eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error('Invalid era: ' + value.era);
                eraIndex = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $0bc8c577ea38feca$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case 'year':
            var _mutable_calendar_isInverseEra, _mutable_calendar;
            if ((_mutable_calendar_isInverseEra = (_mutable_calendar = mutable.calendar).isInverseEra) === null || _mutable_calendar_isInverseEra === void 0 ? void 0 : _mutable_calendar_isInverseEra.call(_mutable_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case 'month':
            mutable.month = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case 'day':
            mutable.day = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error('Unsupported field ' + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $0bc8c577ea38feca$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $0bc8c577ea38feca$export$dd02b3e0007dfe28(value, field, amount, options) {
    var mutable = value.copy();
    switch(field){
        case 'hour':
            {
                var hours = value.hour;
                var min = 0;
                var max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    var isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case 'minute':
            mutable.minute = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case 'second':
            mutable.second = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case 'millisecond':
            mutable.millisecond = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error('Unsupported field ' + field);
    }
    return mutable;
}
function $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(value, amount, min, max) {
    var round = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        var div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $0bc8c577ea38feca$export$96b1d28349274637(dateTime, duration) {
    var ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        var res = $0bc8c577ea38feca$export$e16d8520af44a096((0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(res, dateTime.timeZone);
    } else ms = (0, $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb)(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    var res1 = (0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms, dateTime.timeZone);
    return (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(res1, dateTime.calendar);
}
function $0bc8c577ea38feca$export$6814caac34ca03c7(dateTime, duration) {
    return $0bc8c577ea38feca$export$96b1d28349274637(dateTime, $0bc8c577ea38feca$export$3e2544e88a25bff8(duration));
}
function $0bc8c577ea38feca$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case 'hour':
            {
                var min = 0;
                var max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    var isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                var plainDateTime = (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(dateTime);
                var minDate = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)($0bc8c577ea38feca$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
                var minAbsolute = [
                    (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(minDate, dateTime.timeZone, 'earlier'),
                    (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(minDate, dateTime.timeZone, 'later')
                ].filter(function(ms) {
                    return (0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms, dateTime.timeZone).day === minDate.day;
                })[0];
                var maxDate = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)($0bc8c577ea38feca$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
                var maxAbsolute = [
                    (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(maxDate, dateTime.timeZone, 'earlier'),
                    (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(maxDate, dateTime.timeZone, 'later')
                ].filter(function(ms) {
                    return (0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms, dateTime.timeZone).day === maxDate.day;
                }).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                var ms = (0, $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb)(dateTime) - dateTime.offset;
                var hours = Math.floor(ms / $0bc8c577ea38feca$var$$735220c2d4774dd3$var$ONE_HOUR);
                var remainder = ms % $0bc8c577ea38feca$var$$735220c2d4774dd3$var$ONE_HOUR;
                ms = $0bc8c577ea38feca$var$$735220c2d4774dd3$var$cycleValue(hours, amount, Math.floor(minAbsolute / $0bc8c577ea38feca$var$$735220c2d4774dd3$var$ONE_HOUR), Math.floor(maxAbsolute / $0bc8c577ea38feca$var$$735220c2d4774dd3$var$ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * $0bc8c577ea38feca$var$$735220c2d4774dd3$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms, dateTime.timeZone), dateTime.calendar);
            }
        case 'minute':
        case 'second':
        case 'millisecond':
            // @ts-ignore
            return $0bc8c577ea38feca$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case 'era':
        case 'year':
        case 'month':
        case 'day':
            {
                var res = $0bc8c577ea38feca$export$d52ced6badfb9a4c((0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(dateTime), field, amount, options);
                var ms1 = (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(res, dateTime.timeZone);
                return (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms1, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error('Unsupported field ' + field);
    }
}
function $0bc8c577ea38feca$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    var plainDateTime = (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(dateTime);
    var res = $0bc8c577ea38feca$export$e5d5e1c1822b6e56($0bc8c577ea38feca$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    var ms = (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(res, dateTime.timeZone, disambiguation);
    return (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms, dateTime.timeZone), dateTime.calendar);
}




var $90NkU = parcelRequire("90NkU");




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$DATE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$DATE_TIME_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?)?\[(.*?)\]$/;
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$ABSOLUTE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$DATE_TIME_DURATION_RE = RegExp("^((?<negative>-)|\\+)?P((?<years>\\d*)Y)?((?<months>\\d*)M)?((?<weeks>\\d*)W)?((?<days>\\d*)D)?((?<time>T)((?<hours>\\d*[.,]?\\d{1,9})H)?((?<minutes>\\d*[.,]?\\d{1,9})M)?((?<seconds>\\d*[.,]?\\d{1,9})S)?)?$");
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$requiredDurationTimeGroups = [
    'hours',
    'minutes',
    'seconds'
];
var $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$requiredDurationGroups = [
    'years',
    'months',
    'weeks',
    'days'
].concat((0, $90NkU._)($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$requiredDurationTimeGroups));
function $d702bd9cfffa1c84$export$c9698ec7f05a07e1(value) {
    var m = value.match($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 time string: ' + value);
    return new (0, $544adb0fa0f2d511$export$680ea196effce5f)($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 23), m[2] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $d702bd9cfffa1c84$export$6b862160d295c8e(value) {
    var m = value.match($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$DATE_RE);
    if (!m) throw new Error('Invalid ISO 8601 date string: ' + value);
    var date = new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 9999), $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1);
    date.day = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[3], 1, date.calendar.getDaysInMonth(date));
    return date;
}
function $d702bd9cfffa1c84$export$588937bcd60ade55(value) {
    var m = value.match($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$DATE_TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    var year = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[1], -9999, 9999);
    var era = year < 1 ? 'BC' : 'AD';
    var date = new (0, $544adb0fa0f2d511$export$ca871e8dbb80966f)(era, year < 1 ? -year + 1 : year, $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[4] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $d702bd9cfffa1c84$export$fd7893f06e92a6a4(value, disambiguation) {
    var m = value.match($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    var year = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[1], -9999, 9999);
    var era = year < 1 ? 'BC' : 'AD';
    var date = new (0, $544adb0fa0f2d511$export$d3b7288e7994edea)(era, year < 1 ? -year + 1 : year, $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var plainDateTime = (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(date);
    var ms;
    if (m[8]) {
        var _m_;
        date.offset = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : '0', 0, 59) * 60000;
        ms = (0, $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb)(date) - date.offset;
        // Validate offset against parsed date.
        var absolutes = (0, $c7eb0f5ee6d7094f$export$136f38efe7caf549)(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error("Offset ".concat($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$offsetToString(date.offset), " is invalid for ").concat($d702bd9cfffa1c84$export$4223de14708adc63(date), " in ").concat(date.timeZone));
    } else ms = (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)((0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(plainDateTime), date.timeZone, disambiguation);
    return (0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(ms, date.timeZone);
}
function $d702bd9cfffa1c84$export$5adfdab05168c219(value, timeZone) {
    var m = value.match($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$ABSOLUTE_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    var year = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[1], -9999, 9999);
    var era = year < 1 ? 'BC' : 'AD';
    var date = new (0, $544adb0fa0f2d511$export$d3b7288e7994edea)(era, year < 1 ? -year + 1 : year, $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var _m_;
    if (m[8]) date.offset = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : '0', 0, 59) * 60000;
    return (0, $c7eb0f5ee6d7094f$export$538b00033cc11c75)(date, timeZone);
}
function $d702bd9cfffa1c84$export$8e384432362ed0f0(value) {
    return $d702bd9cfffa1c84$export$5adfdab05168c219(value, (0, $b20616b02fb62709$export$aa8b41735afcabd2)());
}
function $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$parseNumber(value, min, max) {
    var val = Number(value);
    if (val < min || val > max) throw new RangeError("Value out of range: ".concat(min, " <= ").concat(val, " <= ").concat(max));
    return val;
}
function $d702bd9cfffa1c84$export$f59dee82248f5ad4(time) {
    return "".concat(String(time.hour).padStart(2, '0'), ":").concat(String(time.minute).padStart(2, '0'), ":").concat(String(time.second).padStart(2, '0')).concat(time.millisecond ? String(time.millisecond / 1000).slice(1) : '');
}
function $d702bd9cfffa1c84$export$60dfd74aa96791bd(date) {
    var gregorianDate = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(date, new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
    var year;
    if (gregorianDate.era === 'BC') year = gregorianDate.year === 1 ? '0000' : '-' + String(Math.abs(1 - gregorianDate.year)).padStart(6, '00');
    else year = String(gregorianDate.year).padStart(4, '0');
    return "".concat(year, "-").concat(String(gregorianDate.month).padStart(2, '0'), "-").concat(String(gregorianDate.day).padStart(2, '0'));
}
function $d702bd9cfffa1c84$export$4223de14708adc63(date) {
    // @ts-ignore
    return "".concat($d702bd9cfffa1c84$export$60dfd74aa96791bd(date), "T").concat($d702bd9cfffa1c84$export$f59dee82248f5ad4(date));
}
function $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$offsetToString(offset) {
    var sign = Math.sign(offset) < 0 ? '-' : '+';
    offset = Math.abs(offset);
    var offsetHours = Math.floor(offset / 3600000);
    var offsetMinutes = offset % 3600000 / 60000;
    return "".concat(sign).concat(String(offsetHours).padStart(2, '0'), ":").concat(String(offsetMinutes).padStart(2, '0'));
}
function $d702bd9cfffa1c84$export$bf79f1ebf4b18792(date) {
    return "".concat($d702bd9cfffa1c84$export$4223de14708adc63(date)).concat($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$offsetToString(date.offset), "[").concat(date.timeZone, "]");
}
function $d702bd9cfffa1c84$export$ecae829bb3747ea6(value) {
    var _match_groups, _match_groups1, _match_groups2, _match_groups3, _match_groups4, _match_groups5, _match_groups6, _match_groups7, _match_groups8;
    var match = value.match($d702bd9cfffa1c84$var$$fae977aafc393c5c$var$DATE_TIME_DURATION_RE);
    if (!match) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    var parseDurationGroup = function(group, isNegative) {
        if (!group) return 0;
        try {
            var sign = isNegative ? -1 : 1;
            return sign * Number(group.replace(',', '.'));
        } catch (e) {
            throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
        }
    };
    var isNegative = !!((_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups.negative);
    var hasRequiredGroups = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$requiredDurationGroups.some(function(group) {
        var _match_groups;
        return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
    });
    if (!hasRequiredGroups) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    var durationStringIncludesTime = (_match_groups1 = match.groups) === null || _match_groups1 === void 0 ? void 0 : _match_groups1.time;
    if (durationStringIncludesTime) {
        var hasRequiredDurationTimeGroups = $d702bd9cfffa1c84$var$$fae977aafc393c5c$var$requiredDurationTimeGroups.some(function(group) {
            var _match_groups;
            return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
        });
        if (!hasRequiredDurationTimeGroups) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    }
    var duration = {
        years: parseDurationGroup((_match_groups2 = match.groups) === null || _match_groups2 === void 0 ? void 0 : _match_groups2.years, isNegative),
        months: parseDurationGroup((_match_groups3 = match.groups) === null || _match_groups3 === void 0 ? void 0 : _match_groups3.months, isNegative),
        weeks: parseDurationGroup((_match_groups4 = match.groups) === null || _match_groups4 === void 0 ? void 0 : _match_groups4.weeks, isNegative),
        days: parseDurationGroup((_match_groups5 = match.groups) === null || _match_groups5 === void 0 ? void 0 : _match_groups5.days, isNegative),
        hours: parseDurationGroup((_match_groups6 = match.groups) === null || _match_groups6 === void 0 ? void 0 : _match_groups6.hours, isNegative),
        minutes: parseDurationGroup((_match_groups7 = match.groups) === null || _match_groups7 === void 0 ? void 0 : _match_groups7.minutes, isNegative),
        seconds: parseDurationGroup((_match_groups8 = match.groups) === null || _match_groups8 === void 0 ? void 0 : _match_groups8.seconds, isNegative)
    };
    if (duration.hours !== undefined && duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error("Invalid ISO 8601 Duration string: ".concat(value, " - only the smallest unit can be fractional"));
    if (duration.minutes !== undefined && duration.minutes % 1 !== 0 && duration.seconds) throw new Error("Invalid ISO 8601 Duration string: ".concat(value, " - only the smallest unit can be fractional"));
    return duration;
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$shiftArgs(args) {
    var calendar = (0, $4TMho._)(args[0]) === 'object' ? args.shift() : new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)();
    var era;
    if (typeof args[0] === 'string') era = args.shift();
    else {
        var eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    var year = args.shift();
    var month = args.shift();
    var day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
var // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
// If that behavior is desired, use the AnyCalendarDate interface instead.
// @ts-ignore
$544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type = /*#__PURE__*/ new WeakMap();
var $544adb0fa0f2d511$export$99faa760c7908e4f = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$99faa760c7908e4f() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $35ea8db9cb2ccb90$export$99faa760c7908e4f);
        (0, $7caec834217ccce9$export$71511d61b312f219)(this, $544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type, {
            writable: true,
            value: void 0
        });
        var _$35ea8db9cb2ccb90$var$shiftArgs = (0, $c6938abc98c6418f$export$71511d61b312f219)($544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$shiftArgs(args), 5), calendar = _$35ea8db9cb2ccb90$var$shiftArgs[0], era = _$35ea8db9cb2ccb90$var$shiftArgs[1], year = _$35ea8db9cb2ccb90$var$shiftArgs[2], month = _$35ea8db9cb2ccb90$var$shiftArgs[3], day = _$35ea8db9cb2ccb90$var$shiftArgs[4];
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        (0, $0bc8c577ea38feca$export$c4e2ecac49351ef2)(this);
    }
    (0, $eOJ9o._)($35ea8db9cb2ccb90$export$99faa760c7908e4f, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
                else return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, $0bc8c577ea38feca$export$e16d8520af44a096)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, $0bc8c577ea38feca$export$4e2d2ead65e5f7e3)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return (0, $0bc8c577ea38feca$export$adaa4cf7ef1b65be)(this, fields);
            }
        },
        {
            /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return (0, $0bc8c577ea38feca$export$d52ced6badfb9a4c)(this, field, amount, options);
            }
        },
        {
            /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ key: "toDate",
            value: function toDate(timeZone) {
                return (0, $c7eb0f5ee6d7094f$export$e67a095c620b86fe)(this, timeZone);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return (0, $d702bd9cfffa1c84$export$60dfd74aa96791bd)(this);
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                return (0, $b20616b02fb62709$export$68781ddf31c0090f)(this, b);
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$99faa760c7908e4f;
}();
var // @ts-ignore
$544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type1 = /*#__PURE__*/ new WeakMap();
var $544adb0fa0f2d511$export$680ea196effce5f = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$680ea196effce5f() {
        var hour = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, minute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, second = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, millisecond = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, $gpEpt._)(this, $35ea8db9cb2ccb90$export$680ea196effce5f);
        (0, $7caec834217ccce9$export$71511d61b312f219)(this, $544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type1, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        (0, $0bc8c577ea38feca$export$7555de1e070510cb)(this);
    }
    (0, $eOJ9o._)($35ea8db9cb2ccb90$export$680ea196effce5f, [
        {
            /** Returns a copy of this time. */ key: "copy",
            value: function copy() {
                return new $35ea8db9cb2ccb90$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `Time` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, $0bc8c577ea38feca$export$7ed87b6bc2506470)(this, duration);
            }
        },
        {
            /** Returns a new `Time` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, $0bc8c577ea38feca$export$fe34d3a381cd7501)(this, duration);
            }
        },
        {
            /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return (0, $0bc8c577ea38feca$export$e5d5e1c1822b6e56)(this, fields);
            }
        },
        {
            /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return (0, $0bc8c577ea38feca$export$dd02b3e0007dfe28)(this, field, amount, options);
            }
        },
        {
            /** Converts the time to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return (0, $d702bd9cfffa1c84$export$f59dee82248f5ad4)(this);
            }
        },
        {
            /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ key: "compare",
            value: function compare(b) {
                return (0, $b20616b02fb62709$export$c19a80a9721b80f6)(this, b);
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$680ea196effce5f;
}();
var // @ts-ignore
$544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type2 = /*#__PURE__*/ new WeakMap();
var $544adb0fa0f2d511$export$ca871e8dbb80966f = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$ca871e8dbb80966f() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $35ea8db9cb2ccb90$export$ca871e8dbb80966f);
        (0, $7caec834217ccce9$export$71511d61b312f219)(this, $544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type2, {
            writable: true,
            value: void 0
        });
        var _$35ea8db9cb2ccb90$var$shiftArgs = (0, $c6938abc98c6418f$export$71511d61b312f219)($544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$shiftArgs(args), 5), calendar = _$35ea8db9cb2ccb90$var$shiftArgs[0], era = _$35ea8db9cb2ccb90$var$shiftArgs[1], year = _$35ea8db9cb2ccb90$var$shiftArgs[2], month = _$35ea8db9cb2ccb90$var$shiftArgs[3], day = _$35ea8db9cb2ccb90$var$shiftArgs[4];
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, $0bc8c577ea38feca$export$c4e2ecac49351ef2)(this);
    }
    (0, $eOJ9o._)($35ea8db9cb2ccb90$export$ca871e8dbb80966f, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
                else return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, $0bc8c577ea38feca$export$e16d8520af44a096)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, $0bc8c577ea38feca$export$4e2d2ead65e5f7e3)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return (0, $0bc8c577ea38feca$export$adaa4cf7ef1b65be)((0, $0bc8c577ea38feca$export$e5d5e1c1822b6e56)(this, fields), fields);
            }
        },
        {
            /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                switch(field){
                    case 'era':
                    case 'year':
                    case 'month':
                    case 'day':
                        return (0, $0bc8c577ea38feca$export$d52ced6badfb9a4c)(this, field, amount, options);
                    default:
                        return (0, $0bc8c577ea38feca$export$dd02b3e0007dfe28)(this, field, amount, options);
                }
            }
        },
        {
            /** Converts the date to a native JavaScript Date object in the given time zone. */ key: "toDate",
            value: function toDate(timeZone, disambiguation) {
                return (0, $c7eb0f5ee6d7094f$export$e67a095c620b86fe)(this, timeZone, disambiguation);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return (0, $d702bd9cfffa1c84$export$4223de14708adc63)(this);
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                var res = (0, $b20616b02fb62709$export$68781ddf31c0090f)(this, b);
                if (res === 0) return (0, $b20616b02fb62709$export$c19a80a9721b80f6)(this, (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(b));
                return res;
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$ca871e8dbb80966f;
}();
var // @ts-ignore
$544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type3 = /*#__PURE__*/ new WeakMap();
var $544adb0fa0f2d511$export$d3b7288e7994edea = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$d3b7288e7994edea() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $35ea8db9cb2ccb90$export$d3b7288e7994edea);
        (0, $7caec834217ccce9$export$71511d61b312f219)(this, $544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$_type3, {
            writable: true,
            value: void 0
        });
        var _$35ea8db9cb2ccb90$var$shiftArgs = (0, $c6938abc98c6418f$export$71511d61b312f219)($544adb0fa0f2d511$var$$35ea8db9cb2ccb90$var$shiftArgs(args), 5), calendar = _$35ea8db9cb2ccb90$var$shiftArgs[0], era = _$35ea8db9cb2ccb90$var$shiftArgs[1], year = _$35ea8db9cb2ccb90$var$shiftArgs[2], month = _$35ea8db9cb2ccb90$var$shiftArgs[3], day = _$35ea8db9cb2ccb90$var$shiftArgs[4];
        var timeZone = args.shift();
        var offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, $0bc8c577ea38feca$export$c4e2ecac49351ef2)(this);
    }
    (0, $eOJ9o._)($35ea8db9cb2ccb90$export$d3b7288e7994edea, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
                else return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, $0bc8c577ea38feca$export$96b1d28349274637)(this, duration);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, $0bc8c577ea38feca$export$6814caac34ca03c7)(this, duration);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields, disambiguation) {
                return (0, $0bc8c577ea38feca$export$31b5430eb18be4f8)(this, fields, disambiguation);
            }
        },
        {
            /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return (0, $0bc8c577ea38feca$export$9a297d111fc86b79)(this, field, amount, options);
            }
        },
        {
            /** Converts the date to a native JavaScript Date object. */ key: "toDate",
            value: function toDate() {
                return (0, $c7eb0f5ee6d7094f$export$83aac07b4c37b25)(this);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ key: "toString",
            value: function toString() {
                return (0, $d702bd9cfffa1c84$export$bf79f1ebf4b18792)(this);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string in UTC. */ key: "toAbsoluteString",
            value: function toAbsoluteString() {
                return this.toDate().toISOString();
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                // TODO: Is this a bad idea??
                return this.toDate().getTime() - (0, $c7eb0f5ee6d7094f$export$84c95a83c799e074)(b, this.timeZone).toDate().getTime();
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$d3b7288e7994edea;
}();





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
function $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb(date) {
    date = $c7eb0f5ee6d7094f$export$b4a036af3fc0b032(date, new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
    var year = (0, $acc76a7a17331648$export$c36e0ecb2d4fa69d)(date.era, date.year);
    return $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    var date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $c7eb0f5ee6d7094f$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === 'UTC') return 0;
    // Fast path: for local timezone after 1970, use native Date.
    if (ms > 0 && timeZone === (0, $b20616b02fb62709$export$aa8b41735afcabd2)()) return new Date(ms).getTimezoneOffset() * -60000;
    var _$11d87f3f76e88657$var$getTimeZoneParts = $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone), year = _$11d87f3f76e88657$var$getTimeZoneParts.year, month = _$11d87f3f76e88657$var$getTimeZoneParts.month, day = _$11d87f3f76e88657$var$getTimeZoneParts.day, hour = _$11d87f3f76e88657$var$getTimeZoneParts.hour, minute = _$11d87f3f76e88657$var$getTimeZoneParts.minute, second = _$11d87f3f76e88657$var$getTimeZoneParts.second;
    var utc = $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
var $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$formattersByTimeZone = new Map();
function $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone) {
    var formatter = $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            hour12: false,
            era: 'short',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        });
        $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$formattersByTimeZone.set(timeZone, formatter);
    }
    var parts = formatter.formatToParts(new Date(ms));
    var namedParts = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (part.type !== 'literal') namedParts[part.type] = part.value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === 'BC' || namedParts.era === 'B' ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === '24' ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
var $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$DAYMILLIS = 86400000;
function $c7eb0f5ee6d7094f$export$136f38efe7caf549(date, timeZone) {
    var ms = $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb(date);
    var earlier = ms - $c7eb0f5ee6d7094f$export$59c99f3515d3493f(ms - $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    var later = ms - $c7eb0f5ee6d7094f$export$59c99f3515d3493f(ms + $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    return $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later) {
    var found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter(function(absolute) {
        return $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute);
    });
}
function $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute) {
    var parts = $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $c7eb0f5ee6d7094f$export$5107c82f94518f5c(date, timeZone) {
    var disambiguation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'compatible';
    var dateTime = $c7eb0f5ee6d7094f$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === 'UTC') return $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === (0, $b20616b02fb62709$export$aa8b41735afcabd2)() && disambiguation === 'compatible') {
        dateTime = $c7eb0f5ee6d7094f$export$b4a036af3fc0b032(dateTime, new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        var _$date = new Date();
        var year = (0, $acc76a7a17331648$export$c36e0ecb2d4fa69d)(dateTime.era, dateTime.year);
        _$date.setFullYear(year, dateTime.month - 1, dateTime.day);
        _$date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return _$date.getTime();
    }
    var ms = $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb(dateTime);
    var offsetBefore = $c7eb0f5ee6d7094f$export$59c99f3515d3493f(ms - $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    var offsetAfter = $c7eb0f5ee6d7094f$export$59c99f3515d3493f(ms + $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    var valid = $c7eb0f5ee6d7094f$var$$11d87f3f76e88657$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case 'compatible':
        case 'earlier':
            return valid[0];
        case 'later':
            return valid[valid.length - 1];
        case 'reject':
            throw new RangeError('Multiple possible absolute times found');
    }
    switch(disambiguation){
        case 'earlier':
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case 'compatible':
        case 'later':
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case 'reject':
            throw new RangeError('No such absolute time found');
    }
}
function $c7eb0f5ee6d7094f$export$e67a095c620b86fe(dateTime, timeZone) {
    var disambiguation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'compatible';
    return new Date($c7eb0f5ee6d7094f$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $c7eb0f5ee6d7094f$export$1b96692a1ba042ac(ms, timeZone) {
    var offset = $c7eb0f5ee6d7094f$export$59c99f3515d3493f(ms, timeZone);
    var date = new Date(ms + offset);
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth() + 1;
    var day = date.getUTCDate();
    var hour = date.getUTCHours();
    var minute = date.getUTCMinutes();
    var second = date.getUTCSeconds();
    var millisecond = date.getUTCMilliseconds();
    return new (0, $544adb0fa0f2d511$export$d3b7288e7994edea)(year < 1 ? 'BC' : 'AD', year < 1 ? -year + 1 : year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $c7eb0f5ee6d7094f$export$e57ff100d91bd4b9(date, timeZone) {
    return $c7eb0f5ee6d7094f$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $c7eb0f5ee6d7094f$export$d7f92bcd3596b086(date) {
    return $c7eb0f5ee6d7094f$export$e57ff100d91bd4b9(date, (0, $b20616b02fb62709$export$aa8b41735afcabd2)());
}
function $c7eb0f5ee6d7094f$export$93522d1a439f3617(dateTime) {
    return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $c7eb0f5ee6d7094f$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $c7eb0f5ee6d7094f$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $c7eb0f5ee6d7094f$export$b21e0b124e224484(date, time) {
    var hour = 0, minute = 0, second = 0, millisecond = 0;
    var ref;
    if ('timeZone' in date) ref = date, hour = ref.hour, minute = ref.minute, second = ref.second, millisecond = ref.millisecond, ref;
    else if ('hour' in date && !time) return date;
    var ref1;
    if (time) ref1 = time, hour = ref1.hour, minute = ref1.minute, second = ref1.second, millisecond = ref1.millisecond, ref1;
    return new (0, $544adb0fa0f2d511$export$ca871e8dbb80966f)(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $c7eb0f5ee6d7094f$export$d33f79e3ffc3dc83(dateTime) {
    return new (0, $544adb0fa0f2d511$export$680ea196effce5f)(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $c7eb0f5ee6d7094f$export$b4a036af3fc0b032(date, calendar) {
    if ((0, $b20616b02fb62709$export$dbc69fd56b53d5e)(date.calendar, calendar)) return date;
    var calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    var copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    (0, $0bc8c577ea38feca$export$c4e2ecac49351ef2)(copy);
    return copy;
}
function $c7eb0f5ee6d7094f$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof (0, $544adb0fa0f2d511$export$d3b7288e7994edea)) {
        if (date.timeZone === timeZone) return date;
        return $c7eb0f5ee6d7094f$export$538b00033cc11c75(date, timeZone);
    }
    var ms = $c7eb0f5ee6d7094f$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $c7eb0f5ee6d7094f$export$1b96692a1ba042ac(ms, timeZone);
}
function $c7eb0f5ee6d7094f$export$83aac07b4c37b25(date) {
    var ms = $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $c7eb0f5ee6d7094f$export$538b00033cc11c75(date, timeZone) {
    var ms = $c7eb0f5ee6d7094f$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $c7eb0f5ee6d7094f$export$b4a036af3fc0b032($c7eb0f5ee6d7094f$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $c7eb0f5ee6d7094f$export$d9b67bc93c097491(date) {
    return $c7eb0f5ee6d7094f$export$538b00033cc11c75(date, (0, $b20616b02fb62709$export$aa8b41735afcabd2)());
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
var $30e346d2ce0fb159$export$7a5acbd77d414bd9 = {
    '001': 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b20616b02fb62709$export$ea39ec197993aef0(a, b) {
    b = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $b20616b02fb62709$export$a18c89cbd24170ff(a, b) {
    b = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $b20616b02fb62709$export$a5a3b454ada2268e(a);
    b = $b20616b02fb62709$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $b20616b02fb62709$export$5841f9eb9773f25f(a, b) {
    b = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(b, a.calendar);
    a = $b20616b02fb62709$export$f91e89d3d0406102(a);
    b = $b20616b02fb62709$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $b20616b02fb62709$export$91b62ebf2ba703ee(a, b) {
    return $b20616b02fb62709$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $b20616b02fb62709$export$ea39ec197993aef0(a, b);
}
function $b20616b02fb62709$export$5a8da0c44a3afdf2(a, b) {
    return $b20616b02fb62709$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $b20616b02fb62709$export$a18c89cbd24170ff(a, b);
}
function $b20616b02fb62709$export$ea840f5a6dda8147(a, b) {
    return $b20616b02fb62709$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $b20616b02fb62709$export$5841f9eb9773f25f(a, b);
}
function $b20616b02fb62709$export$dbc69fd56b53d5e(a, b) {
    var _a_isEqual, _b_isEqual;
    var _a_isEqual1, _ref;
    return (_ref = (_a_isEqual1 = (_a_isEqual = a.isEqual) === null || _a_isEqual === void 0 ? void 0 : _a_isEqual.call(a, b)) !== null && _a_isEqual1 !== void 0 ? _a_isEqual1 : (_b_isEqual = b.isEqual) === null || _b_isEqual === void 0 ? void 0 : _b_isEqual.call(b, a)) !== null && _ref !== void 0 ? _ref : a.identifier === b.identifier;
}
function $b20616b02fb62709$export$629b0a497aa65267(date, timeZone) {
    return $b20616b02fb62709$export$ea39ec197993aef0(date, $b20616b02fb62709$export$d0bdf45af03a6ea3(timeZone));
}
var $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$DAY_MAP = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
};
function $b20616b02fb62709$export$2061056d06d7cdf7(date, locale, firstDayOfWeek) {
    var julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    var weekStart = firstDayOfWeek ? $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$DAY_MAP[firstDayOfWeek] : $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$getWeekStart(locale);
    var dayOfWeek = Math.ceil(julian + 1 - weekStart) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $b20616b02fb62709$export$461939dd4422153(timeZone) {
    return (0, $c7eb0f5ee6d7094f$export$1b96692a1ba042ac)(Date.now(), timeZone);
}
function $b20616b02fb62709$export$d0bdf45af03a6ea3(timeZone) {
    return (0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)($b20616b02fb62709$export$461939dd4422153(timeZone));
}
function $b20616b02fb62709$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $b20616b02fb62709$export$c19a80a9721b80f6(a, b) {
    return $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$timeToMs(a) - $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$timeToMs(b);
}
function $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $b20616b02fb62709$export$126c91c941de7e(a, timeZone) {
    var ms = (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(a, timeZone);
    var tomorrow = a.add({
        days: 1
    });
    var tomorrowMs = (0, $c7eb0f5ee6d7094f$export$5107c82f94518f5c)(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
var $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$localTimeZone = null;
function $b20616b02fb62709$export$aa8b41735afcabd2() {
    // TODO: invalidate this somehow?
    if ($b20616b02fb62709$var$$14e0f24ef4ac5c92$var$localTimeZone == null) $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$localTimeZone;
}
function $b20616b02fb62709$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $b20616b02fb62709$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $b20616b02fb62709$export$f91e89d3d0406102(date) {
    return $b20616b02fb62709$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $b20616b02fb62709$export$8b7aa55c66d5569e(date) {
    return $b20616b02fb62709$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $b20616b02fb62709$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $b20616b02fb62709$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $b20616b02fb62709$export$42c81a444fbfb5d4(date, locale, firstDayOfWeek) {
    var dayOfWeek = $b20616b02fb62709$export$2061056d06d7cdf7(date, locale, firstDayOfWeek);
    return date.subtract({
        days: dayOfWeek
    });
}
function $b20616b02fb62709$export$ef8b6d9133084f4e(date, locale, firstDayOfWeek) {
    return $b20616b02fb62709$export$42c81a444fbfb5d4(date, locale, firstDayOfWeek).add({
        days: 6
    });
}
var $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$cachedRegions = new Map();
function $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        var region = $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            if (region) $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    var part = locale.split('-')[1];
    return part === 'u' ? undefined : part;
}
function $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    var region = $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    return region ? (0, $30e346d2ce0fb159$export$7a5acbd77d414bd9)[region] || 0 : 0;
}
function $b20616b02fb62709$export$ccc1b2479e7dd654(date, locale, firstDayOfWeek) {
    var days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($b20616b02fb62709$export$2061056d06d7cdf7($b20616b02fb62709$export$a5a3b454ada2268e(date), locale, firstDayOfWeek) + days) / 7);
}
function $b20616b02fb62709$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $b20616b02fb62709$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
var $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $b20616b02fb62709$export$618d60ea299da42(date, locale) {
    var julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    var dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    var region = $b20616b02fb62709$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    var _ref = (0, $c6938abc98c6418f$export$71511d61b312f219)($b20616b02fb62709$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA[region] || [
        6,
        0
    ], 2), start = _ref[0], end = _ref[1];
    return dayOfWeek === start || dayOfWeek === end;
}
function $b20616b02fb62709$export$ee9d87258e1d19ed(date, locale) {
    return !$b20616b02fb62709$export$618d60ea299da42(date, locale);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $2QPpE = parcelRequire("2QPpE");


var $90NkU = parcelRequire("90NkU");
var $de6ec507564b9a27$var$$fb18d541ea1ad717$var$formatterCache = new Map();
var $de6ec507564b9a27$export$ad991b66133851cf = /*#__PURE__*/ function() {
    "use strict";
    function $fb18d541ea1ad717$export$ad991b66133851cf(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gpEpt._)(this, $fb18d541ea1ad717$export$ad991b66133851cf);
        this.formatter = $de6ec507564b9a27$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
    (0, $eOJ9o._)($fb18d541ea1ad717$export$ad991b66133851cf, [
        {
            /** Formats a date as a string according to the locale and format options passed to the constructor. */ key: "format",
            value: function format(value) {
                return this.formatter.format(value);
            }
        },
        {
            /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ key: "formatToParts",
            value: function formatToParts(value) {
                return this.formatter.formatToParts(value);
            }
        },
        {
            /** Formats a date range as a string. */ key: "formatRange",
            value: function formatRange(start, end) {
                // @ts-ignore
                if (typeof this.formatter.formatRange === 'function') return this.formatter.formatRange(start, end);
                if (end < start) throw new RangeError('End date must be >= start date');
                // Very basic fallback for old browsers.
                return "".concat(this.formatter.format(start), " \u2013 ").concat(this.formatter.format(end));
            }
        },
        {
            /** Formats a date range as an array of parts. */ key: "formatRangeToParts",
            value: function formatRangeToParts(start, end) {
                // @ts-ignore
                if (typeof this.formatter.formatRangeToParts === 'function') return this.formatter.formatRangeToParts(start, end);
                if (end < start) throw new RangeError('End date must be >= start date');
                var startParts = this.formatter.formatToParts(start);
                var endParts = this.formatter.formatToParts(end);
                return (0, $90NkU._)(startParts.map(function(p) {
                    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, p), {
                        source: 'startRange'
                    });
                })).concat([
                    {
                        type: 'literal',
                        value: " \u2013 ",
                        source: 'shared'
                    }
                ], (0, $90NkU._)(endParts.map(function(p) {
                    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, p), {
                        source: 'endRange'
                    });
                })));
            }
        },
        {
            /** Returns the resolved formatting options based on the values passed to the constructor. */ key: "resolvedOptions",
            value: function resolvedOptions() {
                var resolvedOptions = this.formatter.resolvedOptions();
                if ($de6ec507564b9a27$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
                    if (!this.resolvedHourCycle) this.resolvedHourCycle = $de6ec507564b9a27$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
                    resolvedOptions.hourCycle = this.resolvedHourCycle;
                    resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
                }
                // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
                // https://bugs.webkit.org/show_bug.cgi?id=241564
                if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
                return resolvedOptions;
            }
        }
    ]);
    return $fb18d541ea1ad717$export$ad991b66133851cf;
}();
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
var $de6ec507564b9a27$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {}
};
function $de6ec507564b9a27$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && $de6ec507564b9a27$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = (0, $2QPpE._)({}, options);
        var pref = $de6ec507564b9a27$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        var defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : '');
    if ($de6ec507564b9a27$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $de6ec507564b9a27$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    var numberFormatter = new Intl.DateTimeFormat(locale, options);
    $de6ec507564b9a27$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
var $de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $de6ec507564b9a27$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return $de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
var $de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $de6ec507564b9a27$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return $de6ec507564b9a27$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $de6ec507564b9a27$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    var formatter = $de6ec507564b9a27$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, options), {
        timeZone: undefined // use local timezone
    }));
    var min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find(function(p) {
        return p.type === 'hour';
    }).value, 10);
    var max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find(function(p) {
        return p.type === 'hour';
    }).value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $9fa6665d3a5025d4$export$722debc0e56fea39(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    var lastValue = (0, $ggE0n.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}



var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ee23060f623d2310$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $9fa6665d3a5025d4$export$722debc0e56fea39)(options !== null && options !== void 0 ? options : {}, $ee23060f623d2310$var$$896ba0a80a8f4d36$var$isEqual);
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    return (0, $ggE0n.useMemo)(function() {
        return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, options);
    }, [
        locale,
        options
    ]);
}
function $ee23060f623d2310$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (b[key] !== a[key]) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}



var $ggE0n = parcelRequire("ggE0n");
function $6f9513d1883bda16$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $6f9513d1883bda16$export$653eddfc964b0f8a = new WeakMap();
function $6f9513d1883bda16$export$134cbb7fb09a9522(date) {
    return (date === null || date === void 0 ? void 0 : date.calendar.identifier) === 'gregory' && date.era === 'BC' ? 'short' : undefined;
}
function $6f9513d1883bda16$export$b6df97c887c38e1a(state) {
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($6f9513d1883bda16$var$$parcel$interopDefault((0, $d76dbf185a4c1508$export$2e2bcd8739ae039)), '@react-aria/calendar');
    var start, end;
    var _state_value;
    var ref;
    if ('highlightedRange' in state) ref = state.highlightedRange || {}, start = ref.start, end = ref.end, ref;
    else start = end = (_state_value = state.value) !== null && _state_value !== void 0 ? _state_value : undefined;
    var dateFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        weekday: 'long',
        month: 'long',
        year: 'numeric',
        day: 'numeric',
        era: $6f9513d1883bda16$export$134cbb7fb09a9522(start) || $6f9513d1883bda16$export$134cbb7fb09a9522(end),
        timeZone: state.timeZone
    });
    var anchorDate = 'anchorDate' in state ? state.anchorDate : null;
    return (0, $ggE0n.useMemo)(function() {
        // No message if currently selecting a range, or there is nothing highlighted.
        if (!anchorDate && start && end) {
            // Use a single date message if the start and end dates are the same day,
            // otherwise include both dates.
            if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(start, end)) {
                var date = dateFormatter.format(start.toDate(state.timeZone));
                return stringFormatter.format('selectedDateDescription', {
                    date: date
                });
            } else {
                var dateRange = $6f9513d1883bda16$var$$a074e1e2d0f0a665$var$formatRange(dateFormatter, stringFormatter, start, end, state.timeZone);
                return stringFormatter.format('selectedRangeDescription', {
                    dateRange: dateRange
                });
            }
        }
        return '';
    }, [
        start,
        end,
        anchorDate,
        state.timeZone,
        stringFormatter,
        dateFormatter
    ]);
}
function $6f9513d1883bda16$export$31afe65d91ef6e8(startDate, endDate, timeZone, isAria) {
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($6f9513d1883bda16$var$$parcel$interopDefault((0, $d76dbf185a4c1508$export$2e2bcd8739ae039)), '@react-aria/calendar');
    var era = $6f9513d1883bda16$export$134cbb7fb09a9522(startDate) || $6f9513d1883bda16$export$134cbb7fb09a9522(endDate);
    var monthFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        month: 'long',
        year: 'numeric',
        era: era,
        calendar: startDate.calendar.identifier,
        timeZone: timeZone
    });
    var dateFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        month: 'long',
        year: 'numeric',
        day: 'numeric',
        era: era,
        calendar: startDate.calendar.identifier,
        timeZone: timeZone
    });
    return (0, $ggE0n.useMemo)(function() {
        // Special case for month granularity. Format as a single month if only a
        // single month is visible, otherwise format as a range of months.
        if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(startDate, (0, $b20616b02fb62709$export$a5a3b454ada2268e)(startDate))) {
            var startMonth = startDate;
            var endMonth = endDate;
            if (startDate.calendar.getFormattableMonth) startMonth = startDate.calendar.getFormattableMonth(startDate);
            if (endDate.calendar.getFormattableMonth) endMonth = endDate.calendar.getFormattableMonth(endDate);
            if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(endDate, (0, $b20616b02fb62709$export$a2258d9c4118825c)(startDate))) return monthFormatter.format(startMonth.toDate(timeZone));
            else if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(endDate, (0, $b20616b02fb62709$export$a2258d9c4118825c)(endDate))) return isAria ? $6f9513d1883bda16$var$$a074e1e2d0f0a665$var$formatRange(monthFormatter, stringFormatter, startMonth, endMonth, timeZone) : monthFormatter.formatRange(startMonth.toDate(timeZone), endMonth.toDate(timeZone));
        }
        return isAria ? $6f9513d1883bda16$var$$a074e1e2d0f0a665$var$formatRange(dateFormatter, stringFormatter, startDate, endDate, timeZone) : dateFormatter.formatRange(startDate.toDate(timeZone), endDate.toDate(timeZone));
    }, [
        startDate,
        endDate,
        monthFormatter,
        dateFormatter,
        stringFormatter,
        timeZone,
        isAria
    ]);
}
function $6f9513d1883bda16$var$$a074e1e2d0f0a665$var$formatRange(dateFormatter, stringFormatter, start, end, timeZone) {
    var parts = dateFormatter.formatRangeToParts(start.toDate(timeZone), end.toDate(timeZone));
    // Find the separator between the start and end date. This is determined
    // by finding the last shared literal before the end range.
    var separatorIndex = -1;
    for(var i = 0; i < parts.length; i++){
        var part = parts[i];
        if (part.source === 'shared' && part.type === 'literal') separatorIndex = i;
        else if (part.source === 'endRange') break;
    }
    // Now we can combine the parts into start and end strings.
    var startValue = '';
    var endValue = '';
    for(var i1 = 0; i1 < parts.length; i1++){
        if (i1 < separatorIndex) startValue += parts[i1].value;
        else if (i1 > separatorIndex) endValue += parts[i1].value;
    }
    return stringFormatter.format('dateRange', {
        startDate: startValue,
        endDate: endValue
    });
}





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1ce0777722ad12fd$export$496315a1608d9602(effect, dependencies) {
    var isInitialMount = (0, $ggE0n.useRef)(true);
    var lastDeps = (0, $ggE0n.useRef)(null);
    (0, $ggE0n.useEffect)(function() {
        isInitialMount.current = true;
        return function() {
            isInitialMount.current = false;
        };
    }, []);
    (0, $ggE0n.useEffect)(function() {
        var prevDeps = lastDeps.current;
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!prevDeps || dependencies.some(function(dep, i) {
            return !Object.is(dep, prevDeps[i]);
        })) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}




var $ggE0n = parcelRequire("ggE0n");
function $a03ba0b03b44f054$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a03ba0b03b44f054$export$d652b3ea2d672d5b(props, state) {
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($a03ba0b03b44f054$var$$parcel$interopDefault((0, $d76dbf185a4c1508$export$2e2bcd8739ae039)), '@react-aria/calendar');
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    var title = (0, $6f9513d1883bda16$export$31afe65d91ef6e8)(state.visibleRange.start, state.visibleRange.end, state.timeZone, false);
    var visibleRangeDescription = (0, $6f9513d1883bda16$export$31afe65d91ef6e8)(state.visibleRange.start, state.visibleRange.end, state.timeZone, true);
    (0, $1ce0777722ad12fd$export$496315a1608d9602)(function() {
        // only when pressing the Previous or Next button
        if (!state.isFocused) (0, $e7c771ec74591764$export$a9b970dcc4ae71a9)(visibleRangeDescription);
    }, [
        visibleRangeDescription
    ]);
    // Announce when the selected value changes
    var selectedDateDescription = (0, $6f9513d1883bda16$export$b6df97c887c38e1a)(state);
    (0, $1ce0777722ad12fd$export$496315a1608d9602)(function() {
        if (selectedDateDescription) (0, $e7c771ec74591764$export$a9b970dcc4ae71a9)(selectedDateDescription, 'polite', 4000);
    // handle an update to the caption that describes the currently selected range, to announce the new value
    }, [
        selectedDateDescription
    ]);
    var errorMessageId = (0, $7fc455d18519c289$export$b4cc09c592e8fdb8)([
        Boolean(props.errorMessage),
        props.isInvalid,
        props.validationState
    ]);
    (0, $6f9513d1883bda16$export$653eddfc964b0f8a).set(state, {
        ariaLabel: props['aria-label'],
        ariaLabelledBy: props['aria-labelledby'],
        errorMessageId: errorMessageId,
        selectedDateDescription: selectedDateDescription
    });
    // If the next or previous buttons become disabled while they are focused, move focus to the calendar body.
    var _$g2t6q$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), nextFocused = _$g2t6q$useState[0], setNextFocused = _$g2t6q$useState[1];
    var nextDisabled = props.isDisabled || state.isNextVisibleRangeInvalid();
    if (nextDisabled && nextFocused) {
        setNextFocused(false);
        state.setFocused(true);
    }
    var _$g2t6q$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), previousFocused = _$g2t6q$useState1[0], setPreviousFocused = _$g2t6q$useState1[1];
    var previousDisabled = props.isDisabled || state.isPreviousVisibleRangeInvalid();
    if (previousDisabled && previousFocused) {
        setPreviousFocused(false);
        state.setFocused(true);
    }
    var labelProps = (0, $c7019d53357f553d$export$d6875122194c7b44)({
        id: props['id'],
        'aria-label': [
            props['aria-label'],
            visibleRangeDescription
        ].filter(Boolean).join(', '),
        'aria-labelledby': props['aria-labelledby']
    });
    return {
        calendarProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, labelProps, {
            role: 'application',
            'aria-details': props['aria-details'] || undefined,
            'aria-describedby': props['aria-describedby'] || undefined
        }),
        nextButtonProps: {
            onPress: function() {
                return state.focusNextPage();
            },
            'aria-label': stringFormatter.format('next'),
            isDisabled: nextDisabled,
            onFocusChange: setNextFocused
        },
        prevButtonProps: {
            onPress: function() {
                return state.focusPreviousPage();
            },
            'aria-label': stringFormatter.format('previous'),
            isDisabled: previousDisabled,
            onFocusChange: setPreviousFocused
        },
        errorMessageProps: {
            id: errorMessageId
        },
        title: title
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c173dad03c524184$export$3ee915f8151bd4f1(props, state) {
    return (0, $a03ba0b03b44f054$export$d652b3ea2d672d5b)(props, state);
}








var $ggE0n = parcelRequire("ggE0n");
function $383e466db8fc2eec$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $383e466db8fc2eec$export$136073280381448e(props, state, ref) {
    var date = props.date, isDisabled = props.isDisabled;
    var _$a074e1e2d0f0a665$export$653eddfc964b0f8a_get = (0, $6f9513d1883bda16$export$653eddfc964b0f8a).get(state), errorMessageId = _$a074e1e2d0f0a665$export$653eddfc964b0f8a_get.errorMessageId, selectedDateDescription = _$a074e1e2d0f0a665$export$653eddfc964b0f8a_get.selectedDateDescription;
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($383e466db8fc2eec$var$$parcel$interopDefault((0, $d76dbf185a4c1508$export$2e2bcd8739ae039)), '@react-aria/calendar');
    var dateFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        era: (0, $6f9513d1883bda16$export$134cbb7fb09a9522)(date),
        timeZone: state.timeZone
    });
    var isSelected = state.isSelected(date);
    var isFocused = state.isCellFocused(date);
    isDisabled = isDisabled || state.isCellDisabled(date);
    var isUnavailable = state.isCellUnavailable(date);
    var isSelectable = !isDisabled && !isUnavailable;
    var isInvalid = state.isValueInvalid && Boolean('highlightedRange' in state ? !state.anchorDate && state.highlightedRange && date.compare(state.highlightedRange.start) >= 0 && date.compare(state.highlightedRange.end) <= 0 : state.value && (0, $b20616b02fb62709$export$ea39ec197993aef0)(state.value, date));
    if (isInvalid) isSelected = true;
    // For performance, reuse the same date object as before if the new date prop is the same.
    // This allows subsequent useMemo results to be reused.
    date = (0, $9fa6665d3a5025d4$export$722debc0e56fea39)(date, (0, $b20616b02fb62709$export$91b62ebf2ba703ee));
    var nativeDate = (0, $ggE0n.useMemo)(function() {
        return date.toDate(state.timeZone);
    }, [
        date,
        state.timeZone
    ]);
    // aria-label should be localize Day of week, Month, Day and Year without Time.
    var isDateToday = (0, $b20616b02fb62709$export$629b0a497aa65267)(date, state.timeZone);
    var label = (0, $ggE0n.useMemo)(function() {
        var label = '';
        // If this is a range calendar, add a description of the full selected range
        // to the first and last selected date.
        if ('highlightedRange' in state && state.value && !state.anchorDate && ((0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.value.start) || (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.value.end))) label = selectedDateDescription + ', ';
        label += dateFormatter.format(nativeDate);
        if (isDateToday) label = stringFormatter.format(isSelected ? 'todayDateSelected' : 'todayDate', {
            date: label
        });
        else if (isSelected) label = stringFormatter.format('dateSelected', {
            date: label
        });
        if (state.minValue && (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.minValue)) label += ', ' + stringFormatter.format('minimumDate');
        else if (state.maxValue && (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.maxValue)) label += ', ' + stringFormatter.format('maximumDate');
        return label;
    }, [
        dateFormatter,
        nativeDate,
        stringFormatter,
        isSelected,
        isDateToday,
        date,
        state,
        selectedDateDescription
    ]);
    // When a cell is focused and this is a range calendar, add a prompt to help
    // screenreader users know that they are in a range selection mode.
    var rangeSelectionPrompt = '';
    if ('anchorDate' in state && isFocused && !state.isReadOnly && isSelectable) {
        // If selection has started add "click to finish selecting range"
        if (state.anchorDate) rangeSelectionPrompt = stringFormatter.format('finishRangeSelectionPrompt');
        else rangeSelectionPrompt = stringFormatter.format('startRangeSelectionPrompt');
    }
    var descriptionProps = (0, $b484270dee1cc590$export$f8aeda7b10753fa1)(rangeSelectionPrompt);
    var isAnchorPressed = (0, $ggE0n.useRef)(false);
    var isRangeBoundaryPressed = (0, $ggE0n.useRef)(false);
    var touchDragTimerRef = (0, $ggE0n.useRef)(undefined);
    var _$dm6hl$usePress = (0, $741a5668c6acdbac$export$45712eceda6fad21)({
        // When dragging to select a range, we don't want dragging over the original anchor
        // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
        shouldCancelOnPointerExit: 'anchorDate' in state && !!state.anchorDate,
        preventFocusOnPress: true,
        isDisabled: !isSelectable || state.isReadOnly,
        onPressStart: function(e) {
            if (state.isReadOnly) {
                state.setFocusedDate(date);
                return;
            }
            if ('highlightedRange' in state && !state.anchorDate && (e.pointerType === 'mouse' || e.pointerType === 'touch')) {
                // Allow dragging the start or end date of a range to modify it
                // rather than starting a new selection.
                // Don't allow dragging when invalid, or weird jumping behavior may occur as date ranges
                // are constrained to available dates. The user will need to select a new range in this case.
                if (state.highlightedRange && !isInvalid) {
                    if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.highlightedRange.start)) {
                        state.setAnchorDate(state.highlightedRange.end);
                        state.setFocusedDate(date);
                        state.setDragging(true);
                        isRangeBoundaryPressed.current = true;
                        return;
                    } else if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.highlightedRange.end)) {
                        state.setAnchorDate(state.highlightedRange.start);
                        state.setFocusedDate(date);
                        state.setDragging(true);
                        isRangeBoundaryPressed.current = true;
                        return;
                    }
                }
                var startDragging = function() {
                    state.setDragging(true);
                    touchDragTimerRef.current = undefined;
                    state.selectDate(date);
                    state.setFocusedDate(date);
                    isAnchorPressed.current = true;
                };
                // Start selection on mouse/touch down so users can drag to select a range.
                // On touch, delay dragging to determine if the user really meant to scroll.
                if (e.pointerType === 'touch') touchDragTimerRef.current = setTimeout(startDragging, 200);
                else startDragging();
            }
        },
        onPressEnd: function() {
            isRangeBoundaryPressed.current = false;
            isAnchorPressed.current = false;
            clearTimeout(touchDragTimerRef.current);
            touchDragTimerRef.current = undefined;
        },
        onPress: function() {
            // For non-range selection, always select on press up.
            if (!('anchorDate' in state) && !state.isReadOnly) {
                state.selectDate(date);
                state.setFocusedDate(date);
            }
        },
        onPressUp: function(e) {
            if (state.isReadOnly) return;
            // If the user tapped quickly, the date won't be selected yet and the
            // timer will still be in progress. In this case, select the date on touch up.
            // Timer is cleared in onPressEnd.
            if ('anchorDate' in state && touchDragTimerRef.current) {
                state.selectDate(date);
                state.setFocusedDate(date);
            }
            if ('anchorDate' in state) {
                if (isRangeBoundaryPressed.current) // start a new selection on press up to also allow dragging the date to
                // change the existing range.
                state.setAnchorDate(date);
                else if (state.anchorDate && !isAnchorPressed.current) {
                    // When releasing a drag or pressing the end date of a range, select it.
                    state.selectDate(date);
                    state.setFocusedDate(date);
                } else if (e.pointerType === 'keyboard' && !state.anchorDate) {
                    // For range selection, auto-advance the focused date by one if using keyboard.
                    // This gives an indication that you're selecting a range rather than a single date.
                    // For mouse, this is unnecessary because users will see the indication on hover. For screen readers,
                    // there will be an announcement to "click to finish selecting range" (above).
                    state.selectDate(date);
                    var nextDay = date.add({
                        days: 1
                    });
                    if (state.isInvalid(nextDay)) nextDay = date.subtract({
                        days: 1
                    });
                    if (!state.isInvalid(nextDay)) state.setFocusedDate(nextDay);
                } else if (e.pointerType === 'virtual') {
                    // For screen readers, just select the date on click.
                    state.selectDate(date);
                    state.setFocusedDate(date);
                }
            }
        }
    }), pressProps = _$dm6hl$usePress.pressProps, isPressed = _$dm6hl$usePress.isPressed;
    var tabIndex = undefined;
    if (!isDisabled) tabIndex = (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.focusedDate) ? 0 : -1;
    (0, $ggE0n.useEffect)(function() {
        if (isFocused && ref.current) {
            (0, $0e32e36d6fc7d24d$export$de79e2c695e052f3)(ref.current);
            // Scroll into view if navigating with a keyboard, otherwise
            // try not to shift the view under the user's mouse/finger.
            // If in a overlay, scrollIntoViewport will only cause scrolling
            // up to the overlay scroll body to prevent overlay shifting.
            // Also only scroll into view if the cell actually got focused.
            // There are some cases where the cell might be disabled or inside,
            // an inert container and we don't want to scroll then.
            if ((0, $33b4709e5e6e943f$export$630ff653c5ada6a9)() !== 'pointer' && document.activeElement === ref.current) (0, $d3940bd7bb9376be$export$c826860796309d1b)(ref.current, {
                containingElement: (0, $6639b0c48472043a$export$cfa2225e87938781)(ref.current)
            });
        }
    }, [
        isFocused,
        ref
    ]);
    var cellDateFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        day: 'numeric',
        timeZone: state.timeZone,
        calendar: date.calendar.identifier
    });
    var formattedDate = (0, $ggE0n.useMemo)(function() {
        return cellDateFormatter.formatToParts(nativeDate).find(function(part) {
            return part.type === 'day';
        }).value;
    }, [
        cellDateFormatter,
        nativeDate
    ]);
    return {
        cellProps: {
            role: 'gridcell',
            'aria-disabled': !isSelectable || undefined,
            'aria-selected': isSelected || undefined,
            'aria-invalid': isInvalid || undefined
        },
        buttonProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(pressProps, {
            onFocus: function() {
                if (!isDisabled) state.setFocusedDate(date);
            },
            tabIndex: tabIndex,
            role: 'button',
            'aria-disabled': !isSelectable || undefined,
            'aria-label': label,
            'aria-invalid': isInvalid || undefined,
            'aria-describedby': [
                isInvalid ? errorMessageId : undefined,
                descriptionProps['aria-describedby']
            ].filter(Boolean).join(' ') || undefined,
            onPointerEnter: function(e) {
                // Highlight the date on hover or drag over a date when selecting a range.
                if ('highlightDate' in state && (e.pointerType !== 'touch' || state.isDragging) && isSelectable) state.highlightDate(date);
            },
            onPointerDown: function(e) {
                // This is necessary on touch devices to allow dragging
                // outside the original pressed element.
                // (JSDOM does not support this)
                if ('releasePointerCapture' in e.target) e.target.releasePointerCapture(e.pointerId);
            },
            onContextMenu: function(e) {
                // Prevent context menu on long press.
                e.preventDefault();
            }
        }),
        isPressed: isPressed,
        isFocused: isFocused,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isUnavailable: isUnavailable,
        isOutsideVisibleRange: date.compare(state.visibleRange.start) < 0 || date.compare(state.visibleRange.end) > 0,
        isInvalid: isInvalid,
        formattedDate: formattedDate
    };
}


var $90NkU = parcelRequire("90NkU");



var $ggE0n = parcelRequire("ggE0n");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $02363c945deddc96$export$cb95147730a423f5(props, state) {
    var tmp = props.startDate, startDate = tmp === void 0 ? state.visibleRange.start : tmp, tmp1 = props.endDate, endDate = tmp1 === void 0 ? state.visibleRange.end : tmp1, firstDayOfWeek = props.firstDayOfWeek;
    var _$NQfxu$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), direction = _$NQfxu$useLocale.direction;
    var onKeyDown = function(e) {
        switch(e.key){
            case 'Enter':
            case ' ':
                e.preventDefault();
                state.selectFocusedDate();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                state.focusPreviousSection(e.shiftKey);
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                state.focusNextSection(e.shiftKey);
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                state.focusSectionEnd();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                state.focusSectionStart();
                break;
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                if (direction === 'rtl') state.focusNextDay();
                else state.focusPreviousDay();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                state.focusPreviousRow();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                if (direction === 'rtl') state.focusPreviousDay();
                else state.focusNextDay();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                state.focusNextRow();
                break;
            case 'Escape':
                // Cancel the selection.
                if ('setAnchorDate' in state) {
                    e.preventDefault();
                    state.setAnchorDate(null);
                }
                break;
        }
    };
    var visibleRangeDescription = (0, $6f9513d1883bda16$export$31afe65d91ef6e8)(startDate, endDate, state.timeZone, true);
    var _$a074e1e2d0f0a665$export$653eddfc964b0f8a_get = (0, $6f9513d1883bda16$export$653eddfc964b0f8a).get(state), ariaLabel = _$a074e1e2d0f0a665$export$653eddfc964b0f8a_get.ariaLabel, ariaLabelledBy = _$a074e1e2d0f0a665$export$653eddfc964b0f8a_get.ariaLabelledBy;
    var labelProps = (0, $c7019d53357f553d$export$d6875122194c7b44)({
        'aria-label': [
            ariaLabel,
            visibleRangeDescription
        ].filter(Boolean).join(', '),
        'aria-labelledby': ariaLabelledBy
    });
    var dayFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        weekday: props.weekdayStyle || 'narrow',
        timeZone: state.timeZone
    });
    var _$NQfxu$useLocale1 = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$NQfxu$useLocale1.locale;
    var weekDays = (0, $ggE0n.useMemo)(function() {
        var weekStart = (0, $b20616b02fb62709$export$42c81a444fbfb5d4)((0, $b20616b02fb62709$export$d0bdf45af03a6ea3)(state.timeZone), locale, firstDayOfWeek);
        return (0, $90NkU._)(new Array(7).keys()).map(function(index) {
            var date = weekStart.add({
                days: index
            });
            var dateDay = date.toDate(state.timeZone);
            return dayFormatter.format(dateDay);
        });
    }, [
        locale,
        state.timeZone,
        dayFormatter,
        firstDayOfWeek
    ]);
    var weeksInMonth = (0, $b20616b02fb62709$export$ccc1b2479e7dd654)(startDate, locale, firstDayOfWeek);
    return {
        gridProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(labelProps, {
            role: 'grid',
            'aria-readonly': state.isReadOnly || undefined,
            'aria-disabled': state.isDisabled || undefined,
            'aria-multiselectable': 'highlightedRange' in state || undefined,
            onKeyDown: onKeyDown,
            onFocus: function() {
                return state.setFocused(true);
            },
            onBlur: function() {
                return state.setFocused(false);
            }
        }),
        headerProps: {
            // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
            // The day names are already included in the label of each cell, so there's no need to announce them twice.
            'aria-hidden': true
        },
        weekDays: weekDays,
        weeksInMonth: weeksInMonth
    };
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a612bb81a65fa99$export$87e0539f600c24e5(props, state, ref) {
    var res = (0, $a03ba0b03b44f054$export$d652b3ea2d672d5b)(props, state);
    // We need to ignore virtual pointer events from VoiceOver due to these bugs.
    // https://bugs.webkit.org/show_bug.cgi?id=222627
    // https://bugs.webkit.org/show_bug.cgi?id=223202
    // usePress also does this and waits for the following click event before firing.
    // We need to match that here otherwise this will fire before the press event in
    // useCalendarCell, causing range selection to not work properly.
    var isVirtualClick = (0, $ggE0n.useRef)(false);
    var windowRef = (0, $ggE0n.useRef)(typeof window !== 'undefined' ? window : null);
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(windowRef, 'pointerdown', function(e) {
        isVirtualClick.current = e.width === 0 && e.height === 0;
    });
    // Stop range selection when pressing or releasing a pointer outside the calendar body,
    // except when pressing the next or previous buttons to switch months.
    var endDragging = function(e) {
        if (isVirtualClick.current) {
            isVirtualClick.current = false;
            return;
        }
        state.setDragging(false);
        if (!state.anchorDate) return;
        var target = e.target;
        if (ref.current && ref.current.contains(document.activeElement) && (!ref.current.contains(target) || !target.closest('button, [role="button"]'))) state.selectFocusedDate();
    };
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(windowRef, 'pointerup', endDragging);
    // Also stop range selection on blur, e.g. tabbing away from the calendar.
    res.calendarProps.onBlur = function(e) {
        if (!ref.current) return;
        if ((!e.relatedTarget || !ref.current.contains(e.relatedTarget)) && state.anchorDate) state.selectFocusedDate();
    };
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(ref, 'touchmove', function(e) {
        if (state.isDragging) e.preventDefault();
    }, {
        passive: false,
        capture: true
    });
    return res;
}



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $h6th5 = parcelRequire("h6th5");
function $62e71e81bcdc057a$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $h6th5._)(object);
        if (object === null) break;
    }
    return object;
}


function $3f4f1a9c447416b5$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $3f4f1a9c447416b5$export$71511d61b312f219 = Reflect.get;
    else $3f4f1a9c447416b5$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $62e71e81bcdc057a$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $3f4f1a9c447416b5$export$71511d61b312f219(target, property, receiver || target);
}



var $h6th5 = parcelRequire("h6th5");

var $83AyS = parcelRequire("83AyS");


var $90NkU = parcelRequire("90NkU");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $b0bc0fb25a87444e$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START = -543;
var $b0bc0fb25a87444e$export$42d20a78301dee44 = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, $83AyS._)($8d73d47422ca7302$export$42d20a78301dee44, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    function $8d73d47422ca7302$export$42d20a78301dee44() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $8d73d47422ca7302$export$42d20a78301dee44);
        var _this;
        _this = (0, $3qQ3j._)(this, $8d73d47422ca7302$export$42d20a78301dee44, (0, $90NkU._)(args)), _this.identifier = 'buddhist';
        return _this;
    }
    (0, $eOJ9o._)($8d73d47422ca7302$export$42d20a78301dee44, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var gregorianDate = (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($8d73d47422ca7302$export$42d20a78301dee44.prototype), "fromJulianDay", this).call(this, jd);
                var year = (0, $acc76a7a17331648$export$c36e0ecb2d4fa69d)(gregorianDate.era, gregorianDate.year);
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, year - $b0bc0fb25a87444e$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($8d73d47422ca7302$export$42d20a78301dee44.prototype), "toJulianDay", this).call(this, $b0bc0fb25a87444e$var$$8d73d47422ca7302$var$toGregorian(date));
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'BE'
                ];
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($8d73d47422ca7302$export$42d20a78301dee44.prototype), "getDaysInMonth", this).call(this, $b0bc0fb25a87444e$var$$8d73d47422ca7302$var$toGregorian(date));
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate() {}
        }
    ]);
    return $8d73d47422ca7302$export$42d20a78301dee44;
}((0, $acc76a7a17331648$export$80ee6245ec4f29ec));
function $b0bc0fb25a87444e$var$$8d73d47422ca7302$var$toGregorian(date) {
    var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $acc76a7a17331648$export$4475b7e617eb123c)(date.year + $b0bc0fb25a87444e$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
    return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(era, year, date.month, date.day);
}



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $83AyS = parcelRequire("83AyS");


var $90NkU = parcelRequire("90NkU");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $586e55003750ed34$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH = 1723856;
var $586e55003750ed34$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
var $586e55003750ed34$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA = 5500;
function $586e55003750ed34$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function $586e55003750ed34$var$$b956b2d7a6cf451f$var$julianDayToCE(epoch, jd) {
    var year = Math.floor(4 * (jd - epoch) / 1461);
    var month = 1 + Math.floor((jd - $586e55003750ed34$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    var day = jd + 1 - $586e55003750ed34$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function $586e55003750ed34$var$$b956b2d7a6cf451f$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $586e55003750ed34$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $586e55003750ed34$var$$b956b2d7a6cf451f$var$getLeapDay(year) + 5;
}
var $586e55003750ed34$export$26ba6eab5e20cd7d = /*#__PURE__*/ function() {
    "use strict";
    function $b956b2d7a6cf451f$export$26ba6eab5e20cd7d() {
        (0, $gpEpt._)(this, $b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
        this.identifier = 'ethiopic';
    }
    (0, $eOJ9o._)($b956b2d7a6cf451f$export$26ba6eab5e20cd7d, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _$b956b2d7a6cf451f$var$julianDayToCE = (0, $c6938abc98c6418f$export$71511d61b312f219)($586e55003750ed34$var$$b956b2d7a6cf451f$var$julianDayToCE($586e55003750ed34$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd), 3), year = _$b956b2d7a6cf451f$var$julianDayToCE[0], month = _$b956b2d7a6cf451f$var$julianDayToCE[1], day = _$b956b2d7a6cf451f$var$julianDayToCE[2];
                var era = 'AM';
                if (year <= 0) {
                    era = 'AA';
                    year += $586e55003750ed34$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
                }
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var year = date.year;
                if (date.era === 'AA') year -= $586e55003750ed34$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
                return $586e55003750ed34$var$$b956b2d7a6cf451f$var$ceToJulianDay($586e55003750ed34$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return $586e55003750ed34$var$$b956b2d7a6cf451f$var$getDaysInMonth(date.year, date.month);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 13;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return 365 + $586e55003750ed34$var$$b956b2d7a6cf451f$var$getLeapDay(date.year);
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // 9999-12-31 gregorian is 9992-20-02 ethiopic.
                // Round down to 9991 for the last full year.
                // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
                return date.era === 'AA' ? 9999 : 9991;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'AA',
                    'AM'
                ];
            }
        }
    ]);
    return $b956b2d7a6cf451f$export$26ba6eab5e20cd7d;
}();
var $586e55003750ed34$export$d72e0c37005a4914 = /*#__PURE__*/ function($b956b2d7a6cf451f$export$26ba6eab5e20cd7d) {
    "use strict";
    (0, $83AyS._)($b956b2d7a6cf451f$export$d72e0c37005a4914, $b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
    function $b956b2d7a6cf451f$export$d72e0c37005a4914() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $b956b2d7a6cf451f$export$d72e0c37005a4914);
        var _this;
        _this = (0, $3qQ3j._)(this, $b956b2d7a6cf451f$export$d72e0c37005a4914, (0, $90NkU._)(args)), _this.identifier = 'ethioaa' // also known as 'ethiopic-amete-alem' in ICU
        ;
        return _this;
    }
    (0, $eOJ9o._)($b956b2d7a6cf451f$export$d72e0c37005a4914, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _$b956b2d7a6cf451f$var$julianDayToCE = (0, $c6938abc98c6418f$export$71511d61b312f219)($586e55003750ed34$var$$b956b2d7a6cf451f$var$julianDayToCE($586e55003750ed34$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd), 3), year = _$b956b2d7a6cf451f$var$julianDayToCE[0], month = _$b956b2d7a6cf451f$var$julianDayToCE[1], day = _$b956b2d7a6cf451f$var$julianDayToCE[2];
                year += $586e55003750ed34$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, 'AA', year, month, day);
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'AA'
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
                return 9999;
            }
        }
    ]);
    return $b956b2d7a6cf451f$export$d72e0c37005a4914;
}($586e55003750ed34$export$26ba6eab5e20cd7d);
var $586e55003750ed34$export$fe6243cbe1a4b7c1 = /*#__PURE__*/ function($b956b2d7a6cf451f$export$26ba6eab5e20cd7d) {
    "use strict";
    (0, $83AyS._)($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1, $b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
    function $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1);
        var _this;
        _this = (0, $3qQ3j._)(this, $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1, (0, $90NkU._)(args)), _this.identifier = 'coptic';
        return _this;
    }
    (0, $eOJ9o._)($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _$b956b2d7a6cf451f$var$julianDayToCE = (0, $c6938abc98c6418f$export$71511d61b312f219)($586e55003750ed34$var$$b956b2d7a6cf451f$var$julianDayToCE($586e55003750ed34$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, jd), 3), year = _$b956b2d7a6cf451f$var$julianDayToCE[0], month = _$b956b2d7a6cf451f$var$julianDayToCE[1], day = _$b956b2d7a6cf451f$var$julianDayToCE[2];
                var era = 'CE';
                if (year <= 0) {
                    era = 'BCE';
                    year = 1 - year;
                }
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var year = date.year;
                if (date.era === 'BCE') year = 1 - year;
                return $586e55003750ed34$var$$b956b2d7a6cf451f$var$ceToJulianDay($586e55003750ed34$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                var year = date.year;
                if (date.era === 'BCE') year = 1 - year;
                return $586e55003750ed34$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === 'BCE';
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                if (date.year <= 0) {
                    date.era = date.era === 'BCE' ? 'CE' : 'BCE';
                    date.year = 1 - date.year;
                }
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'BCE',
                    'CE'
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // 9999-12-30 gregorian is 9716-02-20 coptic.
                // Round down to 9715 for the last full year.
                // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
                return date.era === 'BCE' ? 9999 : 9715;
            }
        }
    ]);
    return $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1;
}($586e55003750ed34$export$26ba6eab5e20cd7d);




var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $6d75e8883d58468e$var$$7c5f6fbf42389787$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
var $6d75e8883d58468e$var$$7c5f6fbf42389787$var$HOUR_PARTS = 1080;
var $6d75e8883d58468e$var$$7c5f6fbf42389787$var$DAY_PARTS = 24 * $6d75e8883d58468e$var$$7c5f6fbf42389787$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
var $6d75e8883d58468e$var$$7c5f6fbf42389787$var$MONTH_DAYS = 29;
var $6d75e8883d58468e$var$$7c5f6fbf42389787$var$MONTH_FRACT = 12 * $6d75e8883d58468e$var$$7c5f6fbf42389787$var$HOUR_PARTS + 793;
var $6d75e8883d58468e$var$$7c5f6fbf42389787$var$MONTH_PARTS = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$MONTH_DAYS * $6d75e8883d58468e$var$$7c5f6fbf42389787$var$DAY_PARTS + $6d75e8883d58468e$var$$7c5f6fbf42389787$var$MONTH_FRACT;
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(year) {
    return (0, $dbab1b4d381c444e$export$842a2cf37af977e1)(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay1(year) {
    var months = Math.floor((235 * year - 234) / 19);
    var parts = 12084 + 13753 * months;
    var day = months * 29 + Math.floor(parts / 25920);
    if ((0, $dbab1b4d381c444e$export$842a2cf37af977e1)(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay2(year) {
    var last = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay1(year - 1);
    var present = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay1(year);
    var next = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$startOfYear(year) {
    return $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay1(year) + $6d75e8883d58468e$var$$7c5f6fbf42389787$var$hebrewDelay2(year);
}
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInYear(year) {
    return $6d75e8883d58468e$var$$7c5f6fbf42389787$var$startOfYear(year + 1) - $6d75e8883d58468e$var$$7c5f6fbf42389787$var$startOfYear(year);
}
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getYearType(year) {
    var yearLength = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    var yearType = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
var $6d75e8883d58468e$export$ca405048b8fb5af = /*#__PURE__*/ function() {
    "use strict";
    function $7c5f6fbf42389787$export$ca405048b8fb5af() {
        (0, $gpEpt._)(this, $7c5f6fbf42389787$export$ca405048b8fb5af);
        this.identifier = 'hebrew';
    }
    (0, $eOJ9o._)($7c5f6fbf42389787$export$ca405048b8fb5af, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var d = jd - $6d75e8883d58468e$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
                var m = d * $6d75e8883d58468e$var$$7c5f6fbf42389787$var$DAY_PARTS / $6d75e8883d58468e$var$$7c5f6fbf42389787$var$MONTH_PARTS; // Months (approx)
                var year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
                var ys = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$startOfYear(year); // 1st day of year
                var dayOfYear = Math.floor(d - ys);
                // Because of the postponement rules, it's possible to guess wrong.  Fix it.
                while(dayOfYear < 1){
                    year--;
                    ys = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$startOfYear(year);
                    dayOfYear = Math.floor(d - ys);
                }
                // Now figure out which month we're in, and the date within that month
                var month = 1;
                var monthStart = 0;
                while(monthStart < dayOfYear){
                    monthStart += $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
                    month++;
                }
                month--;
                monthStart -= $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
                var day = dayOfYear - monthStart;
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var jd = $6d75e8883d58468e$var$$7c5f6fbf42389787$var$startOfYear(date.year);
                for(var month = 1; month < date.month; month++)jd += $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, month);
                return jd + date.day + $6d75e8883d58468e$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, date.month);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear(date) {
                return $6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(date.year) ? 13 : 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return $6d75e8883d58468e$var$$7c5f6fbf42389787$var$getDaysInYear(date.year);
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 6239 gregorian
                return 9999;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'AM'
                ];
            }
        },
        {
            key: "balanceYearMonth",
            value: function balanceYearMonth(date, previousDate) {
                // Keep date in the same month when switching between leap years and non leap years
                if (previousDate.year !== date.year) {
                    if ($6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && !$6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
                    else if (!$6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && $6d75e8883d58468e$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
                }
            }
        }
    ]);
    return $7c5f6fbf42389787$export$ca405048b8fb5af;
}();



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


var $h6th5 = parcelRequire("h6th5");

var $83AyS = parcelRequire("83AyS");


var $90NkU = parcelRequire("90NkU");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
// Starts in 78 AD,
var $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
var $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_YEAR_START = 80;
var $d895e645157bf406$export$39f31c639fa15726 = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, $83AyS._)($82c358003bdda0a8$export$39f31c639fa15726, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    function $82c358003bdda0a8$export$39f31c639fa15726() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $82c358003bdda0a8$export$39f31c639fa15726);
        var _this;
        _this = (0, $3qQ3j._)(this, $82c358003bdda0a8$export$39f31c639fa15726, (0, $90NkU._)(args)), _this.identifier = 'indian';
        return _this;
    }
    (0, $eOJ9o._)($82c358003bdda0a8$export$39f31c639fa15726, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                // Gregorian date for Julian day
                var date = (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($82c358003bdda0a8$export$39f31c639fa15726.prototype), "fromJulianDay", this).call(this, jd);
                // Year in Saka era
                var indianYear = date.year - $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
                // Day number in Gregorian year (starting from 0)
                var yDay = jd - (0, $acc76a7a17331648$export$f297eb839006d339)(date.era, date.year, 1, 1);
                var leapMonth;
                if (yDay < $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_YEAR_START) {
                    //  Day is at the end of the preceding Saka year
                    indianYear--;
                    // Days in leapMonth this year, previous Gregorian year
                    leapMonth = (0, $acc76a7a17331648$export$553d7fa8e3805fc0)(date.year - 1) ? 31 : 30;
                    yDay += leapMonth + 155 + 90 + 10;
                } else {
                    // Days in leapMonth this year
                    leapMonth = (0, $acc76a7a17331648$export$553d7fa8e3805fc0)(date.year) ? 31 : 30;
                    yDay -= $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_YEAR_START;
                }
                var indianMonth;
                var indianDay;
                if (yDay < leapMonth) {
                    indianMonth = 1;
                    indianDay = yDay + 1;
                } else {
                    var mDay = yDay - leapMonth;
                    if (mDay < 155) {
                        indianMonth = Math.floor(mDay / 31) + 2;
                        indianDay = mDay % 31 + 1;
                    } else {
                        mDay -= 155;
                        indianMonth = Math.floor(mDay / 30) + 7;
                        indianDay = mDay % 30 + 1;
                    }
                }
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, indianYear, indianMonth, indianDay);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var extendedYear = date.year + $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
                var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $acc76a7a17331648$export$4475b7e617eb123c)(extendedYear), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
                var leapMonth;
                var jd;
                if ((0, $acc76a7a17331648$export$553d7fa8e3805fc0)(year)) {
                    leapMonth = 31;
                    jd = (0, $acc76a7a17331648$export$f297eb839006d339)(era, year, 3, 21);
                } else {
                    leapMonth = 30;
                    jd = (0, $acc76a7a17331648$export$f297eb839006d339)(era, year, 3, 22);
                }
                if (date.month === 1) return jd + date.day - 1;
                jd += leapMonth + Math.min(date.month - 2, 5) * 31;
                if (date.month >= 8) jd += (date.month - 7) * 30;
                jd += date.day - 1;
                return jd;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.month === 1 && (0, $acc76a7a17331648$export$553d7fa8e3805fc0)(date.year + $d895e645157bf406$var$$82c358003bdda0a8$var$INDIAN_ERA_START)) return 31;
                if (date.month >= 2 && date.month <= 6) return 31;
                return 30;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999-12-31 gregorian is 9920-10-10 indian.
                // Round down to 9919 for the last full year.
                return 9919;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'saka'
                ];
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate() {}
        }
    ]);
    return $82c358003bdda0a8$export$39f31c639fa15726;
}((0, $acc76a7a17331648$export$80ee6245ec4f29ec));



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


var $h6th5 = parcelRequire("h6th5");

var $83AyS = parcelRequire("83AyS");

var $90NkU = parcelRequire("90NkU");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START = 1300;
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END = 1600;
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS = 460322;
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(calendar, epoch, jd) {
    var year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    var month = Math.min(12, Math.ceil((jd - (29 + $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    var day = jd - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(calendar, year, month, day);
}
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
var $e225e2995bc7175f$export$2066795aadd37bfc = /*#__PURE__*/ function() {
    "use strict";
    function $f2f3e0e3a817edbd$export$2066795aadd37bfc() {
        (0, $gpEpt._)(this, $f2f3e0e3a817edbd$export$2066795aadd37bfc);
        this.identifier = 'islamic-civil';
    }
    (0, $eOJ9o._)($f2f3e0e3a817edbd$export$2066795aadd37bfc, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, jd);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, date.year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                var length = 29 + date.month % 2;
                if (date.month === 12 && $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year)) length++;
                return length;
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year) ? 355 : 354;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999 gregorian
                return 9665;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'AH'
                ];
            }
        }
    ]);
    return $f2f3e0e3a817edbd$export$2066795aadd37bfc;
}();
var $e225e2995bc7175f$export$37f0887f2f9d22f7 = /*#__PURE__*/ function($f2f3e0e3a817edbd$export$2066795aadd37bfc) {
    "use strict";
    (0, $83AyS._)($f2f3e0e3a817edbd$export$37f0887f2f9d22f7, $f2f3e0e3a817edbd$export$2066795aadd37bfc);
    function $f2f3e0e3a817edbd$export$37f0887f2f9d22f7() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $f2f3e0e3a817edbd$export$37f0887f2f9d22f7);
        var _this;
        _this = (0, $3qQ3j._)(this, $f2f3e0e3a817edbd$export$37f0887f2f9d22f7, (0, $90NkU._)(args)), _this.identifier = 'islamic-tbla';
        return _this;
    }
    (0, $eOJ9o._)($f2f3e0e3a817edbd$export$37f0887f2f9d22f7, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, jd);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
            }
        }
    ]);
    return $f2f3e0e3a817edbd$export$37f0887f2f9d22f7;
}($e225e2995bc7175f$export$2066795aadd37bfc);
// Generated by scripts/generate-umalqura.js
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA = 'qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=';
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;
var $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year) {
    return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS + $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, month) {
    var idx = year - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;
    var mask = 0x01 << 11 - (month - 1);
    if (($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(year, month) {
    var day = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year);
    for(var i = 1; i < month; i++)day += $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
    return day;
}
function $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearLength(year) {
    return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year + 1 - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
var $e225e2995bc7175f$export$5baab4758c231076 = /*#__PURE__*/ function($f2f3e0e3a817edbd$export$2066795aadd37bfc) {
    "use strict";
    (0, $83AyS._)($f2f3e0e3a817edbd$export$5baab4758c231076, $f2f3e0e3a817edbd$export$2066795aadd37bfc);
    function $f2f3e0e3a817edbd$export$5baab4758c231076() {
        (0, $gpEpt._)(this, $f2f3e0e3a817edbd$export$5baab4758c231076);
        var _this;
        _this = (0, $3qQ3j._)(this, $f2f3e0e3a817edbd$export$5baab4758c231076), _this.identifier = 'islamic-umalqura';
        if (!$e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH) $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA), function(c) {
            return c.charCodeAt(0);
        }).buffer);
        if (!$e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE) {
            $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START + 1);
            var yearStart = 0;
            for(var year = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START; year <= $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END; year++){
                $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] = yearStart;
                for(var i = 1; i <= 12; i++)yearStart += $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
            }
        }
        return _this;
    }
    (0, $eOJ9o._)($f2f3e0e3a817edbd$export$5baab4758c231076, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var days = jd - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC;
                var startDays = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearStart($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);
                var endDays = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearStart($e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);
                if (days < startDays || days > endDays) return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "fromJulianDay", this).call(this, jd);
                else {
                    var y = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START - 1;
                    var m = 1;
                    var d = 1;
                    while(d > 0){
                        y++;
                        d = days - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearStart(y) + 1;
                        var yearLength = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearLength(y);
                        if (d === yearLength) {
                            m = 12;
                            break;
                        } else if (d < yearLength) {
                            var monthLength = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                            m = 1;
                            while(d > monthLength){
                                d -= monthLength;
                                m++;
                                monthLength = $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                            }
                            break;
                        }
                    }
                    return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, y, m, days - $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(y, m) + 1);
                }
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                if (date.year < $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "toJulianDay", this).call(this, date);
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC + $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.year < $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "getDaysInMonth", this).call(this, date);
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(date.year, date.month);
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                if (date.year < $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "getDaysInYear", this).call(this, date);
                return $e225e2995bc7175f$var$$f2f3e0e3a817edbd$var$umalquraYearLength(date.year);
            }
        }
    ]);
    return $f2f3e0e3a817edbd$export$5baab4758c231076;
}($e225e2995bc7175f$export$2066795aadd37bfc);



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


var $h6th5 = parcelRequire("h6th5");

var $83AyS = parcelRequire("83AyS");


var $90NkU = parcelRequire("90NkU");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
var $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
var $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
var $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES = [
    'meiji',
    'taisho',
    'showa',
    'heisei',
    'reiwa'
];
function $77d2fd24c2d4c473$var$$62225008020f0a13$var$findEraFromGregorianDate(date) {
    var idx = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES.findIndex(function(param) {
        var _param = (0, $c6938abc98c6418f$export$71511d61b312f219)(param, 3), year = _param[0], month = _param[1], day = _param[2];
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $77d2fd24c2d4c473$var$$62225008020f0a13$var$toGregorian(date) {
    var eraAddend = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_ADDENDS[$77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error('Unknown era: ' + date.era);
    return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(date.year + eraAddend, date.month, date.day);
}
var $77d2fd24c2d4c473$export$b746ab2b60cdffbf = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, $83AyS._)($62225008020f0a13$export$b746ab2b60cdffbf, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    function $62225008020f0a13$export$b746ab2b60cdffbf() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $62225008020f0a13$export$b746ab2b60cdffbf);
        var _this;
        _this = (0, $3qQ3j._)(this, $62225008020f0a13$export$b746ab2b60cdffbf, (0, $90NkU._)(args)), _this.identifier = 'japanese';
        return _this;
    }
    (0, $eOJ9o._)($62225008020f0a13$export$b746ab2b60cdffbf, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var date = (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "fromJulianDay", this).call(this, jd);
                var era = $77d2fd24c2d4c473$var$$62225008020f0a13$var$findEraFromGregorianDate(date);
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES[era], date.year - $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "toJulianDay", this).call(this, $77d2fd24c2d4c473$var$$62225008020f0a13$var$toGregorian(date));
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                var gregorianDate = $77d2fd24c2d4c473$var$$62225008020f0a13$var$toGregorian(date);
                var era = $77d2fd24c2d4c473$var$$62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
                if ($77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
                    date.era = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES[era];
                    date.year = gregorianDate.year - $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_ADDENDS[era];
                }
                // Constrain in case we went before the first supported era.
                this.constrainDate(date);
            }
        },
        {
            key: "constrainDate",
            value: function constrainDate(date) {
                var idx = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
                var end = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_END_DATES[idx];
                if (end != null) {
                    var _end = (0, $c6938abc98c6418f$export$71511d61b312f219)(end, 3), endYear = _end[0], endMonth = _end[1], endDay = _end[2];
                    // Constrain the year to the maximum possible value in the era.
                    // Then constrain the month and day fields within that.
                    var maxYear = endYear - $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_ADDENDS[idx];
                    date.year = Math.max(1, Math.min(maxYear, date.year));
                    if (date.year === maxYear) {
                        date.month = Math.min(endMonth, date.month);
                        if (date.month === endMonth) date.day = Math.min(endDay, date.day);
                    }
                }
                if (date.year === 1 && idx >= 0) {
                    var _$62225008020f0a13$var$ERA_START_DATES_idx = (0, $c6938abc98c6418f$export$71511d61b312f219)($77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES[idx], 3), startMonth = _$62225008020f0a13$var$ERA_START_DATES_idx[1], startDay = _$62225008020f0a13$var$ERA_START_DATES_idx[2];
                    date.month = Math.max(startMonth, date.month);
                    if (date.month === startMonth) date.day = Math.max(startDay, date.day);
                }
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // Get the number of years in the era, taking into account the date's month and day fields.
                var era = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
                var cur = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES[era];
                var next = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES[era + 1];
                if (next == null) return 9999 - cur[0] + 1;
                var years = next[0] - cur[0];
                if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
                return years;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "getDaysInMonth", this).call(this, $77d2fd24c2d4c473$var$$62225008020f0a13$var$toGregorian(date));
            }
        },
        {
            key: "getMinimumMonthInYear",
            value: function getMinimumMonthInYear(date) {
                var start = $77d2fd24c2d4c473$var$$62225008020f0a13$var$getMinimums(date);
                return start ? start[1] : 1;
            }
        },
        {
            key: "getMinimumDayInMonth",
            value: function getMinimumDayInMonth(date) {
                var start = $77d2fd24c2d4c473$var$$62225008020f0a13$var$getMinimums(date);
                return start && date.month === start[1] ? start[2] : 1;
            }
        }
    ]);
    return $62225008020f0a13$export$b746ab2b60cdffbf;
}((0, $acc76a7a17331648$export$80ee6245ec4f29ec));
function $77d2fd24c2d4c473$var$$62225008020f0a13$var$getMinimums(date) {
    if (date.year === 1) {
        var idx = $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        return $77d2fd24c2d4c473$var$$62225008020f0a13$var$ERA_START_DATES[idx];
    }
}



var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $048cc43969345308$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH = 1948320;
// Number of days from the start of the year to the start of each month.
var $048cc43969345308$var$$f3ed2e4472ae7e25$var$MONTH_START = [
    0,
    31,
    62,
    93,
    124,
    155,
    186,
    216,
    246,
    276,
    306,
    336 // Esfand
];
var $048cc43969345308$export$37fccdbfd14c5939 = /*#__PURE__*/ function() {
    "use strict";
    function $f3ed2e4472ae7e25$export$37fccdbfd14c5939() {
        (0, $gpEpt._)(this, $f3ed2e4472ae7e25$export$37fccdbfd14c5939);
        this.identifier = 'persian';
    }
    (0, $eOJ9o._)($f3ed2e4472ae7e25$export$37fccdbfd14c5939, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var daysSinceEpoch = jd - $048cc43969345308$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH;
                var year = 1 + Math.floor((33 * daysSinceEpoch + 3) / 12053);
                var farvardin1 = 365 * (year - 1) + Math.floor((8 * year + 21) / 33);
                var dayOfYear = daysSinceEpoch - farvardin1;
                var month = dayOfYear < 216 ? Math.floor(dayOfYear / 31) : Math.floor((dayOfYear - 6) / 30);
                var day = dayOfYear - $048cc43969345308$var$$f3ed2e4472ae7e25$var$MONTH_START[month] + 1;
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, year, month + 1, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var jd = $048cc43969345308$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH - 1 + 365 * (date.year - 1) + Math.floor((8 * date.year + 21) / 33);
                jd += $048cc43969345308$var$$f3ed2e4472ae7e25$var$MONTH_START[date.month - 1];
                jd += date.day;
                return jd;
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 12;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.month <= 6) return 31;
                if (date.month <= 11) return 30;
                var isLeapYear = (0, $dbab1b4d381c444e$export$842a2cf37af977e1)(25 * date.year + 11, 33) < 8;
                return isLeapYear ? 30 : 29;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'AP'
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9378-10-10 persian is 9999-12-31 gregorian.
                // Round down to 9377 to set the maximum full year.
                return 9377;
            }
        }
    ]);
    return $f3ed2e4472ae7e25$export$37fccdbfd14c5939;
}();



var $3qQ3j = parcelRequire("3qQ3j");

var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");


var $h6th5 = parcelRequire("h6th5");

var $83AyS = parcelRequire("83AyS");


var $90NkU = parcelRequire("90NkU");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START = 1911;
function $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$gregorianYear(date) {
    return date.era === 'minguo' ? date.year + $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START : 1 - date.year + $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
}
function $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(year) {
    var y = year - $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    if (y > 0) return [
        'minguo',
        y
    ];
    else return [
        'before_minguo',
        1 - y
    ];
}
var $9f5bd800e4c66b54$export$65e01080afcb0799 = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, $83AyS._)($5f31bd6f0c8940b2$export$65e01080afcb0799, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    function $5f31bd6f0c8940b2$export$65e01080afcb0799() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $gpEpt._)(this, $5f31bd6f0c8940b2$export$65e01080afcb0799);
        var _this;
        _this = (0, $3qQ3j._)(this, $5f31bd6f0c8940b2$export$65e01080afcb0799, (0, $90NkU._)(args)), _this.identifier = 'roc' // Republic of China
        ;
        return _this;
    }
    (0, $eOJ9o._)($5f31bd6f0c8940b2$export$65e01080afcb0799, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var date = (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($5f31bd6f0c8940b2$export$65e01080afcb0799.prototype), "fromJulianDay", this).call(this, jd);
                var extendedYear = (0, $acc76a7a17331648$export$c36e0ecb2d4fa69d)(date.era, date.year);
                var _$5f31bd6f0c8940b2$var$gregorianToTaiwan = (0, $c6938abc98c6418f$export$71511d61b312f219)($9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear), 2), era = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[0], year = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[1];
                return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(this, era, year, date.month, date.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($5f31bd6f0c8940b2$export$65e01080afcb0799.prototype), "toJulianDay", this).call(this, $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$toGregorian(date));
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    'before_minguo',
                    'minguo'
                ];
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                var _$5f31bd6f0c8940b2$var$gregorianToTaiwan = (0, $c6938abc98c6418f$export$71511d61b312f219)($9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan($9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$gregorianYear(date)), 2), era = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[0], year = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[1];
                date.era = era;
                date.year = year;
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === 'before_minguo';
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, $3f4f1a9c447416b5$export$71511d61b312f219)((0, $h6th5._)($5f31bd6f0c8940b2$export$65e01080afcb0799.prototype), "getDaysInMonth", this).call(this, $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$toGregorian(date));
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                return date.era === 'before_minguo' ? 9999 : 9999 - $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
            }
        }
    ]);
    return $5f31bd6f0c8940b2$export$65e01080afcb0799;
}((0, $acc76a7a17331648$export$80ee6245ec4f29ec));
function $9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$toGregorian(date) {
    var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $acc76a7a17331648$export$4475b7e617eb123c)($9f5bd800e4c66b54$var$$5f31bd6f0c8940b2$var$gregorianYear(date)), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
    return new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(era, year, date.month, date.day);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $103adbfdbf9a1de6$export$dd0bbc9b26defe37(name) {
    switch(name){
        case 'buddhist':
            return new (0, $b0bc0fb25a87444e$export$42d20a78301dee44)();
        case 'ethiopic':
            return new (0, $586e55003750ed34$export$26ba6eab5e20cd7d)();
        case 'ethioaa':
            return new (0, $586e55003750ed34$export$d72e0c37005a4914)();
        case 'coptic':
            return new (0, $586e55003750ed34$export$fe6243cbe1a4b7c1)();
        case 'hebrew':
            return new (0, $6d75e8883d58468e$export$ca405048b8fb5af)();
        case 'indian':
            return new (0, $d895e645157bf406$export$39f31c639fa15726)();
        case 'islamic-civil':
            return new (0, $e225e2995bc7175f$export$2066795aadd37bfc)();
        case 'islamic-tbla':
            return new (0, $e225e2995bc7175f$export$37f0887f2f9d22f7)();
        case 'islamic-umalqura':
            return new (0, $e225e2995bc7175f$export$5baab4758c231076)();
        case 'japanese':
            return new (0, $77d2fd24c2d4c473$export$b746ab2b60cdffbf)();
        case 'persian':
            return new (0, $048cc43969345308$export$37fccdbfd14c5939)();
        case 'roc':
            return new (0, $9f5bd800e4c66b54$export$65e01080afcb0799)();
        case 'gregory':
        default:
            return new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)();
    }
}



var $2QPpE = parcelRequire("2QPpE");


var $2QPpE = parcelRequire("2QPpE");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea849c48b604d6dd$export$eac50920cf2fd59a(date, minValue, maxValue) {
    return minValue != null && date.compare(minValue) < 0 || maxValue != null && date.compare(maxValue) > 0;
}
function $ea849c48b604d6dd$export$f4a51ff076cc9a09(date, duration, locale, minValue, maxValue) {
    var halfDuration = {};
    for(var key in duration){
        halfDuration[key] = Math.floor(duration[key] / 2);
        if (halfDuration[key] > 0 && duration[key] % 2 === 0) halfDuration[key]--;
    }
    var aligned = $ea849c48b604d6dd$export$144a00ba6044eb9(date, duration, locale).subtract(halfDuration);
    return $ea849c48b604d6dd$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue);
}
function $ea849c48b604d6dd$export$144a00ba6044eb9(date, duration, locale, minValue, maxValue) {
    // align to the start of the largest unit
    var aligned = date;
    if (duration.years) aligned = (0, $b20616b02fb62709$export$f91e89d3d0406102)(date);
    else if (duration.months) aligned = (0, $b20616b02fb62709$export$a5a3b454ada2268e)(date);
    else if (duration.weeks) aligned = (0, $b20616b02fb62709$export$42c81a444fbfb5d4)(date, locale);
    return $ea849c48b604d6dd$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue);
}
function $ea849c48b604d6dd$export$530edbfc915b2b04(date, duration, locale, minValue, maxValue) {
    var d = (0, $2QPpE._)({}, duration);
    // subtract 1 from the smallest unit
    if (d.days) d.days--;
    else if (d.weeks) d.weeks--;
    else if (d.months) d.months--;
    else if (d.years) d.years--;
    var aligned = $ea849c48b604d6dd$export$144a00ba6044eb9(date, duration, locale).subtract(d);
    return $ea849c48b604d6dd$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue);
}
function $ea849c48b604d6dd$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue) {
    if (minValue && date.compare(minValue) >= 0) {
        var newDate = (0, $b20616b02fb62709$export$a75f2bff57811055)(aligned, $ea849c48b604d6dd$export$144a00ba6044eb9((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(minValue), duration, locale));
        if (newDate) aligned = newDate;
    }
    if (maxValue && date.compare(maxValue) <= 0) {
        var newDate1 = (0, $b20616b02fb62709$export$5c333a116e949cdd)(aligned, $ea849c48b604d6dd$export$530edbfc915b2b04((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(maxValue), duration, locale));
        if (newDate1) aligned = newDate1;
    }
    return aligned;
}
function $ea849c48b604d6dd$export$4f5203c0d889109e(date, minValue, maxValue) {
    if (minValue) {
        var newDate = (0, $b20616b02fb62709$export$a75f2bff57811055)(date, (0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(minValue));
        if (newDate) date = newDate;
    }
    if (maxValue) {
        var newDate1 = (0, $b20616b02fb62709$export$5c333a116e949cdd)(date, (0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(maxValue));
        if (newDate1) date = newDate1;
    }
    return date;
}
function $ea849c48b604d6dd$export$a1d3911297b952d7(date, minValue, isDateUnavailable) {
    if (!isDateUnavailable) return date;
    while(date.compare(minValue) >= 0 && isDateUnavailable(date))date = date.subtract({
        days: 1
    });
    if (date.compare(minValue) >= 0) return date;
    return null;
}





var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f90286f6c6997287$export$6d095e787d2b5e1f(props) {
    var defaultFormatter = (0, $ggE0n.useMemo)(function() {
        return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(props.locale);
    }, [
        props.locale
    ]);
    var resolvedOptions = (0, $ggE0n.useMemo)(function() {
        return defaultFormatter.resolvedOptions();
    }, [
        defaultFormatter
    ]);
    var locale = props.locale, createCalendar = props.createCalendar, tmp = props.visibleDuration, visibleDuration = tmp === void 0 ? {
        months: 1
    } : tmp, minValue = props.minValue, maxValue = props.maxValue, selectionAlignment = props.selectionAlignment, isDateUnavailable = props.isDateUnavailable, tmp1 = props.pageBehavior, pageBehavior = tmp1 === void 0 ? 'visible' : tmp1, firstDayOfWeek = props.firstDayOfWeek;
    var calendar = (0, $ggE0n.useMemo)(function() {
        return createCalendar(resolvedOptions.calendar);
    }, [
        createCalendar,
        resolvedOptions.calendar
    ]);
    var _props_defaultValue;
    var _$7G4ZY$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange), 2), value = _$7G4ZY$useControlledState[0], setControlledValue = _$7G4ZY$useControlledState[1];
    var calendarDateValue = (0, $ggE0n.useMemo)(function() {
        return value ? (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(value), calendar) : null;
    }, [
        value,
        calendar
    ]);
    var timeZone = (0, $ggE0n.useMemo)(function() {
        return value && 'timeZone' in value ? value.timeZone : resolvedOptions.timeZone;
    }, [
        value,
        resolvedOptions.timeZone
    ]);
    var focusedCalendarDate = (0, $ggE0n.useMemo)(function() {
        return props.focusedValue ? (0, $ea849c48b604d6dd$export$4f5203c0d889109e)((0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(props.focusedValue), calendar), minValue, maxValue) : undefined;
    }, [
        props.focusedValue,
        calendar,
        minValue,
        maxValue
    ]);
    var defaultFocusedCalendarDate = (0, $ggE0n.useMemo)(function() {
        return (0, $ea849c48b604d6dd$export$4f5203c0d889109e)(props.defaultFocusedValue ? (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(props.defaultFocusedValue), calendar) : calendarDateValue || (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $b20616b02fb62709$export$d0bdf45af03a6ea3)(timeZone), calendar), minValue, maxValue);
    }, [
        props.defaultFocusedValue,
        calendarDateValue,
        timeZone,
        calendar,
        minValue,
        maxValue
    ]);
    var _$7G4ZY$useControlledState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(focusedCalendarDate, defaultFocusedCalendarDate, props.onFocusChange), 2), focusedDate = _$7G4ZY$useControlledState1[0], setFocusedDate = _$7G4ZY$useControlledState1[1];
    var _$7G4ZY$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        switch(selectionAlignment){
            case 'start':
                return (0, $ea849c48b604d6dd$export$144a00ba6044eb9)(focusedDate, visibleDuration, locale, minValue, maxValue);
            case 'end':
                return (0, $ea849c48b604d6dd$export$530edbfc915b2b04)(focusedDate, visibleDuration, locale, minValue, maxValue);
            case 'center':
            default:
                return (0, $ea849c48b604d6dd$export$f4a51ff076cc9a09)(focusedDate, visibleDuration, locale, minValue, maxValue);
        }
    }), 2), startDate = _$7G4ZY$useState[0], setStartDate = _$7G4ZY$useState[1];
    var _$7G4ZY$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(props.autoFocus || false), 2), isFocused = _$7G4ZY$useState1[0], setFocused = _$7G4ZY$useState1[1];
    var endDate = (0, $ggE0n.useMemo)(function() {
        var duration = (0, $2QPpE._)({}, visibleDuration);
        if (duration.days) duration.days--;
        else duration.days = -1;
        return startDate.add(duration);
    }, [
        startDate,
        visibleDuration
    ]);
    // Reset focused date and visible range when calendar changes.
    var _$7G4ZY$useState2 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(calendar), 2), lastCalendar = _$7G4ZY$useState2[0], setLastCalendar = _$7G4ZY$useState2[1];
    if (!(0, $b20616b02fb62709$export$dbc69fd56b53d5e)(calendar, lastCalendar)) {
        var newFocusedDate = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(focusedDate, calendar);
        setStartDate((0, $ea849c48b604d6dd$export$f4a51ff076cc9a09)(newFocusedDate, visibleDuration, locale, minValue, maxValue));
        setFocusedDate(newFocusedDate);
        setLastCalendar(calendar);
    }
    if ((0, $ea849c48b604d6dd$export$eac50920cf2fd59a)(focusedDate, minValue, maxValue)) setFocusedDate((0, $ea849c48b604d6dd$export$4f5203c0d889109e)(focusedDate, minValue, maxValue));
    else if (focusedDate.compare(startDate) < 0) setStartDate((0, $ea849c48b604d6dd$export$530edbfc915b2b04)(focusedDate, visibleDuration, locale, minValue, maxValue));
    else if (focusedDate.compare(endDate) > 0) setStartDate((0, $ea849c48b604d6dd$export$144a00ba6044eb9)(focusedDate, visibleDuration, locale, minValue, maxValue));
    // Sets focus to a specific cell date
    function focusCell(date) {
        date = (0, $ea849c48b604d6dd$export$4f5203c0d889109e)(date, minValue, maxValue);
        setFocusedDate(date);
    }
    function setValue(newValue) {
        if (!props.isDisabled && !props.isReadOnly) {
            var localValue = newValue;
            if (localValue === null) {
                setControlledValue(null);
                return;
            }
            localValue = (0, $ea849c48b604d6dd$export$4f5203c0d889109e)(localValue, minValue, maxValue);
            localValue = (0, $ea849c48b604d6dd$export$a1d3911297b952d7)(localValue, startDate, isDateUnavailable);
            if (!localValue) return;
            // The display calendar should not have any effect on the emitted value.
            // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
            localValue = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(localValue, (value === null || value === void 0 ? void 0 : value.calendar) || new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
            // Preserve time if the input value had one.
            if (value && 'hour' in value) setControlledValue(value.set(localValue));
            else setControlledValue(localValue);
        }
    }
    var isUnavailable = (0, $ggE0n.useMemo)(function() {
        if (!calendarDateValue) return false;
        if (isDateUnavailable && isDateUnavailable(calendarDateValue)) return true;
        return (0, $ea849c48b604d6dd$export$eac50920cf2fd59a)(calendarDateValue, minValue, maxValue);
    }, [
        calendarDateValue,
        isDateUnavailable,
        minValue,
        maxValue
    ]);
    var isValueInvalid = props.isInvalid || props.validationState === 'invalid' || isUnavailable;
    var validationState = isValueInvalid ? 'invalid' : null;
    var pageDuration = (0, $ggE0n.useMemo)(function() {
        if (pageBehavior === 'visible') return visibleDuration;
        return $f90286f6c6997287$var$$131cf43a05231e1e$var$unitDuration(visibleDuration);
    }, [
        pageBehavior,
        visibleDuration
    ]);
    var _props_isDisabled, _props_isReadOnly;
    return {
        isDisabled: (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : false,
        isReadOnly: (_props_isReadOnly = props.isReadOnly) !== null && _props_isReadOnly !== void 0 ? _props_isReadOnly : false,
        value: calendarDateValue,
        setValue: setValue,
        visibleRange: {
            start: startDate,
            end: endDate
        },
        minValue: minValue,
        maxValue: maxValue,
        focusedDate: focusedDate,
        timeZone: timeZone,
        validationState: validationState,
        isValueInvalid: isValueInvalid,
        setFocusedDate: function(date) {
            focusCell(date);
            setFocused(true);
        },
        focusNextDay: function() {
            focusCell(focusedDate.add({
                days: 1
            }));
        },
        focusPreviousDay: function() {
            focusCell(focusedDate.subtract({
                days: 1
            }));
        },
        focusNextRow: function() {
            if (visibleDuration.days) this.focusNextPage();
            else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
                weeks: 1
            }));
        },
        focusPreviousRow: function() {
            if (visibleDuration.days) this.focusPreviousPage();
            else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
                weeks: 1
            }));
        },
        focusNextPage: function() {
            var start = startDate.add(pageDuration);
            setFocusedDate((0, $ea849c48b604d6dd$export$4f5203c0d889109e)(focusedDate.add(pageDuration), minValue, maxValue));
            setStartDate((0, $ea849c48b604d6dd$export$144a00ba6044eb9)((0, $ea849c48b604d6dd$export$5bb865b12696a77d)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
        },
        focusPreviousPage: function() {
            var start = startDate.subtract(pageDuration);
            setFocusedDate((0, $ea849c48b604d6dd$export$4f5203c0d889109e)(focusedDate.subtract(pageDuration), minValue, maxValue));
            setStartDate((0, $ea849c48b604d6dd$export$144a00ba6044eb9)((0, $ea849c48b604d6dd$export$5bb865b12696a77d)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
        },
        focusSectionStart: function() {
            if (visibleDuration.days) focusCell(startDate);
            else if (visibleDuration.weeks) focusCell((0, $b20616b02fb62709$export$42c81a444fbfb5d4)(focusedDate, locale));
            else if (visibleDuration.months || visibleDuration.years) focusCell((0, $b20616b02fb62709$export$a5a3b454ada2268e)(focusedDate));
        },
        focusSectionEnd: function() {
            if (visibleDuration.days) focusCell(endDate);
            else if (visibleDuration.weeks) focusCell((0, $b20616b02fb62709$export$ef8b6d9133084f4e)(focusedDate, locale));
            else if (visibleDuration.months || visibleDuration.years) focusCell((0, $b20616b02fb62709$export$a2258d9c4118825c)(focusedDate));
        },
        focusNextSection: function(larger) {
            if (!larger && !visibleDuration.days) {
                focusCell(focusedDate.add($f90286f6c6997287$var$$131cf43a05231e1e$var$unitDuration(visibleDuration)));
                return;
            }
            if (visibleDuration.days) this.focusNextPage();
            else if (visibleDuration.weeks) focusCell(focusedDate.add({
                months: 1
            }));
            else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
                years: 1
            }));
        },
        focusPreviousSection: function(larger) {
            if (!larger && !visibleDuration.days) {
                focusCell(focusedDate.subtract($f90286f6c6997287$var$$131cf43a05231e1e$var$unitDuration(visibleDuration)));
                return;
            }
            if (visibleDuration.days) this.focusPreviousPage();
            else if (visibleDuration.weeks) focusCell(focusedDate.subtract({
                months: 1
            }));
            else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
                years: 1
            }));
        },
        selectFocusedDate: function() {
            if (!(isDateUnavailable && isDateUnavailable(focusedDate))) setValue(focusedDate);
        },
        selectDate: function(date) {
            setValue(date);
        },
        isFocused: isFocused,
        setFocused: setFocused,
        isInvalid: function(date) {
            return (0, $ea849c48b604d6dd$export$eac50920cf2fd59a)(date, minValue, maxValue);
        },
        isSelected: function(date) {
            return calendarDateValue != null && (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, calendarDateValue) && !this.isCellDisabled(date) && !this.isCellUnavailable(date);
        },
        isCellFocused: function(date) {
            return isFocused && focusedDate && (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, focusedDate);
        },
        isCellDisabled: function(date) {
            return props.isDisabled || date.compare(startDate) < 0 || date.compare(endDate) > 0 || this.isInvalid(date);
        },
        isCellUnavailable: function(date) {
            return props.isDateUnavailable ? props.isDateUnavailable(date) : false;
        },
        isPreviousVisibleRangeInvalid: function() {
            var prev = startDate.subtract({
                days: 1
            });
            return (0, $b20616b02fb62709$export$ea39ec197993aef0)(prev, startDate) || this.isInvalid(prev);
        },
        isNextVisibleRangeInvalid: function() {
            // Adding may return the same date if we reached the end of time
            // according to the calendar system (e.g. 9999-12-31).
            var next = endDate.add({
                days: 1
            });
            return (0, $b20616b02fb62709$export$ea39ec197993aef0)(next, endDate) || this.isInvalid(next);
        },
        getDatesInWeek: function(weekIndex) {
            var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : startDate;
            var date = from.add({
                weeks: weekIndex
            });
            var dates = [];
            date = (0, $b20616b02fb62709$export$42c81a444fbfb5d4)(date, locale, firstDayOfWeek);
            // startOfWeek will clamp dates within the calendar system's valid range, which may
            // start in the middle of a week. In this case, add null placeholders.
            var dayOfWeek = (0, $b20616b02fb62709$export$2061056d06d7cdf7)(date, locale, firstDayOfWeek);
            for(var i = 0; i < dayOfWeek; i++)dates.push(null);
            while(dates.length < 7){
                dates.push(date);
                var nextDate = date.add({
                    days: 1
                });
                if ((0, $b20616b02fb62709$export$ea39ec197993aef0)(date, nextDate)) break;
                date = nextDate;
            }
            // Add null placeholders if at the end of the calendar system.
            while(dates.length < 7)dates.push(null);
            return dates;
        }
    };
}
function $f90286f6c6997287$var$$131cf43a05231e1e$var$unitDuration(duration) {
    var unit = (0, $2QPpE._)({}, duration);
    for(var key in duration)unit[key] = 1;
    return unit;
}


var $2QPpE = parcelRequire("2QPpE");








var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $49bedc2b89874c67$export$9a987164d97ecc90(props) {
    var valueProp = props.value, defaultValue = props.defaultValue, onChange = props.onChange, createCalendar = props.createCalendar, locale = props.locale, tmp = props.visibleDuration, visibleDuration = tmp === void 0 ? {
        months: 1
    } : tmp, minValue = props.minValue, maxValue = props.maxValue, calendarProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "value",
        "defaultValue",
        "onChange",
        "createCalendar",
        "locale",
        "visibleDuration",
        "minValue",
        "maxValue"
    ]);
    var _$d0gbl$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(valueProp, defaultValue || null, onChange), 2), value = _$d0gbl$useControlledState[0], setValue = _$d0gbl$useControlledState[1];
    var _$d0gbl$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), anchorDate = _$d0gbl$useState[0], setAnchorDateState = _$d0gbl$useState[1];
    var alignment = 'center';
    if (value && value.start && value.end) {
        var start = (0, $ea849c48b604d6dd$export$f4a51ff076cc9a09)((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(value.start), visibleDuration, locale, minValue, maxValue);
        var end = start.add(visibleDuration).subtract({
            days: 1
        });
        if (value.end.compare(end) > 0) alignment = 'start';
    }
    // Available range must be stored in a ref so we have access to the updated version immediately in `isInvalid`.
    var availableRangeRef = (0, $ggE0n.useRef)(null);
    var _$d0gbl$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), availableRange = _$d0gbl$useState1[0], setAvailableRange = _$d0gbl$useState1[1];
    var min = (0, $ggE0n.useMemo)(function() {
        return (0, $b20616b02fb62709$export$a75f2bff57811055)(minValue, availableRange === null || availableRange === void 0 ? void 0 : availableRange.start);
    }, [
        minValue,
        availableRange
    ]);
    var max = (0, $ggE0n.useMemo)(function() {
        return (0, $b20616b02fb62709$export$5c333a116e949cdd)(maxValue, availableRange === null || availableRange === void 0 ? void 0 : availableRange.end);
    }, [
        maxValue,
        availableRange
    ]);
    var calendar = (0, $f90286f6c6997287$export$6d095e787d2b5e1f)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, calendarProps), {
        value: value && value.start,
        createCalendar: createCalendar,
        locale: locale,
        visibleDuration: visibleDuration,
        minValue: min,
        maxValue: max,
        selectionAlignment: alignment
    }));
    var updateAvailableRange = function(date) {
        if (date && props.isDateUnavailable && !props.allowsNonContiguousRanges) {
            var nextAvailableStartDate = $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$nextUnavailableDate(date, calendar, -1);
            var nextAvailableEndDate = $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$nextUnavailableDate(date, calendar, 1);
            availableRangeRef.current = {
                start: nextAvailableStartDate,
                end: nextAvailableEndDate
            };
            setAvailableRange(availableRangeRef.current);
        } else {
            availableRangeRef.current = null;
            setAvailableRange(null);
        }
    };
    // If the visible range changes, we need to update the available range.
    var _$d0gbl$useState2 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(calendar.visibleRange), 2), lastVisibleRange = _$d0gbl$useState2[0], setLastVisibleRange = _$d0gbl$useState2[1];
    if (!(0, $b20616b02fb62709$export$91b62ebf2ba703ee)(calendar.visibleRange.start, lastVisibleRange.start) || !(0, $b20616b02fb62709$export$91b62ebf2ba703ee)(calendar.visibleRange.end, lastVisibleRange.end)) {
        updateAvailableRange(anchorDate);
        setLastVisibleRange(calendar.visibleRange);
    }
    var setAnchorDate = function(date) {
        if (date) {
            setAnchorDateState(date);
            updateAvailableRange(date);
        } else {
            setAnchorDateState(null);
            updateAvailableRange(null);
        }
    };
    var highlightedRange = anchorDate ? $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$makeRange(anchorDate, calendar.focusedDate) : value && $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$makeRange(value.start, value.end);
    var selectDate = function(date) {
        if (props.isReadOnly) return;
        var constrainedDate = (0, $ea849c48b604d6dd$export$4f5203c0d889109e)(date, min, max);
        var previousAvailableConstrainedDate = (0, $ea849c48b604d6dd$export$a1d3911297b952d7)(constrainedDate, calendar.visibleRange.start, props.isDateUnavailable);
        if (!previousAvailableConstrainedDate) return;
        if (!anchorDate) setAnchorDate(previousAvailableConstrainedDate);
        else {
            var range = $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$makeRange(anchorDate, previousAvailableConstrainedDate);
            if (range) setValue({
                start: $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$convertValue(range.start, value === null || value === void 0 ? void 0 : value.start),
                end: $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$convertValue(range.end, value === null || value === void 0 ? void 0 : value.end)
            });
            setAnchorDate(null);
        }
    };
    var _$d0gbl$useState3 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(false), 2), isDragging = _$d0gbl$useState3[0], setDragging = _$d0gbl$useState3[1];
    var isDateUnavailable = props.isDateUnavailable;
    var isInvalidSelection = (0, $ggE0n.useMemo)(function() {
        if (!value || anchorDate) return false;
        if (isDateUnavailable && (isDateUnavailable(value.start) || isDateUnavailable(value.end))) return true;
        return (0, $ea849c48b604d6dd$export$eac50920cf2fd59a)(value.start, minValue, maxValue) || (0, $ea849c48b604d6dd$export$eac50920cf2fd59a)(value.end, minValue, maxValue);
    }, [
        isDateUnavailable,
        value,
        anchorDate,
        minValue,
        maxValue
    ]);
    var isValueInvalid = props.isInvalid || props.validationState === 'invalid' || isInvalidSelection;
    var validationState = isValueInvalid ? 'invalid' : null;
    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, calendar), {
        value: value,
        setValue: setValue,
        anchorDate: anchorDate,
        setAnchorDate: setAnchorDate,
        highlightedRange: highlightedRange,
        validationState: validationState,
        isValueInvalid: isValueInvalid,
        selectFocusedDate: function() {
            selectDate(calendar.focusedDate);
        },
        selectDate: selectDate,
        highlightDate: function(date) {
            if (anchorDate) calendar.setFocusedDate(date);
        },
        isSelected: function(date) {
            return Boolean(highlightedRange && date.compare(highlightedRange.start) >= 0 && date.compare(highlightedRange.end) <= 0 && !calendar.isCellDisabled(date) && !calendar.isCellUnavailable(date));
        },
        isInvalid: function(date) {
            var _availableRangeRef_current, _availableRangeRef_current1;
            return calendar.isInvalid(date) || (0, $ea849c48b604d6dd$export$eac50920cf2fd59a)(date, (_availableRangeRef_current = availableRangeRef.current) === null || _availableRangeRef_current === void 0 ? void 0 : _availableRangeRef_current.start, (_availableRangeRef_current1 = availableRangeRef.current) === null || _availableRangeRef_current1 === void 0 ? void 0 : _availableRangeRef_current1.end);
        },
        isDragging: isDragging,
        setDragging: setDragging
    });
}
function $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$makeRange(start, end) {
    if (!start || !end) return null;
    var ref;
    if (end.compare(start) < 0) ref = [
        end,
        start
    ], start = ref[0], end = ref[1], ref;
    return {
        start: (0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(start),
        end: (0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(end)
    };
}
function $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$convertValue(newValue, oldValue) {
    // The display calendar should not have any effect on the emitted value.
    // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
    newValue = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(newValue, (oldValue === null || oldValue === void 0 ? void 0 : oldValue.calendar) || new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
    // Preserve time if the input value had one.
    if (oldValue && 'hour' in oldValue) return oldValue.set(newValue);
    return newValue;
}
function $49bedc2b89874c67$var$$9a36b6ba2fb1a7c5$var$nextUnavailableDate(anchorDate, state, dir) {
    var nextDate = anchorDate.add({
        days: dir
    });
    while((dir < 0 ? nextDate.compare(state.visibleRange.start) >= 0 : nextDate.compare(state.visibleRange.end) <= 0) && !state.isCellUnavailable(nextDate))nextDate = nextDate.add({
        days: dir
    });
    if (state.isCellUnavailable(nextDate)) return nextDate.add({
        days: -dir
    });
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ad6a52d9b4386a70$export$3b805cea1f178355 = (0, $ggE0n.createContext)(null);
var $ad6a52d9b4386a70$export$233dd9682e1ad64b = (0, $ggE0n.createContext)(null);
var $ad6a52d9b4386a70$export$9e31dcedda1dadc7 = (0, $ggE0n.createContext)(null);
var $ad6a52d9b4386a70$export$5e0fc348c00f87a0 = (0, $ggE0n.createContext)(null);
var $ad6a52d9b4386a70$export$e1aef45b828286de = (0, $ggE0n.forwardRef)(function Calendar(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $ad6a52d9b4386a70$export$3b805cea1f178355), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _$dCiKx$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$dCiKx$useLocale.locale;
    var state = (0, $f90286f6c6997287$export$6d095e787d2b5e1f)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        locale: locale,
        createCalendar: props.createCalendar || (0, $103adbfdbf9a1de6$export$dd0bbc9b26defe37)
    }));
    var _$dCiKx$useCalendar = (0, $c173dad03c524184$export$3ee915f8151bd4f1)(props, state), calendarProps = _$dCiKx$useCalendar.calendarProps, prevButtonProps = _$dCiKx$useCalendar.prevButtonProps, nextButtonProps = _$dCiKx$useCalendar.nextButtonProps, errorMessageProps = _$dCiKx$useCalendar.errorMessageProps, title = _$dCiKx$useCalendar.title;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            state: state,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isValueInvalid
        },
        defaultClassName: 'react-aria-Calendar'
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, renderProps, calendarProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": state.isValueInvalid || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $28c5f096242aff4d$export$24d547caef80ccd1),
                {
                    slots: {
                        previous: prevButtonProps,
                        next: nextButtonProps
                    }
                }
            ],
            [
                (0, $0669a7cc0abfc405$export$d688439359537581),
                {
                    'aria-hidden': true,
                    level: 2,
                    children: title
                }
            ],
            [
                $ad6a52d9b4386a70$export$9e31dcedda1dadc7,
                state
            ],
            [
                $ad6a52d9b4386a70$export$3b805cea1f178355,
                props
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $1bc22ae41938fdeb$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("h2", null, calendarProps['aria-label'])), renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $1bc22ae41938fdeb$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("button", {
        "aria-label": nextButtonProps['aria-label'],
        disabled: nextButtonProps.isDisabled,
        onClick: function() {
            return state.focusNextPage();
        },
        tabIndex: -1
    }))));
});
var $ad6a52d9b4386a70$export$a4f5c8b89d277a8d = (0, $ggE0n.forwardRef)(function RangeCalendar(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $ad6a52d9b4386a70$export$233dd9682e1ad64b), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _$dCiKx$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$dCiKx$useLocale.locale;
    var state = (0, $49bedc2b89874c67$export$9a987164d97ecc90)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        locale: locale,
        createCalendar: props.createCalendar || (0, $103adbfdbf9a1de6$export$dd0bbc9b26defe37)
    }));
    var _$dCiKx$useRangeCalendar = (0, $6a612bb81a65fa99$export$87e0539f600c24e5)(props, state, ref), calendarProps = _$dCiKx$useRangeCalendar.calendarProps, prevButtonProps = _$dCiKx$useRangeCalendar.prevButtonProps, nextButtonProps = _$dCiKx$useRangeCalendar.nextButtonProps, errorMessageProps = _$dCiKx$useRangeCalendar.errorMessageProps, title = _$dCiKx$useRangeCalendar.title;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            state: state,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isValueInvalid
        },
        defaultClassName: 'react-aria-RangeCalendar'
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, renderProps, calendarProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": state.isValueInvalid || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                (0, $28c5f096242aff4d$export$24d547caef80ccd1),
                {
                    slots: {
                        previous: prevButtonProps,
                        next: nextButtonProps
                    }
                }
            ],
            [
                (0, $0669a7cc0abfc405$export$d688439359537581),
                {
                    'aria-hidden': true,
                    level: 2,
                    children: title
                }
            ],
            [
                $ad6a52d9b4386a70$export$5e0fc348c00f87a0,
                state
            ],
            [
                $ad6a52d9b4386a70$export$233dd9682e1ad64b,
                props
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $1bc22ae41938fdeb$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("h2", null, calendarProps['aria-label'])), renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $1bc22ae41938fdeb$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("button", {
        "aria-label": nextButtonProps['aria-label'],
        disabled: nextButtonProps.isDisabled,
        onClick: function() {
            return state.focusNextPage();
        },
        tabIndex: -1
    }))));
});
var $ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$InternalCalendarGridContext = (0, $ggE0n.createContext)(null);
var $ad6a52d9b4386a70$export$5bd780d491cfc46c = (0, $ggE0n.forwardRef)(function CalendarGrid(props, ref) {
    var calendarState = (0, $ggE0n.useContext)($ad6a52d9b4386a70$export$9e31dcedda1dadc7);
    var rangeCalendarState = (0, $ggE0n.useContext)($ad6a52d9b4386a70$export$5e0fc348c00f87a0);
    var calenderProps = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)($ad6a52d9b4386a70$export$3b805cea1f178355);
    var rangeCalenderProps = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)($ad6a52d9b4386a70$export$233dd9682e1ad64b);
    var state = calendarState !== null && calendarState !== void 0 ? calendarState : rangeCalendarState;
    var startDate = state.visibleRange.start;
    if (props.offset) startDate = startDate.add(props.offset);
    var _calenderProps_firstDayOfWeek;
    var firstDayOfWeek = (_calenderProps_firstDayOfWeek = calenderProps === null || calenderProps === void 0 ? void 0 : calenderProps.firstDayOfWeek) !== null && _calenderProps_firstDayOfWeek !== void 0 ? _calenderProps_firstDayOfWeek : rangeCalenderProps === null || rangeCalenderProps === void 0 ? void 0 : rangeCalenderProps.firstDayOfWeek;
    var _$dCiKx$useCalendarGrid = (0, $02363c945deddc96$export$cb95147730a423f5)({
        startDate: startDate,
        endDate: (0, $b20616b02fb62709$export$a2258d9c4118825c)(startDate),
        weekdayStyle: props.weekdayStyle,
        firstDayOfWeek: firstDayOfWeek
    }, state), gridProps = _$dCiKx$useCalendarGrid.gridProps, headerProps = _$dCiKx$useCalendarGrid.headerProps, weekDays = _$dCiKx$useCalendarGrid.weekDays, weeksInMonth = _$dCiKx$useCalendarGrid.weeksInMonth;
    var _props_className;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$InternalCalendarGridContext.Provider, {
        value: {
            headerProps: headerProps,
            weekDays: weekDays,
            startDate: startDate,
            weeksInMonth: weeksInMonth
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("table", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), gridProps), {
        ref: ref,
        style: props.style,
        className: (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : 'react-aria-CalendarGrid'
    }), typeof props.children !== 'function' ? props.children : (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($ad6a52d9b4386a70$export$22e2d15eaa4d2377, null, function(day) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($ad6a52d9b4386a70$export$ad2135cac3a11b3d, null, day);
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($ad6a52d9b4386a70$export$e11f8ba65d857bff, null, props.children))));
});
function $ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$CalendarGridHeader(props, ref) {
    var children = props.children, style = props.style, className = props.className;
    var _$dCiKx$useContext = (0, $ggE0n.useContext)($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$InternalCalendarGridContext), headerProps = _$dCiKx$useContext.headerProps, weekDays = _$dCiKx$useContext.weekDays;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("thead", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props), headerProps), {
        ref: ref,
        style: style,
        className: className || 'react-aria-CalendarGridHeader'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("tr", null, weekDays.map(function(day, key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).cloneElement(children(day), {
            key: key
        });
    })));
}
/**
 * A calendar grid header displays a row of week day names at the top of a month.
 */ var $ad6a52d9b4386a70$export$22e2d15eaa4d2377 = (0, $ggE0n.forwardRef)($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$CalendarGridHeader);
function $ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$CalendarHeaderCell(props, ref) {
    var children = props.children, style = props.style, className = props.className;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("th", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props)), {
        ref: ref,
        style: style,
        className: className || 'react-aria-CalendarHeaderCell'
    }), children);
}
/**
 * A calendar header cell displays a week day name at the top of a column within a calendar.
 */ var $ad6a52d9b4386a70$export$ad2135cac3a11b3d = (0, $ggE0n.forwardRef)($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$CalendarHeaderCell);
function $ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$CalendarGridBody(props, ref) {
    var children = props.children, style = props.style, className = props.className;
    var calendarState = (0, $ggE0n.useContext)($ad6a52d9b4386a70$export$9e31dcedda1dadc7);
    var rangeCalendarState = (0, $ggE0n.useContext)($ad6a52d9b4386a70$export$5e0fc348c00f87a0);
    var state = calendarState !== null && calendarState !== void 0 ? calendarState : rangeCalendarState;
    var _$dCiKx$useContext = (0, $ggE0n.useContext)($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$InternalCalendarGridContext), startDate = _$dCiKx$useContext.startDate, weeksInMonth = _$dCiKx$useContext.weeksInMonth;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("tbody", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props)), {
        ref: ref,
        style: style,
        className: className || 'react-aria-CalendarGridBody'
    }), (0, $90NkU._)(new Array(weeksInMonth).keys()).map(function(weekIndex) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("tr", {
            key: weekIndex
        }, state.getDatesInWeek(weekIndex, startDate).map(function(date, i) {
            return date ? (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).cloneElement(children(date), {
                key: i
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("td", {
                key: i
            });
        }));
    }));
}
/**
 * A calendar grid body displays a grid of calendar cells within a month.
 */ var $ad6a52d9b4386a70$export$e11f8ba65d857bff = (0, $ggE0n.forwardRef)($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$CalendarGridBody);
var $ad6a52d9b4386a70$export$5d847498420df57b = (0, $ggE0n.forwardRef)(function CalendarCell(_param, ref) {
    var date = _param.date, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_param, [
        "date"
    ]);
    var calendarState = (0, $ggE0n.useContext)($ad6a52d9b4386a70$export$9e31dcedda1dadc7);
    var rangeCalendarState = (0, $ggE0n.useContext)($ad6a52d9b4386a70$export$5e0fc348c00f87a0);
    var state = calendarState !== null && calendarState !== void 0 ? calendarState : rangeCalendarState;
    var _useContext;
    var _ref = (_useContext = (0, $ggE0n.useContext)($ad6a52d9b4386a70$var$$dfd62f934fc76fed$var$InternalCalendarGridContext)) !== null && _useContext !== void 0 ? _useContext : {
        startDate: state.visibleRange.start
    }, currentMonth = _ref.startDate;
    var buttonRef = (0, $ggE0n.useRef)(null);
    var _$dCiKx$useCalendarCell = (0, $383e466db8fc2eec$export$136073280381448e)({
        date: date
    }, state, buttonRef), cellProps = _$dCiKx$useCalendarCell.cellProps, buttonProps = _$dCiKx$useCalendarCell.buttonProps, states = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$dCiKx$useCalendarCell, [
        "cellProps",
        "buttonProps"
    ]);
    var _$dCiKx$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        isDisabled: states.isDisabled
    })), hoverProps = _$dCiKx$useHover.hoverProps, isHovered = _$dCiKx$useHover.isHovered;
    var _$dCiKx$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)(), focusProps = _$dCiKx$useFocusRing.focusProps, isFocusVisible = _$dCiKx$useFocusRing.isFocusVisible;
    isFocusVisible && (isFocusVisible = states.isFocused);
    var isOutsideMonth = !(0, $b20616b02fb62709$export$a18c89cbd24170ff)(currentMonth, date);
    var isSelectionStart = false;
    var isSelectionEnd = false;
    if ('highlightedRange' in state && state.highlightedRange) {
        isSelectionStart = (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.highlightedRange.start);
        isSelectionEnd = (0, $b20616b02fb62709$export$ea39ec197993aef0)(date, state.highlightedRange.end);
    }
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        defaultChildren: states.formattedDate,
        defaultClassName: 'react-aria-CalendarCell',
        values: (0, $2QPpE._)({
            date: date,
            isHovered: isHovered,
            isOutsideMonth: isOutsideMonth,
            isFocusVisible: isFocusVisible,
            isSelectionStart: isSelectionStart,
            isSelectionEnd: isSelectionEnd
        }, states)
    }));
    var dataAttrs = {
        'data-focused': states.isFocused || undefined,
        'data-hovered': isHovered || undefined,
        'data-pressed': states.isPressed || undefined,
        'data-unavailable': states.isUnavailable || undefined,
        'data-disabled': states.isDisabled || undefined,
        'data-focus-visible': isFocusVisible || undefined,
        'data-outside-visible-range': states.isOutsideVisibleRange || undefined,
        'data-outside-month': isOutsideMonth || undefined,
        'data-selected': states.isSelected || undefined,
        'data-selection-start': isSelectionStart || undefined,
        'data-selection-end': isSelectionEnd || undefined,
        'data-invalid': states.isInvalid || undefined
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("td", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, cellProps), {
        ref: ref
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)((0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(otherProps), buttonProps, focusProps, hoverProps, dataAttrs, renderProps)), {
        ref: buttonRef
    })));
});


var $2QPpE = parcelRequire("2QPpE");







var $2QPpE = parcelRequire("2QPpE");











var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");

var $dcfd84c654dba0a4$export$2e2bcd8739ae039 = {};
$dcfd84c654dba0a4$export$2e2bcd8739ae039 = {
    "calendar": "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
    "day": "\u064A\u0648\u0645",
    "dayPeriod": "\u0635/\u0645",
    "endDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
    "era": "\u0627\u0644\u0639\u0635\u0631",
    "hour": "\u0627\u0644\u0633\u0627\u0639\u0627\u062A",
    "minute": "\u0627\u0644\u062F\u0642\u0627\u0626\u0642",
    "month": "\u0627\u0644\u0634\u0647\u0631",
    "second": "\u0627\u0644\u062B\u0648\u0627\u0646\u064A",
    "selectedDateDescription": function(args) {
        return "\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.startDate, " \u0625\u0644\u0649 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.time);
    },
    "startDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621",
    "timeZoneName": "\u0627\u0644\u062A\u0648\u0642\u064A\u062A",
    "weekday": "\u0627\u0644\u064A\u0648\u0645",
    "year": "\u0627\u0644\u0633\u0646\u0629"
};


var $a5efc6868270995f$export$2e2bcd8739ae039 = {};
$a5efc6868270995f$export$2e2bcd8739ae039 = {
    "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
    "day": "\u0434\u0435\u043D",
    "dayPeriod": "\u043F\u0440.\u043E\u0431./\u0441\u043B.\u043E\u0431.",
    "endDate": "\u041A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430",
    "era": "\u0435\u0440\u0430",
    "hour": "\u0447\u0430\u0441",
    "minute": "\u043C\u0438\u043D\u0443\u0442\u0430",
    "month": "\u043C\u0435\u0441\u0435\u0446",
    "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    "selectedDateDescription": function(args) {
        return "\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate, " \u0434\u043E ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0432\u0440\u0435\u043C\u0435: ".concat(args.time);
    },
    "startDate": "\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0434\u0430\u0442\u0430",
    "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u0430 \u0437\u043E\u043D\u0430",
    "weekday": "\u0434\u0435\u043D \u043E\u0442 \u0441\u0435\u0434\u043C\u0438\u0446\u0430\u0442\u0430",
    "year": "\u0433\u043E\u0434\u0438\u043D\u0430"
};


var $5ac1ec7e1ce3796e$export$2e2bcd8739ae039 = {};
$5ac1ec7e1ce3796e$export$2e2bcd8739ae039 = {
    "calendar": "Kalend\xe1\u0159",
    "day": "den",
    "dayPeriod": "\u010D\xe1st dne",
    "endDate": "Kone\u010Dn\xe9 datum",
    "era": "letopo\u010Det",
    "hour": "hodina",
    "minute": "minuta",
    "month": "m\u011Bs\xedc",
    "second": "sekunda",
    "selectedDateDescription": function(args) {
        return "Vybran\xe9 datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Vybran\xe9 obdob\xed: ".concat(args.startDate, " a\u017E ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Vybran\xfd \u010Das: ".concat(args.time);
    },
    "startDate": "Po\u010D\xe1te\u010Dn\xed datum",
    "timeZoneName": "\u010Dasov\xe9 p\xe1smo",
    "weekday": "den v t\xfddnu",
    "year": "rok"
};


var $309f080d2c601b08$export$2e2bcd8739ae039 = {};
$309f080d2c601b08$export$2e2bcd8739ae039 = {
    "calendar": "Kalender",
    "day": "dag",
    "dayPeriod": "AM/PM",
    "endDate": "Slutdato",
    "era": "\xe6ra",
    "hour": "time",
    "minute": "minut",
    "month": "m\xe5ned",
    "second": "sekund",
    "selectedDateDescription": function(args) {
        return "Valgt dato: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valgt interval: ".concat(args.startDate, " til ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Valgt tidspunkt: ".concat(args.time);
    },
    "startDate": "Startdato",
    "timeZoneName": "tidszone",
    "weekday": "ugedag",
    "year": "\xe5r"
};


var $011ca9bef6c34af2$export$2e2bcd8739ae039 = {};
$011ca9bef6c34af2$export$2e2bcd8739ae039 = {
    "calendar": "Kalender",
    "day": "Tag",
    "dayPeriod": "Tagesh\xe4lfte",
    "endDate": "Enddatum",
    "era": "Epoche",
    "hour": "Stunde",
    "minute": "Minute",
    "month": "Monat",
    "second": "Sekunde",
    "selectedDateDescription": function(args) {
        return "Ausgew\xe4hltes Datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Ausgew\xe4hlter Bereich: ".concat(args.startDate, " bis ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Ausgew\xe4hlte Zeit: ".concat(args.time);
    },
    "startDate": "Anfangsdatum",
    "timeZoneName": "Zeitzone",
    "weekday": "Wochentag",
    "year": "Jahr"
};


var $47d509c22073c185$export$2e2bcd8739ae039 = {};
$47d509c22073c185$export$2e2bcd8739ae039 = {
    "calendar": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF",
    "day": "\u03B7\u03BC\u03AD\u03C1\u03B1",
    "dayPeriod": "\u03C0.\u03BC./\u03BC.\u03BC.",
    "endDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
    "era": "\u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2",
    "hour": "\u03CE\u03C1\u03B1",
    "minute": "\u03BB\u03B5\u03C0\u03C4\u03CC",
    "month": "\u03BC\u03AE\u03BD\u03B1\u03C2",
    "second": "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    "selectedDateDescription": function(args) {
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.startDate, " \u03AD\u03C9\u03C2 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03CE\u03C1\u03B1: ".concat(args.time);
    },
    "startDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2",
    "timeZoneName": "\u03B6\u03CE\u03BD\u03B7 \u03CE\u03C1\u03B1\u03C2",
    "weekday": "\u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE",
    "year": "\u03AD\u03C4\u03BF\u03C2"
};


var $d99f3b69f70ff462$export$2e2bcd8739ae039 = {};
$d99f3b69f70ff462$export$2e2bcd8739ae039 = {
    "era": "era",
    "year": "year",
    "month": "month",
    "day": "day",
    "hour": "hour",
    "minute": "minute",
    "second": "second",
    "dayPeriod": "AM/PM",
    "calendar": "Calendar",
    "startDate": "Start Date",
    "endDate": "End Date",
    "weekday": "day of the week",
    "timeZoneName": "time zone",
    "selectedDateDescription": function(args) {
        return "Selected Date: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Selected Range: ".concat(args.startDate, " to ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Selected Time: ".concat(args.time);
    }
};


var $bd38665c35f605e2$export$2e2bcd8739ae039 = {};
$bd38665c35f605e2$export$2e2bcd8739ae039 = {
    "calendar": "Calendario",
    "day": "d\xeda",
    "dayPeriod": "a.\xa0m./p.\xa0m.",
    "endDate": "Fecha final",
    "era": "era",
    "hour": "hora",
    "minute": "minuto",
    "month": "mes",
    "second": "segundo",
    "selectedDateDescription": function(args) {
        return "Fecha seleccionada: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Rango seleccionado: ".concat(args.startDate, " a ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Hora seleccionada: ".concat(args.time);
    },
    "startDate": "Fecha de inicio",
    "timeZoneName": "zona horaria",
    "weekday": "d\xeda de la semana",
    "year": "a\xf1o"
};


var $ea87f1d97e2dbe34$export$2e2bcd8739ae039 = {};
$ea87f1d97e2dbe34$export$2e2bcd8739ae039 = {
    "calendar": "Kalender",
    "day": "p\xe4ev",
    "dayPeriod": "enne/p\xe4rast l\xf5unat",
    "endDate": "L\xf5ppkuup\xe4ev",
    "era": "ajastu",
    "hour": "tund",
    "minute": "minut",
    "month": "kuu",
    "second": "sekund",
    "selectedDateDescription": function(args) {
        return "Valitud kuup\xe4ev: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valitud vahemik: ".concat(args.startDate, " kuni ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Valitud aeg: ".concat(args.time);
    },
    "startDate": "Alguskuup\xe4ev",
    "timeZoneName": "ajav\xf6\xf6nd",
    "weekday": "n\xe4dalap\xe4ev",
    "year": "aasta"
};


var $0bf59fa6c574c74e$export$2e2bcd8739ae039 = {};
$0bf59fa6c574c74e$export$2e2bcd8739ae039 = {
    "calendar": "Kalenteri",
    "day": "p\xe4iv\xe4",
    "dayPeriod": "vuorokaudenaika",
    "endDate": "P\xe4\xe4ttymisp\xe4iv\xe4",
    "era": "aikakausi",
    "hour": "tunti",
    "minute": "minuutti",
    "month": "kuukausi",
    "second": "sekunti",
    "selectedDateDescription": function(args) {
        return "Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valittu aikav\xe4li: ".concat(args.startDate, " \u2013 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Valittu aika: ".concat(args.time);
    },
    "startDate": "Alkamisp\xe4iv\xe4",
    "timeZoneName": "aikavy\xf6hyke",
    "weekday": "viikonp\xe4iv\xe4",
    "year": "vuosi"
};


var $32de43492d0a62ca$export$2e2bcd8739ae039 = {};
$32de43492d0a62ca$export$2e2bcd8739ae039 = {
    "calendar": "Calendrier",
    "day": "jour",
    "dayPeriod": "cadran",
    "endDate": "Date de fin",
    "era": "\xe8re",
    "hour": "heure",
    "minute": "minute",
    "month": "mois",
    "second": "seconde",
    "selectedDateDescription": function(args) {
        return "Date s\xe9lectionn\xe9e\xa0: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Plage s\xe9lectionn\xe9e\xa0: ".concat(args.startDate, " au ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Heure choisie\xa0: ".concat(args.time);
    },
    "startDate": "Date de d\xe9but",
    "timeZoneName": "fuseau horaire",
    "weekday": "jour de la semaine",
    "year": "ann\xe9e"
};


var $83ccdc942ca904ca$export$2e2bcd8739ae039 = {};
$83ccdc942ca904ca$export$2e2bcd8739ae039 = {
    "calendar": "\u05DC\u05D5\u05D7 \u05E9\u05E0\u05D4",
    "day": "\u05D9\u05D5\u05DD",
    "dayPeriod": "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6/\u05D0\u05D7\u05D4\u05F4\u05E6",
    "endDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E1\u05D9\u05D5\u05DD",
    "era": "\u05EA\u05E7\u05D5\u05E4\u05D4",
    "hour": "\u05E9\u05E2\u05D4",
    "minute": "\u05D3\u05E7\u05D4",
    "month": "\u05D7\u05D5\u05D3\u05E9",
    "second": "\u05E9\u05E0\u05D9\u05D9\u05D4",
    "selectedDateDescription": function(args) {
        return "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.startDate, " \u05E2\u05D3 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u05D6\u05DE\u05DF \u05E0\u05D1\u05D7\u05E8: ".concat(args.time);
    },
    "startDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05EA\u05D7\u05DC\u05D4",
    "timeZoneName": "\u05D0\u05D6\u05D5\u05E8 \u05D6\u05DE\u05DF",
    "weekday": "\u05D9\u05D5\u05DD \u05D1\u05E9\u05D1\u05D5\u05E2",
    "year": "\u05E9\u05E0\u05D4"
};


var $329280a02570e49e$export$2e2bcd8739ae039 = {};
$329280a02570e49e$export$2e2bcd8739ae039 = {
    "calendar": "Kalendar",
    "day": "dan",
    "dayPeriod": "AM/PM",
    "endDate": "Datum zavr\u0161etka",
    "era": "era",
    "hour": "sat",
    "minute": "minuta",
    "month": "mjesec",
    "second": "sekunda",
    "selectedDateDescription": function(args) {
        return "Odabrani datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Odabrani raspon: ".concat(args.startDate, " do ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Odabrano vrijeme: ".concat(args.time);
    },
    "startDate": "Datum po\u010Detka",
    "timeZoneName": "vremenska zona",
    "weekday": "dan u tjednu",
    "year": "godina"
};


var $b5e60d41efa61015$export$2e2bcd8739ae039 = {};
$b5e60d41efa61015$export$2e2bcd8739ae039 = {
    "calendar": "Napt\xe1r",
    "day": "nap",
    "dayPeriod": "napszak",
    "endDate": "Befejez\u0151 d\xe1tum",
    "era": "\xe9ra",
    "hour": "\xf3ra",
    "minute": "perc",
    "month": "h\xf3nap",
    "second": "m\xe1sodperc",
    "selectedDateDescription": function(args) {
        return "Kijel\xf6lt d\xe1tum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Kijel\xf6lt tartom\xe1ny: ".concat(args.startDate, "\u2013").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Kijel\xf6lt id\u0151: ".concat(args.time);
    },
    "startDate": "Kezd\u0151 d\xe1tum",
    "timeZoneName": "id\u0151z\xf3na",
    "weekday": "h\xe9t napja",
    "year": "\xe9v"
};


var $8e60d05bacc75770$export$2e2bcd8739ae039 = {};
$8e60d05bacc75770$export$2e2bcd8739ae039 = {
    "calendar": "Calendario",
    "day": "giorno",
    "dayPeriod": "AM/PM",
    "endDate": "Data finale",
    "era": "era",
    "hour": "ora",
    "minute": "minuto",
    "month": "mese",
    "second": "secondo",
    "selectedDateDescription": function(args) {
        return "Data selezionata: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervallo selezionato: da ".concat(args.startDate, " a ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Ora selezionata: ".concat(args.time);
    },
    "startDate": "Data iniziale",
    "timeZoneName": "fuso orario",
    "weekday": "giorno della settimana",
    "year": "anno"
};


var $a903f3bd1d7c1757$export$2e2bcd8739ae039 = {};
$a903f3bd1d7c1757$export$2e2bcd8739ae039 = {
    "calendar": "\u30AB\u30EC\u30F3\u30C0\u30FC",
    "day": "\u65E5",
    "dayPeriod": "\u5348\u524D/\u5348\u5F8C",
    "endDate": "\u7D42\u4E86\u65E5",
    "era": "\u6642\u4EE3",
    "hour": "\u6642",
    "minute": "\u5206",
    "month": "\u6708",
    "second": "\u79D2",
    "selectedDateDescription": function(args) {
        return "\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u9078\u629E\u7BC4\u56F2 : ".concat(args.startDate, " \u304B\u3089 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u9078\u629E\u3057\u305F\u6642\u9593 : ".concat(args.time);
    },
    "startDate": "\u958B\u59CB\u65E5",
    "timeZoneName": "\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3",
    "weekday": "\u66DC\u65E5",
    "year": "\u5E74"
};


var $a6c5d30e0b165204$export$2e2bcd8739ae039 = {};
$a6c5d30e0b165204$export$2e2bcd8739ae039 = {
    "calendar": "\uB2EC\uB825",
    "day": "\uC77C",
    "dayPeriod": "\uC624\uC804/\uC624\uD6C4",
    "endDate": "\uC885\uB8CC\uC77C",
    "era": "\uC5F0\uD638",
    "hour": "\uC2DC",
    "minute": "\uBD84",
    "month": "\uC6D4",
    "second": "\uCD08",
    "selectedDateDescription": function(args) {
        return "\uC120\uD0DD \uC77C\uC790: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\uC120\uD0DD \uBC94\uC704: ".concat(args.startDate, " ~ ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\uC120\uD0DD \uC2DC\uAC04: ".concat(args.time);
    },
    "startDate": "\uC2DC\uC791\uC77C",
    "timeZoneName": "\uC2DC\uAC04\uB300",
    "weekday": "\uC694\uC77C",
    "year": "\uB144"
};


var $5a9eb117c71e40b6$export$2e2bcd8739ae039 = {};
$5a9eb117c71e40b6$export$2e2bcd8739ae039 = {
    "calendar": "Kalendorius",
    "day": "diena",
    "dayPeriod": "iki piet\u0173 / po piet\u0173",
    "endDate": "Pabaigos data",
    "era": "era",
    "hour": "valanda",
    "minute": "minut\u0117",
    "month": "m\u0117nuo",
    "second": "sekund\u0117",
    "selectedDateDescription": function(args) {
        return "Pasirinkta data: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Pasirinktas intervalas: nuo ".concat(args.startDate, " iki ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Pasirinktas laikas: ".concat(args.time);
    },
    "startDate": "Prad\u017Eios data",
    "timeZoneName": "laiko juosta",
    "weekday": "savait\u0117s diena",
    "year": "metai"
};


var $cf1edc403144c8ef$export$2e2bcd8739ae039 = {};
$cf1edc403144c8ef$export$2e2bcd8739ae039 = {
    "calendar": "Kalend\u0101rs",
    "day": "diena",
    "dayPeriod": "priek\u0161pusdien\u0101/p\u0113cpusdien\u0101",
    "endDate": "Beigu datums",
    "era": "\u0113ra",
    "hour": "stundas",
    "minute": "min\u016Btes",
    "month": "m\u0113nesis",
    "second": "sekundes",
    "selectedDateDescription": function(args) {
        return "Atlas\u012Btais datums: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Atlas\u012Btais diapazons: no ".concat(args.startDate, " l\u012Bdz ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Atlas\u012Btais laiks: ".concat(args.time);
    },
    "startDate": "S\u0101kuma datums",
    "timeZoneName": "laika josla",
    "weekday": "ned\u0113\u013Cas diena",
    "year": "gads"
};


var $54bdf0061cb97a0a$export$2e2bcd8739ae039 = {};
$54bdf0061cb97a0a$export$2e2bcd8739ae039 = {
    "calendar": "Kalender",
    "day": "dag",
    "dayPeriod": "a.m./p.m.",
    "endDate": "Sluttdato",
    "era": "tidsalder",
    "hour": "time",
    "minute": "minutt",
    "month": "m\xe5ned",
    "second": "sekund",
    "selectedDateDescription": function(args) {
        return "Valgt dato: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valgt omr\xe5de: ".concat(args.startDate, " til ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Valgt tid: ".concat(args.time);
    },
    "startDate": "Startdato",
    "timeZoneName": "tidssone",
    "weekday": "ukedag",
    "year": "\xe5r"
};


var $337c5158c1fea7a9$export$2e2bcd8739ae039 = {};
$337c5158c1fea7a9$export$2e2bcd8739ae039 = {
    "calendar": "Kalender",
    "day": "dag",
    "dayPeriod": "a.m./p.m.",
    "endDate": "Einddatum",
    "era": "tijdperk",
    "hour": "uur",
    "minute": "minuut",
    "month": "maand",
    "second": "seconde",
    "selectedDateDescription": function(args) {
        return "Geselecteerde datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Geselecteerd bereik: ".concat(args.startDate, " tot ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Geselecteerde tijd: ".concat(args.time);
    },
    "startDate": "Startdatum",
    "timeZoneName": "tijdzone",
    "weekday": "dag van de week",
    "year": "jaar"
};


var $849ba821d0b7acf0$export$2e2bcd8739ae039 = {};
$849ba821d0b7acf0$export$2e2bcd8739ae039 = {
    "calendar": "Kalendarz",
    "day": "dzie\u0144",
    "dayPeriod": "rano / po po\u0142udniu / wieczorem",
    "endDate": "Data ko\u0144cowa",
    "era": "era",
    "hour": "godzina",
    "minute": "minuta",
    "month": "miesi\u0105c",
    "second": "sekunda",
    "selectedDateDescription": function(args) {
        return "Wybrana data: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Wybrany zakres: ".concat(args.startDate, " do ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Wybrany czas: ".concat(args.time);
    },
    "startDate": "Data pocz\u0105tkowa",
    "timeZoneName": "strefa czasowa",
    "weekday": "dzie\u0144 tygodnia",
    "year": "rok"
};


var $1cdd952197be101e$export$2e2bcd8739ae039 = {};
$1cdd952197be101e$export$2e2bcd8739ae039 = {
    "calendar": "Calend\xe1rio",
    "day": "dia",
    "dayPeriod": "AM/PM",
    "endDate": "Data final",
    "era": "era",
    "hour": "hora",
    "minute": "minuto",
    "month": "m\xeas",
    "second": "segundo",
    "selectedDateDescription": function(args) {
        return "Data selecionada: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervalo selecionado: ".concat(args.startDate, " a ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Hora selecionada: ".concat(args.time);
    },
    "startDate": "Data inicial",
    "timeZoneName": "fuso hor\xe1rio",
    "weekday": "dia da semana",
    "year": "ano"
};


var $512b00eb79d01762$export$2e2bcd8739ae039 = {};
$512b00eb79d01762$export$2e2bcd8739ae039 = {
    "calendar": "Calend\xe1rio",
    "day": "dia",
    "dayPeriod": "am/pm",
    "endDate": "Data de T\xe9rmino",
    "era": "era",
    "hour": "hora",
    "minute": "minuto",
    "month": "m\xeas",
    "second": "segundo",
    "selectedDateDescription": function(args) {
        return "Data selecionada: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Intervalo selecionado: ".concat(args.startDate, " a ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Hora selecionada: ".concat(args.time);
    },
    "startDate": "Data de In\xedcio",
    "timeZoneName": "fuso hor\xe1rio",
    "weekday": "dia da semana",
    "year": "ano"
};


var $1bf243546944cab4$export$2e2bcd8739ae039 = {};
$1bf243546944cab4$export$2e2bcd8739ae039 = {
    "calendar": "Calendar",
    "day": "zi",
    "dayPeriod": "a.m/p.m.",
    "endDate": "Dat\u0103 final",
    "era": "er\u0103",
    "hour": "or\u0103",
    "minute": "minut",
    "month": "lun\u0103",
    "second": "secund\u0103",
    "selectedDateDescription": function(args) {
        return "Dat\u0103 selectat\u0103: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Interval selectat: de la ".concat(args.startDate, " p\xe2n\u0103 la ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Ora selectat\u0103: ".concat(args.time);
    },
    "startDate": "Dat\u0103 \xeenceput",
    "timeZoneName": "fus orar",
    "weekday": "ziua din s\u0103pt\u0103m\xe2n\u0103",
    "year": "an"
};


var $669d99522d8fe944$export$2e2bcd8739ae039 = {};
$669d99522d8fe944$export$2e2bcd8739ae039 = {
    "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C",
    "day": "\u0434\u0435\u043D\u044C",
    "dayPeriod": "AM/PM",
    "endDate": "\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F",
    "era": "\u044D\u0440\u0430",
    "hour": "\u0447\u0430\u0441",
    "minute": "\u043C\u0438\u043D\u0443\u0442\u0430",
    "month": "\u043C\u0435\u0441\u044F\u0446",
    "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    "selectedDateDescription": function(args) {
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: \u0441 ".concat(args.startDate, " \u043F\u043E ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F: ".concat(args.time);
    },
    "startDate": "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430",
    "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441",
    "weekday": "\u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438",
    "year": "\u0433\u043E\u0434"
};


var $ebccf2147ebd9ce2$export$2e2bcd8739ae039 = {};
$ebccf2147ebd9ce2$export$2e2bcd8739ae039 = {
    "calendar": "Kalend\xe1r",
    "day": "de\u0148",
    "dayPeriod": "AM/PM",
    "endDate": "D\xe1tum ukon\u010Denia",
    "era": "letopo\u010Det",
    "hour": "hodina",
    "minute": "min\xfata",
    "month": "mesiac",
    "second": "sekunda",
    "selectedDateDescription": function(args) {
        return "Vybrat\xfd d\xe1tum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Vybrat\xfd rozsah: od ".concat(args.startDate, " do ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Vybrat\xfd \u010Das: ".concat(args.time);
    },
    "startDate": "D\xe1tum za\u010Datia",
    "timeZoneName": "\u010Dasov\xe9 p\xe1smo",
    "weekday": "de\u0148 t\xfd\u017Ed\u0148a",
    "year": "rok"
};


var $e4894d8cf2bbb298$export$2e2bcd8739ae039 = {};
$e4894d8cf2bbb298$export$2e2bcd8739ae039 = {
    "calendar": "Koledar",
    "day": "dan",
    "dayPeriod": "dop/pop",
    "endDate": "Datum konca",
    "era": "doba",
    "hour": "ura",
    "minute": "minuta",
    "month": "mesec",
    "second": "sekunda",
    "selectedDateDescription": function(args) {
        return "Izbrani datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Izbrano obmo\u010Dje: ".concat(args.startDate, " do ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Izbrani \u010Das: ".concat(args.time);
    },
    "startDate": "Datum za\u010Detka",
    "timeZoneName": "\u010Dasovni pas",
    "weekday": "dan v tednu",
    "year": "leto"
};


var $0bf2894840aec79e$export$2e2bcd8739ae039 = {};
$0bf2894840aec79e$export$2e2bcd8739ae039 = {
    "calendar": "Kalendar",
    "day": "\u0434\u0430\u043D",
    "dayPeriod": "\u043F\u0440\u0435 \u043F\u043E\u0434\u043D\u0435/\u043F\u043E \u043F\u043E\u0434\u043D\u0435",
    "endDate": "Datum zavr\u0161etka",
    "era": "\u0435\u0440\u0430",
    "hour": "\u0441\u0430\u0442",
    "minute": "\u043C\u0438\u043D\u0443\u0442",
    "month": "\u043C\u0435\u0441\u0435\u0446",
    "second": "\u0441\u0435\u043A\u0443\u043D\u0434",
    "selectedDateDescription": function(args) {
        return "Izabrani datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Izabrani opseg: od ".concat(args.startDate, " do ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Izabrano vreme: ".concat(args.time);
    },
    "startDate": "Datum po\u010Detka",
    "timeZoneName": "\u0432\u0440\u0435\u043C\u0435\u043D\u0441\u043A\u0430 \u0437\u043E\u043D\u0430",
    "weekday": "\u0434\u0430\u043D \u0443 \u043D\u0435\u0434\u0435\u0459\u0438",
    "year": "\u0433\u043E\u0434\u0438\u043D\u0430"
};


var $1e173a061e7f0ca5$export$2e2bcd8739ae039 = {};
$1e173a061e7f0ca5$export$2e2bcd8739ae039 = {
    "calendar": "Kalender",
    "day": "dag",
    "dayPeriod": "fm/em",
    "endDate": "Slutdatum",
    "era": "era",
    "hour": "timme",
    "minute": "minut",
    "month": "m\xe5nad",
    "second": "sekund",
    "selectedDateDescription": function(args) {
        return "Valt datum: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Valt intervall: ".concat(args.startDate, " till ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Vald tid: ".concat(args.time);
    },
    "startDate": "Startdatum",
    "timeZoneName": "tidszon",
    "weekday": "veckodag",
    "year": "\xe5r"
};


var $aa9e73a4aa3b83e8$export$2e2bcd8739ae039 = {};
$aa9e73a4aa3b83e8$export$2e2bcd8739ae039 = {
    "calendar": "Takvim",
    "day": "g\xfcn",
    "dayPeriod": "\xd6\xd6/\xd6S",
    "endDate": "Biti\u015F Tarihi",
    "era": "\xe7a\u011F",
    "hour": "saat",
    "minute": "dakika",
    "month": "ay",
    "second": "saniye",
    "selectedDateDescription": function(args) {
        return "Se\xe7ilen Tarih: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "Se\xe7ilen Aral\u0131k: ".concat(args.startDate, " - ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "Se\xe7ilen Zaman: ".concat(args.time);
    },
    "startDate": "Ba\u015Flang\u0131\xe7 Tarihi",
    "timeZoneName": "saat dilimi",
    "weekday": "haftan\u0131n g\xfcn\xfc",
    "year": "y\u0131l"
};


var $e187385e43bb2712$export$2e2bcd8739ae039 = {};
$e187385e43bb2712$export$2e2bcd8739ae039 = {
    "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
    "day": "\u0434\u0435\u043D\u044C",
    "dayPeriod": "\u0434\u043F/\u043F\u043F",
    "endDate": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
    "era": "\u0435\u0440\u0430",
    "hour": "\u0433\u043E\u0434\u0438\u043D\u0430",
    "minute": "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
    "month": "\u043C\u0456\u0441\u044F\u0446\u044C",
    "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    "selectedDateDescription": function(args) {
        return "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate, " \u2014 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0447\u0430\u0441: ".concat(args.time);
    },
    "startDate": "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
    "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441",
    "weekday": "\u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F",
    "year": "\u0440\u0456\u043A"
};


var $f6812808a23d3b66$export$2e2bcd8739ae039 = {};
$f6812808a23d3b66$export$2e2bcd8739ae039 = {
    "calendar": "\u65E5\u5386",
    "day": "\u65E5",
    "dayPeriod": "\u4E0A\u5348/\u4E0B\u5348",
    "endDate": "\u7ED3\u675F\u65E5\u671F",
    "era": "\u7EAA\u5143",
    "hour": "\u5C0F\u65F6",
    "minute": "\u5206\u949F",
    "month": "\u6708",
    "second": "\u79D2",
    "selectedDateDescription": function(args) {
        return "\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.startDate, " \u81F3 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u9009\u5B9A\u7684\u65F6\u95F4\uFF1A".concat(args.time);
    },
    "startDate": "\u5F00\u59CB\u65E5\u671F",
    "timeZoneName": "\u65F6\u533A",
    "weekday": "\u5DE5\u4F5C\u65E5",
    "year": "\u5E74"
};


var $98a6363f02d2e126$export$2e2bcd8739ae039 = {};
$98a6363f02d2e126$export$2e2bcd8739ae039 = {
    "calendar": "\u65E5\u66C6",
    "day": "\u65E5",
    "dayPeriod": "\u4E0A\u5348/\u4E0B\u5348",
    "endDate": "\u7D50\u675F\u65E5\u671F",
    "era": "\u7EAA\u5143",
    "hour": "\u5C0F\u65F6",
    "minute": "\u5206\u949F",
    "month": "\u6708",
    "second": "\u79D2",
    "selectedDateDescription": function(args) {
        return "\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
    },
    "selectedRangeDescription": function(args) {
        return "\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.startDate, " \u81F3 ").concat(args.endDate);
    },
    "selectedTimeDescription": function(args) {
        return "\u9078\u5B9A\u7684\u6642\u9593\uFF1A".concat(args.time);
    },
    "startDate": "\u958B\u59CB\u65E5\u671F",
    "timeZoneName": "\u65F6\u533A",
    "weekday": "\u5DE5\u4F5C\u65E5",
    "year": "\u5E74"
};


var $4857b42b1c06afab$export$2e2bcd8739ae039 = {};
$4857b42b1c06afab$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $dcfd84c654dba0a4$export$2e2bcd8739ae039),
    "bg-BG": (0, $a5efc6868270995f$export$2e2bcd8739ae039),
    "cs-CZ": (0, $5ac1ec7e1ce3796e$export$2e2bcd8739ae039),
    "da-DK": (0, $309f080d2c601b08$export$2e2bcd8739ae039),
    "de-DE": (0, $011ca9bef6c34af2$export$2e2bcd8739ae039),
    "el-GR": (0, $47d509c22073c185$export$2e2bcd8739ae039),
    "en-US": (0, $d99f3b69f70ff462$export$2e2bcd8739ae039),
    "es-ES": (0, $bd38665c35f605e2$export$2e2bcd8739ae039),
    "et-EE": (0, $ea87f1d97e2dbe34$export$2e2bcd8739ae039),
    "fi-FI": (0, $0bf59fa6c574c74e$export$2e2bcd8739ae039),
    "fr-FR": (0, $32de43492d0a62ca$export$2e2bcd8739ae039),
    "he-IL": (0, $83ccdc942ca904ca$export$2e2bcd8739ae039),
    "hr-HR": (0, $329280a02570e49e$export$2e2bcd8739ae039),
    "hu-HU": (0, $b5e60d41efa61015$export$2e2bcd8739ae039),
    "it-IT": (0, $8e60d05bacc75770$export$2e2bcd8739ae039),
    "ja-JP": (0, $a903f3bd1d7c1757$export$2e2bcd8739ae039),
    "ko-KR": (0, $a6c5d30e0b165204$export$2e2bcd8739ae039),
    "lt-LT": (0, $5a9eb117c71e40b6$export$2e2bcd8739ae039),
    "lv-LV": (0, $cf1edc403144c8ef$export$2e2bcd8739ae039),
    "nb-NO": (0, $54bdf0061cb97a0a$export$2e2bcd8739ae039),
    "nl-NL": (0, $337c5158c1fea7a9$export$2e2bcd8739ae039),
    "pl-PL": (0, $849ba821d0b7acf0$export$2e2bcd8739ae039),
    "pt-BR": (0, $1cdd952197be101e$export$2e2bcd8739ae039),
    "pt-PT": (0, $512b00eb79d01762$export$2e2bcd8739ae039),
    "ro-RO": (0, $1bf243546944cab4$export$2e2bcd8739ae039),
    "ru-RU": (0, $669d99522d8fe944$export$2e2bcd8739ae039),
    "sk-SK": (0, $ebccf2147ebd9ce2$export$2e2bcd8739ae039),
    "sl-SI": (0, $e4894d8cf2bbb298$export$2e2bcd8739ae039),
    "sr-SP": (0, $0bf2894840aec79e$export$2e2bcd8739ae039),
    "sv-SE": (0, $1e173a061e7f0ca5$export$2e2bcd8739ae039),
    "tr-TR": (0, $aa9e73a4aa3b83e8$export$2e2bcd8739ae039),
    "uk-UA": (0, $e187385e43bb2712$export$2e2bcd8739ae039),
    "zh-CN": (0, $f6812808a23d3b66$export$2e2bcd8739ae039),
    "zh-TW": (0, $98a6363f02d2e126$export$2e2bcd8739ae039)
};






var $ggE0n = parcelRequire("ggE0n");

function $89da7d8072ad6fee$export$4a931266a3838b86(state, ref, disableArrowNavigation) {
    var _$7CEvq$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), direction = _$7CEvq$useLocale.direction;
    var focusManager = (0, $ggE0n.useMemo)(function() {
        return (0, $67c1d94bd0a42a56$export$c5251b9e124bf29)(ref);
    }, [
        ref
    ]);
    // Open the popover on alt + arrow down
    var onKeyDown = function(e) {
        if (!e.currentTarget.contains(e.target)) return;
        if (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp') && 'setOpen' in state) {
            e.preventDefault();
            e.stopPropagation();
            state.setOpen(true);
        }
        if (disableArrowNavigation) return;
        switch(e.key){
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                if (direction === 'rtl') {
                    if (ref.current) {
                        var target = e.target;
                        var prev = $89da7d8072ad6fee$var$$3dfb0f96be0d6a08$var$findNextSegment(ref.current, target.getBoundingClientRect().left, -1);
                        if (prev) prev.focus();
                    }
                } else focusManager.focusPrevious();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                if (direction === 'rtl') {
                    if (ref.current) {
                        var target1 = e.target;
                        var next = $89da7d8072ad6fee$var$$3dfb0f96be0d6a08$var$findNextSegment(ref.current, target1.getBoundingClientRect().left, 1);
                        if (next) next.focus();
                    }
                } else focusManager.focusNext();
                break;
        }
    };
    // Focus the first placeholder segment from the end on mouse down/touch up in the field.
    var focusLast = function() {
        var _window_event;
        if (!ref.current) return;
        // Try to find the segment prior to the element that was clicked on.
        var target = (_window_event = window.event) === null || _window_event === void 0 ? void 0 : _window_event.target;
        var walker = (0, $67c1d94bd0a42a56$export$2d6ec8fc375ceafa)(ref.current, {
            tabbable: true
        });
        if (target) {
            walker.currentNode = target;
            target = walker.previousNode();
        }
        // If no target found, find the last element from the end.
        if (!target) {
            var last;
            do {
                last = walker.lastChild();
                if (last) target = last;
            }while (last);
        }
        // Now go backwards until we find an element that is not a placeholder.
        while(target === null || target === void 0 ? void 0 : target.hasAttribute('data-placeholder')){
            var prev = walker.previousNode();
            if (prev && prev.hasAttribute('data-placeholder')) target = prev;
            else break;
        }
        if (target) target.focus();
    };
    var _$7CEvq$usePress = (0, $741a5668c6acdbac$export$45712eceda6fad21)({
        preventFocusOnPress: true,
        allowTextSelectionOnPress: true,
        onPressStart: function(e) {
            if (e.pointerType === 'mouse') focusLast();
        },
        onPress: function(e) {
            if (e.pointerType === 'touch' || e.pointerType === 'pen') focusLast();
        }
    }), pressProps = _$7CEvq$usePress.pressProps;
    return (0, $850b305c152381bf$export$9d1611c77c2fe928)(pressProps, {
        onKeyDown: onKeyDown
    });
}
function $89da7d8072ad6fee$var$$3dfb0f96be0d6a08$var$findNextSegment(group, fromX, direction) {
    var walker = (0, $67c1d94bd0a42a56$export$2d6ec8fc375ceafa)(group, {
        tabbable: true
    });
    var node = walker.nextNode();
    var closest = null;
    var closestDistance = Infinity;
    while(node){
        var x = node.getBoundingClientRect().left;
        var distance = x - fromX;
        var absoluteDistance = Math.abs(distance);
        if (Math.sign(distance) === direction && absoluteDistance < closestDistance) {
            closest = node;
            closestDistance = absoluteDistance;
        }
        node = walker.nextNode();
    }
    return closest;
}





var $ggE0n = parcelRequire("ggE0n");




function $e373cd6e88fbaa4c$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e373cd6e88fbaa4c$export$653eddfc964b0f8a = new WeakMap();
var $e373cd6e88fbaa4c$export$300019f83c56d282 = '__role_' + Date.now();
var $e373cd6e88fbaa4c$export$7b3062cd49e80452 = '__focusManager_' + Date.now();
function $e373cd6e88fbaa4c$export$5591b0b878c1a989(props, state, ref) {
    var _state_value;
    var _state_displayValidation = state.displayValidation, isInvalid = _state_displayValidation.isInvalid, validationErrors = _state_displayValidation.validationErrors, validationDetails = _state_displayValidation.validationDetails;
    var _$7Gzdi$useField = (0, $fb08f700a6e84f93$export$294aa081a6c6f55d)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    })), labelProps = _$7Gzdi$useField.labelProps, fieldProps = _$7Gzdi$useField.fieldProps, descriptionProps = _$7Gzdi$useField.descriptionProps, errorMessageProps = _$7Gzdi$useField.errorMessageProps;
    var valueOnFocus = (0, $ggE0n.useRef)(null);
    var _$7Gzdi$useFocusWithin = (0, $2d409168e187362c$export$420e68273165f4ec)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        onFocusWithin: function(e) {
            var _props_onFocus;
            valueOnFocus.current = state.value;
            (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 || _props_onFocus.call(props, e);
        },
        onBlurWithin: function(e) {
            var _props_onBlur;
            state.confirmPlaceholder();
            if (state.value !== valueOnFocus.current) state.commitValidation();
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
        },
        onFocusWithinChange: props.onFocusChange
    })), focusWithinProps = _$7Gzdi$useFocusWithin.focusWithinProps;
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($e373cd6e88fbaa4c$var$$parcel$interopDefault((0, $4857b42b1c06afab$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    var message = state.maxGranularity === 'hour' ? 'selectedTimeDescription' : 'selectedDateDescription';
    var field = state.maxGranularity === 'hour' ? 'time' : 'date';
    var description = state.value ? stringFormatter.format(message, (0, $3Hxpr._)({}, field, state.formatValue({
        month: 'long'
    }))) : '';
    var descProps = (0, $b484270dee1cc590$export$f8aeda7b10753fa1)(description);
    // If within a date picker or date range picker, the date field will have role="presentation" and an aria-describedby
    // will be passed in that references the value (e.g. entire range). Otherwise, add the field's value description.
    var describedBy = props[$e373cd6e88fbaa4c$export$300019f83c56d282] === 'presentation' ? fieldProps['aria-describedby'] : [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    var propsFocusManager = props[$e373cd6e88fbaa4c$export$7b3062cd49e80452];
    var focusManager = (0, $ggE0n.useMemo)(function() {
        return propsFocusManager || (0, $67c1d94bd0a42a56$export$c5251b9e124bf29)(ref);
    }, [
        propsFocusManager,
        ref
    ]);
    var groupProps = (0, $89da7d8072ad6fee$export$4a931266a3838b86)(state, ref, props[$e373cd6e88fbaa4c$export$300019f83c56d282] === 'presentation');
    // Pass labels and other information to segments.
    $e373cd6e88fbaa4c$export$653eddfc964b0f8a.set(state, {
        ariaLabel: props['aria-label'],
        ariaLabelledBy: [
            labelProps.id,
            props['aria-labelledby']
        ].filter(Boolean).join(' ') || undefined,
        ariaDescribedBy: describedBy,
        focusManager: focusManager
    });
    var autoFocusRef = (0, $ggE0n.useRef)(props.autoFocus);
    // When used within a date picker or date range picker, the field gets role="presentation"
    // rather than role="group". Since the date picker/date range picker already has a role="group"
    // with a label and description, and the segments are already labeled by this as well, this
    // avoids very verbose duplicate announcements.
    var fieldDOMProps;
    if (props[$e373cd6e88fbaa4c$export$300019f83c56d282] === 'presentation') fieldDOMProps = {
        role: 'presentation'
    };
    else fieldDOMProps = (0, $850b305c152381bf$export$9d1611c77c2fe928)(fieldProps, {
        role: 'group',
        'aria-disabled': props.isDisabled || undefined,
        'aria-describedby': describedBy
    });
    (0, $ggE0n.useEffect)(function() {
        if (autoFocusRef.current) focusManager.focusFirst();
        autoFocusRef.current = false;
    }, [
        focusManager
    ]);
    (0, $c799dbebbb3cf444$export$5add1d006293d136)(props.inputRef, state.value, state.setValue);
    (0, $76355b41addb9c3e$export$b8473d3665f3a75a)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        focus: function() {
            focusManager.focusFirst();
        }
    }), state, props.inputRef);
    var inputProps = {
        type: 'hidden',
        name: props.name,
        value: ((_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.toString()) || '',
        disabled: props.isDisabled
    };
    if (props.validationBehavior === 'native') {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = 'text';
        inputProps.hidden = true;
        inputProps.required = props.isRequired;
        // Ignore react warning.
        inputProps.onChange = function() {};
    }
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    return {
        labelProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
            onClick: function() {
                focusManager.focusFirst();
            }
        }),
        fieldProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, fieldDOMProps, groupProps, focusWithinProps, {
            onKeyDown: function(e) {
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp: function(e) {
                if (props.onKeyUp) props.onKeyUp(e);
            },
            style: {
                unicodeBidi: 'isolate'
            }
        }),
        inputProps: inputProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
function $e373cd6e88fbaa4c$export$4c842f6a241dc825(props, state, ref) {
    var _state_timeValue;
    var res = $e373cd6e88fbaa4c$export$5591b0b878c1a989(props, state, ref);
    res.inputProps.value = ((_state_timeValue = state.timeValue) === null || _state_timeValue === void 0 ? void 0 : _state_timeValue.toString()) || '';
    return res;
}


var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");



var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");



var $ggE0n = parcelRequire("ggE0n");
function $9deb3c5157a9c484$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
function $9deb3c5157a9c484$export$d42c60378c8168f8() {
    var _$jR5iF$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$jR5iF$useLocale.locale;
    var dictionary = (0, $e3ba67447894b71b$export$87b761675e8eaa10)($9deb3c5157a9c484$var$$parcel$interopDefault((0, $4857b42b1c06afab$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    return (0, $ggE0n.useMemo)(function() {
        // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
        // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
        try {
            return new Intl.DisplayNames(locale, {
                type: 'dateTimeField'
            });
        } catch (e) {
            return new $9deb3c5157a9c484$var$$3aeceb3a64eb8358$var$DisplayNamesPolyfill(locale, dictionary);
        }
    }, [
        locale,
        dictionary
    ]);
}
var $9deb3c5157a9c484$var$$3aeceb3a64eb8358$var$DisplayNamesPolyfill = /*#__PURE__*/ function() {
    "use strict";
    function $3aeceb3a64eb8358$var$DisplayNamesPolyfill(locale, dictionary) {
        (0, $gpEpt._)(this, $3aeceb3a64eb8358$var$DisplayNamesPolyfill);
        this.locale = locale;
        this.dictionary = dictionary;
    }
    (0, $eOJ9o._)($3aeceb3a64eb8358$var$DisplayNamesPolyfill, [
        {
            key: "of",
            value: function of(field) {
                return this.dictionary.getStringForLocale(field, this.locale);
            }
        }
    ]);
    return $3aeceb3a64eb8358$var$DisplayNamesPolyfill;
}();





var $gpEpt = parcelRequire("gpEpt");

var $eOJ9o = parcelRequire("eOJ9o");

var $2QPpE = parcelRequire("2QPpE");


var $90NkU = parcelRequire("90NkU");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f90b901f643edb3a$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp('^.*\\(.*\\).*$');
var $f90b901f643edb3a$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    'latn',
    'arab',
    'hanidec',
    'deva',
    'beng'
];
var $f90b901f643edb3a$export$cd11ab140839f11d = /*#__PURE__*/ function() {
    "use strict";
    function $6c7bd7858deea686$export$cd11ab140839f11d(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gpEpt._)(this, $6c7bd7858deea686$export$cd11ab140839f11d);
        this.locale = locale;
        this.options = options;
    }
    (0, $eOJ9o._)($6c7bd7858deea686$export$cd11ab140839f11d, [
        {
            /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ key: "parse",
            value: function parse(value) {
                return $f90b901f643edb3a$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
            }
        },
        {
            /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ key: "isValidPartialNumber",
            value: function isValidPartialNumber(value, minValue, maxValue) {
                return $f90b901f643edb3a$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
            }
        },
        {
            /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ key: "getNumberingSystem",
            value: function getNumberingSystem(value) {
                return $f90b901f643edb3a$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
            }
        }
    ]);
    return $6c7bd7858deea686$export$cd11ab140839f11d;
}();
var $f90b901f643edb3a$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $f90b901f643edb3a$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    var defaultParser = $f90b901f643edb3a$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes('-nu-') && !defaultParser.isValidPartialNumber(value)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $f90b901f643edb3a$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var numberingSystem = _step.value;
                if (numberingSystem !== defaultParser.options.numberingSystem) {
                    var parser = $f90b901f643edb3a$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes('-u-') ? '-nu-' : '-u-nu-') + numberingSystem, options);
                    if (parser.isValidPartialNumber(value)) return parser;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return defaultParser;
}
function $f90b901f643edb3a$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : '');
    var parser = $f90b901f643edb3a$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $f90b901f643edb3a$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $f90b901f643edb3a$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
var $f90b901f643edb3a$var$$6c7bd7858deea686$var$NumberParserImpl = /*#__PURE__*/ function() {
    "use strict";
    function $6c7bd7858deea686$var$NumberParserImpl(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gpEpt._)(this, $6c7bd7858deea686$var$NumberParserImpl);
        this.locale = locale;
        // see https://tc39.es/ecma402/#sec-setnfdigitoptions, when using roundingIncrement, the maximumFractionDigits and minimumFractionDigits must be equal
        // by default, they are 0 and 3 respectively, so we set them to 0 if neither are set
        if (options.roundingIncrement !== 1 && options.roundingIncrement != null) {
            if (options.maximumFractionDigits == null && options.minimumFractionDigits == null) {
                options.maximumFractionDigits = 0;
                options.minimumFractionDigits = 0;
            } else if (options.maximumFractionDigits == null) options.maximumFractionDigits = options.minimumFractionDigits;
            else if (options.minimumFractionDigits == null) options.minimumFractionDigits = options.maximumFractionDigits;
        // if both are specified, let the normal Range Error be thrown
        }
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $f90b901f643edb3a$var$$6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === 'percent' && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn('NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.');
    }
    (0, $eOJ9o._)($6c7bd7858deea686$var$NumberParserImpl, [
        {
            key: "parse",
            value: function parse(value) {
                // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
                var fullySanitizedValue = this.sanitize(value);
                if (this.symbols.group) fullySanitizedValue = $f90b901f643edb3a$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, '');
                if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, '.');
                if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, '-');
                fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
                if (this.options.style === 'percent') {
                    // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
                    var isNegative = fullySanitizedValue.indexOf('-');
                    fullySanitizedValue = fullySanitizedValue.replace('-', '');
                    fullySanitizedValue = fullySanitizedValue.replace('+', '');
                    var index = fullySanitizedValue.indexOf('.');
                    if (index === -1) index = fullySanitizedValue.length;
                    fullySanitizedValue = fullySanitizedValue.replace('.', '');
                    if (index - 2 === 0) fullySanitizedValue = "0.".concat(fullySanitizedValue);
                    else if (index - 2 === -1) fullySanitizedValue = "0.0".concat(fullySanitizedValue);
                    else if (index - 2 === -2) fullySanitizedValue = '0.00';
                    else fullySanitizedValue = "".concat(fullySanitizedValue.slice(0, index - 2), ".").concat(fullySanitizedValue.slice(index - 2));
                    if (isNegative > -1) fullySanitizedValue = "-".concat(fullySanitizedValue);
                }
                var newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
                if (isNaN(newValue)) return NaN;
                if (this.options.style === 'percent') {
                    var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
                    // extra step for rounding percents to what our formatter would output
                    var options = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, this.options), {
                        style: 'decimal',
                        minimumFractionDigits: Math.min(((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) + 2, 20),
                        maximumFractionDigits: Math.min(((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) + 2, 20)
                    });
                    return new $f90b901f643edb3a$export$cd11ab140839f11d(this.locale, options).parse(new (0, $f92957428704dfd4$export$cc77c4ff7e8673c5)(this.locale, options).format(newValue));
                }
                // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
                if (this.options.currencySign === 'accounting' && $f90b901f643edb3a$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
                return newValue;
            }
        },
        {
            key: "sanitize",
            value: function sanitize(value) {
                // Remove literals and whitespace, which are allowed anywhere in the string
                value = value.replace(this.symbols.literals, '');
                // Replace the ASCII minus sign with the minus sign used in the current locale
                // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
                if (this.symbols.minusSign) value = value.replace('-', this.symbols.minusSign);
                // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
                // instead they use the , (44) character or apparently the (1548) character.
                if (this.options.numberingSystem === 'arab') {
                    if (this.symbols.decimal) {
                        value = value.replace(',', this.symbols.decimal);
                        value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
                    }
                    if (this.symbols.group) value = $f90b901f643edb3a$var$$6c7bd7858deea686$var$replaceAll(value, '.', this.symbols.group);
                }
                // fr-FR group character is narrow non-breaking space, char code 8239 (U+202F), but that's not a key on the french keyboard,
                // so allow space and non-breaking space as a group char as well
                if (this.options.locale === 'fr-FR' && this.symbols.group) {
                    value = $f90b901f643edb3a$var$$6c7bd7858deea686$var$replaceAll(value, ' ', this.symbols.group);
                    value = $f90b901f643edb3a$var$$6c7bd7858deea686$var$replaceAll(value, /\u00A0/g, this.symbols.group);
                }
                return value;
            }
        },
        {
            key: "isValidPartialNumber",
            value: function isValidPartialNumber(value) {
                var minValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, maxValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
                value = this.sanitize(value);
                // Remove minus or plus sign, which must be at the start of the string.
                if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
                else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
                // Numbers cannot start with a group separator
                if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
                // Numbers that can't have any decimal values fail if a decimal character is typed
                if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
                // Remove numerals, groups, and decimals
                if (this.symbols.group) value = $f90b901f643edb3a$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, '');
                value = value.replace(this.symbols.numeral, '');
                if (this.symbols.decimal) value = value.replace(this.symbols.decimal, '');
                // The number is valid if there are no remaining characters
                return value.length === 0;
            }
        }
    ]);
    return $6c7bd7858deea686$var$NumberParserImpl;
}();
var $f90b901f643edb3a$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    'decimal',
    'fraction',
    'integer',
    'minusSign',
    'plusSign',
    'group'
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
var $f90b901f643edb3a$var$$6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $f90b901f643edb3a$var$$6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    var symbolFormatter = new Intl.NumberFormat(locale, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, intlOptions), {
        // Resets so we get the full range of symbols
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21,
        roundingIncrement: 1,
        roundingPriority: 'auto',
        roundingMode: 'halfExpand'
    }));
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    var allParts = symbolFormatter.formatToParts(-10000.111);
    var posAllParts = symbolFormatter.formatToParts(10000.111);
    var pluralParts = $f90b901f643edb3a$var$$6c7bd7858deea686$var$pluralNumbers.map(function(n) {
        return symbolFormatter.formatToParts(n);
    });
    var _allParts_find_value;
    var minusSign = (_allParts_find_value = (_allParts_find = allParts.find(function(p) {
        return p.type === 'minusSign';
    })) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : '-';
    var plusSign = (_posAllParts_find = posAllParts.find(function(p) {
        return p.type === 'plusSign';
    })) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === 'exceptZero' || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === 'always')) plusSign = '+';
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    var decimalParts = new Intl.NumberFormat(locale, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, intlOptions), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })).formatToParts(0.001);
    var decimal = (_decimalParts_find = decimalParts.find(function(p) {
        return p.type === 'decimal';
    })) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    var group = (_allParts_find1 = allParts.find(function(p) {
        return p.type === 'group';
    })) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    var allPartsLiterals = allParts.filter(function(p) {
        return !$f90b901f643edb3a$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type);
    }).map(function(p) {
        return $f90b901f643edb3a$var$$6c7bd7858deea686$var$escapeRegex(p.value);
    });
    var pluralPartsLiterals = pluralParts.flatMap(function(p) {
        return p.filter(function(p) {
            return !$f90b901f643edb3a$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type);
        }).map(function(p) {
            return $f90b901f643edb3a$var$$6c7bd7858deea686$var$escapeRegex(p.value);
        });
    });
    var sortedLiterals = (0, $90NkU._)(new Set((0, $90NkU._)(allPartsLiterals).concat((0, $90NkU._)(pluralPartsLiterals)))).sort(function(a, b) {
        return b.length - a.length;
    });
    var literals = sortedLiterals.length === 0 ? new RegExp('[\\p{White_Space}]', 'gu') : new RegExp("".concat(sortedLiterals.join('|'), "|[\\p{White_Space}]"), 'gu');
    // These are for replacing non-latn characters with the latn equivalent
    var numerals = (0, $90NkU._)(new Intl.NumberFormat(intlOptions.locale, {
        useGrouping: false
    }).format(9876543210)).reverse();
    var indexes = new Map(numerals.map(function(d, i) {
        return [
            d,
            i
        ];
    }));
    var numeral = new RegExp("[".concat(numerals.join(''), "]"), 'g');
    var index = function(d) {
        return String(indexes.get(d));
    };
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $f90b901f643edb3a$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $f90b901f643edb3a$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}



var $ggE0n = parcelRequire("ggE0n");

var $2QPpE = parcelRequire("2QPpE");


var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $28f1011d8470b002$export$3274cf84b703fff(options) {
    var collator = (0, $0058623f38789090$export$a16aca283550c30d)((0, $2QPpE._)({
        usage: 'search'
    }, options));
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    var startsWith = (0, $ggE0n.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    var endsWith = (0, $ggE0n.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    var contains = (0, $ggE0n.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        var scan = 0;
        var sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            var slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $ggE0n.useMemo)(function() {
        return {
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        };
    }, [
        startsWith,
        endsWith,
        contains
    ]);
}


var $3901a163a83865ef$export$2e2bcd8739ae039 = {};
$3901a163a83865ef$export$2e2bcd8739ae039 = {
    "Empty": "\u0641\u0627\u0631\u063A"
};


var $4476974fcaff0834$export$2e2bcd8739ae039 = {};
$4476974fcaff0834$export$2e2bcd8739ae039 = {
    "Empty": "\u0418\u0437\u043F\u0440\u0430\u0437\u043D\u0438"
};


var $e4c4cf7bda917cec$export$2e2bcd8739ae039 = {};
$e4c4cf7bda917cec$export$2e2bcd8739ae039 = {
    "Empty": "Pr\xe1zdn\xe9"
};


var $f3dd0b4b01b53707$export$2e2bcd8739ae039 = {};
$f3dd0b4b01b53707$export$2e2bcd8739ae039 = {
    "Empty": "Tom"
};


var $1cc78c4a0ed1ca75$export$2e2bcd8739ae039 = {};
$1cc78c4a0ed1ca75$export$2e2bcd8739ae039 = {
    "Empty": "Leer"
};


var $ada2d1f08f653b26$export$2e2bcd8739ae039 = {};
$ada2d1f08f653b26$export$2e2bcd8739ae039 = {
    "Empty": "\u0386\u03B4\u03B5\u03B9\u03BF"
};


var $563361785f243d29$export$2e2bcd8739ae039 = {};
$563361785f243d29$export$2e2bcd8739ae039 = {
    "Empty": "Empty"
};


var $2ff5801a489fa225$export$2e2bcd8739ae039 = {};
$2ff5801a489fa225$export$2e2bcd8739ae039 = {
    "Empty": "Vac\xedo"
};


var $fe494d5476461148$export$2e2bcd8739ae039 = {};
$fe494d5476461148$export$2e2bcd8739ae039 = {
    "Empty": "T\xfchjenda"
};


var $5acd70bf1db749d0$export$2e2bcd8739ae039 = {};
$5acd70bf1db749d0$export$2e2bcd8739ae039 = {
    "Empty": "Tyhj\xe4"
};


var $3ad146f3e9f5400c$export$2e2bcd8739ae039 = {};
$3ad146f3e9f5400c$export$2e2bcd8739ae039 = {
    "Empty": "Vide"
};


var $39ad090824feeb09$export$2e2bcd8739ae039 = {};
$39ad090824feeb09$export$2e2bcd8739ae039 = {
    "Empty": "\u05E8\u05D9\u05E7"
};


var $03da88cee3e82beb$export$2e2bcd8739ae039 = {};
$03da88cee3e82beb$export$2e2bcd8739ae039 = {
    "Empty": "Prazno"
};


var $bbca4ac29363478d$export$2e2bcd8739ae039 = {};
$bbca4ac29363478d$export$2e2bcd8739ae039 = {
    "Empty": "\xdcres"
};


var $fe7fd8b1ea25b757$export$2e2bcd8739ae039 = {};
$fe7fd8b1ea25b757$export$2e2bcd8739ae039 = {
    "Empty": "Vuoto"
};


var $d9f9a4e72e39063d$export$2e2bcd8739ae039 = {};
$d9f9a4e72e39063d$export$2e2bcd8739ae039 = {
    "Empty": "\u7A7A"
};


var $ce17e8081ab13f4d$export$2e2bcd8739ae039 = {};
$ce17e8081ab13f4d$export$2e2bcd8739ae039 = {
    "Empty": "\uBE44\uC5B4 \uC788\uC74C"
};


var $f6765fbc5a5bec73$export$2e2bcd8739ae039 = {};
$f6765fbc5a5bec73$export$2e2bcd8739ae039 = {
    "Empty": "Tu\u0161\u010Dias"
};


var $f369fe400197d3dc$export$2e2bcd8739ae039 = {};
$f369fe400197d3dc$export$2e2bcd8739ae039 = {
    "Empty": "Tuk\u0161s"
};


var $bb63e19b6ce156fe$export$2e2bcd8739ae039 = {};
$bb63e19b6ce156fe$export$2e2bcd8739ae039 = {
    "Empty": "Tom"
};


var $7967215acd0dfb10$export$2e2bcd8739ae039 = {};
$7967215acd0dfb10$export$2e2bcd8739ae039 = {
    "Empty": "Leeg"
};


var $736b160f7da21625$export$2e2bcd8739ae039 = {};
$736b160f7da21625$export$2e2bcd8739ae039 = {
    "Empty": "Pusty"
};


var $12e6262d1d3ba03f$export$2e2bcd8739ae039 = {};
$12e6262d1d3ba03f$export$2e2bcd8739ae039 = {
    "Empty": "Vazio"
};


var $ecdeeb30b4ace372$export$2e2bcd8739ae039 = {};
$ecdeeb30b4ace372$export$2e2bcd8739ae039 = {
    "Empty": "Vazio"
};


var $3c2dbf65b0ab7ecc$export$2e2bcd8739ae039 = {};
$3c2dbf65b0ab7ecc$export$2e2bcd8739ae039 = {
    "Empty": "Gol"
};


var $83d5a463eceffd1c$export$2e2bcd8739ae039 = {};
$83d5a463eceffd1c$export$2e2bcd8739ae039 = {
    "Empty": "\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E"
};


var $ee0af20c36f5e6c5$export$2e2bcd8739ae039 = {};
$ee0af20c36f5e6c5$export$2e2bcd8739ae039 = {
    "Empty": "Pr\xe1zdne"
};


var $3d58d7dc4aa77f0e$export$2e2bcd8739ae039 = {};
$3d58d7dc4aa77f0e$export$2e2bcd8739ae039 = {
    "Empty": "Prazen"
};


var $804021001ef4e412$export$2e2bcd8739ae039 = {};
$804021001ef4e412$export$2e2bcd8739ae039 = {
    "Empty": "Prazno"
};


var $a6e8033e433b8f37$export$2e2bcd8739ae039 = {};
$a6e8033e433b8f37$export$2e2bcd8739ae039 = {
    "Empty": "Tomt"
};


var $057e7a36c11a180e$export$2e2bcd8739ae039 = {};
$057e7a36c11a180e$export$2e2bcd8739ae039 = {
    "Empty": "Bo\u015F"
};


var $a633d865b2bfc0fa$export$2e2bcd8739ae039 = {};
$a633d865b2bfc0fa$export$2e2bcd8739ae039 = {
    "Empty": "\u041F\u0443\u0441\u0442\u043E"
};


var $6db5fc8e371041a7$export$2e2bcd8739ae039 = {};
$6db5fc8e371041a7$export$2e2bcd8739ae039 = {
    "Empty": "\u7A7A"
};


var $a282edab0d4a56c5$export$2e2bcd8739ae039 = {};
$a282edab0d4a56c5$export$2e2bcd8739ae039 = {
    "Empty": "\u7A7A\u767D"
};


var $96175bfd3fad69c9$export$2e2bcd8739ae039 = {};
$96175bfd3fad69c9$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $3901a163a83865ef$export$2e2bcd8739ae039),
    "bg-BG": (0, $4476974fcaff0834$export$2e2bcd8739ae039),
    "cs-CZ": (0, $e4c4cf7bda917cec$export$2e2bcd8739ae039),
    "da-DK": (0, $f3dd0b4b01b53707$export$2e2bcd8739ae039),
    "de-DE": (0, $1cc78c4a0ed1ca75$export$2e2bcd8739ae039),
    "el-GR": (0, $ada2d1f08f653b26$export$2e2bcd8739ae039),
    "en-US": (0, $563361785f243d29$export$2e2bcd8739ae039),
    "es-ES": (0, $2ff5801a489fa225$export$2e2bcd8739ae039),
    "et-EE": (0, $fe494d5476461148$export$2e2bcd8739ae039),
    "fi-FI": (0, $5acd70bf1db749d0$export$2e2bcd8739ae039),
    "fr-FR": (0, $3ad146f3e9f5400c$export$2e2bcd8739ae039),
    "he-IL": (0, $39ad090824feeb09$export$2e2bcd8739ae039),
    "hr-HR": (0, $03da88cee3e82beb$export$2e2bcd8739ae039),
    "hu-HU": (0, $bbca4ac29363478d$export$2e2bcd8739ae039),
    "it-IT": (0, $fe7fd8b1ea25b757$export$2e2bcd8739ae039),
    "ja-JP": (0, $d9f9a4e72e39063d$export$2e2bcd8739ae039),
    "ko-KR": (0, $ce17e8081ab13f4d$export$2e2bcd8739ae039),
    "lt-LT": (0, $f6765fbc5a5bec73$export$2e2bcd8739ae039),
    "lv-LV": (0, $f369fe400197d3dc$export$2e2bcd8739ae039),
    "nb-NO": (0, $bb63e19b6ce156fe$export$2e2bcd8739ae039),
    "nl-NL": (0, $7967215acd0dfb10$export$2e2bcd8739ae039),
    "pl-PL": (0, $736b160f7da21625$export$2e2bcd8739ae039),
    "pt-BR": (0, $12e6262d1d3ba03f$export$2e2bcd8739ae039),
    "pt-PT": (0, $ecdeeb30b4ace372$export$2e2bcd8739ae039),
    "ro-RO": (0, $3c2dbf65b0ab7ecc$export$2e2bcd8739ae039),
    "ru-RU": (0, $83d5a463eceffd1c$export$2e2bcd8739ae039),
    "sk-SK": (0, $ee0af20c36f5e6c5$export$2e2bcd8739ae039),
    "sl-SI": (0, $3d58d7dc4aa77f0e$export$2e2bcd8739ae039),
    "sr-SP": (0, $804021001ef4e412$export$2e2bcd8739ae039),
    "sv-SE": (0, $a6e8033e433b8f37$export$2e2bcd8739ae039),
    "tr-TR": (0, $057e7a36c11a180e$export$2e2bcd8739ae039),
    "uk-UA": (0, $a633d865b2bfc0fa$export$2e2bcd8739ae039),
    "zh-CN": (0, $6db5fc8e371041a7$export$2e2bcd8739ae039),
    "zh-TW": (0, $a282edab0d4a56c5$export$2e2bcd8739ae039)
};




var $ggE0n = parcelRequire("ggE0n");


function $99ca5e2597606930$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $99ca5e2597606930$export$e908e06f4b8e3402(props) {
    var _async = (0, $ggE0n.useRef)(undefined);
    var value = props.value, textValue = props.textValue, minValue = props.minValue, maxValue = props.maxValue, isDisabled = props.isDisabled, isReadOnly = props.isReadOnly, isRequired = props.isRequired, onIncrement = props.onIncrement, onIncrementPage = props.onIncrementPage, onDecrement = props.onDecrement, onDecrementPage = props.onDecrementPage, onDecrementToMin = props.onDecrementToMin, onIncrementToMax = props.onIncrementToMax;
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($99ca5e2597606930$var$$parcel$interopDefault((0, $96175bfd3fad69c9$export$2e2bcd8739ae039)), '@react-aria/spinbutton');
    var clearAsync = function() {
        return clearTimeout(_async.current);
    };
    (0, $ggE0n.useEffect)(function() {
        return function() {
            return clearAsync();
        };
    }, []);
    var onKeyDown = function(e) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly) return;
        switch(e.key){
            case 'PageUp':
                if (onIncrementPage) {
                    e.preventDefault();
                    onIncrementPage === null || onIncrementPage === void 0 || onIncrementPage();
                    break;
                }
            // fallthrough!
            case 'ArrowUp':
            case 'Up':
                if (onIncrement) {
                    e.preventDefault();
                    onIncrement === null || onIncrement === void 0 || onIncrement();
                }
                break;
            case 'PageDown':
                if (onDecrementPage) {
                    e.preventDefault();
                    onDecrementPage === null || onDecrementPage === void 0 || onDecrementPage();
                    break;
                }
            // fallthrough
            case 'ArrowDown':
            case 'Down':
                if (onDecrement) {
                    e.preventDefault();
                    onDecrement === null || onDecrement === void 0 || onDecrement();
                }
                break;
            case 'Home':
                if (onDecrementToMin) {
                    e.preventDefault();
                    onDecrementToMin === null || onDecrementToMin === void 0 || onDecrementToMin();
                }
                break;
            case 'End':
                if (onIncrementToMax) {
                    e.preventDefault();
                    onIncrementToMax === null || onIncrementToMax === void 0 || onIncrementToMax();
                }
                break;
        }
    };
    var isFocused = (0, $ggE0n.useRef)(false);
    var onFocus = function() {
        isFocused.current = true;
    };
    var onBlur = function() {
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    var ariaTextValue = textValue === '' ? stringFormatter.format('Empty') : (textValue || "".concat(value)).replace('-', '\u2212');
    (0, $ggE0n.useEffect)(function() {
        if (isFocused.current) {
            (0, $e7c771ec74591764$export$d10ae4f68404609a)('assertive');
            (0, $e7c771ec74591764$export$a9b970dcc4ae71a9)(ariaTextValue, 'assertive');
        }
    }, [
        ariaTextValue
    ]);
    var onIncrementPressStart = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(initialStepDelay) {
        clearAsync();
        onIncrement === null || onIncrement === void 0 || onIncrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(function() {
            if (maxValue === undefined || isNaN(maxValue) || value === undefined || isNaN(value) || value < maxValue) onIncrementPressStart(60);
        }, initialStepDelay);
    });
    var onDecrementPressStart = (0, $0770c91df2f1295f$export$7f54fc3180508a52)(function(initialStepDelay) {
        clearAsync();
        onDecrement === null || onDecrement === void 0 || onDecrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(function() {
            if (minValue === undefined || isNaN(minValue) || value === undefined || isNaN(value) || value > minValue) onDecrementPressStart(60);
        }, initialStepDelay);
    });
    var cancelContextMenu = function(e) {
        e.preventDefault();
    };
    var _$5rwhf$useGlobalListeners = (0, $af8e150eb57cc5a4$export$4eaf04e54aa8eed6)(), addGlobalListener = _$5rwhf$useGlobalListeners.addGlobalListener, removeAllGlobalListeners = _$5rwhf$useGlobalListeners.removeAllGlobalListeners;
    return {
        spinButtonProps: {
            role: 'spinbutton',
            'aria-valuenow': value !== undefined && !isNaN(value) ? value : undefined,
            'aria-valuetext': ariaTextValue,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-disabled': isDisabled || undefined,
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur
        },
        incrementButtonProps: {
            onPressStart: function() {
                onIncrementPressStart(400);
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressEnd: function() {
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus: onFocus,
            onBlur: onBlur
        },
        decrementButtonProps: {
            onPressStart: function() {
                onDecrementPressStart(400);
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressEnd: function() {
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e6a6fcf526c5e431$export$1315d136e6f7581(segment, state, ref) {
    var enteredKeys = (0, $ggE0n.useRef)('');
    var _$4d1jn$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$4d1jn$useLocale.locale, direction = _$4d1jn$useLocale.direction;
    var displayNames = (0, $9deb3c5157a9c484$export$d42c60378c8168f8)();
    var _$16f0b7bb276bc17e$export$653eddfc964b0f8a_get = (0, $e373cd6e88fbaa4c$export$653eddfc964b0f8a).get(state), ariaLabel = _$16f0b7bb276bc17e$export$653eddfc964b0f8a_get.ariaLabel, ariaLabelledBy = _$16f0b7bb276bc17e$export$653eddfc964b0f8a_get.ariaLabelledBy, ariaDescribedBy = _$16f0b7bb276bc17e$export$653eddfc964b0f8a_get.ariaDescribedBy, focusManager = _$16f0b7bb276bc17e$export$653eddfc964b0f8a_get.focusManager;
    var textValue = segment.isPlaceholder ? '' : segment.text;
    var options = (0, $ggE0n.useMemo)(function() {
        return state.dateFormatter.resolvedOptions();
    }, [
        state.dateFormatter
    ]);
    var monthDateFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        month: 'long',
        timeZone: options.timeZone
    });
    var hourDateFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        hour: 'numeric',
        hour12: options.hour12,
        timeZone: options.timeZone
    });
    if (segment.type === 'month' && !segment.isPlaceholder) {
        var monthTextValue = monthDateFormatter.format(state.dateValue);
        textValue = monthTextValue !== textValue ? "".concat(textValue, " \u2013 ").concat(monthTextValue) : monthTextValue;
    } else if (segment.type === 'hour' && !segment.isPlaceholder) textValue = hourDateFormatter.format(state.dateValue);
    var _$4d1jn$useSpinButton = (0, $99ca5e2597606930$export$e908e06f4b8e3402)({
        // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
        // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
        // https://github.com/dequelabs/axe-core/issues/3505
        value: segment.value,
        textValue: textValue,
        minValue: segment.minValue,
        maxValue: segment.maxValue,
        isDisabled: state.isDisabled,
        isReadOnly: state.isReadOnly || !segment.isEditable,
        isRequired: state.isRequired,
        onIncrement: function() {
            enteredKeys.current = '';
            state.increment(segment.type);
        },
        onDecrement: function() {
            enteredKeys.current = '';
            state.decrement(segment.type);
        },
        onIncrementPage: function() {
            enteredKeys.current = '';
            state.incrementPage(segment.type);
        },
        onDecrementPage: function() {
            enteredKeys.current = '';
            state.decrementPage(segment.type);
        },
        onIncrementToMax: function() {
            enteredKeys.current = '';
            if (segment.maxValue !== undefined) state.setSegment(segment.type, segment.maxValue);
        },
        onDecrementToMin: function() {
            enteredKeys.current = '';
            if (segment.minValue !== undefined) state.setSegment(segment.type, segment.minValue);
        }
    }), spinButtonProps = _$4d1jn$useSpinButton.spinButtonProps;
    var parser = (0, $ggE0n.useMemo)(function() {
        return new (0, $f90b901f643edb3a$export$cd11ab140839f11d)(locale, {
            maximumFractionDigits: 0
        });
    }, [
        locale
    ]);
    var backspace = function() {
        if (segment.text === segment.placeholder) focusManager.focusPrevious();
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
            var newValue = segment.text.slice(0, -1);
            var parsed = parser.parse(newValue);
            newValue = parsed === 0 ? '' : newValue;
            if (newValue.length === 0 || parsed === 0) state.clearSegment(segment.type);
            else state.setSegment(segment.type, parsed);
            enteredKeys.current = newValue;
        } else if (segment.type === 'dayPeriod') state.clearSegment(segment.type);
    };
    var onKeyDown = function(e) {
        // Firefox does not fire selectstart for Ctrl/Cmd + A
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1742153
        if (e.key === 'a' && ((0, $ccce5714e9b7278a$export$9ac100e40613ea10)() ? e.metaKey : e.ctrlKey)) e.preventDefault();
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        switch(e.key){
            case 'Backspace':
            case 'Delete':
                // Safari on iOS does not fire beforeinput for the backspace key because the cursor is at the start.
                e.preventDefault();
                e.stopPropagation();
                backspace();
                break;
        }
    };
    // Safari dayPeriod option doesn't work...
    var _$4d1jn$useFilter = (0, $28f1011d8470b002$export$3274cf84b703fff)({
        sensitivity: 'base'
    }), startsWith = _$4d1jn$useFilter.startsWith;
    var amPmFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        hour: 'numeric',
        hour12: true
    });
    var am = (0, $ggE0n.useMemo)(function() {
        var date = new Date();
        date.setHours(0);
        return amPmFormatter.formatToParts(date).find(function(part) {
            return part.type === 'dayPeriod';
        }).value;
    }, [
        amPmFormatter
    ]);
    var pm = (0, $ggE0n.useMemo)(function() {
        var date = new Date();
        date.setHours(12);
        return amPmFormatter.formatToParts(date).find(function(part) {
            return part.type === 'dayPeriod';
        }).value;
    }, [
        amPmFormatter
    ]);
    // Get a list of formatted era names so users can type the first character to choose one.
    var eraFormatter = (0, $ee23060f623d2310$export$85fd5fdf27bacc79)({
        year: 'numeric',
        era: 'narrow',
        timeZone: 'UTC'
    });
    var eras = (0, $ggE0n.useMemo)(function() {
        if (segment.type !== 'era') return [];
        var date = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(1, 1, 1), state.calendar);
        var eras = state.calendar.getEras().map(function(era) {
            var eraDate = date.set({
                year: 1,
                month: 1,
                day: 1,
                era: era
            }).toDate('UTC');
            var parts = eraFormatter.formatToParts(eraDate);
            var formatted = parts.find(function(p) {
                return p.type === 'era';
            }).value;
            return {
                era: era,
                formatted: formatted
            };
        });
        // Remove the common prefix from formatted values. This is so that in calendars with eras like
        // ERA0 and ERA1 (e.g. Ethiopic), users can press "0" and "1" to select an era. In other cases,
        // the first letter is used.
        var prefixLength = $e6a6fcf526c5e431$var$$32489daedd52963e$var$commonPrefixLength(eras.map(function(era) {
            return era.formatted;
        }));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (prefixLength) try {
            for(var _iterator = eras[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var era = _step.value;
                era.formatted = era.formatted.slice(prefixLength);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return eras;
    }, [
        eraFormatter,
        state.calendar,
        segment.type
    ]);
    var onInput = function(key) {
        if (state.isDisabled || state.isReadOnly) return;
        var newValue = enteredKeys.current + key;
        switch(segment.type){
            case 'dayPeriod':
                if (startsWith(am, key)) state.setSegment('dayPeriod', 0);
                else if (startsWith(pm, key)) state.setSegment('dayPeriod', 12);
                else break;
                focusManager.focusNext();
                break;
            case 'era':
                {
                    var matched = eras.find(function(e) {
                        return startsWith(e.formatted, key);
                    });
                    if (matched) {
                        state.setSegment('era', matched.era);
                        focusManager.focusNext();
                    }
                    break;
                }
            case 'day':
            case 'hour':
            case 'minute':
            case 'second':
            case 'month':
            case 'year':
                {
                    if (!parser.isValidPartialNumber(newValue)) return;
                    var numberValue = parser.parse(newValue);
                    var segmentValue = numberValue;
                    var allowsZero = segment.minValue === 0;
                    if (segment.type === 'hour' && state.dateFormatter.resolvedOptions().hour12) {
                        switch(state.dateFormatter.resolvedOptions().hourCycle){
                            case 'h11':
                                if (numberValue > 11) segmentValue = parser.parse(key);
                                break;
                            case 'h12':
                                allowsZero = false;
                                if (numberValue > 12) segmentValue = parser.parse(key);
                                break;
                        }
                        if (segment.value !== undefined && segment.value >= 12 && numberValue > 1) numberValue += 12;
                    } else if (segment.maxValue !== undefined && numberValue > segment.maxValue) segmentValue = parser.parse(key);
                    if (isNaN(numberValue)) return;
                    var shouldSetValue = segmentValue !== 0 || allowsZero;
                    if (shouldSetValue) state.setSegment(segment.type, segmentValue);
                    if (segment.maxValue !== undefined && (Number(numberValue + '0') > segment.maxValue || newValue.length >= String(segment.maxValue).length)) {
                        enteredKeys.current = '';
                        if (shouldSetValue) focusManager.focusNext();
                    } else enteredKeys.current = newValue;
                    break;
                }
        }
    };
    var onFocus = function() {
        enteredKeys.current = '';
        if (ref.current) (0, $d3940bd7bb9376be$export$c826860796309d1b)(ref.current, {
            containingElement: (0, $6639b0c48472043a$export$cfa2225e87938781)(ref.current)
        });
        // Collapse selection to start or Chrome won't fire input events.
        var selection = window.getSelection();
        selection === null || selection === void 0 || selection.collapse(ref.current);
    };
    var documentRef = (0, $ggE0n.useRef)(typeof document !== 'undefined' ? document : null);
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(documentRef, 'selectionchange', function() {
        var _ref_current;
        // Enforce that the selection is collapsed when inside a date segment.
        // Otherwise, when tapping on a segment in Android Chrome and then entering text,
        // composition events will be fired that break the DOM structure and crash the page.
        var selection = window.getSelection();
        if ((selection === null || selection === void 0 ? void 0 : selection.anchorNode) && ((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(selection === null || selection === void 0 ? void 0 : selection.anchorNode))) selection.collapse(ref.current);
    });
    var compositionRef = (0, $ggE0n.useRef)('');
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(ref, 'beforeinput', function(e) {
        if (!ref.current) return;
        e.preventDefault();
        switch(e.inputType){
            case 'deleteContentBackward':
            case 'deleteContentForward':
                if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly) backspace();
                break;
            case 'insertCompositionText':
                // insertCompositionText cannot be canceled.
                // Record the current state of the element so we can restore it in the `input` event below.
                compositionRef.current = ref.current.textContent;
                // Safari gets stuck in a composition state unless we also assign to the value here.
                // eslint-disable-next-line no-self-assign
                ref.current.textContent = ref.current.textContent;
                break;
            default:
                if (e.data != null) onInput(e.data);
                break;
        }
    });
    (0, $468cd85a4db23b7b$export$90fc3a17d93f704c)(ref, 'input', function(e) {
        var inputType = e.inputType, data = e.data;
        switch(inputType){
            case 'insertCompositionText':
                // Reset the DOM to how it was in the beforeinput event.
                if (ref.current) ref.current.textContent = compositionRef.current;
                // Android sometimes fires key presses of letters as composition events. Need to handle am/pm keys here too.
                // Can also happen e.g. with Pinyin keyboard on iOS.
                if (data != null && (startsWith(am, data) || startsWith(pm, data))) onInput(data);
                break;
        }
    });
    (0, $14195c176ed33023$export$e5c5a5f917a5871c)(function() {
        var element = ref.current;
        return function() {
            // If the focused segment is removed, focus the previous one, or the next one if there was no previous one.
            if (document.activeElement === element) {
                var prev = focusManager.focusPrevious();
                if (!prev) focusManager.focusNext();
            }
        };
    }, [
        ref,
        focusManager
    ]);
    // spinbuttons cannot be focused with VoiceOver on iOS.
    var touchPropOverrides = (0, $ccce5714e9b7278a$export$fedb369cb70207f1)() || segment.type === 'timeZoneName' ? {
        role: 'textbox',
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuetext': null,
        'aria-valuenow': null
    } : {};
    // Only apply aria-describedby to the first segment, unless the field is invalid. This avoids it being
    // read every time the user navigates to a new segment.
    var firstSegment = (0, $ggE0n.useMemo)(function() {
        return state.segments.find(function(s) {
            return s.isEditable;
        });
    }, [
        state.segments
    ]);
    if (segment !== firstSegment && !state.isInvalid) ariaDescribedBy = undefined;
    var id = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
    // Prepend the label passed from the field to each segment name.
    // This is needed because VoiceOver on iOS does not announce groups.
    var name = segment.type === 'literal' ? '' : displayNames.of(segment.type);
    var labelProps = (0, $c7019d53357f553d$export$d6875122194c7b44)({
        'aria-label': "".concat(name).concat(ariaLabel ? ", ".concat(ariaLabel) : '').concat(ariaLabelledBy ? ', ' : ''),
        'aria-labelledby': ariaLabelledBy
    });
    // Literal segments should not be visible to screen readers. We don't really need any of the above,
    // but the rules of hooks mean hooks cannot be conditional so we have to put this condition here.
    if (segment.type === 'literal') return {
        segmentProps: {
            'aria-hidden': true
        }
    };
    var segmentStyle = {
        caretColor: 'transparent'
    };
    if (direction === 'rtl') {
        // While the bidirectional algorithm seems to work properly on inline elements with actual values, it returns different results for placeholder strings. 
        // To ensure placeholder render in correct format, we apply the CSS equivalent of LRE (left-to-right embedding). See https://www.unicode.org/reports/tr9/#Explicit_Directional_Embeddings.
        // However, we apply this to both placeholders and date segments with an actual value because the date segments will shift around when deleting otherwise. 
        segmentStyle.unicodeBidi = 'embed';
        var format = options[segment.type];
        if (format === 'numeric' || format === '2-digit') segmentStyle.direction = 'ltr';
    }
    var _obj;
    return {
        segmentProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(spinButtonProps, labelProps, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
            id: id
        }, touchPropOverrides), (_obj = {
            'aria-invalid': state.isInvalid ? 'true' : undefined,
            'aria-describedby': ariaDescribedBy,
            'aria-readonly': state.isReadOnly || !segment.isEditable ? 'true' : undefined,
            'data-placeholder': segment.isPlaceholder || undefined,
            contentEditable: isEditable,
            suppressContentEditableWarning: isEditable,
            spellCheck: isEditable ? 'false' : undefined,
            autoCorrect: isEditable ? 'off' : undefined
        }, // Capitalization was changed in React 17...
        (0, $3Hxpr._)(_obj, parseInt((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint', isEditable ? 'next' : undefined), (0, $3Hxpr._)(_obj, "inputMode", state.isDisabled || segment.type === 'dayPeriod' || segment.type === 'era' || !isEditable ? undefined : 'numeric'), (0, $3Hxpr._)(_obj, "tabIndex", state.isDisabled ? undefined : 0), (0, $3Hxpr._)(_obj, "onKeyDown", onKeyDown), (0, $3Hxpr._)(_obj, "onFocus", onFocus), (0, $3Hxpr._)(_obj, "style", segmentStyle), // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
        (0, $3Hxpr._)(_obj, "onPointerDown", function(e) {
            e.stopPropagation();
        }), (0, $3Hxpr._)(_obj, "onMouseDown", function(e) {
            e.stopPropagation();
        }), _obj)))
    };
}
function $e6a6fcf526c5e431$var$$32489daedd52963e$var$commonPrefixLength(strings) {
    // Sort the strings, and compare the characters in the first and last to find the common prefix.
    strings.sort();
    var first = strings[0];
    var last = strings[strings.length - 1];
    for(var i = 0; i < first.length; i++){
        if (first[i] !== last[i]) return i;
    }
    return 0;
}




var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");



var $2QPpE = parcelRequire("2QPpE");


var $c5079f2e71d3f914$export$2e2bcd8739ae039 = {};
$c5079f2e71d3f914$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u064A\u0645\u0629 ".concat(args.maxValue, " \u0623\u0648 \u0642\u0628\u0644 \u0630\u0644\u0643.");
    },
    "rangeReversed": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621 \u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0642\u0628\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621.",
    "rangeUnderflow": function(args) {
        return "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u064A\u0645\u0629 ".concat(args.minValue, " \u0623\u0648 \u0628\u0639\u062F \u0630\u0644\u0643.");
    },
    "unavailableDate": "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629."
};


var $1d5db3bddf1a761b$export$2e2bcd8739ae039 = {};
$1d5db3bddf1a761b$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 ".concat(args.maxValue, " \u0438\u043B\u0438 \u043F\u043E-\u0440\u0430\u043D\u043D\u0430.");
    },
    "rangeReversed": "\u041D\u0430\u0447\u0430\u043B\u043D\u0430\u0442\u0430 \u0434\u0430\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u043F\u0440\u0435\u0434\u0438 \u043A\u0440\u0430\u0439\u043D\u0430\u0442\u0430.",
    "rangeUnderflow": function(args) {
        return "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 ".concat(args.minValue, " \u0438\u043B\u0438 \u043F\u043E-\u043A\u044A\u0441\u043D\u043E.");
    },
    "unavailableDate": "\u0418\u0437\u0431\u0440\u0430\u043D\u0430\u0442\u0430 \u0434\u0430\u0442\u0430 \u043D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430."
};


var $79ef32e4d2160b9d$export$2e2bcd8739ae039 = {};
$79ef32e4d2160b9d$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Hodnota mus\xed b\xfdt ".concat(args.maxValue, " nebo d\u0159\xedv\u011Bj\u0161\xed.");
    },
    "rangeReversed": "Datum zah\xe1jen\xed mus\xed p\u0159edch\xe1zet datu ukon\u010Den\xed.",
    "rangeUnderflow": function(args) {
        return "Hodnota mus\xed b\xfdt ".concat(args.minValue, " nebo pozd\u011Bj\u0161\xed.");
    },
    "unavailableDate": "Vybran\xe9 datum nen\xed k dispozici."
};


var $abeedb27d6c769b2$export$2e2bcd8739ae039 = {};
$abeedb27d6c769b2$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "V\xe6rdien skal v\xe6re ".concat(args.maxValue, " eller tidligere.");
    },
    "rangeReversed": "Startdatoen skal v\xe6re f\xf8r slutdatoen.",
    "rangeUnderflow": function(args) {
        return "V\xe6rdien skal v\xe6re ".concat(args.minValue, " eller nyere.");
    },
    "unavailableDate": "Den valgte dato er ikke tilg\xe6ngelig."
};


var $233c16fad45d2198$export$2e2bcd8739ae039 = {};
$233c16fad45d2198$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Der Wert muss ".concat(args.maxValue, " oder fr\xfcher sein.");
    },
    "rangeReversed": "Das Anfangsdatum muss vor dem Enddatum liegen.",
    "rangeUnderflow": function(args) {
        return "Der Wert muss ".concat(args.minValue, " oder sp\xe4ter sein.");
    },
    "unavailableDate": "Das ausgew\xe4hlte Datum ist nicht verf\xfcgbar."
};


var $21186e3201e046d2$export$2e2bcd8739ae039 = {};
$21186e3201e046d2$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 ".concat(args.maxValue, " \u03AE \u03C0\u03B1\u03BB\u03B1\u03B9\u03CC\u03C4\u03B5\u03C1\u03B7.");
    },
    "rangeReversed": "\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2.",
    "rangeUnderflow": function(args) {
        return "\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 ".concat(args.minValue, " \u03AE \u03BC\u03B5\u03C4\u03B1\u03B3\u03B5\u03BD\u03AD\u03C3\u03C4\u03B5\u03C1\u03B7.");
    },
    "unavailableDate": "\u0397 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7."
};


var $2d2b9c68087ff8b7$export$2e2bcd8739ae039 = {};
$2d2b9c68087ff8b7$export$2e2bcd8739ae039 = {
    "rangeUnderflow": function(args) {
        return "Value must be ".concat(args.minValue, " or later.");
    },
    "rangeOverflow": function(args) {
        return "Value must be ".concat(args.maxValue, " or earlier.");
    },
    "rangeReversed": "Start date must be before end date.",
    "unavailableDate": "Selected date unavailable."
};


var $3756a5b1c3541a36$export$2e2bcd8739ae039 = {};
$3756a5b1c3541a36$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "El valor debe ser ".concat(args.maxValue, " o anterior.");
    },
    "rangeReversed": "La fecha de inicio debe ser anterior a la fecha de finalizaci\xf3n.",
    "rangeUnderflow": function(args) {
        return "El valor debe ser ".concat(args.minValue, " o posterior.");
    },
    "unavailableDate": "Fecha seleccionada no disponible."
};


var $8ec2aa4122b50655$export$2e2bcd8739ae039 = {};
$8ec2aa4122b50655$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "V\xe4\xe4rtus peab olema ".concat(args.maxValue, " v\xf5i varasem.");
    },
    "rangeReversed": "Alguskuup\xe4ev peab olema enne l\xf5ppkuup\xe4eva.",
    "rangeUnderflow": function(args) {
        return "V\xe4\xe4rtus peab olema ".concat(args.minValue, " v\xf5i hilisem.");
    },
    "unavailableDate": "Valitud kuup\xe4ev pole saadaval."
};


var $59afe2e29b5a1045$export$2e2bcd8739ae039 = {};
$59afe2e29b5a1045$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Arvon on oltava ".concat(args.maxValue, " tai sit\xe4 aikaisempi.");
    },
    "rangeReversed": "Aloitusp\xe4iv\xe4n on oltava ennen lopetusp\xe4iv\xe4\xe4.",
    "rangeUnderflow": function(args) {
        return "Arvon on oltava ".concat(args.minValue, " tai sit\xe4 my\xf6h\xe4isempi.");
    },
    "unavailableDate": "Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole k\xe4ytett\xe4viss\xe4."
};


var $509a6feb1da978f2$export$2e2bcd8739ae039 = {};
$509a6feb1da978f2$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "La valeur doit \xeatre ".concat(args.maxValue, " ou ant\xe9rieure.");
    },
    "rangeReversed": "La date de d\xe9but doit \xeatre ant\xe9rieure \xe0 la date de fin.",
    "rangeUnderflow": function(args) {
        return "La valeur doit \xeatre ".concat(args.minValue, " ou ult\xe9rieure.");
    },
    "unavailableDate": "La date s\xe9lectionn\xe9e n\u2019est pas disponible."
};


var $37730aeb8fb20af1$export$2e2bcd8739ae039 = {};
$37730aeb8fb20af1$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u05D4\u05E2\u05E8\u05DA \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA ".concat(args.maxValue, " \u05D0\u05D5 \u05DE\u05D5\u05E7\u05D3\u05DD \u05D9\u05D5\u05EA\u05E8.");
    },
    "rangeReversed": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05D4\u05EA\u05D7\u05DC\u05D4 \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DC\u05E4\u05E0\u05D9 \u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E1\u05D9\u05D5\u05DD.",
    "rangeUnderflow": function(args) {
        return "\u05D4\u05E2\u05E8\u05DA \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA ".concat(args.minValue, " \u05D0\u05D5 \u05DE\u05D0\u05D5\u05D7\u05E8 \u05D9\u05D5\u05EA\u05E8.");
    },
    "unavailableDate": "\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E0\u05D1\u05D7\u05E8 \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF."
};


var $4edb462ccbdc7d20$export$2e2bcd8739ae039 = {};
$4edb462ccbdc7d20$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Vrijednost mora biti ".concat(args.maxValue, " ili ranije.");
    },
    "rangeReversed": "Datum po\u010Detka mora biti prije datuma zavr\u0161etka.",
    "rangeUnderflow": function(args) {
        return "Vrijednost mora biti ".concat(args.minValue, " ili kasnije.");
    },
    "unavailableDate": "Odabrani datum nije dostupan."
};


var $8d38e5deadd04c26$export$2e2bcd8739ae039 = {};
$8d38e5deadd04c26$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Az \xe9rt\xe9knek ".concat(args.maxValue, " vagy kor\xe1bbinak kell lennie.");
    },
    "rangeReversed": "A kezd\u0151 d\xe1tumnak a befejez\u0151 d\xe1tumn\xe1l kor\xe1bbinak kell lennie.",
    "rangeUnderflow": function(args) {
        return "Az \xe9rt\xe9knek ".concat(args.minValue, " vagy k\xe9s\u0151bbinek kell lennie.");
    },
    "unavailableDate": "A kiv\xe1lasztott d\xe1tum nem \xe9rhet\u0151 el."
};


var $742f2bf91acd0c64$export$2e2bcd8739ae039 = {};
$742f2bf91acd0c64$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Il valore deve essere ".concat(args.maxValue, " o precedente.");
    },
    "rangeReversed": "La data di inizio deve essere antecedente alla data di fine.",
    "rangeUnderflow": function(args) {
        return "Il valore deve essere ".concat(args.minValue, " o successivo.");
    },
    "unavailableDate": "Data selezionata non disponibile."
};


var $b0f0b98fa83039d6$export$2e2bcd8739ae039 = {};
$b0f0b98fa83039d6$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u5024\u306F ".concat(args.maxValue, " \u4EE5\u4E0B\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002");
    },
    "rangeReversed": "\u958B\u59CB\u65E5\u306F\u7D42\u4E86\u65E5\u3088\u308A\u524D\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    "rangeUnderflow": function(args) {
        return "\u5024\u306F ".concat(args.minValue, " \u4EE5\u4E0A\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002");
    },
    "unavailableDate": "\u9078\u629E\u3057\u305F\u65E5\u4ED8\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002"
};


var $93fa76feea9f1bbb$export$2e2bcd8739ae039 = {};
$93fa76feea9f1bbb$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\uAC12\uC740 ".concat(args.maxValue, " \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.");
    },
    "rangeReversed": "\uC2DC\uC791\uC77C\uC740 \uC885\uB8CC\uC77C \uC774\uC804\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.",
    "rangeUnderflow": function(args) {
        return "\uAC12\uC740 ".concat(args.minValue, " \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.");
    },
    "unavailableDate": "\uC120\uD0DD\uD55C \uB0A0\uC9DC\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."
};


var $3f684779c6513abe$export$2e2bcd8739ae039 = {};
$3f684779c6513abe$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Reik\u0161m\u0117 turi b\u016Bti ".concat(args.maxValue, " arba ankstesn\u0117.");
    },
    "rangeReversed": "Prad\u017Eios data turi b\u016Bti ankstesn\u0117 nei pabaigos data.",
    "rangeUnderflow": function(args) {
        return "Reik\u0161m\u0117 turi b\u016Bti ".concat(args.minValue, " arba naujesn\u0117.");
    },
    "unavailableDate": "Pasirinkta data nepasiekiama."
};


var $d40d996cb6ebab10$export$2e2bcd8739ae039 = {};
$d40d996cb6ebab10$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "V\u0113rt\u012Bbai ir j\u0101b\u016Bt ".concat(args.maxValue, " vai agr\u0101kai.");
    },
    "rangeReversed": "S\u0101kuma datumam ir j\u0101b\u016Bt pirms beigu datuma.",
    "rangeUnderflow": function(args) {
        return "V\u0113rt\u012Bbai ir j\u0101b\u016Bt ".concat(args.minValue, " vai v\u0113l\u0101kai.");
    },
    "unavailableDate": "Atlas\u012Btais datums nav pieejams."
};


var $d59532cf4fde0de4$export$2e2bcd8739ae039 = {};
$d59532cf4fde0de4$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Verdien m\xe5 v\xe6re ".concat(args.maxValue, " eller tidligere.");
    },
    "rangeReversed": "Startdatoen m\xe5 v\xe6re f\xf8r sluttdatoen.",
    "rangeUnderflow": function(args) {
        return "Verdien m\xe5 v\xe6re ".concat(args.minValue, " eller senere.");
    },
    "unavailableDate": "Valgt dato utilgjengelig."
};


var $b529d1251cda9701$export$2e2bcd8739ae039 = {};
$b529d1251cda9701$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Waarde moet ".concat(args.maxValue, " of eerder zijn.");
    },
    "rangeReversed": "De startdatum moet voor de einddatum liggen.",
    "rangeUnderflow": function(args) {
        return "Waarde moet ".concat(args.minValue, " of later zijn.");
    },
    "unavailableDate": "Geselecteerde datum niet beschikbaar."
};


var $9ea8bfea3b43bdc4$export$2e2bcd8739ae039 = {};
$9ea8bfea3b43bdc4$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Warto\u015B\u0107 musi mie\u0107 warto\u015B\u0107 ".concat(args.maxValue, " lub wcze\u015Bniejsz\u0105.");
    },
    "rangeReversed": "Data rozpocz\u0119cia musi by\u0107 wcze\u015Bniejsza ni\u017C data zako\u0144czenia.",
    "rangeUnderflow": function(args) {
        return "Warto\u015B\u0107 musi mie\u0107 warto\u015B\u0107 ".concat(args.minValue, " lub p\xf3\u017Aniejsz\u0105.");
    },
    "unavailableDate": "Wybrana data jest niedost\u0119pna."
};


var $a640ab38aa2d0640$export$2e2bcd8739ae039 = {};
$a640ab38aa2d0640$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "O valor deve ser ".concat(args.maxValue, " ou anterior.");
    },
    "rangeReversed": "A data inicial deve ser anterior \xe0 data final.",
    "rangeUnderflow": function(args) {
        return "O valor deve ser ".concat(args.minValue, " ou posterior.");
    },
    "unavailableDate": "Data selecionada indispon\xedvel."
};


var $c7c70a00fff16f00$export$2e2bcd8739ae039 = {};
$c7c70a00fff16f00$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "O valor tem de ser ".concat(args.maxValue, " ou anterior.");
    },
    "rangeReversed": "A data de in\xedcio deve ser anterior \xe0 data de fim.",
    "rangeUnderflow": function(args) {
        return "O valor tem de ser ".concat(args.minValue, " ou posterior.");
    },
    "unavailableDate": "Data selecionada indispon\xedvel."
};


var $f7aef10964c909c6$export$2e2bcd8739ae039 = {};
$f7aef10964c909c6$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Valoarea trebuie s\u0103 fie ".concat(args.maxValue, " sau anterioar\u0103.");
    },
    "rangeReversed": "Data de \xeenceput trebuie s\u0103 fie anterioar\u0103 datei de sf\xe2r\u0219it.",
    "rangeUnderflow": function(args) {
        return "Valoarea trebuie s\u0103 fie ".concat(args.minValue, " sau ulterioar\u0103.");
    },
    "unavailableDate": "Data selectat\u0103 nu este disponibil\u0103."
};


var $814e52befd475e44$export$2e2bcd8739ae039 = {};
$814e52befd475e44$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u043F\u043E\u0437\u0436\u0435 ".concat(args.maxValue, ".");
    },
    "rangeReversed": "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0448\u0435\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u0442\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F.",
    "rangeUnderflow": function(args) {
        return "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u0440\u0430\u043D\u044C\u0448\u0435 ".concat(args.minValue, ".");
    },
    "unavailableDate": "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430."
};


var $acd12d49897dae8e$export$2e2bcd8739ae039 = {};
$acd12d49897dae8e$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Hodnota mus\xed by\u0165 ".concat(args.maxValue, " alebo skor\u0161ia.");
    },
    "rangeReversed": "D\xe1tum za\u010Diatku mus\xed by\u0165 skor\u0161\xed ako d\xe1tum konca.",
    "rangeUnderflow": function(args) {
        return "Hodnota mus\xed by\u0165 ".concat(args.minValue, " alebo neskor\u0161ia.");
    },
    "unavailableDate": "Vybrat\xfd d\xe1tum je nedostupn\xfd."
};


var $3d4a81807d3cbd91$export$2e2bcd8739ae039 = {};
$3d4a81807d3cbd91$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Vrednost mora biti ".concat(args.maxValue, " ali starej\u0161a.");
    },
    "rangeReversed": "Za\u010Detni datum mora biti pred kon\u010Dnim datumom.",
    "rangeUnderflow": function(args) {
        return "Vrednost mora biti ".concat(args.minValue, " ali novej\u0161a.");
    },
    "unavailableDate": "Izbrani datum ni na voljo."
};


var $f551966fbec89544$export$2e2bcd8739ae039 = {};
$f551966fbec89544$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "Vrednost mora da bude ".concat(args.maxValue, " ili starija.");
    },
    "rangeReversed": "Datum po\u010Detka mora biti pre datuma zavr\u0161etka.",
    "rangeUnderflow": function(args) {
        return "Vrednost mora da bude ".concat(args.minValue, " ili novija.");
    },
    "unavailableDate": "Izabrani datum nije dostupan."
};


var $1b28085a763c8b11$export$2e2bcd8739ae039 = {};
$1b28085a763c8b11$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "V\xe4rdet m\xe5ste vara ".concat(args.maxValue, " eller tidigare.");
    },
    "rangeReversed": "Startdatumet m\xe5ste vara f\xf6re slutdatumet.",
    "rangeUnderflow": function(args) {
        return "V\xe4rdet m\xe5ste vara ".concat(args.minValue, " eller senare.");
    },
    "unavailableDate": "Det valda datumet \xe4r inte tillg\xe4ngligt."
};


var $d3d581c5ed17d8eb$export$2e2bcd8739ae039 = {};
$d3d581c5ed17d8eb$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "De\u011Fer, ".concat(args.maxValue, " veya \xf6ncesi olmal\u0131d\u0131r.");
    },
    "rangeReversed": "Ba\u015Flang\u0131\xe7 tarihi biti\u015F tarihinden \xf6nce olmal\u0131d\u0131r.",
    "rangeUnderflow": function(args) {
        return "De\u011Fer, ".concat(args.minValue, " veya sonras\u0131 olmal\u0131d\u0131r.");
    },
    "unavailableDate": "Se\xe7ilen tarih kullan\u0131lam\u0131yor."
};


var $06cdcee67961bb53$export$2e2bcd8739ae039 = {};
$06cdcee67961bb53$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043D\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435 ".concat(args.maxValue, ".");
    },
    "rangeReversed": "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043C\u0430\u0454 \u043F\u0435\u0440\u0435\u0434\u0443\u0432\u0430\u0442\u0438 \u0434\u0430\u0442\u0456 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F.",
    "rangeUnderflow": function(args) {
        return "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043D\u0435 \u0440\u0430\u043D\u0456\u0448\u0435 ".concat(args.minValue, ".");
    },
    "unavailableDate": "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430."
};


var $a52714e846c6c90b$export$2e2bcd8739ae039 = {};
$a52714e846c6c90b$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u503C\u5FC5\u987B\u662F ".concat(args.maxValue, " \u6216\u66F4\u65E9\u65E5\u671F\u3002");
    },
    "rangeReversed": "\u5F00\u59CB\u65E5\u671F\u5FC5\u987B\u65E9\u4E8E\u7ED3\u675F\u65E5\u671F\u3002",
    "rangeUnderflow": function(args) {
        return "\u503C\u5FC5\u987B\u662F ".concat(args.minValue, " \u6216\u66F4\u665A\u65E5\u671F\u3002");
    },
    "unavailableDate": "\u6240\u9009\u65E5\u671F\u4E0D\u53EF\u7528\u3002"
};


var $904440578df8203a$export$2e2bcd8739ae039 = {};
$904440578df8203a$export$2e2bcd8739ae039 = {
    "rangeOverflow": function(args) {
        return "\u503C\u5FC5\u9808\u662F ".concat(args.maxValue, " \u6216\u66F4\u65E9\u3002");
    },
    "rangeReversed": "\u958B\u59CB\u65E5\u671F\u5FC5\u9808\u5728\u7D50\u675F\u65E5\u671F\u4E4B\u524D\u3002",
    "rangeUnderflow": function(args) {
        return "\u503C\u5FC5\u9808\u662F ".concat(args.minValue, " \u6216\u66F4\u665A\u3002");
    },
    "unavailableDate": "\u6240\u9078\u65E5\u671F\u7121\u6CD5\u4F7F\u7528\u3002"
};


var $55e9e3dec1b8a44a$export$2e2bcd8739ae039 = {};
$55e9e3dec1b8a44a$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $c5079f2e71d3f914$export$2e2bcd8739ae039),
    "bg-BG": (0, $1d5db3bddf1a761b$export$2e2bcd8739ae039),
    "cs-CZ": (0, $79ef32e4d2160b9d$export$2e2bcd8739ae039),
    "da-DK": (0, $abeedb27d6c769b2$export$2e2bcd8739ae039),
    "de-DE": (0, $233c16fad45d2198$export$2e2bcd8739ae039),
    "el-GR": (0, $21186e3201e046d2$export$2e2bcd8739ae039),
    "en-US": (0, $2d2b9c68087ff8b7$export$2e2bcd8739ae039),
    "es-ES": (0, $3756a5b1c3541a36$export$2e2bcd8739ae039),
    "et-EE": (0, $8ec2aa4122b50655$export$2e2bcd8739ae039),
    "fi-FI": (0, $59afe2e29b5a1045$export$2e2bcd8739ae039),
    "fr-FR": (0, $509a6feb1da978f2$export$2e2bcd8739ae039),
    "he-IL": (0, $37730aeb8fb20af1$export$2e2bcd8739ae039),
    "hr-HR": (0, $4edb462ccbdc7d20$export$2e2bcd8739ae039),
    "hu-HU": (0, $8d38e5deadd04c26$export$2e2bcd8739ae039),
    "it-IT": (0, $742f2bf91acd0c64$export$2e2bcd8739ae039),
    "ja-JP": (0, $b0f0b98fa83039d6$export$2e2bcd8739ae039),
    "ko-KR": (0, $93fa76feea9f1bbb$export$2e2bcd8739ae039),
    "lt-LT": (0, $3f684779c6513abe$export$2e2bcd8739ae039),
    "lv-LV": (0, $d40d996cb6ebab10$export$2e2bcd8739ae039),
    "nb-NO": (0, $d59532cf4fde0de4$export$2e2bcd8739ae039),
    "nl-NL": (0, $b529d1251cda9701$export$2e2bcd8739ae039),
    "pl-PL": (0, $9ea8bfea3b43bdc4$export$2e2bcd8739ae039),
    "pt-BR": (0, $a640ab38aa2d0640$export$2e2bcd8739ae039),
    "pt-PT": (0, $c7c70a00fff16f00$export$2e2bcd8739ae039),
    "ro-RO": (0, $f7aef10964c909c6$export$2e2bcd8739ae039),
    "ru-RU": (0, $814e52befd475e44$export$2e2bcd8739ae039),
    "sk-SK": (0, $acd12d49897dae8e$export$2e2bcd8739ae039),
    "sl-SI": (0, $3d4a81807d3cbd91$export$2e2bcd8739ae039),
    "sr-SP": (0, $f551966fbec89544$export$2e2bcd8739ae039),
    "sv-SE": (0, $1b28085a763c8b11$export$2e2bcd8739ae039),
    "tr-TR": (0, $d3d581c5ed17d8eb$export$2e2bcd8739ae039),
    "uk-UA": (0, $06cdcee67961bb53$export$2e2bcd8739ae039),
    "zh-CN": (0, $a52714e846c6c90b$export$2e2bcd8739ae039),
    "zh-TW": (0, $904440578df8203a$export$2e2bcd8739ae039)
};






var $ggE0n = parcelRequire("ggE0n");
function $d723c63582520b7d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $d723c63582520b7d$var$$35a22f14a1f04b11$var$dictionary = new (0, $11d7852987212578$export$c17fa47878dc55b6)($d723c63582520b7d$var$$parcel$interopDefault((0, $55e9e3dec1b8a44a$export$2e2bcd8739ae039)));
function $d723c63582520b7d$var$$35a22f14a1f04b11$var$getLocale() {
    // Match browser language setting here, NOT react-aria's I18nProvider, so that we match other browser-provided
    // validation messages, which to not respect our provider's language.
    // @ts-ignore
    return typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
}
function $d723c63582520b7d$export$f18627323ab57ac0(value, minValue, maxValue, isDateUnavailable, options) {
    var rangeOverflow = value != null && maxValue != null && value.compare(maxValue) > 0;
    var rangeUnderflow = value != null && minValue != null && value.compare(minValue) < 0;
    var isUnavailable = value != null && (isDateUnavailable === null || isDateUnavailable === void 0 ? void 0 : isDateUnavailable(value)) || false;
    var isInvalid = rangeOverflow || rangeUnderflow || isUnavailable;
    var errors = [];
    if (isInvalid) {
        var locale = $d723c63582520b7d$var$$35a22f14a1f04b11$var$getLocale();
        var strings = (0, $11d7852987212578$export$c17fa47878dc55b6).getGlobalDictionaryForPackage('@react-stately/datepicker') || $d723c63582520b7d$var$$35a22f14a1f04b11$var$dictionary;
        var formatter = new (0, $8c3c9b101bb1fdda$export$2f817fcdc4b89ae0)(locale, strings);
        var dateFormatter = new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, $d723c63582520b7d$export$7e319ea407e63bc0({}, options));
        var timeZone = dateFormatter.resolvedOptions().timeZone;
        if (rangeUnderflow && minValue != null) errors.push(formatter.format('rangeUnderflow', {
            minValue: dateFormatter.format(minValue.toDate(timeZone))
        }));
        if (rangeOverflow && maxValue != null) errors.push(formatter.format('rangeOverflow', {
            maxValue: dateFormatter.format(maxValue.toDate(timeZone))
        }));
        if (isUnavailable) errors.push(formatter.format('unavailableDate'));
    }
    return {
        isInvalid: isInvalid,
        validationErrors: errors,
        validationDetails: {
            badInput: isUnavailable,
            customError: false,
            patternMismatch: false,
            rangeOverflow: rangeOverflow,
            rangeUnderflow: rangeUnderflow,
            stepMismatch: false,
            tooLong: false,
            tooShort: false,
            typeMismatch: false,
            valueMissing: false,
            valid: !isInvalid
        }
    };
}
function $d723c63582520b7d$export$80ff8fc0ae339c13(value, minValue, maxValue, isDateUnavailable, options) {
    var _value_start;
    var startValidation = $d723c63582520b7d$export$f18627323ab57ac0((_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : null, minValue, maxValue, isDateUnavailable, options);
    var _value_end;
    var endValidation = $d723c63582520b7d$export$f18627323ab57ac0((_value_end = value === null || value === void 0 ? void 0 : value.end) !== null && _value_end !== void 0 ? _value_end : null, minValue, maxValue, isDateUnavailable, options);
    var result = (0, $7aa741b584fcccb5$export$75ee7c75d68f5b0e)(startValidation, endValidation);
    if ((value === null || value === void 0 ? void 0 : value.end) != null && value.start != null && value.end.compare(value.start) < 0) {
        var strings = (0, $11d7852987212578$export$c17fa47878dc55b6).getGlobalDictionaryForPackage('@react-stately/datepicker') || $d723c63582520b7d$var$$35a22f14a1f04b11$var$dictionary;
        result = (0, $7aa741b584fcccb5$export$75ee7c75d68f5b0e)(result, {
            isInvalid: true,
            validationErrors: [
                strings.getStringForLocale('rangeReversed', $d723c63582520b7d$var$$35a22f14a1f04b11$var$getLocale())
            ],
            validationDetails: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $7aa741b584fcccb5$export$aca958c65c314e6c)), {
                rangeUnderflow: true,
                rangeOverflow: true,
                valid: false
            })
        });
    }
    return result;
}
var $d723c63582520b7d$var$$35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit'
};
var $d723c63582520b7d$var$$35a22f14a1f04b11$var$TWO_DIGIT_FIELD_OPTIONS = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
};
function $d723c63582520b7d$export$7e319ea407e63bc0(fieldOptions, options) {
    var defaultFieldOptions = options.shouldForceLeadingZeros ? $d723c63582520b7d$var$$35a22f14a1f04b11$var$TWO_DIGIT_FIELD_OPTIONS : $d723c63582520b7d$var$$35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS;
    fieldOptions = (0, $2QPpE._)({}, defaultFieldOptions, fieldOptions);
    var granularity = options.granularity || 'minute';
    var keys = Object.keys(fieldOptions);
    var _options_maxGranularity;
    var startIdx = keys.indexOf((_options_maxGranularity = options.maxGranularity) !== null && _options_maxGranularity !== void 0 ? _options_maxGranularity : 'year');
    if (startIdx < 0) startIdx = 0;
    var endIdx = keys.indexOf(granularity);
    if (endIdx < 0) endIdx = 2;
    if (startIdx > endIdx) throw new Error('maxGranularity must be greater than granularity');
    var opts = keys.slice(startIdx, endIdx + 1).reduce(function(opts, key) {
        opts[key] = fieldOptions[key];
        return opts;
    }, {});
    if (options.hourCycle != null) opts.hour12 = options.hourCycle === 12;
    opts.timeZone = options.timeZone || 'UTC';
    var hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    if (hasTime && options.timeZone && !options.hideTimeZone) opts.timeZoneName = 'short';
    if (options.showEra && startIdx === 0) opts.era = 'short';
    return opts;
}
function $d723c63582520b7d$export$c5221a78ef73c5e9(placeholderValue) {
    if (placeholderValue && 'hour' in placeholderValue) return placeholderValue;
    return new (0, $544adb0fa0f2d511$export$680ea196effce5f)();
}
function $d723c63582520b7d$export$61a490a80c552550(value, calendar) {
    if (value === null) return null;
    if (!value) return undefined;
    return (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(value, calendar);
}
function $d723c63582520b7d$export$66aa2b09de4b1ea5(placeholderValue, granularity, calendar, timeZone) {
    if (placeholderValue) return $d723c63582520b7d$export$61a490a80c552550(placeholderValue, calendar);
    var date = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)((0, $b20616b02fb62709$export$461939dd4422153)(timeZone !== null && timeZone !== void 0 ? timeZone : (0, $b20616b02fb62709$export$aa8b41735afcabd2)()).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
    }), calendar);
    if (granularity === 'year' || granularity === 'month' || granularity === 'day') return (0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(date);
    if (!timeZone) return (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(date);
    return date;
}
function $d723c63582520b7d$export$2440da353cedad43(v, granularity) {
    // Compute default granularity and time zone from the value. If the value becomes null, keep the last values.
    var defaultTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
    var defaultGranularity = v && 'minute' in v ? 'minute' : 'day';
    // props.granularity must actually exist in the value if one is provided.
    if (v && granularity && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    var _$bUJMr$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)([
        defaultGranularity,
        defaultTimeZone
    ]), 2), lastValue = _$bUJMr$useState[0], setLastValue = _$bUJMr$useState[1];
    // If the granularity or time zone changed, update the last value.
    if (v && (lastValue[0] !== defaultGranularity || lastValue[1] !== defaultTimeZone)) setLastValue([
        defaultGranularity,
        defaultTimeZone
    ]);
    if (!granularity) granularity = v ? defaultGranularity : lastValue[0];
    var timeZone = v ? defaultTimeZone : lastValue[1];
    return [
        granularity,
        timeZone
    ];
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // These placeholders are based on the strings used by the <input type="date">
// implementations in Chrome and Firefox. Additional languages are supported
// here than React Spectrum's typical translations.
var $d329e6249bffa574$var$$3e3ed55ab2966714$var$placeholders = new (0, $11d7852987212578$export$c17fa47878dc55b6)({
    ach: {
        year: 'mwaka',
        month: 'dwe',
        day: 'nino'
    },
    af: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    am: {
        year: "\u12D3\u12D3\u12D3\u12D3",
        month: "\u121A\u121C",
        day: "\u1240\u1240"
    },
    an: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    ar: {
        year: "\u0633\u0646\u0629",
        month: "\u0634\u0647\u0631",
        day: "\u064A\u0648\u0645"
    },
    ast: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    az: {
        year: 'iiii',
        month: 'aa',
        day: 'gg'
    },
    be: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bg: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bn: {
        year: 'yyyy',
        month: "\u09AE\u09BF\u09AE\u09BF",
        day: 'dd'
    },
    br: {
        year: 'bbbb',
        month: 'mm',
        day: 'dd'
    },
    bs: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    ca: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    cak: {
        year: 'jjjj',
        month: 'ii',
        day: "q'q'"
    },
    ckb: {
        year: "\u0633\u0627\u06B5",
        month: "\u0645\u0627\u0646\u06AF",
        day: "\u0695\u06C6\u0698"
    },
    cs: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    cy: {
        year: 'bbbb',
        month: 'mm',
        day: 'dd'
    },
    da: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    de: {
        year: 'jjjj',
        month: 'mm',
        day: 'tt'
    },
    dsb: {
        year: 'llll',
        month: 'mm',
        day: "\u017A\u017A"
    },
    el: {
        year: "\u03B5\u03B5\u03B5\u03B5",
        month: "\u03BC\u03BC",
        day: "\u03B7\u03B7"
    },
    en: {
        year: 'yyyy',
        month: 'mm',
        day: 'dd'
    },
    eo: {
        year: 'jjjj',
        month: 'mm',
        day: 'tt'
    },
    es: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    et: {
        year: 'aaaa',
        month: 'kk',
        day: 'pp'
    },
    eu: {
        year: 'uuuu',
        month: 'hh',
        day: 'ee'
    },
    fa: {
        year: "\u0633\u0627\u0644",
        month: "\u0645\u0627\u0647",
        day: "\u0631\u0648\u0632"
    },
    ff: {
        year: 'hhhh',
        month: 'll',
        day: "\xf1\xf1"
    },
    fi: {
        year: 'vvvv',
        month: 'kk',
        day: 'pp'
    },
    fr: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    fy: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    ga: {
        year: 'bbbb',
        month: 'mm',
        day: 'll'
    },
    gd: {
        year: 'bbbb',
        month: 'mm',
        day: 'll'
    },
    gl: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    he: {
        year: "\u05E9\u05E0\u05D4",
        month: "\u05D7\u05D5\u05D3\u05E9",
        day: "\u05D9\u05D5\u05DD"
    },
    hr: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    hsb: {
        year: 'llll',
        month: 'mm',
        day: 'dd'
    },
    hu: {
        year: "\xe9\xe9\xe9\xe9",
        month: 'hh',
        day: 'nn'
    },
    ia: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    id: {
        year: 'tttt',
        month: 'bb',
        day: 'hh'
    },
    it: {
        year: 'aaaa',
        month: 'mm',
        day: 'gg'
    },
    ja: {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    ka: {
        year: "\u10EC\u10EC\u10EC\u10EC",
        month: "\u10D7\u10D7",
        day: "\u10E0\u10E0"
    },
    kk: {
        year: "\u0436\u0436\u0436\u0436",
        month: "\u0430\u0430",
        day: "\u043A\u043A"
    },
    kn: {
        year: "\u0CB5\u0CB5\u0CB5\u0CB5",
        month: "\u0CAE\u0CBF\u0CAE\u0CC0",
        day: "\u0CA6\u0CBF\u0CA6\u0CBF"
    },
    ko: {
        year: "\uC5F0\uB3C4",
        month: "\uC6D4",
        day: "\uC77C"
    },
    lb: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    lo: {
        year: "\u0E9B\u0E9B\u0E9B\u0E9B",
        month: "\u0E94\u0E94",
        day: "\u0EA7\u0EA7"
    },
    lt: {
        year: 'mmmm',
        month: 'mm',
        day: 'dd'
    },
    lv: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    meh: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    ml: {
        year: "\u0D35\u0D7C\u0D37\u0D02",
        month: "\u0D2E\u0D3E\u0D38\u0D02",
        day: "\u0D24\u0D40\u0D2F\u0D24\u0D3F"
    },
    ms: {
        year: 'tttt',
        month: 'mm',
        day: 'hh'
    },
    nl: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    nn: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    no: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    oc: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    pl: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    pt: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    rm: {
        year: 'oooo',
        month: 'mm',
        day: 'dd'
    },
    ro: {
        year: 'aaaa',
        month: 'll',
        day: 'zz'
    },
    ru: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sc: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    scn: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    sk: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    sl: {
        year: 'llll',
        month: 'mm',
        day: 'dd'
    },
    sr: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sv: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    szl: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    tg: {
        year: "\u0441\u0441\u0441\u0441",
        month: "\u043C\u043C",
        day: "\u0440\u0440"
    },
    th: {
        year: "\u0E1B\u0E1B\u0E1B\u0E1B",
        month: "\u0E14\u0E14",
        day: "\u0E27\u0E27"
    },
    tr: {
        year: 'yyyy',
        month: 'aa',
        day: 'gg'
    },
    uk: {
        year: "\u0440\u0440\u0440\u0440",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    'zh-CN': {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    'zh-TW': {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    }
}, 'en');
function $d329e6249bffa574$export$d3f5c5e0a5023fa0(field, value, locale) {
    // Use the actual placeholder value for the era and day period fields.
    if (field === 'era' || field === 'dayPeriod') return value;
    if (field === 'year' || field === 'month' || field === 'day') return $d329e6249bffa574$var$$3e3ed55ab2966714$var$placeholders.getStringForLocale(field, locale);
    // For time fields (e.g. hour, minute, etc.), use two dashes as the placeholder.
    return "\u2013\u2013";
}






var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $9b34374903a0d87e$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS = {
    year: true,
    month: true,
    day: true,
    hour: true,
    minute: true,
    second: true,
    dayPeriod: true,
    era: true
};
var $9b34374903a0d87e$var$$3c0fc76039f1c516$var$PAGE_STEP = {
    year: 5,
    month: 2,
    day: 7,
    hour: 2,
    minute: 15,
    second: 15
};
var $9b34374903a0d87e$var$$3c0fc76039f1c516$var$TYPE_MAPPING = {
    // Node seems to convert everything to lowercase...
    dayperiod: 'dayPeriod',
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts#named_years
    relatedYear: 'year',
    yearName: 'literal',
    unknown: 'literal'
};
function $9b34374903a0d87e$export$60e84778edff6d26(props) {
    var locale = props.locale, createCalendar = props.createCalendar, hideTimeZone = props.hideTimeZone, tmp = props.isDisabled, isDisabled = tmp === void 0 ? false : tmp, tmp1 = props.isReadOnly, isReadOnly = tmp1 === void 0 ? false : tmp1, tmp2 = props.isRequired, isRequired = tmp2 === void 0 ? false : tmp2, minValue = props.minValue, maxValue = props.maxValue, isDateUnavailable = props.isDateUnavailable;
    var v = props.value || props.defaultValue || props.placeholderValue || null;
    var _$35a22f14a1f04b11$export$2440da353cedad43 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $d723c63582520b7d$export$2440da353cedad43)(v, props.granularity), 2), granularity = _$35a22f14a1f04b11$export$2440da353cedad43[0], defaultTimeZone = _$35a22f14a1f04b11$export$2440da353cedad43[1];
    var timeZone = defaultTimeZone || 'UTC';
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    var defaultFormatter = (0, $ggE0n.useMemo)(function() {
        return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale);
    }, [
        locale
    ]);
    var calendar = (0, $ggE0n.useMemo)(function() {
        return createCalendar(defaultFormatter.resolvedOptions().calendar);
    }, [
        createCalendar,
        defaultFormatter
    ]);
    var _props_defaultValue;
    var _$g03ag$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange), 2), value = _$g03ag$useControlledState[0], setDate = _$g03ag$useControlledState[1];
    var calendarValue = (0, $ggE0n.useMemo)(function() {
        var _convertValue;
        return (_convertValue = (0, $d723c63582520b7d$export$61a490a80c552550)(value, calendar)) !== null && _convertValue !== void 0 ? _convertValue : null;
    }, [
        value,
        calendar
    ]);
    // We keep track of the placeholder date separately in state so that onChange is not called
    // until all segments are set. If the value === null (not undefined), then assume the component
    // is controlled, so use the placeholder as the value until all segments are entered so it doesn't
    // change from uncontrolled to controlled and emit a warning.
    var _$g03ag$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        return (0, $d723c63582520b7d$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone);
    }), 2), placeholderDate = _$g03ag$useState[0], setPlaceholderDate = _$g03ag$useState[1];
    var val = calendarValue || placeholderDate;
    var showEra = calendar.identifier === 'gregory' && val.era === 'BC';
    var formatOpts = (0, $ggE0n.useMemo)(function() {
        var _props_maxGranularity;
        return {
            granularity: granularity,
            maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : 'year',
            timeZone: defaultTimeZone,
            hideTimeZone: hideTimeZone,
            hourCycle: props.hourCycle,
            showEra: showEra,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros
        };
    }, [
        props.maxGranularity,
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        hideTimeZone,
        showEra
    ]);
    var opts = (0, $ggE0n.useMemo)(function() {
        return (0, $d723c63582520b7d$export$7e319ea407e63bc0)({}, formatOpts);
    }, [
        formatOpts
    ]);
    var dateFormatter = (0, $ggE0n.useMemo)(function() {
        return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, opts);
    }, [
        locale,
        opts
    ]);
    var resolvedOptions = (0, $ggE0n.useMemo)(function() {
        return dateFormatter.resolvedOptions();
    }, [
        dateFormatter
    ]);
    // Determine how many editable segments there are for validation purposes.
    // The result is cached for performance.
    var allSegments = (0, $ggE0n.useMemo)(function() {
        return dateFormatter.formatToParts(new Date()).filter(function(seg) {
            return $9b34374903a0d87e$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[seg.type];
        }).reduce(function(p, seg) {
            return p[$9b34374903a0d87e$var$$3c0fc76039f1c516$var$TYPE_MAPPING[seg.type] || seg.type] = true, p;
        }, {});
    }, [
        dateFormatter
    ]);
    var _$g03ag$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        return props.value || props.defaultValue ? (0, $2QPpE._)({}, allSegments) : {};
    }), 2), validSegments = _$g03ag$useState1[0], setValidSegments = _$g03ag$useState1[1];
    var clearedSegment = (0, $ggE0n.useRef)(null);
    // Reset placeholder when calendar changes
    var lastCalendar = (0, $ggE0n.useRef)(calendar);
    (0, $ggE0n.useEffect)(function() {
        if (!(0, $b20616b02fb62709$export$dbc69fd56b53d5e)(calendar, lastCalendar.current)) {
            lastCalendar.current = calendar;
            setPlaceholderDate(function(placeholder) {
                return Object.keys(validSegments).length > 0 ? (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(placeholder, calendar) : (0, $d723c63582520b7d$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone);
            });
        }
    }, [
        calendar,
        granularity,
        validSegments,
        defaultTimeZone,
        props.placeholderValue
    ]);
    // If there is a value prop, and some segments were previously placeholders, mark them all as valid.
    if (value && Object.keys(validSegments).length < Object.keys(allSegments).length) {
        validSegments = (0, $2QPpE._)({}, allSegments);
        setValidSegments(validSegments);
    }
    // If the value is set to null and all segments are valid, reset the placeholder.
    if (value == null && Object.keys(validSegments).length === Object.keys(allSegments).length) {
        validSegments = {};
        setValidSegments(validSegments);
        setPlaceholderDate((0, $d723c63582520b7d$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone));
    }
    // If all segments are valid, use the date from state, otherwise use the placeholder date.
    var displayValue = calendarValue && Object.keys(validSegments).length >= Object.keys(allSegments).length ? calendarValue : placeholderDate;
    var setValue = function(newValue) {
        if (props.isDisabled || props.isReadOnly) return;
        var validKeys = Object.keys(validSegments);
        var allKeys = Object.keys(allSegments);
        // if all the segments are completed or a timefield with everything but am/pm set the time, also ignore when am/pm cleared
        if (newValue == null) {
            setDate(null);
            setPlaceholderDate((0, $d723c63582520b7d$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone));
            setValidSegments({});
        } else if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod && clearedSegment.current !== 'dayPeriod') {
            // The display calendar should not have any effect on the emitted value.
            // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
            newValue = (0, $c7eb0f5ee6d7094f$export$b4a036af3fc0b032)(newValue, (v === null || v === void 0 ? void 0 : v.calendar) || new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)());
            setDate(newValue);
        } else setPlaceholderDate(newValue);
        clearedSegment.current = null;
    };
    var dateValue = (0, $ggE0n.useMemo)(function() {
        return displayValue.toDate(timeZone);
    }, [
        displayValue,
        timeZone
    ]);
    var segments = (0, $ggE0n.useMemo)(function() {
        return $9b34374903a0d87e$var$$3c0fc76039f1c516$var$processSegments(dateValue, validSegments, dateFormatter, resolvedOptions, displayValue, calendar, locale, granularity);
    }, [
        dateValue,
        validSegments,
        dateFormatter,
        resolvedOptions,
        displayValue,
        calendar,
        locale,
        granularity
    ]);
    // When the era field appears, mark it valid if the year field is already valid.
    // If the era field disappears, remove it from the valid segments.
    if (allSegments.era && validSegments.year && !validSegments.era) {
        validSegments.era = true;
        setValidSegments((0, $2QPpE._)({}, validSegments));
    } else if (!allSegments.era && validSegments.era) {
        delete validSegments.era;
        setValidSegments((0, $2QPpE._)({}, validSegments));
    }
    var markValid = function(part) {
        validSegments[part] = true;
        if (part === 'year' && allSegments.era) validSegments.era = true;
        setValidSegments((0, $2QPpE._)({}, validSegments));
    };
    var adjustSegment = function(type, amount) {
        if (!validSegments[type]) {
            markValid(type);
            var validKeys = Object.keys(validSegments);
            var allKeys = Object.keys(allSegments);
            if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) setValue(displayValue);
        } else setValue($9b34374903a0d87e$var$$3c0fc76039f1c516$var$addSegment(displayValue, type, amount, resolvedOptions));
    };
    var builtinValidation = (0, $ggE0n.useMemo)(function() {
        return (0, $d723c63582520b7d$export$f18627323ab57ac0)(value, minValue, maxValue, isDateUnavailable, formatOpts);
    }, [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    var validation = (0, $7aa741b584fcccb5$export$fc1a364ae1f3ff10)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        value: value,
        builtinValidation: builtinValidation
    }));
    var isValueInvalid = validation.displayValidation.isInvalid;
    var validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    var _props_maxGranularity;
    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, validation), {
        value: calendarValue,
        dateValue: dateValue,
        calendar: calendar,
        setValue: setValue,
        segments: segments,
        dateFormatter: dateFormatter,
        validationState: validationState,
        isInvalid: isValueInvalid,
        granularity: granularity,
        maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : 'year',
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        increment: function(part) {
            adjustSegment(part, 1);
        },
        decrement: function(part) {
            adjustSegment(part, -1);
        },
        incrementPage: function(part) {
            adjustSegment(part, $9b34374903a0d87e$var$$3c0fc76039f1c516$var$PAGE_STEP[part] || 1);
        },
        decrementPage: function(part) {
            adjustSegment(part, -($9b34374903a0d87e$var$$3c0fc76039f1c516$var$PAGE_STEP[part] || 1));
        },
        setSegment: function(part, v) {
            markValid(part);
            setValue($9b34374903a0d87e$var$$3c0fc76039f1c516$var$setSegment(displayValue, part, v, resolvedOptions));
        },
        confirmPlaceholder: function() {
            if (props.isDisabled || props.isReadOnly) return;
            // Confirm the placeholder if only the day period is not filled in.
            var validKeys = Object.keys(validSegments);
            var allKeys = Object.keys(allSegments);
            if (validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) {
                validSegments = (0, $2QPpE._)({}, allSegments);
                setValidSegments(validSegments);
                setValue(displayValue.copy());
            }
        },
        clearSegment: function(part) {
            delete validSegments[part];
            clearedSegment.current = part;
            setValidSegments((0, $2QPpE._)({}, validSegments));
            var placeholder = (0, $d723c63582520b7d$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone);
            var value = displayValue;
            // Reset day period to default without changing the hour.
            if (part === 'dayPeriod' && 'hour' in displayValue && 'hour' in placeholder) {
                var isPM = displayValue.hour >= 12;
                var shouldBePM = placeholder.hour >= 12;
                if (isPM && !shouldBePM) value = displayValue.set({
                    hour: displayValue.hour - 12
                });
                else if (!isPM && shouldBePM) value = displayValue.set({
                    hour: displayValue.hour + 12
                });
            } else if (part === 'hour' && 'hour' in displayValue && displayValue.hour >= 12 && validSegments.dayPeriod) value = displayValue.set({
                hour: placeholder['hour'] + 12
            });
            else if (part in displayValue) value = displayValue.set((0, $3Hxpr._)({}, part, placeholder[part]));
            setDate(null);
            setValue(value);
        },
        formatValue: function(fieldOptions) {
            if (!calendarValue) return '';
            var formatOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)(fieldOptions, formatOpts);
            var formatter = new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, formatOptions);
            return formatter.format(dateValue);
        },
        getDateFormatter: function(locale, formatOptions) {
            var newOptions = (0, $2QPpE._)({}, formatOpts, formatOptions);
            var newFormatOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, newFormatOptions);
        }
    });
}
function $9b34374903a0d87e$var$$3c0fc76039f1c516$var$processSegments(dateValue, validSegments, dateFormatter, resolvedOptions, displayValue, calendar, locale, granularity) {
    var timeValue = [
        'hour',
        'minute',
        'second'
    ];
    var segments = dateFormatter.formatToParts(dateValue);
    var processedSegments = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var type = $9b34374903a0d87e$var$$3c0fc76039f1c516$var$TYPE_MAPPING[segment.type] || segment.type;
            var isEditable = $9b34374903a0d87e$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type];
            if (type === 'era' && calendar.getEras().length === 1) isEditable = false;
            var isPlaceholder = $9b34374903a0d87e$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type] && !validSegments[type];
            var placeholder = $9b34374903a0d87e$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type] ? (0, $d329e6249bffa574$export$d3f5c5e0a5023fa0)(type, segment.value, locale) : null;
            var dateSegment = (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
                type: type,
                text: isPlaceholder ? placeholder : segment.value
            }, $9b34374903a0d87e$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, type, resolvedOptions)), {
                isPlaceholder: isPlaceholder,
                placeholder: placeholder,
                isEditable: isEditable
            });
            // There is an issue in RTL languages where time fields render (minute:hour) instead of (hour:minute).
            // To force an LTR direction on the time field since, we wrap the time segments in LRI (left-to-right) isolate unicode. See https://www.w3.org/International/questions/qa-bidi-unicode-controls.
            // These unicode characters will be added to the array of processed segments as literals and will mark the start and end of the embedded direction change. 
            if (type === 'hour') {
                // This marks the start of the embedded direction change. 
                processedSegments.push((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
                    type: 'literal',
                    text: '\u2066'
                }, $9b34374903a0d87e$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, 'literal', resolvedOptions)), {
                    isPlaceholder: false,
                    placeholder: '',
                    isEditable: false
                }));
                processedSegments.push(dateSegment);
                // This marks the end of the embedded direction change in the case that the granularity it set to "hour".
                if (type === granularity) processedSegments.push((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
                    type: 'literal',
                    text: '\u2069'
                }, $9b34374903a0d87e$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, 'literal', resolvedOptions)), {
                    isPlaceholder: false,
                    placeholder: '',
                    isEditable: false
                }));
            } else if (timeValue.includes(type) && type === granularity) {
                processedSegments.push(dateSegment);
                // This marks the end of the embedded direction change.
                processedSegments.push((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({
                    type: 'literal',
                    text: '\u2069'
                }, $9b34374903a0d87e$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, 'literal', resolvedOptions)), {
                    isPlaceholder: false,
                    placeholder: '',
                    isEditable: false
                }));
            } else processedSegments.push(dateSegment);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return processedSegments;
}
function $9b34374903a0d87e$var$$3c0fc76039f1c516$var$getSegmentLimits(date, type, options) {
    switch(type){
        case 'era':
            {
                var eras = date.calendar.getEras();
                return {
                    value: eras.indexOf(date.era),
                    minValue: 0,
                    maxValue: eras.length - 1
                };
            }
        case 'year':
            return {
                value: date.year,
                minValue: 1,
                maxValue: date.calendar.getYearsInEra(date)
            };
        case 'month':
            return {
                value: date.month,
                minValue: (0, $b20616b02fb62709$export$5412ac11713b72ad)(date),
                maxValue: date.calendar.getMonthsInYear(date)
            };
        case 'day':
            return {
                value: date.day,
                minValue: (0, $b20616b02fb62709$export$b2f4953d301981d5)(date),
                maxValue: date.calendar.getDaysInMonth(date)
            };
    }
    if ('hour' in date) switch(type){
        case 'dayPeriod':
            return {
                value: date.hour >= 12 ? 12 : 0,
                minValue: 0,
                maxValue: 12
            };
        case 'hour':
            if (options.hour12) {
                var isPM = date.hour >= 12;
                return {
                    value: date.hour,
                    minValue: isPM ? 12 : 0,
                    maxValue: isPM ? 23 : 11
                };
            }
            return {
                value: date.hour,
                minValue: 0,
                maxValue: 23
            };
        case 'minute':
            return {
                value: date.minute,
                minValue: 0,
                maxValue: 59
            };
        case 'second':
            return {
                value: date.second,
                minValue: 0,
                maxValue: 59
            };
    }
    return {};
}
function $9b34374903a0d87e$var$$3c0fc76039f1c516$var$addSegment(value, part, amount, options) {
    switch(part){
        case 'era':
        case 'year':
        case 'month':
        case 'day':
            return value.cycle(part, amount, {
                round: part === 'year'
            });
    }
    if ('hour' in value) switch(part){
        case 'dayPeriod':
            {
                var hours = value.hour;
                var isPM = hours >= 12;
                return value.set({
                    hour: isPM ? hours - 12 : hours + 12
                });
            }
        case 'hour':
        case 'minute':
        case 'second':
            return value.cycle(part, amount, {
                round: part !== 'hour',
                hourCycle: options.hour12 ? 12 : 24
            });
    }
    throw new Error('Unknown segment: ' + part);
}
function $9b34374903a0d87e$var$$3c0fc76039f1c516$var$setSegment(value, part, segmentValue, options) {
    switch(part){
        case 'day':
        case 'month':
        case 'year':
        case 'era':
            return value.set((0, $3Hxpr._)({}, part, segmentValue));
    }
    if ('hour' in value && typeof segmentValue === 'number') switch(part){
        case 'dayPeriod':
            {
                var hours = value.hour;
                var wasPM = hours >= 12;
                var isPM = segmentValue >= 12;
                if (isPM === wasPM) return value;
                return value.set({
                    hour: wasPM ? hours - 12 : hours + 12
                });
            }
        case 'hour':
            // In 12 hour time, ensure that AM/PM does not change
            if (options.hour12) {
                var hours1 = value.hour;
                var wasPM1 = hours1 >= 12;
                if (!wasPM1 && segmentValue === 12) segmentValue = 0;
                if (wasPM1 && segmentValue < 12) segmentValue += 12;
            }
        // fallthrough
        case 'minute':
        case 'second':
            return value.set((0, $3Hxpr._)({}, part, segmentValue));
    }
    throw new Error('Unknown segment: ' + part);
}


var $2QPpE = parcelRequire("2QPpE");





var $ggE0n = parcelRequire("ggE0n");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $146ca4c5beeb9db2$export$fd53cef0cc796101(props) {
    var tmp = props.placeholderValue, placeholderValue = tmp === void 0 ? new (0, $544adb0fa0f2d511$export$680ea196effce5f)() : tmp, minValue = props.minValue, maxValue = props.maxValue, granularity = props.granularity, validate = props.validate;
    var _props_defaultValue;
    var _$2PRh3$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange), 2), value = _$2PRh3$useControlledState[0], setValue = _$2PRh3$useControlledState[1];
    var v = value || placeholderValue;
    var day = v && 'day' in v ? v : undefined;
    var defaultValueTimeZone = props.defaultValue && 'timeZone' in props.defaultValue ? props.defaultValue.timeZone : undefined;
    var placeholderDate = (0, $ggE0n.useMemo)(function() {
        var valueTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
        return (valueTimeZone || defaultValueTimeZone) && placeholderValue ? (0, $c7eb0f5ee6d7094f$export$84c95a83c799e074)($146ca4c5beeb9db2$var$$eff5d8ee529ac4bb$var$convertValue(placeholderValue), valueTimeZone || defaultValueTimeZone) : $146ca4c5beeb9db2$var$$eff5d8ee529ac4bb$var$convertValue(placeholderValue);
    }, [
        placeholderValue,
        v,
        defaultValueTimeZone
    ]);
    var minDate = (0, $ggE0n.useMemo)(function() {
        return $146ca4c5beeb9db2$var$$eff5d8ee529ac4bb$var$convertValue(minValue, day);
    }, [
        minValue,
        day
    ]);
    var maxDate = (0, $ggE0n.useMemo)(function() {
        return $146ca4c5beeb9db2$var$$eff5d8ee529ac4bb$var$convertValue(maxValue, day);
    }, [
        maxValue,
        day
    ]);
    var timeValue = (0, $ggE0n.useMemo)(function() {
        return value && 'day' in value ? (0, $c7eb0f5ee6d7094f$export$d33f79e3ffc3dc83)(value) : value;
    }, [
        value
    ]);
    var dateTime = (0, $ggE0n.useMemo)(function() {
        return value == null ? null : $146ca4c5beeb9db2$var$$eff5d8ee529ac4bb$var$convertValue(value);
    }, [
        value
    ]);
    var onChange = function(newValue) {
        setValue(day || defaultValueTimeZone ? newValue : newValue && (0, $c7eb0f5ee6d7094f$export$d33f79e3ffc3dc83)(newValue));
    };
    var state = (0, $9b34374903a0d87e$export$60e84778edff6d26)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        value: dateTime,
        defaultValue: undefined,
        minValue: minDate,
        maxValue: maxDate,
        onChange: onChange,
        granularity: granularity || 'minute',
        maxGranularity: 'hour',
        placeholderValue: placeholderDate !== null && placeholderDate !== void 0 ? placeholderDate : undefined,
        // Calendar should not matter for time fields.
        createCalendar: function() {
            return new (0, $acc76a7a17331648$export$80ee6245ec4f29ec)();
        },
        validate: (0, $ggE0n.useCallback)(function() {
            return validate === null || validate === void 0 ? void 0 : validate(value);
        }, [
            validate,
            value
        ])
    }));
    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, state), {
        timeValue: timeValue
    });
}
function $146ca4c5beeb9db2$var$$eff5d8ee529ac4bb$var$convertValue(value) {
    var date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $b20616b02fb62709$export$d0bdf45af03a6ea3)((0, $b20616b02fb62709$export$aa8b41735afcabd2)());
    if (!value) return null;
    if ('day' in value) return value;
    return (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(date, value);
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $b988ff963e2c53e5$export$7b3e670c86da5fe8 = (0, $ggE0n.createContext)(null);
var $b988ff963e2c53e5$export$8e17ddc448e87c1e = (0, $ggE0n.createContext)(null);
var $b988ff963e2c53e5$export$3b08bebcf796eea0 = (0, $ggE0n.createContext)(null);
var $b988ff963e2c53e5$export$5d8dc44abd10a920 = (0, $ggE0n.createContext)(null);
var $b988ff963e2c53e5$export$d9781c7894a82487 = (0, $ggE0n.forwardRef)(function DateField(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $b988ff963e2c53e5$export$7b3e670c86da5fe8), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _ref = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)((0, $2bf90da467e9636b$export$c24727297075ec6a)) || {}, formValidationBehavior = _ref.validationBehavior;
    var _props_validationBehavior, _ref1;
    var validationBehavior = (_ref1 = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref1 !== void 0 ? _ref1 : 'native';
    var _$a9Sgq$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$a9Sgq$useLocale.locale;
    var state = (0, $9b34374903a0d87e$export$60e84778edff6d26)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        locale: locale,
        createCalendar: (0, $103adbfdbf9a1de6$export$dd0bbc9b26defe37),
        validationBehavior: validationBehavior
    }));
    var fieldRef = (0, $ggE0n.useRef)(null);
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var inputRef = (0, $ggE0n.useRef)(null);
    var _$a9Sgq$useDateField = (0, $e373cd6e88fbaa4c$export$5591b0b878c1a989)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        label: label,
        inputRef: inputRef,
        validationBehavior: validationBehavior
    }), state, fieldRef), labelProps = _$a9Sgq$useDateField.labelProps, fieldProps = _$a9Sgq$useDateField.fieldProps, inputProps = _$a9Sgq$useDateField.inputProps, descriptionProps = _$a9Sgq$useDateField.descriptionProps, errorMessageProps = _$a9Sgq$useDateField.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$a9Sgq$useDateField, [
        "labelProps",
        "fieldProps",
        "inputProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        values: {
            state: state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled
        },
        defaultClassName: 'react-aria-DateField'
    }));
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $b988ff963e2c53e5$export$3b08bebcf796eea0,
                state
            ],
            [
                (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, fieldProps), {
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                })
            ],
            [
                (0, $a34d4855f0a68343$export$37fb8590cf2c088c),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, inputProps), {
                    ref: inputRef
                })
            ],
            [
                (0, $4fa91534e9375925$export$75b6ee27786ba447),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
                    ref: labelRef,
                    elementType: 'span'
                })
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $aef12de62ee30fed$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, DOMProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined
    })));
});
var $b988ff963e2c53e5$export$5eaee2322dd727eb = (0, $ggE0n.forwardRef)(function TimeField(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $b988ff963e2c53e5$export$8e17ddc448e87c1e), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _ref = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)((0, $2bf90da467e9636b$export$c24727297075ec6a)) || {}, formValidationBehavior = _ref.validationBehavior;
    var _props_validationBehavior, _ref1;
    var validationBehavior = (_ref1 = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref1 !== void 0 ? _ref1 : 'native';
    var _$a9Sgq$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$a9Sgq$useLocale.locale;
    var state = (0, $146ca4c5beeb9db2$export$fd53cef0cc796101)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        locale: locale,
        validationBehavior: validationBehavior
    }));
    var fieldRef = (0, $ggE0n.useRef)(null);
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var inputRef = (0, $ggE0n.useRef)(null);
    var _$a9Sgq$useTimeField = (0, $e373cd6e88fbaa4c$export$4c842f6a241dc825)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        label: label,
        inputRef: inputRef,
        validationBehavior: validationBehavior
    }), state, fieldRef), labelProps = _$a9Sgq$useTimeField.labelProps, fieldProps = _$a9Sgq$useTimeField.fieldProps, inputProps = _$a9Sgq$useTimeField.inputProps, descriptionProps = _$a9Sgq$useTimeField.descriptionProps, errorMessageProps = _$a9Sgq$useTimeField.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$a9Sgq$useTimeField, [
        "labelProps",
        "fieldProps",
        "inputProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            state: state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled
        },
        defaultClassName: 'react-aria-TimeField'
    }));
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $b988ff963e2c53e5$export$5d8dc44abd10a920,
                state
            ],
            [
                (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, fieldProps), {
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                })
            ],
            [
                (0, $a34d4855f0a68343$export$37fb8590cf2c088c),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, inputProps), {
                    ref: inputRef
                })
            ],
            [
                (0, $4fa91534e9375925$export$75b6ee27786ba447),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
                    ref: labelRef,
                    elementType: 'span'
                })
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $aef12de62ee30fed$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, DOMProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined
    })));
});
var $b988ff963e2c53e5$export$7edc06cf1783b30f = (0, $ggE0n.forwardRef)(function DateInput(props, ref) {
    // If state is provided by DateField/TimeField, just render.
    // Otherwise (e.g. in DatePicker), we need to call hooks and create state ourselves.
    var dateFieldState = (0, $ggE0n.useContext)($b988ff963e2c53e5$export$3b08bebcf796eea0);
    var timeFieldState = (0, $ggE0n.useContext)($b988ff963e2c53e5$export$5d8dc44abd10a920);
    return dateFieldState || timeFieldState ? (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($b988ff963e2c53e5$var$$40825cdb76e74f70$var$DateInputInner, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        ref: ref
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($b988ff963e2c53e5$var$$40825cdb76e74f70$var$DateInputStandalone, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        ref: ref
    }));
});
var $b988ff963e2c53e5$var$$40825cdb76e74f70$var$DateInputStandalone = (0, $ggE0n.forwardRef)(function(props, ref) {
    var _$64fa3d84918910a7$export$29f1550f4b0d4415 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)({
        slot: props.slot
    }, ref, $b988ff963e2c53e5$export$7b3e670c86da5fe8), 2), dateFieldProps = _$64fa3d84918910a7$export$29f1550f4b0d4415[0], fieldRef = _$64fa3d84918910a7$export$29f1550f4b0d4415[1];
    var _$a9Sgq$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$a9Sgq$useLocale.locale;
    var state = (0, $9b34374903a0d87e$export$60e84778edff6d26)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, dateFieldProps), {
        locale: locale,
        createCalendar: (0, $103adbfdbf9a1de6$export$dd0bbc9b26defe37)
    }));
    var inputRef = (0, $ggE0n.useRef)(null);
    var _$a9Sgq$useDateField = (0, $e373cd6e88fbaa4c$export$5591b0b878c1a989)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, dateFieldProps), {
        inputRef: inputRef
    }), state, fieldRef), fieldProps = _$a9Sgq$useDateField.fieldProps, inputProps = _$a9Sgq$useDateField.inputProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $b988ff963e2c53e5$export$3b08bebcf796eea0,
                state
            ],
            [
                (0, $a34d4855f0a68343$export$37fb8590cf2c088c),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, inputProps), {
                    ref: inputRef
                })
            ],
            [
                (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, fieldProps), {
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                })
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement($b988ff963e2c53e5$var$$40825cdb76e74f70$var$DateInputInner, props));
});
var $b988ff963e2c53e5$var$$40825cdb76e74f70$var$DateInputInner = (0, $ggE0n.forwardRef)(function(props, ref) {
    var className = props.className, children = props.children;
    var dateFieldState = (0, $ggE0n.useContext)($b988ff963e2c53e5$export$3b08bebcf796eea0);
    var timeFieldState = (0, $ggE0n.useContext)($b988ff963e2c53e5$export$5d8dc44abd10a920);
    var state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $b758c97c918eb1ee$export$eb2fcfdbd7ba97d4), (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        ref: ref,
        slot: props.slot || undefined,
        className: className !== null && className !== void 0 ? className : 'react-aria-DateInput',
        isInvalid: state.isInvalid,
        isDisabled: state.isDisabled
    }), state.segments.map(function(segment, i) {
        return (0, $ggE0n.cloneElement)(children(segment), {
            key: i
        });
    })), (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $a34d4855f0a68343$export$f5b8910cec6cf069), null));
});
var $b988ff963e2c53e5$export$336ab7fa954c4b5f = (0, $ggE0n.forwardRef)(function DateSegment(_param, ref) {
    var segment = _param.segment, otherProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_param, [
        "segment"
    ]);
    var dateFieldState = (0, $ggE0n.useContext)($b988ff963e2c53e5$export$3b08bebcf796eea0);
    var timeFieldState = (0, $ggE0n.useContext)($b988ff963e2c53e5$export$5d8dc44abd10a920);
    var state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
    var domRef = (0, $c25977d36d6c3204$export$4338b53315abf666)(ref);
    var _$a9Sgq$useDateSegment = (0, $e6a6fcf526c5e431$export$1315d136e6f7581)(segment, state, domRef), segmentProps = _$a9Sgq$useDateSegment.segmentProps;
    var _$a9Sgq$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)(), focusProps = _$a9Sgq$useFocusRing.focusProps, isFocused = _$a9Sgq$useFocusRing.isFocused, isFocusVisible = _$a9Sgq$useFocusRing.isFocusVisible;
    var _$a9Sgq$useHover = (0, $b825a66cb81adbfc$export$ae780daf29e6d456)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        isDisabled: state.isDisabled || segment.type === 'literal'
    })), hoverProps = _$a9Sgq$useHover.hoverProps, isHovered = _$a9Sgq$useHover.isHovered;
    var isEditable = segment.isEditable, segmentRest = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(segment, [
        "isEditable"
    ]);
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, otherProps), {
        values: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, segmentRest), {
            isReadOnly: !isEditable,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        }),
        defaultChildren: segment.text,
        defaultClassName: 'react-aria-DateSegment'
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("span", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $850b305c152381bf$export$9d1611c77c2fe928)((0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(otherProps), segmentProps, focusProps, hoverProps), renderProps), {
        style: segmentProps.style,
        ref: domRef,
        "data-placeholder": segment.isPlaceholder || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-readonly": !isEditable || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-type": segment.type,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }));
});










var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");











var $ggE0n = parcelRequire("ggE0n");
function $5ae9c14d003882b1$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5ae9c14d003882b1$export$42df105a73306d51(props, state, ref) {
    var buttonId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var dialogId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var fieldId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($5ae9c14d003882b1$var$$parcel$interopDefault((0, $4857b42b1c06afab$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    var _state_displayValidation = state.displayValidation, isInvalid = _state_displayValidation.isInvalid, validationErrors = _state_displayValidation.validationErrors, validationDetails = _state_displayValidation.validationDetails;
    var _$4lVjK$useField = (0, $fb08f700a6e84f93$export$294aa081a6c6f55d)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    })), labelProps = _$4lVjK$useField.labelProps, fieldProps = _$4lVjK$useField.fieldProps, descriptionProps = _$4lVjK$useField.descriptionProps, errorMessageProps = _$4lVjK$useField.errorMessageProps;
    var groupProps = (0, $89da7d8072ad6fee$export$4a931266a3838b86)(state, ref);
    var labelledBy = fieldProps['aria-labelledby'] || fieldProps.id;
    var _$4lVjK$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$4lVjK$useLocale.locale;
    var date = state.formatValue(locale, {
        month: 'long'
    });
    var description = date ? stringFormatter.format('selectedDateDescription', {
        date: date
    }) : '';
    var descProps = (0, $b484270dee1cc590$export$f8aeda7b10753fa1)(description);
    var ariaDescribedBy = [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    var focusManager = (0, $ggE0n.useMemo)(function() {
        return (0, $67c1d94bd0a42a56$export$c5251b9e124bf29)(ref);
    }, [
        ref
    ]);
    var isFocused = (0, $ggE0n.useRef)(false);
    var _$4lVjK$useFocusWithin = (0, $2d409168e187362c$export$420e68273165f4ec)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        isDisabled: state.isOpen,
        onBlurWithin: function(e) {
            // Ignore when focus moves into the popover.
            var dialog = document.getElementById(dialogId);
            if (!(dialog === null || dialog === void 0 ? void 0 : dialog.contains(e.relatedTarget))) {
                var _props_onBlur, _props_onFocusChange;
                isFocused.current = false;
                (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
                (_props_onFocusChange = props.onFocusChange) === null || _props_onFocusChange === void 0 || _props_onFocusChange.call(props, false);
            }
        },
        onFocusWithin: function(e) {
            if (!isFocused.current) {
                var _props_onFocus, _props_onFocusChange;
                isFocused.current = true;
                (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 || _props_onFocus.call(props, e);
                (_props_onFocusChange = props.onFocusChange) === null || _props_onFocusChange === void 0 || _props_onFocusChange.call(props, true);
            }
        }
    })), focusWithinProps = _$4lVjK$useFocusWithin.focusWithinProps;
    var _obj;
    return {
        groupProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: 'group',
            'aria-disabled': props.isDisabled || null,
            'aria-labelledby': labelledBy,
            'aria-describedby': ariaDescribedBy,
            onKeyDown: function(e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp: function(e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
            onClick: function() {
                focusManager.focusFirst();
            }
        }),
        fieldProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, fieldProps), (_obj = {
            id: fieldId
        }, (0, $3Hxpr._)(_obj, (0, $e373cd6e88fbaa4c$export$300019f83c56d282), 'presentation'), (0, $3Hxpr._)(_obj, 'aria-describedby', ariaDescribedBy), (0, $3Hxpr._)(_obj, "value", state.value), (0, $3Hxpr._)(_obj, "onChange", state.setValue), (0, $3Hxpr._)(_obj, "placeholderValue", props.placeholderValue), (0, $3Hxpr._)(_obj, "hideTimeZone", props.hideTimeZone), (0, $3Hxpr._)(_obj, "hourCycle", props.hourCycle), (0, $3Hxpr._)(_obj, "shouldForceLeadingZeros", props.shouldForceLeadingZeros), (0, $3Hxpr._)(_obj, "granularity", props.granularity), (0, $3Hxpr._)(_obj, "isDisabled", props.isDisabled), (0, $3Hxpr._)(_obj, "isReadOnly", props.isReadOnly), (0, $3Hxpr._)(_obj, "isRequired", props.isRequired), (0, $3Hxpr._)(_obj, "validationBehavior", props.validationBehavior), // DatePicker owns the validation state for the date field.
        (0, $3Hxpr._)(_obj, (0, $7aa741b584fcccb5$export$a763b9476acd3eb), state), (0, $3Hxpr._)(_obj, "autoFocus", props.autoFocus), (0, $3Hxpr._)(_obj, "name", props.name), _obj)),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        buttonProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, descProps), {
            id: buttonId,
            'aria-haspopup': 'dialog',
            'aria-label': stringFormatter.format('calendar'),
            'aria-labelledby': "".concat(buttonId, " ").concat(labelledBy),
            'aria-describedby': ariaDescribedBy,
            'aria-expanded': state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: function() {
                return state.setOpen(true);
            }
        }),
        dialogProps: {
            id: dialogId,
            'aria-labelledby': "".concat(buttonId, " ").concat(labelledBy)
        },
        calendarProps: {
            autoFocus: true,
            value: state.dateValue,
            onChange: state.setDateValue,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            defaultFocusedValue: state.dateValue ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === 'function' ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(' ')
        },
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}


var $3Hxpr = parcelRequire("3Hxpr");

var $2QPpE = parcelRequire("2QPpE");











var $ggE0n = parcelRequire("ggE0n");
function $36ab3c7676c7cc1d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $36ab3c7676c7cc1d$export$12fd5f0e9f4bb192(props, state, ref) {
    var _state_value, _state_value1, _state_dateRange;
    var stringFormatter = (0, $e3ba67447894b71b$export$f12b703ca79dfbb1)($36ab3c7676c7cc1d$var$$parcel$interopDefault((0, $4857b42b1c06afab$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    var _state_displayValidation = state.displayValidation, isInvalid = _state_displayValidation.isInvalid, validationErrors = _state_displayValidation.validationErrors, validationDetails = _state_displayValidation.validationDetails;
    var _$eIQ1H$useField = (0, $fb08f700a6e84f93$export$294aa081a6c6f55d)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    })), labelProps = _$eIQ1H$useField.labelProps, fieldProps = _$eIQ1H$useField.fieldProps, descriptionProps = _$eIQ1H$useField.descriptionProps, errorMessageProps = _$eIQ1H$useField.errorMessageProps;
    var labelledBy = fieldProps['aria-labelledby'] || fieldProps.id;
    var _$eIQ1H$useLocale = (0, $541452378073fc0a$export$43bb16f9c6d9e3f7)(), locale = _$eIQ1H$useLocale.locale;
    var range = state.formatValue(locale, {
        month: 'long'
    });
    var description = range ? stringFormatter.format('selectedRangeDescription', {
        startDate: range.start,
        endDate: range.end
    }) : '';
    var descProps = (0, $b484270dee1cc590$export$f8aeda7b10753fa1)(description);
    var startFieldProps = {
        'aria-label': stringFormatter.format('startDate'),
        'aria-labelledby': labelledBy
    };
    var endFieldProps = {
        'aria-label': stringFormatter.format('endDate'),
        'aria-labelledby': labelledBy
    };
    var buttonId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var dialogId = (0, $7fc455d18519c289$export$f680877a34711e37)();
    var groupProps = (0, $89da7d8072ad6fee$export$4a931266a3838b86)(state, ref);
    var ariaDescribedBy = [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    var focusManager = (0, $ggE0n.useMemo)(function() {
        return (0, $67c1d94bd0a42a56$export$c5251b9e124bf29)(ref, {
            // Exclude the button from the focus manager.
            accept: function(element) {
                return element.id !== buttonId;
            }
        });
    }, [
        ref,
        buttonId
    ]);
    var _obj;
    var commonFieldProps = (_obj = {}, (0, $3Hxpr._)(_obj, (0, $e373cd6e88fbaa4c$export$7b3062cd49e80452), focusManager), (0, $3Hxpr._)(_obj, (0, $e373cd6e88fbaa4c$export$300019f83c56d282), 'presentation'), (0, $3Hxpr._)(_obj, 'aria-describedby', ariaDescribedBy), (0, $3Hxpr._)(_obj, "placeholderValue", props.placeholderValue), (0, $3Hxpr._)(_obj, "hideTimeZone", props.hideTimeZone), (0, $3Hxpr._)(_obj, "hourCycle", props.hourCycle), (0, $3Hxpr._)(_obj, "granularity", props.granularity), (0, $3Hxpr._)(_obj, "shouldForceLeadingZeros", props.shouldForceLeadingZeros), (0, $3Hxpr._)(_obj, "isDisabled", props.isDisabled), (0, $3Hxpr._)(_obj, "isReadOnly", props.isReadOnly), (0, $3Hxpr._)(_obj, "isRequired", props.isRequired), (0, $3Hxpr._)(_obj, "validationBehavior", props.validationBehavior), _obj);
    var domProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    var isFocused = (0, $ggE0n.useRef)(false);
    var _$eIQ1H$useFocusWithin = (0, $2d409168e187362c$export$420e68273165f4ec)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        isDisabled: state.isOpen,
        onBlurWithin: function(e) {
            // Ignore when focus moves into the popover.
            var dialog = document.getElementById(dialogId);
            if (!(dialog === null || dialog === void 0 ? void 0 : dialog.contains(e.relatedTarget))) {
                var _props_onBlur, _props_onFocusChange;
                isFocused.current = false;
                (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
                (_props_onFocusChange = props.onFocusChange) === null || _props_onFocusChange === void 0 || _props_onFocusChange.call(props, false);
            }
        },
        onFocusWithin: function(e) {
            if (!isFocused.current) {
                var _props_onFocus, _props_onFocusChange;
                isFocused.current = true;
                (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 || _props_onFocus.call(props, e);
                (_props_onFocusChange = props.onFocusChange) === null || _props_onFocusChange === void 0 || _props_onFocusChange.call(props, true);
            }
        }
    })), focusWithinProps = _$eIQ1H$useFocusWithin.focusWithinProps;
    var startFieldValidation = (0, $ggE0n.useRef)((0, $7aa741b584fcccb5$export$dad6ae84456c676a));
    var endFieldValidation = (0, $ggE0n.useRef)((0, $7aa741b584fcccb5$export$dad6ae84456c676a));
    var _state_value_start, _state_value_end;
    return {
        groupProps: (0, $850b305c152381bf$export$9d1611c77c2fe928)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: 'group',
            'aria-disabled': props.isDisabled || null,
            'aria-describedby': ariaDescribedBy,
            onKeyDown: function(e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp: function(e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
            onClick: function() {
                focusManager.focusFirst();
            }
        }),
        buttonProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, descProps), {
            id: buttonId,
            'aria-haspopup': 'dialog',
            'aria-label': stringFormatter.format('calendar'),
            'aria-labelledby': "".concat(buttonId, " ").concat(labelledBy),
            'aria-describedby': ariaDescribedBy,
            'aria-expanded': state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: function() {
                return state.setOpen(true);
            }
        }),
        dialogProps: {
            id: dialogId,
            'aria-labelledby': "".concat(buttonId, " ").concat(labelledBy)
        },
        startFieldProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, startFieldProps, commonFieldProps), (0, $3Hxpr._)({
            value: (_state_value_start = (_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.start) !== null && _state_value_start !== void 0 ? _state_value_start : null,
            onChange: function(start) {
                return state.setDateTime('start', start);
            },
            autoFocus: props.autoFocus,
            name: props.startName
        }, (0, $7aa741b584fcccb5$export$a763b9476acd3eb), {
            realtimeValidation: state.realtimeValidation,
            displayValidation: state.displayValidation,
            updateValidation: function(e) {
                startFieldValidation.current = e;
                state.updateValidation((0, $7aa741b584fcccb5$export$75ee7c75d68f5b0e)(e, endFieldValidation.current));
            },
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation
        })),
        endFieldProps: (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, endFieldProps, commonFieldProps), (0, $3Hxpr._)({
            value: (_state_value_end = (_state_value1 = state.value) === null || _state_value1 === void 0 ? void 0 : _state_value1.end) !== null && _state_value_end !== void 0 ? _state_value_end : null,
            onChange: function(end) {
                return state.setDateTime('end', end);
            },
            name: props.endName
        }, (0, $7aa741b584fcccb5$export$a763b9476acd3eb), {
            realtimeValidation: state.realtimeValidation,
            displayValidation: state.displayValidation,
            updateValidation: function(e) {
                endFieldValidation.current = e;
                state.updateValidation((0, $7aa741b584fcccb5$export$75ee7c75d68f5b0e)(startFieldValidation.current, e));
            },
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation
        })),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        calendarProps: {
            autoFocus: true,
            value: ((_state_dateRange = state.dateRange) === null || _state_dateRange === void 0 ? void 0 : _state_dateRange.start) && state.dateRange.end ? state.dateRange : null,
            onChange: state.setDateRange,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            allowsNonContiguousRanges: props.allowsNonContiguousRanges,
            defaultFocusedValue: state.dateRange ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === 'function' ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(' ')
        },
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}



var $2QPpE = parcelRequire("2QPpE");








var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $510c37eb18b18b1d$export$87194bb378cc3ac2(props) {
    var overlayState = (0, $995b915c2e36d0af$export$61c6a8c84e605fb6)(props);
    var _$goopS$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.value, props.defaultValue || null, props.onChange), 2), value = _$goopS$useControlledState[0], setValue = _$goopS$useControlledState[1];
    var v = value || props.placeholderValue || null;
    var _$35a22f14a1f04b11$export$2440da353cedad43 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $d723c63582520b7d$export$2440da353cedad43)(v, props.granularity), 2), granularity = _$35a22f14a1f04b11$export$2440da353cedad43[0], defaultTimeZone = _$35a22f14a1f04b11$export$2440da353cedad43[1];
    var dateValue = value != null ? value.toDate(defaultTimeZone !== null && defaultTimeZone !== void 0 ? defaultTimeZone : 'UTC') : null;
    var hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    var _props_shouldCloseOnSelect;
    var shouldCloseOnSelect = (_props_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _props_shouldCloseOnSelect !== void 0 ? _props_shouldCloseOnSelect : true;
    var _$goopS$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), selectedDate = _$goopS$useState[0], setSelectedDate = _$goopS$useState[1];
    var _$goopS$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), selectedTime = _$goopS$useState1[0], setSelectedTime = _$goopS$useState1[1];
    if (value) {
        selectedDate = value;
        if ('hour' in value) selectedTime = value;
    }
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    var showEra = (value === null || value === void 0 ? void 0 : value.calendar.identifier) === 'gregory' && value.era === 'BC';
    var formatOpts = (0, $ggE0n.useMemo)(function() {
        return {
            granularity: granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra: showEra
        };
    }, [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    var minValue = props.minValue, maxValue = props.maxValue, isDateUnavailable = props.isDateUnavailable;
    var builtinValidation = (0, $ggE0n.useMemo)(function() {
        return (0, $d723c63582520b7d$export$f18627323ab57ac0)(value, minValue, maxValue, isDateUnavailable, formatOpts);
    }, [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    var validation = (0, $7aa741b584fcccb5$export$fc1a364ae1f3ff10)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        value: value,
        builtinValidation: builtinValidation
    }));
    var isValueInvalid = validation.displayValidation.isInvalid;
    var validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    var commitValue = function(date, time) {
        setValue('timeZone' in time ? time.set((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(date)) : (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(date, time));
        setSelectedDate(null);
        setSelectedTime(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    var selectDate = function(newValue) {
        var shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            if (selectedTime || shouldClose) commitValue(newValue, selectedTime || (0, $d723c63582520b7d$export$c5221a78ef73c5e9)(props.defaultValue || props.placeholderValue));
            else setSelectedDate(newValue);
        } else {
            setValue(newValue);
            validation.commitValidation();
        }
        if (shouldClose) overlayState.setOpen(false);
    };
    var selectTime = function(newValue) {
        if (selectedDate && newValue) commitValue(selectedDate, newValue);
        else setSelectedTime(newValue);
    };
    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, validation), {
        value: value,
        setValue: setValue,
        dateValue: selectedDate,
        timeValue: selectedTime,
        setDateValue: selectDate,
        setTimeValue: selectTime,
        granularity: granularity,
        hasTime: hasTime
    }), overlayState), {
        setOpen: function(isOpen) {
            // Commit the selected date when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time was set and not the date, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !value && selectedDate && hasTime) commitValue(selectedDate, selectedTime || (0, $d723c63582520b7d$export$c5221a78ef73c5e9)(props.defaultValue || props.placeholderValue));
            overlayState.setOpen(isOpen);
        },
        validationState: validationState,
        isInvalid: isValueInvalid,
        formatValue: function(locale, fieldOptions) {
            if (!dateValue) return '';
            var formatOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)(fieldOptions, formatOpts);
            var formatter = new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, formatOptions);
            return formatter.format(dateValue);
        },
        getDateFormatter: function(locale, formatOptions) {
            var newOptions = (0, $2QPpE._)({}, formatOpts, formatOptions);
            var newFormatOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, newFormatOptions);
        }
    });
}


var $2QPpE = parcelRequire("2QPpE");








var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $94633e85b80d99c4$export$e50a61c1de9f574(props) {
    var _value_start, _value_end;
    var overlayState = (0, $995b915c2e36d0af$export$61c6a8c84e605fb6)(props);
    var _$hac8C$useControlledState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e8d739d764b8c43b$export$40bfa8c7b0832715)(props.value, props.defaultValue || null, props.onChange), 2), controlledValue = _$hac8C$useControlledState[0], setControlledValue = _$hac8C$useControlledState[1];
    var _$hac8C$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(function() {
        return controlledValue || {
            start: null,
            end: null
        };
    }), 2), placeholderValue = _$hac8C$useState[0], setPlaceholderValue = _$hac8C$useState[1];
    // Reset the placeholder if the value prop is set to null.
    if (controlledValue == null && placeholderValue.start && placeholderValue.end) {
        placeholderValue = {
            start: null,
            end: null
        };
        setPlaceholderValue(placeholderValue);
    }
    var value = controlledValue || placeholderValue;
    var setValue = function(value) {
        setPlaceholderValue(value || {
            start: null,
            end: null
        });
        if ($94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(value)) setControlledValue(value);
        else setControlledValue(null);
    };
    var v = (value === null || value === void 0 ? void 0 : value.start) || (value === null || value === void 0 ? void 0 : value.end) || props.placeholderValue || null;
    var _$35a22f14a1f04b11$export$2440da353cedad43 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $d723c63582520b7d$export$2440da353cedad43)(v, props.granularity), 2), granularity = _$35a22f14a1f04b11$export$2440da353cedad43[0], defaultTimeZone = _$35a22f14a1f04b11$export$2440da353cedad43[1];
    var hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    var _props_shouldCloseOnSelect;
    var shouldCloseOnSelect = (_props_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _props_shouldCloseOnSelect !== void 0 ? _props_shouldCloseOnSelect : true;
    var _$hac8C$useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), dateRange = _$hac8C$useState1[0], setSelectedDateRange = _$hac8C$useState1[1];
    var _$hac8C$useState2 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), timeRange = _$hac8C$useState2[0], setSelectedTimeRange = _$hac8C$useState2[1];
    if (value && $94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(value)) {
        dateRange = value;
        if ('hour' in value.start) timeRange = value;
    }
    var commitValue = function(dateRange, timeRange) {
        setValue({
            start: 'timeZone' in timeRange.start ? timeRange.start.set((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(dateRange.start)) : (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(dateRange.start, timeRange.start),
            end: 'timeZone' in timeRange.end ? timeRange.end.set((0, $c7eb0f5ee6d7094f$export$93522d1a439f3617)(dateRange.end)) : (0, $c7eb0f5ee6d7094f$export$b21e0b124e224484)(dateRange.end, timeRange.end)
        });
        setSelectedDateRange(null);
        setSelectedTimeRange(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    var setDateRange = function(range) {
        var shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            // Set a placeholder time if the popover is closing so we don't leave the field in an incomplete state.
            if ($94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(range) && (shouldClose || (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) && (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end))) commitValue(range, {
                start: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) || (0, $d723c63582520b7d$export$c5221a78ef73c5e9)(props.placeholderValue),
                end: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) || (0, $d723c63582520b7d$export$c5221a78ef73c5e9)(props.placeholderValue)
            });
            else setSelectedDateRange(range);
        } else if ($94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(range)) {
            setValue(range);
            validation.commitValidation();
        } else setSelectedDateRange(range);
        if (shouldClose) overlayState.setOpen(false);
    };
    var setTimeRange = function(range) {
        if ($94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(dateRange) && $94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(range)) commitValue(dateRange, range);
        else setSelectedTimeRange(range);
    };
    var showEra = (value === null || value === void 0 ? void 0 : (_value_start = value.start) === null || _value_start === void 0 ? void 0 : _value_start.calendar.identifier) === 'gregory' && value.start.era === 'BC' || (value === null || value === void 0 ? void 0 : (_value_end = value.end) === null || _value_end === void 0 ? void 0 : _value_end.calendar.identifier) === 'gregory' && value.end.era === 'BC';
    var formatOpts = (0, $ggE0n.useMemo)(function() {
        return {
            granularity: granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra: showEra
        };
    }, [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    var minValue = props.minValue, maxValue = props.maxValue, isDateUnavailable = props.isDateUnavailable;
    var builtinValidation = (0, $ggE0n.useMemo)(function() {
        return (0, $d723c63582520b7d$export$80ff8fc0ae339c13)(value, minValue, maxValue, isDateUnavailable, formatOpts);
    }, [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    var validation = (0, $7aa741b584fcccb5$export$fc1a364ae1f3ff10)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        value: controlledValue,
        name: (0, $ggE0n.useMemo)(function() {
            return [
                props.startName,
                props.endName
            ].filter(function(n) {
                return n != null;
            });
        }, [
            props.startName,
            props.endName
        ]),
        builtinValidation: builtinValidation
    }));
    var isValueInvalid = validation.displayValidation.isInvalid;
    var validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    return (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, validation), {
        value: value,
        setValue: setValue,
        dateRange: dateRange,
        timeRange: timeRange,
        granularity: granularity,
        hasTime: hasTime,
        setDate: function(part, date) {
            var _dateRange_end, _dateRange_start;
            if (part === 'start') setDateRange({
                start: date,
                end: (_dateRange_end = dateRange === null || dateRange === void 0 ? void 0 : dateRange.end) !== null && _dateRange_end !== void 0 ? _dateRange_end : null
            });
            else setDateRange({
                start: (_dateRange_start = dateRange === null || dateRange === void 0 ? void 0 : dateRange.start) !== null && _dateRange_start !== void 0 ? _dateRange_start : null,
                end: date
            });
        },
        setTime: function(part, time) {
            var _timeRange_end, _timeRange_start;
            if (part === 'start') setTimeRange({
                start: time,
                end: (_timeRange_end = timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) !== null && _timeRange_end !== void 0 ? _timeRange_end : null
            });
            else setTimeRange({
                start: (_timeRange_start = timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) !== null && _timeRange_start !== void 0 ? _timeRange_start : null,
                end: time
            });
        },
        setDateTime: function(part, dateTime) {
            var _value_end, _value_start;
            if (part === 'start') setValue({
                start: dateTime,
                end: (_value_end = value === null || value === void 0 ? void 0 : value.end) !== null && _value_end !== void 0 ? _value_end : null
            });
            else setValue({
                start: (_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : null,
                end: dateTime
            });
        },
        setDateRange: setDateRange,
        setTimeRange: setTimeRange
    }), overlayState), {
        setOpen: function(isOpen) {
            // Commit the selected date range when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time range was set and not the date range, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !((value === null || value === void 0 ? void 0 : value.start) && (value === null || value === void 0 ? void 0 : value.end)) && $94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(dateRange) && hasTime) commitValue(dateRange, {
                start: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) || (0, $d723c63582520b7d$export$c5221a78ef73c5e9)(props.placeholderValue),
                end: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) || (0, $d723c63582520b7d$export$c5221a78ef73c5e9)(props.placeholderValue)
            });
            overlayState.setOpen(isOpen);
        },
        validationState: validationState,
        isInvalid: isValueInvalid,
        formatValue: function(locale, fieldOptions) {
            if (!value || !value.start || !value.end) return null;
            var startTimeZone = 'timeZone' in value.start ? value.start.timeZone : undefined;
            var startGranularity = props.granularity || (value.start && 'minute' in value.start ? 'minute' : 'day');
            var endTimeZone = 'timeZone' in value.end ? value.end.timeZone : undefined;
            var endGranularity = props.granularity || (value.end && 'minute' in value.end ? 'minute' : 'day');
            var startOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)(fieldOptions, {
                granularity: startGranularity,
                timeZone: startTimeZone,
                hideTimeZone: props.hideTimeZone,
                hourCycle: props.hourCycle,
                showEra: value.start.calendar.identifier === 'gregory' && value.start.era === 'BC' || value.end.calendar.identifier === 'gregory' && value.end.era === 'BC'
            });
            var startDate = value.start.toDate(startTimeZone || 'UTC');
            var endDate = value.end.toDate(endTimeZone || 'UTC');
            var startFormatter = new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, startOptions);
            var endFormatter;
            if (startTimeZone === endTimeZone && startGranularity === endGranularity && value.start.compare(value.end) !== 0) {
                // Use formatRange, as it results in shorter output when some of the fields
                // are shared between the start and end dates (e.g. the same month).
                // Formatting will fail if the end date is before the start date. Fall back below when that happens.
                try {
                    var parts = startFormatter.formatRangeToParts(startDate, endDate);
                    // Find the separator between the start and end date. This is determined
                    // by finding the last shared literal before the end range.
                    var separatorIndex = -1;
                    for(var i = 0; i < parts.length; i++){
                        var part = parts[i];
                        if (part.source === 'shared' && part.type === 'literal') separatorIndex = i;
                        else if (part.source === 'endRange') break;
                    }
                    // Now we can combine the parts into start and end strings.
                    var start = '';
                    var end = '';
                    for(var i1 = 0; i1 < parts.length; i1++){
                        if (i1 < separatorIndex) start += parts[i1].value;
                        else if (i1 > separatorIndex) end += parts[i1].value;
                    }
                    return {
                        start: start,
                        end: end
                    };
                } catch (e) {
                // ignore
                }
                endFormatter = startFormatter;
            } else {
                var endOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)(fieldOptions, {
                    granularity: endGranularity,
                    timeZone: endTimeZone,
                    hideTimeZone: props.hideTimeZone,
                    hourCycle: props.hourCycle
                });
                endFormatter = new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, endOptions);
            }
            return {
                start: startFormatter.format(startDate),
                end: endFormatter.format(endDate)
            };
        },
        getDateFormatter: function(locale, formatOptions) {
            var newOptions = (0, $2QPpE._)({}, formatOpts, formatOptions);
            var newFormatOptions = (0, $d723c63582520b7d$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $de6ec507564b9a27$export$ad991b66133851cf)(locale, newFormatOptions);
        }
    });
}
function $94633e85b80d99c4$var$$93c38a5e28be6249$var$isCompleteRange(value) {
    return (value === null || value === void 0 ? void 0 : value.start) != null && value.end != null;
}




var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $a82d4d6c9117f171$export$cf316c7f3b44c11e = (0, $ggE0n.createContext)(null);
var $a82d4d6c9117f171$export$8282edba42ee28a = (0, $ggE0n.createContext)(null);
var $a82d4d6c9117f171$export$50a10c048fdcdee9 = (0, $ggE0n.createContext)(null);
var $a82d4d6c9117f171$export$80d7ae1f804790be = (0, $ggE0n.createContext)(null);
// Contexts to clear inside the popover.
var $a82d4d6c9117f171$var$$06d5b8ec9ee5d538$var$CLEAR_CONTEXTS = [
    (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
    (0, $28c5f096242aff4d$export$24d547caef80ccd1),
    (0, $4fa91534e9375925$export$75b6ee27786ba447),
    (0, $fbbc6fda6285b143$export$9afb8bc826b033ea)
];
var $a82d4d6c9117f171$export$5109c6dd95d8fb00 = (0, $ggE0n.forwardRef)(function DatePicker(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $a82d4d6c9117f171$export$cf316c7f3b44c11e), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _ref = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)((0, $2bf90da467e9636b$export$c24727297075ec6a)) || {}, formValidationBehavior = _ref.validationBehavior;
    var _props_validationBehavior, _ref1;
    var validationBehavior = (_ref1 = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref1 !== void 0 ? _ref1 : 'native';
    var state = (0, $510c37eb18b18b1d$export$87194bb378cc3ac2)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        validationBehavior: validationBehavior
    }));
    var groupRef = (0, $ggE0n.useRef)(null);
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var _$8nhma$useDatePicker = (0, $5ae9c14d003882b1$export$42df105a73306d51)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        label: label,
        validationBehavior: validationBehavior
    }), state, groupRef), groupProps = _$8nhma$useDatePicker.groupProps, labelProps = _$8nhma$useDatePicker.labelProps, fieldProps = _$8nhma$useDatePicker.fieldProps, buttonProps = _$8nhma$useDatePicker.buttonProps, dialogProps = _$8nhma$useDatePicker.dialogProps, calendarProps = _$8nhma$useDatePicker.calendarProps, descriptionProps = _$8nhma$useDatePicker.descriptionProps, errorMessageProps = _$8nhma$useDatePicker.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$8nhma$useDatePicker, [
        "groupProps",
        "labelProps",
        "fieldProps",
        "buttonProps",
        "dialogProps",
        "calendarProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    // Allows calendar width to match input group
    var _$8nhma$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), groupWidth = _$8nhma$useState[0], setGroupWidth = _$8nhma$useState[1];
    var onResize = (0, $ggE0n.useCallback)(function() {
        if (groupRef.current) setGroupWidth(groupRef.current.offsetWidth + 'px');
    }, []);
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: groupRef,
        onResize: onResize
    });
    var _$8nhma$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)({
        within: true
    }), focusProps = _$8nhma$useFocusRing.focusProps, isFocused = _$8nhma$useFocusRing.isFocused, isFocusVisible = _$8nhma$useFocusRing.isFocusVisible;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            state: state,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen
        },
        defaultClassName: 'react-aria-DatePicker'
    }));
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $a82d4d6c9117f171$export$50a10c048fdcdee9,
                state
            ],
            [
                (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, groupProps), {
                    ref: groupRef,
                    isInvalid: state.isInvalid
                })
            ],
            [
                (0, $b988ff963e2c53e5$export$7b3e670c86da5fe8),
                fieldProps
            ],
            [
                (0, $28c5f096242aff4d$export$24d547caef80ccd1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, buttonProps), {
                    isPressed: state.isOpen
                })
            ],
            [
                (0, $4fa91534e9375925$export$75b6ee27786ba447),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
                    ref: labelRef,
                    elementType: 'span'
                })
            ],
            [
                (0, $ad6a52d9b4386a70$export$3b805cea1f178355),
                calendarProps
            ],
            [
                (0, $e4ccc8b3c0827610$export$d2f961adcb0afbe),
                state
            ],
            [
                (0, $13b1a1463e05bd62$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'DatePicker',
                    triggerRef: groupRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': groupWidth
                    },
                    clearContexts: $a82d4d6c9117f171$var$$06d5b8ec9ee5d538$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $e4ccc8b3c0827610$export$8b93a07348a7730c),
                dialogProps
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $aef12de62ee30fed$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, focusProps, DOMProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-open": state.isOpen || undefined
    })));
});
var $a82d4d6c9117f171$export$17334619f3ac2224 = (0, $ggE0n.forwardRef)(function DateRangePicker(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, $a82d4d6c9117f171$export$8282edba42ee28a), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var _ref = (0, $e2b7517996df0b67$export$fabf2dc03a41866e)((0, $2bf90da467e9636b$export$c24727297075ec6a)) || {}, formValidationBehavior = _ref.validationBehavior;
    var _props_validationBehavior, _ref1;
    var validationBehavior = (_ref1 = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref1 !== void 0 ? _ref1 : 'native';
    var state = (0, $94633e85b80d99c4$export$e50a61c1de9f574)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        validationBehavior: validationBehavior
    }));
    var groupRef = (0, $ggE0n.useRef)(null);
    var _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']), 2), labelRef = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[0], label = _$64fa3d84918910a7$export$9d4c57ee4c6ffdd8[1];
    var _$8nhma$useDateRangePicker = (0, $36ab3c7676c7cc1d$export$12fd5f0e9f4bb192)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, (0, $e2b7517996df0b67$export$ef03459518577ad4)(props)), {
        label: label,
        validationBehavior: validationBehavior
    }), state, groupRef), groupProps = _$8nhma$useDateRangePicker.groupProps, labelProps = _$8nhma$useDateRangePicker.labelProps, startFieldProps = _$8nhma$useDateRangePicker.startFieldProps, endFieldProps = _$8nhma$useDateRangePicker.endFieldProps, buttonProps = _$8nhma$useDateRangePicker.buttonProps, dialogProps = _$8nhma$useDateRangePicker.dialogProps, calendarProps = _$8nhma$useDateRangePicker.calendarProps, descriptionProps = _$8nhma$useDateRangePicker.descriptionProps, errorMessageProps = _$8nhma$useDateRangePicker.errorMessageProps, validation = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(_$8nhma$useDateRangePicker, [
        "groupProps",
        "labelProps",
        "startFieldProps",
        "endFieldProps",
        "buttonProps",
        "dialogProps",
        "calendarProps",
        "descriptionProps",
        "errorMessageProps"
    ]);
    // Allows calendar width to match input group
    var _$8nhma$useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), groupWidth = _$8nhma$useState[0], setGroupWidth = _$8nhma$useState[1];
    var onResize = (0, $ggE0n.useCallback)(function() {
        if (groupRef.current) setGroupWidth(groupRef.current.offsetWidth + 'px');
    }, []);
    (0, $e75879033f372928$export$683480f191c0e3ea)({
        ref: groupRef,
        onResize: onResize
    });
    var _$8nhma$useFocusRing = (0, $0d787cea72c4b240$export$4e328f61c538687f)({
        within: true
    }), focusProps = _$8nhma$useFocusRing.focusProps, isFocused = _$8nhma$useFocusRing.isFocused, isFocusVisible = _$8nhma$useFocusRing.isFocusVisible;
    var renderProps = (0, $e2b7517996df0b67$export$4d86445c2cf5e3)((0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, props), {
        values: {
            state: state,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen
        },
        defaultClassName: 'react-aria-DateRangePicker'
    }));
    var DOMProps = (0, $eec1da6bbd30ba7f$export$457c3d6518dd4c6f)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $e2b7517996df0b67$export$2881499e37b75b9a), {
        values: [
            [
                $a82d4d6c9117f171$export$80d7ae1f804790be,
                state
            ],
            [
                (0, $b758c97c918eb1ee$export$f9c6924e160136d1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, groupProps), {
                    ref: groupRef,
                    isInvalid: state.isInvalid
                })
            ],
            [
                (0, $28c5f096242aff4d$export$24d547caef80ccd1),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, buttonProps), {
                    isPressed: state.isOpen
                })
            ],
            [
                (0, $4fa91534e9375925$export$75b6ee27786ba447),
                (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, labelProps), {
                    ref: labelRef,
                    elementType: 'span'
                })
            ],
            [
                (0, $ad6a52d9b4386a70$export$233dd9682e1ad64b),
                calendarProps
            ],
            [
                (0, $e4ccc8b3c0827610$export$d2f961adcb0afbe),
                state
            ],
            [
                (0, $13b1a1463e05bd62$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'DateRangePicker',
                    triggerRef: groupRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': groupWidth
                    },
                    clearContexts: $a82d4d6c9117f171$var$$06d5b8ec9ee5d538$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $e4ccc8b3c0827610$export$8b93a07348a7730c),
                dialogProps
            ],
            [
                (0, $b988ff963e2c53e5$export$7b3e670c86da5fe8),
                {
                    slots: {
                        start: startFieldProps,
                        end: endFieldProps
                    }
                }
            ],
            [
                (0, $fbbc6fda6285b143$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $aef12de62ee30fed$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, focusProps, DOMProps, renderProps), {
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-open": state.isOpen || undefined
    })));
});


var $2QPpE = parcelRequire("2QPpE");






var $ggE0n = parcelRequire("ggE0n");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $aded98c01a59b13c$export$a8a3e93435678ff9 = (0, $ggE0n.forwardRef)(function Heading(props, ref) {
    var _$ref;
    _$ref = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $e2b7517996df0b67$export$29f1550f4b0d4415)(props, ref, (0, $0669a7cc0abfc405$export$d688439359537581)), 2), props = _$ref[0], ref = _$ref[1], _$ref;
    var children = props.children, tmp = props.level, level = tmp === void 0 ? 3 : tmp, className = props.className, domProps = (0, $499a28b1dcbc98e8$export$71511d61b312f219)(props, [
        "children",
        "level",
        "className"
    ]);
    var Element = "h".concat(level);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(Element, (0, $077ff55a4e79d1c1$export$71511d61b312f219)((0, $2QPpE._)({}, domProps), {
        ref: ref,
        className: className !== null && className !== void 0 ? className : 'react-aria-Heading'
    }), children);
});



function $5c8e68f5c1b2457a$export$2e2bcd8739ae039(param) {
    var label = param.label, state = param.state, stateCallback = param.stateCallback;
    var _useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), value = _useState[0], setValue = _useState[1];
    // Synchronize local value with incoming state prop
    (0, $ggE0n.useEffect)(function() {
        if (state) {
            // Convert Unix timestamp back to CalendarDate
            var date = new Date(state * 1000);
            var calendarDate = new (0, $544adb0fa0f2d511$export$99faa760c7908e4f)(date.getFullYear(), date.getMonth() + 1, date.getDate());
            setValue(calendarDate);
        } else setValue(null);
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $a82d4d6c9117f171$export$5109c6dd95d8fb00), {
        value: value,
        onChange: function(value) {
            var _ref = value || {}, day = _ref.day, month = _ref.month, year = _ref.year;
            var date = day && month && year ? new Date(year, month - 1, day) : null;
            var unixTimestamp = date ? Math.floor(date.getTime() / 1000) : null;
            setValue(value);
            stateCallback(unixTimestamp);
        },
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $b758c97c918eb1ee$export$eb2fcfdbd7ba97d4), {
                className: "w-full",
                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                    className: "group w-full block p-xs border border-blue-oxford hover:border-gold",
                    children: function() {
                        return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                                    children: value ? "".concat(value.day, "/").concat(value.month, "/").concat(value.year) : label
                                }),
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("svg", {
                                    width: "19",
                                    height: "20",
                                    className: "text-blue-oxford group-hover:text-gold",
                                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("use", {
                                        xlinkHref: "#icon-datepicker"
                                    })
                                })
                            ]
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $13b1a1463e05bd62$export$5b6b19405a83ff9d), {
                className: "bg-white px-sm rounded-md border border-blue-oxford",
                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $e4ccc8b3c0827610$export$3ddf2d174ce01153), {
                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $ad6a52d9b4386a70$export$e1aef45b828286de), {
                        children: [
                            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("header", {
                                children: [
                                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                                        slot: "previous",
                                        children: "\u25C0"
                                    }),
                                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $aded98c01a59b13c$export$a8a3e93435678ff9), {}),
                                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                                        slot: "next",
                                        children: "\u25B6"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $ad6a52d9b4386a70$export$5bd780d491cfc46c), {
                                children: function(date) {
                                    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $ad6a52d9b4386a70$export$5d847498420df57b), {
                                        date: date,
                                        children: function(param) {
                                            var formattedDate = param.formattedDate, isSelected = param.isSelected, isDisabled = param.isDisabled, isOutsideMonth = param.isOutsideMonth, isUnavailable = param.isUnavailable;
                                            return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                                                className: "\n                        w-9 h-9 flex items-center justify-center cursor-pointer rounded-full transition-colors\n                        ".concat(isSelected ? 'bg-blue-oxford hover:!bg-blue-oxford !text-white font-bold' : '', "\n                        ").concat(isDisabled || isOutsideMonth || isUnavailable ? 'text-grey-400 cursor-not-allowed opacity-50 hover:bg-transparent' : 'hover:bg-grey-light', "\n                      "),
                                                children: formattedDate
                                            });
                                        }
                                    });
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
}


function $870eaacb64bbef61$export$2e2bcd8739ae039(param) {
    var heading = param.heading, state = param.state, stateCallbacks = param.stateCallbacks;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $d728d85f208a7030$exports.Fragment), {
        children: [
            heading ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h5", {
                className: "h5 font-semibold mb-md",
                children: heading
            }) : null,
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("ul", {
                className: "flex items-center max-sm:flex-col gap-sm mb-2xl",
                children: [
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $5c8e68f5c1b2457a$export$2e2bcd8739ae039), {
                            label: "From",
                            state: state.startDateFilter,
                            stateCallback: stateCallbacks === null || stateCallbacks === void 0 ? void 0 : stateCallbacks.setStartDateFilter
                        })
                    }),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                        children: "\u2013"
                    }),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $5c8e68f5c1b2457a$export$2e2bcd8739ae039), {
                            label: "To",
                            state: state.endDateFilter,
                            stateCallback: stateCallbacks === null || stateCallbacks === void 0 ? void 0 : stateCallbacks.setEndDateFilter
                        })
                    })
                ]
            })
        ]
    });
}




function $ffeb6bb204e7ae69$export$2e2bcd8739ae039(props) {
    var _useRefinementList = (0, $aac22500be3fad43$export$5da5a5848a7e380)(props), items = _useRefinementList.items, refine = _useRefinementList.refine;
    var heading = props === null || props === void 0 ? void 0 : props.heading;
    if (!items.length) return null;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $d728d85f208a7030$exports.Fragment), {
        children: [
            heading ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h5", {
                className: "h5 mb-md font-semibold",
                children: heading
            }) : null,
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("ol", {
                className: "grid sm:grid-cols-2 gap-y-2xs",
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                        className: "block",
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("label", {
                            className: "flex items-center gap-x-[8px]",
                            children: [
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: item.isRefined,
                                    onChange: function() {
                                        return refine(item.value);
                                    },
                                    className: "w-[16px] h-[16px] accent-gold"
                                }),
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                                    className: "text-[18px] text-black",
                                    children: item.label
                                })
                            ]
                        })
                    }, item.label);
                })
            })
        ]
    });
}




function $dc60521d47dd4db9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc60521d47dd4db9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc60521d47dd4db9$var$_typeof(o);
}
function $dc60521d47dd4db9$var$_toConsumableArray(arr) {
    return $dc60521d47dd4db9$var$_arrayWithoutHoles(arr) || $dc60521d47dd4db9$var$_iterableToArray(arr) || $dc60521d47dd4db9$var$_unsupportedIterableToArray(arr) || $dc60521d47dd4db9$var$_nonIterableSpread();
}
function $dc60521d47dd4db9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc60521d47dd4db9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc60521d47dd4db9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc60521d47dd4db9$var$_arrayLikeToArray(o, minLen);
}
function $dc60521d47dd4db9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dc60521d47dd4db9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dc60521d47dd4db9$var$_arrayLikeToArray(arr);
}
function $dc60521d47dd4db9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc60521d47dd4db9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc60521d47dd4db9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc60521d47dd4db9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dc60521d47dd4db9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc60521d47dd4db9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dc60521d47dd4db9$var$_defineProperty(obj, key, value) {
    key = $dc60521d47dd4db9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc60521d47dd4db9$var$_toPropertyKey(t) {
    var i = $dc60521d47dd4db9$var$_toPrimitive(t, "string");
    return "symbol" == $dc60521d47dd4db9$var$_typeof(i) ? i : String(i);
}
function $dc60521d47dd4db9$var$_toPrimitive(t, r) {
    if ("object" != $dc60521d47dd4db9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dc60521d47dd4db9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dc60521d47dd4db9$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'current-refinements',
    connector: true
});
var $dc60521d47dd4db9$var$connectCurrentRefinements = function connectCurrentRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $dc60521d47dd4db9$var$withUsage());
    return function(widgetParams) {
        if ((widgetParams || {}).includedAttributes && (widgetParams || {}).excludedAttributes) throw new Error($dc60521d47dd4db9$var$withUsage('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
        var _ref = widgetParams || {}, includedAttributes = _ref.includedAttributes, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            'query'
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        return {
            $$type: 'ais.currentRefinements',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($dc60521d47dd4db9$var$_objectSpread($dc60521d47dd4db9$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($dc60521d47dd4db9$var$_objectSpread($dc60521d47dd4db9$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $dc60521d47dd4db9$var$_objectSpread($dc60521d47dd4db9$var$_objectSpread({}, renderState), {}, {
                    currentRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var results = _ref2.results, scopedResults = _ref2.scopedResults, _createURL = _ref2.createURL, helper = _ref2.helper;
                function getItems() {
                    if (!results) return transformItems($dc60521d47dd4db9$var$getRefinementsItems({
                        results: null,
                        helper: helper,
                        indexId: helper.state.index,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes
                    }), {
                        results: results
                    });
                    return scopedResults.reduce(function(accResults, scopedResult) {
                        return accResults.concat(transformItems($dc60521d47dd4db9$var$getRefinementsItems({
                            results: scopedResult.results,
                            helper: scopedResult.helper,
                            indexId: scopedResult.indexId,
                            includedAttributes: includedAttributes,
                            excludedAttributes: excludedAttributes
                        }), {
                            results: results
                        }));
                    }, []);
                }
                var items = getItems();
                return {
                    items: items,
                    canRefine: items.length > 0,
                    refine: function refine(refinement) {
                        return $dc60521d47dd4db9$var$clearRefinement(helper, refinement);
                    },
                    createURL: function createURL(refinement) {
                        return _createURL($dc60521d47dd4db9$var$clearRefinementFromState(helper.state, refinement));
                    },
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $dc60521d47dd4db9$var$getRefinementsItems(_ref3) {
    var results = _ref3.results, helper = _ref3.helper, indexId = _ref3.indexId, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes;
    var includesQuery = (includedAttributes || []).indexOf('query') !== -1 || (excludedAttributes || []).indexOf('query') === -1;
    var filterFunction = includedAttributes ? function filterFunction(item) {
        return includedAttributes.indexOf(item.attribute) !== -1;
    } : function(item) {
        return excludedAttributes.indexOf(item.attribute) === -1;
    };
    var items = (0, $8256e59f633418c3$export$d9f33760e70a0a)(results, helper.state, includesQuery).map($dc60521d47dd4db9$var$normalizeRefinement).filter(filterFunction);
    return items.reduce(function(allItems, currentItem) {
        return [].concat($dc60521d47dd4db9$var$_toConsumableArray(allItems.filter(function(item) {
            return item.attribute !== currentItem.attribute;
        })), [
            {
                indexName: helper.state.index,
                indexId: indexId,
                attribute: currentItem.attribute,
                label: currentItem.attribute,
                refinements: items.filter(function(result) {
                    return result.attribute === currentItem.attribute;
                })// We want to keep the order of refinements except the numeric ones.
                .sort(function(a, b) {
                    return a.type === 'numeric' ? a.value - b.value : 0;
                }),
                refine: function refine(refinement) {
                    return $dc60521d47dd4db9$var$clearRefinement(helper, refinement);
                }
            }
        ]);
    }, []);
}
function $dc60521d47dd4db9$var$clearRefinementFromState(state, refinement) {
    state = state.resetPage();
    switch(refinement.type){
        case 'facet':
            return state.removeFacetRefinement(refinement.attribute, String(refinement.value));
        case 'disjunctive':
            return state.removeDisjunctiveFacetRefinement(refinement.attribute, String(refinement.value));
        case 'hierarchical':
            return state.removeHierarchicalFacetRefinement(refinement.attribute);
        case 'exclude':
            return state.removeExcludeRefinement(refinement.attribute, String(refinement.value));
        case 'numeric':
            return state.removeNumericRefinement(refinement.attribute, refinement.operator, String(refinement.value));
        case 'tag':
            return state.removeTagRefinement(String(refinement.value));
        case 'query':
            return state.setQueryParameter('query', '');
        default:
            return state;
    }
}
function $dc60521d47dd4db9$var$clearRefinement(helper, refinement) {
    helper.setState($dc60521d47dd4db9$var$clearRefinementFromState(helper.state, refinement)).search();
}
function $dc60521d47dd4db9$var$getOperatorSymbol(operator) {
    switch(operator){
        case '>=':
            return "\u2265";
        case '<=':
            return "\u2264";
        default:
            return operator;
    }
}
function $dc60521d47dd4db9$var$normalizeRefinement(refinement) {
    var value = $dc60521d47dd4db9$var$getValue(refinement);
    var label = refinement.operator ? "".concat($dc60521d47dd4db9$var$getOperatorSymbol(refinement.operator), " ").concat(refinement.name) : refinement.name;
    var normalizedRefinement = {
        attribute: refinement.attribute,
        type: refinement.type,
        value: value,
        label: label
    };
    if (refinement.operator !== undefined) normalizedRefinement.operator = refinement.operator;
    if (refinement.count !== undefined) normalizedRefinement.count = refinement.count;
    if (refinement.exhaustive !== undefined) normalizedRefinement.exhaustive = refinement.exhaustive;
    return normalizedRefinement;
}
function $dc60521d47dd4db9$var$getValue(refinement) {
    if (refinement.type === 'numeric') return Number(refinement.name);
    if ('escapedValue' in refinement) return refinement.escapedValue;
    return refinement.name;
}
var $dc60521d47dd4db9$export$2e2bcd8739ae039 = $dc60521d47dd4db9$var$connectCurrentRefinements;



function $9d979794f4292963$export$a547396a8ef2bade(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $dc60521d47dd4db9$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}



function $b8fbe2a2af7b4e1e$export$2e2bcd8739ae039() {
    var items = (0, $9d979794f4292963$export$a547396a8ef2bade)().items;
    // Calculate total number of active refinements
    var totalRefinements = items.reduce(function(total, item) {
        return total + item.refinements.length;
    }, 0);
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
        className: "\n        group\n        flex\n        shrink-0\n        items-center\n        justify-center\n        h-[64px]\n        max-sm:w-[54px]\n        max-sm:h-[54px]\n        gap-x-sm\n        py-sm\n        sm:px-lg\n        text-lg\n        rounded-full\n        outline-2\n        duration-250\n        transition-colors\n        outline-primary\n        text-primary\n        hover:text-bg\n        hover:bg-primary\n    ",
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("svg", {
                width: "24",
                height: "24",
                className: "text-current",
                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("use", {
                    xlinkHref: "#icon-filters"
                })
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("span", {
                className: "max-sm:sr-only whitespace-nowrap",
                children: [
                    "Filters ",
                    totalRefinements >= 1 ? "(".concat(totalRefinements, ")") : null
                ]
            })
        ]
    });
}


function $848160b27624d3ae$export$2e2bcd8739ae039(param) {
    var state = param.state, stateCallbacks = param.stateCallbacks;
    var _useSearchBox = (0, $7732a887e1609a22$export$34d981d965dcc5b5)(), query = _useSearchBox.query, refine = _useSearchBox.refine;
    var _useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(query), 2), _ = _useState[0], setInputValue = _useState[1];
    var _useClearRefinements = (0, $1f65d342571fa7e6$export$60a47f8af66e226a)({
        includedAttributes: [
            'default_genre',
            'query'
        ]
    }), canRefine = _useClearRefinements.canRefine, clearRefinement = _useClearRefinements.refine;
    function setQuery(newQuery) {
        setInputValue(newQuery);
        refine(newQuery);
    }
    var portalRoot = document.getElementById('react-portal-placeholder');
    var toolbarContent = /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("form", {
        className: "w-full flex gap-x-lg max-sm:gap-x-sm",
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("input", {
                onChange: function(event) {
                    return setQuery(event.currentTarget.value);
                },
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "off",
                maxLength: 300,
                type: "text",
                placeholder: "Search ".concat(window.POST_TYPE),
                className: "\n          rounded-full\n          w-full\n          sm:h-[64px]\n          max-sm:h-[54px]\n          py-sm\n          px-lg\n          pl-[60px]\n          max-sm:pl-[44px]\n          text-lg\n          max-md:text-sm\n          input-bg--search\n          outline-2\n          duration-250\n          transition-colors\n          outline-primary\n          placeholder-primary\n          hover:bg-line\n          focus:text-bg\n          focus:bg-primary\n        "
            }),
            window.POST_TYPE === 'events' ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $e4ccc8b3c0827610$export$2e1e1122cf0cba88), {
                children: [
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $b8fbe2a2af7b4e1e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $203bd87f5067e9a4$export$2b77a92f1a5ad772), {
                        isDismissable: true,
                        className: "w-full max-w-[600px] max-h-[90vh] rounded-md bg-white sm:mx-sm mx-2xs overflow-hidden",
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $e4ccc8b3c0827610$export$3ddf2d174ce01153), {
                            className: "flex flex-col h-full max-h-[90vh]",
                            children: [
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("header", {
                                    className: "flex items-center justify-between px-lg py-md border-b border-grey-light",
                                    children: [
                                        /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                                            className: "text-lg",
                                            children: "Filters"
                                        }),
                                        /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                                            slot: "close",
                                            children: [
                                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("svg", {
                                                    width: "18",
                                                    height: "18",
                                                    className: "text-black hover:text-gold",
                                                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("use", {
                                                        xlinkHref: "#icon-close"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close filter window"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                                    className: "p-lg overflow-y-auto flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $870eaacb64bbef61$export$2e2bcd8739ae039), {
                                            heading: "Date range",
                                            state: state,
                                            stateCallbacks: stateCallbacks
                                        }),
                                        /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $ffeb6bb204e7ae69$export$2e2bcd8739ae039), {
                                            heading: "Categories",
                                            attribute: "default_genre",
                                            sortBy: [
                                                'name:asc'
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("footer", {
                                    className: "flex items-center justify-between px-lg py-md border-t border-grey-light flex-shrink-0",
                                    children: [
                                        canRefine || state.startDateFilter || state.endDateFilter ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                                            onClick: function() {
                                                clearRefinement();
                                                if (state.startDateFilter) stateCallbacks.setStartDateFilter(null);
                                                if (state.endDateFilter) stateCallbacks.setEndDateFilter(null);
                                            },
                                            className: "text-sm hover:text-gold",
                                            children: "Clear all"
                                        }) : /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {}),
                                        /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                                            className: "w-auto btn btn--sm btn--solid py-sm px-sm",
                                            slot: "close",
                                            "aria-label": "Close filter window return to show results",
                                            children: "View results"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
    if (portalRoot) return /*#__PURE__*/ (0, $3og2D.createPortal)(toolbarContent, portalRoot);
    return toolbarContent;
}




function $9f5b40917e98c523$export$2e2bcd8739ae039(param) {
    var hit = param.hit;
    var _hit_images, _hit_event_dates, _hit_event_dates1, _hit_event_dates2, _hit_event_dates3, _hit_event_dates4, _hit_event_dates5;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
        className: "wrapper--outside mb-3xl sm:border-t sm:border-grey-light",
        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("article", {
            className: "group wrapper wrapper--max grid grid-cols-3 max-md:grid-cols-1",
            children: [
                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                        className: "grid grid-cols-[var(--spacing-xl)_1fr] gap-lg max-lg:grid-cols-1",
                        children: [
                            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                                className: "text-[44px] text--vertical hidden lg:block font-thin",
                                children: (hit === null || hit === void 0 ? void 0 : hit.default_genre) ? hit.default_genre : 'Event'
                            }),
                            (hit === null || hit === void 0 ? void 0 : (_hit_images = hit.images) === null || _hit_images === void 0 ? void 0 : _hit_images.grid_image) && (hit === null || hit === void 0 ? void 0 : hit.post_title) && (hit === null || hit === void 0 ? void 0 : hit.permalink) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                                href: hit === null || hit === void 0 ? void 0 : hit.permalink,
                                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                                    className: "overflow-hidden",
                                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("img", {
                                        src: hit.images.grid_image,
                                        className: "object-cover aspect-video w-full wp-post-image  group-hover:scale-105 transition-all duration-250",
                                        alt: hit.post_title,
                                        decoding: "async",
                                        loading: "lazy"
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                                href: hit === null || hit === void 0 ? void 0 : hit.permalink,
                                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("img", {
                                    src: "/wp-content/themes/jersey-opera-house/dist/img/grid-item-placeholder.png",
                                    alt: "Placeholder"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                    className: "text--theme theme--text-sm border-0",
                    children: [
                        (hit === null || hit === void 0 ? void 0 : hit.default_genre) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                            className: "text-[28px] hidden max-lg:block text-gold font-secondary mt-md",
                            children: hit.default_genre
                        }) : null,
                        (hit === null || hit === void 0 ? void 0 : hit.post_title) && (hit === null || hit === void 0 ? void 0 : hit.permalink) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h3", {
                            className: "text--stretch",
                            children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                                href: hit === null || hit === void 0 ? void 0 : hit.permalink,
                                className: "hover:text-gold group-hover:text-gold duration-200 leading-none !no-underline",
                                children: hit.post_title
                            })
                        }) : null,
                        (hit === null || hit === void 0 ? void 0 : hit.description) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: hit.description
                            }
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                    className: "text--theme theme--text-sm",
                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                        className: "flex max-xl:flex-col max-md:flex-row max-sm:flex-col gap-md justify-between",
                        children: [
                            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("p", {
                                className: "block p--lg leading-tight",
                                children: [
                                    (hit === null || hit === void 0 ? void 0 : (_hit_event_dates = hit.event_dates) === null || _hit_event_dates === void 0 ? void 0 : _hit_event_dates.start_date) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("strong", {
                                        children: (_hit_event_dates1 = hit.event_dates) === null || _hit_event_dates1 === void 0 ? void 0 : _hit_event_dates1.start_date
                                    }) : null,
                                    ' ',
                                    (hit === null || hit === void 0 ? void 0 : (_hit_event_dates2 = hit.event_dates) === null || _hit_event_dates2 === void 0 ? void 0 : _hit_event_dates2.end_date) && (hit === null || hit === void 0 ? void 0 : (_hit_event_dates3 = hit.event_dates) === null || _hit_event_dates3 === void 0 ? void 0 : _hit_event_dates3.start_date) !== (hit === null || hit === void 0 ? void 0 : (_hit_event_dates4 = hit.event_dates) === null || _hit_event_dates4 === void 0 ? void 0 : _hit_event_dates4.end_date) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("strong", {
                                        children: [
                                            " - ",
                                            (_hit_event_dates5 = hit.event_dates) === null || _hit_event_dates5 === void 0 ? void 0 : _hit_event_dates5.end_date
                                        ]
                                    }) : null,
                                    ' ',
                                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("br", {}),
                                    (hit === null || hit === void 0 ? void 0 : hit.venue) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                                        className: "block mt-2xs",
                                        children: hit === null || hit === void 0 ? void 0 : hit.venue
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("nav", {
                                className: "flex items-center flex-col max-md:flex-row max-xs:flex-col gap-sm",
                                children: [
                                    hit.booking_url ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                                        href: hit.booking_url,
                                        className: "btn btn--sm btn--solid py-sm px-lg w-full whitespace-nowrap",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book Now"
                                    }) : null,
                                    (hit === null || hit === void 0 ? void 0 : hit.permalink) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                                        href: hit === null || hit === void 0 ? void 0 : hit.permalink,
                                        className: "btn btn--sm btn--outline py-sm px-lg w-full whitespace-nowrap",
                                        children: "More Info"
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



function $039367123b4ecb14$export$2e2bcd8739ae039(param) {
    var hit = param.hit;
    var _hit_images;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("article", {
        className: "group h-full flex flex-col",
        children: [
            (hit === null || hit === void 0 ? void 0 : (_hit_images = hit.images) === null || _hit_images === void 0 ? void 0 : _hit_images.grid_image) && (hit === null || hit === void 0 ? void 0 : hit.post_title) && (hit === null || hit === void 0 ? void 0 : hit.permalink) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                href: hit === null || hit === void 0 ? void 0 : hit.permalink,
                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("img", {
                        src: hit.images.grid_image,
                        className: "object-cover object-center aspect-video w-full lg:max-h-[315px] wp-post-image group-hover:scale-105 transition-all duration-250",
                        alt: hit.post_title,
                        decoding: "async",
                        loading: "lazy"
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                className: "text--theme theme--text-card mce-content-body",
                children: [
                    (hit === null || hit === void 0 ? void 0 : hit.post_title) && (hit === null || hit === void 0 ? void 0 : hit.permalink) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h3", {
                        className: "max-xl:text-2xl max-md:text-h3",
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                            href: hit === null || hit === void 0 ? void 0 : hit.permalink,
                            className: "hover:text-gold duration-200 leading-none group-hover:text-gold !no-underline",
                            children: hit.post_title
                        })
                    }) : null,
                    (hit === null || hit === void 0 ? void 0 : hit.post_date_formatted) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("p", {
                        className: "p--lg",
                        children: hit === null || hit === void 0 ? void 0 : hit.post_date_formatted
                    }) : null
                ]
            })
        ]
    });
}


function $faeabef4a901a1ed$export$2e2bcd8739ae039(param) {
    var hit = param.hit;
    if ((hit === null || hit === void 0 ? void 0 : hit.post_type) === 'events') return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $9f5b40917e98c523$export$2e2bcd8739ae039), {
        hit: hit
    });
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $039367123b4ecb14$export$2e2bcd8739ae039), {
        hit: hit
    });
}




function $813c5aafb0286059$var$_toConsumableArray(arr) {
    return $813c5aafb0286059$var$_arrayWithoutHoles(arr) || $813c5aafb0286059$var$_iterableToArray(arr) || $813c5aafb0286059$var$_unsupportedIterableToArray(arr) || $813c5aafb0286059$var$_nonIterableSpread();
}
function $813c5aafb0286059$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $813c5aafb0286059$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $813c5aafb0286059$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $813c5aafb0286059$var$_arrayLikeToArray(o, minLen);
}
function $813c5aafb0286059$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $813c5aafb0286059$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $813c5aafb0286059$var$_arrayLikeToArray(arr);
}
function $813c5aafb0286059$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $813c5aafb0286059$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $813c5aafb0286059$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return start + current * limitStep;
    });
}


function $ac714c8e13174de5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ac714c8e13174de5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ac714c8e13174de5$var$_typeof(o);
}
function $ac714c8e13174de5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ac714c8e13174de5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ac714c8e13174de5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ac714c8e13174de5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ac714c8e13174de5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ac714c8e13174de5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ac714c8e13174de5$var$_defineProperty(obj, key, value) {
    key = $ac714c8e13174de5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ac714c8e13174de5$var$_toPropertyKey(t) {
    var i = $ac714c8e13174de5$var$_toPrimitive(t, "string");
    return "symbol" == $ac714c8e13174de5$var$_typeof(i) ? i : String(i);
}
function $ac714c8e13174de5$var$_toPrimitive(t, r) {
    if ("object" != $ac714c8e13174de5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ac714c8e13174de5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ac714c8e13174de5$var$Paginator = /*#__PURE__*/ function() {
    function Paginator(params) {
        $ac714c8e13174de5$var$_classCallCheck(this, Paginator);
        $ac714c8e13174de5$var$_defineProperty(this, "currentPage", void 0);
        $ac714c8e13174de5$var$_defineProperty(this, "total", void 0);
        $ac714c8e13174de5$var$_defineProperty(this, "padding", void 0);
        this.currentPage = params.currentPage;
        this.total = params.total;
        this.padding = params.padding;
    }
    $ac714c8e13174de5$var$_createClass(Paginator, [
        {
            key: "pages",
            value: function pages() {
                var total = this.total, currentPage = this.currentPage, padding = this.padding;
                if (total === 0) return [
                    0
                ];
                var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
                if (totalDisplayedPages === total) return (0, $813c5aafb0286059$export$d02631cccf789723)({
                    end: total
                });
                var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
                var paddingRight = totalDisplayedPages - paddingLeft;
                var first = currentPage - paddingLeft;
                var last = currentPage + paddingRight;
                return (0, $813c5aafb0286059$export$d02631cccf789723)({
                    start: first,
                    end: last
                });
            }
        },
        {
            key: "nbPagesDisplayed",
            value: function nbPagesDisplayed(padding, total) {
                return Math.min(2 * padding + 1, total);
            }
        },
        {
            key: "calculatePaddingLeft",
            value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
                if (current <= padding) return current;
                if (current >= total - padding) return totalDisplayedPages - (total - current);
                return padding;
            }
        },
        {
            key: "isLastPage",
            value: function isLastPage() {
                return this.currentPage >= this.total - 1;
            }
        },
        {
            key: "isFirstPage",
            value: function isFirstPage() {
                return this.currentPage <= 0;
            }
        }
    ]);
    return Paginator;
}();
var $ac714c8e13174de5$export$2e2bcd8739ae039 = $ac714c8e13174de5$var$Paginator;


function $964b4ba346871f02$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $964b4ba346871f02$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $964b4ba346871f02$var$_typeof(o);
}
function $964b4ba346871f02$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $964b4ba346871f02$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $964b4ba346871f02$var$ownKeys(Object(t), !0).forEach(function(r) {
            $964b4ba346871f02$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $964b4ba346871f02$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $964b4ba346871f02$var$_defineProperty(obj, key, value) {
    key = $964b4ba346871f02$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $964b4ba346871f02$var$_toPropertyKey(t) {
    var i = $964b4ba346871f02$var$_toPrimitive(t, "string");
    return "symbol" == $964b4ba346871f02$var$_typeof(i) ? i : String(i);
}
function $964b4ba346871f02$var$_toPrimitive(t, r) {
    if ("object" != $964b4ba346871f02$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $964b4ba346871f02$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $964b4ba346871f02$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'pagination',
    connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */ var $964b4ba346871f02$var$connectPagination = function connectPagination(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $964b4ba346871f02$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, totalPages = _ref.totalPages, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
        var pager = new (0, $ac714c8e13174de5$export$2e2bcd8739ae039)({
            currentPage: 0,
            total: 0,
            padding: padding
        });
        var connectorState = {};
        function getMaxPage(_ref2) {
            var nbPages = _ref2.nbPages;
            return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
        }
        return {
            $$type: 'ais.pagination',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($964b4ba346871f02$var$_objectSpread($964b4ba346871f02$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($964b4ba346871f02$var$_objectSpread($964b4ba346871f02$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.setQueryParameter('page', undefined);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) return uiState;
                return $964b4ba346871f02$var$_objectSpread($964b4ba346871f02$var$_objectSpread({}, uiState), {}, {
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var page = uiState.page ? uiState.page - 1 : 0;
                return searchParameters.setQueryParameter('page', page);
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var results = _ref6.results, helper = _ref6.helper, state = _ref6.state, createURL = _ref6.createURL;
                if (!connectorState.refine) connectorState.refine = function(page) {
                    helper.setPage(page);
                    helper.search();
                };
                if (!connectorState.createURL) connectorState.createURL = function(page) {
                    return createURL(function(uiState) {
                        return $964b4ba346871f02$var$_objectSpread($964b4ba346871f02$var$_objectSpread({}, uiState), {}, {
                            page: page + 1
                        });
                    });
                };
                var page = state.page || 0;
                var nbPages = getMaxPage(results || {
                    nbPages: 0
                });
                pager.currentPage = page;
                pager.total = nbPages;
                return {
                    createURL: connectorState.createURL,
                    refine: connectorState.refine,
                    canRefine: nbPages > 1,
                    currentRefinement: page,
                    nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
                    nbPages: nbPages,
                    pages: results ? pager.pages() : [],
                    isFirstPage: pager.isFirstPage(),
                    isLastPage: pager.isLastPage(),
                    widgetParams: widgetParams
                };
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $964b4ba346871f02$var$_objectSpread($964b4ba346871f02$var$_objectSpread({}, renderState), {}, {
                    pagination: this.getWidgetRenderState(renderOptions)
                });
            }
        };
    };
};
var $964b4ba346871f02$export$2e2bcd8739ae039 = $964b4ba346871f02$var$connectPagination;



function $e33adfb2666d3e59$export$f80c710216eae131(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $964b4ba346871f02$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $3397557cb5aa0d71$export$2e2bcd8739ae039(props) {
    var _usePagination = (0, $e33adfb2666d3e59$export$f80c710216eae131)(props), currentRefinement = _usePagination.currentRefinement, nbHits = _usePagination.nbHits, nbPages = _usePagination.nbPages, isFirstPage = _usePagination.isFirstPage, isLastPage = _usePagination.isLastPage, refine = _usePagination.refine;
    var previousPageIndex = currentRefinement - 1;
    var nextPageIndex = currentRefinement + 1;
    var itemClass = 'text-md text-blue-oxford hover:text-gold';
    if (nbHits === 0 || nbPages <= 1) return null;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
        className: "wrapper--outside border-t border-grey-light",
        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
            className: "wrapper wrapper--max flex justify-between gap-x-sm py-xl ",
            children: [
                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("span", {
                    className: itemClass,
                    children: [
                        "Page ",
                        currentRefinement + 1,
                        " of ",
                        nbPages
                    ]
                }),
                /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("ul", {
                    className: "flex",
                    children: [
                        !isFirstPage ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("button", {
                                onClick: function() {
                                    refine(previousPageIndex);
                                    if (typeof window !== 'undefined') window.scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: 'smooth'
                                    });
                                },
                                className: itemClass,
                                children: "Previous"
                            })
                        }) : null,
                        !isFirstPage && !isLastPage ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                            className: " ".concat(itemClass, " px-3xs"),
                            children: " / "
                        }) : null,
                        !isLastPage ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("button", {
                                onClick: function() {
                                    refine(nextPageIndex);
                                    if (typeof window !== 'undefined') window.scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: 'smooth'
                                    });
                                },
                                className: itemClass,
                                children: "Next"
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
}





function $61bd4b6b2031ce51$export$2e2bcd8739ae039(param) {
    var callbacks = param.callbacks;
    var _useClearRefinements = (0, $1f65d342571fa7e6$export$60a47f8af66e226a)({
        includedAttributes: [
            'taxonomies.genre',
            'query'
        ]
    }), clearRefinement = _useClearRefinements.refine;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
        className: "text-center my-[10%]",
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h3", {
                className: "mb-sm",
                children: "No results found"
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("p", {
                className: "p--lg",
                children: "Please try a different search term or browse our categories"
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $28c5f096242aff4d$export$353f5b6fc5456de1), {
                onClick: function() {
                    clearRefinement();
                    if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.refine) callbacks.refine();
                },
                className: "btn btn--sm btn--solid py-sm px-lg w-auto whitespace-nowrap mt-lg",
                children: "Clear and try again"
            })
        ]
    });
}




var $ggE0n = parcelRequire("ggE0n");




var $ggE0n = parcelRequire("ggE0n");



function $b70fb61f64a0552e$var$_slicedToArray(arr, i) {
    return $b70fb61f64a0552e$var$_arrayWithHoles(arr) || $b70fb61f64a0552e$var$_iterableToArrayLimit(arr, i) || $b70fb61f64a0552e$var$_unsupportedIterableToArray(arr, i) || $b70fb61f64a0552e$var$_nonIterableRest();
}
function $b70fb61f64a0552e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b70fb61f64a0552e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b70fb61f64a0552e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b70fb61f64a0552e$var$_arrayLikeToArray(o, minLen);
}
function $b70fb61f64a0552e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b70fb61f64a0552e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b70fb61f64a0552e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b70fb61f64a0552e$export$deb5cc6ef1318024() {
    var search = (0, $7b73f0fe3da59f00$export$607655cdd66d2a68)();
    var searchIndex = (0, $ff1c2cc87ff571fe$export$78be30f1ffebe6ed)();
    var _useState = (0, $ggE0n.useState)(function() {
        var indexSearchResults = (0, $02c1f4b77019b96f$export$cb51f617c98f90d3)(searchIndex);
        // We do this not to leak `recommendResults` in the API.
        return {
            results: indexSearchResults.results,
            scopedResults: indexSearchResults.scopedResults
        };
    }), _useState2 = $b70fb61f64a0552e$var$_slicedToArray(_useState, 2), searchResults = _useState2[0], setSearchResults = _useState2[1];
    (0, $ggE0n.useEffect)(function() {
        function handleRender() {
            var results = searchIndex.getResults();
            // Results can be `null` when the first search is stalled.
            // In this case, we skip the update.
            // See: https://github.com/algolia/instantsearch/blob/20996c7a159988c58e00ff24d2d2dc98af8b980f/src/widgets/index/index.ts#L652-L657
            if (results !== null) setSearchResults({
                results: results,
                scopedResults: searchIndex.getScopedResults()
            });
            else if (search.mainIndex.getIndexName().length === 0) {
                // If the main index has no name, we get the scoped results from
                // the first child index instead.
                var childIndex = search.mainIndex.getWidgets().find((0, $60dca3dbb9baf5ef$export$a9c9a0d43506297d));
                childIndex && setSearchResults({
                    results: (0, $02c1f4b77019b96f$export$cb51f617c98f90d3)(searchIndex).results,
                    scopedResults: childIndex.getScopedResults()
                });
            }
        }
        search.addListener('render', handleRender);
        // Force setting results to mitigate potential race conditions where
        // render listener is added after search results have been returned.
        // This edge case is currently not covered by the tests.
        handleRender();
        return function() {
            search.removeListener('render', handleRender);
        };
    }, [
        search,
        searchIndex
    ]);
    return searchResults;
}



var $ggE0n = parcelRequire("ggE0n");


function $292f2d27053ffad2$var$_slicedToArray(arr, i) {
    return $292f2d27053ffad2$var$_arrayWithHoles(arr) || $292f2d27053ffad2$var$_iterableToArrayLimit(arr, i) || $292f2d27053ffad2$var$_unsupportedIterableToArray(arr, i) || $292f2d27053ffad2$var$_nonIterableRest();
}
function $292f2d27053ffad2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $292f2d27053ffad2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $292f2d27053ffad2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $292f2d27053ffad2$var$_arrayLikeToArray(o, minLen);
}
function $292f2d27053ffad2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $292f2d27053ffad2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $292f2d27053ffad2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $292f2d27053ffad2$export$5fd14fa624074d55() {
    var search = (0, $7b73f0fe3da59f00$export$607655cdd66d2a68)();
    var searchIndex = (0, $ff1c2cc87ff571fe$export$78be30f1ffebe6ed)();
    var indexId = searchIndex.getIndexId();
    var _useState = (0, $ggE0n.useState)(function() {
        return search.getUiState();
    }), _useState2 = $292f2d27053ffad2$var$_slicedToArray(_useState, 2), uiState = _useState2[0], setLocalUiState = _useState2[1];
    var indexUiState = uiState[indexId];
    var _useState3 = (0, $ggE0n.useState)(function() {
        return search.renderState;
    }), _useState4 = $292f2d27053ffad2$var$_slicedToArray(_useState3, 2), renderState = _useState4[0], setRenderState = _useState4[1];
    var indexRenderState = renderState[indexId] || {};
    var setUiState = (0, $ggE0n.useCallback)(function(nextUiState) {
        search.setUiState(nextUiState);
    }, [
        search
    ]);
    var setIndexUiState = (0, $ggE0n.useCallback)(function(nextIndexUiState) {
        searchIndex.setIndexUiState(nextIndexUiState);
    }, [
        searchIndex
    ]);
    (0, $ggE0n.useEffect)(function() {
        function handleRender() {
            setLocalUiState(search.getUiState());
            setRenderState(search.renderState);
        }
        search.addListener('render', handleRender);
        // Force setting state to mitigate potential race conditions where
        // render listener is added after search results have been returned.
        // This edge case is currently not covered by the tests.
        handleRender();
        return function() {
            search.removeListener('render', handleRender);
        };
    }, [
        search
    ]);
    return {
        uiState: uiState,
        setUiState: setUiState,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        renderState: renderState,
        indexRenderState: indexRenderState
    };
}


function $ed99ed12fcc0facf$export$c3584afb06ed387d() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, catchError = _ref.catchError;
    var search = (0, $7b73f0fe3da59f00$export$607655cdd66d2a68)();
    var _useSearchState = (0, $292f2d27053ffad2$export$5fd14fa624074d55)(), uiState = _useSearchState.uiState, setUiState = _useSearchState.setUiState, indexUiState = _useSearchState.indexUiState, setIndexUiState = _useSearchState.setIndexUiState, renderState = _useSearchState.renderState, indexRenderState = _useSearchState.indexRenderState;
    var _useSearchResults = (0, $b70fb61f64a0552e$export$deb5cc6ef1318024)(), results = _useSearchResults.results, scopedResults = _useSearchResults.scopedResults;
    var addMiddlewares = (0, $ggE0n.useCallback)(function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
        search.use.apply(search, middlewares);
        return function() {
            search.unuse.apply(search, middlewares);
        };
    }, [
        search
    ]);
    var refresh = (0, $ggE0n.useCallback)(function() {
        search.refresh();
    }, [
        search
    ]);
    (0, $b279185b17e60034$export$700979bc83e7db82)(function() {
        if (catchError) {
            var onError = function onError() {};
            search.addListener('error', onError);
            return function() {
                return search.removeListener('error', onError);
            };
        }
        return function() {};
    }, [
        search,
        catchError
    ]);
    return {
        results: results,
        scopedResults: scopedResults,
        uiState: uiState,
        setUiState: setUiState,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        renderState: renderState,
        indexRenderState: indexRenderState,
        addMiddlewares: addMiddlewares,
        refresh: refresh,
        status: search.status,
        error: search.error
    };
}


function $4c9d73fabaec8ac1$export$2a19844878d7a6e0(param) {
    var children = param.children, fallback = param.fallback;
    var results = (0, $ed99ed12fcc0facf$export$c3584afb06ed387d)().results;
    // The `__isArtificial` flag makes sure not to display the No Results message
    // when no hits have been returned.
    if (!results.__isArtificial && results.nbHits === 0) return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $d728d85f208a7030$exports.Fragment), {
        children: fallback
    });
    return children;
}


function $0a0fd746fdb2993a$var$VirtualRefinementList(props) {
    (0, $aac22500be3fad43$export$5da5a5848a7e380)(props);
    return null;
}
function $0a0fd746fdb2993a$export$2e2bcd8739ae039() {
    var _useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), searchClient = _useState[0], setSearchClient = _useState[1];
    var _useState1 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), startDateFilter = _useState1[0], setStartDateFilter = _useState1[1];
    var _useState2 = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), endDateFilter = _useState2[0], setEndDateFilter = _useState2[1];
    var routing = {
        stateMapping: (0, $52c40fbe513f5efb$export$2e2bcd8739ae039)()
    };
    var todayUnix = Math.floor(Date.now() / 1000);
    (0, $ggE0n.useEffect)(function() {
        // Check if we're in the browser and API keys are available
        if (typeof window !== 'undefined' && window.ALGOLIA_APPLICATION_ID && window.ALGOLIA_SEARCH_API_KEY) {
            var client = (0, (/*@__PURE__*/$parcel$interopDefault($iom5D)))(window.ALGOLIA_APPLICATION_ID, window.ALGOLIA_SEARCH_API_KEY);
            setSearchClient(client);
        }
    }, []);
    // Don't render InstantSearch until we have a valid search client
    if (!searchClient) return null;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $204762a302987aec$export$ad8f235d2c2c71c0), {
        searchClient: searchClient,
        routing: routing,
        indexName: "wp_posts_".concat(window.POST_TYPE),
        future: {
            preserveSharedStateOnUnmount: true,
            persistHierarchicalRootCount: true
        },
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)($0a0fd746fdb2993a$var$VirtualRefinementList, {
                attribute: "default_genre"
            }),
            window.POST_TYPE !== 'events' ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $d728d85f208a7030$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $3240ea332fbba201$export$de5f40ff1ff419d2), {
                        analytics: false,
                        hitsPerPage: 10
                    }),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $4c9d73fabaec8ac1$export$2a19844878d7a6e0), {
                        fallback: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $61bd4b6b2031ce51$export$2e2bcd8739ae039), {}),
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $51e227cba8706de3$export$9abb8533010f1d93), {
                            hitComponent: (0, $faeabef4a901a1ed$export$2e2bcd8739ae039),
                            classNames: {
                                list: 'grid grid-cols-3 max-md:grid-cols-1 gap-y-5xl max-md:gap-y-2xl mb-3xl'
                            }
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $d728d85f208a7030$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $3240ea332fbba201$export$de5f40ff1ff419d2), {
                        analytics: false,
                        hitsPerPage: 36,
                        filters: "event_dates.start_date_unix >= ".concat(todayUnix).concat(startDateFilter ? " AND event_dates.start_date_unix >= ".concat(startDateFilter) : '', " ").concat(endDateFilter ? "AND event_dates.end_date_unix <= ".concat(endDateFilter) : '')
                    }),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $4c9d73fabaec8ac1$export$2a19844878d7a6e0), {
                        fallback: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $61bd4b6b2031ce51$export$2e2bcd8739ae039), {
                            callbacks: {
                                refine: function() {
                                    setStartDateFilter(null);
                                    setEndDateFilter(null);
                                }
                            }
                        }),
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $51e227cba8706de3$export$9abb8533010f1d93), {
                            hitComponent: (0, $faeabef4a901a1ed$export$2e2bcd8739ae039)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $848160b27624d3ae$export$2e2bcd8739ae039), {
                state: {
                    startDateFilter: startDateFilter,
                    endDateFilter: endDateFilter
                },
                stateCallbacks: {
                    setStartDateFilter: setStartDateFilter,
                    setEndDateFilter: setEndDateFilter
                }
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $3397557cb5aa0d71$export$2e2bcd8739ae039), {})
        ]
    });
}





var $ggE0n = parcelRequire("ggE0n");

var $iom5D = parcelRequire("iom5D");

var $ggE0n = parcelRequire("ggE0n");



var $ggE0n = parcelRequire("ggE0n");
var $f88d81f0b0e64aaa$var$_excluded = [
    "formRef",
    "inputRef",
    "isSearchStalled",
    "onChange",
    "onReset",
    "onSubmit",
    "placeholder",
    "value",
    "autoFocus",
    "resetIconComponent",
    "submitIconComponent",
    "loadingIconComponent",
    "classNames",
    "translations"
];
function $f88d81f0b0e64aaa$var$_extends() {
    $f88d81f0b0e64aaa$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f88d81f0b0e64aaa$var$_extends.apply(this, arguments);
}
function $f88d81f0b0e64aaa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f88d81f0b0e64aaa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f88d81f0b0e64aaa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f88d81f0b0e64aaa$var$_ref2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
function $f88d81f0b0e64aaa$var$DefaultSubmitIcon(_ref) {
    var classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("svg", {
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-submitIcon', classNames.submitIcon),
        width: "10",
        height: "10",
        viewBox: "0 0 40 40",
        "aria-hidden": "true"
    }, $f88d81f0b0e64aaa$var$_ref2);
}
var $f88d81f0b0e64aaa$var$_ref4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
function $f88d81f0b0e64aaa$var$DefaultResetIcon(_ref3) {
    var classNames = _ref3.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("svg", {
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-resetIcon', classNames.resetIcon),
        viewBox: "0 0 20 20",
        width: "10",
        height: "10",
        "aria-hidden": "true"
    }, $f88d81f0b0e64aaa$var$_ref4);
}
var $f88d81f0b0e64aaa$var$_ref6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("g", {
    fill: "none",
    fillRule: "evenodd"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
function $f88d81f0b0e64aaa$var$DefaultLoadingIcon(_ref5) {
    var classNames = _ref5.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("svg", {
        "aria-label": "Results are loading",
        width: "16",
        height: "16",
        viewBox: "0 0 38 38",
        stroke: "#444",
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-loadingIcon', classNames.loadingIcon),
        "aria-hidden": "true"
    }, $f88d81f0b0e64aaa$var$_ref6);
}
function $f88d81f0b0e64aaa$export$5a58787633b0b5d8(_ref7) {
    var formRef = _ref7.formRef, inputRef = _ref7.inputRef, isSearchStalled = _ref7.isSearchStalled, onChange = _ref7.onChange, onReset = _ref7.onReset, onSubmit = _ref7.onSubmit, _ref7$placeholder = _ref7.placeholder, placeholder = _ref7$placeholder === void 0 ? '' : _ref7$placeholder, value = _ref7.value, autoFocus = _ref7.autoFocus, _ref7$resetIconCompon = _ref7.resetIconComponent, ResetIcon = _ref7$resetIconCompon === void 0 ? $f88d81f0b0e64aaa$var$DefaultResetIcon : _ref7$resetIconCompon, _ref7$submitIconCompo = _ref7.submitIconComponent, SubmitIcon = _ref7$submitIconCompo === void 0 ? $f88d81f0b0e64aaa$var$DefaultSubmitIcon : _ref7$submitIconCompo, _ref7$loadingIconComp = _ref7.loadingIconComponent, LoadingIcon = _ref7$loadingIconComp === void 0 ? $f88d81f0b0e64aaa$var$DefaultLoadingIcon : _ref7$loadingIconComp, _ref7$classNames = _ref7.classNames, classNames = _ref7$classNames === void 0 ? {} : _ref7$classNames, translations = _ref7.translations, props = $f88d81f0b0e64aaa$var$_objectWithoutProperties(_ref7, $f88d81f0b0e64aaa$var$_excluded);
    function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (onSubmit) onSubmit(event);
        if (inputRef.current) inputRef.current.blur();
    }
    function handleReset(event) {
        event.preventDefault();
        event.stopPropagation();
        onReset(event);
        if (inputRef.current) inputRef.current.focus();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("div", $f88d81f0b0e64aaa$var$_extends({}, props, {
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox', classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("form", {
        ref: formRef,
        action: "",
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-form', classNames.form),
        noValidate: true,
        onSubmit: handleSubmit,
        onReset: handleReset,
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("input", {
        ref: inputRef,
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-input', classNames.input),
        "aria-label": "Search",
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        placeholder: placeholder,
        spellCheck: false,
        maxLength: 512,
        type: "search",
        value: value,
        onChange: onChange,
        onCompositionEnd: onChange,
        autoFocus: autoFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("button", {
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-submit', classNames.submit),
        type: "submit",
        title: translations.submitButtonTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(SubmitIcon, {
        classNames: classNames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("button", {
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-reset', classNames.reset),
        type: "reset",
        title: translations.resetButtonTitle,
        hidden: value.length === 0 || isSearchStalled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(ResetIcon, {
        classNames: classNames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement("span", {
        className: (0, $ca477697f7684c0d$export$a274e22fb40f762e)('ais-SearchBox-loadingIndicator', classNames.loadingIndicator),
        hidden: !isSearchStalled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement(LoadingIcon, {
        classNames: classNames
    }))));
}


function $045da01f1be2b5f7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $045da01f1be2b5f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $045da01f1be2b5f7$var$_typeof(o);
}
var $045da01f1be2b5f7$var$_excluded = [
    "queryHook",
    "searchAsYouType",
    "ignoreCompositionEvents",
    "translations"
];
function $045da01f1be2b5f7$var$_extends() {
    $045da01f1be2b5f7$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $045da01f1be2b5f7$var$_extends.apply(this, arguments);
}
function $045da01f1be2b5f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $045da01f1be2b5f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $045da01f1be2b5f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $045da01f1be2b5f7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $045da01f1be2b5f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $045da01f1be2b5f7$var$_defineProperty(obj, key, value) {
    key = $045da01f1be2b5f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $045da01f1be2b5f7$var$_toPropertyKey(t) {
    var i = $045da01f1be2b5f7$var$_toPrimitive(t, "string");
    return "symbol" == $045da01f1be2b5f7$var$_typeof(i) ? i : String(i);
}
function $045da01f1be2b5f7$var$_toPrimitive(t, r) {
    if ("object" != $045da01f1be2b5f7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $045da01f1be2b5f7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $045da01f1be2b5f7$var$_slicedToArray(arr, i) {
    return $045da01f1be2b5f7$var$_arrayWithHoles(arr) || $045da01f1be2b5f7$var$_iterableToArrayLimit(arr, i) || $045da01f1be2b5f7$var$_unsupportedIterableToArray(arr, i) || $045da01f1be2b5f7$var$_nonIterableRest();
}
function $045da01f1be2b5f7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $045da01f1be2b5f7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $045da01f1be2b5f7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $045da01f1be2b5f7$var$_arrayLikeToArray(o, minLen);
}
function $045da01f1be2b5f7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $045da01f1be2b5f7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $045da01f1be2b5f7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $045da01f1be2b5f7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $045da01f1be2b5f7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $045da01f1be2b5f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $045da01f1be2b5f7$export$5a58787633b0b5d8(_ref) {
    var queryHook = _ref.queryHook, _ref$searchAsYouType = _ref.searchAsYouType, searchAsYouType = _ref$searchAsYouType === void 0 ? true : _ref$searchAsYouType, _ref$ignoreCompositio = _ref.ignoreCompositionEvents, ignoreCompositionEvents = _ref$ignoreCompositio === void 0 ? false : _ref$ignoreCompositio, translations = _ref.translations, props = $045da01f1be2b5f7$var$_objectWithoutProperties(_ref, $045da01f1be2b5f7$var$_excluded);
    var _useSearchBox = (0, $7732a887e1609a22$export$34d981d965dcc5b5)({
        queryHook: queryHook
    }, {
        $$widgetType: 'ais.searchBox'
    }), query = _useSearchBox.query, refine = _useSearchBox.refine, isSearchStalled = _useSearchBox.isSearchStalled;
    var _useState = (0, $ggE0n.useState)(query), _useState2 = $045da01f1be2b5f7$var$_slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var inputRef = (0, $ggE0n.useRef)(null);
    function setQuery(newQuery) {
        var isComposing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setInputValue(newQuery);
        if (searchAsYouType && !(ignoreCompositionEvents && isComposing)) refine(newQuery);
    }
    function onReset() {
        setQuery('');
        if (!searchAsYouType) refine('');
    }
    function onChange(event) {
        setQuery(event.currentTarget.value, event.nativeEvent.isComposing);
    }
    function onSubmit(event) {
        if (!searchAsYouType) refine(inputValue);
        if (props.onSubmit) props.onSubmit(event);
    }
    // Track when the InstantSearch query changes to synchronize it with
    // the React state.
    // We bypass the state update if the input is focused to avoid concurrent
    // updates when typing.
    if (query !== inputValue && document.activeElement !== inputRef.current) setInputValue(query);
    var uiProps = {
        inputRef: inputRef,
        isSearchStalled: isSearchStalled,
        onChange: onChange,
        onReset: onReset,
        onSubmit: onSubmit,
        value: inputValue,
        translations: $045da01f1be2b5f7$var$_objectSpread({
            submitButtonTitle: 'Submit the search query',
            resetButtonTitle: 'Clear the search query'
        }, translations)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ggE0n))).createElement((0, $f88d81f0b0e64aaa$export$5a58787633b0b5d8), $045da01f1be2b5f7$var$_extends({}, props, uiProps));
}



function $6b60e53f893b6979$export$2e2bcd8739ae039(param) {
    var hit = param.hit;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
        className: "border-b border-grey-light py-md",
        children: [
            (hit === null || hit === void 0 ? void 0 : hit.post_title) && (hit === null || hit === void 0 ? void 0 : hit.permalink) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h4", {
                className: "h4 text-[24px] font-bold font-primary",
                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("a", {
                    href: hit.permalink,
                    className: "text-blue-oxford hover:text-gold duration-200",
                    children: hit === null || hit === void 0 ? void 0 : hit.post_title
                })
            }) : null,
            (hit === null || hit === void 0 ? void 0 : hit.post_type_label) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                className: "block text-xs text-[#7b7b7b] mb-xs",
                children: hit.post_type_label
            }) : null,
            (hit === null || hit === void 0 ? void 0 : hit.post_excerpt) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                className: "sm:text-[18px]",
                dangerouslySetInnerHTML: {
                    __html: hit.post_excerpt
                }
            }) : null,
            !(hit === null || hit === void 0 ? void 0 : hit.post_excerpt) && (hit === null || hit === void 0 ? void 0 : hit.description) ? /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("span", {
                className: "sm:text-[18px]",
                dangerouslySetInnerHTML: {
                    __html: hit.description
                }
            }) : null
        ]
    });
}




function $d47fb496a3e3655b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d47fb496a3e3655b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d47fb496a3e3655b$var$_typeof(o);
}
function $d47fb496a3e3655b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d47fb496a3e3655b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d47fb496a3e3655b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d47fb496a3e3655b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d47fb496a3e3655b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d47fb496a3e3655b$var$_defineProperty(obj, key, value) {
    key = $d47fb496a3e3655b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d47fb496a3e3655b$var$_toPropertyKey(t) {
    var i = $d47fb496a3e3655b$var$_toPrimitive(t, "string");
    return "symbol" == $d47fb496a3e3655b$var$_typeof(i) ? i : String(i);
}
function $d47fb496a3e3655b$var$_toPrimitive(t, r) {
    if ("object" != $d47fb496a3e3655b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d47fb496a3e3655b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d47fb496a3e3655b$var$withUsage = (0, $ae06a923ad950e1e$export$2fde5bffc340821e)({
    name: 'stats',
    connector: true
});
/**
 * **Stats** connector provides the logic to build a custom widget that will displays
 * search statistics (hits number and processing time).
 */ var $d47fb496a3e3655b$var$connectStats = function connectStats(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1c8cc0c1c6330343$export$8793edee2d425525);
    (0, $73ae0484fe128d08$export$adc2a8e09aa583ee)(renderFn, $d47fb496a3e3655b$var$withUsage());
    return function(widgetParams) {
        return {
            $$type: 'ais.stats',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($d47fb496a3e3655b$var$_objectSpread($d47fb496a3e3655b$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($d47fb496a3e3655b$var$_objectSpread($d47fb496a3e3655b$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $d47fb496a3e3655b$var$_objectSpread($d47fb496a3e3655b$var$_objectSpread({}, renderState), {}, {
                    stats: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref) {
                var results = _ref.results, state = _ref.state;
                if (!results) return {
                    hitsPerPage: state.hitsPerPage,
                    nbHits: 0,
                    nbSortedHits: undefined,
                    areHitsSorted: false,
                    nbPages: 0,
                    page: state.page || 0,
                    processingTimeMS: -1,
                    query: state.query || '',
                    widgetParams: widgetParams
                };
                return {
                    hitsPerPage: results.hitsPerPage,
                    nbHits: results.nbHits,
                    nbSortedHits: results.nbSortedHits,
                    areHitsSorted: typeof results.appliedRelevancyStrictness !== 'undefined' && results.appliedRelevancyStrictness > 0 && results.nbSortedHits !== results.nbHits,
                    nbPages: results.nbPages,
                    page: results.page,
                    processingTimeMS: results.processingTimeMS,
                    query: results.query,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
var $d47fb496a3e3655b$export$2e2bcd8739ae039 = $d47fb496a3e3655b$var$connectStats;



function $42a4bd6273ea6e7a$export$c4a4af21c466f4c0(props, additionalWidgetProperties) {
    return (0, $ef79e46e7636cdf2$export$7b345619fa263f7e)((0, $d47fb496a3e3655b$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $7beeb67d8d3407ee$export$2e2bcd8739ae039() {
    var _useStats = (0, $42a4bd6273ea6e7a$export$c4a4af21c466f4c0)(), nbHits = _useStats.nbHits, query = _useStats.query;
    if (nbHits <= 0) return null;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
        className: "border-b border-grey-light py-2xl text-[18px] text-blue-oxford",
        children: [
            "Showing ",
            nbHits,
            ' results for your query "',
            query,
            '"'
        ]
    });
}



var $c7d0b5c5f722d2d5$var$getUrlParam = function() {
    var urlParams = new URLSearchParams(window.location.search);
    var queryParam = urlParams.get('s');
    if (!queryParam) return '';
    return queryParam;
};
function $c7d0b5c5f722d2d5$var$AlgoliaNoResults() {
    var _useClearRefinements = (0, $1f65d342571fa7e6$export$60a47f8af66e226a)({
        includedAttributes: [
            'query'
        ]
    }), clearRefinement = _useClearRefinements.refine;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
        className: "text-center my-[10%]",
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("h3", {
                className: "mb-sm",
                children: "No results found"
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("p", {
                className: "p--lg",
                children: "Please try a different search term or browse our categories"
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("button", {
                onClick: function() {
                    clearRefinement();
                },
                className: "btn btn--sm btn--solid py-sm px-lg w-auto whitespace-nowrap mt-lg",
                children: "Clear and try again"
            })
        ]
    });
}
function $c7d0b5c5f722d2d5$var$NoResultsBoundary(param) {
    var children = param.children, fallback = param.fallback;
    var results = (0, $ed99ed12fcc0facf$export$c3584afb06ed387d)().results;
    // The `__isArtificial` flag makes sure not to display the No Results message
    // when no hits have been returned.
    if (!results.__isArtificial && results.nbHits === 0) return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $d728d85f208a7030$exports.Fragment), {
        children: fallback
    });
    return children;
}
function $c7d0b5c5f722d2d5$export$2e2bcd8739ae039() {
    var _useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $ggE0n.useState)(null), 2), searchClient = _useState[0], setSearchClient = _useState[1];
    (0, $ggE0n.useEffect)(function() {
        // Check if we're in the browser and API keys are available
        if (typeof window !== 'undefined' && window.ALGOLIA_APPLICATION_ID && window.ALGOLIA_SEARCH_API_KEY) {
            var client = (0, (/*@__PURE__*/$parcel$interopDefault($iom5D)))(window.ALGOLIA_APPLICATION_ID, window.ALGOLIA_SEARCH_API_KEY);
            setSearchClient(client);
        }
    }, []);
    // Don't render InstantSearch until we have a valid search client
    if (!searchClient) return null;
    return /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)((0, $204762a302987aec$export$ad8f235d2c2c71c0), {
        searchClient: searchClient,
        indexName: "wp_searchable_posts",
        future: {
            preserveSharedStateOnUnmount: true,
            persistHierarchicalRootCount: true
        },
        routing: false,
        initialUiState: {
            wp_searchable_posts: {
                query: $c7d0b5c5f722d2d5$var$getUrlParam()
            }
        },
        children: [
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $3240ea332fbba201$export$de5f40ff1ff419d2), {
                analytics: false,
                hitsPerPage: 16
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                className: "bg-blue-pale py-2xl",
                children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("div", {
                    className: "wrapper wrapper--sm",
                    children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $045da01f1be2b5f7$export$5a58787633b0b5d8), {
                        searchAsYouType: true,
                        placeholder: "Enter keyword...",
                        classNames: {
                            form: 'relative h-[64px]',
                            input: 'bg-white w-full h-full px-sm focus:outline-none focus:border focus:border-gold',
                            resetIcon: 'absolute right-[24px] top-1/2 transform -translate-y-[50%] w-[12px] h-[12px]'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsxs)("div", {
                className: "wrapper wrapper--sm",
                children: [
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $7beeb67d8d3407ee$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)($c7d0b5c5f722d2d5$var$NoResultsBoundary, {
                        fallback: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)($c7d0b5c5f722d2d5$var$AlgoliaNoResults, {}),
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $51e227cba8706de3$export$9abb8533010f1d93), {
                            hitComponent: (0, $6b60e53f893b6979$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)("footer", {
                        className: "mt-3xl",
                        children: /*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $3397557cb5aa0d71$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
}





window.addEventListener('DOMContentLoaded', function() {
    (0, $045332d6670dfa00$export$2e2bcd8739ae039)();
    (0, $617e40c786b88f50$export$2e2bcd8739ae039)();
    (0, $53pa5.default)();
    (0, $6f8aa9ddaa708685$export$2e2bcd8739ae039)();
    // Archive Grids
    var archivesTarget = document.getElementById('js-archive-root');
    if (archivesTarget !== null) {
        var root = (0, $ac0c57d620ff2fd4$exports.createRoot)(archivesTarget);
        root.render(/*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $0a0fd746fdb2993a$export$2e2bcd8739ae039), {}));
    }
    // Search Results
    var searchTarget = document.getElementById('js-search-root');
    if (searchTarget !== null) {
        var root1 = (0, $ac0c57d620ff2fd4$exports.createRoot)(searchTarget);
        root1.render(/*#__PURE__*/ (0, $d728d85f208a7030$exports.jsx)((0, $c7d0b5c5f722d2d5$export$2e2bcd8739ae039), {}));
    }
    // Canvas Animation
    if (document.getElementById('js--canvas-logo')) (parcelRequire("dShRg")).then(function(module) {
        var Rive = module.default;
        Rive();
    }).catch(function(error) {
        return console.error('Failed to load animation:', error);
    });
    // Anchors
    if (document.getElementById('js--anchored')) (parcelRequire("jjZ2x")).then(function(module) {
        var Anchor = module.default;
        Anchor();
    }).catch(function(error) {
        return console.error('Failed to load anchor:', error);
    });
    // Lightbox
    if (document.querySelector('.js-lightbox')) (parcelRequire("j4SEU")).then(function(module) {
        var Gallery = module.default;
        Gallery();
    }).catch(function(error) {
        return console.error('Failed to load lightbox:', error);
    });
});

})();
//# sourceMappingURL=app.js.map
